import { InjectionToken, Inject, Injectable, Optional, Self, NgModule, SkipSelf } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { of, Observable, throwError } from 'rxjs';
import { HttpClient, HttpClientModule } from '@angular/common/http';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
class KalturaClientException extends Error {
    /**
     * @param {?} code
     * @param {?} message
     * @param {?=} args
     */
    constructor(code, message, args) {
        super(message);
        this.code = code;
        this.message = message;
        this.args = args;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, KalturaClientException.prototype);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAPIException extends Error {
    /**
     * @param {?} message
     * @param {?} code
     * @param {?} args
     */
    constructor(message, code, args) {
        super(message);
        this.message = message;
        this.code = code;
        this.args = args;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, KalturaAPIException.prototype);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaClientUtils {
    /**
     * @param {?} value
     * @return {?}
     */
    static fromServerDate(value) {
        return (value ? new Date(value * 1000) : null);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    static toServerDate(value) {
        return value ? Math.round(value.getTime() / 1000) : null;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    static getStartDateValue(value) {
        if (value) {
            value.setHours(0);
            value.setMinutes(0);
            value.setSeconds(0);
            return value;
        }
        else {
            return null;
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    static getEndDateValue(value) {
        if (value) {
            value.setHours(23);
            value.setMinutes(59);
            value.setSeconds(59);
            return value;
        }
        else {
            return null;
        }
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLogger {
    /**
     * @param {?} _name
     */
    constructor(_name) {
        this._name = _name;
    }
    /**
     * @param {?} message
     * @return {?}
     */
    warn(message) {
        {
            console.warn(`[kaltura-client/${this._name}]: ${message}`);
        }
    }
    /**
     * @param {?} message
     * @return {?}
     */
    info(message) {
    }
    /**
     * @param {?} message
     * @return {?}
     */
    error(message) {
        {
            console.error(`[kaltura-client/${this._name}]: ${message}`);
        }
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const logger = new KalturaLogger('KalturaObjectBase');
/** @type {?} */
const typesMappingStorage = {};
class KalturaObjectBaseFactory {
    /**
     * @param {?} type
     * @return {?}
     */
    static createObject(type) {
        /** @type {?} */
        let typeName = '';
        if (type instanceof KalturaObjectBase) {
            typeName = type.getTypeName();
        }
        else if (typeof type === 'string') {
            typeName = type;
        }
        /** @type {?} */
        const factory = typeName ? typesMappingStorage[typeName] : null;
        return factory ? new factory() : null;
    }
}
/**
 * @abstract
 */
class KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        this._allowedEmptyArray = [];
        this._dependentProperties = {};
        if (data) {
            Object.assign(this, data);
        }
        if (typeof this.relatedObjects === 'undefined')
            this.relatedObjects = [];
    }
    /**
     * @param {...?} properties
     * @return {?}
     */
    allowEmptyArray(...properties) {
        /** @type {?} */
        const metadata = this._getMetadata().properties;
        for (const property of properties) {
            /** @type {?} */
            const metadataProperty = metadata[property];
            if (!metadataProperty) {
                logger.warn(`ignore property '${property}' flaged to allow empty array as it doesn't not exists on type (did you set the right property in method 'allowEmptyArray'?)`);
            }
            else if (metadataProperty.type !== 'a') {
                logger.warn(`ignore property '${property}' flaged to allow empty array as it is not of type array (did you set the right property in method 'allowEmptyArray'?)`);
            }
            else {
                this._allowedEmptyArray.push(property);
            }
        }
        return this;
    }
    /**
     * @param {?} handler
     * @return {?}
     */
    setData(handler) {
        if (handler) {
            handler(this);
        }
        return this;
    }
    /**
     * @return {?}
     */
    getTypeName() {
        return this._getMetadata().properties['objectType'].default;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        // DEVELOPER NOTICE: according to the server schema, property 'relatedObjects' should have be of type 'KalturaListResponse'.
        // this is not an option as it created circle reference where KalturaListResponse > KalturaObjectBase > KalturaListResponse.
        // Hence, we cannot set the type explicitly and we need to expose the default type 'KalturaObjectBase'
        return { properties: {
                relatedObjects: { type: 'a', readOnly: true, subTypeConstructor: null, subType: 'KalturaListResponse' },
            } };
    }
    /**
     * @param {?} propertyName
     * @return {?}
     */
    hasMetadataProperty(propertyName) {
        return !!this._getMetadata().properties[propertyName];
    }
    /**
     * @return {?}
     */
    toRequestObject() {
        /** @type {?} */
        const metadata = this._getMetadata();
        /** @type {?} */
        let result = {};
        try {
            Object.keys(metadata.properties).forEach(propertyName => {
                /** @type {?} */
                const propertyData = metadata.properties[propertyName];
                /** @type {?} */
                const propertyValue = this._createRequestPropertyValue(propertyName, propertyData);
                switch (propertyValue.status) {
                    case "exists":
                        result[propertyName] = propertyValue.value;
                        break;
                    case "removed":
                        result[`${propertyName}__null`] = ''; // mark property for deletion
                        break;
                    case "missing":
                    default:
                        break;
                }
            });
        }
        catch (err) {
            // TODO [kaltura] should use logHandler
            logger.warn(err.message);
            throw err;
        }
        return result;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    fromResponseObject(data) {
        /** @type {?} */
        const metadata = this._getMetadata();
        /** @type {?} */
        let result = {};
        try {
            Object.keys(metadata.properties).forEach(propertyName => {
                /** @type {?} */
                const propertyData = metadata.properties[propertyName];
                /** @type {?} */
                const propertyValue = this._parseResponseProperty(propertyName, propertyData, data);
                if (propertyValue != null && typeof propertyValue !== 'undefined') {
                    this[propertyName] = propertyValue;
                }
            });
        }
        catch (err) {
            // TODO [kaltura] should use logHandler
            logger.warn(err.message);
            throw err;
        }
        return result;
    }
    /**
     * @param {?} propertyName
     * @param {?} property
     * @param {?} source
     * @return {?}
     */
    _parseResponseProperty(propertyName, property, source) {
        /** @type {?} */
        let result;
        /** @type {?} */
        let sourceValue = propertyName ? source[propertyName] : source;
        if (typeof sourceValue !== 'undefined') {
            if (sourceValue === null) {
                result = null;
            }
            else {
                switch (property.type) {
                    case 'b':
                        // boolean
                        if (typeof sourceValue === 'boolean') {
                            result = sourceValue;
                        }
                        else if (sourceValue + '' === '0') {
                            result = false;
                        }
                        else if (sourceValue + '' === '1') {
                            result = true;
                        }
                        break;
                    case 's':
                        // string
                        result = sourceValue + '';
                        break;
                    case 'n': // number
                    case 'en':
                        // enum of type number
                        result = sourceValue * 1;
                        break;
                    case 'es':
                        // enum of type number
                        result = typeof sourceValue !== 'undefined' && sourceValue !== null ? sourceValue.toString() : undefined;
                        break;
                    case 'o':
                        /** @type {?} */
                        const propertyObjectType = sourceValue['objectType'];
                        if (propertyObjectType) {
                            result = this._createKalturaObject(propertyObjectType, property.subType);
                            if (result) {
                                result.fromResponseObject(sourceValue);
                            }
                            else {
                                throw new Error(`Failed to create kaltura object of type '${source['objectType']}' (fallback type '${property.subType}')`);
                            }
                        }
                        else {
                            throw new Error(`Failed to create kaltura object for property '${propertyName}' (type '${property.subType}'). provided response object is missing property 'objectType'.`);
                        }
                        break;
                    case 'm':
                        /** @type {?} */
                        const parsedMap = {};
                        if (sourceValue instanceof Object) {
                            Object.keys(sourceValue).forEach(itemKey => {
                                /** @type {?} */
                                const itemValue = sourceValue[itemKey];
                                /** @type {?} */
                                const newItem = this._createKalturaObject(itemValue['objectType'], property.subType);
                                if (itemValue && newItem) {
                                    newItem.fromResponseObject(itemValue);
                                    parsedMap[itemKey] = newItem;
                                }
                                else {
                                    throw new Error(`Failed to create kaltura object for type '${property.subType}'`);
                                }
                            });
                            result = parsedMap;
                        }
                        else {
                            throw new Error(`failed to parse property '${propertyName}. Expected type object, got type '${typeof sourceValue}`);
                        }
                        break;
                    case 'a':
                        // array
                        if (sourceValue instanceof Array) {
                            /** @type {?} */
                            const parsedArray = [];
                            sourceValue.forEach(responseItem => {
                                /** @type {?} */
                                const newItem = this._createKalturaObject(responseItem['objectType'], property.subType);
                                if (newItem) {
                                    newItem.fromResponseObject(responseItem);
                                    parsedArray.push(newItem);
                                }
                                else {
                                    throw new Error(`Failed to create kaltura object for type '${responseItem['objectType']}' and for fallback type '${property.subType}'`);
                                }
                            });
                            result = parsedArray;
                        }
                        else {
                            throw new Error(`failed to parse property '${propertyName}. Expected type array, got type '${typeof sourceValue}`);
                        }
                        break;
                    case 'd':
                        // date
                        if (this._isNumeric(sourceValue)) {
                            result = KalturaClientUtils.fromServerDate(sourceValue * 1);
                        }
                        else {
                            throw new Error(`failed to parse property '${propertyName}. Expected type date, got type '${typeof sourceValue}`);
                        }
                        break;
                    default:
                        break;
                }
            }
        }
        return result;
    }
    /**
     * @param {?} n
     * @return {?}
     */
    _isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    /**
     * @param {?} objectType
     * @param {?=} fallbackObjectType
     * @return {?}
     */
    _createKalturaObject(objectType, fallbackObjectType) {
        /** @type {?} */
        let result = null;
        /** @type {?} */
        let usedFallbackType = false;
        if (objectType) {
            result = KalturaObjectBaseFactory.createObject(objectType);
        }
        if (!result && fallbackObjectType) {
            usedFallbackType = true;
            result = KalturaObjectBaseFactory.createObject(fallbackObjectType);
        }
        if (usedFallbackType && result) {
            logger.warn(`[kaltura-client]: Could not find object type '${objectType}', Falling back to '${fallbackObjectType}' object type. (Did you remember to set your accepted object types in the request “config.acceptedTypes” attribute?)`);
        }
        else if (!result) {
            logger.warn(`[kaltura-client]: Could not find object type '${objectType}'. (Did you remember to set your accepted object types in the request “config.acceptedTypes” attribute?)`);
        }
        return result;
    }
    /**
     * @param {?} propertyName
     * @param {?} property
     * @return {?}
     */
    _createRequestPropertyValue(propertyName, property) {
        /** @type {?} */
        let result = { status: 'missing' };
        if (property.type === 'c') {
            // constant string
            if (property.default) {
                result = { status: 'exists', value: property.default };
            }
        }
        else if (this._dependentProperties[propertyName]) {
            /** @type {?} */
            const dependentProperty = this._dependentProperties[propertyName];
            /** @type {?} */
            const resultValue = `{${dependentProperty.request}:result${dependentProperty.targetPath ? ':' + dependentProperty.targetPath : ''}}`;
            result = { status: 'exists', value: resultValue };
        }
        else if (!property.readOnly) {
            /** @type {?} */
            let value = this[propertyName];
            if (typeof value !== 'undefined') {
                if (value === null) {
                    result = { status: 'removed' };
                }
                else {
                    switch (property.type) {
                        case 'b':
                            // boolean
                            result = { status: 'exists', value: value };
                            break;
                        case 's':
                            // string
                            result = { status: 'exists', value: value + '' };
                            break;
                        case 'n': // number
                        case 'en':
                            // enum of type number
                            result = { status: 'exists', value: value * 1 };
                            break;
                        case 'o':
                            // object
                            if (value instanceof KalturaObjectBase) {
                                result = { status: 'exists', value: value.toRequestObject() };
                            }
                            else {
                                throw new Error(`failed to parse property. Expected '${propertyName} to be kaltura object`);
                            }
                            break;
                        case 'a':
                            // array
                            if (value instanceof Array) {
                                /** @type {?} */
                                const parsedArray = [];
                                value.forEach(item => {
                                    if (item instanceof KalturaObjectBase) {
                                        parsedArray.push(item.toRequestObject());
                                    }
                                });
                                /** @type {?} */
                                const allowEmptyArrayAsAValue = this._allowedEmptyArray.indexOf(propertyName) !== -1;
                                if (allowEmptyArrayAsAValue || parsedArray.length !== 0) {
                                    if (parsedArray.length === value.length) {
                                        result = { status: 'exists', value: parsedArray };
                                    }
                                    else {
                                        throw new Error(`failed to parse array. Expected all '${propertyName} items to be kaltura object`);
                                    }
                                }
                            }
                            else {
                                throw new Error(`failed to parse property. Expected '${propertyName} to be Array`);
                            }
                            break;
                        case 'm':
                            //map
                            if (value instanceof Object) {
                                /** @type {?} */
                                const valueKeys = Object.keys(value);
                                if (valueKeys.length > 0) {
                                    /** @type {?} */
                                    const parsedObject = {};
                                    valueKeys.forEach(itemKey => {
                                        /** @type {?} */
                                        var itemValue = value[itemKey];
                                        if (itemValue instanceof KalturaObjectBase) {
                                            parsedObject[itemKey] = itemValue.toRequestObject();
                                        }
                                    });
                                    if (valueKeys.length === Object.keys(parsedObject).length) {
                                        result = { status: 'exists', value: parsedObject };
                                    }
                                    else {
                                        throw new Error(`failed to parse map. Expected all '${propertyName} items to be kaltura object`);
                                    }
                                }
                            }
                            else {
                                throw new Error(`failed to parse property. Expected '${propertyName} to be kaltura object`);
                            }
                            break;
                        case 'd':
                            // date
                            if (value instanceof Date) {
                                result = { status: 'exists', value: KalturaClientUtils.toServerDate(value) };
                            }
                            else {
                                throw new Error(`failed to parse property. Expected '${propertyName} to be date`);
                            }
                            break;
                        case 'es':
                            // enum of type string
                            result = { status: 'exists', value: typeof value === 'string' ? value : undefined };
                            break;
                        case 'f':
                            if (value instanceof FormData) {
                                result = { status: 'exists', value: value };
                            }
                            break;
                        default:
                            // do nothing
                            break;
                    }
                }
            }
        }
        return result;
    }
    /**
     * @param {...?} dependency
     * @return {?}
     */
    setDependency(...dependency) {
        for (let i = 0, len = dependency.length; i < len; i++) {
            /** @type {?} */
            const item = dependency[i];
            let { property, request, targetPath } = /** @type {?} */ (item);
            if (item instanceof Array) {
                property = item[0];
                request = item[1];
                targetPath = item.length === 3 ? item[2] : null;
            }
            // The server expect one based index (meaning the first item has index 1)
            // since Javascript array are zero based index we expose the api as zero based
            // and transform the index value in the actual request by adding 1
            request = request + 1;
            this._dependentProperties[property] = { property, request, targetPath };
        }
        return this;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRequestBase extends KalturaObjectBase {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @param {?} tag
     * @return {?}
     */
    setNetworkTag(tag) {
        if (!tag || tag.length > 10) {
            console.warn(`cannot set network tag longer than 10 characters. ignoring tag '${tag}`);
        }
        else {
            this._networkTag = tag;
        }
        return this;
    }
    /**
     * @return {?}
     */
    getNetworkTag() {
        return this._networkTag;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMultiResponse extends Array {
    /**
     * @param {?=} results
     */
    constructor(results = []) {
        super();
        if (new.target) {
            // Set the prototype explicitly - see: https://github.com/Microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work
            Object.setPrototypeOf(this, new.target.prototype);
        }
        if (results && results.length > 0) {
            this.push(...results);
        }
    }
    /**
     * @return {?}
     */
    hasErrors() {
        return this.filter(result => result.error).length > 0;
    }
    /**
     * @return {?}
     */
    getFirstError() {
        /** @type {?} */
        let result = null;
        for (let i = 0; i < this.length; i++) {
            result = this[i].error;
            if (result) {
                break;
            }
        }
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const environment = {
    request: {
        apiVersion: '14.9.0'
    },
    response: {
        nestedResponse: false
    }
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMultiRequest extends KalturaRequestBase {
    /**
     * @param {...?} args
     */
    constructor(...args) {
        super({});
        this.requests = [];
        this.requests = args;
    }
    /**
     * @param {?} defaultRequestOptions
     * @return {?}
     */
    buildRequest(defaultRequestOptions) {
        /** @type {?} */
        const result = super.toRequestObject();
        for (let i = 0, length = this.requests.length; i < length; i++) {
            result[i] = this.requests[i].buildRequest(defaultRequestOptions);
        }
        return result;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { default: 'multirequest', type: 'c' }
        });
        return result;
    }
    /**
     * @param {?} response
     * @return {?}
     */
    _unwrapResponse(response) {
        return response;
    }
    /**
     * @param {?} callback
     * @return {?}
     */
    setCompletion(callback) {
        this.callback = callback;
        return this;
    }
    /**
     * @param {?} responses
     * @return {?}
     */
    handleResponse(responses) {
        /** @type {?} */
        const kalturaResponses = [];
        /** @type {?} */
        const unwrappedResponse = this._unwrapResponse(responses);
        if (!unwrappedResponse || !(unwrappedResponse instanceof Array) || unwrappedResponse.length !== this.requests.length) {
            /** @type {?} */
            const response = new KalturaAPIException(`server response is invalid, expected array of ${this.requests.length}`, 'client::response_type_error', null);
            for (let i = 0, len = this.requests.length; i < len; i++) {
                kalturaResponses.push(this.requests[i].handleResponse(response));
            }
        }
        else {
            for (let i = 0, len = this.requests.length; i < len; i++) {
                /** @type {?} */
                const serverResponse = unwrappedResponse[i];
                kalturaResponses.push(this.requests[i].handleResponse(serverResponse));
            }
            if (this.callback) {
                try {
                    this.callback(new KalturaMultiResponse(kalturaResponses));
                }
                catch (ex) {
                    // do nothing by design
                }
            }
        }
        return new KalturaMultiResponse(kalturaResponses);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @template T
 */
class KalturaResponse {
    /**
     * @param {?} result
     * @param {?} error
     */
    constructor(result, error) {
        this.result = result;
        this.error = error;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBaseResponseProfile extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBaseResponseProfile' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBaseResponseProfile'] = KalturaBaseResponseProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const KALTURA_CLIENT_DEFAULT_REQUEST_OPTIONS = new InjectionToken('kaltura client default request options');
class KalturaRequestOptions extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.acceptedTypes === 'undefined')
            this.acceptedTypes = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            partnerId: { type: 'n' },
            ks: { type: 's' },
            responseProfile: { type: 'o', subTypeConstructor: KalturaBaseResponseProfile, subType: 'KalturaBaseResponseProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @abstract
 * @template T
 */
class KalturaRequest extends KalturaRequestBase {
    /**
     * @param {?} data
     * @param {?} __1
     */
    constructor(data, { responseType, responseSubType, responseConstructor }) {
        super(data);
        this.responseSubType = responseSubType;
        this.responseType = responseType;
        this._responseConstructor = responseConstructor;
    }
    /**
     * @param {?} callback
     * @return {?}
     */
    setCompletion(callback) {
        this.callback = callback;
        return this;
    }
    /**
     * @param {?} response
     * @return {?}
     */
    _unwrapResponse(response) {
        return response;
    }
    /**
     * @param {?} response
     * @return {?}
     */
    handleResponse(response) {
        /** @type {?} */
        let responseResult;
        /** @type {?} */
        let responseError;
        try {
            /** @type {?} */
            const unwrappedResponse = this._unwrapResponse(response);
            /** @type {?} */
            let responseObject = null;
            if (unwrappedResponse) {
                if (unwrappedResponse instanceof KalturaAPIException) {
                    // handle situation when multi request propagated actual api exception object.
                    responseObject = unwrappedResponse;
                }
                else if (unwrappedResponse.objectType === 'KalturaAPIException') {
                    responseObject = new KalturaAPIException(unwrappedResponse.message, unwrappedResponse.code, unwrappedResponse.args);
                }
                else {
                    responseObject = super._parseResponseProperty("", {
                        type: this.responseType,
                        subType: this.responseSubType
                    }, unwrappedResponse);
                }
            }
            if (!responseObject && this.responseType !== 'v') {
                responseError = new KalturaAPIException(`server response is undefined, expected '${this.responseType} / ${this.responseSubType}'`, 'client::response_type_error', null);
            }
            else if (responseObject instanceof KalturaAPIException) {
                // got exception from library
                responseError = responseObject;
            }
            else {
                responseResult = responseObject;
            }
        }
        catch (ex) {
            responseError = new KalturaAPIException(ex.message, 'client::general_error', null);
        }
        /** @type {?} */
        const result = new KalturaResponse(responseResult, responseError);
        if (this.callback) {
            try {
                this.callback(result);
            }
            catch (ex) {
                // do nothing by design
            }
        }
        return result;
    }
    /**
     * @param {?} arg
     * @return {?}
     */
    setRequestOptions(arg) {
        this.__requestOptions__ = arg instanceof KalturaRequestOptions ? arg : new KalturaRequestOptions(arg);
        return this;
    }
    /**
     * @return {?}
     */
    getRequestOptions() {
        return this.__requestOptions__;
    }
    /**
     * @param {?} defaultRequestOptions
     * @return {?}
     */
    buildRequest(defaultRequestOptions) {
        /** @type {?} */
        const requestOptionsObject = this.__requestOptions__ ? this.__requestOptions__.toRequestObject() : {};
        /** @type {?} */
        const defaultRequestOptionsObject = defaultRequestOptions ? defaultRequestOptions.toRequestObject() : {};
        return Object.assign({}, defaultRequestOptionsObject, requestOptionsObject, this.toRequestObject());
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @template T
 */
class KalturaUploadRequest extends KalturaRequest {
    /**
     * @param {?} data
     * @param {?} __1
     */
    constructor(data, { responseType, responseSubType, responseConstructor }) {
        super(data, { responseType, responseSubType, responseConstructor });
        this.uploadedFileSize = 0;
        this.uploadedFileSize = data.uploadedFileSize;
    }
    /**
     * @param {?} callback
     * @return {?}
     */
    setProgress(callback) {
        this._progressCallback = callback;
        return this;
    }
    /**
     * @return {?}
     */
    _getProgressCallback() {
        return this._progressCallback;
    }
    /**
     * @return {?}
     */
    supportChunkUpload() {
        const { properties } = this._getMetadata();
        /** @type {?} */
        const responseSupportChunk = this._responseConstructor ? (new this._responseConstructor()).hasMetadataProperty("uploadedFileSize") : false;
        return responseSupportChunk
            && !!properties["resume"]
            && !!properties["resumeAt"]
            && !!properties["finalChunk"];
    }
    /**
     * @return {?}
     */
    getFileInfo() {
        /** @type {?} */
        const metadataProperties = this._getMetadata().properties;
        /** @type {?} */
        const filePropertyName = Object.keys(metadataProperties).find(propertyName => metadataProperties[propertyName].type === "f");
        return filePropertyName ? { propertyName: filePropertyName, file: this[filePropertyName] } : null;
    }
    /**
     * @return {?}
     */
    toRequestObject() {
        /** @type {?} */
        const result = super.toRequestObject();
        const { propertyName: filePropertyName } = this.getFileInfo();
        if (filePropertyName) {
            delete result[filePropertyName];
        }
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFileRequest extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @param {?} request
 * @param {?} options
 * @param {?} service
 * @param {?=} action
 * @return {?}
 */
function createEndpoint(request, options, service, action) {
    /** @type {?} */
    const endpoint = options.endpointUrl;
    /** @type {?} */
    const clientTag = createClientTag(request, options);
    /** @type {?} */
    let result = `${endpoint}/api_v3/service/${service}`;
    if (action) {
        result += `/action/${action}`;
    }
    if (clientTag) {
        result += `?${_buildQuerystring({ clientTag })}`;
    }
    return result;
}
/**
 * @param {?} request
 * @param {?} options
 * @return {?}
 */
function createClientTag(request, options) {
    /** @type {?} */
    const networkTag = (request.getNetworkTag() || "").trim();
    /** @type {?} */
    const clientTag = (options.clientTag || "").trim() || "ng-app";
    if (networkTag && networkTag.length) {
        return `${clientTag}_${networkTag}`;
    }
    else {
        return clientTag;
    }
}
/**
 * @param {?} data
 * @param {?=} prefix
 * @return {?}
 */
function _buildQuerystring(data, prefix) {
    /** @type {?} */
    let str = [];
    /** @type {?} */
    let p;
    for (p in data) {
        if (data.hasOwnProperty(p)) {
            /** @type {?} */
            let k = prefix ? prefix + "[" + p + "]" : p;
            /** @type {?} */
            let v = data[p];
            str.push((v !== null && typeof v === "object") ?
                _buildQuerystring(v, k) :
                encodeURIComponent(k) + "=" + encodeURIComponent(v));
        }
    }
    return str.join("&");
}
/**
 * @param {?} url
 * @param {?} querystring
 * @return {?}
 */
function buildUrl(url, querystring) {
    /** @type {?} */
    let formattedUrl = (url).trim();
    /** @type {?} */
    const urlHasQuerystring = formattedUrl.indexOf('?') !== -1;
    /** @type {?} */
    const formattedQuerystring = _buildQuerystring(querystring);
    return `${formattedUrl}${urlHasQuerystring ? '&' : '?'}${formattedQuerystring}`;
}
/**
 * @return {?}
 */
function getHeaders() {
    return {
        "Accept": "application/json",
        "Content-Type": "application/json"
    };
}
/**
 * @param {?} request
 * @param {?} options
 * @param {?} defaultRequestOptions
 * @return {?}
 */
function prepareParameters(request, options, defaultRequestOptions) {
    return Object.assign({}, request.buildRequest(defaultRequestOptions), {
        apiVersion: environment.request.apiVersion,
        format: 1
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRequestAdapter {
    /**
     * @param {?} _http
     */
    constructor(_http) {
        this._http = _http;
    }
    /**
     * @template T
     * @param {?} request
     * @param {?} clientOptions
     * @param {?} defaultRequestOptions
     * @return {?}
     */
    transmit(request, clientOptions, defaultRequestOptions) {
        /** @type {?} */
        const parameters = prepareParameters(request, clientOptions, defaultRequestOptions);
        /** @type {?} */
        const endpointUrl = createEndpoint(request, clientOptions, parameters['service'], parameters['action']);
        delete parameters['service'];
        delete parameters['action'];
        return this._http.request('post', endpointUrl, {
            body: parameters,
            headers: getHeaders()
        }).pipe(catchError(error => {
            /** @type {?} */
            const errorMessage = error instanceof Error ? error.message : typeof error === 'string' ? error : null;
            throw new KalturaClientException("client::request-network-error", errorMessage || 'Error connecting to server');
        }), map(result => {
            try {
                /** @type {?} */
                const response = request.handleResponse(result);
                if (response.error) {
                    throw response.error;
                }
                else {
                    return response.result;
                }
            }
            catch (error) {
                if (error instanceof KalturaClientException || error instanceof KalturaAPIException) {
                    throw error;
                }
                else {
                    /** @type {?} */
                    const errorMessage = error instanceof Error ? error.message : typeof error === 'string' ? error : null;
                    throw new KalturaClientException('client::response-unknown-error', errorMessage || 'Failed to parse response');
                }
            }
        }));
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFileRequestAdapter {
    /**
     * @param {?} request
     * @param {?} clientOptions
     * @param {?} defaultRequestOptions
     * @return {?}
     */
    transmit(request, clientOptions, defaultRequestOptions) {
        /** @type {?} */
        const parameters = prepareParameters(request, clientOptions, defaultRequestOptions);
        /** @type {?} */
        const endpointUrl = createEndpoint(request, clientOptions, parameters['service'], parameters['action']);
        delete parameters['service'];
        delete parameters['action'];
        return of({ url: buildUrl(endpointUrl, parameters) });
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const KALTURA_CLIENT_OPTIONS = new InjectionToken('kaltura client options');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMultiRequestAdapter {
    /**
     * @param {?} _http
     */
    constructor(_http) {
        this._http = _http;
    }
    /**
     * @param {?} request
     * @param {?} clientOptions
     * @param {?} defaultRequestOptions
     * @return {?}
     */
    transmit(request, clientOptions, defaultRequestOptions) {
        /** @type {?} */
        const parameters = prepareParameters(request, clientOptions, defaultRequestOptions);
        /** @type {?} */
        const endpointUrl = createEndpoint(request, clientOptions, parameters['service'], parameters['action']);
        delete parameters['service'];
        delete parameters['action'];
        return this._http.request('post', endpointUrl, {
            body: parameters,
            headers: getHeaders()
        }).pipe(catchError(error => {
            /** @type {?} */
            const errorMessage = error instanceof Error ? error.message : typeof error === 'string' ? error : null;
            throw new KalturaClientException("client::multi-request-network-error", errorMessage || 'Error connecting to server');
        }), map(result => {
            try {
                return request.handleResponse(result);
            }
            catch (error) {
                if (error instanceof KalturaClientException || error instanceof KalturaAPIException) {
                    throw error;
                }
                else {
                    /** @type {?} */
                    const errorMessage = error instanceof Error ? error.message : typeof error === 'string' ? error : null;
                    throw new KalturaClientException('client::multi-response-unknown-error', errorMessage || 'Failed to parse response');
                }
            }
        }));
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUploadRequestAdapter {
    /**
     * @param {?} clientOptions
     * @param {?} defaultRequestOptions
     */
    constructor(clientOptions, defaultRequestOptions) {
        this.clientOptions = clientOptions;
        this.defaultRequestOptions = defaultRequestOptions;
    }
    /**
     * @param {?} request
     * @return {?}
     */
    _chunkUploadSupported(request) {
        /** @type {?} */
        const supportedByBrowser = ((typeof (File) !== 'undefined')
            &&
                (typeof (Blob) !== 'undefined')
            &&
                (typeof (FileList) !== 'undefined')
            &&
                (!!(/** @type {?} */ (Blob.prototype))['webkitSlice'] || !!(/** @type {?} */ (Blob.prototype))['mozSlice'] || !!(/** @type {?} */ (Blob.prototype)).slice || false));
        /** @type {?} */
        const supportedByRequest = request.supportChunkUpload();
        /** @type {?} */
        const enabledInClient = !this.clientOptions.chunkFileDisabled;
        return enabledInClient && supportedByBrowser && supportedByRequest;
    }
    /**
     * @param {?} request
     * @return {?}
     */
    transmit(request) {
        return Observable.create(observer => {
            /** @type {?} */
            const uploadedFileSize = !isNaN(request.uploadedFileSize) && isFinite(request.uploadedFileSize) && request.uploadedFileSize > 0 ? request.uploadedFileSize : 0;
            /** @type {?} */
            const data = {
                enabled: this._chunkUploadSupported(request),
                resume: !!uploadedFileSize,
                finalChunk: false,
                resumeAt: uploadedFileSize
            };
            /** @type {?} */
            let requestSubscription;
            /** @type {?} */
            const handleChunkUploadError = reason => {
                requestSubscription = null;
                observer.error(reason);
            };
            /** @type {?} */
            const handleChunkUploadSuccess = result => {
                if (!data.enabled || data.finalChunk) {
                    requestSubscription = null;
                    try {
                        /** @type {?} */
                        const response = request.handleResponse(result);
                        if (response.error) {
                            observer.error(response.error);
                        }
                        else {
                            observer.next(response.result);
                            observer.complete();
                        }
                    }
                    catch (error) {
                        if (error instanceof KalturaClientException || error instanceof KalturaAPIException) {
                            observer.error(error);
                        }
                        else {
                            /** @type {?} */
                            const errorMessage = error instanceof Error ? error.message : typeof error === 'string' ? error : null;
                            observer.error(new KalturaClientException('client::response-unknown-error', errorMessage || 'Failed to parse response'));
                        }
                    }
                }
                else {
                    requestSubscription = this._chunkUpload(request, data).subscribe(handleChunkUploadSuccess, handleChunkUploadError);
                }
            };
            requestSubscription = this._chunkUpload(request, data)
                .subscribe(handleChunkUploadSuccess, handleChunkUploadError);
            return () => {
                if (requestSubscription) {
                    requestSubscription.unsubscribe();
                    requestSubscription = null;
                }
            };
        });
    }
    /**
     * @param {?} filePropertyName
     * @param {?} fileName
     * @param {?} fileChunk
     * @return {?}
     */
    _getFormData(filePropertyName, fileName, fileChunk) {
        /** @type {?} */
        const result = new FormData();
        result.append("Filename", fileName);
        result.append(filePropertyName, fileChunk, fileName);
        return result;
    }
    /**
     * @param {?} response
     * @return {?}
     */
    _unwrapResponse(response) {
        return response;
    }
    /**
     * @param {?} request
     * @param {?} uploadChunkData
     * @return {?}
     */
    _chunkUpload(request, uploadChunkData) {
        return Observable.create(observer => {
            /** @type {?} */
            const parameters = prepareParameters(request, this.clientOptions, this.defaultRequestOptions);
            /** @type {?} */
            let isComplete = false;
            const { propertyName, file } = request.getFileInfo();
            /** @type {?} */
            let data = this._getFormData(propertyName, file.name, file);
            /** @type {?} */
            let fileStart = 0;
            if (uploadChunkData.enabled) {
                /** @type {?} */
                let actualChunkFileSize = null;
                /** @type {?} */
                const userChunkFileSize = this.clientOptions ? this.clientOptions.chunkFileSize : null;
                if (userChunkFileSize && Number.isFinite(userChunkFileSize) && !Number.isNaN(userChunkFileSize)) {
                    if (userChunkFileSize < 1e5) {
                        console.warn(`user requested for invalid upload chunk size '${userChunkFileSize}'. minimal value 100Kb. using minimal value 100Kb instead`);
                        actualChunkFileSize = 1e5;
                    }
                    else {
                        console.log(`using user requetsed chunk size '${userChunkFileSize}'`);
                        actualChunkFileSize = userChunkFileSize;
                    }
                }
                else {
                    console.log(`using default chunk size 5Mb`);
                    actualChunkFileSize = 5e6; // default
                }
                uploadChunkData.finalChunk = (file.size - uploadChunkData.resumeAt) <= actualChunkFileSize;
                fileStart = uploadChunkData.resumeAt;
                /** @type {?} */
                const fileEnd = uploadChunkData.finalChunk ? file.size : fileStart + actualChunkFileSize;
                data = this._getFormData(propertyName, file.name, file.slice(fileStart, fileEnd, file.type));
                parameters.resume = uploadChunkData.resume;
                parameters.resumeAt = uploadChunkData.resumeAt;
                parameters.finalChunk = uploadChunkData.finalChunk;
            }
            else {
                console.log(`chunk upload not supported by browser or by request. Uploading the file as-is`);
            }
            /** @type {?} */
            let endpointUrl = createEndpoint(request, this.clientOptions, parameters['service'], parameters['action']);
            delete parameters['service'];
            delete parameters['action'];
            endpointUrl = buildUrl(endpointUrl, parameters);
            /** @type {?} */
            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (isComplete) {
                        return;
                    }
                    isComplete = true;
                    /** @type {?} */
                    let resp;
                    try {
                        if (xhr.status === 200) {
                            resp = this._unwrapResponse(JSON.parse(xhr.response));
                            if (resp && resp.objectType === 'KalturaAPIException') {
                                resp = new KalturaAPIException(resp.message, resp.code, resp.args);
                            }
                        }
                        else {
                            resp = new KalturaClientException('client::upload-failure', xhr.responseText || 'failed to upload file');
                        }
                    }
                    catch (e) {
                        resp = new KalturaClientException('client::upload-failure', e.message || 'failed to upload file');
                    }
                    if (resp instanceof Error) {
                        observer.error(resp);
                    }
                    else {
                        if (uploadChunkData.enabled) {
                            if (typeof resp.uploadedFileSize === "undefined" || resp.uploadedFileSize === null) {
                                observer.error(new KalturaClientException('client::upload-failure', `uploaded chunk of file failed, expected response with property 'uploadedFileSize'`));
                                return;
                            }
                            else if (!uploadChunkData.finalChunk) {
                                uploadChunkData.resumeAt = Number(resp.uploadedFileSize);
                                uploadChunkData.resume = true;
                            }
                        }
                        observer.next(resp);
                        observer.complete();
                    }
                }
            };
            /** @type {?} */
            const progressCallback = request._getProgressCallback();
            if (progressCallback) {
                xhr.upload.addEventListener("progress", e => {
                    if (e.lengthComputable) {
                        progressCallback.apply(request, [e.loaded + fileStart, file.size]);
                    }
                }, false);
            }
            xhr.open("POST", endpointUrl);
            xhr.send(data);
            return () => {
                if (!isComplete) {
                    isComplete = true;
                    xhr.abort();
                }
            };
        });
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaClient {
    /**
     * @param {?} _http
     * @param {?} _options
     * @param {?} defaultRequestOptionsArgs
     */
    constructor(_http, _options, defaultRequestOptionsArgs) {
        this._http = _http;
        this._options = _options;
        this._defaultRequestOptions = new KalturaRequestOptions(defaultRequestOptionsArgs || {});
    }
    /**
     * @param {?} options
     * @return {?}
     */
    appendOptions(options) {
        if (!options) {
            throw new KalturaClientException('client::append_options', `missing required argument 'options'`);
        }
        this._options = Object.assign(this._options || {}, options);
    }
    /**
     * @param {?} options
     * @return {?}
     */
    setOptions(options) {
        if (!options) {
            throw new KalturaClientException('client::set_options', `missing required argument 'options'`);
        }
        this._options = options;
    }
    /**
     * @param {?} args
     * @return {?}
     */
    appendDefaultRequestOptions(args) {
        if (!args) {
            throw new KalturaClientException('client::append_default_request_options', `missing required argument 'args'`);
        }
        this._defaultRequestOptions = Object.assign(this._defaultRequestOptions || new KalturaRequestOptions(), new KalturaRequestOptions(args));
    }
    /**
     * @param {?} args
     * @return {?}
     */
    setDefaultRequestOptions(args) {
        if (!args) {
            throw new KalturaClientException('client::set_default_request_options', `missing required argument 'args'`);
        }
        this._defaultRequestOptions = new KalturaRequestOptions(args);
    }
    /**
     * @return {?}
     */
    _validateOptions() {
        if (!this._options) {
            return new KalturaClientException('client::missing_options', 'cannot transmit request, missing client options (did you forgot to provide options manually or using KALTURA_CLIENT_OPTIONS?)');
        }
        if (!this._options.endpointUrl) {
            return new KalturaClientException('client::missing_options', `cannot transmit request, missing 'endpointUrl' in client options`);
        }
        if (!this._options.clientTag) {
            return new KalturaClientException('client::missing_options', `cannot transmit request, missing 'clientTag' in client options`);
        }
        return null;
    }
    /**
     * @template T
     * @param {?} request
     * @return {?}
     */
    request(request) {
        /** @type {?} */
        const optionsViolationError = this._validateOptions();
        if (optionsViolationError) {
            return throwError(optionsViolationError);
        }
        if (request instanceof KalturaFileRequest) {
            return new KalturaFileRequestAdapter().transmit(request, this._options, this._defaultRequestOptions);
        }
        else if (request instanceof KalturaUploadRequest) {
            return new KalturaUploadRequestAdapter(this._options, this._defaultRequestOptions).transmit(request);
        }
        else if (request instanceof KalturaRequest) {
            return new KalturaRequestAdapter(this._http).transmit(request, this._options, this._defaultRequestOptions);
        }
        else {
            return throwError(new KalturaClientException("client::request_type_error", 'unsupported request type requested'));
        }
    }
    /**
     * @param {?} arg
     * @return {?}
     */
    multiRequest(arg) {
        /** @type {?} */
        const optionsViolationError = this._validateOptions();
        if (optionsViolationError) {
            return throwError(optionsViolationError);
        }
        /** @type {?} */
        const request = arg instanceof KalturaMultiRequest ? arg : (arg instanceof Array ? new KalturaMultiRequest(...arg) : null);
        if (!request) {
            return throwError(new KalturaClientException('client::invalid_request', `Expected argument of type Array or KalturaMultiRequest`));
        }
        /** @type {?} */
        const containsFileRequest = request.requests.some(item => item instanceof KalturaFileRequest);
        if (containsFileRequest) {
            return throwError(new KalturaClientException('client::invalid_request', `multi-request not support requests of type 'KalturaFileRequest', use regular request instead`));
        }
        else {
            return new KalturaMultiRequestAdapter(this._http).transmit(request, this._options, this._defaultRequestOptions);
        }
    }
}
KalturaClient.ɵfac = function KalturaClient_Factory(t) { return new (t || KalturaClient)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(KALTURA_CLIENT_OPTIONS, 10), ɵngcc0.ɵɵinject(KALTURA_CLIENT_DEFAULT_REQUEST_OPTIONS, 10)); };
KalturaClient.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: KalturaClient, factory: KalturaClient.ɵfac });
/** @nocollapse */
KalturaClient.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [KALTURA_CLIENT_OPTIONS,] }, { type: Optional }, { type: Self }] },
    { type: undefined, decorators: [{ type: Inject, args: [KALTURA_CLIENT_DEFAULT_REQUEST_OPTIONS,] }, { type: Optional }, { type: Self }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(KalturaClient, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [KALTURA_CLIENT_OPTIONS]
            }, {
                type: Optional
            }, {
                type: Self
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [KALTURA_CLIENT_DEFAULT_REQUEST_OPTIONS]
            }, {
                type: Optional
            }, {
                type: Self
            }] }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaClientModule {
    /**
     * @param {?} module
     */
    constructor(module) {
        if (module) {
            throw new Error("'KalturaClientModule' module imported twice.");
        }
    }
    /**
     * @param {?=} clientOptionsFactory
     * @param {?=} defaultRequestOptionsArgsFactory
     * @return {?}
     */
    static forRoot(clientOptionsFactory, defaultRequestOptionsArgsFactory) {
        return {
            ngModule: KalturaClientModule,
            providers: [
                KalturaClient,
                KALTURA_CLIENT_OPTIONS ? {
                    provide: KALTURA_CLIENT_OPTIONS,
                    useFactory: clientOptionsFactory
                } : [],
                KALTURA_CLIENT_DEFAULT_REQUEST_OPTIONS ? {
                    provide: KALTURA_CLIENT_DEFAULT_REQUEST_OPTIONS,
                    useFactory: defaultRequestOptionsArgsFactory
                } : []
            ]
        };
    }
}
KalturaClientModule.ɵfac = function KalturaClientModule_Factory(t) { return new (t || KalturaClientModule)(ɵngcc0.ɵɵinject(KalturaClientModule, 12)); };
KalturaClientModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: KalturaClientModule });
KalturaClientModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: /** @type {?} */ ([]), imports: [HttpClientModule] });
/** @nocollapse */
KalturaClientModule.ctorParameters = () => [
    { type: KalturaClientModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(KalturaClientModule, [{
        type: NgModule,
        args: [{
                imports: /** @type {?} */ ([
                    HttpClientModule
                ]),
                declarations: /** @type {?} */ ([]),
                exports: /** @type {?} */ ([]),
                providers: /** @type {?} */ ([])
            }]
    }], function () { return [{ type: KalturaClientModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(KalturaClientModule, { imports: function () { return [HttpClientModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaListResponse extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaListResponse' },
            totalCount: { type: 'n', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaListResponse'] = KalturaListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBaseRestriction extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBaseRestriction' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBaseRestriction'] = KalturaBaseRestriction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaNullableBoolean = {
    falseValue: 0,
    nullValue: -1,
    trueValue: 1,
};
KalturaNullableBoolean[KalturaNullableBoolean.falseValue] = 'falseValue';
KalturaNullableBoolean[KalturaNullableBoolean.nullValue] = 'nullValue';
KalturaNullableBoolean[KalturaNullableBoolean.trueValue] = 'trueValue';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControl extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.restrictions === 'undefined')
            this.restrictions = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControl' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            name: { type: 's' },
            systemName: { type: 's' },
            description: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            isDefault: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            restrictions: { type: 'a', subTypeConstructor: KalturaBaseRestriction, subType: 'KalturaBaseRestriction' },
            containsUnsuportedRestrictions: { type: 'b', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControl'] = KalturaAccessControl;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaContextType = {
    download: '2',
    export: '5',
    metadata: '4',
    play: '1',
    serve: '6',
    thumbnail: '3',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaContextTypeHolder extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaContextTypeHolder' },
            type: { type: 'es', subTypeConstructor: KalturaContextType, subType: 'KalturaContextType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaContextTypeHolder'] = KalturaContextTypeHolder;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlContextTypeHolder extends KalturaContextTypeHolder {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlContextTypeHolder' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlContextTypeHolder'] = KalturaAccessControlContextTypeHolder;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlMessage extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlMessage' },
            message: { type: 's' },
            code: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlMessage'] = KalturaAccessControlMessage;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaRuleActionType = {
    addToStorage: '4',
    block: '1',
    drmPolicy: 'drm.DRM_POLICY',
    limitDeliveryProfiles: '5',
    limitFlavors: '3',
    limitThumbnailCapture: '8',
    preview: '2',
    requestHostRegex: '7',
    serveFromRemoteServer: '6',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRuleAction extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRuleAction' },
            type: { type: 'es', readOnly: true, subTypeConstructor: KalturaRuleActionType, subType: 'KalturaRuleActionType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaRuleAction'] = KalturaRuleAction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaConditionType = {
    activeEdgeValidate: '14',
    anonymousIp: '15',
    assetPropertiesCompare: '8',
    assetType: '16',
    authenticated: '1',
    country: '2',
    deliveryProfile: '13',
    eventNotificationField: 'eventNotification.BooleanField',
    eventNotificationObjectChanged: 'eventNotification.ObjectChanged',
    fieldCompare: '7',
    fieldMatch: '6',
    geoDistance: '10',
    hash: '12',
    ipAddress: '3',
    metadataFieldChanged: 'metadata.FieldChanged',
    metadataFieldCompare: 'metadata.FieldCompare',
    metadataFieldMatch: 'metadata.FieldMatch',
    orOperator: '11',
    site: '4',
    userAgent: '5',
    userRole: '9',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCondition extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCondition' },
            type: { type: 'es', readOnly: true, subTypeConstructor: KalturaConditionType, subType: 'KalturaConditionType' },
            description: { type: 's' },
            not: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCondition'] = KalturaCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRule extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.actions === 'undefined')
            this.actions = [];
        if (typeof this.conditions === 'undefined')
            this.conditions = [];
        if (typeof this.contexts === 'undefined')
            this.contexts = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRule' },
            description: { type: 's' },
            ruleData: { type: 's' },
            message: { type: 's' },
            code: { type: 's' },
            actions: { type: 'a', subTypeConstructor: KalturaRuleAction, subType: 'KalturaRuleAction' },
            conditions: { type: 'a', subTypeConstructor: KalturaCondition, subType: 'KalturaCondition' },
            contexts: { type: 'a', subTypeConstructor: KalturaContextTypeHolder, subType: 'KalturaContextTypeHolder' },
            stopProcessing: { type: 'b' },
            forceAdminValidation: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaRule'] = KalturaRule;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlProfile extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.rules === 'undefined')
            this.rules = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlProfile' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            name: { type: 's' },
            systemName: { type: 's' },
            description: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            isDefault: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            rules: { type: 'a', subTypeConstructor: KalturaRule, subType: 'KalturaRule' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlProfile'] = KalturaAccessControlProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaKeyValue extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaKeyValue' },
            key: { type: 's' },
            value: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaKeyValue'] = KalturaKeyValue;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlScope extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.contexts === 'undefined')
            this.contexts = [];
        if (typeof this.hashes === 'undefined')
            this.hashes = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlScope' },
            referrer: { type: 's' },
            ip: { type: 's' },
            ks: { type: 's' },
            userAgent: { type: 's' },
            time: { type: 'n' },
            contexts: { type: 'a', subTypeConstructor: KalturaAccessControlContextTypeHolder, subType: 'KalturaAccessControlContextTypeHolder' },
            hashes: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlScope'] = KalturaAccessControlScope;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaReportFilter extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaReportFilter' },
            dimension: { type: 's' },
            values: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaReportFilter'] = KalturaReportFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAnalyticsFilter extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.filters === 'undefined')
            this.filters = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAnalyticsFilter' },
            from_time: { type: 's' },
            to_time: { type: 's' },
            metrics: { type: 's' },
            utcOffset: { type: 'n' },
            dimensions: { type: 's' },
            filters: { type: 'a', subTypeConstructor: KalturaReportFilter, subType: 'KalturaReportFilter' },
            orderBy: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAnalyticsFilter'] = KalturaAnalyticsFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaCuePointType = {
    ad: 'adCuePoint.Ad',
    annotation: 'annotation.Annotation',
    code: 'codeCuePoint.Code',
    event: 'eventCuePoint.Event',
    quizAnswer: 'quiz.QUIZ_ANSWER',
    quizQuestion: 'quiz.QUIZ_QUESTION',
    thumb: 'thumbCuePoint.Thumb',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaCuePointStatus = {
    deleted: 2,
    handled: 3,
    pending: 4,
    ready: 1,
};
KalturaCuePointStatus[KalturaCuePointStatus.deleted] = 'deleted';
KalturaCuePointStatus[KalturaCuePointStatus.handled] = 'handled';
KalturaCuePointStatus[KalturaCuePointStatus.pending] = 'pending';
KalturaCuePointStatus[KalturaCuePointStatus.ready] = 'ready';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCuePoint extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCuePoint' },
            id: { type: 's', readOnly: true },
            cuePointType: { type: 'es', readOnly: true, subTypeConstructor: KalturaCuePointType, subType: 'KalturaCuePointType' },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaCuePointStatus, subType: 'KalturaCuePointStatus' },
            entryId: { type: 's' },
            partnerId: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            triggeredAt: { type: 'd' },
            tags: { type: 's' },
            startTime: { type: 'n' },
            userId: { type: 's', readOnly: true },
            partnerData: { type: 's' },
            partnerSortValue: { type: 'n' },
            forceStop: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            thumbOffset: { type: 'n' },
            systemName: { type: 's' },
            isMomentary: { type: 'b', readOnly: true },
            copiedFrom: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaCuePoint'] = KalturaCuePoint;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAnnotation extends KalturaCuePoint {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAnnotation' },
            parentId: { type: 's' },
            text: { type: 's' },
            endTime: { type: 'n' },
            duration: { type: 'n', readOnly: true },
            depth: { type: 'n', readOnly: true },
            childrenCount: { type: 'n', readOnly: true },
            directChildrenCount: { type: 'n', readOnly: true },
            isPublic: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            searchableOnEntry: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAnnotation'] = KalturaAnnotation;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaApiExceptionArg extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaApiExceptionArg' },
            name: { type: 's' },
            value: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaApiExceptionArg'] = KalturaApiExceptionArg;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaAppTokenStatus = {
    active: 2,
    deleted: 3,
    disabled: 1,
};
KalturaAppTokenStatus[KalturaAppTokenStatus.active] = 'active';
KalturaAppTokenStatus[KalturaAppTokenStatus.deleted] = 'deleted';
KalturaAppTokenStatus[KalturaAppTokenStatus.disabled] = 'disabled';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaSessionType = {
    admin: 2,
    user: 0,
};
KalturaSessionType[KalturaSessionType.admin] = 'admin';
KalturaSessionType[KalturaSessionType.user] = 'user';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAppTokenHashType = {
    md5: 'MD5',
    sha1: 'SHA1',
    sha256: 'SHA256',
    sha512: 'SHA512',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAppToken extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAppToken' },
            id: { type: 's', readOnly: true },
            token: { type: 's', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaAppTokenStatus, subType: 'KalturaAppTokenStatus' },
            expiry: { type: 'n' },
            sessionType: { type: 'en', subTypeConstructor: KalturaSessionType, subType: 'KalturaSessionType' },
            sessionUserId: { type: 's' },
            sessionDuration: { type: 'n' },
            sessionPrivileges: { type: 's' },
            hashType: { type: 'es', subTypeConstructor: KalturaAppTokenHashType, subType: 'KalturaAppTokenHashType' },
            description: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAppToken'] = KalturaAppToken;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAsset extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAsset' },
            id: { type: 's', readOnly: true },
            entryId: { type: 's', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            version: { type: 'n', readOnly: true },
            size: { type: 'n', readOnly: true },
            tags: { type: 's' },
            fileExt: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            deletedAt: { type: 'd', readOnly: true },
            description: { type: 's', readOnly: true },
            partnerData: { type: 's' },
            partnerDescription: { type: 's' },
            actualSourceAssetParamsIds: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAsset'] = KalturaAsset;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAssetDistributionCondition extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAssetDistributionCondition' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAssetDistributionCondition'] = KalturaAssetDistributionCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAssetDistributionRule extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.assetDistributionConditions === 'undefined')
            this.assetDistributionConditions = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAssetDistributionRule' },
            validationError: { type: 's' },
            assetDistributionConditions: { type: 'a', subTypeConstructor: KalturaAssetDistributionCondition, subType: 'KalturaAssetDistributionCondition' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAssetDistributionRule'] = KalturaAssetDistributionRule;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaString extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaString' },
            value: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaString'] = KalturaString;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaMediaParserType = {
    ffmpeg: '1',
    mediainfo: '0',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAssetParams extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.requiredPermissions === 'undefined')
            this.requiredPermissions = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAssetParams' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n' },
            name: { type: 's' },
            systemName: { type: 's' },
            description: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            isSystemDefault: { type: 'en', readOnly: true, subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            tags: { type: 's' },
            requiredPermissions: { type: 'a', subTypeConstructor: KalturaString, subType: 'KalturaString' },
            sourceRemoteStorageProfileId: { type: 'n' },
            remoteStorageProfileIds: { type: 'n' },
            mediaParserType: { type: 'es', subTypeConstructor: KalturaMediaParserType, subType: 'KalturaMediaParserType' },
            sourceAssetParamsIds: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAssetParams'] = KalturaAssetParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaResource extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaResource' }
        });
        return result;
    }
}
typesMappingStorage['KalturaResource'] = KalturaResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaContentResource extends KalturaResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaContentResource' }
        });
        return result;
    }
}
typesMappingStorage['KalturaContentResource'] = KalturaContentResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAssetParamsResourceContainer extends KalturaResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAssetParamsResourceContainer' },
            resource: { type: 'o', subTypeConstructor: KalturaContentResource, subType: 'KalturaContentResource' },
            assetParamsId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAssetParamsResourceContainer'] = KalturaAssetParamsResourceContainer;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAssetServeOptions extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAssetServeOptions' },
            download: { type: 'b' },
            referrer: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAssetServeOptions'] = KalturaAssetServeOptions;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAttachmentType = {
    document: '3',
    json: '4',
    media: '2',
    text: '1',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaAttachmentAssetStatus = {
    deleted: 3,
    error: -1,
    exporting: 9,
    importing: 7,
    queued: 0,
    ready: 2,
};
KalturaAttachmentAssetStatus[KalturaAttachmentAssetStatus.deleted] = 'deleted';
KalturaAttachmentAssetStatus[KalturaAttachmentAssetStatus.error] = 'error';
KalturaAttachmentAssetStatus[KalturaAttachmentAssetStatus.exporting] = 'exporting';
KalturaAttachmentAssetStatus[KalturaAttachmentAssetStatus.importing] = 'importing';
KalturaAttachmentAssetStatus[KalturaAttachmentAssetStatus.queued] = 'queued';
KalturaAttachmentAssetStatus[KalturaAttachmentAssetStatus.ready] = 'ready';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAttachmentAsset extends KalturaAsset {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAttachmentAsset' },
            filename: { type: 's' },
            title: { type: 's' },
            format: { type: 'es', subTypeConstructor: KalturaAttachmentType, subType: 'KalturaAttachmentType' },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaAttachmentAssetStatus, subType: 'KalturaAttachmentAssetStatus' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAttachmentAsset'] = KalturaAttachmentAsset;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAuditTrailInfo extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAuditTrailInfo' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAuditTrailInfo'] = KalturaAuditTrailInfo;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaAuditTrailStatus = {
    failed: 3,
    pending: 1,
    ready: 2,
};
KalturaAuditTrailStatus[KalturaAuditTrailStatus.failed] = 'failed';
KalturaAuditTrailStatus[KalturaAuditTrailStatus.pending] = 'pending';
KalturaAuditTrailStatus[KalturaAuditTrailStatus.ready] = 'ready';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAuditTrailObjectType = {
    accessControl: 'accessControl',
    batchJob: 'BatchJob',
    category: 'category',
    conversionProfile2: 'conversionProfile2',
    emailIngestionProfile: 'EmailIngestionProfile',
    entry: 'entry',
    fileSync: 'FileSync',
    flavorAsset: 'flavorAsset',
    flavorParams: 'flavorParams',
    flavorParamsConversionProfile: 'flavorParamsConversionProfile',
    flavorParamsOutput: 'flavorParamsOutput',
    kshow: 'kshow',
    kshowKuser: 'KshowKuser',
    kuser: 'kuser',
    mediaInfo: 'mediaInfo',
    metadata: 'Metadata',
    metadataProfile: 'MetadataProfile',
    moderation: 'moderation',
    partner: 'Partner',
    permission: 'Permission',
    roughcut: 'roughcutEntry',
    syndication: 'syndicationFeed',
    thumbnailAsset: 'thumbAsset',
    thumbnailParams: 'thumbParams',
    thumbnailParamsOutput: 'thumbParamsOutput',
    uiConf: 'uiConf',
    uploadToken: 'UploadToken',
    userLoginData: 'UserLoginData',
    userRole: 'UserRole',
    widget: 'widget',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAuditTrailAction = {
    changed: 'CHANGED',
    contentViewed: 'CONTENT_VIEWED',
    copied: 'COPIED',
    created: 'CREATED',
    deleted: 'DELETED',
    fileSyncCreated: 'FILE_SYNC_CREATED',
    relationAdded: 'RELATION_ADDED',
    relationRemoved: 'RELATION_REMOVED',
    viewed: 'VIEWED',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaAuditTrailContext = {
    apiV3: 2,
    client: -1,
    ps2: 1,
    script: 0,
};
KalturaAuditTrailContext[KalturaAuditTrailContext.apiV3] = 'apiV3';
KalturaAuditTrailContext[KalturaAuditTrailContext.client] = 'client';
KalturaAuditTrailContext[KalturaAuditTrailContext.ps2] = 'ps2';
KalturaAuditTrailContext[KalturaAuditTrailContext.script] = 'script';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAuditTrail extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAuditTrail' },
            id: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            parsedAt: { type: 'n', readOnly: true },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaAuditTrailStatus, subType: 'KalturaAuditTrailStatus' },
            auditObjectType: { type: 'es', subTypeConstructor: KalturaAuditTrailObjectType, subType: 'KalturaAuditTrailObjectType' },
            objectId: { type: 's' },
            relatedObjectId: { type: 's' },
            relatedObjectType: { type: 'es', subTypeConstructor: KalturaAuditTrailObjectType, subType: 'KalturaAuditTrailObjectType' },
            entryId: { type: 's' },
            masterPartnerId: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            requestId: { type: 's', readOnly: true },
            userId: { type: 's' },
            action: { type: 'es', subTypeConstructor: KalturaAuditTrailAction, subType: 'KalturaAuditTrailAction' },
            data: { type: 'o', subTypeConstructor: KalturaAuditTrailInfo, subType: 'KalturaAuditTrailInfo' },
            ks: { type: 's', readOnly: true },
            context: { type: 'en', readOnly: true, subTypeConstructor: KalturaAuditTrailContext, subType: 'KalturaAuditTrailContext' },
            entryPoint: { type: 's', readOnly: true },
            serverName: { type: 's', readOnly: true },
            ipAddress: { type: 's', readOnly: true },
            userAgent: { type: 's', readOnly: true },
            clientTag: { type: 's' },
            description: { type: 's' },
            errorDescription: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaAuditTrail'] = KalturaAuditTrail;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAuditTrailChangeItem extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAuditTrailChangeItem' },
            descriptor: { type: 's' },
            oldValue: { type: 's' },
            newValue: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAuditTrailChangeItem'] = KalturaAuditTrailChangeItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaOperationAttributes extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaOperationAttributes' }
        });
        return result;
    }
}
typesMappingStorage['KalturaOperationAttributes'] = KalturaOperationAttributes;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEntryStatus = {
    blocked: '6',
    deleted: '3',
    errorConverting: '-1',
    errorImporting: '-2',
    import: '0',
    infected: 'virusScan.Infected',
    moderate: '5',
    noContent: '7',
    pending: '4',
    preconvert: '1',
    ready: '2',
    scanFailure: 'virusScan.ScanFailure',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaEntryModerationStatus = {
    approved: 2,
    autoApproved: 6,
    deleted: 4,
    flaggedForReview: 5,
    pendingModeration: 1,
    rejected: 3,
};
KalturaEntryModerationStatus[KalturaEntryModerationStatus.approved] = 'approved';
KalturaEntryModerationStatus[KalturaEntryModerationStatus.autoApproved] = 'autoApproved';
KalturaEntryModerationStatus[KalturaEntryModerationStatus.deleted] = 'deleted';
KalturaEntryModerationStatus[KalturaEntryModerationStatus.flaggedForReview] = 'flaggedForReview';
KalturaEntryModerationStatus[KalturaEntryModerationStatus.pendingModeration] = 'pendingModeration';
KalturaEntryModerationStatus[KalturaEntryModerationStatus.rejected] = 'rejected';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEntryType = {
    automatic: '-1',
    data: '6',
    document: '10',
    externalMedia: 'externalMedia.externalMedia',
    liveChannel: '8',
    liveStream: '7',
    mediaClip: '1',
    mix: '2',
    playlist: '5',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaLicenseType = {
    afferoGpl: 11,
    apache: 14,
    bsd: 13,
    copyrighted: 1,
    creativecommonsAttribution: 3,
    creativecommonsAttributionNonCommercial: 6,
    creativecommonsAttributionNonCommercialNoDerivatives: 8,
    creativecommonsAttributionNonCommercialShareAlike: 7,
    creativecommonsAttributionNoDerivatives: 5,
    creativecommonsAttributionShareAlike: 4,
    gfdl: 9,
    gpl: 10,
    lgpl: 12,
    mozilla: 15,
    none: 0,
    publicDomain: 2,
    unknown: -1,
};
KalturaLicenseType[KalturaLicenseType.afferoGpl] = 'afferoGpl';
KalturaLicenseType[KalturaLicenseType.apache] = 'apache';
KalturaLicenseType[KalturaLicenseType.bsd] = 'bsd';
KalturaLicenseType[KalturaLicenseType.copyrighted] = 'copyrighted';
KalturaLicenseType[KalturaLicenseType.creativecommonsAttribution] = 'creativecommonsAttribution';
KalturaLicenseType[KalturaLicenseType.creativecommonsAttributionNonCommercial] = 'creativecommonsAttributionNonCommercial';
KalturaLicenseType[KalturaLicenseType.creativecommonsAttributionNonCommercialNoDerivatives] = 'creativecommonsAttributionNonCommercialNoDerivatives';
KalturaLicenseType[KalturaLicenseType.creativecommonsAttributionNonCommercialShareAlike] = 'creativecommonsAttributionNonCommercialShareAlike';
KalturaLicenseType[KalturaLicenseType.creativecommonsAttributionNoDerivatives] = 'creativecommonsAttributionNoDerivatives';
KalturaLicenseType[KalturaLicenseType.creativecommonsAttributionShareAlike] = 'creativecommonsAttributionShareAlike';
KalturaLicenseType[KalturaLicenseType.gfdl] = 'gfdl';
KalturaLicenseType[KalturaLicenseType.gpl] = 'gpl';
KalturaLicenseType[KalturaLicenseType.lgpl] = 'lgpl';
KalturaLicenseType[KalturaLicenseType.mozilla] = 'mozilla';
KalturaLicenseType[KalturaLicenseType.none] = 'none';
KalturaLicenseType[KalturaLicenseType.publicDomain] = 'publicDomain';
KalturaLicenseType[KalturaLicenseType.unknown] = 'unknown';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEntryReplacementStatus = {
    approvedButNotReady: '1',
    failed: '4',
    none: '0',
    notReadyAndNotApproved: '3',
    readyButNotApproved: '2',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaEntryDisplayInSearchType = {
    kalturaNetwork: 2,
    none: 0,
    partnerOnly: 1,
    system: -1,
};
KalturaEntryDisplayInSearchType[KalturaEntryDisplayInSearchType.kalturaNetwork] = 'kalturaNetwork';
KalturaEntryDisplayInSearchType[KalturaEntryDisplayInSearchType.none] = 'none';
KalturaEntryDisplayInSearchType[KalturaEntryDisplayInSearchType.partnerOnly] = 'partnerOnly';
KalturaEntryDisplayInSearchType[KalturaEntryDisplayInSearchType.system] = 'system';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBaseEntry extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.operationAttributes === 'undefined')
            this.operationAttributes = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBaseEntry' },
            id: { type: 's', readOnly: true },
            name: { type: 's' },
            description: { type: 's' },
            partnerId: { type: 'n', readOnly: true },
            userId: { type: 's' },
            creatorId: { type: 's' },
            tags: { type: 's' },
            adminTags: { type: 's' },
            categories: { type: 's' },
            categoriesIds: { type: 's' },
            status: { type: 'es', readOnly: true, subTypeConstructor: KalturaEntryStatus, subType: 'KalturaEntryStatus' },
            moderationStatus: { type: 'en', readOnly: true, subTypeConstructor: KalturaEntryModerationStatus, subType: 'KalturaEntryModerationStatus' },
            moderationCount: { type: 'n', readOnly: true },
            type: { type: 'es', subTypeConstructor: KalturaEntryType, subType: 'KalturaEntryType' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            rank: { type: 'n', readOnly: true },
            totalRank: { type: 'n', readOnly: true },
            votes: { type: 'n', readOnly: true },
            groupId: { type: 'n' },
            partnerData: { type: 's' },
            downloadUrl: { type: 's', readOnly: true },
            searchText: { type: 's', readOnly: true },
            licenseType: { type: 'en', subTypeConstructor: KalturaLicenseType, subType: 'KalturaLicenseType' },
            version: { type: 'n', readOnly: true },
            thumbnailUrl: { type: 's', readOnly: true },
            accessControlId: { type: 'n' },
            startDate: { type: 'd' },
            endDate: { type: 'd' },
            referenceId: { type: 's' },
            replacingEntryId: { type: 's', readOnly: true },
            replacedEntryId: { type: 's', readOnly: true },
            replacementStatus: { type: 'es', readOnly: true, subTypeConstructor: KalturaEntryReplacementStatus, subType: 'KalturaEntryReplacementStatus' },
            partnerSortValue: { type: 'n' },
            conversionProfileId: { type: 'n' },
            redirectEntryId: { type: 's' },
            rootEntryId: { type: 's', readOnly: true },
            parentEntryId: { type: 's' },
            operationAttributes: { type: 'a', subTypeConstructor: KalturaOperationAttributes, subType: 'KalturaOperationAttributes' },
            entitledUsersEdit: { type: 's' },
            entitledUsersPublish: { type: 's' },
            entitledUsersView: { type: 's' },
            capabilities: { type: 's', readOnly: true },
            templateEntryId: { type: 's' },
            displayInSearch: { type: 'en', subTypeConstructor: KalturaEntryDisplayInSearchType, subType: 'KalturaEntryDisplayInSearchType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBaseEntry'] = KalturaBaseEntry;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBaseEntryCloneOptionItem extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBaseEntryCloneOptionItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBaseEntryCloneOptionItem'] = KalturaBaseEntryCloneOptionItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaSyndicationFeedStatus = {
    active: 1,
    deleted: -1,
};
KalturaSyndicationFeedStatus[KalturaSyndicationFeedStatus.active] = 'active';
KalturaSyndicationFeedStatus[KalturaSyndicationFeedStatus.deleted] = 'deleted';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaSyndicationFeedType = {
    googleVideo: 1,
    itunes: 3,
    kaltura: 5,
    kalturaXslt: 6,
    operaTvSnap: 8,
    rokuDirectPublisher: 7,
    tubeMogul: 4,
    yahoo: 2,
};
KalturaSyndicationFeedType[KalturaSyndicationFeedType.googleVideo] = 'googleVideo';
KalturaSyndicationFeedType[KalturaSyndicationFeedType.itunes] = 'itunes';
KalturaSyndicationFeedType[KalturaSyndicationFeedType.kaltura] = 'kaltura';
KalturaSyndicationFeedType[KalturaSyndicationFeedType.kalturaXslt] = 'kalturaXslt';
KalturaSyndicationFeedType[KalturaSyndicationFeedType.operaTvSnap] = 'operaTvSnap';
KalturaSyndicationFeedType[KalturaSyndicationFeedType.rokuDirectPublisher] = 'rokuDirectPublisher';
KalturaSyndicationFeedType[KalturaSyndicationFeedType.tubeMogul] = 'tubeMogul';
KalturaSyndicationFeedType[KalturaSyndicationFeedType.yahoo] = 'yahoo';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaSyndicationFeedEntriesOrderBy = {
    createdAtDesc: '-createdAt',
    recent: 'recent',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBaseSyndicationFeed extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBaseSyndicationFeed' },
            id: { type: 's', readOnly: true },
            feedUrl: { type: 's', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            playlistId: { type: 's' },
            name: { type: 's' },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaSyndicationFeedStatus, subType: 'KalturaSyndicationFeedStatus' },
            type: { type: 'en', subTypeConstructor: KalturaSyndicationFeedType, subType: 'KalturaSyndicationFeedType' },
            landingPage: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            allowEmbed: { type: 'b' },
            playerUiconfId: { type: 'n' },
            flavorParamId: { type: 'n' },
            transcodeExistingContent: { type: 'b' },
            addToDefaultConversionProfile: { type: 'b' },
            categories: { type: 's' },
            storageId: { type: 'n' },
            entriesOrderBy: { type: 'es', subTypeConstructor: KalturaSyndicationFeedEntriesOrderBy, subType: 'KalturaSyndicationFeedEntriesOrderBy' },
            enforceEntitlement: { type: 'b' },
            privacyContext: { type: 's' },
            updatedAt: { type: 'd', readOnly: true },
            useCategoryEntries: { type: 'b' },
            feedContentTypeHeader: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBaseSyndicationFeed'] = KalturaBaseSyndicationFeed;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaJobData extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaJobData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaJobData'] = KalturaJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBatchHistoryData extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBatchHistoryData' },
            schedulerId: { type: 'n' },
            workerId: { type: 'n' },
            batchIndex: { type: 'n' },
            timeStamp: { type: 'n' },
            message: { type: 's' },
            errType: { type: 'n' },
            errNumber: { type: 'n' },
            hostName: { type: 's' },
            sessionId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBatchHistoryData'] = KalturaBatchHistoryData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBatchJobType = {
    bulkdownload: '19',
    bulkupload: '4',
    captureThumb: '30',
    chunkedEncodeJobScheduler: '44',
    cleanup: '17',
    clipConcat: '47',
    concat: '35',
    convert: '0',
    convertCollection: '22',
    convertLiveSegment: '36',
    convertProfile: '10',
    copy: '34',
    copyCaptions: '43',
    copyCuePoints: '48',
    copyPartner: '37',
    dbCleanup: '20',
    delete: '2',
    deleteFile: '31',
    distributionDelete: 'contentDistribution.DistributionDelete',
    distributionDisable: 'contentDistribution.DistributionDisable',
    distributionEnable: 'contentDistribution.DistributionEnable',
    distributionFetchReport: 'contentDistribution.DistributionFetchReport',
    distributionSubmit: 'contentDistribution.DistributionSubmit',
    distributionSync: 'contentDistribution.DistributionSync',
    distributionUpdate: 'contentDistribution.DistributionUpdate',
    download: '6',
    dropFolderContentProcessor: 'dropFolder.DropFolderContentProcessor',
    dropFolderWatcher: 'dropFolder.DropFolderWatcher',
    dvdcreator: '5',
    emailIngestion: '26',
    eventNotificationHandler: 'eventNotification.EventNotificationHandler',
    extractMedia: '14',
    filesyncImport: '29',
    flatten: '3',
    import: '1',
    index: '32',
    indexTags: 'tagSearch.IndexTagsByPrivacyContext',
    integration: 'integration.Integration',
    liveReportExport: '40',
    liveToVod: '42',
    mail: '15',
    metadataImport: '27',
    metadataTransform: '28',
    moveCategoryEntries: '33',
    notification: '16',
    ooconvert: '7',
    parseCaptionAsset: 'captionSearch.parseCaptionAsset',
    parseMultiLanguageCaptionAsset: 'caption.parsemultilanguagecaptionasset',
    postconvert: '11',
    provisionDelete: '24',
    provisionProvide: '21',
    recalculateCache: '41',
    scheduledTask: 'scheduledTask.ScheduledTask',
    schedulerHelper: '18',
    serverNodeMonitor: '45',
    storageDelete: '25',
    storageExport: '23',
    syncCategoryPrivacyContext: '39',
    tagResolve: 'tagSearch.TagResolve',
    usersCsv: '46',
    validateLiveMediaServers: '38',
    virusScan: 'virusScan.VirusScan',
    widevineRepositorySync: 'widevine.WidevineRepositorySync',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaBatchJobStatus = {
    aborted: 7,
    almostDone: 8,
    dontProcess: 11,
    failed: 6,
    fatal: 10,
    finished: 5,
    finishedPartially: 12,
    movefile: 4,
    pending: 0,
    processed: 3,
    processing: 2,
    queued: 1,
    retry: 9,
    suspend: 13,
    suspendAlmostDone: 14,
};
KalturaBatchJobStatus[KalturaBatchJobStatus.aborted] = 'aborted';
KalturaBatchJobStatus[KalturaBatchJobStatus.almostDone] = 'almostDone';
KalturaBatchJobStatus[KalturaBatchJobStatus.dontProcess] = 'dontProcess';
KalturaBatchJobStatus[KalturaBatchJobStatus.failed] = 'failed';
KalturaBatchJobStatus[KalturaBatchJobStatus.fatal] = 'fatal';
KalturaBatchJobStatus[KalturaBatchJobStatus.finished] = 'finished';
KalturaBatchJobStatus[KalturaBatchJobStatus.finishedPartially] = 'finishedPartially';
KalturaBatchJobStatus[KalturaBatchJobStatus.movefile] = 'movefile';
KalturaBatchJobStatus[KalturaBatchJobStatus.pending] = 'pending';
KalturaBatchJobStatus[KalturaBatchJobStatus.processed] = 'processed';
KalturaBatchJobStatus[KalturaBatchJobStatus.processing] = 'processing';
KalturaBatchJobStatus[KalturaBatchJobStatus.queued] = 'queued';
KalturaBatchJobStatus[KalturaBatchJobStatus.retry] = 'retry';
KalturaBatchJobStatus[KalturaBatchJobStatus.suspend] = 'suspend';
KalturaBatchJobStatus[KalturaBatchJobStatus.suspendAlmostDone] = 'suspendAlmostDone';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaBatchJobErrorTypes = {
    app: 0,
    curl: 3,
    http: 2,
    kalturaApi: 4,
    kalturaClient: 5,
    runtime: 1,
};
KalturaBatchJobErrorTypes[KalturaBatchJobErrorTypes.app] = 'app';
KalturaBatchJobErrorTypes[KalturaBatchJobErrorTypes.curl] = 'curl';
KalturaBatchJobErrorTypes[KalturaBatchJobErrorTypes.http] = 'http';
KalturaBatchJobErrorTypes[KalturaBatchJobErrorTypes.kalturaApi] = 'kalturaApi';
KalturaBatchJobErrorTypes[KalturaBatchJobErrorTypes.kalturaClient] = 'kalturaClient';
KalturaBatchJobErrorTypes[KalturaBatchJobErrorTypes.runtime] = 'runtime';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBatchJob extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.history === 'undefined')
            this.history = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBatchJob' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            deletedAt: { type: 'd', readOnly: true },
            lockExpiration: { type: 'n', readOnly: true },
            executionAttempts: { type: 'n', readOnly: true },
            lockVersion: { type: 'n', readOnly: true },
            entryId: { type: 's' },
            entryName: { type: 's' },
            jobType: { type: 'es', readOnly: true, subTypeConstructor: KalturaBatchJobType, subType: 'KalturaBatchJobType' },
            jobSubType: { type: 'n' },
            data: { type: 'o', subTypeConstructor: KalturaJobData, subType: 'KalturaJobData' },
            status: { type: 'en', subTypeConstructor: KalturaBatchJobStatus, subType: 'KalturaBatchJobStatus' },
            abort: { type: 'n' },
            checkAgainTimeout: { type: 'n' },
            message: { type: 's' },
            description: { type: 's' },
            priority: { type: 'n' },
            history: { type: 'a', subTypeConstructor: KalturaBatchHistoryData, subType: 'KalturaBatchHistoryData' },
            bulkJobId: { type: 'n' },
            batchVersion: { type: 'n' },
            parentJobId: { type: 'n' },
            rootJobId: { type: 'n' },
            queueTime: { type: 'n' },
            finishTime: { type: 'n' },
            errType: { type: 'en', subTypeConstructor: KalturaBatchJobErrorTypes, subType: 'KalturaBatchJobErrorTypes' },
            errNumber: { type: 'n' },
            estimatedEffort: { type: 'n' },
            urgency: { type: 'n' },
            schedulerId: { type: 'n' },
            workerId: { type: 'n' },
            batchIndex: { type: 'n' },
            lastSchedulerId: { type: 'n' },
            lastWorkerId: { type: 'n' },
            dc: { type: 'n' },
            jobObjectId: { type: 's' },
            jobObjectType: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBatchJob'] = KalturaBatchJob;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayerDeliveryType extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.flashvars === 'undefined')
            this.flashvars = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayerDeliveryType' },
            id: { type: 's' },
            label: { type: 's' },
            flashvars: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            minVersion: { type: 's' },
            enabledByDefault: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayerDeliveryType'] = KalturaPlayerDeliveryType;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayerEmbedCodeType extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayerEmbedCodeType' },
            id: { type: 's' },
            label: { type: 's' },
            entryOnly: { type: 'b' },
            minVersion: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayerEmbedCodeType'] = KalturaPlayerEmbedCodeType;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaESearchLanguage = {
    arabic: 'Arabic',
    basque: 'Basque',
    brazilian: 'Brazilian',
    bulgarian: 'Bulgarian',
    catalan: 'Catalan',
    chinese: 'Chinese',
    czech: 'Czech',
    danish: 'Danish',
    dutch: 'Dutch',
    english: 'English',
    finnish: 'Finnish',
    french: 'French',
    galician: 'Galician',
    german: 'German',
    greek: 'Greek',
    hindi: 'Hindi',
    hungrian: 'Hungarian',
    indonesian: 'Indonesian',
    italian: 'Italian',
    japanese: 'Japanese',
    korean: 'Korean',
    latvian: 'Latvian',
    lithuanian: 'Lithuanian',
    norwegian: 'Norwegian',
    persian: 'Persian',
    portuguese: 'Prtuguese',
    romanian: 'Romanian',
    russian: 'Russian',
    sorani: 'Sorani',
    spanish: 'Spanish',
    swedish: 'Swedish',
    thai: 'Thai',
    turkish: 'Turkish',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchLanguageItem extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchLanguageItem' },
            eSerachLanguage: { type: 'es', subTypeConstructor: KalturaESearchLanguage, subType: 'KalturaESearchLanguage' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchLanguageItem'] = KalturaESearchLanguageItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaCommercialUseType = {
    commercialUse: 1,
    nonCommercialUse: 0,
};
KalturaCommercialUseType[KalturaCommercialUseType.commercialUse] = 'commercialUse';
KalturaCommercialUseType[KalturaCommercialUseType.nonCommercialUse] = 'nonCommercialUse';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaPartnerType = {
    adminConsole: 109,
    blackboard: 107,
    communityEdition: 105,
    dekiwiki: 103,
    drupal: 102,
    joomla: 106,
    kmc: 1,
    moodle: 104,
    sakai: 108,
    wiki: 100,
    wordpress: 101,
};
KalturaPartnerType[KalturaPartnerType.adminConsole] = 'adminConsole';
KalturaPartnerType[KalturaPartnerType.blackboard] = 'blackboard';
KalturaPartnerType[KalturaPartnerType.communityEdition] = 'communityEdition';
KalturaPartnerType[KalturaPartnerType.dekiwiki] = 'dekiwiki';
KalturaPartnerType[KalturaPartnerType.drupal] = 'drupal';
KalturaPartnerType[KalturaPartnerType.joomla] = 'joomla';
KalturaPartnerType[KalturaPartnerType.kmc] = 'kmc';
KalturaPartnerType[KalturaPartnerType.moodle] = 'moodle';
KalturaPartnerType[KalturaPartnerType.sakai] = 'sakai';
KalturaPartnerType[KalturaPartnerType.wiki] = 'wiki';
KalturaPartnerType[KalturaPartnerType.wordpress] = 'wordpress';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaPartnerStatus = {
    active: 1,
    blocked: 2,
    deleted: 0,
    fullBlock: 3,
};
KalturaPartnerStatus[KalturaPartnerStatus.active] = 'active';
KalturaPartnerStatus[KalturaPartnerStatus.blocked] = 'blocked';
KalturaPartnerStatus[KalturaPartnerStatus.deleted] = 'deleted';
KalturaPartnerStatus[KalturaPartnerStatus.fullBlock] = 'fullBlock';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaPartnerGroupType = {
    group: 3,
    publisher: 1,
    template: 4,
    varGroup: 2,
};
KalturaPartnerGroupType[KalturaPartnerGroupType.group] = 'group';
KalturaPartnerGroupType[KalturaPartnerGroupType.publisher] = 'publisher';
KalturaPartnerGroupType[KalturaPartnerGroupType.template] = 'template';
KalturaPartnerGroupType[KalturaPartnerGroupType.varGroup] = 'varGroup';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPartner extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.additionalParams === 'undefined')
            this.additionalParams = [];
        if (typeof this.deliveryTypes === 'undefined')
            this.deliveryTypes = [];
        if (typeof this.embedCodeTypes === 'undefined')
            this.embedCodeTypes = [];
        if (typeof this.eSearchLanguages === 'undefined')
            this.eSearchLanguages = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPartner' },
            id: { type: 'n', readOnly: true },
            name: { type: 's' },
            website: { type: 's' },
            notificationUrl: { type: 's' },
            appearInSearch: { type: 'n' },
            createdAt: { type: 'd', readOnly: true },
            adminName: { type: 's' },
            adminEmail: { type: 's' },
            description: { type: 's' },
            commercialUse: { type: 'en', subTypeConstructor: KalturaCommercialUseType, subType: 'KalturaCommercialUseType' },
            landingPage: { type: 's' },
            userLandingPage: { type: 's' },
            contentCategories: { type: 's' },
            type: { type: 'en', subTypeConstructor: KalturaPartnerType, subType: 'KalturaPartnerType' },
            phone: { type: 's' },
            describeYourself: { type: 's' },
            adultContent: { type: 'b' },
            defConversionProfileType: { type: 's' },
            notify: { type: 'n' },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaPartnerStatus, subType: 'KalturaPartnerStatus' },
            allowQuickEdit: { type: 'n' },
            mergeEntryLists: { type: 'n' },
            notificationsConfig: { type: 's' },
            maxUploadSize: { type: 'n' },
            partnerPackage: { type: 'n' },
            secret: { type: 's', readOnly: true },
            adminSecret: { type: 's', readOnly: true },
            cmsPassword: { type: 's', readOnly: true },
            allowMultiNotification: { type: 'n' },
            adminLoginUsersQuota: { type: 'n', readOnly: true },
            adminUserId: { type: 's' },
            firstName: { type: 's' },
            lastName: { type: 's' },
            country: { type: 's' },
            state: { type: 's' },
            additionalParams: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            publishersQuota: { type: 'n', readOnly: true },
            partnerGroupType: { type: 'en', readOnly: true, subTypeConstructor: KalturaPartnerGroupType, subType: 'KalturaPartnerGroupType' },
            defaultEntitlementEnforcement: { type: 'b', readOnly: true },
            defaultDeliveryType: { type: 's', readOnly: true },
            defaultEmbedCodeType: { type: 's', readOnly: true },
            deliveryTypes: { type: 'a', readOnly: true, subTypeConstructor: KalturaPlayerDeliveryType, subType: 'KalturaPlayerDeliveryType' },
            embedCodeTypes: { type: 'a', readOnly: true, subTypeConstructor: KalturaPlayerEmbedCodeType, subType: 'KalturaPlayerEmbedCodeType' },
            templatePartnerId: { type: 'n', readOnly: true },
            ignoreSeoLinks: { type: 'b', readOnly: true },
            host: { type: 's', readOnly: true },
            cdnHost: { type: 's', readOnly: true },
            isFirstLogin: { type: 'b', readOnly: true },
            logoutUrl: { type: 's', readOnly: true },
            partnerParentId: { type: 'n' },
            crmId: { type: 's', readOnly: true },
            referenceId: { type: 's' },
            timeAlignedRenditions: { type: 'b', readOnly: true },
            publisherEnvironmentType: { type: 'n', readOnly: true },
            ovpEnvironmentUrl: { type: 's', readOnly: true },
            ottEnvironmentUrl: { type: 's', readOnly: true },
            eSearchLanguages: { type: 'a', subTypeConstructor: KalturaESearchLanguageItem, subType: 'KalturaESearchLanguageItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPartner'] = KalturaPartner;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaValue extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaValue' },
            description: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaValue'] = KalturaValue;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBooleanValue extends KalturaValue {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBooleanValue' },
            value: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBooleanValue'] = KalturaBooleanValue;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkServiceData extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkServiceData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkServiceData'] = KalturaBulkServiceData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadPluginData extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadPluginData' },
            field: { type: 's' },
            value: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadPluginData'] = KalturaBulkUploadPluginData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBulkUploadResultStatus = {
    error: '1',
    inProgress: '3',
    ok: '2',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBulkUploadAction = {
    activate: '7',
    add: '1',
    addOrUpdate: '6',
    cancel: 'scheduleBulkUpload.CANCEL',
    delete: '3',
    reject: '8',
    replace: '4',
    transformXslt: '5',
    update: '2',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBulkUploadObjectType = {
    category: '2',
    categoryEntry: '5',
    categoryUser: '4',
    entry: '1',
    scheduleEvent: 'scheduleBulkUpload.SCHEDULE_EVENT',
    scheduleResource: 'scheduleBulkUpload.SCHEDULE_RESOURCE',
    user: '3',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadResult extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.pluginsData === 'undefined')
            this.pluginsData = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadResult' },
            id: { type: 'n', readOnly: true },
            bulkUploadJobId: { type: 'n' },
            lineIndex: { type: 'n' },
            partnerId: { type: 'n' },
            status: { type: 'es', subTypeConstructor: KalturaBulkUploadResultStatus, subType: 'KalturaBulkUploadResultStatus' },
            action: { type: 'es', subTypeConstructor: KalturaBulkUploadAction, subType: 'KalturaBulkUploadAction' },
            objectId: { type: 's' },
            objectStatus: { type: 'n' },
            bulkUploadResultObjectType: { type: 'es', subTypeConstructor: KalturaBulkUploadObjectType, subType: 'KalturaBulkUploadObjectType' },
            rowData: { type: 's' },
            partnerData: { type: 's' },
            objectErrorDescription: { type: 's' },
            pluginsData: { type: 'a', subTypeConstructor: KalturaBulkUploadPluginData, subType: 'KalturaBulkUploadPluginData' },
            errorDescription: { type: 's' },
            errorCode: { type: 's' },
            errorType: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadResult'] = KalturaBulkUploadResult;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBulkUploadType = {
    csv: 'bulkUploadCsv.CSV',
    dropFolderIcal: 'scheduleDropFolder.DROP_FOLDER_ICAL',
    dropFolderXml: 'dropFolderXmlBulkUpload.DROP_FOLDER_XML',
    filter: 'bulkUploadFilter.FILTER',
    ical: 'scheduleBulkUpload.ICAL',
    xml: 'bulkUploadXml.XML',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUpload extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.results === 'undefined')
            this.results = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUpload' },
            id: { type: 'n' },
            uploadedBy: { type: 's' },
            uploadedByUserId: { type: 's' },
            uploadedOn: { type: 'd' },
            numOfEntries: { type: 'n' },
            status: { type: 'en', subTypeConstructor: KalturaBatchJobStatus, subType: 'KalturaBatchJobStatus' },
            logFileUrl: { type: 's' },
            csvFileUrl: { type: 's' },
            bulkFileUrl: { type: 's' },
            bulkUploadType: { type: 'es', subTypeConstructor: KalturaBulkUploadType, subType: 'KalturaBulkUploadType' },
            results: { type: 'a', subTypeConstructor: KalturaBulkUploadResult, subType: 'KalturaBulkUploadResult' },
            error: { type: 's' },
            errorType: { type: 'en', subTypeConstructor: KalturaBatchJobErrorTypes, subType: 'KalturaBatchJobErrorTypes' },
            errorNumber: { type: 'n' },
            fileName: { type: 's' },
            description: { type: 's' },
            numOfObjects: { type: 'n' },
            bulkUploadObjectType: { type: 'es', subTypeConstructor: KalturaBulkUploadObjectType, subType: 'KalturaBulkUploadObjectType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUpload'] = KalturaBulkUpload;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadObjectData extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadObjectData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadObjectData'] = KalturaBulkUploadObjectData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessCase extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessCase' },
            id: { type: 's' },
            businessProcessId: { type: 's' },
            businessProcessStartNotificationTemplateId: { type: 'n' },
            suspended: { type: 'b' },
            activityId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessCase'] = KalturaBusinessProcessCase;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBusinessProcessServerStatus = {
    deleted: '3',
    disabled: '1',
    enabled: '2',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBusinessProcessProvider = {
    activiti: 'activitiBusinessProcessNotification.Activiti',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessServer extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessServer' },
            id: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            name: { type: 's' },
            systemName: { type: 's' },
            description: { type: 's' },
            status: { type: 'es', readOnly: true, subTypeConstructor: KalturaBusinessProcessServerStatus, subType: 'KalturaBusinessProcessServerStatus' },
            type: { type: 'es', readOnly: true, subTypeConstructor: KalturaBusinessProcessProvider, subType: 'KalturaBusinessProcessProvider' },
            dc: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessServer'] = KalturaBusinessProcessServer;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCEError extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCEError' },
            id: { type: 's', readOnly: true },
            partnerId: { type: 'n' },
            browser: { type: 's' },
            serverIp: { type: 's' },
            serverOs: { type: 's' },
            phpVersion: { type: 's' },
            ceAdminEmail: { type: 's' },
            type: { type: 's' },
            description: { type: 's' },
            data: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCEError'] = KalturaCEError;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLanguage = {
    aa: 'Afar',
    aal: 'Afade',
    ab: 'Abkhazian',
    abe: 'Abnaki Western',
    abq: 'Abaza',
    abu: 'Abure',
    ace: 'Achinese',
    acf: 'Saint Lucian Creole French',
    acn: 'Achang',
    act: 'Achterhooks',
    acv: 'Achumawi',
    adj: 'Adioukrou',
    adt: 'Adynyamathanha',
    ady: 'Adyghe; Adygei',
    af: 'Afrikaans',
    agq: 'Aghem',
    agr: 'Aguaruna',
    agu: 'Aguacateco',
    agx: 'Aghul',
    aii: 'Assyrian Neo-Aramaic',
    ain: 'Ainu (Japan)',
    akk: 'Akkadian',
    akl: 'Aklanon',
    aku: 'Akum',
    akz: 'Alabama',
    alc: 'Qawasqar',
    ale: 'Aleut',
    aln: 'Albanian (Gheg)',
    alq: 'Algonquin',
    als: 'Albanian (Tosk)',
    alt: 'Altai (Southern)',
    am: 'Amharic',
    ame: 'Yanesha',
    amw: 'Western Neo-Aramaic',
    ang: 'Old English',
    apj: 'Apache (Jicarilla)',
    apw: 'Apache (Western)',
    ar: 'Arabic',
    arb: 'Arabic (standard)',
    arc: 'Aramaic',
    ari: 'Arikara',
    arn: 'Araucanian',
    arp: 'Arapaho',
    asb: 'Assiniboine',
    ast: 'Asturian',
    as: 'Assamese',
    atj: 'Atikamekw',
    auc: 'Waorani',
    avk: 'Kotava',
    awa: 'Awadhi',
    ay: 'Aymara',
    az: 'Azerbaijani',
    ba: 'Bashkir',
    bal: 'Baluchi',
    ban: 'Balinese',
    bar: 'Bavarian',
    bas: 'Basa (Cameroon)',
    bcc: 'Balochi Southern',
    bcr: 'Babine',
    bdj: 'Bai',
    be: 'Byelorussian (Belarusian)',
    bea: 'Beaver',
    bej: 'Beja',
    bem: 'Bemba (Zambia)',
    bew: 'Betawi',
    bfq: 'Badaga',
    bft: 'Balti',
    bg: 'Bulgarian',
    bh: 'Bihari',
    bhb: 'Bhili',
    bho: 'Bhojpuri',
    bi: 'Bislama',
    bik: 'Bikol',
    bin: 'Bini',
    bn: 'Bengali (Bangla)',
    bo: 'Tibetan',
    bpy: 'Bishnupriya Manipuri',
    br: 'Breton',
    bua: 'Buriat',
    bug: 'Buginese',
    bT: 'Arabic Tunisian Spoken',
    ca: 'Catalan',
    caa: 'Chor',
    cad: 'Caddo',
    caf: 'Carrier Southern',
    cay: 'Cayuga',
    cdo: 'Min Dong Chinese',
    ceb: 'Cebuano',
    chc: 'Catawba',
    chg: 'Chagatai',
    chm: 'Mari (Russia)',
    chn: 'Chinook jargon',
    cho: 'Choctaw',
    chp: 'Chipewyan',
    chr: 'Cherokee',
    chy: 'Cheyenne',
    cic: 'Chickasaw',
    cim: 'Cimbrian',
    ciw: 'Chippewa',
    cjs: 'Shor',
    cjy: 'Jinyu Chinese',
    ckt: 'Chukot',
    clc: 'Chilcotin',
    cld: 'Chaldean Neo-Aramaic',
    clm: 'Clallam Klallam',
    cmn: 'Mandarin Chinese',
    co: 'Corsican',
    coc: 'Cocopa',
    coj: 'Cochimi',
    com: 'Comanche',
    coo: 'Comox',
    cop: 'Coptic',
    crh: 'Crimean Tatar',
    crx: 'Carrier',
    cs: 'Czech',
    csb: 'Kashubian',
    cup: 'Cupeo',
    cy: 'Welsh',
    czh: 'Huizhou Chinese',
    da: 'Danish',
    dak: 'Dakota',
    dar: 'Dargwa',
    ddo: 'Tsez',
    de: 'German',
    del: 'Delaware',
    dgr: 'Dogrib',
    dhv: 'Dehu',
    dih: 'Kumiai',
    din: 'Dinka',
    dje: 'Zarma',
    dlg: 'Dolgan',
    dng: 'Dungan',
    doh: 'Dong',
    doi: 'Dogri (generic)',
    dsb: 'Sorbian Lower',
    dua: 'Duala',
    dyu: 'Dyula',
    dz: 'Bhutani',
    eee: 'E',
    egl: 'Emilian',
    el: 'Greek',
    en: 'English',
    enm: 'English Middle (1100-1500)',
    enGb: 'English (British)',
    enUs: 'English (American)',
    eo: 'Esperanto',
    es: 'Spanish',
    et: 'Estonian',
    eu: 'Basque',
    eve: 'Even',
    evn: 'Evenki',
    fa: 'Farsi',
    fan: 'Fang (Equatorial Guinea)',
    fax: 'Fala',
    fi: 'Finnish',
    fil: 'Filipino',
    fit: 'Finnish (Tornedalen)',
    fj: 'Fiji',
    fo: 'Faeroese',
    fon: 'Fon',
    fr: 'French',
    frk: 'Frankish',
    frp: 'Franco-Prove',
    frr: 'Frisian Northern',
    fuc: 'Pulaar',
    fur: 'Friulian',
    fvr: 'Fur',
    fy: 'Frisian',
    ga: 'Irish',
    gaa: 'Ga',
    gag: 'Gagauz',
    gan: 'Gan',
    gbz: 'Dari Zoroastrian',
    gd: 'Gaelic (Scottish)',
    gdm: 'Laal',
    geh: 'German Hutterite',
    gez: 'Geez',
    gil: 'Gilbertese',
    git: 'Gitxsan',
    gl: 'Galician',
    gld: 'Nanai',
    gn: 'Guarani',
    gom: 'Konkani Goan',
    grc: 'Greek Ancient (to 1453)',
    gsw: 'Swiss German Alemannic Alsatian',
    gu: 'Gujarati',
    gv: 'Gaelic (Manx)',
    gwi: 'Gwichin',
    ha: 'Hausa',
    haa: 'Han',
    hai: 'Haida',
    hak: 'Hakka',
    has: 'Haisla',
    haw: 'Hawaiian',
    he: 'Hebrew',
    hei: 'Heiltsuk',
    hi: 'Hindi',
    hid: 'Hidatsa',
    hil: 'Hiligaynon',
    hkk: 'Hokkien',
    hmn: 'Hmong',
    hni: 'Hani',
    hnn: 'Hainanese',
    hop: 'Hopi',
    hr: 'Croatian',
    hsb: 'Sorbian Upper',
    hu: 'Hungarian',
    hur: 'Halkomelem',
    hy: 'Armenian',
    ia: 'Interlingua',
    id: 'Indonesian',
    ie: 'Interlingue',
    ik: 'Inupiak',
    ilo: 'Iloko',
    in: 'Indonesian',
    inh: 'Ingush',
    is: 'Icelandic',
    it: 'Italian',
    itl: 'Itelmen',
    iu: 'Inuktitut',
    iw: 'Hebrew',
    izh: 'Ingrian',
    ja: 'Japanese',
    jbo: 'Lojban',
    jct: 'Judeo-Crimean Tatar',
    jge: 'Judeo-Georgian',
    ji: 'Yiddish',
    jut: 'Jutish',
    jv: 'Javanese',
    ka: 'Georgian',
    kaa: 'Karakalpak',
    kab: 'Kabyle',
    kaj: 'Jju',
    kap: 'Bezhta',
    kaw: 'Kawi',
    kbd: 'Kabardian',
    kca: 'Khanty',
    kdr: 'Karaim',
    kea: 'Kabuverdianu',
    kfa: 'Kodava',
    kfr: 'Kachchi',
    kha: 'Khasi',
    kic: 'Kickapoo',
    kim: 'Karagas',
    kio: 'Kiowa',
    kjh: 'Khakas',
    kjv: 'Kaikavian literary language (Kajkavian)',
    kk: 'Kazakh',
    kkz: 'Kaska',
    kl: 'Greenlandic',
    klj: 'Khalaj Turkic',
    km: 'Cambodian',
    kn: 'Kannada',
    knn: 'Konkani (specific)',
    ko: 'Korean',
    koi: 'Komi-Permyak',
    kok: 'Konkani (generic)',
    kos: 'Kosraean',
    kpe: 'Kpelle',
    kpo: 'Ikposo',
    kpy: 'Koryak',
    krc: 'Karachay-Balkar',
    krl: 'Karelian',
    ks: 'Kashmiri',
    ksh: 'Colognian',
    ksk: 'Kansa',
    ku: 'Kurdish',
    kum: 'Kumyk',
    kut: 'Kutenai',
    kwk: 'Kwakiutl',
    kxm: 'Khmer Northern',
    ky: 'Kirghiz',
    la: 'Latin',
    lad: 'Ladino',
    lah: 'Lahnda',
    lbe: 'Lak',
    lez: 'Lezghian',
    lhu: 'Lahu',
    li: 'Limburgish ( Limburger)',
    lif: 'Limbu',
    lij: 'Ligurian',
    lil: 'Lillooet',
    lki: 'Laki',
    lkt: 'Lakota',
    lld: 'Ladin',
    lmo: 'Lombard',
    ln: 'Lingala',
    lo: 'Laothian',
    lom: 'Loma (Liberia)',
    loz: 'Lozi',
    lt: 'Lithuanian',
    lua: 'Luba-Lulua',
    lud: 'Ludian',
    lun: 'Lunda',
    luo: 'Luo (Kenya and Tanzania)',
    luq: 'Lucumi',
    lut: 'Lushootseed',
    lv: 'Latvian (Lettish)',
    lzz: 'Laz',
    mad: 'Madurese',
    mag: 'Magahi',
    mai: 'Maithili',
    mas: 'Masai',
    mdf: 'Moksha',
    men: 'Mende (Sierra Leone)',
    mez: 'Menominee',
    mfe: 'Morisyen',
    mfy: 'Mayo',
    mg: 'Malagasy',
    mhq: 'Mandan',
    mi: 'Maori',
    mic: 'Micmac',
    mid: 'Mandaic',
    min: 'Minangkabau',
    mk: 'Macedonian',
    ml: 'Malayalam',
    mn: 'Mongolian',
    mnc: 'Manchu',
    mni: 'Meitei',
    mnp: 'Min Bei Chinese',
    mns: 'Mansi',
    mnw: 'Mon',
    mo: 'Moldavian',
    moh: 'Mohawk',
    mos: 'Mossi',
    mr: 'Marathi',
    mrw: 'Maranao',
    ms: 'Malay',
    mt: 'Maltese',
    mtq: 'Muong',
    mu: 'Multilingual',
    mus: 'Creek',
    mwl: 'Mirandese',
    mwr: 'Marwari',
    mxi: 'Mozarabic',
    my: 'Burmese',
    myp: 'Pirah',
    myv: 'Erzya',
    mzb: 'Tumzabt',
    na: 'Nauru',
    nap: 'Neapolitan',
    naq: 'Nama (Namibia)',
    ncg: 'Nisgaa',
    nds: 'Low German Low Saxon',
    ne: 'Nepali',
    new: 'Newari Nepal Bhasa',
    nio: 'Nganasan',
    niu: 'Niuean',
    niv: 'Gilyak Nivkh',
    nl: 'Dutch',
    no: 'Norwegian',
    nod: 'Thai (Northern)',
    nog: 'Nogai',
    non: 'Norse Old',
    nov: 'Novial',
    nsk: 'Naskapi',
    nso: 'Northern Sotho Pedi Sepedi',
    nym: 'Nyamwezi',
    nyo: 'Nyoro',
    nys: 'Nyungah',
    oc: 'Occitan',
    ojb: 'Ojibwa Northwestern',
    ojc: 'Ojibwa Central',
    ojg: 'Ojibwa Eastern',
    ojs: 'Ojibwa Severn',
    ojw: 'Ojibwa Western',
    om: 'Oromo (Afan, Galla)',
    one: 'Oneida',
    ono: 'Onondaga',
    ood: 'Tohono Oodham',
    or: 'Oriya',
    ota: 'Turkish Ottoman',
    otw: 'Ottawa',
    pa: 'Punjabi',
    pag: 'Pangasinan',
    pam: 'Pampanga',
    pap: 'Papiamento',
    pau: 'Palauan',
    pcd: 'Picard',
    pdc: 'German Pennsylvania',
    pdt: 'Plautdietsch',
    pes: 'Western Farsi',
    pfl: 'Pfaelzisch',
    pih: 'Pitcairn-Norfolk',
    pl: 'Polish',
    pms: 'Piedmontese',
    pnt: 'Pontic',
    pot: 'Potawatomi',
    ppi: 'Paipai',
    pqm: 'Malecite-Passamaquoddy',
    prd: 'Dari (Persian)',
    prg: 'Prussian',
    prp: 'Persian',
    prs: 'Persian (Dari)',
    ps: 'Pashto (Pushto)',
    pt: 'Portuguese',
    qtz: 'Reserved for local use.',
    qu: 'Quechua',
    quc: 'Quich Central',
    qxq: 'Qashqai',
    rap: 'Rapanui',
    rar: 'Rarotongan',
    rcf: 'Runion Creole French',
    rgn: 'Romagnol',
    rm: 'Rhaeto-Romance',
    rme: 'Angloromani',
    rmf: 'Romani Kalo Finnish',
    rmo: 'Romani Sinte',
    rn: 'Kirundi (Rundi)',
    ro: 'Romanian',
    rom: 'Romany',
    ru: 'Russian',
    rue: 'Rusyn',
    ruo: 'Romanian Istro',
    rup: 'Aromanian',
    ruq: 'Romanian Megleno',
    rw: 'Kinyarwanda (Ruanda)',
    ryu: 'Okinawan Central',
    sa: 'Sanskrit',
    sah: 'Sakha',
    sam: 'Aramaic Samaritan',
    sat: 'Santali',
    scn: 'Sicilian',
    sco: 'Scots',
    scs: 'Slavey North',
    sd: 'Sindhi',
    sdc: 'Sardinian Sassarese',
    sec: 'Sechelt',
    see: 'Seneca',
    sei: 'Seri',
    sek: 'Sekani',
    sel: 'Selkup',
    sg: 'Sangro',
    sh: 'Serbo-Croatian',
    shh: 'Shoshoni',
    shi: 'Tachelhit',
    shs: 'Shuswap',
    shy: 'Tachawit',
    si: 'Sinhalese',
    sid: 'Sidamo',
    sjd: 'Sami Kildin',
    sjw: 'Shawnee',
    sk: 'Slovak',
    sl: 'Slovenian',
    slr: 'Salar',
    sm: 'Samoan',
    sma: 'Southern Sami',
    smj: 'Lule Sami',
    smn: 'Inari Sami',
    sms: 'Skolt Sami',
    sn: 'Shona',
    snk: 'Soninke',
    so: 'Somali',
    sq: 'Albanian',
    sr: 'Serbian',
    srm: 'Saramaccan',
    srn: 'Sranan',
    ss: 'Siswati',
    st: 'Sesotho',
    sto: 'Stoney',
    stq: 'Saterland Frisian',
    str: 'Salish Straits',
    su: 'Sundanese',
    sux: 'Sumerian',
    sv: 'Swedish',
    sva: 'Svan',
    sw: 'Swahili (Kiswahili)',
    swb: 'Comorian',
    swg: 'Swabian',
    swl: 'Swedish Sign Language',
    sxu: 'Saxon Upper',
    syr: 'Syriac',
    szl: 'Silesian',
    ta: 'Tamil',
    tab: 'Tabassaran',
    taq: 'Tamasheq',
    tar: 'Tarahumara Central',
    tbw: 'Tagbanwa',
    tcx: 'Toda',
    tcy: 'Tulu',
    tdd: 'Tai Na',
    te: 'Telugu',
    teo: 'Teo Chew',
    tet: 'Tetum',
    tg: 'Tajik',
    tgx: 'Tagish',
    th: 'Thai',
    thp: 'Thompson',
    tht: 'Tahltan',
    ti: 'Tigrinya',
    tig: 'Tigre',
    tk: 'Turkmen',
    tl: 'Tagalog',
    tlh: 'Klingon tlhIngan-Hol',
    tli: 'Tlingit',
    tly: 'Talysh',
    tn: 'Setswana',
    to: 'Tonga',
    tog: 'Tonga (Nyasa)',
    tpi: 'Tok Pisin',
    tpn: 'Tupinamb',
    tr: 'Turkish',
    trv: 'Seediq',
    ts: 'Tsonga',
    tsi: 'Tsimshian',
    tt: 'Tatar',
    ttq: 'Tamajaq Tawallammat',
    tts: 'Thai Northeastern',
    ttt: 'Tat Muslim',
    tum: 'Tumbuka',
    tus: 'Tuscarora',
    tuv: 'Turkana',
    tvl: 'Tuvalu',
    tw: 'Twi',
    tyv: 'Tuvinian',
    tzm: 'Tamazight Central Atlas',
    uby: 'Ubykh',
    udi: 'Udi',
    udm: 'Udmurt',
    ug: 'Uighur',
    uk: 'Ukrainian',
    un: 'Undefined',
    ur: 'Urdu',
    uum: 'Urum',
    uz: 'Uzbek',
    vec: 'Venetian',
    vep: 'Veps',
    vi: 'Vietnamese',
    vo: 'Volapuk',
    vor: 'Voro',
    vot: 'Votic',
    vro: 'Vro',
    war: 'Waray (Philippines)',
    wiy: 'Wiyot',
    wo: 'Wolof',
    wuu: 'Wu Chinese',
    wym: 'Wymysorys',
    xal: 'Kalmyk Oirat',
    xh: 'Xhosa',
    xmf: 'Mingrelian',
    xsl: 'Slavey South',
    xsv: 'Sudovian',
    yi: 'Yiddish',
    yo: 'Yoruba',
    yue: 'Cantonese',
    zai: 'Zapotec Isthmus',
    zh: 'Chinese',
    zu: 'Zulu',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLanguageCode = {
    aa: 'aa',
    ab: 'ab',
    af: 'af',
    am: 'am',
    ar: 'ar',
    as: 'as',
    ay: 'ay',
    az: 'az',
    ba: 'ba',
    be: 'be',
    bg: 'bg',
    bh: 'bh',
    bi: 'bi',
    bn: 'bn',
    bo: 'bo',
    br: 'br',
    ca: 'ca',
    co: 'co',
    cs: 'cs',
    cy: 'cy',
    da: 'da',
    de: 'de',
    dz: 'dz',
    el: 'el',
    en: 'en',
    enGb: 'en_gb',
    enUs: 'en_us',
    eo: 'eo',
    es: 'es',
    et: 'et',
    eu: 'eu',
    fa: 'fa',
    fi: 'fi',
    fj: 'fj',
    fo: 'fo',
    fr: 'fr',
    fy: 'fy',
    ga: 'ga',
    gd: 'gd',
    gl: 'gl',
    gn: 'gn',
    gu: 'gu',
    gv: 'gv',
    ha: 'ha',
    he: 'he',
    hi: 'hi',
    hr: 'hr',
    hu: 'hu',
    hy: 'hy',
    ia: 'ia',
    id: 'id',
    ie: 'ie',
    ik: 'ik',
    in: 'in',
    is: 'is',
    it: 'it',
    iu: 'iu',
    iw: 'iw',
    ja: 'ja',
    ji: 'ji',
    jv: 'jv',
    ka: 'ka',
    kk: 'kk',
    kl: 'kl',
    km: 'km',
    kn: 'kn',
    ko: 'ko',
    ks: 'ks',
    ku: 'ku',
    ky: 'ky',
    la: 'la',
    li: 'li',
    ln: 'ln',
    lo: 'lo',
    lt: 'lt',
    lv: 'lv',
    mg: 'mg',
    mi: 'mi',
    mk: 'mk',
    ml: 'ml',
    mn: 'mn',
    mo: 'mo',
    mr: 'mr',
    ms: 'ms',
    mt: 'mt',
    mu: 'multilingual',
    my: 'my',
    na: 'na',
    ne: 'ne',
    nl: 'nl',
    no: 'no',
    oc: 'oc',
    om: 'om',
    or: 'or',
    pa: 'pa',
    pl: 'pl',
    ps: 'ps',
    pt: 'pt',
    qu: 'qu',
    rm: 'rm',
    rn: 'rn',
    ro: 'ro',
    ru: 'ru',
    rw: 'rw',
    sa: 'sa',
    sd: 'sd',
    sg: 'sg',
    sh: 'sh',
    si: 'si',
    sk: 'sk',
    sl: 'sl',
    sm: 'sm',
    sn: 'sn',
    so: 'so',
    sq: 'sq',
    sr: 'sr',
    ss: 'ss',
    st: 'st',
    su: 'su',
    sv: 'sv',
    sw: 'sw',
    ta: 'ta',
    te: 'te',
    tg: 'tg',
    th: 'th',
    ti: 'ti',
    tk: 'tk',
    tl: 'tl',
    tn: 'tn',
    to: 'to',
    tr: 'tr',
    ts: 'ts',
    tt: 'tt',
    tw: 'tw',
    ug: 'ug',
    uk: 'uk',
    ur: 'ur',
    uz: 'uz',
    vi: 'vi',
    vo: 'vo',
    wo: 'wo',
    xh: 'xh',
    yi: 'yi',
    yo: 'yo',
    zh: 'zh',
    zu: 'zu',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaCaptionType = {
    cap: '4',
    dfxp: '2',
    srt: '1',
    webvtt: '3',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaCaptionAssetStatus = {
    deleted: 3,
    error: -1,
    exporting: 9,
    importing: 7,
    queued: 0,
    ready: 2,
};
KalturaCaptionAssetStatus[KalturaCaptionAssetStatus.deleted] = 'deleted';
KalturaCaptionAssetStatus[KalturaCaptionAssetStatus.error] = 'error';
KalturaCaptionAssetStatus[KalturaCaptionAssetStatus.exporting] = 'exporting';
KalturaCaptionAssetStatus[KalturaCaptionAssetStatus.importing] = 'importing';
KalturaCaptionAssetStatus[KalturaCaptionAssetStatus.queued] = 'queued';
KalturaCaptionAssetStatus[KalturaCaptionAssetStatus.ready] = 'ready';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCaptionAsset extends KalturaAsset {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCaptionAsset' },
            captionParamsId: { type: 'n' },
            language: { type: 'es', subTypeConstructor: KalturaLanguage, subType: 'KalturaLanguage' },
            languageCode: { type: 'es', readOnly: true, subTypeConstructor: KalturaLanguageCode, subType: 'KalturaLanguageCode' },
            isDefault: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            label: { type: 's' },
            format: { type: 'es', subTypeConstructor: KalturaCaptionType, subType: 'KalturaCaptionType' },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaCaptionAssetStatus, subType: 'KalturaCaptionAssetStatus' },
            parentId: { type: 's' },
            accuracy: { type: 'n' },
            displayOnPlayer: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCaptionAsset'] = KalturaCaptionAsset;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCaptionAssetItem extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCaptionAssetItem' },
            asset: { type: 'o', subTypeConstructor: KalturaCaptionAsset, subType: 'KalturaCaptionAsset' },
            entry: { type: 'o', subTypeConstructor: KalturaBaseEntry, subType: 'KalturaBaseEntry' },
            startTime: { type: 'n' },
            endTime: { type: 'n' },
            content: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCaptionAssetItem'] = KalturaCaptionAssetItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCaptionParams extends KalturaAssetParams {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCaptionParams' },
            language: { type: 'es', subTypeConstructor: KalturaLanguage, subType: 'KalturaLanguage' },
            isDefault: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            label: { type: 's' },
            format: { type: 'es', subTypeConstructor: KalturaCaptionType, subType: 'KalturaCaptionType' },
            sourceParamsId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCaptionParams'] = KalturaCaptionParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaAppearInListType = {
    categoryMembersOnly: 3,
    partnerOnly: 1,
};
KalturaAppearInListType[KalturaAppearInListType.categoryMembersOnly] = 'categoryMembersOnly';
KalturaAppearInListType[KalturaAppearInListType.partnerOnly] = 'partnerOnly';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaPrivacyType = {
    all: 1,
    authenticatedUsers: 2,
    membersOnly: 3,
};
KalturaPrivacyType[KalturaPrivacyType.all] = 'all';
KalturaPrivacyType[KalturaPrivacyType.authenticatedUsers] = 'authenticatedUsers';
KalturaPrivacyType[KalturaPrivacyType.membersOnly] = 'membersOnly';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaInheritanceType = {
    inherit: 1,
    manual: 2,
};
KalturaInheritanceType[KalturaInheritanceType.inherit] = 'inherit';
KalturaInheritanceType[KalturaInheritanceType.manual] = 'manual';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaUserJoinPolicyType = {
    autoJoin: 1,
    notAllowed: 3,
    requestToJoin: 2,
};
KalturaUserJoinPolicyType[KalturaUserJoinPolicyType.autoJoin] = 'autoJoin';
KalturaUserJoinPolicyType[KalturaUserJoinPolicyType.notAllowed] = 'notAllowed';
KalturaUserJoinPolicyType[KalturaUserJoinPolicyType.requestToJoin] = 'requestToJoin';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaCategoryUserPermissionLevel = {
    contributor: 2,
    manager: 0,
    member: 3,
    moderator: 1,
    none: 4,
};
KalturaCategoryUserPermissionLevel[KalturaCategoryUserPermissionLevel.contributor] = 'contributor';
KalturaCategoryUserPermissionLevel[KalturaCategoryUserPermissionLevel.manager] = 'manager';
KalturaCategoryUserPermissionLevel[KalturaCategoryUserPermissionLevel.member] = 'member';
KalturaCategoryUserPermissionLevel[KalturaCategoryUserPermissionLevel.moderator] = 'moderator';
KalturaCategoryUserPermissionLevel[KalturaCategoryUserPermissionLevel.none] = 'none';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaContributionPolicyType = {
    all: 1,
    membersWithContributionPermission: 2,
};
KalturaContributionPolicyType[KalturaContributionPolicyType.all] = 'all';
KalturaContributionPolicyType[KalturaContributionPolicyType.membersWithContributionPermission] = 'membersWithContributionPermission';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaCategoryStatus = {
    active: 2,
    deleted: 3,
    purged: 4,
    updating: 1,
};
KalturaCategoryStatus[KalturaCategoryStatus.active] = 'active';
KalturaCategoryStatus[KalturaCategoryStatus.deleted] = 'deleted';
KalturaCategoryStatus[KalturaCategoryStatus.purged] = 'purged';
KalturaCategoryStatus[KalturaCategoryStatus.updating] = 'updating';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaCategoryOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    depthAsc: '+depth',
    depthDesc: '-depth',
    directEntriesCountAsc: '+directEntriesCount',
    directEntriesCountDesc: '-directEntriesCount',
    directSubCategoriesCountAsc: '+directSubCategoriesCount',
    directSubCategoriesCountDesc: '-directSubCategoriesCount',
    entriesCountAsc: '+entriesCount',
    entriesCountDesc: '-entriesCount',
    fullNameAsc: '+fullName',
    fullNameDesc: '-fullName',
    membersCountAsc: '+membersCount',
    membersCountDesc: '-membersCount',
    nameAsc: '+name',
    nameDesc: '-name',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCategory extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCategory' },
            id: { type: 'n', readOnly: true },
            parentId: { type: 'n' },
            depth: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            name: { type: 's' },
            fullName: { type: 's', readOnly: true },
            fullIds: { type: 's', readOnly: true },
            entriesCount: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            description: { type: 's' },
            tags: { type: 's' },
            appearInList: { type: 'en', subTypeConstructor: KalturaAppearInListType, subType: 'KalturaAppearInListType' },
            privacy: { type: 'en', subTypeConstructor: KalturaPrivacyType, subType: 'KalturaPrivacyType' },
            inheritanceType: { type: 'en', subTypeConstructor: KalturaInheritanceType, subType: 'KalturaInheritanceType' },
            userJoinPolicy: { type: 'en', readOnly: true, subTypeConstructor: KalturaUserJoinPolicyType, subType: 'KalturaUserJoinPolicyType' },
            defaultPermissionLevel: { type: 'en', subTypeConstructor: KalturaCategoryUserPermissionLevel, subType: 'KalturaCategoryUserPermissionLevel' },
            owner: { type: 's' },
            directEntriesCount: { type: 'n', readOnly: true },
            referenceId: { type: 's' },
            contributionPolicy: { type: 'en', subTypeConstructor: KalturaContributionPolicyType, subType: 'KalturaContributionPolicyType' },
            membersCount: { type: 'n', readOnly: true },
            pendingMembersCount: { type: 'n', readOnly: true },
            privacyContext: { type: 's' },
            privacyContexts: { type: 's', readOnly: true },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaCategoryStatus, subType: 'KalturaCategoryStatus' },
            inheritedParentId: { type: 'n', readOnly: true },
            partnerSortValue: { type: 'n' },
            partnerData: { type: 's' },
            defaultOrderBy: { type: 'es', subTypeConstructor: KalturaCategoryOrderBy, subType: 'KalturaCategoryOrderBy' },
            directSubCategoriesCount: { type: 'n', readOnly: true },
            moderation: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            pendingEntriesCount: { type: 'n', readOnly: true },
            isAggregationCategory: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            aggregationCategories: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCategory'] = KalturaCategory;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaCategoryEntryStatus = {
    active: 2,
    deleted: 3,
    pending: 1,
    rejected: 4,
};
KalturaCategoryEntryStatus[KalturaCategoryEntryStatus.active] = 'active';
KalturaCategoryEntryStatus[KalturaCategoryEntryStatus.deleted] = 'deleted';
KalturaCategoryEntryStatus[KalturaCategoryEntryStatus.pending] = 'pending';
KalturaCategoryEntryStatus[KalturaCategoryEntryStatus.rejected] = 'rejected';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCategoryEntry extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCategoryEntry' },
            categoryId: { type: 'n' },
            entryId: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            categoryFullIds: { type: 's', readOnly: true },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaCategoryEntryStatus, subType: 'KalturaCategoryEntryStatus' },
            creatorUserId: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaCategoryEntry'] = KalturaCategoryEntry;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaCategoryUserStatus = {
    active: 1,
    deleted: 4,
    notActive: 3,
    pending: 2,
};
KalturaCategoryUserStatus[KalturaCategoryUserStatus.active] = 'active';
KalturaCategoryUserStatus[KalturaCategoryUserStatus.deleted] = 'deleted';
KalturaCategoryUserStatus[KalturaCategoryUserStatus.notActive] = 'notActive';
KalturaCategoryUserStatus[KalturaCategoryUserStatus.pending] = 'pending';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaUpdateMethodType = {
    automatic: 1,
    manual: 0,
};
KalturaUpdateMethodType[KalturaUpdateMethodType.automatic] = 'automatic';
KalturaUpdateMethodType[KalturaUpdateMethodType.manual] = 'manual';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCategoryUser extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCategoryUser' },
            categoryId: { type: 'n' },
            userId: { type: 's' },
            partnerId: { type: 'n', readOnly: true },
            permissionLevel: { type: 'en', subTypeConstructor: KalturaCategoryUserPermissionLevel, subType: 'KalturaCategoryUserPermissionLevel' },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaCategoryUserStatus, subType: 'KalturaCategoryUserStatus' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            updateMethod: { type: 'en', subTypeConstructor: KalturaUpdateMethodType, subType: 'KalturaUpdateMethodType' },
            categoryFullIds: { type: 's', readOnly: true },
            permissionNames: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCategoryUser'] = KalturaCategoryUser;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaClientNotification extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaClientNotification' },
            url: { type: 's' },
            data: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaClientNotification'] = KalturaClientNotification;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaClipDescription extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaClipDescription' },
            sourceEntryId: { type: 's' },
            startTime: { type: 'n' },
            duration: { type: 'n' },
            offsetInDestination: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaClipDescription'] = KalturaClipDescription;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaContext extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaContext' }
        });
        return result;
    }
}
typesMappingStorage['KalturaContext'] = KalturaContext;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaContextDataResult extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.messages === 'undefined')
            this.messages = [];
        if (typeof this.actions === 'undefined')
            this.actions = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaContextDataResult' },
            messages: { type: 'a', subTypeConstructor: KalturaString, subType: 'KalturaString' },
            actions: { type: 'a', subTypeConstructor: KalturaRuleAction, subType: 'KalturaRuleAction' }
        });
        return result;
    }
}
typesMappingStorage['KalturaContextDataResult'] = KalturaContextDataResult;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaControlPanelCommandType = {
    kill: 4,
};
KalturaControlPanelCommandType[KalturaControlPanelCommandType.kill] = 'kill';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaControlPanelCommandTargetType = {
    batch: 5,
    dataCenter: 1,
    job: 4,
    jobType: 3,
    scheduler: 2,
};
KalturaControlPanelCommandTargetType[KalturaControlPanelCommandTargetType.batch] = 'batch';
KalturaControlPanelCommandTargetType[KalturaControlPanelCommandTargetType.dataCenter] = 'dataCenter';
KalturaControlPanelCommandTargetType[KalturaControlPanelCommandTargetType.job] = 'job';
KalturaControlPanelCommandTargetType[KalturaControlPanelCommandTargetType.jobType] = 'jobType';
KalturaControlPanelCommandTargetType[KalturaControlPanelCommandTargetType.scheduler] = 'scheduler';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaControlPanelCommandStatus = {
    done: 3,
    failed: 4,
    handled: 2,
    pending: 1,
};
KalturaControlPanelCommandStatus[KalturaControlPanelCommandStatus.done] = 'done';
KalturaControlPanelCommandStatus[KalturaControlPanelCommandStatus.failed] = 'failed';
KalturaControlPanelCommandStatus[KalturaControlPanelCommandStatus.handled] = 'handled';
KalturaControlPanelCommandStatus[KalturaControlPanelCommandStatus.pending] = 'pending';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaControlPanelCommand extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaControlPanelCommand' },
            id: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            createdBy: { type: 's' },
            updatedAt: { type: 'd', readOnly: true },
            updatedBy: { type: 's' },
            createdById: { type: 'n' },
            schedulerId: { type: 'n' },
            workerId: { type: 'n' },
            workerConfiguredId: { type: 'n' },
            workerName: { type: 'n' },
            batchIndex: { type: 'n' },
            type: { type: 'en', subTypeConstructor: KalturaControlPanelCommandType, subType: 'KalturaControlPanelCommandType' },
            targetType: { type: 'en', subTypeConstructor: KalturaControlPanelCommandTargetType, subType: 'KalturaControlPanelCommandTargetType' },
            status: { type: 'en', subTypeConstructor: KalturaControlPanelCommandStatus, subType: 'KalturaControlPanelCommandStatus' },
            cause: { type: 's' },
            description: { type: 's' },
            errorDescription: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaControlPanelCommand'] = KalturaControlPanelCommand;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConversionAttribute extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConversionAttribute' },
            flavorParamsId: { type: 'n' },
            name: { type: 's' },
            value: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConversionAttribute'] = KalturaConversionAttribute;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCropDimensions extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCropDimensions' },
            left: { type: 'n' },
            top: { type: 'n' },
            width: { type: 'n' },
            height: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCropDimensions'] = KalturaCropDimensions;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPluginReplacementOptionsItem extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPluginReplacementOptionsItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPluginReplacementOptionsItem'] = KalturaPluginReplacementOptionsItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryReplacementOptions extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.pluginOptionItems === 'undefined')
            this.pluginOptionItems = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryReplacementOptions' },
            keepManualThumbnails: { type: 'n' },
            pluginOptionItems: { type: 'a', subTypeConstructor: KalturaPluginReplacementOptionsItem, subType: 'KalturaPluginReplacementOptionsItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryReplacementOptions'] = KalturaEntryReplacementOptions;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaConversionProfileStatus = {
    deleted: '3',
    disabled: '1',
    enabled: '2',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaConversionProfileType = {
    liveStream: '2',
    media: '1',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConversionProfile extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConversionProfile' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            status: { type: 'es', subTypeConstructor: KalturaConversionProfileStatus, subType: 'KalturaConversionProfileStatus' },
            type: { type: 'es', subTypeConstructor: KalturaConversionProfileType, subType: 'KalturaConversionProfileType' },
            name: { type: 's' },
            systemName: { type: 's' },
            tags: { type: 's' },
            description: { type: 's' },
            defaultEntryId: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            flavorParamsIds: { type: 's' },
            isDefault: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            isPartnerDefault: { type: 'b', readOnly: true },
            cropDimensions: { type: 'o', subTypeConstructor: KalturaCropDimensions, subType: 'KalturaCropDimensions' },
            clipStart: { type: 'n' },
            clipDuration: { type: 'n' },
            xslTransformation: { type: 's' },
            storageProfileId: { type: 'n' },
            mediaParserType: { type: 'es', subTypeConstructor: KalturaMediaParserType, subType: 'KalturaMediaParserType' },
            calculateComplexity: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            collectionTags: { type: 's' },
            conditionalProfiles: { type: 's' },
            detectGOP: { type: 'n' },
            mediaInfoXslTransformation: { type: 's' },
            defaultReplacementOptions: { type: 'o', subTypeConstructor: KalturaEntryReplacementOptions, subType: 'KalturaEntryReplacementOptions' },
            defaultAudioLang: { type: 'es', subTypeConstructor: KalturaLanguage, subType: 'KalturaLanguage' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConversionProfile'] = KalturaConversionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaFlavorReadyBehaviorType = {
    inheritFlavorParams: 0,
    noImpact: 0,
    optional: 2,
    required: 1,
};
KalturaFlavorReadyBehaviorType[KalturaFlavorReadyBehaviorType.inheritFlavorParams] = 'inheritFlavorParams';
KalturaFlavorReadyBehaviorType[KalturaFlavorReadyBehaviorType.noImpact] = 'noImpact';
KalturaFlavorReadyBehaviorType[KalturaFlavorReadyBehaviorType.optional] = 'optional';
KalturaFlavorReadyBehaviorType[KalturaFlavorReadyBehaviorType.required] = 'required';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaAssetParamsOrigin = {
    convert: 0,
    convertWhenMissing: 2,
    ingest: 1,
};
KalturaAssetParamsOrigin[KalturaAssetParamsOrigin.convert] = 'convert';
KalturaAssetParamsOrigin[KalturaAssetParamsOrigin.convertWhenMissing] = 'convertWhenMissing';
KalturaAssetParamsOrigin[KalturaAssetParamsOrigin.ingest] = 'ingest';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaAssetParamsDeletePolicy = {
    delete: 1,
    keep: 0,
};
KalturaAssetParamsDeletePolicy[KalturaAssetParamsDeletePolicy.delete] = 'delete';
KalturaAssetParamsDeletePolicy[KalturaAssetParamsDeletePolicy.keep] = 'keep';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConversionProfileAssetParams extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConversionProfileAssetParams' },
            conversionProfileId: { type: 'n', readOnly: true },
            assetParamsId: { type: 'n', readOnly: true },
            readyBehavior: { type: 'en', subTypeConstructor: KalturaFlavorReadyBehaviorType, subType: 'KalturaFlavorReadyBehaviorType' },
            origin: { type: 'en', subTypeConstructor: KalturaAssetParamsOrigin, subType: 'KalturaAssetParamsOrigin' },
            systemName: { type: 's' },
            forceNoneComplied: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            deletePolicy: { type: 'en', subTypeConstructor: KalturaAssetParamsDeletePolicy, subType: 'KalturaAssetParamsDeletePolicy' },
            isEncrypted: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            contentAwareness: { type: 'n' },
            chunkedEncodeMode: { type: 'n' },
            twoPass: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            tags: { type: 's' },
            overloadParams: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConversionProfileAssetParams'] = KalturaConversionProfileAssetParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConvertCollectionFlavorData extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConvertCollectionFlavorData' },
            flavorAssetId: { type: 's' },
            flavorParamsOutputId: { type: 'n' },
            readyBehavior: { type: 'n' },
            videoBitrate: { type: 'n' },
            audioBitrate: { type: 'n' },
            destFileSyncLocalPath: { type: 's' },
            destFileSyncRemoteUrl: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConvertCollectionFlavorData'] = KalturaConvertCollectionFlavorData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCoordinate extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCoordinate' },
            latitude: { type: 'n' },
            longitude: { type: 'n' },
            name: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCoordinate'] = KalturaCoordinate;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCsvAdditionalFieldInfo extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCsvAdditionalFieldInfo' },
            fieldName: { type: 's' },
            xpath: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCsvAdditionalFieldInfo'] = KalturaCsvAdditionalFieldInfo;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDailymotionDistributionCaptionAction = {
    deleteAction: 3,
    submitAction: 2,
    updateAction: 1,
};
KalturaDailymotionDistributionCaptionAction[KalturaDailymotionDistributionCaptionAction.deleteAction] = 'deleteAction';
KalturaDailymotionDistributionCaptionAction[KalturaDailymotionDistributionCaptionAction.submitAction] = 'submitAction';
KalturaDailymotionDistributionCaptionAction[KalturaDailymotionDistributionCaptionAction.updateAction] = 'updateAction';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDailymotionDistributionCaptionFormat = {
    srt: 1,
    stl: 2,
    tt: 3,
};
KalturaDailymotionDistributionCaptionFormat[KalturaDailymotionDistributionCaptionFormat.srt] = 'srt';
KalturaDailymotionDistributionCaptionFormat[KalturaDailymotionDistributionCaptionFormat.stl] = 'stl';
KalturaDailymotionDistributionCaptionFormat[KalturaDailymotionDistributionCaptionFormat.tt] = 'tt';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDailymotionDistributionCaptionInfo extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDailymotionDistributionCaptionInfo' },
            language: { type: 's' },
            filePath: { type: 's' },
            remoteId: { type: 's' },
            action: { type: 'en', subTypeConstructor: KalturaDailymotionDistributionCaptionAction, subType: 'KalturaDailymotionDistributionCaptionAction' },
            version: { type: 's' },
            assetId: { type: 's' },
            format: { type: 'en', subTypeConstructor: KalturaDailymotionDistributionCaptionFormat, subType: 'KalturaDailymotionDistributionCaptionFormat' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDailymotionDistributionCaptionInfo'] = KalturaDailymotionDistributionCaptionInfo;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDataEntry extends KalturaBaseEntry {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDataEntry' },
            dataContent: { type: 's' },
            retrieveDataContentByGet: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDataEntry'] = KalturaDataEntry;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlRecognizer extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlRecognizer' },
            hosts: { type: 's' },
            uriPrefix: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlRecognizer'] = KalturaUrlRecognizer;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlTokenizer extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlTokenizer' },
            window: { type: 'n' },
            key: { type: 's' },
            limitIpAddress: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlTokenizer'] = KalturaUrlTokenizer;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSearchItem extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSearchItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSearchItem'] = KalturaSearchItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFilter extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFilter' },
            orderBy: { type: 's' },
            advancedSearch: { type: 'o', subTypeConstructor: KalturaSearchItem, subType: 'KalturaSearchItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFilter'] = KalturaFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRelatedFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRelatedFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaRelatedFilter'] = KalturaRelatedFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAssetBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAssetBaseFilter' },
            idEqual: { type: 's' },
            idIn: { type: 's' },
            entryIdEqual: { type: 's' },
            entryIdIn: { type: 's' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            sizeGreaterThanOrEqual: { type: 'n' },
            sizeLessThanOrEqual: { type: 'n' },
            tagsLike: { type: 's' },
            tagsMultiLikeOr: { type: 's' },
            tagsMultiLikeAnd: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            deletedAtGreaterThanOrEqual: { type: 'd' },
            deletedAtLessThanOrEqual: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAssetBaseFilter'] = KalturaAssetBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAssetFilter extends KalturaAssetBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAssetFilter' },
            typeIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAssetFilter'] = KalturaAssetFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDeliveryProfileType = {
    akamaiHd: '12',
    akamaiHds: '13',
    akamaiHlsDirect: '10',
    akamaiHlsManifest: '11',
    akamaiHttp: '14',
    akamaiRtmp: '15',
    akamaiRtsp: '16',
    akamaiSs: '17',
    appleHttp: '1',
    edgeCastHttp: 'edgeCast.EDGE_CAST_HTTP',
    edgeCastRtmp: 'edgeCast.EDGE_CAST_RTMP',
    genericHds: '23',
    genericHdsManifest: '26',
    genericHls: '21',
    genericHlsManifest: '25',
    genericHttp: '24',
    genericRtmp: '28',
    genericSs: '27',
    hds: '3',
    http: '4',
    kontikiHttp: 'kontiki.KONTIKI_HTTP',
    level3Hls: '31',
    level3Http: '34',
    level3Rtmp: '35',
    limelightHttp: '44',
    limelightRtmp: '45',
    liveAkamaiHds: '1013',
    liveDash: '1003',
    liveHds: '1002',
    liveHls: '1001',
    liveHlsToMulticast: '1006',
    livePackagerDash: '1009',
    livePackagerHds: '1008',
    livePackagerHls: '1007',
    livePackagerMss: '1010',
    liveRtmp: '1005',
    localPathAppleHttp: '51',
    localPathHds: '53',
    localPathHttp: '54',
    localPathRtmp: '55',
    rtmp: '5',
    rtsp: '6',
    silverLight: '7',
    velocixHds: 'velocix.VELOCIX_HDS',
    velocixHls: 'velocix.VELOCIX_HLS',
    vodPackagerDash: '68',
    vodPackagerHds: '63',
    vodPackagerHls: '61',
    vodPackagerHlsManifest: '69',
    vodPackagerMss: '67',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPlaybackProtocol = {
    akamaiHd: 'hdnetwork',
    akamaiHds: 'hdnetworkmanifest',
    appleHttp: 'applehttp',
    appleHttpToMc: 'applehttp_to_mc',
    auto: 'auto',
    hds: 'hds',
    hls: 'hls',
    http: 'http',
    mpegDash: 'mpegdash',
    multicastSl: 'multicast_silverlight',
    rtmp: 'rtmp',
    rtsp: 'rtsp',
    silverLight: 'sl',
    url: 'url',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDeliveryStatus = {
    active: 0,
    deleted: 1,
    stagingIn: 2,
    stagingOut: 3,
};
KalturaDeliveryStatus[KalturaDeliveryStatus.active] = 'active';
KalturaDeliveryStatus[KalturaDeliveryStatus.deleted] = 'deleted';
KalturaDeliveryStatus[KalturaDeliveryStatus.stagingIn] = 'stagingIn';
KalturaDeliveryStatus[KalturaDeliveryStatus.stagingOut] = 'stagingOut';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfile extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfile' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            name: { type: 's' },
            type: { type: 'es', subTypeConstructor: KalturaDeliveryProfileType, subType: 'KalturaDeliveryProfileType' },
            systemName: { type: 's' },
            description: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            streamerType: { type: 'es', subTypeConstructor: KalturaPlaybackProtocol, subType: 'KalturaPlaybackProtocol' },
            url: { type: 's' },
            hostName: { type: 's', readOnly: true },
            status: { type: 'en', subTypeConstructor: KalturaDeliveryStatus, subType: 'KalturaDeliveryStatus' },
            recognizer: { type: 'o', subTypeConstructor: KalturaUrlRecognizer, subType: 'KalturaUrlRecognizer' },
            tokenizer: { type: 'o', subTypeConstructor: KalturaUrlTokenizer, subType: 'KalturaUrlTokenizer' },
            isDefault: { type: 'en', readOnly: true, subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            parentId: { type: 'n', readOnly: true },
            mediaProtocols: { type: 's' },
            priority: { type: 'n' },
            extraParams: { type: 's' },
            supplementaryAssetsFilter: { type: 'o', subTypeConstructor: KalturaAssetFilter, subType: 'KalturaAssetFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfile'] = KalturaDeliveryProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFileSyncDescriptor extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFileSyncDescriptor' },
            fileSyncLocalPath: { type: 's' },
            fileEncryptionKey: { type: 's' },
            fileSyncRemoteUrl: { type: 's' },
            fileSyncObjectSubType: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFileSyncDescriptor'] = KalturaFileSyncDescriptor;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDestFileSyncDescriptor extends KalturaFileSyncDescriptor {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDestFileSyncDescriptor' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDestFileSyncDescriptor'] = KalturaDestFileSyncDescriptor;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPager extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPager' },
            pageSize: { type: 'n' },
            pageIndex: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPager'] = KalturaPager;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFilterPager extends KalturaPager {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFilterPager' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFilterPager'] = KalturaFilterPager;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaResponseProfileMapping extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaResponseProfileMapping' },
            parentProperty: { type: 's' },
            filterProperty: { type: 's' },
            allowNull: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaResponseProfileMapping'] = KalturaResponseProfileMapping;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaResponseProfileType = {
    excludeFields: 2,
    includeFields: 1,
};
KalturaResponseProfileType[KalturaResponseProfileType.excludeFields] = 'excludeFields';
KalturaResponseProfileType[KalturaResponseProfileType.includeFields] = 'includeFields';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDetachedResponseProfile extends KalturaBaseResponseProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.relatedProfiles === 'undefined')
            this.relatedProfiles = [];
        if (typeof this.mappings === 'undefined')
            this.mappings = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDetachedResponseProfile' },
            name: { type: 's' },
            type: { type: 'en', subTypeConstructor: KalturaResponseProfileType, subType: 'KalturaResponseProfileType' },
            fields: { type: 's' },
            filter: { type: 'o', subTypeConstructor: KalturaRelatedFilter, subType: 'KalturaRelatedFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' },
            relatedProfiles: { type: 'a', subTypeConstructor: KalturaDetachedResponseProfile, subType: 'KalturaDetachedResponseProfile' },
            mappings: { type: 'a', subTypeConstructor: KalturaResponseProfileMapping, subType: 'KalturaResponseProfileMapping' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDetachedResponseProfile'] = KalturaDetachedResponseProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDistributionFieldRequiredStatus = {
    notRequired: 0,
    requiredByPartner: 2,
    requiredByProvider: 1,
    requiredForAutomaticDistribution: 3,
};
KalturaDistributionFieldRequiredStatus[KalturaDistributionFieldRequiredStatus.notRequired] = 'notRequired';
KalturaDistributionFieldRequiredStatus[KalturaDistributionFieldRequiredStatus.requiredByPartner] = 'requiredByPartner';
KalturaDistributionFieldRequiredStatus[KalturaDistributionFieldRequiredStatus.requiredByProvider] = 'requiredByProvider';
KalturaDistributionFieldRequiredStatus[KalturaDistributionFieldRequiredStatus.requiredForAutomaticDistribution] = 'requiredForAutomaticDistribution';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionFieldConfig extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.updateParams === 'undefined')
            this.updateParams = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionFieldConfig' },
            fieldName: { type: 's' },
            userFriendlyFieldName: { type: 's' },
            entryMrssXslt: { type: 's' },
            isRequired: { type: 'en', subTypeConstructor: KalturaDistributionFieldRequiredStatus, subType: 'KalturaDistributionFieldRequiredStatus' },
            type: { type: 's' },
            updateOnChange: { type: 'b' },
            updateParams: { type: 'a', subTypeConstructor: KalturaString, subType: 'KalturaString' },
            isDefault: { type: 'b', readOnly: true },
            triggerDeleteOnError: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionFieldConfig'] = KalturaDistributionFieldConfig;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionJobProviderData extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionJobProviderData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionJobProviderData'] = KalturaDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionThumbDimensions extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionThumbDimensions' },
            width: { type: 'n' },
            height: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionThumbDimensions'] = KalturaDistributionThumbDimensions;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDistributionProviderType = {
    avn: 'avnDistribution.AVN',
    comcastMrss: 'comcastMrssDistribution.COMCAST_MRSS',
    crossKaltura: 'crossKalturaDistribution.CROSS_KALTURA',
    dailymotion: 'dailymotionDistribution.DAILYMOTION',
    doubleclick: 'doubleClickDistribution.DOUBLECLICK',
    facebook: 'facebookDistribution.FACEBOOK',
    freewheel: 'freewheelDistribution.FREEWHEEL',
    freewheelGeneric: 'freewheelGenericDistribution.FREEWHEEL_GENERIC',
    ftp: 'ftpDistribution.FTP',
    ftpScheduled: 'ftpDistribution.FTP_SCHEDULED',
    generic: '1',
    hulu: 'huluDistribution.HULU',
    idetic: 'ideticDistribution.IDETIC',
    metroPcs: 'metroPcsDistribution.METRO_PCS',
    msn: 'msnDistribution.MSN',
    quickplay: 'quickPlayDistribution.QUICKPLAY',
    syndication: '2',
    unicorn: 'unicornDistribution.UNICORN',
    yahoo: 'yahooDistribution.YAHOO',
    youtube: 'youTubeDistribution.YOUTUBE',
    youtubeApi: 'youtubeApiDistribution.YOUTUBE_API',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDistributionProfileStatus = {
    deleted: 3,
    disabled: 1,
    enabled: 2,
};
KalturaDistributionProfileStatus[KalturaDistributionProfileStatus.deleted] = 'deleted';
KalturaDistributionProfileStatus[KalturaDistributionProfileStatus.disabled] = 'disabled';
KalturaDistributionProfileStatus[KalturaDistributionProfileStatus.enabled] = 'enabled';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDistributionProfileActionStatus = {
    automatic: 2,
    disabled: 1,
    manual: 3,
};
KalturaDistributionProfileActionStatus[KalturaDistributionProfileActionStatus.automatic] = 'automatic';
KalturaDistributionProfileActionStatus[KalturaDistributionProfileActionStatus.disabled] = 'disabled';
KalturaDistributionProfileActionStatus[KalturaDistributionProfileActionStatus.manual] = 'manual';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionProfile extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.optionalThumbDimensions === 'undefined')
            this.optionalThumbDimensions = [];
        if (typeof this.requiredThumbDimensions === 'undefined')
            this.requiredThumbDimensions = [];
        if (typeof this.optionalAssetDistributionRules === 'undefined')
            this.optionalAssetDistributionRules = [];
        if (typeof this.requiredAssetDistributionRules === 'undefined')
            this.requiredAssetDistributionRules = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionProfile' },
            id: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            providerType: { type: 'es', subTypeConstructor: KalturaDistributionProviderType, subType: 'KalturaDistributionProviderType' },
            name: { type: 's' },
            status: { type: 'en', subTypeConstructor: KalturaDistributionProfileStatus, subType: 'KalturaDistributionProfileStatus' },
            submitEnabled: { type: 'en', subTypeConstructor: KalturaDistributionProfileActionStatus, subType: 'KalturaDistributionProfileActionStatus' },
            updateEnabled: { type: 'en', subTypeConstructor: KalturaDistributionProfileActionStatus, subType: 'KalturaDistributionProfileActionStatus' },
            deleteEnabled: { type: 'en', subTypeConstructor: KalturaDistributionProfileActionStatus, subType: 'KalturaDistributionProfileActionStatus' },
            reportEnabled: { type: 'en', subTypeConstructor: KalturaDistributionProfileActionStatus, subType: 'KalturaDistributionProfileActionStatus' },
            autoCreateFlavors: { type: 's' },
            autoCreateThumb: { type: 's' },
            optionalFlavorParamsIds: { type: 's' },
            requiredFlavorParamsIds: { type: 's' },
            optionalThumbDimensions: { type: 'a', subTypeConstructor: KalturaDistributionThumbDimensions, subType: 'KalturaDistributionThumbDimensions' },
            requiredThumbDimensions: { type: 'a', subTypeConstructor: KalturaDistributionThumbDimensions, subType: 'KalturaDistributionThumbDimensions' },
            optionalAssetDistributionRules: { type: 'a', subTypeConstructor: KalturaAssetDistributionRule, subType: 'KalturaAssetDistributionRule' },
            requiredAssetDistributionRules: { type: 'a', subTypeConstructor: KalturaAssetDistributionRule, subType: 'KalturaAssetDistributionRule' },
            sunriseDefaultOffset: { type: 'n' },
            sunsetDefaultOffset: { type: 'n' },
            recommendedStorageProfileForDownload: { type: 'n' },
            recommendedDcForDownload: { type: 'n' },
            recommendedDcForExecute: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionProfile'] = KalturaDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionProvider extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionProvider' },
            type: { type: 'es', readOnly: true, subTypeConstructor: KalturaDistributionProviderType, subType: 'KalturaDistributionProviderType' },
            name: { type: 's' },
            scheduleUpdateEnabled: { type: 'b' },
            availabilityUpdateEnabled: { type: 'b' },
            deleteInsteadUpdate: { type: 'b' },
            intervalBeforeSunrise: { type: 'n' },
            intervalBeforeSunset: { type: 'n' },
            updateRequiredEntryFields: { type: 's' },
            updateRequiredMetadataXPaths: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionProvider'] = KalturaDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionRemoteMediaFile extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionRemoteMediaFile' },
            version: { type: 's' },
            assetId: { type: 's' },
            remoteId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionRemoteMediaFile'] = KalturaDistributionRemoteMediaFile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDistributionAction = {
    delete: 3,
    fetchReport: 4,
    submit: 1,
    update: 2,
};
KalturaDistributionAction[KalturaDistributionAction.delete] = 'delete';
KalturaDistributionAction[KalturaDistributionAction.fetchReport] = 'fetchReport';
KalturaDistributionAction[KalturaDistributionAction.submit] = 'submit';
KalturaDistributionAction[KalturaDistributionAction.update] = 'update';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDistributionErrorType = {
    conditionNotMet: 6,
    invalidData: 4,
    missingAsset: 5,
    missingFlavor: 1,
    missingMetadata: 3,
    missingThumbnail: 2,
};
KalturaDistributionErrorType[KalturaDistributionErrorType.conditionNotMet] = 'conditionNotMet';
KalturaDistributionErrorType[KalturaDistributionErrorType.invalidData] = 'invalidData';
KalturaDistributionErrorType[KalturaDistributionErrorType.missingAsset] = 'missingAsset';
KalturaDistributionErrorType[KalturaDistributionErrorType.missingFlavor] = 'missingFlavor';
KalturaDistributionErrorType[KalturaDistributionErrorType.missingMetadata] = 'missingMetadata';
KalturaDistributionErrorType[KalturaDistributionErrorType.missingThumbnail] = 'missingThumbnail';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionValidationError extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionValidationError' },
            action: { type: 'en', subTypeConstructor: KalturaDistributionAction, subType: 'KalturaDistributionAction' },
            errorType: { type: 'en', subTypeConstructor: KalturaDistributionErrorType, subType: 'KalturaDistributionErrorType' },
            description: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionValidationError'] = KalturaDistributionValidationError;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDocumentType = {
    document: 11,
    pdf: 13,
    swf: 12,
};
KalturaDocumentType[KalturaDocumentType.document] = 'document';
KalturaDocumentType[KalturaDocumentType.pdf] = 'pdf';
KalturaDocumentType[KalturaDocumentType.swf] = 'swf';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDocumentEntry extends KalturaBaseEntry {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDocumentEntry' },
            documentType: { type: 'en', subTypeConstructor: KalturaDocumentType, subType: 'KalturaDocumentType' },
            assetParamsIds: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaDocumentEntry'] = KalturaDocumentEntry;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDrmLicenseAccessDetails extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.licenseParams === 'undefined')
            this.licenseParams = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDrmLicenseAccessDetails' },
            policy: { type: 's' },
            duration: { type: 'n' },
            absolute_duration: { type: 'n' },
            licenseParams: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDrmLicenseAccessDetails'] = KalturaDrmLicenseAccessDetails;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPluginData extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPluginData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPluginData'] = KalturaPluginData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDrmSchemeName = {
    fairplay: 'fairplay.FAIRPLAY',
    playready: 'playReady.PLAYREADY',
    playreadyCenc: 'drm.PLAYREADY_CENC',
    widevine: 'widevine.WIDEVINE',
    widevineCenc: 'drm.WIDEVINE_CENC',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDrmPlaybackPluginData extends KalturaPluginData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDrmPlaybackPluginData' },
            scheme: { type: 'es', subTypeConstructor: KalturaDrmSchemeName, subType: 'KalturaDrmSchemeName' },
            licenseURL: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDrmPlaybackPluginData'] = KalturaDrmPlaybackPluginData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDrmProviderType = {
    cenc: '1',
    fairplay: 'fairplay.FAIRPLAY',
    playReady: 'playReady.PLAY_READY',
    widevine: 'widevine.WIDEVINE',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDrmPolicyStatus = {
    active: 1,
    deleted: 2,
};
KalturaDrmPolicyStatus[KalturaDrmPolicyStatus.active] = 'active';
KalturaDrmPolicyStatus[KalturaDrmPolicyStatus.deleted] = 'deleted';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDrmLicenseScenario = {
    protection: 'playReady.PROTECTION',
    purchase: 'playReady.PURCHASE',
    rental: 'playReady.RENTAL',
    subscription: 'playReady.SUBSCRIPTION',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDrmLicenseType = {
    nonPersistent: 'playReady.NON_PERSISTENT',
    persistent: 'playReady.PERSISTENT',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDrmLicenseExpirationPolicy = {
    entrySchedulingEnd: 2,
    fixedDuration: 1,
    unlimited: 3,
};
KalturaDrmLicenseExpirationPolicy[KalturaDrmLicenseExpirationPolicy.entrySchedulingEnd] = 'entrySchedulingEnd';
KalturaDrmLicenseExpirationPolicy[KalturaDrmLicenseExpirationPolicy.fixedDuration] = 'fixedDuration';
KalturaDrmLicenseExpirationPolicy[KalturaDrmLicenseExpirationPolicy.unlimited] = 'unlimited';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDrmPolicy extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.licenseParams === 'undefined')
            this.licenseParams = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDrmPolicy' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n' },
            name: { type: 's' },
            systemName: { type: 's' },
            description: { type: 's' },
            provider: { type: 'es', subTypeConstructor: KalturaDrmProviderType, subType: 'KalturaDrmProviderType' },
            status: { type: 'en', subTypeConstructor: KalturaDrmPolicyStatus, subType: 'KalturaDrmPolicyStatus' },
            scenario: { type: 'es', subTypeConstructor: KalturaDrmLicenseScenario, subType: 'KalturaDrmLicenseScenario' },
            licenseType: { type: 'es', subTypeConstructor: KalturaDrmLicenseType, subType: 'KalturaDrmLicenseType' },
            licenseExpirationPolicy: { type: 'en', subTypeConstructor: KalturaDrmLicenseExpirationPolicy, subType: 'KalturaDrmLicenseExpirationPolicy' },
            duration: { type: 'n' },
            createdAt: { type: 'n', readOnly: true },
            updatedAt: { type: 'n', readOnly: true },
            licenseParams: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDrmPolicy'] = KalturaDrmPolicy;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDrmProfileStatus = {
    active: 1,
    deleted: 2,
};
KalturaDrmProfileStatus[KalturaDrmProfileStatus.active] = 'active';
KalturaDrmProfileStatus[KalturaDrmProfileStatus.deleted] = 'deleted';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDrmProfile extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDrmProfile' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n' },
            name: { type: 's' },
            description: { type: 's' },
            provider: { type: 'es', subTypeConstructor: KalturaDrmProviderType, subType: 'KalturaDrmProviderType' },
            status: { type: 'en', subTypeConstructor: KalturaDrmProfileStatus, subType: 'KalturaDrmProfileStatus' },
            licenseServerUrl: { type: 's' },
            defaultPolicy: { type: 's' },
            createdAt: { type: 'n', readOnly: true },
            updatedAt: { type: 'n', readOnly: true },
            signingKey: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDrmProfile'] = KalturaDrmProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDropFolderFileHandlerType = {
    content: '1',
    ical: 'scheduleDropFolder.ICAL',
    xml: 'dropFolderXmlBulkUpload.XML',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDropFolderFileHandlerConfig extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDropFolderFileHandlerConfig' },
            handlerType: { type: 'es', readOnly: true, subTypeConstructor: KalturaDropFolderFileHandlerType, subType: 'KalturaDropFolderFileHandlerType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDropFolderFileHandlerConfig'] = KalturaDropFolderFileHandlerConfig;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDropFolderType = {
    feed: 'FeedDropFolder.FEED',
    ftp: '2',
    local: '1',
    s3: '6',
    scp: '3',
    sftp: '4',
    webex: 'WebexDropFolder.WEBEX',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDropFolderStatus = {
    deleted: 2,
    disabled: 0,
    enabled: 1,
    error: 3,
};
KalturaDropFolderStatus[KalturaDropFolderStatus.deleted] = 'deleted';
KalturaDropFolderStatus[KalturaDropFolderStatus.disabled] = 'disabled';
KalturaDropFolderStatus[KalturaDropFolderStatus.enabled] = 'enabled';
KalturaDropFolderStatus[KalturaDropFolderStatus.error] = 'error';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDropFolderFileDeletePolicy = {
    autoDelete: 2,
    autoDeleteWhenEntryIsReady: 3,
    manualDelete: 1,
};
KalturaDropFolderFileDeletePolicy[KalturaDropFolderFileDeletePolicy.autoDelete] = 'autoDelete';
KalturaDropFolderFileDeletePolicy[KalturaDropFolderFileDeletePolicy.autoDeleteWhenEntryIsReady] = 'autoDeleteWhenEntryIsReady';
KalturaDropFolderFileDeletePolicy[KalturaDropFolderFileDeletePolicy.manualDelete] = 'manualDelete';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDropFolderErrorCode = {
    contentMatchPolicyUndefined: '6',
    dropFolderAppError: '5',
    errorAutenticate: '2',
    errorConnect: '1',
    errorGetDbFileList: '4',
    errorGetPhisicalFileList: '3',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDropFolder extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDropFolder' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n' },
            name: { type: 's' },
            description: { type: 's' },
            type: { type: 'es', subTypeConstructor: KalturaDropFolderType, subType: 'KalturaDropFolderType' },
            status: { type: 'en', subTypeConstructor: KalturaDropFolderStatus, subType: 'KalturaDropFolderStatus' },
            conversionProfileId: { type: 'n' },
            dc: { type: 'n' },
            path: { type: 's' },
            fileSizeCheckInterval: { type: 'n' },
            fileDeletePolicy: { type: 'en', subTypeConstructor: KalturaDropFolderFileDeletePolicy, subType: 'KalturaDropFolderFileDeletePolicy' },
            autoFileDeleteDays: { type: 'n' },
            fileHandlerType: { type: 'es', subTypeConstructor: KalturaDropFolderFileHandlerType, subType: 'KalturaDropFolderFileHandlerType' },
            fileNamePatterns: { type: 's' },
            fileHandlerConfig: { type: 'o', subTypeConstructor: KalturaDropFolderFileHandlerConfig, subType: 'KalturaDropFolderFileHandlerConfig' },
            tags: { type: 's' },
            errorCode: { type: 'es', subTypeConstructor: KalturaDropFolderErrorCode, subType: 'KalturaDropFolderErrorCode' },
            errorDescription: { type: 's' },
            ignoreFileNamePatterns: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            lastAccessedAt: { type: 'n' },
            incremental: { type: 'b' },
            lastFileTimestamp: { type: 'n' },
            metadataProfileId: { type: 'n' },
            categoriesMetadataFieldName: { type: 's' },
            enforceEntitlement: { type: 'b' },
            shouldValidateKS: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDropFolder'] = KalturaDropFolder;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDropFolderFileStatus = {
    deleted: 6,
    detected: 15,
    downloading: 11,
    errorDeleting: 10,
    errorDownloading: 12,
    errorHandling: 9,
    handled: 4,
    ignore: 5,
    noMatch: 8,
    parsed: 14,
    pending: 2,
    processing: 13,
    purged: 7,
    uploading: 1,
    waiting: 3,
};
KalturaDropFolderFileStatus[KalturaDropFolderFileStatus.deleted] = 'deleted';
KalturaDropFolderFileStatus[KalturaDropFolderFileStatus.detected] = 'detected';
KalturaDropFolderFileStatus[KalturaDropFolderFileStatus.downloading] = 'downloading';
KalturaDropFolderFileStatus[KalturaDropFolderFileStatus.errorDeleting] = 'errorDeleting';
KalturaDropFolderFileStatus[KalturaDropFolderFileStatus.errorDownloading] = 'errorDownloading';
KalturaDropFolderFileStatus[KalturaDropFolderFileStatus.errorHandling] = 'errorHandling';
KalturaDropFolderFileStatus[KalturaDropFolderFileStatus.handled] = 'handled';
KalturaDropFolderFileStatus[KalturaDropFolderFileStatus.ignore] = 'ignore';
KalturaDropFolderFileStatus[KalturaDropFolderFileStatus.noMatch] = 'noMatch';
KalturaDropFolderFileStatus[KalturaDropFolderFileStatus.parsed] = 'parsed';
KalturaDropFolderFileStatus[KalturaDropFolderFileStatus.pending] = 'pending';
KalturaDropFolderFileStatus[KalturaDropFolderFileStatus.processing] = 'processing';
KalturaDropFolderFileStatus[KalturaDropFolderFileStatus.purged] = 'purged';
KalturaDropFolderFileStatus[KalturaDropFolderFileStatus.uploading] = 'uploading';
KalturaDropFolderFileStatus[KalturaDropFolderFileStatus.waiting] = 'waiting';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDropFolderFileErrorCode = {
    errorAddingBulkUpload: 'dropFolderXmlBulkUpload.ERROR_ADDING_BULK_UPLOAD',
    errorAddingContentProcessor: '10',
    errorAddContentResource: 'dropFolderXmlBulkUpload.ERROR_ADD_CONTENT_RESOURCE',
    errorAddEntry: '2',
    errorDeletingFile: '12',
    errorDownloadingFile: '7',
    errorInBulkUpload: 'dropFolderXmlBulkUpload.ERROR_IN_BULK_UPLOAD',
    errorInContentProcessor: '11',
    errorReadingFile: '6',
    errorUpdateEntry: '1',
    errorUpdateFile: '8',
    errorWritingTempFile: 'dropFolderXmlBulkUpload.ERROR_WRITING_TEMP_FILE',
    fileNoMatch: '13',
    flavorMissingInFileName: '4',
    flavorNotFound: '3',
    localFileWrongChecksum: 'dropFolderXmlBulkUpload.LOCAL_FILE_WRONG_CHECKSUM',
    localFileWrongSize: 'dropFolderXmlBulkUpload.LOCAL_FILE_WRONG_SIZE',
    malformedXmlFile: 'dropFolderXmlBulkUpload.MALFORMED_XML_FILE',
    slugRegexNoMatch: '5',
    xmlFileSizeExceedLimit: 'dropFolderXmlBulkUpload.XML_FILE_SIZE_EXCEED_LIMIT',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDropFolderFile extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDropFolderFile' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            dropFolderId: { type: 'n' },
            fileName: { type: 's' },
            fileSize: { type: 'n' },
            fileSizeLastSetAt: { type: 'd', readOnly: true },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaDropFolderFileStatus, subType: 'KalturaDropFolderFileStatus' },
            type: { type: 'es', readOnly: true, subTypeConstructor: KalturaDropFolderType, subType: 'KalturaDropFolderType' },
            parsedSlug: { type: 's' },
            parsedFlavor: { type: 's' },
            parsedUserId: { type: 's' },
            leadDropFolderFileId: { type: 'n' },
            deletedDropFolderFileId: { type: 'n' },
            entryId: { type: 's' },
            errorCode: { type: 'es', subTypeConstructor: KalturaDropFolderFileErrorCode, subType: 'KalturaDropFolderFileErrorCode' },
            errorDescription: { type: 's' },
            lastModificationTime: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            uploadStartDetectedAt: { type: 'd' },
            uploadEndDetectedAt: { type: 'd' },
            importStartedAt: { type: 'd' },
            importEndedAt: { type: 'd' },
            batchJobId: { type: 'n', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaDropFolderFile'] = KalturaDropFolderFile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchBaseItem extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchBaseItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchBaseItem'] = KalturaESearchBaseItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchCategoryBaseItem extends KalturaESearchBaseItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchCategoryBaseItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchCategoryBaseItem'] = KalturaESearchCategoryBaseItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchHighlight extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.hits === 'undefined')
            this.hits = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchHighlight' },
            fieldName: { type: 's' },
            hits: { type: 'a', subTypeConstructor: KalturaString, subType: 'KalturaString' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchHighlight'] = KalturaESearchHighlight;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchItemData extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.highlight === 'undefined')
            this.highlight = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchItemData' },
            highlight: { type: 'a', subTypeConstructor: KalturaESearchHighlight, subType: 'KalturaESearchHighlight' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchItemData'] = KalturaESearchItemData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchItemDataResult extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.items === 'undefined')
            this.items = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchItemDataResult' },
            totalCount: { type: 'n' },
            items: { type: 'a', subTypeConstructor: KalturaESearchItemData, subType: 'KalturaESearchItemData' },
            itemsType: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchItemDataResult'] = KalturaESearchItemDataResult;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchResult extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.highlight === 'undefined')
            this.highlight = [];
        if (typeof this.itemsData === 'undefined')
            this.itemsData = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchResult' },
            highlight: { type: 'a', subTypeConstructor: KalturaESearchHighlight, subType: 'KalturaESearchHighlight' },
            itemsData: { type: 'a', subTypeConstructor: KalturaESearchItemDataResult, subType: 'KalturaESearchItemDataResult' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchResult'] = KalturaESearchResult;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchCategoryResult extends KalturaESearchResult {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchCategoryResult' },
            object: { type: 'o', subTypeConstructor: KalturaCategory, subType: 'KalturaCategory' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchCategoryResult'] = KalturaESearchCategoryResult;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchEntryBaseItem extends KalturaESearchBaseItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchEntryBaseItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchEntryBaseItem'] = KalturaESearchEntryBaseItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchEntryBaseNestedObject extends KalturaESearchEntryBaseItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchEntryBaseNestedObject' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchEntryBaseNestedObject'] = KalturaESearchEntryBaseNestedObject;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchEntryNestedBaseItem extends KalturaESearchEntryBaseNestedObject {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchEntryNestedBaseItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchEntryNestedBaseItem'] = KalturaESearchEntryNestedBaseItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchEntryResult extends KalturaESearchResult {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchEntryResult' },
            object: { type: 'o', subTypeConstructor: KalturaBaseEntry, subType: 'KalturaBaseEntry' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchEntryResult'] = KalturaESearchEntryResult;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaESearchSortOrder = {
    orderByAsc: 'asc',
    orderByDesc: 'desc',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchOrderByItem extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchOrderByItem' },
            sortOrder: { type: 'es', subTypeConstructor: KalturaESearchSortOrder, subType: 'KalturaESearchSortOrder' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchOrderByItem'] = KalturaESearchOrderByItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchOrderBy extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.orderItems === 'undefined')
            this.orderItems = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchOrderBy' },
            orderItems: { type: 'a', subTypeConstructor: KalturaESearchOrderByItem, subType: 'KalturaESearchOrderByItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchOrderBy'] = KalturaESearchOrderBy;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchParams extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchParams' },
            objectStatuses: { type: 's' },
            objectId: { type: 's' },
            orderBy: { type: 'o', subTypeConstructor: KalturaESearchOrderBy, subType: 'KalturaESearchOrderBy' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchParams'] = KalturaESearchParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchRange extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchRange' },
            greaterThanOrEqual: { type: 'n' },
            lessThanOrEqual: { type: 'n' },
            greaterThan: { type: 'n' },
            lessThan: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchRange'] = KalturaESearchRange;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchResponse extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchResponse' },
            totalCount: { type: 'n', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchResponse'] = KalturaESearchResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchUserBaseItem extends KalturaESearchBaseItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchUserBaseItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchUserBaseItem'] = KalturaESearchUserBaseItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaUserType = {
    group: 1,
    user: 0,
};
KalturaUserType[KalturaUserType.group] = 'group';
KalturaUserType[KalturaUserType.user] = 'user';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaGender = {
    female: 2,
    male: 1,
    unknown: 0,
};
KalturaGender[KalturaGender.female] = 'female';
KalturaGender[KalturaGender.male] = 'male';
KalturaGender[KalturaGender.unknown] = 'unknown';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaUserStatus = {
    active: 1,
    blocked: 0,
    deleted: 2,
};
KalturaUserStatus[KalturaUserStatus.active] = 'active';
KalturaUserStatus[KalturaUserStatus.blocked] = 'blocked';
KalturaUserStatus[KalturaUserStatus.deleted] = 'deleted';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaUserMode = {
    none: 0,
    protectedUser: 1,
};
KalturaUserMode[KalturaUserMode.none] = 'none';
KalturaUserMode[KalturaUserMode.protectedUser] = 'protectedUser';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUser extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUser' },
            id: { type: 's' },
            partnerId: { type: 'n', readOnly: true },
            type: { type: 'en', subTypeConstructor: KalturaUserType, subType: 'KalturaUserType' },
            screenName: { type: 's' },
            fullName: { type: 's' },
            email: { type: 's' },
            dateOfBirth: { type: 'n' },
            country: { type: 's' },
            state: { type: 's' },
            city: { type: 's' },
            zip: { type: 's' },
            thumbnailUrl: { type: 's' },
            description: { type: 's' },
            tags: { type: 's' },
            adminTags: { type: 's' },
            gender: { type: 'en', subTypeConstructor: KalturaGender, subType: 'KalturaGender' },
            status: { type: 'en', subTypeConstructor: KalturaUserStatus, subType: 'KalturaUserStatus' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            partnerData: { type: 's' },
            indexedPartnerDataInt: { type: 'n' },
            indexedPartnerDataString: { type: 's' },
            storageSize: { type: 'n', readOnly: true },
            password: { type: 's' },
            firstName: { type: 's' },
            lastName: { type: 's' },
            isAdmin: { type: 'b' },
            language: { type: 'es', subTypeConstructor: KalturaLanguageCode, subType: 'KalturaLanguageCode' },
            lastLoginTime: { type: 'n', readOnly: true },
            statusUpdatedAt: { type: 'n', readOnly: true },
            deletedAt: { type: 'd', readOnly: true },
            loginEnabled: { type: 'b' },
            roleIds: { type: 's' },
            roleNames: { type: 's', readOnly: true },
            isAccountOwner: { type: 'b' },
            allowedPartnerIds: { type: 's' },
            allowedPartnerPackages: { type: 's' },
            userMode: { type: 'en', subTypeConstructor: KalturaUserMode, subType: 'KalturaUserMode' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUser'] = KalturaUser;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchUserResult extends KalturaESearchResult {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchUserResult' },
            object: { type: 'o', subTypeConstructor: KalturaUser, subType: 'KalturaUser' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchUserResult'] = KalturaESearchUserResult;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaEffectType = {
    videoFadeIn: 1,
    videoFadeOut: 2,
};
KalturaEffectType[KalturaEffectType.videoFadeIn] = 'videoFadeIn';
KalturaEffectType[KalturaEffectType.videoFadeOut] = 'videoFadeOut';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEffect extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEffect' },
            effectType: { type: 'en', subTypeConstructor: KalturaEffectType, subType: 'KalturaEffectType' },
            value: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEffect'] = KalturaEffect;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaEmailIngestionProfileStatus = {
    active: 1,
    inactive: 0,
};
KalturaEmailIngestionProfileStatus[KalturaEmailIngestionProfileStatus.active] = 'active';
KalturaEmailIngestionProfileStatus[KalturaEmailIngestionProfileStatus.inactive] = 'inactive';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEmailIngestionProfile extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEmailIngestionProfile' },
            id: { type: 'n', readOnly: true },
            name: { type: 's' },
            description: { type: 's' },
            emailAddress: { type: 's' },
            mailboxId: { type: 's' },
            partnerId: { type: 'n', readOnly: true },
            conversionProfile2Id: { type: 'n' },
            moderationStatus: { type: 'en', subTypeConstructor: KalturaEntryModerationStatus, subType: 'KalturaEntryModerationStatus' },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaEmailIngestionProfileStatus, subType: 'KalturaEmailIngestionProfileStatus' },
            createdAt: { type: 's', readOnly: true },
            defaultCategory: { type: 's' },
            defaultUserId: { type: 's' },
            defaultTags: { type: 's' },
            defaultAdminTags: { type: 's' },
            maxAttachmentSizeKbytes: { type: 'n' },
            maxAttachmentsPerMail: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEmailIngestionProfile'] = KalturaEmailIngestionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaStringValue extends KalturaValue {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaStringValue' },
            value: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaStringValue'] = KalturaStringValue;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEmailNotificationRecipient extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEmailNotificationRecipient' },
            email: { type: 'o', subTypeConstructor: KalturaStringValue, subType: 'KalturaStringValue' },
            name: { type: 'o', subTypeConstructor: KalturaStringValue, subType: 'KalturaStringValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEmailNotificationRecipient'] = KalturaEmailNotificationRecipient;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEmailNotificationRecipientProviderType = {
    category: '2',
    group: '4',
    staticList: '1',
    user: '3',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEmailNotificationRecipientJobData extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEmailNotificationRecipientJobData' },
            providerType: { type: 'es', readOnly: true, subTypeConstructor: KalturaEmailNotificationRecipientProviderType, subType: 'KalturaEmailNotificationRecipientProviderType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEmailNotificationRecipientJobData'] = KalturaEmailNotificationRecipientJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEmailNotificationRecipientProvider extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEmailNotificationRecipientProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEmailNotificationRecipientProvider'] = KalturaEmailNotificationRecipientProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaEntryDistributionStatus = {
    deleted: 3,
    deleting: 6,
    errorDeleting: 9,
    errorSubmitting: 7,
    errorUpdating: 8,
    importSubmitting: 11,
    importUpdating: 12,
    pending: 0,
    queued: 1,
    ready: 2,
    removed: 10,
    submitting: 4,
    updating: 5,
};
KalturaEntryDistributionStatus[KalturaEntryDistributionStatus.deleted] = 'deleted';
KalturaEntryDistributionStatus[KalturaEntryDistributionStatus.deleting] = 'deleting';
KalturaEntryDistributionStatus[KalturaEntryDistributionStatus.errorDeleting] = 'errorDeleting';
KalturaEntryDistributionStatus[KalturaEntryDistributionStatus.errorSubmitting] = 'errorSubmitting';
KalturaEntryDistributionStatus[KalturaEntryDistributionStatus.errorUpdating] = 'errorUpdating';
KalturaEntryDistributionStatus[KalturaEntryDistributionStatus.importSubmitting] = 'importSubmitting';
KalturaEntryDistributionStatus[KalturaEntryDistributionStatus.importUpdating] = 'importUpdating';
KalturaEntryDistributionStatus[KalturaEntryDistributionStatus.pending] = 'pending';
KalturaEntryDistributionStatus[KalturaEntryDistributionStatus.queued] = 'queued';
KalturaEntryDistributionStatus[KalturaEntryDistributionStatus.ready] = 'ready';
KalturaEntryDistributionStatus[KalturaEntryDistributionStatus.removed] = 'removed';
KalturaEntryDistributionStatus[KalturaEntryDistributionStatus.submitting] = 'submitting';
KalturaEntryDistributionStatus[KalturaEntryDistributionStatus.updating] = 'updating';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaEntryDistributionSunStatus = {
    afterSunrise: 2,
    afterSunset: 3,
    beforeSunrise: 1,
};
KalturaEntryDistributionSunStatus[KalturaEntryDistributionSunStatus.afterSunrise] = 'afterSunrise';
KalturaEntryDistributionSunStatus[KalturaEntryDistributionSunStatus.afterSunset] = 'afterSunset';
KalturaEntryDistributionSunStatus[KalturaEntryDistributionSunStatus.beforeSunrise] = 'beforeSunrise';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaEntryDistributionFlag = {
    deleteRequired: 2,
    disableRequired: 5,
    enableRequired: 4,
    none: 0,
    submitRequired: 1,
    updateRequired: 3,
};
KalturaEntryDistributionFlag[KalturaEntryDistributionFlag.deleteRequired] = 'deleteRequired';
KalturaEntryDistributionFlag[KalturaEntryDistributionFlag.disableRequired] = 'disableRequired';
KalturaEntryDistributionFlag[KalturaEntryDistributionFlag.enableRequired] = 'enableRequired';
KalturaEntryDistributionFlag[KalturaEntryDistributionFlag.none] = 'none';
KalturaEntryDistributionFlag[KalturaEntryDistributionFlag.submitRequired] = 'submitRequired';
KalturaEntryDistributionFlag[KalturaEntryDistributionFlag.updateRequired] = 'updateRequired';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryDistribution extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.validationErrors === 'undefined')
            this.validationErrors = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryDistribution' },
            id: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            submittedAt: { type: 'd', readOnly: true },
            entryId: { type: 's' },
            partnerId: { type: 'n', readOnly: true },
            distributionProfileId: { type: 'n' },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaEntryDistributionStatus, subType: 'KalturaEntryDistributionStatus' },
            sunStatus: { type: 'en', readOnly: true, subTypeConstructor: KalturaEntryDistributionSunStatus, subType: 'KalturaEntryDistributionSunStatus' },
            dirtyStatus: { type: 'en', readOnly: true, subTypeConstructor: KalturaEntryDistributionFlag, subType: 'KalturaEntryDistributionFlag' },
            thumbAssetIds: { type: 's' },
            flavorAssetIds: { type: 's' },
            assetIds: { type: 's' },
            sunrise: { type: 'd' },
            sunset: { type: 'd' },
            remoteId: { type: 's', readOnly: true },
            plays: { type: 'n', readOnly: true },
            views: { type: 'n', readOnly: true },
            validationErrors: { type: 'a', subTypeConstructor: KalturaDistributionValidationError, subType: 'KalturaDistributionValidationError' },
            errorType: { type: 'en', readOnly: true, subTypeConstructor: KalturaBatchJobErrorTypes, subType: 'KalturaBatchJobErrorTypes' },
            errorNumber: { type: 'n', readOnly: true },
            errorDescription: { type: 's', readOnly: true },
            hasSubmitResultsLog: { type: 'en', readOnly: true, subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            hasSubmitSentDataLog: { type: 'en', readOnly: true, subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            hasUpdateResultsLog: { type: 'en', readOnly: true, subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            hasUpdateSentDataLog: { type: 'en', readOnly: true, subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            hasDeleteResultsLog: { type: 'en', readOnly: true, subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            hasDeleteSentDataLog: { type: 'en', readOnly: true, subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryDistribution'] = KalturaEntryDistribution;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaEntryServerNodeStatus = {
    authenticated: 3,
    broadcasting: 2,
    error: -1,
    markedForDeletion: 4,
    playable: 1,
    stopped: 0,
    taskFinished: 9,
    taskPending: 5,
    taskProcessing: 7,
    taskQueued: 6,
    taskUploading: 8,
};
KalturaEntryServerNodeStatus[KalturaEntryServerNodeStatus.authenticated] = 'authenticated';
KalturaEntryServerNodeStatus[KalturaEntryServerNodeStatus.broadcasting] = 'broadcasting';
KalturaEntryServerNodeStatus[KalturaEntryServerNodeStatus.error] = 'error';
KalturaEntryServerNodeStatus[KalturaEntryServerNodeStatus.markedForDeletion] = 'markedForDeletion';
KalturaEntryServerNodeStatus[KalturaEntryServerNodeStatus.playable] = 'playable';
KalturaEntryServerNodeStatus[KalturaEntryServerNodeStatus.stopped] = 'stopped';
KalturaEntryServerNodeStatus[KalturaEntryServerNodeStatus.taskFinished] = 'taskFinished';
KalturaEntryServerNodeStatus[KalturaEntryServerNodeStatus.taskPending] = 'taskPending';
KalturaEntryServerNodeStatus[KalturaEntryServerNodeStatus.taskProcessing] = 'taskProcessing';
KalturaEntryServerNodeStatus[KalturaEntryServerNodeStatus.taskQueued] = 'taskQueued';
KalturaEntryServerNodeStatus[KalturaEntryServerNodeStatus.taskUploading] = 'taskUploading';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEntryServerNodeType = {
    liveBackup: '1',
    liveClippingTask: '2',
    livePrimary: '0',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryServerNode extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryServerNode' },
            id: { type: 'n', readOnly: true },
            entryId: { type: 's', readOnly: true },
            serverNodeId: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaEntryServerNodeStatus, subType: 'KalturaEntryServerNodeStatus' },
            serverType: { type: 'es', readOnly: true, subTypeConstructor: KalturaEntryServerNodeType, subType: 'KalturaEntryServerNodeType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryServerNode'] = KalturaEntryServerNode;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEventNotificationParameter extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEventNotificationParameter' },
            key: { type: 's' },
            description: { type: 's' },
            value: { type: 'o', subTypeConstructor: KalturaStringValue, subType: 'KalturaStringValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEventNotificationParameter'] = KalturaEventNotificationParameter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEventNotificationTemplateType = {
    bpmAbort: 'businessProcessNotification.BusinessProcessAbort',
    bpmSignal: 'businessProcessNotification.BusinessProcessSignal',
    bpmStart: 'businessProcessNotification.BusinessProcessStart',
    email: 'emailNotification.Email',
    http: 'httpNotification.Http',
    push: 'pushNotification.Push',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaEventNotificationTemplateStatus = {
    active: 2,
    deleted: 3,
    disabled: 1,
};
KalturaEventNotificationTemplateStatus[KalturaEventNotificationTemplateStatus.active] = 'active';
KalturaEventNotificationTemplateStatus[KalturaEventNotificationTemplateStatus.deleted] = 'deleted';
KalturaEventNotificationTemplateStatus[KalturaEventNotificationTemplateStatus.disabled] = 'disabled';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEventNotificationEventType = {
    batchJobStatus: '1',
    integrationJobClosed: 'integrationEventNotifications.INTEGRATION_JOB_CLOSED',
    objectAdded: '2',
    objectChanged: '3',
    objectCopied: '4',
    objectCreated: '5',
    objectDataChanged: '6',
    objectDeleted: '7',
    objectErased: '8',
    objectReadyForIndex: '13',
    objectReadyForReplacment: '9',
    objectReplaced: '12',
    objectSaved: '10',
    objectUpdated: '11',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEventNotificationEventObjectType = {
    accesscontrol: '9',
    adCuePoint: 'adCuePointEventNotifications.AdCuePoint',
    annotation: 'annotationEventNotifications.Annotation',
    asset: '3',
    attachmentAsset: 'attachmentAssetEventNotifications.AttachmentAsset',
    batchjob: '10',
    bulkuploadresult: '11',
    captionAsset: 'captionAssetEventNotifications.CaptionAsset',
    category: '2',
    categoryentry: '37',
    categorykuser: '12',
    codeCuePoint: 'codeCuePointEventNotifications.CodeCuePoint',
    conversionprofile2: '14',
    cuePoint: 'cuePointEventNotifications.CuePoint',
    distributionProfile: 'contentDistributionEventNotifications.DistributionProfile',
    dropFolder: 'dropFolderEventNotifications.DropFolder',
    dropFolderFile: 'dropFolderEventNotifications.DropFolderFile',
    entry: '1',
    entryDistribution: 'contentDistributionEventNotifications.EntryDistribution',
    entryServerNode: '40',
    entryVendorTask: '42',
    flavorasset: '4',
    flavorparams: '15',
    flavorparamsconversionprofile: '16',
    flavorparamsoutput: '17',
    genericsyndicationfeed: '18',
    kuser: '8',
    kusertouserrole: '19',
    liveStream: '38',
    metadata: 'metadataEventNotifications.Metadata',
    partner: '20',
    permission: '21',
    permissionitem: '22',
    permissiontopermissionitem: '23',
    reachProfile: '41',
    scheduler: '24',
    schedulerconfig: '25',
    schedulerstatus: '26',
    schedulerworker: '27',
    serverNode: '39',
    storageprofile: '28',
    syndicationfeed: '29',
    thumbasset: '5',
    thumbparams: '31',
    thumbparamsoutput: '32',
    transcriptAsset: 'transcriptAssetEventNotifications.TranscriptAsset',
    uploadtoken: '33',
    userlogindata: '34',
    userrole: '35',
    widget: '36',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEventNotificationTemplate extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.eventConditions === 'undefined')
            this.eventConditions = [];
        if (typeof this.contentParameters === 'undefined')
            this.contentParameters = [];
        if (typeof this.userParameters === 'undefined')
            this.userParameters = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEventNotificationTemplate' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            name: { type: 's' },
            systemName: { type: 's' },
            description: { type: 's' },
            type: { type: 'es', subTypeConstructor: KalturaEventNotificationTemplateType, subType: 'KalturaEventNotificationTemplateType' },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaEventNotificationTemplateStatus, subType: 'KalturaEventNotificationTemplateStatus' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            manualDispatchEnabled: { type: 'b' },
            automaticDispatchEnabled: { type: 'b' },
            eventType: { type: 'es', subTypeConstructor: KalturaEventNotificationEventType, subType: 'KalturaEventNotificationEventType' },
            eventObjectType: { type: 'es', subTypeConstructor: KalturaEventNotificationEventObjectType, subType: 'KalturaEventNotificationEventObjectType' },
            eventConditions: { type: 'a', subTypeConstructor: KalturaCondition, subType: 'KalturaCondition' },
            contentParameters: { type: 'a', subTypeConstructor: KalturaEventNotificationParameter, subType: 'KalturaEventNotificationParameter' },
            userParameters: { type: 'a', subTypeConstructor: KalturaEventNotificationParameter, subType: 'KalturaEventNotificationParameter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEventNotificationTemplate'] = KalturaEventNotificationTemplate;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaObjectIdentifier extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaObjectIdentifier' },
            extendedFeatures: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaObjectIdentifier'] = KalturaObjectIdentifier;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaMrssExtensionMode = {
    append: 1,
    replace: 2,
};
KalturaMrssExtensionMode[KalturaMrssExtensionMode.append] = 'append';
KalturaMrssExtensionMode[KalturaMrssExtensionMode.replace] = 'replace';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaExtendingItemMrssParameter extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaExtendingItemMrssParameter' },
            xpath: { type: 's' },
            identifier: { type: 'o', subTypeConstructor: KalturaObjectIdentifier, subType: 'KalturaObjectIdentifier' },
            extensionMode: { type: 'en', subTypeConstructor: KalturaMrssExtensionMode, subType: 'KalturaMrssExtensionMode' }
        });
        return result;
    }
}
typesMappingStorage['KalturaExtendingItemMrssParameter'] = KalturaExtendingItemMrssParameter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDurationType = {
    long: 'long',
    medium: 'medium',
    notAvailable: 'notavailable',
    short: 'short',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayableEntry extends KalturaBaseEntry {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayableEntry' },
            plays: { type: 'n', readOnly: true },
            views: { type: 'n', readOnly: true },
            lastPlayedAt: { type: 'd', readOnly: true },
            width: { type: 'n', readOnly: true },
            height: { type: 'n', readOnly: true },
            duration: { type: 'n', readOnly: true },
            msDuration: { type: 'n' },
            durationType: { type: 'es', readOnly: true, subTypeConstructor: KalturaDurationType, subType: 'KalturaDurationType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayableEntry'] = KalturaPlayableEntry;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaStreamContainer extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaStreamContainer' },
            type: { type: 's' },
            trackIndex: { type: 'n' },
            language: { type: 's' },
            channelIndex: { type: 'n' },
            label: { type: 's' },
            channelLayout: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaStreamContainer'] = KalturaStreamContainer;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaMediaType = {
    audio: 5,
    image: 2,
    liveStreamFlash: 201,
    liveStreamQuicktime: 204,
    liveStreamRealMedia: 203,
    liveStreamWindowsMedia: 202,
    video: 1,
};
KalturaMediaType[KalturaMediaType.audio] = 'audio';
KalturaMediaType[KalturaMediaType.image] = 'image';
KalturaMediaType[KalturaMediaType.liveStreamFlash] = 'liveStreamFlash';
KalturaMediaType[KalturaMediaType.liveStreamQuicktime] = 'liveStreamQuicktime';
KalturaMediaType[KalturaMediaType.liveStreamRealMedia] = 'liveStreamRealMedia';
KalturaMediaType[KalturaMediaType.liveStreamWindowsMedia] = 'liveStreamWindowsMedia';
KalturaMediaType[KalturaMediaType.video] = 'video';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaSourceType = {
    akamaiLive: '29',
    akamaiUniversalLive: '31',
    clip: '35',
    file: '1',
    kalturaRecordedLive: '36',
    lectureCapture: '37',
    limelightLive: 'limeLight.LIVE_STREAM',
    liveChannel: '33',
    liveStream: '32',
    liveStreamOntextdataCaptions: '42',
    manualLiveStream: '30',
    recordedLive: '34',
    searchProvider: '6',
    url: '5',
    velocixLive: 'velocix.VELOCIX_LIVE',
    webcam: '2',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaSearchProviderType = {
    archiveOrg: 22,
    ccmixter: 10,
    current: 12,
    flickr: 3,
    jamendo: 9,
    kaltura: 20,
    kalturaPartner: 23,
    kalturaUserClips: 21,
    mediaCommons: 13,
    metacafe: 24,
    myspace: 7,
    nypl: 11,
    partnerSpecific: 100,
    photobucket: 8,
    searchProxy: 28,
    youtube: 4,
};
KalturaSearchProviderType[KalturaSearchProviderType.archiveOrg] = 'archiveOrg';
KalturaSearchProviderType[KalturaSearchProviderType.ccmixter] = 'ccmixter';
KalturaSearchProviderType[KalturaSearchProviderType.current] = 'current';
KalturaSearchProviderType[KalturaSearchProviderType.flickr] = 'flickr';
KalturaSearchProviderType[KalturaSearchProviderType.jamendo] = 'jamendo';
KalturaSearchProviderType[KalturaSearchProviderType.kaltura] = 'kaltura';
KalturaSearchProviderType[KalturaSearchProviderType.kalturaPartner] = 'kalturaPartner';
KalturaSearchProviderType[KalturaSearchProviderType.kalturaUserClips] = 'kalturaUserClips';
KalturaSearchProviderType[KalturaSearchProviderType.mediaCommons] = 'mediaCommons';
KalturaSearchProviderType[KalturaSearchProviderType.metacafe] = 'metacafe';
KalturaSearchProviderType[KalturaSearchProviderType.myspace] = 'myspace';
KalturaSearchProviderType[KalturaSearchProviderType.nypl] = 'nypl';
KalturaSearchProviderType[KalturaSearchProviderType.partnerSpecific] = 'partnerSpecific';
KalturaSearchProviderType[KalturaSearchProviderType.photobucket] = 'photobucket';
KalturaSearchProviderType[KalturaSearchProviderType.searchProxy] = 'searchProxy';
KalturaSearchProviderType[KalturaSearchProviderType.youtube] = 'youtube';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaEntry extends KalturaPlayableEntry {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.streams === 'undefined')
            this.streams = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaEntry' },
            mediaType: { type: 'en', subTypeConstructor: KalturaMediaType, subType: 'KalturaMediaType' },
            conversionQuality: { type: 's' },
            sourceType: { type: 'es', subTypeConstructor: KalturaSourceType, subType: 'KalturaSourceType' },
            searchProviderType: { type: 'en', subTypeConstructor: KalturaSearchProviderType, subType: 'KalturaSearchProviderType' },
            searchProviderId: { type: 's' },
            creditUserName: { type: 's' },
            creditUrl: { type: 's' },
            mediaDate: { type: 'd', readOnly: true },
            dataUrl: { type: 's', readOnly: true },
            flavorParamsIds: { type: 's', readOnly: true },
            isTrimDisabled: { type: 'en', readOnly: true, subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            streams: { type: 'a', subTypeConstructor: KalturaStreamContainer, subType: 'KalturaStreamContainer' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaEntry'] = KalturaMediaEntry;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaExternalMediaSourceType = {
    intercall: 'InterCall',
    youtube: 'YouTube',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaExternalMediaEntry extends KalturaMediaEntry {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaExternalMediaEntry' },
            externalSourceType: { type: 'es', subTypeConstructor: KalturaExternalMediaSourceType, subType: 'KalturaExternalMediaSourceType' },
            assetParamsIds: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaExternalMediaEntry'] = KalturaExternalMediaEntry;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFacebookCaptionDistributionInfo extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFacebookCaptionDistributionInfo' },
            language: { type: 's' },
            label: { type: 's' },
            filePath: { type: 's' },
            remoteId: { type: 's' },
            version: { type: 's' },
            assetId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFacebookCaptionDistributionInfo'] = KalturaFacebookCaptionDistributionInfo;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaFeatureStatusType = {
    category: 2,
    categoryEntry: 3,
    categoryUser: 5,
    entry: 4,
    lockCategory: 1,
    user: 6,
};
KalturaFeatureStatusType[KalturaFeatureStatusType.category] = 'category';
KalturaFeatureStatusType[KalturaFeatureStatusType.categoryEntry] = 'categoryEntry';
KalturaFeatureStatusType[KalturaFeatureStatusType.categoryUser] = 'categoryUser';
KalturaFeatureStatusType[KalturaFeatureStatusType.entry] = 'entry';
KalturaFeatureStatusType[KalturaFeatureStatusType.lockCategory] = 'lockCategory';
KalturaFeatureStatusType[KalturaFeatureStatusType.user] = 'user';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFeatureStatus extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFeatureStatus' },
            type: { type: 'en', subTypeConstructor: KalturaFeatureStatusType, subType: 'KalturaFeatureStatusType' },
            value: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFeatureStatus'] = KalturaFeatureStatus;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFeedItemInfo extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFeedItemInfo' },
            itemXPath: { type: 's' },
            itemPublishDateXPath: { type: 's' },
            itemUniqueIdentifierXPath: { type: 's' },
            itemContentFileSizeXPath: { type: 's' },
            itemContentUrlXPath: { type: 's' },
            itemContentBitrateXPath: { type: 's' },
            itemHashXPath: { type: 's' },
            itemContentXpath: { type: 's' },
            contentBitrateAttributeName: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFeedItemInfo'] = KalturaFeedItemInfo;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaFileAssetObjectType = {
    entry: '3',
    uiConf: '2',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaFileAssetStatus = {
    deleted: '3',
    error: '4',
    pending: '0',
    ready: '2',
    uploading: '1',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFileAsset extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFileAsset' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            fileAssetObjectType: { type: 'es', subTypeConstructor: KalturaFileAssetObjectType, subType: 'KalturaFileAssetObjectType' },
            objectId: { type: 's' },
            name: { type: 's' },
            systemName: { type: 's' },
            fileExt: { type: 's' },
            version: { type: 'n', readOnly: true },
            createdAt: { type: 'n', readOnly: true },
            updatedAt: { type: 'n', readOnly: true },
            status: { type: 'es', readOnly: true, subTypeConstructor: KalturaFileAssetStatus, subType: 'KalturaFileAssetStatus' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFileAsset'] = KalturaFileAsset;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFileContainer extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFileContainer' },
            filePath: { type: 's' },
            encryptionKey: { type: 's' },
            fileSize: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFileContainer'] = KalturaFileContainer;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaFileSyncObjectType = {
    asset: '4',
    batchjob: '3',
    conversionProfile: '8',
    distributionProfile: 'contentDistribution.DistributionProfile',
    emailNotificationTemplate: 'emailNotification.EmailNotificationTemplate',
    entry: '1',
    entryDistribution: 'contentDistribution.EntryDistribution',
    fileAsset: '9',
    flavorAsset: '4',
    genericDistributionAction: 'contentDistribution.GenericDistributionAction',
    httpNotificationTemplate: 'httpNotification.HttpNotificationTemplate',
    metadata: '5',
    metadataProfile: '6',
    syndicationFeed: '7',
    uiconf: '2',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaFileSyncStatus = {
    deleted: 3,
    error: -1,
    pending: 1,
    purged: 4,
    ready: 2,
};
KalturaFileSyncStatus[KalturaFileSyncStatus.deleted] = 'deleted';
KalturaFileSyncStatus[KalturaFileSyncStatus.error] = 'error';
KalturaFileSyncStatus[KalturaFileSyncStatus.pending] = 'pending';
KalturaFileSyncStatus[KalturaFileSyncStatus.purged] = 'purged';
KalturaFileSyncStatus[KalturaFileSyncStatus.ready] = 'ready';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaFileSyncType = {
    file: 1,
    link: 2,
    url: 3,
};
KalturaFileSyncType[KalturaFileSyncType.file] = 'file';
KalturaFileSyncType[KalturaFileSyncType.link] = 'link';
KalturaFileSyncType[KalturaFileSyncType.url] = 'url';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFileSync extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFileSync' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            fileObjectType: { type: 'es', readOnly: true, subTypeConstructor: KalturaFileSyncObjectType, subType: 'KalturaFileSyncObjectType' },
            objectId: { type: 's', readOnly: true },
            version: { type: 's', readOnly: true },
            objectSubType: { type: 'n', readOnly: true },
            dc: { type: 's', readOnly: true },
            original: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            readyAt: { type: 'n', readOnly: true },
            syncTime: { type: 'n', readOnly: true },
            status: { type: 'en', subTypeConstructor: KalturaFileSyncStatus, subType: 'KalturaFileSyncStatus' },
            fileType: { type: 'en', readOnly: true, subTypeConstructor: KalturaFileSyncType, subType: 'KalturaFileSyncType' },
            linkedId: { type: 'n', readOnly: true },
            linkCount: { type: 'n', readOnly: true },
            fileRoot: { type: 's' },
            filePath: { type: 's' },
            fileSize: { type: 'n', readOnly: true },
            fileUrl: { type: 's', readOnly: true },
            fileContent: { type: 's', readOnly: true },
            fileDiscSize: { type: 'n', readOnly: true },
            isCurrentDc: { type: 'b', readOnly: true },
            isDir: { type: 'b', readOnly: true },
            originalId: { type: 'n', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaFileSync'] = KalturaFileSync;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaFlavorAssetStatus = {
    converting: 1,
    deleted: 3,
    error: -1,
    exporting: 9,
    importing: 7,
    notApplicable: 4,
    queued: 0,
    ready: 2,
    temp: 5,
    validating: 8,
    waitForConvert: 6,
};
KalturaFlavorAssetStatus[KalturaFlavorAssetStatus.converting] = 'converting';
KalturaFlavorAssetStatus[KalturaFlavorAssetStatus.deleted] = 'deleted';
KalturaFlavorAssetStatus[KalturaFlavorAssetStatus.error] = 'error';
KalturaFlavorAssetStatus[KalturaFlavorAssetStatus.exporting] = 'exporting';
KalturaFlavorAssetStatus[KalturaFlavorAssetStatus.importing] = 'importing';
KalturaFlavorAssetStatus[KalturaFlavorAssetStatus.notApplicable] = 'notApplicable';
KalturaFlavorAssetStatus[KalturaFlavorAssetStatus.queued] = 'queued';
KalturaFlavorAssetStatus[KalturaFlavorAssetStatus.ready] = 'ready';
KalturaFlavorAssetStatus[KalturaFlavorAssetStatus.temp] = 'temp';
KalturaFlavorAssetStatus[KalturaFlavorAssetStatus.validating] = 'validating';
KalturaFlavorAssetStatus[KalturaFlavorAssetStatus.waitForConvert] = 'waitForConvert';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFlavorAsset extends KalturaAsset {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFlavorAsset' },
            flavorParamsId: { type: 'n' },
            width: { type: 'n', readOnly: true },
            height: { type: 'n', readOnly: true },
            bitrate: { type: 'n', readOnly: true },
            frameRate: { type: 'n', readOnly: true },
            isOriginal: { type: 'b', readOnly: true },
            isWeb: { type: 'b', readOnly: true },
            containerFormat: { type: 's', readOnly: true },
            videoCodecId: { type: 's', readOnly: true },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaFlavorAssetStatus, subType: 'KalturaFlavorAssetStatus' },
            language: { type: 'es', subTypeConstructor: KalturaLanguage, subType: 'KalturaLanguage' },
            label: { type: 's' },
            isDefault: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFlavorAsset'] = KalturaFlavorAsset;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFlavorAssetUrlOptions extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFlavorAssetUrlOptions' },
            fileName: { type: 's' },
            referrer: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFlavorAssetUrlOptions'] = KalturaFlavorAssetUrlOptions;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaVideoCodec = {
    apch: 'apch',
    apcn: 'apcn',
    apco: 'apco',
    apcs: 'apcs',
    copy: 'copy',
    dnxhd: 'dnxhd',
    dv: 'dv',
    flv: 'flv',
    h263: 'h263',
    h264: 'h264',
    h264b: 'h264b',
    h264h: 'h264h',
    h264m: 'h264m',
    h265: 'h265',
    mpeg2: 'mpeg2',
    mpeg4: 'mpeg4',
    none: '',
    theora: 'theora',
    vp6: 'vp6',
    vp8: 'vp8',
    vp9: 'vp9',
    wmv2: 'wmv2',
    wmv3: 'wmv3',
    wvc1a: 'wvc1a',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAudioCodec = {
    aac: 'aac',
    aache: 'aache',
    ac3: 'ac3',
    amrnb: 'amrnb',
    copy: 'copy',
    eac3: 'eac3',
    mp3: 'mp3',
    mpeg2: 'mpeg2',
    none: '',
    pcm: 'pcm',
    vorbis: 'vorbis',
    wma: 'wma',
    wmapro: 'wmapro',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaContainerFormat = {
    applehttp: 'applehttp',
    avi: 'avi',
    bmp: 'bmp',
    copy: 'copy',
    flv: 'flv',
    hls: 'hls',
    isma: 'isma',
    ismv: 'ismv',
    jpg: 'jpg',
    m2ts: 'm2ts',
    m4v: 'm4v',
    mkv: 'mkv',
    mov: 'mov',
    mp3: 'mp3',
    mp4: 'mp4',
    mpeg: 'mpeg',
    mpegts: 'mpegts',
    mxf: 'mxf',
    ogg: 'ogg',
    ogv: 'ogv',
    pdf: 'pdf',
    png: 'png',
    swf: 'swf',
    wav: 'wav',
    webm: 'webm',
    wma: 'wma',
    wmv: 'wmv',
    wvm: 'wvm',
    _3gp: '3gp',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFlavorParams extends KalturaAssetParams {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFlavorParams' },
            videoCodec: { type: 'es', subTypeConstructor: KalturaVideoCodec, subType: 'KalturaVideoCodec' },
            videoBitrate: { type: 'n' },
            audioCodec: { type: 'es', subTypeConstructor: KalturaAudioCodec, subType: 'KalturaAudioCodec' },
            audioBitrate: { type: 'n' },
            audioChannels: { type: 'n' },
            audioSampleRate: { type: 'n' },
            width: { type: 'n' },
            height: { type: 'n' },
            frameRate: { type: 'n' },
            gopSize: { type: 'n' },
            conversionEngines: { type: 's' },
            conversionEnginesExtraParams: { type: 's' },
            twoPass: { type: 'b' },
            deinterlice: { type: 'n' },
            rotate: { type: 'n' },
            operators: { type: 's' },
            engineVersion: { type: 'n' },
            format: { type: 'es', subTypeConstructor: KalturaContainerFormat, subType: 'KalturaContainerFormat' },
            aspectRatioProcessingMode: { type: 'n' },
            forceFrameToMultiplication16: { type: 'n' },
            isGopInSec: { type: 'n' },
            isAvoidVideoShrinkFramesizeToSource: { type: 'n' },
            isAvoidVideoShrinkBitrateToSource: { type: 'n' },
            isVideoFrameRateForLowBrAppleHls: { type: 'n' },
            multiStream: { type: 's' },
            anamorphicPixels: { type: 'n' },
            isAvoidForcedKeyFrames: { type: 'n' },
            forcedKeyFramesMode: { type: 'n' },
            isCropIMX: { type: 'n' },
            optimizationPolicy: { type: 'n' },
            maxFrameRate: { type: 'n' },
            videoConstantBitrate: { type: 'n' },
            videoBitrateTolerance: { type: 'n' },
            watermarkData: { type: 's' },
            subtitlesData: { type: 's' },
            isEncrypted: { type: 'n' },
            contentAwareness: { type: 'n' },
            chunkedEncodeMode: { type: 'n' },
            clipOffset: { type: 'n' },
            clipDuration: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFlavorParams'] = KalturaFlavorParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFlavorAssetWithParams extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFlavorAssetWithParams' },
            flavorAsset: { type: 'o', subTypeConstructor: KalturaFlavorAsset, subType: 'KalturaFlavorAsset' },
            flavorParams: { type: 'o', subTypeConstructor: KalturaFlavorParams, subType: 'KalturaFlavorParams' },
            entryId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFlavorAssetWithParams'] = KalturaFlavorAssetWithParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFlavorParamsOutput extends KalturaFlavorParams {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFlavorParamsOutput' },
            flavorParamsId: { type: 'n' },
            commandLinesStr: { type: 's' },
            flavorParamsVersion: { type: 's' },
            flavorAssetId: { type: 's' },
            flavorAssetVersion: { type: 's' },
            readyBehavior: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFlavorParamsOutput'] = KalturaFlavorParamsOutput;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFreewheelDistributionAssetPath extends KalturaDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFreewheelDistributionAssetPath' },
            path: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFreewheelDistributionAssetPath'] = KalturaFreewheelDistributionAssetPath;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFtpDistributionFile extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFtpDistributionFile' },
            assetId: { type: 's' },
            filename: { type: 's' },
            contents: { type: 's' },
            localFilePath: { type: 's' },
            version: { type: 's' },
            hash: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFtpDistributionFile'] = KalturaFtpDistributionFile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaSchedulerStatusType = {
    runningBatchesCount: 1,
    runningBatchesCpu: 2,
    runningBatchesDiscIo: 5,
    runningBatchesDiscSpace: 6,
    runningBatchesIsRunning: 7,
    runningBatchesLastExecutionTime: 8,
    runningBatchesMemory: 3,
    runningBatchesNetwork: 4,
};
KalturaSchedulerStatusType[KalturaSchedulerStatusType.runningBatchesCount] = 'runningBatchesCount';
KalturaSchedulerStatusType[KalturaSchedulerStatusType.runningBatchesCpu] = 'runningBatchesCpu';
KalturaSchedulerStatusType[KalturaSchedulerStatusType.runningBatchesDiscIo] = 'runningBatchesDiscIo';
KalturaSchedulerStatusType[KalturaSchedulerStatusType.runningBatchesDiscSpace] = 'runningBatchesDiscSpace';
KalturaSchedulerStatusType[KalturaSchedulerStatusType.runningBatchesIsRunning] = 'runningBatchesIsRunning';
KalturaSchedulerStatusType[KalturaSchedulerStatusType.runningBatchesLastExecutionTime] = 'runningBatchesLastExecutionTime';
KalturaSchedulerStatusType[KalturaSchedulerStatusType.runningBatchesMemory] = 'runningBatchesMemory';
KalturaSchedulerStatusType[KalturaSchedulerStatusType.runningBatchesNetwork] = 'runningBatchesNetwork';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSchedulerStatus extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSchedulerStatus' },
            id: { type: 'n', readOnly: true },
            schedulerConfiguredId: { type: 'n' },
            workerConfiguredId: { type: 'n' },
            workerType: { type: 'es', subTypeConstructor: KalturaBatchJobType, subType: 'KalturaBatchJobType' },
            type: { type: 'en', subTypeConstructor: KalturaSchedulerStatusType, subType: 'KalturaSchedulerStatusType' },
            value: { type: 'n' },
            schedulerId: { type: 'n', readOnly: true },
            workerId: { type: 'n', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaSchedulerStatus'] = KalturaSchedulerStatus;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSchedulerConfig extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSchedulerConfig' },
            id: { type: 'n', readOnly: true },
            createdBy: { type: 's' },
            updatedBy: { type: 's' },
            commandId: { type: 's' },
            commandStatus: { type: 's' },
            schedulerId: { type: 'n' },
            schedulerConfiguredId: { type: 'n' },
            schedulerName: { type: 's' },
            workerId: { type: 'n' },
            workerConfiguredId: { type: 'n' },
            workerName: { type: 's' },
            variable: { type: 's' },
            variablePart: { type: 's' },
            value: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSchedulerConfig'] = KalturaSchedulerConfig;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSchedulerWorker extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.statuses === 'undefined')
            this.statuses = [];
        if (typeof this.configs === 'undefined')
            this.configs = [];
        if (typeof this.lockedJobs === 'undefined')
            this.lockedJobs = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSchedulerWorker' },
            id: { type: 'n', readOnly: true },
            configuredId: { type: 'n' },
            schedulerId: { type: 'n' },
            schedulerConfiguredId: { type: 'n' },
            type: { type: 'es', subTypeConstructor: KalturaBatchJobType, subType: 'KalturaBatchJobType' },
            typeName: { type: 's' },
            name: { type: 's' },
            statuses: { type: 'a', subTypeConstructor: KalturaSchedulerStatus, subType: 'KalturaSchedulerStatus' },
            configs: { type: 'a', subTypeConstructor: KalturaSchedulerConfig, subType: 'KalturaSchedulerConfig' },
            lockedJobs: { type: 'a', subTypeConstructor: KalturaBatchJob, subType: 'KalturaBatchJob' },
            avgWait: { type: 'n' },
            avgWork: { type: 'n' },
            lastStatus: { type: 'n' },
            lastStatusStr: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSchedulerWorker'] = KalturaSchedulerWorker;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduler extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.statuses === 'undefined')
            this.statuses = [];
        if (typeof this.configs === 'undefined')
            this.configs = [];
        if (typeof this.workers === 'undefined')
            this.workers = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduler' },
            id: { type: 'n', readOnly: true },
            configuredId: { type: 'n' },
            name: { type: 's' },
            host: { type: 's' },
            statuses: { type: 'a', readOnly: true, subTypeConstructor: KalturaSchedulerStatus, subType: 'KalturaSchedulerStatus' },
            configs: { type: 'a', readOnly: true, subTypeConstructor: KalturaSchedulerConfig, subType: 'KalturaSchedulerConfig' },
            workers: { type: 'a', readOnly: true, subTypeConstructor: KalturaSchedulerWorker, subType: 'KalturaSchedulerWorker' },
            createdAt: { type: 'd', readOnly: true },
            lastStatus: { type: 'n', readOnly: true },
            lastStatusStr: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduler'] = KalturaScheduler;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDistributionProtocol = {
    aspera: 10,
    ftp: 1,
    http: 4,
    https: 5,
    scp: 2,
    sftp: 3,
};
KalturaDistributionProtocol[KalturaDistributionProtocol.aspera] = 'aspera';
KalturaDistributionProtocol[KalturaDistributionProtocol.ftp] = 'ftp';
KalturaDistributionProtocol[KalturaDistributionProtocol.http] = 'http';
KalturaDistributionProtocol[KalturaDistributionProtocol.https] = 'https';
KalturaDistributionProtocol[KalturaDistributionProtocol.scp] = 'scp';
KalturaDistributionProtocol[KalturaDistributionProtocol.sftp] = 'sftp';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericDistributionProfileAction extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericDistributionProfileAction' },
            protocol: { type: 'en', subTypeConstructor: KalturaDistributionProtocol, subType: 'KalturaDistributionProtocol' },
            serverUrl: { type: 's' },
            serverPath: { type: 's' },
            username: { type: 's' },
            password: { type: 's' },
            ftpPassiveMode: { type: 'b' },
            httpFieldName: { type: 's' },
            httpFileName: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericDistributionProfileAction'] = KalturaGenericDistributionProfileAction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaGenericDistributionProviderStatus = {
    active: 2,
    deleted: 3,
};
KalturaGenericDistributionProviderStatus[KalturaGenericDistributionProviderStatus.active] = 'active';
KalturaGenericDistributionProviderStatus[KalturaGenericDistributionProviderStatus.deleted] = 'deleted';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaGenericDistributionProviderParser = {
    regex: 3,
    xpath: 2,
    xsl: 1,
};
KalturaGenericDistributionProviderParser[KalturaGenericDistributionProviderParser.regex] = 'regex';
KalturaGenericDistributionProviderParser[KalturaGenericDistributionProviderParser.xpath] = 'xpath';
KalturaGenericDistributionProviderParser[KalturaGenericDistributionProviderParser.xsl] = 'xsl';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericDistributionProviderAction extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericDistributionProviderAction' },
            id: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            genericDistributionProviderId: { type: 'n' },
            action: { type: 'en', subTypeConstructor: KalturaDistributionAction, subType: 'KalturaDistributionAction' },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaGenericDistributionProviderStatus, subType: 'KalturaGenericDistributionProviderStatus' },
            resultsParser: { type: 'en', subTypeConstructor: KalturaGenericDistributionProviderParser, subType: 'KalturaGenericDistributionProviderParser' },
            protocol: { type: 'en', subTypeConstructor: KalturaDistributionProtocol, subType: 'KalturaDistributionProtocol' },
            serverAddress: { type: 's' },
            remotePath: { type: 's' },
            remoteUsername: { type: 's' },
            remotePassword: { type: 's' },
            editableFields: { type: 's' },
            mandatoryFields: { type: 's' },
            mrssTransformer: { type: 's', readOnly: true },
            mrssValidator: { type: 's', readOnly: true },
            resultsTransformer: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericDistributionProviderAction'] = KalturaGenericDistributionProviderAction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.optionalThumbDimensions === 'undefined')
            this.optionalThumbDimensions = [];
        if (typeof this.requiredThumbDimensions === 'undefined')
            this.requiredThumbDimensions = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericDistributionProvider' },
            id: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            isDefault: { type: 'b' },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaGenericDistributionProviderStatus, subType: 'KalturaGenericDistributionProviderStatus' },
            optionalFlavorParamsIds: { type: 's' },
            requiredFlavorParamsIds: { type: 's' },
            optionalThumbDimensions: { type: 'a', subTypeConstructor: KalturaDistributionThumbDimensions, subType: 'KalturaDistributionThumbDimensions' },
            requiredThumbDimensions: { type: 'a', subTypeConstructor: KalturaDistributionThumbDimensions, subType: 'KalturaDistributionThumbDimensions' },
            editableFields: { type: 's' },
            mandatoryFields: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericDistributionProvider'] = KalturaGenericDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaGroupUserStatus = {
    active: 0,
    deleted: 1,
};
KalturaGroupUserStatus[KalturaGroupUserStatus.active] = 'active';
KalturaGroupUserStatus[KalturaGroupUserStatus.deleted] = 'deleted';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaGroupUserCreationMode = {
    automatic: 2,
    manual: 1,
};
KalturaGroupUserCreationMode[KalturaGroupUserCreationMode.automatic] = 'automatic';
KalturaGroupUserCreationMode[KalturaGroupUserCreationMode.manual] = 'manual';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGroupUser extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGroupUser' },
            userId: { type: 's' },
            groupId: { type: 's' },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaGroupUserStatus, subType: 'KalturaGroupUserStatus' },
            partnerId: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            creationMode: { type: 'en', subTypeConstructor: KalturaGroupUserCreationMode, subType: 'KalturaGroupUserCreationMode' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGroupUser'] = KalturaGroupUser;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaObject extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaObject' }
        });
        return result;
    }
}
typesMappingStorage['KalturaObject'] = KalturaObject;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaHttpNotification extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaHttpNotification' },
            object: { type: 'o', subTypeConstructor: KalturaObjectBase, subType: 'KalturaObjectBase' },
            eventObjectType: { type: 'es', subTypeConstructor: KalturaEventNotificationEventObjectType, subType: 'KalturaEventNotificationEventObjectType' },
            eventNotificationJobId: { type: 'n' },
            templateId: { type: 'n' },
            templateName: { type: 's' },
            templateSystemName: { type: 's' },
            eventType: { type: 'es', subTypeConstructor: KalturaEventNotificationEventType, subType: 'KalturaEventNotificationEventType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaHttpNotification'] = KalturaHttpNotification;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaHttpNotificationData extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaHttpNotificationData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaHttpNotificationData'] = KalturaHttpNotificationData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIntegerValue extends KalturaValue {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIntegerValue' },
            value: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIntegerValue'] = KalturaIntegerValue;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIntegrationJobProviderData extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIntegrationJobProviderData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIntegrationJobProviderData'] = KalturaIntegrationJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIntegrationJobTriggerData extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIntegrationJobTriggerData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIntegrationJobTriggerData'] = KalturaIntegrationJobTriggerData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFileSyncListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFileSyncListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaFileSync, subType: 'KalturaFileSync' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFileSyncListResponse'] = KalturaFileSyncListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBatchJobListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBatchJobListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaBatchJob, subType: 'KalturaBatchJob' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBatchJobListResponse'] = KalturaBatchJobListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaBitRateMode = {
    cbr: 1,
    vbr: 2,
};
KalturaBitRateMode[KalturaBitRateMode.cbr] = 'cbr';
KalturaBitRateMode[KalturaBitRateMode.vbr] = 'vbr';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaInfo extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaInfo' },
            id: { type: 'n', readOnly: true },
            flavorAssetId: { type: 's' },
            fileSize: { type: 'n' },
            containerFormat: { type: 's' },
            containerId: { type: 's' },
            containerProfile: { type: 's' },
            containerDuration: { type: 'n' },
            containerBitRate: { type: 'n' },
            videoFormat: { type: 's' },
            videoCodecId: { type: 's' },
            videoDuration: { type: 'n' },
            videoBitRate: { type: 'n' },
            videoBitRateMode: { type: 'en', subTypeConstructor: KalturaBitRateMode, subType: 'KalturaBitRateMode' },
            videoWidth: { type: 'n' },
            videoHeight: { type: 'n' },
            videoFrameRate: { type: 'n' },
            videoDar: { type: 'n' },
            videoRotation: { type: 'n' },
            audioFormat: { type: 's' },
            audioCodecId: { type: 's' },
            audioDuration: { type: 'n' },
            audioBitRate: { type: 'n' },
            audioBitRateMode: { type: 'en', subTypeConstructor: KalturaBitRateMode, subType: 'KalturaBitRateMode' },
            audioChannels: { type: 'n' },
            audioSamplingRate: { type: 'n' },
            audioResolution: { type: 'n' },
            writingLib: { type: 's' },
            rawData: { type: 's' },
            multiStreamInfo: { type: 's' },
            scanType: { type: 'n' },
            multiStream: { type: 's' },
            isFastStart: { type: 'n' },
            contentStreams: { type: 's' },
            complexityValue: { type: 'n' },
            maxGOP: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaInfo'] = KalturaMediaInfo;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaInfoListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaInfoListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaMediaInfo, subType: 'KalturaMediaInfo' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaInfoListResponse'] = KalturaMediaInfoListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFlavorParamsOutputListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFlavorParamsOutputListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaFlavorParamsOutput, subType: 'KalturaFlavorParamsOutput' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFlavorParamsOutputListResponse'] = KalturaFlavorParamsOutputListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaThumbAssetStatus = {
    capturing: 1,
    deleted: 3,
    error: -1,
    exporting: 9,
    importing: 7,
    queued: 0,
    ready: 2,
};
KalturaThumbAssetStatus[KalturaThumbAssetStatus.capturing] = 'capturing';
KalturaThumbAssetStatus[KalturaThumbAssetStatus.deleted] = 'deleted';
KalturaThumbAssetStatus[KalturaThumbAssetStatus.error] = 'error';
KalturaThumbAssetStatus[KalturaThumbAssetStatus.exporting] = 'exporting';
KalturaThumbAssetStatus[KalturaThumbAssetStatus.importing] = 'importing';
KalturaThumbAssetStatus[KalturaThumbAssetStatus.queued] = 'queued';
KalturaThumbAssetStatus[KalturaThumbAssetStatus.ready] = 'ready';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaThumbAsset extends KalturaAsset {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaThumbAsset' },
            thumbParamsId: { type: 'n' },
            width: { type: 'n', readOnly: true },
            height: { type: 'n', readOnly: true },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaThumbAssetStatus, subType: 'KalturaThumbAssetStatus' }
        });
        return result;
    }
}
typesMappingStorage['KalturaThumbAsset'] = KalturaThumbAsset;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaThumbCropType = {
    crop: 3,
    cropFromTop: 4,
    resize: 1,
    resizeWithForce: 5,
    resizeWithPadding: 2,
};
KalturaThumbCropType[KalturaThumbCropType.crop] = 'crop';
KalturaThumbCropType[KalturaThumbCropType.cropFromTop] = 'cropFromTop';
KalturaThumbCropType[KalturaThumbCropType.resize] = 'resize';
KalturaThumbCropType[KalturaThumbCropType.resizeWithForce] = 'resizeWithForce';
KalturaThumbCropType[KalturaThumbCropType.resizeWithPadding] = 'resizeWithPadding';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaThumbParams extends KalturaAssetParams {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaThumbParams' },
            cropType: { type: 'en', subTypeConstructor: KalturaThumbCropType, subType: 'KalturaThumbCropType' },
            quality: { type: 'n' },
            cropX: { type: 'n' },
            cropY: { type: 'n' },
            cropWidth: { type: 'n' },
            cropHeight: { type: 'n' },
            videoOffset: { type: 'n' },
            width: { type: 'n' },
            height: { type: 'n' },
            scaleWidth: { type: 'n' },
            scaleHeight: { type: 'n' },
            backgroundColor: { type: 's' },
            sourceParamsId: { type: 'n' },
            format: { type: 'es', subTypeConstructor: KalturaContainerFormat, subType: 'KalturaContainerFormat' },
            density: { type: 'n' },
            stripProfiles: { type: 'b' },
            videoOffsetInPercentage: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaThumbParams'] = KalturaThumbParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaThumbParamsOutput extends KalturaThumbParams {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaThumbParamsOutput' },
            thumbParamsId: { type: 'n' },
            thumbParamsVersion: { type: 's' },
            thumbAssetId: { type: 's' },
            thumbAssetVersion: { type: 's' },
            rotate: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaThumbParamsOutput'] = KalturaThumbParamsOutput;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaThumbParamsOutputListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaThumbParamsOutputListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaThumbParamsOutput, subType: 'KalturaThumbParamsOutput' }
        });
        return result;
    }
}
typesMappingStorage['KalturaThumbParamsOutputListResponse'] = KalturaThumbParamsOutputListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaTrackEntryEventType = {
    addEntry: 4,
    deletedEntry: 6,
    importStarted: 3,
    updateEntry: 5,
    uploadedFile: 1,
    webcamCompleted: 2,
};
KalturaTrackEntryEventType[KalturaTrackEntryEventType.addEntry] = 'addEntry';
KalturaTrackEntryEventType[KalturaTrackEntryEventType.deletedEntry] = 'deletedEntry';
KalturaTrackEntryEventType[KalturaTrackEntryEventType.importStarted] = 'importStarted';
KalturaTrackEntryEventType[KalturaTrackEntryEventType.updateEntry] = 'updateEntry';
KalturaTrackEntryEventType[KalturaTrackEntryEventType.uploadedFile] = 'uploadedFile';
KalturaTrackEntryEventType[KalturaTrackEntryEventType.webcamCompleted] = 'webcamCompleted';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTrackEntry extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTrackEntry' },
            id: { type: 'n' },
            trackEventType: { type: 'en', subTypeConstructor: KalturaTrackEntryEventType, subType: 'KalturaTrackEntryEventType' },
            psVersion: { type: 's' },
            context: { type: 's' },
            partnerId: { type: 'n' },
            entryId: { type: 's' },
            hostName: { type: 's' },
            userId: { type: 's' },
            changedProperties: { type: 's' },
            paramStr1: { type: 's' },
            paramStr2: { type: 's' },
            paramStr3: { type: 's' },
            ks: { type: 's' },
            description: { type: 's' },
            createdAt: { type: 'd' },
            updatedAt: { type: 'd' },
            userIp: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaTrackEntry'] = KalturaTrackEntry;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLike extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLike' },
            entryId: { type: 's' },
            userId: { type: 's' },
            createdAt: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLike'] = KalturaLike;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamConfiguration extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamConfiguration' },
            protocol: { type: 'es', subTypeConstructor: KalturaPlaybackProtocol, subType: 'KalturaPlaybackProtocol' },
            url: { type: 's' },
            publishUrl: { type: 's' },
            backupUrl: { type: 's' },
            streamName: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamConfiguration'] = KalturaLiveStreamConfiguration;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamPushPublishConfiguration extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamPushPublishConfiguration' },
            publishUrl: { type: 's' },
            backupPublishUrl: { type: 's' },
            port: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamPushPublishConfiguration'] = KalturaLiveStreamPushPublishConfiguration;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveEntryRecordingOptions extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveEntryRecordingOptions' },
            shouldCopyEntitlement: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            shouldCopyScheduling: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            shouldCopyThumbnail: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            shouldMakeHidden: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveEntryRecordingOptions'] = KalturaLiveEntryRecordingOptions;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaRecordStatus = {
    appended: 1,
    disabled: 0,
    perSession: 2,
};
KalturaRecordStatus[KalturaRecordStatus.appended] = 'appended';
KalturaRecordStatus[KalturaRecordStatus.disabled] = 'disabled';
KalturaRecordStatus[KalturaRecordStatus.perSession] = 'perSession';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDVRStatus = {
    disabled: 0,
    enabled: 1,
};
KalturaDVRStatus[KalturaDVRStatus.disabled] = 'disabled';
KalturaDVRStatus[KalturaDVRStatus.enabled] = 'enabled';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaLivePublishStatus = {
    disabled: 0,
    enabled: 1,
};
KalturaLivePublishStatus[KalturaLivePublishStatus.disabled] = 'disabled';
KalturaLivePublishStatus[KalturaLivePublishStatus.enabled] = 'enabled';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaViewMode = {
    allowAll: 1,
    preview: 0,
};
KalturaViewMode[KalturaViewMode.allowAll] = 'allowAll';
KalturaViewMode[KalturaViewMode.preview] = 'preview';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaRecordingStatus = {
    active: 2,
    disabled: 3,
    paused: 1,
    stopped: 0,
};
KalturaRecordingStatus[KalturaRecordingStatus.active] = 'active';
KalturaRecordingStatus[KalturaRecordingStatus.disabled] = 'disabled';
KalturaRecordingStatus[KalturaRecordingStatus.paused] = 'paused';
KalturaRecordingStatus[KalturaRecordingStatus.stopped] = 'stopped';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveEntry extends KalturaMediaEntry {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.liveStreamConfigurations === 'undefined')
            this.liveStreamConfigurations = [];
        if (typeof this.publishConfigurations === 'undefined')
            this.publishConfigurations = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveEntry' },
            offlineMessage: { type: 's' },
            recordStatus: { type: 'en', subTypeConstructor: KalturaRecordStatus, subType: 'KalturaRecordStatus' },
            dvrStatus: { type: 'en', subTypeConstructor: KalturaDVRStatus, subType: 'KalturaDVRStatus' },
            dvrWindow: { type: 'n' },
            lastElapsedRecordingTime: { type: 'n' },
            liveStreamConfigurations: { type: 'a', subTypeConstructor: KalturaLiveStreamConfiguration, subType: 'KalturaLiveStreamConfiguration' },
            recordedEntryId: { type: 's' },
            pushPublishEnabled: { type: 'en', subTypeConstructor: KalturaLivePublishStatus, subType: 'KalturaLivePublishStatus' },
            publishConfigurations: { type: 'a', subTypeConstructor: KalturaLiveStreamPushPublishConfiguration, subType: 'KalturaLiveStreamPushPublishConfiguration' },
            firstBroadcast: { type: 'n', readOnly: true },
            lastBroadcast: { type: 'n', readOnly: true },
            currentBroadcastStartTime: { type: 'n' },
            recordingOptions: { type: 'o', subTypeConstructor: KalturaLiveEntryRecordingOptions, subType: 'KalturaLiveEntryRecordingOptions' },
            liveStatus: { type: 'en', readOnly: true, subTypeConstructor: KalturaEntryServerNodeStatus, subType: 'KalturaEntryServerNodeStatus' },
            segmentDuration: { type: 'n' },
            explicitLive: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            viewMode: { type: 'en', subTypeConstructor: KalturaViewMode, subType: 'KalturaViewMode' },
            recordingStatus: { type: 'en', subTypeConstructor: KalturaRecordingStatus, subType: 'KalturaRecordingStatus' },
            lastBroadcastEndTime: { type: 'n', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveEntry'] = KalturaLiveEntry;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveChannel extends KalturaLiveEntry {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveChannel' },
            playlistId: { type: 's' },
            repeat: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveChannel'] = KalturaLiveChannel;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveChannelSegmentType = {
    videoAndAudio: '1',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveChannelSegmentStatus = {
    active: '2',
    deleted: '3',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveChannelSegmentTriggerType = {
    absoluteTime: '2',
    channelRelative: '1',
    segmentEndRelative: '4',
    segmentStartRelative: '3',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveChannelSegment extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveChannelSegment' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            createdAt: { type: 'n', readOnly: true },
            updatedAt: { type: 'n', readOnly: true },
            name: { type: 's' },
            description: { type: 's' },
            tags: { type: 's' },
            type: { type: 'es', subTypeConstructor: KalturaLiveChannelSegmentType, subType: 'KalturaLiveChannelSegmentType' },
            status: { type: 'es', readOnly: true, subTypeConstructor: KalturaLiveChannelSegmentStatus, subType: 'KalturaLiveChannelSegmentStatus' },
            channelId: { type: 's' },
            entryId: { type: 's' },
            triggerType: { type: 'es', subTypeConstructor: KalturaLiveChannelSegmentTriggerType, subType: 'KalturaLiveChannelSegmentTriggerType' },
            triggerSegmentId: { type: 'n' },
            startTime: { type: 'n' },
            duration: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveChannelSegment'] = KalturaLiveChannelSegment;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaEntryServerNodeRecordingStatus = {
    dismissed: 3,
    done: 2,
    onGoing: 1,
    stopped: 0,
};
KalturaEntryServerNodeRecordingStatus[KalturaEntryServerNodeRecordingStatus.dismissed] = 'dismissed';
KalturaEntryServerNodeRecordingStatus[KalturaEntryServerNodeRecordingStatus.done] = 'done';
KalturaEntryServerNodeRecordingStatus[KalturaEntryServerNodeRecordingStatus.onGoing] = 'onGoing';
KalturaEntryServerNodeRecordingStatus[KalturaEntryServerNodeRecordingStatus.stopped] = 'stopped';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveEntryServerNodeRecordingInfo extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveEntryServerNodeRecordingInfo' },
            recordedEntryId: { type: 's' },
            duration: { type: 'n' },
            recordingStatus: { type: 'en', subTypeConstructor: KalturaEntryServerNodeRecordingStatus, subType: 'KalturaEntryServerNodeRecordingStatus' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveEntryServerNodeRecordingInfo'] = KalturaLiveEntryServerNodeRecordingInfo;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveReportExportParams extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveReportExportParams' },
            entryIds: { type: 's' },
            recpientEmail: { type: 's' },
            timeZoneOffset: { type: 'n' },
            applicationUrlTemplate: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveReportExportParams'] = KalturaLiveReportExportParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveReportExportResponse extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveReportExportResponse' },
            referenceJobId: { type: 'n' },
            reportEmail: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveReportExportResponse'] = KalturaLiveReportExportResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveReportOrderBy = {
    audienceDesc: '-audience',
    eventTimeDesc: '-eventTime',
    nameAsc: '+name',
    playsDesc: '-plays',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveReportInputFilter extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveReportInputFilter' },
            entryIds: { type: 's' },
            fromTime: { type: 'd' },
            toTime: { type: 'd' },
            live: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            orderBy: { type: 'es', subTypeConstructor: KalturaLiveReportOrderBy, subType: 'KalturaLiveReportOrderBy' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveReportInputFilter'] = KalturaLiveReportInputFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStats extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStats' },
            audience: { type: 'n' },
            dvrAudience: { type: 'n' },
            avgBitrate: { type: 'n' },
            bufferTime: { type: 'n' },
            plays: { type: 'n' },
            secondsViewed: { type: 'n' },
            startEvent: { type: 'n' },
            timestamp: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStats'] = KalturaLiveStats;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaLiveStatsEventType = {
    dvr: 2,
    live: 1,
};
KalturaLiveStatsEventType[KalturaLiveStatsEventType.dvr] = 'dvr';
KalturaLiveStatsEventType[KalturaLiveStatsEventType.live] = 'live';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStatsEvent extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStatsEvent' },
            partnerId: { type: 'n' },
            entryId: { type: 's' },
            eventType: { type: 'en', subTypeConstructor: KalturaLiveStatsEventType, subType: 'KalturaLiveStatsEventType' },
            sessionId: { type: 's' },
            eventIndex: { type: 'n' },
            bufferTime: { type: 'n' },
            bitrate: { type: 'n' },
            referrer: { type: 's' },
            isLive: { type: 'b' },
            startTime: { type: 's' },
            deliveryType: { type: 'es', subTypeConstructor: KalturaPlaybackProtocol, subType: 'KalturaPlaybackProtocol' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStatsEvent'] = KalturaLiveStatsEvent;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamBitrate extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamBitrate' },
            bitrate: { type: 'n' },
            width: { type: 'n' },
            height: { type: 'n' },
            tags: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamBitrate'] = KalturaLiveStreamBitrate;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamEntry extends KalturaLiveEntry {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.bitrates === 'undefined')
            this.bitrates = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamEntry' },
            streamRemoteId: { type: 's', readOnly: true },
            streamRemoteBackupId: { type: 's', readOnly: true },
            bitrates: { type: 'a', subTypeConstructor: KalturaLiveStreamBitrate, subType: 'KalturaLiveStreamBitrate' },
            primaryBroadcastingUrl: { type: 's' },
            secondaryBroadcastingUrl: { type: 's' },
            primaryRtspBroadcastingUrl: { type: 's' },
            secondaryRtspBroadcastingUrl: { type: 's' },
            streamName: { type: 's' },
            streamUrl: { type: 's' },
            hlsStreamUrl: { type: 's' },
            urlManager: { type: 's' },
            encodingIP1: { type: 's' },
            encodingIP2: { type: 's' },
            streamPassword: { type: 's' },
            streamUsername: { type: 's', readOnly: true },
            primaryServerNodeId: { type: 'n', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamEntry'] = KalturaLiveStreamEntry;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamParams extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamParams' },
            bitrate: { type: 'n' },
            flavorId: { type: 's' },
            width: { type: 'n' },
            height: { type: 'n' },
            codec: { type: 's' },
            frameRate: { type: 'n' },
            keyFrameInterval: { type: 'n' },
            language: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamParams'] = KalturaLiveStreamParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBaseEntryBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBaseEntryBaseFilter' },
            idEqual: { type: 's' },
            idIn: { type: 's' },
            idNotIn: { type: 's' },
            nameLike: { type: 's' },
            nameMultiLikeOr: { type: 's' },
            nameMultiLikeAnd: { type: 's' },
            nameEqual: { type: 's' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            userIdEqual: { type: 's' },
            userIdIn: { type: 's' },
            userIdNotIn: { type: 's' },
            creatorIdEqual: { type: 's' },
            tagsLike: { type: 's' },
            tagsMultiLikeOr: { type: 's' },
            tagsMultiLikeAnd: { type: 's' },
            adminTagsLike: { type: 's' },
            adminTagsMultiLikeOr: { type: 's' },
            adminTagsMultiLikeAnd: { type: 's' },
            categoriesMatchAnd: { type: 's' },
            categoriesMatchOr: { type: 's' },
            categoriesNotContains: { type: 's' },
            categoriesIdsMatchAnd: { type: 's' },
            categoriesIdsMatchOr: { type: 's' },
            categoriesIdsNotContains: { type: 's' },
            categoriesIdsEmpty: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            statusEqual: { type: 'es', subTypeConstructor: KalturaEntryStatus, subType: 'KalturaEntryStatus' },
            statusNotEqual: { type: 'es', subTypeConstructor: KalturaEntryStatus, subType: 'KalturaEntryStatus' },
            statusIn: { type: 's' },
            statusNotIn: { type: 's' },
            moderationStatusEqual: { type: 'en', subTypeConstructor: KalturaEntryModerationStatus, subType: 'KalturaEntryModerationStatus' },
            moderationStatusNotEqual: { type: 'en', subTypeConstructor: KalturaEntryModerationStatus, subType: 'KalturaEntryModerationStatus' },
            moderationStatusIn: { type: 's' },
            moderationStatusNotIn: { type: 's' },
            typeEqual: { type: 'es', subTypeConstructor: KalturaEntryType, subType: 'KalturaEntryType' },
            typeIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            totalRankLessThanOrEqual: { type: 'n' },
            totalRankGreaterThanOrEqual: { type: 'n' },
            groupIdEqual: { type: 'n' },
            searchTextMatchAnd: { type: 's' },
            searchTextMatchOr: { type: 's' },
            accessControlIdEqual: { type: 'n' },
            accessControlIdIn: { type: 's' },
            startDateGreaterThanOrEqual: { type: 'd' },
            startDateLessThanOrEqual: { type: 'd' },
            startDateGreaterThanOrEqualOrNull: { type: 'd' },
            startDateLessThanOrEqualOrNull: { type: 'd' },
            endDateGreaterThanOrEqual: { type: 'd' },
            endDateLessThanOrEqual: { type: 'd' },
            endDateGreaterThanOrEqualOrNull: { type: 'd' },
            endDateLessThanOrEqualOrNull: { type: 'd' },
            referenceIdEqual: { type: 's' },
            referenceIdIn: { type: 's' },
            replacingEntryIdEqual: { type: 's' },
            replacingEntryIdIn: { type: 's' },
            replacedEntryIdEqual: { type: 's' },
            replacedEntryIdIn: { type: 's' },
            replacementStatusEqual: { type: 'es', subTypeConstructor: KalturaEntryReplacementStatus, subType: 'KalturaEntryReplacementStatus' },
            replacementStatusIn: { type: 's' },
            partnerSortValueGreaterThanOrEqual: { type: 'n' },
            partnerSortValueLessThanOrEqual: { type: 'n' },
            rootEntryIdEqual: { type: 's' },
            rootEntryIdIn: { type: 's' },
            parentEntryIdEqual: { type: 's' },
            entitledUsersEditMatchAnd: { type: 's' },
            entitledUsersEditMatchOr: { type: 's' },
            entitledUsersPublishMatchAnd: { type: 's' },
            entitledUsersPublishMatchOr: { type: 's' },
            entitledUsersViewMatchAnd: { type: 's' },
            entitledUsersViewMatchOr: { type: 's' },
            tagsNameMultiLikeOr: { type: 's' },
            tagsAdminTagsMultiLikeOr: { type: 's' },
            tagsAdminTagsNameMultiLikeOr: { type: 's' },
            tagsNameMultiLikeAnd: { type: 's' },
            tagsAdminTagsMultiLikeAnd: { type: 's' },
            tagsAdminTagsNameMultiLikeAnd: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBaseEntryBaseFilter'] = KalturaBaseEntryBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBaseEntryFilter extends KalturaBaseEntryBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBaseEntryFilter' },
            freeText: { type: 's' },
            isRoot: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            categoriesFullNameIn: { type: 's' },
            categoryAncestorIdIn: { type: 's' },
            redirectFromEntryId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBaseEntryFilter'] = KalturaBaseEntryFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayableEntryBaseFilter extends KalturaBaseEntryFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayableEntryBaseFilter' },
            lastPlayedAtGreaterThanOrEqual: { type: 'd' },
            lastPlayedAtLessThanOrEqual: { type: 'd' },
            durationLessThan: { type: 'n' },
            durationGreaterThan: { type: 'n' },
            durationLessThanOrEqual: { type: 'n' },
            durationGreaterThanOrEqual: { type: 'n' },
            durationTypeMatchOr: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayableEntryBaseFilter'] = KalturaPlayableEntryBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayableEntryFilter extends KalturaPlayableEntryBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayableEntryFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayableEntryFilter'] = KalturaPlayableEntryFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaEntryBaseFilter extends KalturaPlayableEntryFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaEntryBaseFilter' },
            mediaTypeEqual: { type: 'en', subTypeConstructor: KalturaMediaType, subType: 'KalturaMediaType' },
            mediaTypeIn: { type: 's' },
            sourceTypeEqual: { type: 'es', subTypeConstructor: KalturaSourceType, subType: 'KalturaSourceType' },
            sourceTypeNotEqual: { type: 'es', subTypeConstructor: KalturaSourceType, subType: 'KalturaSourceType' },
            sourceTypeIn: { type: 's' },
            sourceTypeNotIn: { type: 's' },
            mediaDateGreaterThanOrEqual: { type: 'd' },
            mediaDateLessThanOrEqual: { type: 'd' },
            flavorParamsIdsMatchOr: { type: 's' },
            flavorParamsIdsMatchAnd: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaEntryBaseFilter'] = KalturaMediaEntryBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaEntryFilter extends KalturaMediaEntryBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaEntryFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaEntryFilter'] = KalturaMediaEntryFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaEntryFilterForPlaylist extends KalturaMediaEntryFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaEntryFilterForPlaylist' },
            limit: { type: 'n' },
            name: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaEntryFilterForPlaylist'] = KalturaMediaEntryFilterForPlaylist;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaMetadataObjectType = {
    adCuePoint: 'adCuePointMetadata.AdCuePoint',
    annotation: 'annotationMetadata.Annotation',
    answerCuePoint: 'quiz.AnswerCuePoint',
    category: '2',
    codeCuePoint: 'codeCuePointMetadata.CodeCuePoint',
    dynamicObject: '5',
    entry: '1',
    partner: '4',
    questionCuePoint: 'quiz.QuestionCuePoint',
    thumbCuePoint: 'thumbCuePointMetadata.thumbCuePoint',
    user: '3',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaMetadataStatus = {
    deleted: 3,
    invalid: 2,
    valid: 1,
};
KalturaMetadataStatus[KalturaMetadataStatus.deleted] = 'deleted';
KalturaMetadataStatus[KalturaMetadataStatus.invalid] = 'invalid';
KalturaMetadataStatus[KalturaMetadataStatus.valid] = 'valid';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetadata extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetadata' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            metadataProfileId: { type: 'n', readOnly: true },
            metadataProfileVersion: { type: 'n', readOnly: true },
            metadataObjectType: { type: 'es', readOnly: true, subTypeConstructor: KalturaMetadataObjectType, subType: 'KalturaMetadataObjectType' },
            objectId: { type: 's', readOnly: true },
            version: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaMetadataStatus, subType: 'KalturaMetadataStatus' },
            xml: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetadata'] = KalturaMetadata;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaMetadataProfileStatus = {
    active: 1,
    deprecated: 2,
    transforming: 3,
};
KalturaMetadataProfileStatus[KalturaMetadataProfileStatus.active] = 'active';
KalturaMetadataProfileStatus[KalturaMetadataProfileStatus.deprecated] = 'deprecated';
KalturaMetadataProfileStatus[KalturaMetadataProfileStatus.transforming] = 'transforming';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaMetadataProfileCreateMode = {
    api: 1,
    app: 3,
    kmc: 2,
};
KalturaMetadataProfileCreateMode[KalturaMetadataProfileCreateMode.api] = 'api';
KalturaMetadataProfileCreateMode[KalturaMetadataProfileCreateMode.app] = 'app';
KalturaMetadataProfileCreateMode[KalturaMetadataProfileCreateMode.kmc] = 'kmc';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetadataProfile extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetadataProfile' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            metadataObjectType: { type: 'es', subTypeConstructor: KalturaMetadataObjectType, subType: 'KalturaMetadataObjectType' },
            version: { type: 'n', readOnly: true },
            name: { type: 's' },
            systemName: { type: 's' },
            description: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaMetadataProfileStatus, subType: 'KalturaMetadataProfileStatus' },
            xsd: { type: 's', readOnly: true },
            views: { type: 's', readOnly: true },
            xslt: { type: 's', readOnly: true },
            createMode: { type: 'en', subTypeConstructor: KalturaMetadataProfileCreateMode, subType: 'KalturaMetadataProfileCreateMode' },
            disableReIndexing: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetadataProfile'] = KalturaMetadataProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetadataProfileField extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetadataProfileField' },
            id: { type: 'n', readOnly: true },
            xPath: { type: 's', readOnly: true },
            key: { type: 's', readOnly: true },
            label: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetadataProfileField'] = KalturaMetadataProfileField;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaEditorType = {
    advanced: 2,
    simple: 1,
};
KalturaEditorType[KalturaEditorType.advanced] = 'advanced';
KalturaEditorType[KalturaEditorType.simple] = 'simple';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMixEntry extends KalturaPlayableEntry {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMixEntry' },
            hasRealThumbnail: { type: 'b', readOnly: true },
            editorType: { type: 'en', subTypeConstructor: KalturaEditorType, subType: 'KalturaEditorType' },
            dataContent: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMixEntry'] = KalturaMixEntry;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaModerationObjectType = {
    entry: '2',
    user: '3',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaModerationFlagStatus = {
    moderated: '2',
    pending: '1',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaModerationFlagType = {
    copyright: 5,
    harmfulDangerous: 3,
    sexualContent: 1,
    spamCommercials: 4,
    termsOfUseViolation: 6,
    violentRepulsive: 2,
};
KalturaModerationFlagType[KalturaModerationFlagType.copyright] = 'copyright';
KalturaModerationFlagType[KalturaModerationFlagType.harmfulDangerous] = 'harmfulDangerous';
KalturaModerationFlagType[KalturaModerationFlagType.sexualContent] = 'sexualContent';
KalturaModerationFlagType[KalturaModerationFlagType.spamCommercials] = 'spamCommercials';
KalturaModerationFlagType[KalturaModerationFlagType.termsOfUseViolation] = 'termsOfUseViolation';
KalturaModerationFlagType[KalturaModerationFlagType.violentRepulsive] = 'violentRepulsive';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaModerationFlag extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaModerationFlag' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            userId: { type: 's', readOnly: true },
            moderationObjectType: { type: 'es', readOnly: true, subTypeConstructor: KalturaModerationObjectType, subType: 'KalturaModerationObjectType' },
            flaggedEntryId: { type: 's' },
            flaggedUserId: { type: 's' },
            status: { type: 'es', readOnly: true, subTypeConstructor: KalturaModerationFlagStatus, subType: 'KalturaModerationFlagStatus' },
            comments: { type: 's' },
            flagType: { type: 'en', subTypeConstructor: KalturaModerationFlagType, subType: 'KalturaModerationFlagType' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaModerationFlag'] = KalturaModerationFlag;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaObjectTaskType = {
    convertEntryFlavors: '4',
    deleteEntry: '1',
    deleteEntryFlavors: '3',
    deleteLocalContent: '5',
    dispatchEventNotification: 'scheduledTaskEventNotification.DispatchEventNotification',
    distribute: 'scheduledTaskContentDistribution.Distribute',
    executeMetadataXslt: 'scheduledTaskMetadata.ExecuteMetadataXslt',
    mailNotification: '8',
    modifyCategories: '2',
    modifyEntry: '7',
    storageExport: '6',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaObjectTask extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaObjectTask' },
            type: { type: 'es', readOnly: true, subTypeConstructor: KalturaObjectTaskType, subType: 'KalturaObjectTaskType' },
            stopProcessingOnError: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaObjectTask'] = KalturaObjectTask;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaOptionalAnswer extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaOptionalAnswer' },
            key: { type: 's' },
            text: { type: 's' },
            weight: { type: 'n' },
            isCorrect: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaOptionalAnswer'] = KalturaOptionalAnswer;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPartnerStatistics extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPartnerStatistics' },
            packageBandwidthAndStorage: { type: 'n', readOnly: true },
            hosting: { type: 'n', readOnly: true },
            bandwidth: { type: 'n', readOnly: true },
            usage: { type: 'n', readOnly: true },
            usagePercent: { type: 'n', readOnly: true },
            reachedLimitDate: { type: 'n', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaPartnerStatistics'] = KalturaPartnerStatistics;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPartnerUsage extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPartnerUsage' },
            hostingGB: { type: 'n', readOnly: true },
            Percent: { type: 'n', readOnly: true },
            packageBW: { type: 'n', readOnly: true },
            usageGB: { type: 'n', readOnly: true },
            reachedLimitDate: { type: 'n', readOnly: true },
            usageGraph: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaPartnerUsage'] = KalturaPartnerUsage;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaPermissionType = {
    normal: 1,
    partnerGroup: 4,
    plugin: 3,
    specialFeature: 2,
};
KalturaPermissionType[KalturaPermissionType.normal] = 'normal';
KalturaPermissionType[KalturaPermissionType.partnerGroup] = 'partnerGroup';
KalturaPermissionType[KalturaPermissionType.plugin] = 'plugin';
KalturaPermissionType[KalturaPermissionType.specialFeature] = 'specialFeature';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaPermissionStatus = {
    active: 1,
    blocked: 2,
    deleted: 3,
};
KalturaPermissionStatus[KalturaPermissionStatus.active] = 'active';
KalturaPermissionStatus[KalturaPermissionStatus.blocked] = 'blocked';
KalturaPermissionStatus[KalturaPermissionStatus.deleted] = 'deleted';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPermission extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPermission' },
            id: { type: 'n', readOnly: true },
            type: { type: 'en', readOnly: true, subTypeConstructor: KalturaPermissionType, subType: 'KalturaPermissionType' },
            name: { type: 's' },
            friendlyName: { type: 's' },
            description: { type: 's' },
            status: { type: 'en', subTypeConstructor: KalturaPermissionStatus, subType: 'KalturaPermissionStatus' },
            partnerId: { type: 'n', readOnly: true },
            dependsOnPermissionNames: { type: 's' },
            tags: { type: 's' },
            permissionItemsIds: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            partnerGroup: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPermission'] = KalturaPermission;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPermissionItemType = {
    apiActionItem: 'kApiActionPermissionItem',
    apiParameterItem: 'kApiParameterPermissionItem',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPermissionItem extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPermissionItem' },
            id: { type: 'n', readOnly: true },
            type: { type: 'es', readOnly: true, subTypeConstructor: KalturaPermissionItemType, subType: 'KalturaPermissionItemType' },
            partnerId: { type: 'n', readOnly: true },
            tags: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaPermissionItem'] = KalturaPermissionItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPlayReadyAnalogVideoOPId = {
    agcAndColorStripe: 'C3FD11C6-F8B7-4D20-B008-1DB17D61F2DA',
    bestEffortExplicitAnalogTv: '225CD36F-F132-49EF-BA8C-C91EA28E4369',
    explicitAnalogTv: '2098DE8D-7DDD-4BAB-96C6-32EBB6FABEA3',
    imageConstraintMonitor: 'D783A191-E083-4BAF-B2DA-E69F910B3772',
    imageConstraintVideo: '811C5110-46C8-4C6E-8163-C0482A15D47E',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayReadyAnalogVideoOPIdHolder extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayReadyAnalogVideoOPIdHolder' },
            type: { type: 'es', subTypeConstructor: KalturaPlayReadyAnalogVideoOPId, subType: 'KalturaPlayReadyAnalogVideoOPId' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayReadyAnalogVideoOPIdHolder'] = KalturaPlayReadyAnalogVideoOPIdHolder;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayReadyContentKey extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayReadyContentKey' },
            keyId: { type: 's' },
            contentKey: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayReadyContentKey'] = KalturaPlayReadyContentKey;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPlayReadyCopyEnablerType = {
    aacs: 'C3CF56E0-7FF2-4491-809F-53E21D3ABF07',
    clipboard: '6E76C588-C3A9-47ea-A875-546D5209FF38',
    cprm: 'CDD801AD-A577-48DB-950E-46D5F1592FAE',
    css: '3CAF2814-A7AB-467C-B4DF-54ACC56C66DC',
    device: '6848955D-516B-4EB0-90E8-8F6D5A77B85F',
    helix: 'CCB0B4E3-8B46-409e-A998-82556E3F5AF4',
    orangeBookCd: 'EC930B7D-1F2D-4682-A38B-8AB977721D0D',
    pc: 'CE480EDE-516B-40B3-90E1-D6CFC47630C5',
    printer: '3CF2E054-F4D5-46cd-85A6-FCD152AD5FBE',
    sdc: '79F78A0D-0B69-401e-8A90-8BEF30BCE192',
    sdcLimited: 'E6785609-64CC-4bfa-B82D-6B619733B746',
    sdcPreview: '81BD9AD4-A720-4ea1-B510-5D4E6FFB6A4D',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayReadyCopyEnablerHolder extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayReadyCopyEnablerHolder' },
            type: { type: 'es', subTypeConstructor: KalturaPlayReadyCopyEnablerType, subType: 'KalturaPlayReadyCopyEnablerType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayReadyCopyEnablerHolder'] = KalturaPlayReadyCopyEnablerHolder;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPlayReadyDigitalAudioOPId = {
    scms: '6D5CFA59-C250-4426-930E-FAC72C8FCFA6',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayReadyDigitalAudioOPIdHolder extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayReadyDigitalAudioOPIdHolder' },
            type: { type: 'es', subTypeConstructor: KalturaPlayReadyDigitalAudioOPId, subType: 'KalturaPlayReadyDigitalAudioOPId' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayReadyDigitalAudioOPIdHolder'] = KalturaPlayReadyDigitalAudioOPIdHolder;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayReadyRight extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayReadyRight' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayReadyRight'] = KalturaPlayReadyRight;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaPlayReadyLicenseRemovalPolicy = {
    entrySchedulingEnd: 2,
    fixedFromExpiration: 1,
    none: 3,
};
KalturaPlayReadyLicenseRemovalPolicy[KalturaPlayReadyLicenseRemovalPolicy.entrySchedulingEnd] = 'entrySchedulingEnd';
KalturaPlayReadyLicenseRemovalPolicy[KalturaPlayReadyLicenseRemovalPolicy.fixedFromExpiration] = 'fixedFromExpiration';
KalturaPlayReadyLicenseRemovalPolicy[KalturaPlayReadyLicenseRemovalPolicy.none] = 'none';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaPlayReadyMinimumLicenseSecurityLevel = {
    commercialQuality: 2000,
    nonCommercialQuality: 150,
};
KalturaPlayReadyMinimumLicenseSecurityLevel[KalturaPlayReadyMinimumLicenseSecurityLevel.commercialQuality] = 'commercialQuality';
KalturaPlayReadyMinimumLicenseSecurityLevel[KalturaPlayReadyMinimumLicenseSecurityLevel.nonCommercialQuality] = 'nonCommercialQuality';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayReadyPolicy extends KalturaDrmPolicy {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.rights === 'undefined')
            this.rights = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayReadyPolicy' },
            gracePeriod: { type: 'n' },
            licenseRemovalPolicy: { type: 'en', subTypeConstructor: KalturaPlayReadyLicenseRemovalPolicy, subType: 'KalturaPlayReadyLicenseRemovalPolicy' },
            licenseRemovalDuration: { type: 'n' },
            minSecurityLevel: { type: 'en', subTypeConstructor: KalturaPlayReadyMinimumLicenseSecurityLevel, subType: 'KalturaPlayReadyMinimumLicenseSecurityLevel' },
            rights: { type: 'a', subTypeConstructor: KalturaPlayReadyRight, subType: 'KalturaPlayReadyRight' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayReadyPolicy'] = KalturaPlayReadyPolicy;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayReadyLicenseDetails extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayReadyLicenseDetails' },
            policy: { type: 'o', subTypeConstructor: KalturaPlayReadyPolicy, subType: 'KalturaPlayReadyPolicy' },
            beginDate: { type: 'n' },
            expirationDate: { type: 'n' },
            removalDate: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayReadyLicenseDetails'] = KalturaPlayReadyLicenseDetails;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPlayReadyPlayEnablerType = {
    airplay: '5ABF0F0D-DC29-4B82-9982-FD8E57525BFC',
    dtcp: 'D685030B-0F4F-43A6-BBAD-356F1EA0049A',
    hdcpMiracast: 'A340C256-0941-4D4C-AD1D-0B6735C0CB24',
    hdcpWivu: '1B4542E3-B5CF-4C99-B3BA-829AF46C92F8',
    helix: '002F9772-38A0-43E5-9F79-0F6361DCC62A',
    unknown: '786627D8-C2A6-44BE-8F88-08AE255B01A',
    unknown520: 'B621D91F-EDCC-4035-8D4B-DC71760D43E9',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayReadyPlayEnablerHolder extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayReadyPlayEnablerHolder' },
            type: { type: 'es', subTypeConstructor: KalturaPlayReadyPlayEnablerType, subType: 'KalturaPlayReadyPlayEnablerType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayReadyPlayEnablerHolder'] = KalturaPlayReadyPlayEnablerHolder;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlaybackSource extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.drm === 'undefined')
            this.drm = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlaybackSource' },
            deliveryProfileId: { type: 's' },
            format: { type: 's' },
            protocols: { type: 's' },
            flavorIds: { type: 's' },
            url: { type: 's' },
            drm: { type: 'a', subTypeConstructor: KalturaDrmPlaybackPluginData, subType: 'KalturaDrmPlaybackPluginData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlaybackSource'] = KalturaPlaybackSource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlaybackContext extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.sources === 'undefined')
            this.sources = [];
        if (typeof this.flavorAssets === 'undefined')
            this.flavorAssets = [];
        if (typeof this.actions === 'undefined')
            this.actions = [];
        if (typeof this.messages === 'undefined')
            this.messages = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlaybackContext' },
            sources: { type: 'a', subTypeConstructor: KalturaPlaybackSource, subType: 'KalturaPlaybackSource' },
            flavorAssets: { type: 'a', subTypeConstructor: KalturaFlavorAsset, subType: 'KalturaFlavorAsset' },
            actions: { type: 'a', subTypeConstructor: KalturaRuleAction, subType: 'KalturaRuleAction' },
            messages: { type: 'a', subTypeConstructor: KalturaAccessControlMessage, subType: 'KalturaAccessControlMessage' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlaybackContext'] = KalturaPlaybackContext;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaPlaylistType = {
    dynamic: 10,
    external: 101,
    staticList: 3,
};
KalturaPlaylistType[KalturaPlaylistType.dynamic] = 'dynamic';
KalturaPlaylistType[KalturaPlaylistType.external] = 'external';
KalturaPlaylistType[KalturaPlaylistType.staticList] = 'staticList';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlaylist extends KalturaBaseEntry {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.filters === 'undefined')
            this.filters = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlaylist' },
            playlistContent: { type: 's' },
            filters: { type: 'a', subTypeConstructor: KalturaMediaEntryFilterForPlaylist, subType: 'KalturaMediaEntryFilterForPlaylist' },
            totalResults: { type: 'n' },
            playlistType: { type: 'en', subTypeConstructor: KalturaPlaylistType, subType: 'KalturaPlaylistType' },
            plays: { type: 'n', readOnly: true },
            views: { type: 'n', readOnly: true },
            duration: { type: 'n', readOnly: true },
            executeUrl: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlaylist'] = KalturaPlaylist;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPushEventNotificationParameter extends KalturaEventNotificationParameter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPushEventNotificationParameter' },
            queueKeyToken: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPushEventNotificationParameter'] = KalturaPushEventNotificationParameter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPushNotificationData extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPushNotificationData' },
            queueName: { type: 's', readOnly: true },
            queueKey: { type: 's', readOnly: true },
            url: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaPushNotificationData'] = KalturaPushNotificationData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPushNotificationParams extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.userParams === 'undefined')
            this.userParams = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPushNotificationParams' },
            userParams: { type: 'a', subTypeConstructor: KalturaPushEventNotificationParameter, subType: 'KalturaPushEventNotificationParameter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPushNotificationParams'] = KalturaPushNotificationParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaQuiz extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.uiAttributes === 'undefined')
            this.uiAttributes = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaQuiz' },
            version: { type: 'n', readOnly: true },
            uiAttributes: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            showResultOnAnswer: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            showCorrectKeyOnAnswer: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            allowAnswerUpdate: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            showCorrectAfterSubmission: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            allowDownload: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            showGradeAfterSubmission: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaQuiz'] = KalturaQuiz;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRemotePath extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRemotePath' },
            storageProfileId: { type: 'n', readOnly: true },
            uri: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaRemotePath'] = KalturaRemotePath;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlResource extends KalturaContentResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlResource' },
            url: { type: 's' },
            forceAsyncDownload: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlResource'] = KalturaUrlResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRemoteStorageResource extends KalturaUrlResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRemoteStorageResource' },
            storageProfileId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaRemoteStorageResource'] = KalturaRemoteStorageResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaReport extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaReport' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n' },
            name: { type: 's' },
            systemName: { type: 's' },
            description: { type: 's' },
            query: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaReport'] = KalturaReport;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaReportBaseTotal extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaReportBaseTotal' },
            id: { type: 's' },
            data: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaReportBaseTotal'] = KalturaReportBaseTotal;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaReportGraph extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaReportGraph' },
            id: { type: 's' },
            data: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaReportGraph'] = KalturaReportGraph;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaReportInputBaseFilter extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaReportInputBaseFilter' },
            fromDate: { type: 'n' },
            toDate: { type: 'n' },
            fromDay: { type: 's' },
            toDay: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaReportInputBaseFilter'] = KalturaReportInputBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaReportResponse extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.results === 'undefined')
            this.results = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaReportResponse' },
            columns: { type: 's' },
            results: { type: 'a', subTypeConstructor: KalturaString, subType: 'KalturaString' }
        });
        return result;
    }
}
typesMappingStorage['KalturaReportResponse'] = KalturaReportResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaReportTable extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaReportTable' },
            header: { type: 's', readOnly: true },
            data: { type: 's', readOnly: true },
            totalCount: { type: 'n', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaReportTable'] = KalturaReportTable;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaReportTotal extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaReportTotal' },
            header: { type: 's' },
            data: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaReportTotal'] = KalturaReportTotal;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRequestConfiguration extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRequestConfiguration' },
            partnerId: { type: 'n' },
            ks: { type: 's' },
            responseProfile: { type: 'o', subTypeConstructor: KalturaBaseResponseProfile, subType: 'KalturaBaseResponseProfile' }
        });
        return result;
    }
}
typesMappingStorage['KalturaRequestConfiguration'] = KalturaRequestConfiguration;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaResponseProfileStatus = {
    deleted: 3,
    disabled: 1,
    enabled: 2,
};
KalturaResponseProfileStatus[KalturaResponseProfileStatus.deleted] = 'deleted';
KalturaResponseProfileStatus[KalturaResponseProfileStatus.disabled] = 'disabled';
KalturaResponseProfileStatus[KalturaResponseProfileStatus.enabled] = 'enabled';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaResponseProfile extends KalturaDetachedResponseProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaResponseProfile' },
            id: { type: 'n', readOnly: true },
            systemName: { type: 's' },
            partnerId: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaResponseProfileStatus, subType: 'KalturaResponseProfileStatus' },
            version: { type: 'n', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaResponseProfile'] = KalturaResponseProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaResponseProfileCacheRecalculateOptions extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaResponseProfileCacheRecalculateOptions' },
            limit: { type: 'n' },
            cachedObjectType: { type: 's' },
            objectId: { type: 's' },
            startObjectKey: { type: 's' },
            endObjectKey: { type: 's' },
            jobCreatedAt: { type: 'd' },
            isFirstLoop: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaResponseProfileCacheRecalculateOptions'] = KalturaResponseProfileCacheRecalculateOptions;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaResponseProfileCacheRecalculateResults extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaResponseProfileCacheRecalculateResults' },
            lastObjectKey: { type: 's' },
            recalculated: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaResponseProfileCacheRecalculateResults'] = KalturaResponseProfileCacheRecalculateResults;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaScheduleEventRecurrenceFrequency = {
    daily: 'days',
    hourly: 'hours',
    minutely: 'minutes',
    monthly: 'months',
    secondly: 'seconds',
    weekly: 'weeks',
    yearly: 'years',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaScheduleEventRecurrenceDay = {
    friday: 'FR',
    monday: 'MO',
    saturday: 'SA',
    sunday: 'SU',
    thursday: 'TH',
    tuesday: 'TU',
    wednesday: 'WE',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduleEventRecurrence extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduleEventRecurrence' },
            name: { type: 's' },
            frequency: { type: 'es', subTypeConstructor: KalturaScheduleEventRecurrenceFrequency, subType: 'KalturaScheduleEventRecurrenceFrequency' },
            until: { type: 'd' },
            timeZone: { type: 's' },
            count: { type: 'n' },
            interval: { type: 'n' },
            bySecond: { type: 's' },
            byMinute: { type: 's' },
            byHour: { type: 's' },
            byDay: { type: 's' },
            byMonthDay: { type: 's' },
            byYearDay: { type: 's' },
            byWeekNumber: { type: 's' },
            byMonth: { type: 's' },
            byOffset: { type: 's' },
            weekStartDay: { type: 'es', subTypeConstructor: KalturaScheduleEventRecurrenceDay, subType: 'KalturaScheduleEventRecurrenceDay' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduleEventRecurrence'] = KalturaScheduleEventRecurrence;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaScheduleEventStatus = {
    active: 2,
    cancelled: 1,
    deleted: 3,
};
KalturaScheduleEventStatus[KalturaScheduleEventStatus.active] = 'active';
KalturaScheduleEventStatus[KalturaScheduleEventStatus.cancelled] = 'cancelled';
KalturaScheduleEventStatus[KalturaScheduleEventStatus.deleted] = 'deleted';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaScheduleEventClassificationType = {
    confidentialEvent: 3,
    privateEvent: 2,
    publicEvent: 1,
};
KalturaScheduleEventClassificationType[KalturaScheduleEventClassificationType.confidentialEvent] = 'confidentialEvent';
KalturaScheduleEventClassificationType[KalturaScheduleEventClassificationType.privateEvent] = 'privateEvent';
KalturaScheduleEventClassificationType[KalturaScheduleEventClassificationType.publicEvent] = 'publicEvent';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaScheduleEventRecurrenceType = {
    none: 0,
    recurrence: 2,
    recurring: 1,
};
KalturaScheduleEventRecurrenceType[KalturaScheduleEventRecurrenceType.none] = 'none';
KalturaScheduleEventRecurrenceType[KalturaScheduleEventRecurrenceType.recurrence] = 'recurrence';
KalturaScheduleEventRecurrenceType[KalturaScheduleEventRecurrenceType.recurring] = 'recurring';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduleEvent extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduleEvent' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            parentId: { type: 'n', readOnly: true },
            summary: { type: 's' },
            description: { type: 's' },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaScheduleEventStatus, subType: 'KalturaScheduleEventStatus' },
            startDate: { type: 'd' },
            endDate: { type: 'd' },
            referenceId: { type: 's' },
            classificationType: { type: 'en', subTypeConstructor: KalturaScheduleEventClassificationType, subType: 'KalturaScheduleEventClassificationType' },
            geoLatitude: { type: 'n' },
            geoLongitude: { type: 'n' },
            location: { type: 's' },
            organizer: { type: 's' },
            ownerId: { type: 's' },
            priority: { type: 'n' },
            sequence: { type: 'n' },
            recurrenceType: { type: 'en', subTypeConstructor: KalturaScheduleEventRecurrenceType, subType: 'KalturaScheduleEventRecurrenceType' },
            duration: { type: 'n' },
            contact: { type: 's' },
            comment: { type: 's' },
            tags: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            recurrence: { type: 'o', subTypeConstructor: KalturaScheduleEventRecurrence, subType: 'KalturaScheduleEventRecurrence' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduleEvent'] = KalturaScheduleEvent;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduleEventResource extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduleEventResource' },
            eventId: { type: 'n' },
            resourceId: { type: 'n' },
            partnerId: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduleEventResource'] = KalturaScheduleEventResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaScheduleResourceStatus = {
    active: 2,
    deleted: 3,
    disabled: 1,
};
KalturaScheduleResourceStatus[KalturaScheduleResourceStatus.active] = 'active';
KalturaScheduleResourceStatus[KalturaScheduleResourceStatus.deleted] = 'deleted';
KalturaScheduleResourceStatus[KalturaScheduleResourceStatus.disabled] = 'disabled';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduleResource extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduleResource' },
            id: { type: 'n', readOnly: true },
            parentId: { type: 'n' },
            partnerId: { type: 'n', readOnly: true },
            name: { type: 's' },
            systemName: { type: 's' },
            description: { type: 's' },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaScheduleResourceStatus, subType: 'KalturaScheduleResourceStatus' },
            tags: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduleResource'] = KalturaScheduleResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaScheduledTaskProfileStatus = {
    active: 2,
    deleted: 3,
    disabled: 1,
    dryRunOnly: 5,
    suspended: 4,
};
KalturaScheduledTaskProfileStatus[KalturaScheduledTaskProfileStatus.active] = 'active';
KalturaScheduledTaskProfileStatus[KalturaScheduledTaskProfileStatus.deleted] = 'deleted';
KalturaScheduledTaskProfileStatus[KalturaScheduledTaskProfileStatus.disabled] = 'disabled';
KalturaScheduledTaskProfileStatus[KalturaScheduledTaskProfileStatus.dryRunOnly] = 'dryRunOnly';
KalturaScheduledTaskProfileStatus[KalturaScheduledTaskProfileStatus.suspended] = 'suspended';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaObjectFilterEngineType = {
    entry: '1',
    entryVendorTask: '2',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduledTaskProfile extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objectTasks === 'undefined')
            this.objectTasks = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduledTaskProfile' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            name: { type: 's' },
            systemName: { type: 's' },
            description: { type: 's' },
            status: { type: 'en', subTypeConstructor: KalturaScheduledTaskProfileStatus, subType: 'KalturaScheduledTaskProfileStatus' },
            objectFilterEngineType: { type: 'es', subTypeConstructor: KalturaObjectFilterEngineType, subType: 'KalturaObjectFilterEngineType' },
            objectFilter: { type: 'o', subTypeConstructor: KalturaFilter, subType: 'KalturaFilter' },
            objectTasks: { type: 'a', subTypeConstructor: KalturaObjectTask, subType: 'KalturaObjectTask' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            lastExecutionStartedAt: { type: 'd' },
            maxTotalCountAllowed: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduledTaskProfile'] = KalturaScheduledTaskProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScope extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScope' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScope'] = KalturaScope;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSearch extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSearch' },
            keyWords: { type: 's' },
            searchSource: { type: 'en', subTypeConstructor: KalturaSearchProviderType, subType: 'KalturaSearchProviderType' },
            mediaType: { type: 'en', subTypeConstructor: KalturaMediaType, subType: 'KalturaMediaType' },
            extraData: { type: 's' },
            authData: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSearch'] = KalturaSearch;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSearchAuthData extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSearchAuthData' },
            authData: { type: 's' },
            loginUrl: { type: 's' },
            message: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSearchAuthData'] = KalturaSearchAuthData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSearchResult extends KalturaSearch {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSearchResult' },
            id: { type: 's' },
            title: { type: 's' },
            thumbUrl: { type: 's' },
            description: { type: 's' },
            tags: { type: 's' },
            url: { type: 's' },
            sourceLink: { type: 's' },
            credit: { type: 's' },
            licenseType: { type: 'en', subTypeConstructor: KalturaLicenseType, subType: 'KalturaLicenseType' },
            flashPlaybackType: { type: 's' },
            fileExt: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSearchResult'] = KalturaSearchResult;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSearchResultResponse extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSearchResultResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaSearchResult, subType: 'KalturaSearchResult' },
            needMediaInfo: { type: 'b', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaSearchResultResponse'] = KalturaSearchResultResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaServerNodeStatus = {
    active: 1,
    deleted: 3,
    disabled: 2,
    notOperational: 5,
    notRegistered: 4,
};
KalturaServerNodeStatus[KalturaServerNodeStatus.active] = 'active';
KalturaServerNodeStatus[KalturaServerNodeStatus.deleted] = 'deleted';
KalturaServerNodeStatus[KalturaServerNodeStatus.disabled] = 'disabled';
KalturaServerNodeStatus[KalturaServerNodeStatus.notOperational] = 'notOperational';
KalturaServerNodeStatus[KalturaServerNodeStatus.notRegistered] = 'notRegistered';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaServerNodeType = {
    edge: '1',
    wowzaMediaServer: 'wowza.WOWZA_MEDIA_SERVER',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaServerNode extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaServerNode' },
            id: { type: 'n', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            heartbeatTime: { type: 'd', readOnly: true },
            name: { type: 's' },
            systemName: { type: 's' },
            description: { type: 's' },
            hostName: { type: 's' },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaServerNodeStatus, subType: 'KalturaServerNodeStatus' },
            type: { type: 'es', readOnly: true, subTypeConstructor: KalturaServerNodeType, subType: 'KalturaServerNodeType' },
            tags: { type: 's' },
            dc: { type: 'n', readOnly: true },
            parentId: { type: 's' },
            environment: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaServerNode'] = KalturaServerNode;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSessionInfo extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSessionInfo' },
            ks: { type: 's', readOnly: true },
            sessionType: { type: 'en', readOnly: true, subTypeConstructor: KalturaSessionType, subType: 'KalturaSessionType' },
            partnerId: { type: 'n', readOnly: true },
            userId: { type: 's', readOnly: true },
            expiry: { type: 'n', readOnly: true },
            privileges: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaSessionInfo'] = KalturaSessionInfo;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaShortLinkStatus = {
    deleted: 3,
    disabled: 1,
    enabled: 2,
};
KalturaShortLinkStatus[KalturaShortLinkStatus.deleted] = 'deleted';
KalturaShortLinkStatus[KalturaShortLinkStatus.disabled] = 'disabled';
KalturaShortLinkStatus[KalturaShortLinkStatus.enabled] = 'enabled';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaShortLink extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaShortLink' },
            id: { type: 's', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            expiresAt: { type: 'n' },
            partnerId: { type: 'n', readOnly: true },
            userId: { type: 's' },
            name: { type: 's' },
            systemName: { type: 's' },
            fullUrl: { type: 's' },
            status: { type: 'en', subTypeConstructor: KalturaShortLinkStatus, subType: 'KalturaShortLinkStatus' }
        });
        return result;
    }
}
typesMappingStorage['KalturaShortLink'] = KalturaShortLink;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSourceFileSyncDescriptor extends KalturaFileSyncDescriptor {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSourceFileSyncDescriptor' },
            actualFileSyncLocalPath: { type: 's' },
            assetId: { type: 's' },
            assetParamsId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSourceFileSyncDescriptor'] = KalturaSourceFileSyncDescriptor;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaStartWidgetSessionResponse extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaStartWidgetSessionResponse' },
            partnerId: { type: 'n', readOnly: true },
            ks: { type: 's', readOnly: true },
            userId: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaStartWidgetSessionResponse'] = KalturaStartWidgetSessionResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaStatsEventType = {
    bufferEnd: 13,
    bufferStart: 12,
    bumperClicked: 23,
    closeEditor: 20,
    closeFullScreen: 15,
    mediaLoaded: 2,
    midroll25: 35,
    midroll50: 36,
    midroll75: 37,
    midrollClicked: 29,
    midrollStarted: 25,
    openDownload: 10,
    openEdit: 8,
    openFullScreen: 14,
    openReport: 11,
    openUpload: 18,
    openViral: 9,
    overlayClicked: 31,
    overlayStarted: 27,
    play: 3,
    playReached100: 7,
    playReached25: 4,
    playReached50: 5,
    playReached75: 6,
    postroll25: 38,
    postroll50: 39,
    postroll75: 40,
    postrollClicked: 30,
    postrollStarted: 26,
    postBumperPlayed: 22,
    preroll25: 32,
    preroll50: 33,
    preroll75: 34,
    prerollClicked: 28,
    prerollStarted: 24,
    preBumperPlayed: 21,
    replay: 16,
    savePublish: 19,
    seek: 17,
    widgetLoaded: 1,
};
KalturaStatsEventType[KalturaStatsEventType.bufferEnd] = 'bufferEnd';
KalturaStatsEventType[KalturaStatsEventType.bufferStart] = 'bufferStart';
KalturaStatsEventType[KalturaStatsEventType.bumperClicked] = 'bumperClicked';
KalturaStatsEventType[KalturaStatsEventType.closeEditor] = 'closeEditor';
KalturaStatsEventType[KalturaStatsEventType.closeFullScreen] = 'closeFullScreen';
KalturaStatsEventType[KalturaStatsEventType.mediaLoaded] = 'mediaLoaded';
KalturaStatsEventType[KalturaStatsEventType.midroll25] = 'midroll25';
KalturaStatsEventType[KalturaStatsEventType.midroll50] = 'midroll50';
KalturaStatsEventType[KalturaStatsEventType.midroll75] = 'midroll75';
KalturaStatsEventType[KalturaStatsEventType.midrollClicked] = 'midrollClicked';
KalturaStatsEventType[KalturaStatsEventType.midrollStarted] = 'midrollStarted';
KalturaStatsEventType[KalturaStatsEventType.openDownload] = 'openDownload';
KalturaStatsEventType[KalturaStatsEventType.openEdit] = 'openEdit';
KalturaStatsEventType[KalturaStatsEventType.openFullScreen] = 'openFullScreen';
KalturaStatsEventType[KalturaStatsEventType.openReport] = 'openReport';
KalturaStatsEventType[KalturaStatsEventType.openUpload] = 'openUpload';
KalturaStatsEventType[KalturaStatsEventType.openViral] = 'openViral';
KalturaStatsEventType[KalturaStatsEventType.overlayClicked] = 'overlayClicked';
KalturaStatsEventType[KalturaStatsEventType.overlayStarted] = 'overlayStarted';
KalturaStatsEventType[KalturaStatsEventType.play] = 'play';
KalturaStatsEventType[KalturaStatsEventType.playReached100] = 'playReached100';
KalturaStatsEventType[KalturaStatsEventType.playReached25] = 'playReached25';
KalturaStatsEventType[KalturaStatsEventType.playReached50] = 'playReached50';
KalturaStatsEventType[KalturaStatsEventType.playReached75] = 'playReached75';
KalturaStatsEventType[KalturaStatsEventType.postroll25] = 'postroll25';
KalturaStatsEventType[KalturaStatsEventType.postroll50] = 'postroll50';
KalturaStatsEventType[KalturaStatsEventType.postroll75] = 'postroll75';
KalturaStatsEventType[KalturaStatsEventType.postrollClicked] = 'postrollClicked';
KalturaStatsEventType[KalturaStatsEventType.postrollStarted] = 'postrollStarted';
KalturaStatsEventType[KalturaStatsEventType.postBumperPlayed] = 'postBumperPlayed';
KalturaStatsEventType[KalturaStatsEventType.preroll25] = 'preroll25';
KalturaStatsEventType[KalturaStatsEventType.preroll50] = 'preroll50';
KalturaStatsEventType[KalturaStatsEventType.preroll75] = 'preroll75';
KalturaStatsEventType[KalturaStatsEventType.prerollClicked] = 'prerollClicked';
KalturaStatsEventType[KalturaStatsEventType.prerollStarted] = 'prerollStarted';
KalturaStatsEventType[KalturaStatsEventType.preBumperPlayed] = 'preBumperPlayed';
KalturaStatsEventType[KalturaStatsEventType.replay] = 'replay';
KalturaStatsEventType[KalturaStatsEventType.savePublish] = 'savePublish';
KalturaStatsEventType[KalturaStatsEventType.seek] = 'seek';
KalturaStatsEventType[KalturaStatsEventType.widgetLoaded] = 'widgetLoaded';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaStatsFeatureType = {
    none: 0,
    related: 1,
};
KalturaStatsFeatureType[KalturaStatsFeatureType.none] = 'none';
KalturaStatsFeatureType[KalturaStatsFeatureType.related] = 'related';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaStatsEvent extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaStatsEvent' },
            clientVer: { type: 's' },
            eventType: { type: 'en', subTypeConstructor: KalturaStatsEventType, subType: 'KalturaStatsEventType' },
            eventTimestamp: { type: 'n' },
            sessionId: { type: 's' },
            partnerId: { type: 'n' },
            entryId: { type: 's' },
            uniqueViewer: { type: 's' },
            widgetId: { type: 's' },
            uiconfId: { type: 'n' },
            userId: { type: 's' },
            currentPoint: { type: 'n' },
            duration: { type: 'n' },
            userIp: { type: 's', readOnly: true },
            processDuration: { type: 'n' },
            controlId: { type: 's' },
            seek: { type: 'b' },
            newPoint: { type: 'n' },
            referrer: { type: 's' },
            isFirstInSession: { type: 'b' },
            applicationId: { type: 's' },
            contextId: { type: 'n' },
            featureType: { type: 'en', subTypeConstructor: KalturaStatsFeatureType, subType: 'KalturaStatsFeatureType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaStatsEvent'] = KalturaStatsEvent;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaStatsKmcEventType = {
    accountAccessControl: 1035,
    accountAccessControlDelete: 1039,
    accountAccountOverview: 1034,
    accountAccountUpgrade: 1037,
    accountChangeLoginInfo: 1031,
    accountChangePartnerInfo: 1030,
    accountContactUsUsage: 1032,
    accountSaveServerSettings: 1038,
    accountSaveTranscodingSettings: 1040,
    accountTranscodingSettings: 1036,
    accountUpdateServerSettings: 1033,
    appStudioDuplicatePlayer: 1056,
    appStudioEditPlayerMultiTabPlaylist: 1055,
    appStudioEditPlayerPlaylist: 1054,
    appStudioEditPlayerSingleVideo: 1053,
    appStudioNewPlayerMultiTabPlaylist: 1052,
    appStudioNewPlayerPlaylist: 1051,
    appStudioNewPlayerSingleVideo: 1050,
    contentAddAdminTags: 1017,
    contentAddPlaylist: 1010,
    contentAddTags: 1015,
    contentAdminKcwUpload: 1023,
    contentApproveModeration: 1020,
    contentBulkUpload: 1022,
    contentChangeThumbnail: 1014,
    contentContentGoToPage: 1057,
    contentDeleteItem: 1058,
    contentDeleteMix: 1059,
    contentDeletePlaylist: 1012,
    contentDownload: 1019,
    contentEditEntry: 1013,
    contentEditPlaylist: 1011,
    contentEntryDrilldown: 1088,
    contentOpenPreviewAndEmbed: 1089,
    contentPageView: 1001,
    contentRejectModeration: 1021,
    contentRemoveAdminTags: 1018,
    contentRemoveTags: 1016,
    dashboardAccountContactUs: 1044,
    dashboardCustomizePlayers: 1048,
    dashboardEmbedPlayer: 1046,
    dashboardEmbedPlaylist: 1047,
    dashboardImportContent: 1042,
    dashboardUpdateContent: 1043,
    dashboardViewReports: 1045,
    login: 1041,
    reportsAndAnalyticsBandwidthUsageTab: 1070,
    reportsAndAnalyticsBandwidthUsageViewMonthly: 1086,
    reportsAndAnalyticsBandwidthUsageViewYearly: 1087,
    reportsAndAnalyticsContentContributions: 1079,
    reportsAndAnalyticsContentContributionsDrilldown: 1082,
    reportsAndAnalyticsContentDrillDownInteraction: 1081,
    reportsAndAnalyticsContentDropoff: 1077,
    reportsAndAnalyticsContentInteractions: 1078,
    reportsAndAnalyticsContentReportsTab: 1071,
    reportsAndAnalyticsMapOverlays: 1074,
    reportsAndAnalyticsMapOverlaysDrilldown: 1084,
    reportsAndAnalyticsTopContent: 1076,
    reportsAndAnalyticsTopContributors: 1073,
    reportsAndAnalyticsTopSyndications: 1075,
    reportsAndAnalyticsTopSyndicationsDrillDown: 1085,
    reportsAndAnalyticsUsersAndCommunityReportsTab: 1072,
    reportsAndAnalyticsVideoDrillDown: 1080,
    reportsAndAnalyticsVideoDrillDownDropoff: 1083,
};
KalturaStatsKmcEventType[KalturaStatsKmcEventType.accountAccessControl] = 'accountAccessControl';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.accountAccessControlDelete] = 'accountAccessControlDelete';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.accountAccountOverview] = 'accountAccountOverview';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.accountAccountUpgrade] = 'accountAccountUpgrade';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.accountChangeLoginInfo] = 'accountChangeLoginInfo';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.accountChangePartnerInfo] = 'accountChangePartnerInfo';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.accountContactUsUsage] = 'accountContactUsUsage';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.accountSaveServerSettings] = 'accountSaveServerSettings';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.accountSaveTranscodingSettings] = 'accountSaveTranscodingSettings';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.accountTranscodingSettings] = 'accountTranscodingSettings';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.accountUpdateServerSettings] = 'accountUpdateServerSettings';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.appStudioDuplicatePlayer] = 'appStudioDuplicatePlayer';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.appStudioEditPlayerMultiTabPlaylist] = 'appStudioEditPlayerMultiTabPlaylist';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.appStudioEditPlayerPlaylist] = 'appStudioEditPlayerPlaylist';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.appStudioEditPlayerSingleVideo] = 'appStudioEditPlayerSingleVideo';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.appStudioNewPlayerMultiTabPlaylist] = 'appStudioNewPlayerMultiTabPlaylist';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.appStudioNewPlayerPlaylist] = 'appStudioNewPlayerPlaylist';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.appStudioNewPlayerSingleVideo] = 'appStudioNewPlayerSingleVideo';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentAddAdminTags] = 'contentAddAdminTags';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentAddPlaylist] = 'contentAddPlaylist';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentAddTags] = 'contentAddTags';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentAdminKcwUpload] = 'contentAdminKcwUpload';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentApproveModeration] = 'contentApproveModeration';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentBulkUpload] = 'contentBulkUpload';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentChangeThumbnail] = 'contentChangeThumbnail';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentContentGoToPage] = 'contentContentGoToPage';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentDeleteItem] = 'contentDeleteItem';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentDeleteMix] = 'contentDeleteMix';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentDeletePlaylist] = 'contentDeletePlaylist';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentDownload] = 'contentDownload';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentEditEntry] = 'contentEditEntry';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentEditPlaylist] = 'contentEditPlaylist';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentEntryDrilldown] = 'contentEntryDrilldown';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentOpenPreviewAndEmbed] = 'contentOpenPreviewAndEmbed';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentPageView] = 'contentPageView';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentRejectModeration] = 'contentRejectModeration';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentRemoveAdminTags] = 'contentRemoveAdminTags';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.contentRemoveTags] = 'contentRemoveTags';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.dashboardAccountContactUs] = 'dashboardAccountContactUs';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.dashboardCustomizePlayers] = 'dashboardCustomizePlayers';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.dashboardEmbedPlayer] = 'dashboardEmbedPlayer';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.dashboardEmbedPlaylist] = 'dashboardEmbedPlaylist';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.dashboardImportContent] = 'dashboardImportContent';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.dashboardUpdateContent] = 'dashboardUpdateContent';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.dashboardViewReports] = 'dashboardViewReports';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.login] = 'login';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsBandwidthUsageTab] = 'reportsAndAnalyticsBandwidthUsageTab';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsBandwidthUsageViewMonthly] = 'reportsAndAnalyticsBandwidthUsageViewMonthly';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsBandwidthUsageViewYearly] = 'reportsAndAnalyticsBandwidthUsageViewYearly';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsContentContributions] = 'reportsAndAnalyticsContentContributions';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsContentContributionsDrilldown] = 'reportsAndAnalyticsContentContributionsDrilldown';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsContentDrillDownInteraction] = 'reportsAndAnalyticsContentDrillDownInteraction';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsContentDropoff] = 'reportsAndAnalyticsContentDropoff';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsContentInteractions] = 'reportsAndAnalyticsContentInteractions';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsContentReportsTab] = 'reportsAndAnalyticsContentReportsTab';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsMapOverlays] = 'reportsAndAnalyticsMapOverlays';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsMapOverlaysDrilldown] = 'reportsAndAnalyticsMapOverlaysDrilldown';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsTopContent] = 'reportsAndAnalyticsTopContent';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsTopContributors] = 'reportsAndAnalyticsTopContributors';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsTopSyndications] = 'reportsAndAnalyticsTopSyndications';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsTopSyndicationsDrillDown] = 'reportsAndAnalyticsTopSyndicationsDrillDown';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsUsersAndCommunityReportsTab] = 'reportsAndAnalyticsUsersAndCommunityReportsTab';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsVideoDrillDown] = 'reportsAndAnalyticsVideoDrillDown';
KalturaStatsKmcEventType[KalturaStatsKmcEventType.reportsAndAnalyticsVideoDrillDownDropoff] = 'reportsAndAnalyticsVideoDrillDownDropoff';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaStatsKmcEvent extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaStatsKmcEvent' },
            clientVer: { type: 's' },
            kmcEventActionPath: { type: 's' },
            kmcEventType: { type: 'en', subTypeConstructor: KalturaStatsKmcEventType, subType: 'KalturaStatsKmcEventType' },
            eventTimestamp: { type: 'n' },
            sessionId: { type: 's' },
            partnerId: { type: 'n' },
            entryId: { type: 's' },
            widgetId: { type: 's' },
            uiconfId: { type: 'n' },
            userId: { type: 's' },
            userIp: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaStatsKmcEvent'] = KalturaStatsKmcEvent;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaStorageProfileStatus = {
    automatic: 2,
    disabled: 1,
    manual: 3,
};
KalturaStorageProfileStatus[KalturaStorageProfileStatus.automatic] = 'automatic';
KalturaStorageProfileStatus[KalturaStorageProfileStatus.disabled] = 'disabled';
KalturaStorageProfileStatus[KalturaStorageProfileStatus.manual] = 'manual';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaStorageProfileProtocol = {
    ftp: '1',
    kalturaDc: '0',
    kontiki: 'kontiki.KONTIKI',
    local: '7',
    s3: '6',
    scp: '2',
    sftp: '3',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaStorageProfileDeliveryStatus = {
    active: 1,
    blocked: 2,
};
KalturaStorageProfileDeliveryStatus[KalturaStorageProfileDeliveryStatus.active] = 'active';
KalturaStorageProfileDeliveryStatus[KalturaStorageProfileDeliveryStatus.blocked] = 'blocked';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaStorageProfileReadyBehavior = {
    noImpact: 0,
    required: 1,
};
KalturaStorageProfileReadyBehavior[KalturaStorageProfileReadyBehavior.noImpact] = 'noImpact';
KalturaStorageProfileReadyBehavior[KalturaStorageProfileReadyBehavior.required] = 'required';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaStorageProfile extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.pathManagerParams === 'undefined')
            this.pathManagerParams = [];
        if (typeof this.rules === 'undefined')
            this.rules = [];
        if (typeof this.deliveryProfileIds === 'undefined')
            this.deliveryProfileIds = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaStorageProfile' },
            id: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            name: { type: 's' },
            systemName: { type: 's' },
            desciption: { type: 's' },
            status: { type: 'en', subTypeConstructor: KalturaStorageProfileStatus, subType: 'KalturaStorageProfileStatus' },
            protocol: { type: 'es', subTypeConstructor: KalturaStorageProfileProtocol, subType: 'KalturaStorageProfileProtocol' },
            storageUrl: { type: 's' },
            storageBaseDir: { type: 's' },
            storageUsername: { type: 's' },
            storagePassword: { type: 's' },
            storageFtpPassiveMode: { type: 'b' },
            minFileSize: { type: 'n' },
            maxFileSize: { type: 'n' },
            flavorParamsIds: { type: 's' },
            maxConcurrentConnections: { type: 'n' },
            pathManagerClass: { type: 's' },
            pathManagerParams: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            trigger: { type: 'n' },
            deliveryPriority: { type: 'n' },
            deliveryStatus: { type: 'en', subTypeConstructor: KalturaStorageProfileDeliveryStatus, subType: 'KalturaStorageProfileDeliveryStatus' },
            readyBehavior: { type: 'en', subTypeConstructor: KalturaStorageProfileReadyBehavior, subType: 'KalturaStorageProfileReadyBehavior' },
            allowAutoDelete: { type: 'n' },
            createFileLink: { type: 'b' },
            rules: { type: 'a', subTypeConstructor: KalturaRule, subType: 'KalturaRule' },
            deliveryProfileIds: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            privateKey: { type: 's' },
            publicKey: { type: 's' },
            passPhrase: { type: 's' },
            shouldExportThumbs: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaStorageProfile'] = KalturaStorageProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSyndicationFeedEntryCount extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSyndicationFeedEntryCount' },
            totalEntryCount: { type: 'n' },
            actualEntryCount: { type: 'n' },
            requireTranscodingCount: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSyndicationFeedEntryCount'] = KalturaSyndicationFeedEntryCount;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSystemPartnerUsageItem extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSystemPartnerUsageItem' },
            partnerId: { type: 'n' },
            partnerName: { type: 's' },
            partnerStatus: { type: 'en', subTypeConstructor: KalturaPartnerStatus, subType: 'KalturaPartnerStatus' },
            partnerPackage: { type: 'n' },
            partnerCreatedAt: { type: 'n' },
            views: { type: 'n' },
            plays: { type: 'n' },
            entriesCount: { type: 'n' },
            totalEntriesCount: { type: 'n' },
            videoEntriesCount: { type: 'n' },
            imageEntriesCount: { type: 'n' },
            audioEntriesCount: { type: 'n' },
            mixEntriesCount: { type: 'n' },
            bandwidth: { type: 'n' },
            totalStorage: { type: 'n' },
            storage: { type: 'n' },
            peakStorage: { type: 'n' },
            avgStorage: { type: 'n' },
            combinedBandwidthStorage: { type: 'n' },
            deletedStorage: { type: 'n' },
            transcodingUsage: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSystemPartnerUsageItem'] = KalturaSystemPartnerUsageItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaTaggedObjectType = {
    category: '2',
    entry: '1',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTag extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTag' },
            id: { type: 'n', readOnly: true },
            tag: { type: 's', readOnly: true },
            taggedObjectType: { type: 'es', readOnly: true, subTypeConstructor: KalturaTaggedObjectType, subType: 'KalturaTaggedObjectType' },
            partnerId: { type: 'n', readOnly: true },
            instanceCount: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaTag'] = KalturaTag;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaTranscriptProviderType = {
    cielo24: 'cielo24.Cielo24',
    voicebase: 'voicebase.Voicebase',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTranscriptAsset extends KalturaAttachmentAsset {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTranscriptAsset' },
            accuracy: { type: 'n' },
            humanVerified: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            language: { type: 'es', subTypeConstructor: KalturaLanguage, subType: 'KalturaLanguage' },
            providerType: { type: 'es', subTypeConstructor: KalturaTranscriptProviderType, subType: 'KalturaTranscriptProviderType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaTranscriptAsset'] = KalturaTranscriptAsset;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaUiConfObjType = {
    advancedEditor: 4,
    appStudio: 6,
    clientsideEncoder: 15,
    clipper: 18,
    contributionWizard: 2,
    kmcAccount: 9,
    kmcAnalytics: 10,
    kmcContent: 11,
    kmcDashboard: 12,
    kmcGeneral: 16,
    kmcLogin: 13,
    kmcRolesAndPermissions: 17,
    krecord: 7,
    ksr: 19,
    kupload: 20,
    player: 1,
    playerSl: 14,
    playerV3: 8,
    playlist: 5,
    simpleEditor: 3,
    webcasting: 21,
};
KalturaUiConfObjType[KalturaUiConfObjType.advancedEditor] = 'advancedEditor';
KalturaUiConfObjType[KalturaUiConfObjType.appStudio] = 'appStudio';
KalturaUiConfObjType[KalturaUiConfObjType.clientsideEncoder] = 'clientsideEncoder';
KalturaUiConfObjType[KalturaUiConfObjType.clipper] = 'clipper';
KalturaUiConfObjType[KalturaUiConfObjType.contributionWizard] = 'contributionWizard';
KalturaUiConfObjType[KalturaUiConfObjType.kmcAccount] = 'kmcAccount';
KalturaUiConfObjType[KalturaUiConfObjType.kmcAnalytics] = 'kmcAnalytics';
KalturaUiConfObjType[KalturaUiConfObjType.kmcContent] = 'kmcContent';
KalturaUiConfObjType[KalturaUiConfObjType.kmcDashboard] = 'kmcDashboard';
KalturaUiConfObjType[KalturaUiConfObjType.kmcGeneral] = 'kmcGeneral';
KalturaUiConfObjType[KalturaUiConfObjType.kmcLogin] = 'kmcLogin';
KalturaUiConfObjType[KalturaUiConfObjType.kmcRolesAndPermissions] = 'kmcRolesAndPermissions';
KalturaUiConfObjType[KalturaUiConfObjType.krecord] = 'krecord';
KalturaUiConfObjType[KalturaUiConfObjType.ksr] = 'ksr';
KalturaUiConfObjType[KalturaUiConfObjType.kupload] = 'kupload';
KalturaUiConfObjType[KalturaUiConfObjType.player] = 'player';
KalturaUiConfObjType[KalturaUiConfObjType.playerSl] = 'playerSl';
KalturaUiConfObjType[KalturaUiConfObjType.playerV3] = 'playerV3';
KalturaUiConfObjType[KalturaUiConfObjType.playlist] = 'playlist';
KalturaUiConfObjType[KalturaUiConfObjType.simpleEditor] = 'simpleEditor';
KalturaUiConfObjType[KalturaUiConfObjType.webcasting] = 'webcasting';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaUiConfCreationMode = {
    advanced: 3,
    wizard: 2,
};
KalturaUiConfCreationMode[KalturaUiConfCreationMode.advanced] = 'advanced';
KalturaUiConfCreationMode[KalturaUiConfCreationMode.wizard] = 'wizard';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUiConf extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUiConf' },
            id: { type: 'n', readOnly: true },
            name: { type: 's' },
            description: { type: 's' },
            partnerId: { type: 'n', readOnly: true },
            objType: { type: 'en', subTypeConstructor: KalturaUiConfObjType, subType: 'KalturaUiConfObjType' },
            objTypeAsString: { type: 's', readOnly: true },
            width: { type: 'n' },
            height: { type: 'n' },
            htmlParams: { type: 's' },
            swfUrl: { type: 's' },
            confFilePath: { type: 's', readOnly: true },
            confFile: { type: 's' },
            confFileFeatures: { type: 's' },
            config: { type: 's' },
            confVars: { type: 's' },
            useCdn: { type: 'b' },
            tags: { type: 's' },
            swfUrlVersion: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            creationMode: { type: 'en', subTypeConstructor: KalturaUiConfCreationMode, subType: 'KalturaUiConfCreationMode' },
            html5Url: { type: 's' },
            version: { type: 's', readOnly: true },
            partnerTags: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUiConf'] = KalturaUiConf;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUiConfAdmin extends KalturaUiConf {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUiConfAdmin' },
            isPublic: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUiConfAdmin'] = KalturaUiConfAdmin;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUiConfTypeInfo extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.versions === 'undefined')
            this.versions = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUiConfTypeInfo' },
            type: { type: 'en', subTypeConstructor: KalturaUiConfObjType, subType: 'KalturaUiConfObjType' },
            versions: { type: 'a', subTypeConstructor: KalturaString, subType: 'KalturaString' },
            directory: { type: 's' },
            filename: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUiConfTypeInfo'] = KalturaUiConfTypeInfo;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaUploadErrorCode = {
    generalError: 1,
    noError: 0,
    partialUpload: 2,
};
KalturaUploadErrorCode[KalturaUploadErrorCode.generalError] = 'generalError';
KalturaUploadErrorCode[KalturaUploadErrorCode.noError] = 'noError';
KalturaUploadErrorCode[KalturaUploadErrorCode.partialUpload] = 'partialUpload';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUploadResponse extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUploadResponse' },
            uploadTokenId: { type: 's' },
            fileSize: { type: 'n' },
            errorCode: { type: 'en', subTypeConstructor: KalturaUploadErrorCode, subType: 'KalturaUploadErrorCode' },
            errorDescription: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUploadResponse'] = KalturaUploadResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaUploadTokenStatus = {
    closed: 3,
    deleted: 5,
    fullUpload: 2,
    partialUpload: 1,
    pending: 0,
    timedOut: 4,
};
KalturaUploadTokenStatus[KalturaUploadTokenStatus.closed] = 'closed';
KalturaUploadTokenStatus[KalturaUploadTokenStatus.deleted] = 'deleted';
KalturaUploadTokenStatus[KalturaUploadTokenStatus.fullUpload] = 'fullUpload';
KalturaUploadTokenStatus[KalturaUploadTokenStatus.partialUpload] = 'partialUpload';
KalturaUploadTokenStatus[KalturaUploadTokenStatus.pending] = 'pending';
KalturaUploadTokenStatus[KalturaUploadTokenStatus.timedOut] = 'timedOut';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUploadToken extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUploadToken' },
            id: { type: 's', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            userId: { type: 's', readOnly: true },
            status: { type: 'en', readOnly: true, subTypeConstructor: KalturaUploadTokenStatus, subType: 'KalturaUploadTokenStatus' },
            fileName: { type: 's' },
            fileSize: { type: 'n' },
            uploadedFileSize: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            uploadUrl: { type: 's', readOnly: true },
            autoFinalize: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUploadToken'] = KalturaUploadToken;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaUserEntryStatus = {
    active: '1',
    deleted: '2',
    quizSubmitted: 'quiz.3',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaUserEntryType = {
    quiz: 'quiz.QUIZ',
    viewHistory: 'viewHistory.VIEW_HISTORY',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaUserEntryExtendedStatus = {
    playbackComplete: 'viewHistory.PLAYBACK_COMPLETE',
    playbackStarted: 'viewHistory.PLAYBACK_STARTED',
    viewed: 'viewHistory.VIEWED',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserEntry extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserEntry' },
            id: { type: 'n', readOnly: true },
            entryId: { type: 's' },
            userId: { type: 's' },
            partnerId: { type: 'n', readOnly: true },
            status: { type: 'es', readOnly: true, subTypeConstructor: KalturaUserEntryStatus, subType: 'KalturaUserEntryStatus' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            type: { type: 'es', readOnly: true, subTypeConstructor: KalturaUserEntryType, subType: 'KalturaUserEntryType' },
            extendedStatus: { type: 'es', subTypeConstructor: KalturaUserEntryExtendedStatus, subType: 'KalturaUserEntryExtendedStatus' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserEntry'] = KalturaUserEntry;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserLoginData extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserLoginData' },
            id: { type: 's' },
            loginEmail: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserLoginData'] = KalturaUserLoginData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaUserRoleStatus = {
    active: 1,
    blocked: 2,
    deleted: 3,
};
KalturaUserRoleStatus[KalturaUserRoleStatus.active] = 'active';
KalturaUserRoleStatus[KalturaUserRoleStatus.blocked] = 'blocked';
KalturaUserRoleStatus[KalturaUserRoleStatus.deleted] = 'deleted';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserRole extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserRole' },
            id: { type: 'n', readOnly: true },
            name: { type: 's' },
            systemName: { type: 's' },
            description: { type: 's' },
            status: { type: 'en', subTypeConstructor: KalturaUserRoleStatus, subType: 'KalturaUserRoleStatus' },
            partnerId: { type: 'n', readOnly: true },
            permissionNames: { type: 's' },
            tags: { type: 's' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserRole'] = KalturaUserRole;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaVarPartnerUsageItem extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaVarPartnerUsageItem' },
            partnerId: { type: 'n' },
            partnerName: { type: 's' },
            partnerStatus: { type: 'en', subTypeConstructor: KalturaPartnerStatus, subType: 'KalturaPartnerStatus' },
            partnerPackage: { type: 'n' },
            partnerCreatedAt: { type: 'n' },
            views: { type: 'n' },
            plays: { type: 'n' },
            entriesCount: { type: 'n' },
            totalEntriesCount: { type: 'n' },
            videoEntriesCount: { type: 'n' },
            imageEntriesCount: { type: 'n' },
            audioEntriesCount: { type: 'n' },
            mixEntriesCount: { type: 'n' },
            bandwidth: { type: 'n' },
            totalStorage: { type: 'n' },
            storage: { type: 'n' },
            deletedStorage: { type: 'n' },
            peakStorage: { type: 'n' },
            avgStorage: { type: 'n' },
            combinedStorageBandwidth: { type: 'n' },
            transcodingUsage: { type: 'n' },
            dateId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaVarPartnerUsageItem'] = KalturaVarPartnerUsageItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaVirusScanProfileStatus = {
    deleted: 3,
    disabled: 1,
    enabled: 2,
};
KalturaVirusScanProfileStatus[KalturaVirusScanProfileStatus.deleted] = 'deleted';
KalturaVirusScanProfileStatus[KalturaVirusScanProfileStatus.disabled] = 'disabled';
KalturaVirusScanProfileStatus[KalturaVirusScanProfileStatus.enabled] = 'enabled';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaVirusScanEngineType = {
    clamavScanEngine: 'clamAVScanEngine.ClamAV',
    symantecScanDirectEngine: 'symantecScanEngine.SymantecScanDirectEngine',
    symantecScanEngine: 'symantecScanEngine.SymantecScanEngine',
    symantecScanJavaEngine: 'symantecScanEngine.SymantecScanJavaEngine',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaVirusFoundAction = {
    cleanDelete: 3,
    cleanNone: 2,
    delete: 1,
    none: 0,
};
KalturaVirusFoundAction[KalturaVirusFoundAction.cleanDelete] = 'cleanDelete';
KalturaVirusFoundAction[KalturaVirusFoundAction.cleanNone] = 'cleanNone';
KalturaVirusFoundAction[KalturaVirusFoundAction.delete] = 'delete';
KalturaVirusFoundAction[KalturaVirusFoundAction.none] = 'none';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaVirusScanProfile extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaVirusScanProfile' },
            id: { type: 'n', readOnly: true },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            name: { type: 's' },
            status: { type: 'en', subTypeConstructor: KalturaVirusScanProfileStatus, subType: 'KalturaVirusScanProfileStatus' },
            engineType: { type: 'es', subTypeConstructor: KalturaVirusScanEngineType, subType: 'KalturaVirusScanEngineType' },
            entryFilter: { type: 'o', subTypeConstructor: KalturaBaseEntryFilter, subType: 'KalturaBaseEntryFilter' },
            actionIfInfected: { type: 'en', subTypeConstructor: KalturaVirusFoundAction, subType: 'KalturaVirusFoundAction' }
        });
        return result;
    }
}
typesMappingStorage['KalturaVirusScanProfile'] = KalturaVirusScanProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaWidgetSecurityType = {
    none: 1,
    timehash: 2,
};
KalturaWidgetSecurityType[KalturaWidgetSecurityType.none] = 'none';
KalturaWidgetSecurityType[KalturaWidgetSecurityType.timehash] = 'timehash';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWidget extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWidget' },
            id: { type: 's', readOnly: true },
            sourceWidgetId: { type: 's' },
            rootWidgetId: { type: 's', readOnly: true },
            partnerId: { type: 'n', readOnly: true },
            entryId: { type: 's' },
            uiConfId: { type: 'n' },
            securityType: { type: 'en', subTypeConstructor: KalturaWidgetSecurityType, subType: 'KalturaWidgetSecurityType' },
            securityPolicy: { type: 'n' },
            createdAt: { type: 'd', readOnly: true },
            updatedAt: { type: 'd', readOnly: true },
            partnerData: { type: 's' },
            widgetHTML: { type: 's', readOnly: true },
            enforceEntitlement: { type: 'b' },
            privacyContext: { type: 's' },
            addEmbedHtml5Support: { type: 'b' },
            roles: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWidget'] = KalturaWidget;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBatchJobBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBatchJobBaseFilter' },
            idEqual: { type: 'n' },
            idGreaterThanOrEqual: { type: 'n' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            partnerIdNotIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            executionAttemptsGreaterThanOrEqual: { type: 'n' },
            executionAttemptsLessThanOrEqual: { type: 'n' },
            lockVersionGreaterThanOrEqual: { type: 'n' },
            lockVersionLessThanOrEqual: { type: 'n' },
            entryIdEqual: { type: 's' },
            jobTypeEqual: { type: 'es', subTypeConstructor: KalturaBatchJobType, subType: 'KalturaBatchJobType' },
            jobTypeIn: { type: 's' },
            jobTypeNotIn: { type: 's' },
            jobSubTypeEqual: { type: 'n' },
            jobSubTypeIn: { type: 's' },
            jobSubTypeNotIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaBatchJobStatus, subType: 'KalturaBatchJobStatus' },
            statusIn: { type: 's' },
            statusNotIn: { type: 's' },
            priorityGreaterThanOrEqual: { type: 'n' },
            priorityLessThanOrEqual: { type: 'n' },
            priorityEqual: { type: 'n' },
            priorityIn: { type: 's' },
            priorityNotIn: { type: 's' },
            batchVersionGreaterThanOrEqual: { type: 'n' },
            batchVersionLessThanOrEqual: { type: 'n' },
            batchVersionEqual: { type: 'n' },
            queueTimeGreaterThanOrEqual: { type: 'n' },
            queueTimeLessThanOrEqual: { type: 'n' },
            finishTimeGreaterThanOrEqual: { type: 'n' },
            finishTimeLessThanOrEqual: { type: 'n' },
            errTypeEqual: { type: 'en', subTypeConstructor: KalturaBatchJobErrorTypes, subType: 'KalturaBatchJobErrorTypes' },
            errTypeIn: { type: 's' },
            errTypeNotIn: { type: 's' },
            errNumberEqual: { type: 'n' },
            errNumberIn: { type: 's' },
            errNumberNotIn: { type: 's' },
            estimatedEffortLessThan: { type: 'n' },
            estimatedEffortGreaterThan: { type: 'n' },
            urgencyLessThanOrEqual: { type: 'n' },
            urgencyGreaterThanOrEqual: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBatchJobBaseFilter'] = KalturaBatchJobBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBatchJobFilter extends KalturaBatchJobBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBatchJobFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBatchJobFilter'] = KalturaBatchJobFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaYouTubeApiDistributionCaptionAction = {
    deleteAction: 3,
    submitAction: 2,
    updateAction: 1,
};
KalturaYouTubeApiDistributionCaptionAction[KalturaYouTubeApiDistributionCaptionAction.deleteAction] = 'deleteAction';
KalturaYouTubeApiDistributionCaptionAction[KalturaYouTubeApiDistributionCaptionAction.submitAction] = 'submitAction';
KalturaYouTubeApiDistributionCaptionAction[KalturaYouTubeApiDistributionCaptionAction.updateAction] = 'updateAction';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYouTubeApiCaptionDistributionInfo extends KalturaObjectBase {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYouTubeApiCaptionDistributionInfo' },
            language: { type: 's' },
            label: { type: 's' },
            filePath: { type: 's' },
            remoteId: { type: 's' },
            action: { type: 'en', subTypeConstructor: KalturaYouTubeApiDistributionCaptionAction, subType: 'KalturaYouTubeApiDistributionCaptionAction' },
            version: { type: 's' },
            assetId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYouTubeApiCaptionDistributionInfo'] = KalturaYouTubeApiCaptionDistributionInfo;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlBlockAction extends KalturaRuleAction {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlBlockAction' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlBlockAction'] = KalturaAccessControlBlockAction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlDrmPolicyAction extends KalturaRuleAction {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlDrmPolicyAction' },
            policyId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlDrmPolicyAction'] = KalturaAccessControlDrmPolicyAction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlLimitDeliveryProfilesAction extends KalturaRuleAction {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlLimitDeliveryProfilesAction' },
            deliveryProfileIds: { type: 's' },
            isBlockedList: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlLimitDeliveryProfilesAction'] = KalturaAccessControlLimitDeliveryProfilesAction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlLimitFlavorsAction extends KalturaRuleAction {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlLimitFlavorsAction' },
            flavorParamsIds: { type: 's' },
            isBlockedList: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlLimitFlavorsAction'] = KalturaAccessControlLimitFlavorsAction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlLimitThumbnailCaptureAction extends KalturaRuleAction {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlLimitThumbnailCaptureAction' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlLimitThumbnailCaptureAction'] = KalturaAccessControlLimitThumbnailCaptureAction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaAccessControl, subType: 'KalturaAccessControl' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlListResponse'] = KalturaAccessControlListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlModifyRequestHostRegexAction extends KalturaRuleAction {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlModifyRequestHostRegexAction' },
            pattern: { type: 's' },
            replacement: { type: 's' },
            replacmenServerNodeId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlModifyRequestHostRegexAction'] = KalturaAccessControlModifyRequestHostRegexAction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlPreviewAction extends KalturaRuleAction {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlPreviewAction' },
            limit: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlPreviewAction'] = KalturaAccessControlPreviewAction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlProfileListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlProfileListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaAccessControlProfile, subType: 'KalturaAccessControlProfile' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlProfileListResponse'] = KalturaAccessControlProfileListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlServeRemoteEdgeServerAction extends KalturaRuleAction {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlServeRemoteEdgeServerAction' },
            edgeServerIds: { type: 's' },
            seamlessFallbackEnabled: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlServeRemoteEdgeServerAction'] = KalturaAccessControlServeRemoteEdgeServerAction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaActivitiBusinessProcessServerProtocol = {
    http: 'http',
    https: 'https',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaActivitiBusinessProcessServer extends KalturaBusinessProcessServer {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaActivitiBusinessProcessServer' },
            host: { type: 's' },
            port: { type: 'n' },
            protocol: { type: 'es', subTypeConstructor: KalturaActivitiBusinessProcessServerProtocol, subType: 'KalturaActivitiBusinessProcessServerProtocol' },
            username: { type: 's' },
            password: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaActivitiBusinessProcessServer'] = KalturaActivitiBusinessProcessServer;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAdProtocolType = {
    custom: '0',
    vast: '1',
    vast20: '2',
    vpaid: '3',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAdType = {
    overlay: '2',
    video: '1',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAdCuePoint extends KalturaCuePoint {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAdCuePoint' },
            protocolType: { type: 'es', subTypeConstructor: KalturaAdProtocolType, subType: 'KalturaAdProtocolType' },
            sourceUrl: { type: 's' },
            adType: { type: 'es', subTypeConstructor: KalturaAdType, subType: 'KalturaAdType' },
            title: { type: 's' },
            endTime: { type: 'n' },
            duration: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAdCuePoint'] = KalturaAdCuePoint;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAdminUser extends KalturaUser {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAdminUser' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAdminUser'] = KalturaAdminUser;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAmazonS3StorageProfileFilesPermissionLevel = {
    aclAuthenticatedRead: 'authenticated-read',
    aclPrivate: 'private',
    aclPublicRead: 'public-read',
    aclPublicReadWrite: 'public-read-write',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAmazonS3StorageProfile extends KalturaStorageProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAmazonS3StorageProfile' },
            filesPermissionInS3: { type: 'es', subTypeConstructor: KalturaAmazonS3StorageProfileFilesPermissionLevel, subType: 'KalturaAmazonS3StorageProfileFilesPermissionLevel' },
            s3Region: { type: 's' },
            sseType: { type: 's' },
            sseKmsKeyId: { type: 's' },
            signatureType: { type: 's' },
            endPoint: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAmazonS3StorageProfile'] = KalturaAmazonS3StorageProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAnnotationListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAnnotationListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaAnnotation, subType: 'KalturaAnnotation' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAnnotationListResponse'] = KalturaAnnotationListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAnswerCuePoint extends KalturaCuePoint {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.correctAnswerKeys === 'undefined')
            this.correctAnswerKeys = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAnswerCuePoint' },
            parentId: { type: 's' },
            quizUserEntryId: { type: 's' },
            answerKey: { type: 's' },
            isCorrect: { type: 'en', readOnly: true, subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            correctAnswerKeys: { type: 'a', readOnly: true, subTypeConstructor: KalturaString, subType: 'KalturaString' },
            explanation: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaAnswerCuePoint'] = KalturaAnswerCuePoint;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaApiActionPermissionItem extends KalturaPermissionItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaApiActionPermissionItem' },
            service: { type: 's' },
            action: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaApiActionPermissionItem'] = KalturaApiActionPermissionItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaApiParameterPermissionItemAction = {
    insert: 'insert',
    read: 'read',
    update: 'update',
    usage: 'all',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaApiParameterPermissionItem extends KalturaPermissionItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaApiParameterPermissionItem' },
            object: { type: 's' },
            parameter: { type: 's' },
            action: { type: 'es', subTypeConstructor: KalturaApiParameterPermissionItemAction, subType: 'KalturaApiParameterPermissionItemAction' }
        });
        return result;
    }
}
typesMappingStorage['KalturaApiParameterPermissionItem'] = KalturaApiParameterPermissionItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAppTokenBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAppTokenBaseFilter' },
            idEqual: { type: 's' },
            idIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaAppTokenStatus, subType: 'KalturaAppTokenStatus' },
            statusIn: { type: 's' },
            sessionUserIdEqual: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAppTokenBaseFilter'] = KalturaAppTokenBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAppTokenListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAppTokenListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaAppToken, subType: 'KalturaAppToken' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAppTokenListResponse'] = KalturaAppTokenListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAssetDistributionPropertyCondition extends KalturaAssetDistributionCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAssetDistributionPropertyCondition' },
            propertyName: { type: 's' },
            propertyValue: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAssetDistributionPropertyCondition'] = KalturaAssetDistributionPropertyCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAssetParamsOutput extends KalturaAssetParams {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAssetParamsOutput' },
            assetParamsId: { type: 'n' },
            assetParamsVersion: { type: 's' },
            assetId: { type: 's' },
            assetVersion: { type: 's' },
            readyBehavior: { type: 'n' },
            format: { type: 'es', subTypeConstructor: KalturaContainerFormat, subType: 'KalturaContainerFormat' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAssetParamsOutput'] = KalturaAssetParamsOutput;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAssetPropertiesCompareCondition extends KalturaCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.properties === 'undefined')
            this.properties = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAssetPropertiesCompareCondition' },
            properties: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAssetPropertiesCompareCondition'] = KalturaAssetPropertiesCompareCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAssetTypeCondition extends KalturaCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAssetTypeCondition' },
            assetTypes: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAssetTypeCondition'] = KalturaAssetTypeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAssetsParamsResourceContainers extends KalturaResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.resources === 'undefined')
            this.resources = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAssetsParamsResourceContainers' },
            resources: { type: 'a', subTypeConstructor: KalturaAssetParamsResourceContainer, subType: 'KalturaAssetParamsResourceContainer' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAssetsParamsResourceContainers'] = KalturaAssetsParamsResourceContainers;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAttachmentAssetListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAttachmentAssetListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaAttachmentAsset, subType: 'KalturaAttachmentAsset' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAttachmentAssetListResponse'] = KalturaAttachmentAssetListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAttachmentServeOptions extends KalturaAssetServeOptions {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAttachmentServeOptions' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAttachmentServeOptions'] = KalturaAttachmentServeOptions;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAttributeCondition extends KalturaSearchItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAttributeCondition' },
            value: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAttributeCondition'] = KalturaAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAuditTrailChangeInfo extends KalturaAuditTrailInfo {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.changedItems === 'undefined')
            this.changedItems = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAuditTrailChangeInfo' },
            changedItems: { type: 'a', subTypeConstructor: KalturaAuditTrailChangeItem, subType: 'KalturaAuditTrailChangeItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAuditTrailChangeInfo'] = KalturaAuditTrailChangeInfo;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaAuditTrailChangeXmlNodeType = {
    added: 2,
    changed: 1,
    removed: 3,
};
KalturaAuditTrailChangeXmlNodeType[KalturaAuditTrailChangeXmlNodeType.added] = 'added';
KalturaAuditTrailChangeXmlNodeType[KalturaAuditTrailChangeXmlNodeType.changed] = 'changed';
KalturaAuditTrailChangeXmlNodeType[KalturaAuditTrailChangeXmlNodeType.removed] = 'removed';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAuditTrailChangeXmlNode extends KalturaAuditTrailChangeItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAuditTrailChangeXmlNode' },
            type: { type: 'en', subTypeConstructor: KalturaAuditTrailChangeXmlNodeType, subType: 'KalturaAuditTrailChangeXmlNodeType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAuditTrailChangeXmlNode'] = KalturaAuditTrailChangeXmlNode;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaAuditTrailFileSyncType = {
    file: 1,
    link: 2,
    url: 3,
};
KalturaAuditTrailFileSyncType[KalturaAuditTrailFileSyncType.file] = 'file';
KalturaAuditTrailFileSyncType[KalturaAuditTrailFileSyncType.link] = 'link';
KalturaAuditTrailFileSyncType[KalturaAuditTrailFileSyncType.url] = 'url';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAuditTrailFileSyncCreateInfo extends KalturaAuditTrailInfo {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAuditTrailFileSyncCreateInfo' },
            version: { type: 's' },
            objectSubType: { type: 'n' },
            dc: { type: 'n' },
            original: { type: 'b' },
            fileType: { type: 'en', subTypeConstructor: KalturaAuditTrailFileSyncType, subType: 'KalturaAuditTrailFileSyncType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAuditTrailFileSyncCreateInfo'] = KalturaAuditTrailFileSyncCreateInfo;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAuditTrailListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAuditTrailListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaAuditTrail, subType: 'KalturaAuditTrail' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAuditTrailListResponse'] = KalturaAuditTrailListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAuditTrailTextInfo extends KalturaAuditTrailInfo {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAuditTrailTextInfo' },
            info: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAuditTrailTextInfo'] = KalturaAuditTrailTextInfo;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAuthenticatedCondition extends KalturaCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.privileges === 'undefined')
            this.privileges = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAuthenticatedCondition' },
            privileges: { type: 'a', subTypeConstructor: KalturaStringValue, subType: 'KalturaStringValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAuthenticatedCondition'] = KalturaAuthenticatedCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAvnDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAvnDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAvnDistributionProvider'] = KalturaAvnDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBaseEntryCloneOptions = {
    accessControl: '4',
    adCuePoints: 'adCuePoint.AD_CUE_POINTS',
    annotationCuePoints: 'annotation.ANNOTATION_CUE_POINTS',
    captions: '7',
    categories: '2',
    childEntries: '3',
    codeCuePoints: 'codeCuePoint.CODE_CUE_POINTS',
    flavors: '6',
    metadata: '5',
    thumbCuePoints: 'thumbCuePoint.THUMB_CUE_POINTS',
    users: '1',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaCloneComponentSelectorType = {
    excludeComponent: '1',
    includeComponent: '0',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBaseEntryCloneOptionComponent extends KalturaBaseEntryCloneOptionItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBaseEntryCloneOptionComponent' },
            itemType: { type: 'es', subTypeConstructor: KalturaBaseEntryCloneOptions, subType: 'KalturaBaseEntryCloneOptions' },
            rule: { type: 'es', subTypeConstructor: KalturaCloneComponentSelectorType, subType: 'KalturaCloneComponentSelectorType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBaseEntryCloneOptionComponent'] = KalturaBaseEntryCloneOptionComponent;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBaseEntryListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBaseEntryListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaBaseEntry, subType: 'KalturaBaseEntry' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBaseEntryListResponse'] = KalturaBaseEntryListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBaseSyndicationFeedBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBaseSyndicationFeedBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBaseSyndicationFeedBaseFilter'] = KalturaBaseSyndicationFeedBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBaseSyndicationFeedListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBaseSyndicationFeedListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaBaseSyndicationFeed, subType: 'KalturaBaseSyndicationFeed' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBaseSyndicationFeedListResponse'] = KalturaBaseSyndicationFeedListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBpmEventNotificationIntegrationJobTriggerData extends KalturaIntegrationJobTriggerData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBpmEventNotificationIntegrationJobTriggerData' },
            templateId: { type: 'n' },
            businessProcessId: { type: 's' },
            caseId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBpmEventNotificationIntegrationJobTriggerData'] = KalturaBpmEventNotificationIntegrationJobTriggerData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkDownloadJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkDownloadJobData' },
            entryIds: { type: 's' },
            flavorParamsId: { type: 'n' },
            puserId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkDownloadJobData'] = KalturaBulkDownloadJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkServiceFilterData extends KalturaBulkServiceData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkServiceFilterData' },
            filter: { type: 'o', subTypeConstructor: KalturaFilter, subType: 'KalturaFilter' },
            templateObject: { type: 'o', subTypeConstructor: KalturaObjectBase, subType: 'KalturaObjectBase' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkServiceFilterData'] = KalturaBulkServiceFilterData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadBaseFilter' },
            uploadedOnGreaterThanOrEqual: { type: 'd' },
            uploadedOnLessThanOrEqual: { type: 'd' },
            uploadedOnEqual: { type: 'd' },
            statusIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaBatchJobStatus, subType: 'KalturaBatchJobStatus' },
            bulkUploadObjectTypeEqual: { type: 'es', subTypeConstructor: KalturaBulkUploadObjectType, subType: 'KalturaBulkUploadObjectType' },
            bulkUploadObjectTypeIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadBaseFilter'] = KalturaBulkUploadBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadCategoryData extends KalturaBulkUploadObjectData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadCategoryData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadCategoryData'] = KalturaBulkUploadCategoryData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadCategoryEntryData extends KalturaBulkUploadObjectData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadCategoryEntryData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadCategoryEntryData'] = KalturaBulkUploadCategoryEntryData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadCategoryUserData extends KalturaBulkUploadObjectData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadCategoryUserData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadCategoryUserData'] = KalturaBulkUploadCategoryUserData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadEntryData extends KalturaBulkUploadObjectData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadEntryData' },
            conversionProfileId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadEntryData'] = KalturaBulkUploadEntryData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadJobData' },
            userId: { type: 's', readOnly: true },
            uploadedBy: { type: 's', readOnly: true },
            conversionProfileId: { type: 'n', readOnly: true },
            resultsFileLocalPath: { type: 's', readOnly: true },
            resultsFileUrl: { type: 's', readOnly: true },
            numOfEntries: { type: 'n', readOnly: true },
            numOfObjects: { type: 'n', readOnly: true },
            filePath: { type: 's', readOnly: true },
            bulkUploadObjectType: { type: 'es', readOnly: true, subTypeConstructor: KalturaBulkUploadObjectType, subType: 'KalturaBulkUploadObjectType' },
            fileName: { type: 's' },
            objectData: { type: 'o', readOnly: true, subTypeConstructor: KalturaBulkUploadObjectData, subType: 'KalturaBulkUploadObjectData' },
            type: { type: 'es', readOnly: true, subTypeConstructor: KalturaBulkUploadType, subType: 'KalturaBulkUploadType' },
            emailRecipients: { type: 's' },
            numOfErrorObjects: { type: 'n' },
            privileges: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadJobData'] = KalturaBulkUploadJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaBulkUpload, subType: 'KalturaBulkUpload' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadListResponse'] = KalturaBulkUploadListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadResultCategory extends KalturaBulkUploadResult {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadResultCategory' },
            relativePath: { type: 's' },
            name: { type: 's' },
            referenceId: { type: 's' },
            description: { type: 's' },
            tags: { type: 's' },
            appearInList: { type: 'n' },
            privacy: { type: 'n' },
            inheritanceType: { type: 'n' },
            userJoinPolicy: { type: 'n' },
            defaultPermissionLevel: { type: 'n' },
            owner: { type: 's' },
            contributionPolicy: { type: 'n' },
            partnerSortValue: { type: 'n' },
            moderation: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadResultCategory'] = KalturaBulkUploadResultCategory;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadResultCategoryEntry extends KalturaBulkUploadResult {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadResultCategoryEntry' },
            categoryId: { type: 'n' },
            entryId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadResultCategoryEntry'] = KalturaBulkUploadResultCategoryEntry;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadResultCategoryUser extends KalturaBulkUploadResult {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadResultCategoryUser' },
            categoryId: { type: 'n' },
            categoryReferenceId: { type: 's' },
            userId: { type: 's' },
            permissionLevel: { type: 'n' },
            updateMethod: { type: 'n' },
            requiredObjectStatus: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadResultCategoryUser'] = KalturaBulkUploadResultCategoryUser;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadResultEntry extends KalturaBulkUploadResult {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadResultEntry' },
            entryId: { type: 's' },
            title: { type: 's' },
            description: { type: 's' },
            tags: { type: 's' },
            url: { type: 's' },
            contentType: { type: 's' },
            conversionProfileId: { type: 'n' },
            accessControlProfileId: { type: 'n' },
            category: { type: 's' },
            scheduleStartDate: { type: 'n' },
            scheduleEndDate: { type: 'n' },
            entryStatus: { type: 'n' },
            thumbnailUrl: { type: 's' },
            thumbnailSaved: { type: 'b' },
            sshPrivateKey: { type: 's' },
            sshPublicKey: { type: 's' },
            sshKeyPassphrase: { type: 's' },
            creatorId: { type: 's' },
            entitledUsersEdit: { type: 's' },
            entitledUsersPublish: { type: 's' },
            ownerId: { type: 's' },
            referenceId: { type: 's' },
            templateEntryId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadResultEntry'] = KalturaBulkUploadResultEntry;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadResultScheduleEvent extends KalturaBulkUploadResult {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadResultScheduleEvent' },
            referenceId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadResultScheduleEvent'] = KalturaBulkUploadResultScheduleEvent;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadResultScheduleResource extends KalturaBulkUploadResult {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadResultScheduleResource' },
            resourceId: { type: 's' },
            name: { type: 's' },
            type: { type: 's' },
            systemName: { type: 's' },
            description: { type: 's' },
            tags: { type: 's' },
            parentType: { type: 's' },
            parentSystemName: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadResultScheduleResource'] = KalturaBulkUploadResultScheduleResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadResultUser extends KalturaBulkUploadResult {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadResultUser' },
            userId: { type: 's' },
            screenName: { type: 's' },
            email: { type: 's' },
            description: { type: 's' },
            tags: { type: 's' },
            dateOfBirth: { type: 'n' },
            country: { type: 's' },
            state: { type: 's' },
            city: { type: 's' },
            zip: { type: 's' },
            gender: { type: 'n' },
            firstName: { type: 's' },
            lastName: { type: 's' },
            group: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadResultUser'] = KalturaBulkUploadResultUser;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadUserData extends KalturaBulkUploadObjectData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadUserData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadUserData'] = KalturaBulkUploadUserData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessNotificationTemplate extends KalturaEventNotificationTemplate {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessNotificationTemplate' },
            serverId: { type: 'n' },
            processId: { type: 's' },
            mainObjectCode: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessNotificationTemplate'] = KalturaBusinessProcessNotificationTemplate;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessServerBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessServerBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            idNotIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            statusEqual: { type: 'es', subTypeConstructor: KalturaBusinessProcessServerStatus, subType: 'KalturaBusinessProcessServerStatus' },
            statusNotEqual: { type: 'es', subTypeConstructor: KalturaBusinessProcessServerStatus, subType: 'KalturaBusinessProcessServerStatus' },
            statusIn: { type: 's' },
            statusNotIn: { type: 's' },
            typeEqual: { type: 'es', subTypeConstructor: KalturaBusinessProcessProvider, subType: 'KalturaBusinessProcessProvider' },
            typeIn: { type: 's' },
            dcEqual: { type: 'n' },
            dcEqOrNull: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessServerBaseFilter'] = KalturaBusinessProcessServerBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessServerListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessServerListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaBusinessProcessServer, subType: 'KalturaBusinessProcessServer' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessServerListResponse'] = KalturaBusinessProcessServerListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCameraScheduleResource extends KalturaScheduleResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCameraScheduleResource' },
            streamUrl: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCameraScheduleResource'] = KalturaCameraScheduleResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCaptionAssetItemListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCaptionAssetItemListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaCaptionAssetItem, subType: 'KalturaCaptionAssetItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCaptionAssetItemListResponse'] = KalturaCaptionAssetItemListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCaptionAssetListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCaptionAssetListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaCaptionAsset, subType: 'KalturaCaptionAsset' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCaptionAssetListResponse'] = KalturaCaptionAssetListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCaptionParamsListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCaptionParamsListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaCaptionParams, subType: 'KalturaCaptionParams' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCaptionParamsListResponse'] = KalturaCaptionParamsListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAssetType = {
    attachment: 'attachment.Attachment',
    caption: 'caption.Caption',
    document: 'document.Document',
    flavor: '1',
    image: 'document.Image',
    live: '3',
    pdf: 'document.PDF',
    swf: 'document.SWF',
    thumbnail: '2',
    timedThumbAsset: 'thumbCuePoint.timedThumb',
    transcript: 'transcript.Transcript',
    widevineFlavor: 'widevine.WidevineFlavor',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCaptureThumbJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCaptureThumbJobData' },
            fileContainer: { type: 'o', subTypeConstructor: KalturaFileContainer, subType: 'KalturaFileContainer' },
            actualSrcFileSyncLocalPath: { type: 's' },
            srcFileSyncRemoteUrl: { type: 's' },
            thumbParamsOutputId: { type: 'n' },
            thumbAssetId: { type: 's' },
            srcAssetId: { type: 's' },
            srcAssetEncryptionKey: { type: 's' },
            srcAssetType: { type: 'es', subTypeConstructor: KalturaAssetType, subType: 'KalturaAssetType' },
            thumbPath: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCaptureThumbJobData'] = KalturaCaptureThumbJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaCategoryEntryAdvancedOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCategoryEntryAdvancedFilter extends KalturaSearchItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCategoryEntryAdvancedFilter' },
            categoriesMatchOr: { type: 's' },
            categoryEntryStatusIn: { type: 's' },
            orderBy: { type: 'es', subTypeConstructor: KalturaCategoryEntryAdvancedOrderBy, subType: 'KalturaCategoryEntryAdvancedOrderBy' },
            categoryIdEqual: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCategoryEntryAdvancedFilter'] = KalturaCategoryEntryAdvancedFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCategoryEntryListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCategoryEntryListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaCategoryEntry, subType: 'KalturaCategoryEntry' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCategoryEntryListResponse'] = KalturaCategoryEntryListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaCategoryIdentifierField = {
    fullName: 'fullName',
    id: 'id',
    referenceId: 'referenceId',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCategoryIdentifier extends KalturaObjectIdentifier {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCategoryIdentifier' },
            identifier: { type: 'es', subTypeConstructor: KalturaCategoryIdentifierField, subType: 'KalturaCategoryIdentifierField' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCategoryIdentifier'] = KalturaCategoryIdentifier;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCategoryListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCategoryListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaCategory, subType: 'KalturaCategory' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCategoryListResponse'] = KalturaCategoryListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCategoryUserAdvancedFilter extends KalturaSearchItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCategoryUserAdvancedFilter' },
            memberIdEq: { type: 's' },
            memberIdIn: { type: 's' },
            memberPermissionsMatchOr: { type: 's' },
            memberPermissionsMatchAnd: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCategoryUserAdvancedFilter'] = KalturaCategoryUserAdvancedFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCategoryUserListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCategoryUserListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaCategoryUser, subType: 'KalturaCategoryUser' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCategoryUserListResponse'] = KalturaCategoryUserListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCategoryUserProviderFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCategoryUserProviderFilter' },
            userIdEqual: { type: 's' },
            userIdIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaCategoryUserStatus, subType: 'KalturaCategoryUserStatus' },
            statusIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'n' },
            createdAtLessThanOrEqual: { type: 'n' },
            updatedAtGreaterThanOrEqual: { type: 'n' },
            updatedAtLessThanOrEqual: { type: 'n' },
            updateMethodEqual: { type: 'en', subTypeConstructor: KalturaUpdateMethodType, subType: 'KalturaUpdateMethodType' },
            updateMethodIn: { type: 's' },
            permissionNamesMatchAnd: { type: 's' },
            permissionNamesMatchOr: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCategoryUserProviderFilter'] = KalturaCategoryUserProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaCielo24Priority = {
    priority: 'PRIORITY',
    standard: 'STANDARD',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaCielo24Fidelity = {
    mechanical: 'MECHANICAL',
    premium: 'PREMIUM',
    professional: 'PROFESSIONAL',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCielo24JobProviderData extends KalturaIntegrationJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCielo24JobProviderData' },
            entryId: { type: 's' },
            flavorAssetId: { type: 's' },
            captionAssetFormats: { type: 's' },
            priority: { type: 'es', subTypeConstructor: KalturaCielo24Priority, subType: 'KalturaCielo24Priority' },
            fidelity: { type: 'es', subTypeConstructor: KalturaCielo24Fidelity, subType: 'KalturaCielo24Fidelity' },
            username: { type: 's', readOnly: true },
            password: { type: 's', readOnly: true },
            baseUrl: { type: 's', readOnly: true },
            spokenLanguage: { type: 'es', subTypeConstructor: KalturaLanguage, subType: 'KalturaLanguage' },
            replaceMediaContent: { type: 'b' },
            additionalParameters: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCielo24JobProviderData'] = KalturaCielo24JobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaClipAttributes extends KalturaOperationAttributes {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.effectArray === 'undefined')
            this.effectArray = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaClipAttributes' },
            offset: { type: 'n' },
            duration: { type: 'n' },
            globalOffsetInDestination: { type: 'n' },
            effectArray: { type: 'a', subTypeConstructor: KalturaEffect, subType: 'KalturaEffect' }
        });
        return result;
    }
}
typesMappingStorage['KalturaClipAttributes'] = KalturaClipAttributes;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaClipConcatJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.operationAttributes === 'undefined')
            this.operationAttributes = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaClipConcatJobData' },
            partnerId: { type: 'n' },
            priority: { type: 'n' },
            operationAttributes: { type: 'a', subTypeConstructor: KalturaObject, subType: 'KalturaObject' }
        });
        return result;
    }
}
typesMappingStorage['KalturaClipConcatJobData'] = KalturaClipConcatJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCodeCuePoint extends KalturaCuePoint {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCodeCuePoint' },
            code: { type: 's' },
            description: { type: 's' },
            endTime: { type: 'n' },
            duration: { type: 'n', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaCodeCuePoint'] = KalturaCodeCuePoint;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaComcastMrssDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaComcastMrssDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaComcastMrssDistributionProvider'] = KalturaComcastMrssDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaSearchConditionComparison = {
    equal: '1',
    greaterThan: '2',
    greaterThanOrEqual: '3',
    lessThan: '4',
    lessThanOrEqual: '5',
    notEqual: '6',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCompareCondition extends KalturaCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCompareCondition' },
            value: { type: 'o', subTypeConstructor: KalturaIntegerValue, subType: 'KalturaIntegerValue' },
            comparison: { type: 'es', subTypeConstructor: KalturaSearchConditionComparison, subType: 'KalturaSearchConditionComparison' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCompareCondition'] = KalturaCompareCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDataCenterContentResource extends KalturaContentResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDataCenterContentResource' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDataCenterContentResource'] = KalturaDataCenterContentResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConcatAttributes extends KalturaOperationAttributes {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConcatAttributes' },
            resource: { type: 'o', subTypeConstructor: KalturaDataCenterContentResource, subType: 'KalturaDataCenterContentResource' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConcatAttributes'] = KalturaConcatAttributes;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConcatJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.srcFiles === 'undefined')
            this.srcFiles = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConcatJobData' },
            srcFiles: { type: 'a', subTypeConstructor: KalturaString, subType: 'KalturaString' },
            destFilePath: { type: 's' },
            flavorAssetId: { type: 's' },
            offset: { type: 'n' },
            duration: { type: 'n' },
            concatenatedDuration: { type: 'n' },
            shouldSort: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConcatJobData'] = KalturaConcatJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConfigurableDistributionJobProviderData extends KalturaDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConfigurableDistributionJobProviderData' },
            fieldValues: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConfigurableDistributionJobProviderData'] = KalturaConfigurableDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConfigurableDistributionProfile extends KalturaDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.fieldConfigArray === 'undefined')
            this.fieldConfigArray = [];
        if (typeof this.itemXpathsToExtend === 'undefined')
            this.itemXpathsToExtend = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConfigurableDistributionProfile' },
            fieldConfigArray: { type: 'a', subTypeConstructor: KalturaDistributionFieldConfig, subType: 'KalturaDistributionFieldConfig' },
            itemXpathsToExtend: { type: 'a', subTypeConstructor: KalturaExtendingItemMrssParameter, subType: 'KalturaExtendingItemMrssParameter' },
            useCategoryEntries: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConfigurableDistributionProfile'] = KalturaConfigurableDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaContentDistributionSearchItem extends KalturaSearchItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaContentDistributionSearchItem' },
            noDistributionProfiles: { type: 'b' },
            distributionProfileId: { type: 'n' },
            distributionSunStatus: { type: 'en', subTypeConstructor: KalturaEntryDistributionSunStatus, subType: 'KalturaEntryDistributionSunStatus' },
            entryDistributionFlag: { type: 'en', subTypeConstructor: KalturaEntryDistributionFlag, subType: 'KalturaEntryDistributionFlag' },
            entryDistributionStatus: { type: 'en', subTypeConstructor: KalturaEntryDistributionStatus, subType: 'KalturaEntryDistributionStatus' },
            hasEntryDistributionValidationErrors: { type: 'b' },
            entryDistributionValidationErrors: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaContentDistributionSearchItem'] = KalturaContentDistributionSearchItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaControlPanelCommandBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaControlPanelCommandBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            createdByIdEqual: { type: 'n' },
            typeEqual: { type: 'en', subTypeConstructor: KalturaControlPanelCommandType, subType: 'KalturaControlPanelCommandType' },
            typeIn: { type: 's' },
            targetTypeEqual: { type: 'en', subTypeConstructor: KalturaControlPanelCommandTargetType, subType: 'KalturaControlPanelCommandTargetType' },
            targetTypeIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaControlPanelCommandStatus, subType: 'KalturaControlPanelCommandStatus' },
            statusIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaControlPanelCommandBaseFilter'] = KalturaControlPanelCommandBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaControlPanelCommandListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaControlPanelCommandListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaControlPanelCommand, subType: 'KalturaControlPanelCommand' }
        });
        return result;
    }
}
typesMappingStorage['KalturaControlPanelCommandListResponse'] = KalturaControlPanelCommandListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConvartableJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.srcFileSyncs === 'undefined')
            this.srcFileSyncs = [];
        if (typeof this.pluginData === 'undefined')
            this.pluginData = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConvartableJobData' },
            srcFileSyncLocalPath: { type: 's' },
            actualSrcFileSyncLocalPath: { type: 's' },
            srcFileSyncRemoteUrl: { type: 's' },
            srcFileSyncs: { type: 'a', subTypeConstructor: KalturaSourceFileSyncDescriptor, subType: 'KalturaSourceFileSyncDescriptor' },
            engineVersion: { type: 'n' },
            flavorParamsOutputId: { type: 'n' },
            flavorParamsOutput: { type: 'o', subTypeConstructor: KalturaFlavorParamsOutput, subType: 'KalturaFlavorParamsOutput' },
            mediaInfoId: { type: 'n' },
            currentOperationSet: { type: 'n' },
            currentOperationIndex: { type: 'n' },
            pluginData: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConvartableJobData'] = KalturaConvartableJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConversionProfileAssetParamsListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConversionProfileAssetParamsListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaConversionProfileAssetParams, subType: 'KalturaConversionProfileAssetParams' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConversionProfileAssetParamsListResponse'] = KalturaConversionProfileAssetParamsListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConversionProfileListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConversionProfileListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaConversionProfile, subType: 'KalturaConversionProfile' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConversionProfileListResponse'] = KalturaConversionProfileListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConvertEntryFlavorsObjectTask extends KalturaObjectTask {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConvertEntryFlavorsObjectTask' },
            flavorParamsIds: { type: 's' },
            reconvert: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConvertEntryFlavorsObjectTask'] = KalturaConvertEntryFlavorsObjectTask;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConvertLiveSegmentJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConvertLiveSegmentJobData' },
            entryId: { type: 's' },
            assetId: { type: 's' },
            mediaServerIndex: { type: 'es', subTypeConstructor: KalturaEntryServerNodeType, subType: 'KalturaEntryServerNodeType' },
            fileIndex: { type: 'n' },
            srcFilePath: { type: 's' },
            destFilePath: { type: 's' },
            endTime: { type: 'n' },
            destDataFilePath: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConvertLiveSegmentJobData'] = KalturaConvertLiveSegmentJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConvertProfileJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConvertProfileJobData' },
            inputFileSyncLocalPath: { type: 's' },
            thumbHeight: { type: 'n' },
            thumbBitrate: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConvertProfileJobData'] = KalturaConvertProfileJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCopyCaptionsJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.clipsDescriptionArray === 'undefined')
            this.clipsDescriptionArray = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCopyCaptionsJobData' },
            entryId: { type: 's' },
            clipsDescriptionArray: { type: 'a', subTypeConstructor: KalturaClipDescription, subType: 'KalturaClipDescription' },
            fullCopy: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCopyCaptionsJobData'] = KalturaCopyCaptionsJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCopyPartnerJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCopyPartnerJobData' },
            fromPartnerId: { type: 'n' },
            toPartnerId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCopyPartnerJobData'] = KalturaCopyPartnerJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaCountryRestrictionType = {
    allowCountryList: 1,
    restrictCountryList: 0,
};
KalturaCountryRestrictionType[KalturaCountryRestrictionType.allowCountryList] = 'allowCountryList';
KalturaCountryRestrictionType[KalturaCountryRestrictionType.restrictCountryList] = 'restrictCountryList';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCountryRestriction extends KalturaBaseRestriction {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCountryRestriction' },
            countryRestrictionType: { type: 'en', subTypeConstructor: KalturaCountryRestrictionType, subType: 'KalturaCountryRestrictionType' },
            countryList: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCountryRestriction'] = KalturaCountryRestriction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCrossKalturaDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCrossKalturaDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCrossKalturaDistributionProvider'] = KalturaCrossKalturaDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCuePointListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCuePointListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaCuePoint, subType: 'KalturaCuePoint' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCuePointListResponse'] = KalturaCuePointListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDailymotionDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDailymotionDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDailymotionDistributionProvider'] = KalturaDailymotionDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDataListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDataListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaDataEntry, subType: 'KalturaDataEntry' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDataListResponse'] = KalturaDataListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDeleteFlavorsLogicType = {
    deleteKeepSmallest: 3,
    deleteList: 2,
    keepListDeleteOthers: 1,
};
KalturaDeleteFlavorsLogicType[KalturaDeleteFlavorsLogicType.deleteKeepSmallest] = 'deleteKeepSmallest';
KalturaDeleteFlavorsLogicType[KalturaDeleteFlavorsLogicType.deleteList] = 'deleteList';
KalturaDeleteFlavorsLogicType[KalturaDeleteFlavorsLogicType.keepListDeleteOthers] = 'keepListDeleteOthers';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeleteEntryFlavorsObjectTask extends KalturaObjectTask {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeleteEntryFlavorsObjectTask' },
            deleteType: { type: 'en', subTypeConstructor: KalturaDeleteFlavorsLogicType, subType: 'KalturaDeleteFlavorsLogicType' },
            flavorParamsIds: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeleteEntryFlavorsObjectTask'] = KalturaDeleteEntryFlavorsObjectTask;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeleteEntryObjectTask extends KalturaObjectTask {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeleteEntryObjectTask' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeleteEntryObjectTask'] = KalturaDeleteEntryObjectTask;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeleteFileJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeleteFileJobData' },
            localFileSyncPath: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeleteFileJobData'] = KalturaDeleteFileJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeleteJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeleteJobData' },
            filter: { type: 'o', subTypeConstructor: KalturaFilter, subType: 'KalturaFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeleteJobData'] = KalturaDeleteJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeleteLocalContentObjectTask extends KalturaObjectTask {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeleteLocalContentObjectTask' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeleteLocalContentObjectTask'] = KalturaDeleteLocalContentObjectTask;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileAkamaiAppleHttpManifest extends KalturaDeliveryProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileAkamaiAppleHttpManifest' },
            supportClipping: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileAkamaiAppleHttpManifest'] = KalturaDeliveryProfileAkamaiAppleHttpManifest;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileAkamaiHds extends KalturaDeliveryProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileAkamaiHds' },
            supportClipping: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileAkamaiHds'] = KalturaDeliveryProfileAkamaiHds;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileAkamaiHttp extends KalturaDeliveryProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileAkamaiHttp' },
            useIntelliseek: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileAkamaiHttp'] = KalturaDeliveryProfileAkamaiHttp;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            systemNameEqual: { type: 's' },
            systemNameIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            streamerTypeEqual: { type: 'es', subTypeConstructor: KalturaPlaybackProtocol, subType: 'KalturaPlaybackProtocol' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaDeliveryStatus, subType: 'KalturaDeliveryStatus' },
            statusIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileBaseFilter'] = KalturaDeliveryProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileCondition extends KalturaCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.deliveryProfileIds === 'undefined')
            this.deliveryProfileIds = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileCondition' },
            deliveryProfileIds: { type: 'a', subTypeConstructor: KalturaIntegerValue, subType: 'KalturaIntegerValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileCondition'] = KalturaDeliveryProfileCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileGenericAppleHttp extends KalturaDeliveryProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileGenericAppleHttp' },
            pattern: { type: 's' },
            rendererClass: { type: 's' },
            manifestRedirect: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileGenericAppleHttp'] = KalturaDeliveryProfileGenericAppleHttp;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileGenericHds extends KalturaDeliveryProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileGenericHds' },
            pattern: { type: 's' },
            rendererClass: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileGenericHds'] = KalturaDeliveryProfileGenericHds;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileGenericHttp extends KalturaDeliveryProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileGenericHttp' },
            pattern: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileGenericHttp'] = KalturaDeliveryProfileGenericHttp;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileGenericSilverLight extends KalturaDeliveryProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileGenericSilverLight' },
            pattern: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileGenericSilverLight'] = KalturaDeliveryProfileGenericSilverLight;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaDeliveryProfile, subType: 'KalturaDeliveryProfile' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileListResponse'] = KalturaDeliveryProfileListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileLiveAppleHttp extends KalturaDeliveryProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileLiveAppleHttp' },
            disableExtraAttributes: { type: 'b' },
            forceProxy: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileLiveAppleHttp'] = KalturaDeliveryProfileLiveAppleHttp;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileLivePackager extends KalturaDeliveryProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileLivePackager' },
            livePackagerSigningDomain: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileLivePackager'] = KalturaDeliveryProfileLivePackager;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileRtmp extends KalturaDeliveryProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileRtmp' },
            enforceRtmpe: { type: 'b' },
            prefix: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileRtmp'] = KalturaDeliveryProfileRtmp;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileVodPackagerPlayServer extends KalturaDeliveryProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileVodPackagerPlayServer' },
            adStitchingEnabled: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileVodPackagerPlayServer'] = KalturaDeliveryProfileVodPackagerPlayServer;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryServerNode extends KalturaServerNode {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.deliveryProfileIds === 'undefined')
            this.deliveryProfileIds = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryServerNode' },
            deliveryProfileIds: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            config: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryServerNode'] = KalturaDeliveryServerNode;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDirectoryRestrictionType = {
    displayWithLink: 1,
    dontDisplay: 0,
};
KalturaDirectoryRestrictionType[KalturaDirectoryRestrictionType.displayWithLink] = 'displayWithLink';
KalturaDirectoryRestrictionType[KalturaDirectoryRestrictionType.dontDisplay] = 'dontDisplay';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDirectoryRestriction extends KalturaBaseRestriction {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDirectoryRestriction' },
            directoryRestrictionType: { type: 'en', subTypeConstructor: KalturaDirectoryRestrictionType, subType: 'KalturaDirectoryRestrictionType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDirectoryRestriction'] = KalturaDirectoryRestriction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDispatchEventNotificationObjectTask extends KalturaObjectTask {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDispatchEventNotificationObjectTask' },
            eventNotificationTemplateId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDispatchEventNotificationObjectTask'] = KalturaDispatchEventNotificationObjectTask;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributeObjectTask extends KalturaObjectTask {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributeObjectTask' },
            distributionProfileId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributeObjectTask'] = KalturaDistributeObjectTask;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.mediaFiles === 'undefined')
            this.mediaFiles = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionJobData' },
            distributionProfileId: { type: 'n' },
            distributionProfile: { type: 'o', subTypeConstructor: KalturaDistributionProfile, subType: 'KalturaDistributionProfile' },
            entryDistributionId: { type: 'n' },
            entryDistribution: { type: 'o', subTypeConstructor: KalturaEntryDistribution, subType: 'KalturaEntryDistribution' },
            remoteId: { type: 's' },
            providerType: { type: 'es', subTypeConstructor: KalturaDistributionProviderType, subType: 'KalturaDistributionProviderType' },
            providerData: { type: 'o', subTypeConstructor: KalturaDistributionJobProviderData, subType: 'KalturaDistributionJobProviderData' },
            results: { type: 's' },
            sentData: { type: 's' },
            mediaFiles: { type: 'a', subTypeConstructor: KalturaDistributionRemoteMediaFile, subType: 'KalturaDistributionRemoteMediaFile' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionJobData'] = KalturaDistributionJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionProfileBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionProfileBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaDistributionProfileStatus, subType: 'KalturaDistributionProfileStatus' },
            statusIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionProfileBaseFilter'] = KalturaDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionProfileListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionProfileListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaDistributionProfile, subType: 'KalturaDistributionProfile' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionProfileListResponse'] = KalturaDistributionProfileListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionProviderBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionProviderBaseFilter' },
            typeEqual: { type: 'es', subTypeConstructor: KalturaDistributionProviderType, subType: 'KalturaDistributionProviderType' },
            typeIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionProviderBaseFilter'] = KalturaDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionProviderListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionProviderListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaDistributionProvider, subType: 'KalturaDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionProviderListResponse'] = KalturaDistributionProviderListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionValidationErrorConditionNotMet extends KalturaDistributionValidationError {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionValidationErrorConditionNotMet' },
            conditionName: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionValidationErrorConditionNotMet'] = KalturaDistributionValidationErrorConditionNotMet;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDistributionValidationErrorType = {
    customError: 0,
    invalidFormat: 4,
    stringEmpty: 1,
    stringTooLong: 2,
    stringTooShort: 3,
};
KalturaDistributionValidationErrorType[KalturaDistributionValidationErrorType.customError] = 'customError';
KalturaDistributionValidationErrorType[KalturaDistributionValidationErrorType.invalidFormat] = 'invalidFormat';
KalturaDistributionValidationErrorType[KalturaDistributionValidationErrorType.stringEmpty] = 'stringEmpty';
KalturaDistributionValidationErrorType[KalturaDistributionValidationErrorType.stringTooLong] = 'stringTooLong';
KalturaDistributionValidationErrorType[KalturaDistributionValidationErrorType.stringTooShort] = 'stringTooShort';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionValidationErrorInvalidData extends KalturaDistributionValidationError {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionValidationErrorInvalidData' },
            fieldName: { type: 's' },
            validationErrorType: { type: 'en', subTypeConstructor: KalturaDistributionValidationErrorType, subType: 'KalturaDistributionValidationErrorType' },
            validationErrorParam: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionValidationErrorInvalidData'] = KalturaDistributionValidationErrorInvalidData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionValidationErrorMissingAsset extends KalturaDistributionValidationError {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionValidationErrorMissingAsset' },
            data: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionValidationErrorMissingAsset'] = KalturaDistributionValidationErrorMissingAsset;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionValidationErrorMissingFlavor extends KalturaDistributionValidationError {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionValidationErrorMissingFlavor' },
            flavorParamsId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionValidationErrorMissingFlavor'] = KalturaDistributionValidationErrorMissingFlavor;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionValidationErrorMissingMetadata extends KalturaDistributionValidationError {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionValidationErrorMissingMetadata' },
            fieldName: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionValidationErrorMissingMetadata'] = KalturaDistributionValidationErrorMissingMetadata;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionValidationErrorMissingThumbnail extends KalturaDistributionValidationError {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionValidationErrorMissingThumbnail' },
            dimensions: { type: 'o', subTypeConstructor: KalturaDistributionThumbDimensions, subType: 'KalturaDistributionThumbDimensions' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionValidationErrorMissingThumbnail'] = KalturaDistributionValidationErrorMissingThumbnail;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDocumentListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDocumentListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaDocumentEntry, subType: 'KalturaDocumentEntry' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDocumentListResponse'] = KalturaDocumentListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDoubleClickDistributionJobProviderData extends KalturaDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDoubleClickDistributionJobProviderData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDoubleClickDistributionJobProviderData'] = KalturaDoubleClickDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDoubleClickDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDoubleClickDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDoubleClickDistributionProvider'] = KalturaDoubleClickDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDrmEntryContextPluginData extends KalturaPluginData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDrmEntryContextPluginData' },
            flavorData: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDrmEntryContextPluginData'] = KalturaDrmEntryContextPluginData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDrmPolicyBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDrmPolicyBaseFilter' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            nameLike: { type: 's' },
            systemNameLike: { type: 's' },
            providerEqual: { type: 'es', subTypeConstructor: KalturaDrmProviderType, subType: 'KalturaDrmProviderType' },
            providerIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaDrmPolicyStatus, subType: 'KalturaDrmPolicyStatus' },
            statusIn: { type: 's' },
            scenarioEqual: { type: 'es', subTypeConstructor: KalturaDrmLicenseScenario, subType: 'KalturaDrmLicenseScenario' },
            scenarioIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDrmPolicyBaseFilter'] = KalturaDrmPolicyBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDrmPolicyListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDrmPolicyListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaDrmPolicy, subType: 'KalturaDrmPolicy' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDrmPolicyListResponse'] = KalturaDrmPolicyListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDrmProfileBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDrmProfileBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            nameLike: { type: 's' },
            providerEqual: { type: 'es', subTypeConstructor: KalturaDrmProviderType, subType: 'KalturaDrmProviderType' },
            providerIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaDrmProfileStatus, subType: 'KalturaDrmProfileStatus' },
            statusIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDrmProfileBaseFilter'] = KalturaDrmProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDrmProfileListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDrmProfileListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaDrmProfile, subType: 'KalturaDrmProfile' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDrmProfileListResponse'] = KalturaDrmProfileListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDropFolderBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDropFolderBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            nameLike: { type: 's' },
            typeEqual: { type: 'es', subTypeConstructor: KalturaDropFolderType, subType: 'KalturaDropFolderType' },
            typeIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaDropFolderStatus, subType: 'KalturaDropFolderStatus' },
            statusIn: { type: 's' },
            conversionProfileIdEqual: { type: 'n' },
            conversionProfileIdIn: { type: 's' },
            dcEqual: { type: 'n' },
            dcIn: { type: 's' },
            pathEqual: { type: 's' },
            pathLike: { type: 's' },
            fileHandlerTypeEqual: { type: 'es', subTypeConstructor: KalturaDropFolderFileHandlerType, subType: 'KalturaDropFolderFileHandlerType' },
            fileHandlerTypeIn: { type: 's' },
            fileNamePatternsLike: { type: 's' },
            fileNamePatternsMultiLikeOr: { type: 's' },
            fileNamePatternsMultiLikeAnd: { type: 's' },
            tagsLike: { type: 's' },
            tagsMultiLikeOr: { type: 's' },
            tagsMultiLikeAnd: { type: 's' },
            errorCodeEqual: { type: 'es', subTypeConstructor: KalturaDropFolderErrorCode, subType: 'KalturaDropFolderErrorCode' },
            errorCodeIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDropFolderBaseFilter'] = KalturaDropFolderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDropFolderContentFileHandlerMatchPolicy = {
    addAsNew: 1,
    matchExistingOrAddAsNew: 2,
    matchExistingOrKeepInFolder: 3,
};
KalturaDropFolderContentFileHandlerMatchPolicy[KalturaDropFolderContentFileHandlerMatchPolicy.addAsNew] = 'addAsNew';
KalturaDropFolderContentFileHandlerMatchPolicy[KalturaDropFolderContentFileHandlerMatchPolicy.matchExistingOrAddAsNew] = 'matchExistingOrAddAsNew';
KalturaDropFolderContentFileHandlerMatchPolicy[KalturaDropFolderContentFileHandlerMatchPolicy.matchExistingOrKeepInFolder] = 'matchExistingOrKeepInFolder';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDropFolderContentFileHandlerConfig extends KalturaDropFolderFileHandlerConfig {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDropFolderContentFileHandlerConfig' },
            contentMatchPolicy: { type: 'en', subTypeConstructor: KalturaDropFolderContentFileHandlerMatchPolicy, subType: 'KalturaDropFolderContentFileHandlerMatchPolicy' },
            slugRegex: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDropFolderContentFileHandlerConfig'] = KalturaDropFolderContentFileHandlerConfig;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDropFolderContentProcessorJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDropFolderContentProcessorJobData' },
            dropFolderId: { type: 'n' },
            dropFolderFileIds: { type: 's' },
            parsedSlug: { type: 's' },
            contentMatchPolicy: { type: 'en', subTypeConstructor: KalturaDropFolderContentFileHandlerMatchPolicy, subType: 'KalturaDropFolderContentFileHandlerMatchPolicy' },
            conversionProfileId: { type: 'n' },
            parsedUserId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDropFolderContentProcessorJobData'] = KalturaDropFolderContentProcessorJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDropFolderFileBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDropFolderFileBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            dropFolderIdEqual: { type: 'n' },
            dropFolderIdIn: { type: 's' },
            fileNameEqual: { type: 's' },
            fileNameIn: { type: 's' },
            fileNameLike: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaDropFolderFileStatus, subType: 'KalturaDropFolderFileStatus' },
            statusIn: { type: 's' },
            statusNotIn: { type: 's' },
            parsedSlugEqual: { type: 's' },
            parsedSlugIn: { type: 's' },
            parsedSlugLike: { type: 's' },
            parsedFlavorEqual: { type: 's' },
            parsedFlavorIn: { type: 's' },
            parsedFlavorLike: { type: 's' },
            leadDropFolderFileIdEqual: { type: 'n' },
            deletedDropFolderFileIdEqual: { type: 'n' },
            entryIdEqual: { type: 's' },
            errorCodeEqual: { type: 'es', subTypeConstructor: KalturaDropFolderFileErrorCode, subType: 'KalturaDropFolderFileErrorCode' },
            errorCodeIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDropFolderFileBaseFilter'] = KalturaDropFolderFileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDropFolderFileListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDropFolderFileListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaDropFolderFile, subType: 'KalturaDropFolderFile' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDropFolderFileListResponse'] = KalturaDropFolderFileListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaScheduleEventType = {
    liveStream: 2,
    record: 1,
};
KalturaScheduleEventType[KalturaScheduleEventType.liveStream] = 'liveStream';
KalturaScheduleEventType[KalturaScheduleEventType.record] = 'record';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDropFolderICalBulkUploadFileHandlerConfig extends KalturaDropFolderFileHandlerConfig {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDropFolderICalBulkUploadFileHandlerConfig' },
            eventsType: { type: 'en', subTypeConstructor: KalturaScheduleEventType, subType: 'KalturaScheduleEventType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDropFolderICalBulkUploadFileHandlerConfig'] = KalturaDropFolderICalBulkUploadFileHandlerConfig;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDropFolderListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDropFolderListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaDropFolder, subType: 'KalturaDropFolder' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDropFolderListResponse'] = KalturaDropFolderListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDropFolderXmlBulkUploadFileHandlerConfig extends KalturaDropFolderFileHandlerConfig {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDropFolderXmlBulkUploadFileHandlerConfig' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDropFolderXmlBulkUploadFileHandlerConfig'] = KalturaDropFolderXmlBulkUploadFileHandlerConfig;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchCaptionItemData extends KalturaESearchItemData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchCaptionItemData' },
            line: { type: 's' },
            startsAt: { type: 'n' },
            endsAt: { type: 'n' },
            language: { type: 's' },
            captionAssetId: { type: 's' },
            label: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchCaptionItemData'] = KalturaESearchCaptionItemData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaESearchCategoryOrderByFieldName = {
    createdAt: 'created_at',
    entriesCount: 'entries_count',
    membersCount: 'members_count',
    _name: 'name',
    updatedAt: 'updated_at',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchCategoryOrderByItem extends KalturaESearchOrderByItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchCategoryOrderByItem' },
            sortField: { type: 'es', subTypeConstructor: KalturaESearchCategoryOrderByFieldName, subType: 'KalturaESearchCategoryOrderByFieldName' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchCategoryOrderByItem'] = KalturaESearchCategoryOrderByItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaESearchOperatorType = {
    andOp: 1,
    notOp: 3,
    orOp: 2,
};
KalturaESearchOperatorType[KalturaESearchOperatorType.andOp] = 'andOp';
KalturaESearchOperatorType[KalturaESearchOperatorType.notOp] = 'notOp';
KalturaESearchOperatorType[KalturaESearchOperatorType.orOp] = 'orOp';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchCategoryOperator extends KalturaESearchCategoryBaseItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.searchItems === 'undefined')
            this.searchItems = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchCategoryOperator' },
            operator: { type: 'en', subTypeConstructor: KalturaESearchOperatorType, subType: 'KalturaESearchOperatorType' },
            searchItems: { type: 'a', subTypeConstructor: KalturaESearchCategoryBaseItem, subType: 'KalturaESearchCategoryBaseItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchCategoryOperator'] = KalturaESearchCategoryOperator;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchCategoryParams extends KalturaESearchParams {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchCategoryParams' },
            searchOperator: { type: 'o', subTypeConstructor: KalturaESearchCategoryOperator, subType: 'KalturaESearchCategoryOperator' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchCategoryParams'] = KalturaESearchCategoryParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchCategoryResponse extends KalturaESearchResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchCategoryResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaESearchCategoryResult, subType: 'KalturaESearchCategoryResult' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchCategoryResponse'] = KalturaESearchCategoryResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchCuePointItemData extends KalturaESearchItemData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.tags === 'undefined')
            this.tags = [];
        if (typeof this.answers === 'undefined')
            this.answers = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchCuePointItemData' },
            cuePointType: { type: 's' },
            id: { type: 's' },
            name: { type: 's' },
            text: { type: 's' },
            tags: { type: 'a', subTypeConstructor: KalturaString, subType: 'KalturaString' },
            startTime: { type: 's' },
            endTime: { type: 's' },
            subType: { type: 's' },
            question: { type: 's' },
            answers: { type: 'a', subTypeConstructor: KalturaString, subType: 'KalturaString' },
            hint: { type: 's' },
            explanation: { type: 's' },
            assetId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchCuePointItemData'] = KalturaESearchCuePointItemData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaESearchEntryOrderByFieldName = {
    createdAt: 'created_at',
    endDate: 'end_date',
    lastPlayedAt: 'last_played_at',
    _name: 'name',
    plays: 'plays',
    startDate: 'start_date',
    updatedAt: 'updated_at',
    views: 'views',
    votes: 'votes',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchEntryOrderByItem extends KalturaESearchOrderByItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchEntryOrderByItem' },
            sortField: { type: 'es', subTypeConstructor: KalturaESearchEntryOrderByFieldName, subType: 'KalturaESearchEntryOrderByFieldName' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchEntryOrderByItem'] = KalturaESearchEntryOrderByItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchEntryOperator extends KalturaESearchEntryBaseItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.searchItems === 'undefined')
            this.searchItems = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchEntryOperator' },
            operator: { type: 'en', subTypeConstructor: KalturaESearchOperatorType, subType: 'KalturaESearchOperatorType' },
            searchItems: { type: 'a', subTypeConstructor: KalturaESearchEntryBaseItem, subType: 'KalturaESearchEntryBaseItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchEntryOperator'] = KalturaESearchEntryOperator;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchEntryParams extends KalturaESearchParams {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchEntryParams' },
            searchOperator: { type: 'o', subTypeConstructor: KalturaESearchEntryOperator, subType: 'KalturaESearchEntryOperator' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchEntryParams'] = KalturaESearchEntryParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchEntryResponse extends KalturaESearchResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchEntryResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaESearchEntryResult, subType: 'KalturaESearchEntryResult' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchEntryResponse'] = KalturaESearchEntryResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchMetadataItemData extends KalturaESearchItemData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchMetadataItemData' },
            xpath: { type: 's' },
            metadataProfileId: { type: 'n' },
            metadataFieldId: { type: 'n' },
            valueText: { type: 's' },
            valueInt: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchMetadataItemData'] = KalturaESearchMetadataItemData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchMetadataOrderByItem extends KalturaESearchOrderByItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchMetadataOrderByItem' },
            xpath: { type: 's' },
            metadataProfileId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchMetadataOrderByItem'] = KalturaESearchMetadataOrderByItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaESearchUserOrderByFieldName = {
    createdAt: 'created_at',
    updatedAt: 'updated_at',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchUserOrderByItem extends KalturaESearchOrderByItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchUserOrderByItem' },
            sortField: { type: 'es', subTypeConstructor: KalturaESearchUserOrderByFieldName, subType: 'KalturaESearchUserOrderByFieldName' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchUserOrderByItem'] = KalturaESearchUserOrderByItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchUserOperator extends KalturaESearchUserBaseItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.searchItems === 'undefined')
            this.searchItems = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchUserOperator' },
            operator: { type: 'en', subTypeConstructor: KalturaESearchOperatorType, subType: 'KalturaESearchOperatorType' },
            searchItems: { type: 'a', subTypeConstructor: KalturaESearchUserBaseItem, subType: 'KalturaESearchUserBaseItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchUserOperator'] = KalturaESearchUserOperator;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchUserParams extends KalturaESearchParams {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchUserParams' },
            searchOperator: { type: 'o', subTypeConstructor: KalturaESearchUserOperator, subType: 'KalturaESearchUserOperator' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchUserParams'] = KalturaESearchUserParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchUserResponse extends KalturaESearchResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchUserResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaESearchUserResult, subType: 'KalturaESearchUserResult' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchUserResponse'] = KalturaESearchUserResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCategoryUserBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCategoryUserBaseFilter' },
            categoryIdEqual: { type: 'n' },
            categoryIdIn: { type: 's' },
            userIdEqual: { type: 's' },
            userIdIn: { type: 's' },
            permissionLevelEqual: { type: 'en', subTypeConstructor: KalturaCategoryUserPermissionLevel, subType: 'KalturaCategoryUserPermissionLevel' },
            permissionLevelIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaCategoryUserStatus, subType: 'KalturaCategoryUserStatus' },
            statusIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            updateMethodEqual: { type: 'en', subTypeConstructor: KalturaUpdateMethodType, subType: 'KalturaUpdateMethodType' },
            updateMethodIn: { type: 's' },
            categoryFullIdsStartsWith: { type: 's' },
            categoryFullIdsEqual: { type: 's' },
            permissionNamesMatchAnd: { type: 's' },
            permissionNamesMatchOr: { type: 's' },
            permissionNamesNotContains: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCategoryUserBaseFilter'] = KalturaCategoryUserBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCategoryUserFilter extends KalturaCategoryUserBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCategoryUserFilter' },
            categoryDirectMembers: { type: 'b' },
            freeText: { type: 's' },
            relatedGroupsByUserId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCategoryUserFilter'] = KalturaCategoryUserFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEmailNotificationCategoryRecipientJobData extends KalturaEmailNotificationRecipientJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEmailNotificationCategoryRecipientJobData' },
            categoryUserFilter: { type: 'o', subTypeConstructor: KalturaCategoryUserFilter, subType: 'KalturaCategoryUserFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEmailNotificationCategoryRecipientJobData'] = KalturaEmailNotificationCategoryRecipientJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEmailNotificationCategoryRecipientProvider extends KalturaEmailNotificationRecipientProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEmailNotificationCategoryRecipientProvider' },
            categoryId: { type: 'o', subTypeConstructor: KalturaStringValue, subType: 'KalturaStringValue' },
            categoryIds: { type: 'o', subTypeConstructor: KalturaStringValue, subType: 'KalturaStringValue' },
            categoryUserFilter: { type: 'o', subTypeConstructor: KalturaCategoryUserProviderFilter, subType: 'KalturaCategoryUserProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEmailNotificationCategoryRecipientProvider'] = KalturaEmailNotificationCategoryRecipientProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEmailNotificationGroupRecipientJobData extends KalturaEmailNotificationRecipientJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEmailNotificationGroupRecipientJobData' },
            groupId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEmailNotificationGroupRecipientJobData'] = KalturaEmailNotificationGroupRecipientJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEmailNotificationGroupRecipientProvider extends KalturaEmailNotificationRecipientProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEmailNotificationGroupRecipientProvider' },
            groupId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEmailNotificationGroupRecipientProvider'] = KalturaEmailNotificationGroupRecipientProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEmailNotificationParameter extends KalturaEventNotificationParameter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEmailNotificationParameter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEmailNotificationParameter'] = KalturaEmailNotificationParameter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEmailNotificationStaticRecipientJobData extends KalturaEmailNotificationRecipientJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.emailRecipients === 'undefined')
            this.emailRecipients = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEmailNotificationStaticRecipientJobData' },
            emailRecipients: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEmailNotificationStaticRecipientJobData'] = KalturaEmailNotificationStaticRecipientJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEmailNotificationStaticRecipientProvider extends KalturaEmailNotificationRecipientProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.emailRecipients === 'undefined')
            this.emailRecipients = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEmailNotificationStaticRecipientProvider' },
            emailRecipients: { type: 'a', subTypeConstructor: KalturaEmailNotificationRecipient, subType: 'KalturaEmailNotificationRecipient' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEmailNotificationStaticRecipientProvider'] = KalturaEmailNotificationStaticRecipientProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEmailNotificationFormat = {
    html: '1',
    text: '2',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaEmailNotificationTemplatePriority = {
    high: 1,
    low: 5,
    normal: 3,
};
KalturaEmailNotificationTemplatePriority[KalturaEmailNotificationTemplatePriority.high] = 'high';
KalturaEmailNotificationTemplatePriority[KalturaEmailNotificationTemplatePriority.low] = 'low';
KalturaEmailNotificationTemplatePriority[KalturaEmailNotificationTemplatePriority.normal] = 'normal';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEmailNotificationTemplate extends KalturaEventNotificationTemplate {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.customHeaders === 'undefined')
            this.customHeaders = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEmailNotificationTemplate' },
            format: { type: 'es', subTypeConstructor: KalturaEmailNotificationFormat, subType: 'KalturaEmailNotificationFormat' },
            subject: { type: 's' },
            body: { type: 's' },
            fromEmail: { type: 's' },
            fromName: { type: 's' },
            to: { type: 'o', subTypeConstructor: KalturaEmailNotificationRecipientProvider, subType: 'KalturaEmailNotificationRecipientProvider' },
            cc: { type: 'o', subTypeConstructor: KalturaEmailNotificationRecipientProvider, subType: 'KalturaEmailNotificationRecipientProvider' },
            bcc: { type: 'o', subTypeConstructor: KalturaEmailNotificationRecipientProvider, subType: 'KalturaEmailNotificationRecipientProvider' },
            replyTo: { type: 'o', subTypeConstructor: KalturaEmailNotificationRecipientProvider, subType: 'KalturaEmailNotificationRecipientProvider' },
            priority: { type: 'en', subTypeConstructor: KalturaEmailNotificationTemplatePriority, subType: 'KalturaEmailNotificationTemplatePriority' },
            confirmReadingTo: { type: 's' },
            hostname: { type: 's' },
            messageID: { type: 's' },
            customHeaders: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEmailNotificationTemplate'] = KalturaEmailNotificationTemplate;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserBaseFilter' },
            partnerIdEqual: { type: 'n' },
            typeEqual: { type: 'en', subTypeConstructor: KalturaUserType, subType: 'KalturaUserType' },
            typeIn: { type: 's' },
            screenNameLike: { type: 's' },
            screenNameStartsWith: { type: 's' },
            emailLike: { type: 's' },
            emailStartsWith: { type: 's' },
            tagsMultiLikeOr: { type: 's' },
            tagsMultiLikeAnd: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaUserStatus, subType: 'KalturaUserStatus' },
            statusIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            firstNameStartsWith: { type: 's' },
            lastNameStartsWith: { type: 's' },
            isAdminEqual: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserBaseFilter'] = KalturaUserBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserFilter extends KalturaUserBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserFilter' },
            idOrScreenNameStartsWith: { type: 's' },
            idEqual: { type: 's' },
            idIn: { type: 's' },
            loginEnabledEqual: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            roleIdEqual: { type: 's' },
            roleIdsEqual: { type: 's' },
            roleIdsIn: { type: 's' },
            firstNameOrLastNameStartsWith: { type: 's' },
            permissionNamesMultiLikeOr: { type: 's' },
            permissionNamesMultiLikeAnd: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserFilter'] = KalturaUserFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEmailNotificationUserRecipientJobData extends KalturaEmailNotificationRecipientJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEmailNotificationUserRecipientJobData' },
            filter: { type: 'o', subTypeConstructor: KalturaUserFilter, subType: 'KalturaUserFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEmailNotificationUserRecipientJobData'] = KalturaEmailNotificationUserRecipientJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEmailNotificationUserRecipientProvider extends KalturaEmailNotificationRecipientProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEmailNotificationUserRecipientProvider' },
            filter: { type: 'o', subTypeConstructor: KalturaUserFilter, subType: 'KalturaUserFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEmailNotificationUserRecipientProvider'] = KalturaEmailNotificationUserRecipientProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryCaptionAssetSearchItem extends KalturaSearchItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryCaptionAssetSearchItem' },
            contentLike: { type: 's' },
            contentMultiLikeOr: { type: 's' },
            contentMultiLikeAnd: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryCaptionAssetSearchItem'] = KalturaEntryCaptionAssetSearchItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryContext extends KalturaContext {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryContext' },
            entryId: { type: 's' },
            followEntryRedirect: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryContext'] = KalturaEntryContext;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryContextDataParams extends KalturaAccessControlScope {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryContextDataParams' },
            flavorAssetId: { type: 's' },
            flavorTags: { type: 's' },
            streamerType: { type: 's' },
            mediaProtocol: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryContextDataParams'] = KalturaEntryContextDataParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryContextDataResult extends KalturaContextDataResult {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.accessControlMessages === 'undefined')
            this.accessControlMessages = [];
        if (typeof this.accessControlActions === 'undefined')
            this.accessControlActions = [];
        if (typeof this.flavorAssets === 'undefined')
            this.flavorAssets = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryContextDataResult' },
            isSiteRestricted: { type: 'b' },
            isCountryRestricted: { type: 'b' },
            isSessionRestricted: { type: 'b' },
            isIpAddressRestricted: { type: 'b' },
            isUserAgentRestricted: { type: 'b' },
            previewLength: { type: 'n' },
            isScheduledNow: { type: 'b' },
            isAdmin: { type: 'b' },
            streamerType: { type: 's' },
            mediaProtocol: { type: 's' },
            storageProfilesXML: { type: 's' },
            accessControlMessages: { type: 'a', subTypeConstructor: KalturaString, subType: 'KalturaString' },
            accessControlActions: { type: 'a', subTypeConstructor: KalturaRuleAction, subType: 'KalturaRuleAction' },
            flavorAssets: { type: 'a', subTypeConstructor: KalturaFlavorAsset, subType: 'KalturaFlavorAsset' },
            msDuration: { type: 'n' },
            pluginData: { type: 'm', subTypeConstructor: KalturaPluginData, subType: 'KalturaPluginData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryContextDataResult'] = KalturaEntryContextDataResult;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryCuePointSearchFilter extends KalturaSearchItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryCuePointSearchFilter' },
            cuePointsFreeText: { type: 's' },
            cuePointTypeIn: { type: 's' },
            cuePointSubTypeEqual: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryCuePointSearchFilter'] = KalturaEntryCuePointSearchFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryDistributionListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryDistributionListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaEntryDistribution, subType: 'KalturaEntryDistribution' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryDistributionListResponse'] = KalturaEntryDistributionListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEntryIdentifierField = {
    id: 'id',
    referenceId: 'referenceId',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryIdentifier extends KalturaObjectIdentifier {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryIdentifier' },
            identifier: { type: 'es', subTypeConstructor: KalturaEntryIdentifierField, subType: 'KalturaEntryIdentifierField' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryIdentifier'] = KalturaEntryIdentifier;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryLiveStats extends KalturaLiveStats {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryLiveStats' },
            entryId: { type: 's' },
            peakAudience: { type: 'n' },
            peakDvrAudience: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryLiveStats'] = KalturaEntryLiveStats;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryScheduleEvent extends KalturaScheduleEvent {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryScheduleEvent' },
            templateEntryId: { type: 's' },
            entryIds: { type: 's' },
            categoryIds: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryScheduleEvent'] = KalturaEntryScheduleEvent;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryServerNodeBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryServerNodeBaseFilter' },
            entryIdEqual: { type: 's' },
            entryIdIn: { type: 's' },
            serverNodeIdEqual: { type: 'n' },
            createdAtLessThanOrEqual: { type: 'd' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaEntryServerNodeStatus, subType: 'KalturaEntryServerNodeStatus' },
            statusIn: { type: 's' },
            serverTypeEqual: { type: 'es', subTypeConstructor: KalturaEntryServerNodeType, subType: 'KalturaEntryServerNodeType' },
            serverTypeIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryServerNodeBaseFilter'] = KalturaEntryServerNodeBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryServerNodeListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryServerNodeListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaEntryServerNode, subType: 'KalturaEntryServerNode' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryServerNodeListResponse'] = KalturaEntryServerNodeListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryTranscriptAssetSearchItem extends KalturaSearchItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryTranscriptAssetSearchItem' },
            contentLike: { type: 's' },
            contentMultiLikeOr: { type: 's' },
            contentMultiLikeAnd: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryTranscriptAssetSearchItem'] = KalturaEntryTranscriptAssetSearchItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEventType = {
    broadcastEnd: '2',
    broadcastStart: '1',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEventCuePoint extends KalturaCuePoint {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEventCuePoint' },
            eventType: { type: 'es', subTypeConstructor: KalturaEventType, subType: 'KalturaEventType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEventCuePoint'] = KalturaEventCuePoint;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBooleanField extends KalturaBooleanValue {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBooleanField' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBooleanField'] = KalturaBooleanField;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEventFieldCondition extends KalturaCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEventFieldCondition' },
            field: { type: 'o', subTypeConstructor: KalturaBooleanField, subType: 'KalturaBooleanField' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEventFieldCondition'] = KalturaEventFieldCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEventNotificationArrayParameter extends KalturaEventNotificationParameter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.values === 'undefined')
            this.values = [];
        if (typeof this.allowedValues === 'undefined')
            this.allowedValues = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEventNotificationArrayParameter' },
            values: { type: 'a', subTypeConstructor: KalturaString, subType: 'KalturaString' },
            allowedValues: { type: 'a', subTypeConstructor: KalturaStringValue, subType: 'KalturaStringValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEventNotificationArrayParameter'] = KalturaEventNotificationArrayParameter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEventNotificationDispatchJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.contentParameters === 'undefined')
            this.contentParameters = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEventNotificationDispatchJobData' },
            templateId: { type: 'n' },
            contentParameters: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEventNotificationDispatchJobData'] = KalturaEventNotificationDispatchJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEventNotificationScope extends KalturaScope {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEventNotificationScope' },
            objectId: { type: 's' },
            scopeObjectType: { type: 'es', subTypeConstructor: KalturaEventNotificationEventObjectType, subType: 'KalturaEventNotificationEventObjectType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEventNotificationScope'] = KalturaEventNotificationScope;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEventNotificationTemplateBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEventNotificationTemplateBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            systemNameEqual: { type: 's' },
            systemNameIn: { type: 's' },
            typeEqual: { type: 'es', subTypeConstructor: KalturaEventNotificationTemplateType, subType: 'KalturaEventNotificationTemplateType' },
            typeIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaEventNotificationTemplateStatus, subType: 'KalturaEventNotificationTemplateStatus' },
            statusIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEventNotificationTemplateBaseFilter'] = KalturaEventNotificationTemplateBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEventNotificationTemplateListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEventNotificationTemplateListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaEventNotificationTemplate, subType: 'KalturaEventNotificationTemplate' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEventNotificationTemplateListResponse'] = KalturaEventNotificationTemplateListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEventObjectChangedCondition extends KalturaCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEventObjectChangedCondition' },
            modifiedColumns: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEventObjectChangedCondition'] = KalturaEventObjectChangedCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaExecuteMetadataXsltObjectTask extends KalturaObjectTask {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaExecuteMetadataXsltObjectTask' },
            metadataProfileId: { type: 'n' },
            metadataObjectType: { type: 'es', subTypeConstructor: KalturaMetadataObjectType, subType: 'KalturaMetadataObjectType' },
            xslt: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaExecuteMetadataXsltObjectTask'] = KalturaExecuteMetadataXsltObjectTask;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaExternalMediaEntryListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaExternalMediaEntryListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaExternalMediaEntry, subType: 'KalturaExternalMediaEntry' }
        });
        return result;
    }
}
typesMappingStorage['KalturaExternalMediaEntryListResponse'] = KalturaExternalMediaEntryListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFacebookDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFacebookDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFacebookDistributionProvider'] = KalturaFacebookDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFairplayDrmProfile extends KalturaDrmProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFairplayDrmProfile' },
            publicCertificate: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFairplayDrmProfile'] = KalturaFairplayDrmProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFairplayEntryContextPluginData extends KalturaPluginData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFairplayEntryContextPluginData' },
            publicCertificate: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFairplayEntryContextPluginData'] = KalturaFairplayEntryContextPluginData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFeatureStatusListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFeatureStatusListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaFeatureStatus, subType: 'KalturaFeatureStatus' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFeatureStatusListResponse'] = KalturaFeatureStatusListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFeedDropFolder extends KalturaDropFolder {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFeedDropFolder' },
            itemHandlingLimit: { type: 'n' },
            feedItemInfo: { type: 'o', subTypeConstructor: KalturaFeedItemInfo, subType: 'KalturaFeedItemInfo' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFeedDropFolder'] = KalturaFeedDropFolder;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFeedDropFolderFile extends KalturaDropFolderFile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFeedDropFolderFile' },
            hash: { type: 's' },
            feedXmlPath: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFeedDropFolderFile'] = KalturaFeedDropFolderFile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFileAssetListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFileAssetListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaFileAsset, subType: 'KalturaFileAsset' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFileAssetListResponse'] = KalturaFileAssetListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFileSyncBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFileSyncBaseFilter' },
            partnerIdEqual: { type: 'n' },
            fileObjectTypeEqual: { type: 'es', subTypeConstructor: KalturaFileSyncObjectType, subType: 'KalturaFileSyncObjectType' },
            fileObjectTypeIn: { type: 's' },
            objectIdEqual: { type: 's' },
            objectIdIn: { type: 's' },
            versionEqual: { type: 's' },
            versionIn: { type: 's' },
            objectSubTypeEqual: { type: 'n' },
            objectSubTypeIn: { type: 's' },
            dcEqual: { type: 's' },
            dcIn: { type: 's' },
            originalEqual: { type: 'n' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            readyAtGreaterThanOrEqual: { type: 'n' },
            readyAtLessThanOrEqual: { type: 'n' },
            syncTimeGreaterThanOrEqual: { type: 'n' },
            syncTimeLessThanOrEqual: { type: 'n' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaFileSyncStatus, subType: 'KalturaFileSyncStatus' },
            statusIn: { type: 's' },
            fileTypeEqual: { type: 'en', subTypeConstructor: KalturaFileSyncType, subType: 'KalturaFileSyncType' },
            fileTypeIn: { type: 's' },
            linkedIdEqual: { type: 'n' },
            linkCountGreaterThanOrEqual: { type: 'n' },
            linkCountLessThanOrEqual: { type: 'n' },
            fileSizeGreaterThanOrEqual: { type: 'n' },
            fileSizeLessThanOrEqual: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFileSyncBaseFilter'] = KalturaFileSyncBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFlattenJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFlattenJobData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFlattenJobData'] = KalturaFlattenJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFlavorAssetListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFlavorAssetListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaFlavorAsset, subType: 'KalturaFlavorAsset' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFlavorAssetListResponse'] = KalturaFlavorAssetListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFlavorParamsListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFlavorParamsListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaFlavorParams, subType: 'KalturaFlavorParams' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFlavorParamsListResponse'] = KalturaFlavorParamsListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFreewheelDistributionJobProviderData extends KalturaDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.videoAssetFilePaths === 'undefined')
            this.videoAssetFilePaths = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFreewheelDistributionJobProviderData' },
            videoAssetFilePaths: { type: 'a', subTypeConstructor: KalturaFreewheelDistributionAssetPath, subType: 'KalturaFreewheelDistributionAssetPath' },
            thumbAssetFilePath: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFreewheelDistributionJobProviderData'] = KalturaFreewheelDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFreewheelDistributionProfile extends KalturaDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFreewheelDistributionProfile' },
            apikey: { type: 's' },
            email: { type: 's' },
            sftpPass: { type: 's' },
            sftpLogin: { type: 's' },
            accountId: { type: 's' },
            metadataProfileId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFreewheelDistributionProfile'] = KalturaFreewheelDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFreewheelDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFreewheelDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFreewheelDistributionProvider'] = KalturaFreewheelDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFreewheelGenericDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFreewheelGenericDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFreewheelGenericDistributionProvider'] = KalturaFreewheelGenericDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFtpDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFtpDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFtpDistributionProvider'] = KalturaFtpDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericDistributionJobProviderData extends KalturaDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericDistributionJobProviderData' },
            xml: { type: 's' },
            resultParseData: { type: 's' },
            resultParserType: { type: 'en', subTypeConstructor: KalturaGenericDistributionProviderParser, subType: 'KalturaGenericDistributionProviderParser' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericDistributionJobProviderData'] = KalturaGenericDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericDistributionProfile extends KalturaDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericDistributionProfile' },
            genericProviderId: { type: 'n' },
            submitAction: { type: 'o', subTypeConstructor: KalturaGenericDistributionProfileAction, subType: 'KalturaGenericDistributionProfileAction' },
            updateAction: { type: 'o', subTypeConstructor: KalturaGenericDistributionProfileAction, subType: 'KalturaGenericDistributionProfileAction' },
            deleteAction: { type: 'o', subTypeConstructor: KalturaGenericDistributionProfileAction, subType: 'KalturaGenericDistributionProfileAction' },
            fetchReportAction: { type: 'o', subTypeConstructor: KalturaGenericDistributionProfileAction, subType: 'KalturaGenericDistributionProfileAction' },
            updateRequiredEntryFields: { type: 's' },
            updateRequiredMetadataXPaths: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericDistributionProfile'] = KalturaGenericDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericDistributionProviderActionBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericDistributionProviderActionBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            genericDistributionProviderIdEqual: { type: 'n' },
            genericDistributionProviderIdIn: { type: 's' },
            actionEqual: { type: 'en', subTypeConstructor: KalturaDistributionAction, subType: 'KalturaDistributionAction' },
            actionIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericDistributionProviderActionBaseFilter'] = KalturaGenericDistributionProviderActionBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericDistributionProviderActionListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericDistributionProviderActionListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaGenericDistributionProviderAction, subType: 'KalturaGenericDistributionProviderAction' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericDistributionProviderActionListResponse'] = KalturaGenericDistributionProviderActionListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericDistributionProviderListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericDistributionProviderListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaGenericDistributionProvider, subType: 'KalturaGenericDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericDistributionProviderListResponse'] = KalturaGenericDistributionProviderListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericSyndicationFeed extends KalturaBaseSyndicationFeed {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericSyndicationFeed' },
            feedDescription: { type: 's' },
            feedLandingPage: { type: 's' },
            entryFilter: { type: 'o', subTypeConstructor: KalturaBaseEntryFilter, subType: 'KalturaBaseEntryFilter' },
            pageSize: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericSyndicationFeed'] = KalturaGenericSyndicationFeed;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaGoogleSyndicationFeedAdultValues = {
    no: 'No',
    yes: 'Yes',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGoogleVideoSyndicationFeed extends KalturaBaseSyndicationFeed {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGoogleVideoSyndicationFeed' },
            adultContent: { type: 'es', subTypeConstructor: KalturaGoogleSyndicationFeedAdultValues, subType: 'KalturaGoogleSyndicationFeedAdultValues' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGoogleVideoSyndicationFeed'] = KalturaGoogleVideoSyndicationFeed;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGroupUserListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGroupUserListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaGroupUser, subType: 'KalturaGroupUser' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGroupUserListResponse'] = KalturaGroupUserListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaHashCondition extends KalturaCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaHashCondition' },
            hashName: { type: 's' },
            hashSecret: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaHashCondition'] = KalturaHashCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaHttpNotificationDataFields extends KalturaHttpNotificationData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaHttpNotificationDataFields' }
        });
        return result;
    }
}
typesMappingStorage['KalturaHttpNotificationDataFields'] = KalturaHttpNotificationDataFields;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaHttpNotificationDataText extends KalturaHttpNotificationData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaHttpNotificationDataText' },
            content: { type: 'o', subTypeConstructor: KalturaStringValue, subType: 'KalturaStringValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaHttpNotificationDataText'] = KalturaHttpNotificationDataText;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaResponseType = {
    responseTypeHtml: 7,
    responseTypeJson: 1,
    responseTypeJsonp: 9,
    responseTypeMrss: 8,
    responseTypePhp: 3,
    responseTypePhpArray: 4,
    responseTypeXml: 2,
};
KalturaResponseType[KalturaResponseType.responseTypeHtml] = 'responseTypeHtml';
KalturaResponseType[KalturaResponseType.responseTypeJson] = 'responseTypeJson';
KalturaResponseType[KalturaResponseType.responseTypeJsonp] = 'responseTypeJsonp';
KalturaResponseType[KalturaResponseType.responseTypeMrss] = 'responseTypeMrss';
KalturaResponseType[KalturaResponseType.responseTypePhp] = 'responseTypePhp';
KalturaResponseType[KalturaResponseType.responseTypePhpArray] = 'responseTypePhpArray';
KalturaResponseType[KalturaResponseType.responseTypeXml] = 'responseTypeXml';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaHttpNotificationObjectData extends KalturaHttpNotificationData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.dataStringReplacements === 'undefined')
            this.dataStringReplacements = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaHttpNotificationObjectData' },
            apiObjectType: { type: 's' },
            format: { type: 'en', subTypeConstructor: KalturaResponseType, subType: 'KalturaResponseType' },
            ignoreNull: { type: 'b' },
            code: { type: 's' },
            dataStringReplacements: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaHttpNotificationObjectData'] = KalturaHttpNotificationObjectData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaHttpNotificationMethod = {
    delete: 4,
    get: 1,
    post: 2,
    put: 3,
};
KalturaHttpNotificationMethod[KalturaHttpNotificationMethod.delete] = 'delete';
KalturaHttpNotificationMethod[KalturaHttpNotificationMethod.get] = 'get';
KalturaHttpNotificationMethod[KalturaHttpNotificationMethod.post] = 'post';
KalturaHttpNotificationMethod[KalturaHttpNotificationMethod.put] = 'put';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaHttpNotificationAuthenticationMethod = {
    any: -17,
    anysafe: -18,
    basic: 1,
    digest: 2,
    gssnegotiate: 4,
    ntlm: 8,
};
KalturaHttpNotificationAuthenticationMethod[KalturaHttpNotificationAuthenticationMethod.any] = 'any';
KalturaHttpNotificationAuthenticationMethod[KalturaHttpNotificationAuthenticationMethod.anysafe] = 'anysafe';
KalturaHttpNotificationAuthenticationMethod[KalturaHttpNotificationAuthenticationMethod.basic] = 'basic';
KalturaHttpNotificationAuthenticationMethod[KalturaHttpNotificationAuthenticationMethod.digest] = 'digest';
KalturaHttpNotificationAuthenticationMethod[KalturaHttpNotificationAuthenticationMethod.gssnegotiate] = 'gssnegotiate';
KalturaHttpNotificationAuthenticationMethod[KalturaHttpNotificationAuthenticationMethod.ntlm] = 'ntlm';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaHttpNotificationSslVersion = {
    v2: 2,
    v3: 3,
};
KalturaHttpNotificationSslVersion[KalturaHttpNotificationSslVersion.v2] = 'v2';
KalturaHttpNotificationSslVersion[KalturaHttpNotificationSslVersion.v3] = 'v3';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaHttpNotificationCertificateType = {
    der: 'DER',
    eng: 'ENG',
    pem: 'PEM',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaHttpNotificationSslKeyType = {
    der: 'DER',
    eng: 'ENG',
    pem: 'PEM',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaHttpNotificationTemplate extends KalturaEventNotificationTemplate {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.customHeaders === 'undefined')
            this.customHeaders = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaHttpNotificationTemplate' },
            url: { type: 's' },
            method: { type: 'en', subTypeConstructor: KalturaHttpNotificationMethod, subType: 'KalturaHttpNotificationMethod' },
            data: { type: 'o', subTypeConstructor: KalturaHttpNotificationData, subType: 'KalturaHttpNotificationData' },
            timeout: { type: 'n' },
            connectTimeout: { type: 'n' },
            username: { type: 's' },
            password: { type: 's' },
            authenticationMethod: { type: 'en', subTypeConstructor: KalturaHttpNotificationAuthenticationMethod, subType: 'KalturaHttpNotificationAuthenticationMethod' },
            sslVersion: { type: 'en', subTypeConstructor: KalturaHttpNotificationSslVersion, subType: 'KalturaHttpNotificationSslVersion' },
            sslCertificate: { type: 's' },
            sslCertificateType: { type: 'es', subTypeConstructor: KalturaHttpNotificationCertificateType, subType: 'KalturaHttpNotificationCertificateType' },
            sslCertificatePassword: { type: 's' },
            sslEngine: { type: 's' },
            sslEngineDefault: { type: 's' },
            sslKeyType: { type: 'es', subTypeConstructor: KalturaHttpNotificationSslKeyType, subType: 'KalturaHttpNotificationSslKeyType' },
            sslKey: { type: 's' },
            sslKeyPassword: { type: 's' },
            customHeaders: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaHttpNotificationTemplate'] = KalturaHttpNotificationTemplate;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaHuluDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaHuluDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaHuluDistributionProvider'] = KalturaHuluDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaITunesSyndicationFeedCategories = {
    arts: 'Arts',
    artsDesign: 'Arts/Design',
    artsFashionBeauty: 'Arts/Fashion &amp; Beauty',
    artsFood: 'Arts/Food',
    artsLiterature: 'Arts/Literature',
    artsPerformingArts: 'Arts/Performing Arts',
    artsVisualArts: 'Arts/Visual Arts',
    business: 'Business',
    businessBusinessNews: 'Business/Business News',
    businessCareers: 'Business/Careers',
    businessInvesting: 'Business/Investing',
    businessManagementMarketing: 'Business/Management &amp; Marketing',
    businessShopping: 'Business/Shopping',
    comedy: 'Comedy',
    education: 'Education',
    educationHigherEducation: 'Education/Higher Education',
    educationK12: 'Education/K-12',
    educationLanguageCourses: 'Education/Language Courses',
    educationTechnology: 'Education/Education Technology',
    educationTraining: 'Education/Training',
    gamesHobbies: 'Games &amp; Hobbies',
    gamesHobbiesAutomotive: 'Games &amp; Hobbies/Automotive',
    gamesHobbiesAviation: 'Games &amp; Hobbies/Aviation',
    gamesHobbiesHobbies: 'Games &amp; Hobbies/Hobbies',
    gamesHobbiesOtherGames: 'Games &amp; Hobbies/Other Games',
    gamesHobbiesVideoGames: 'Games &amp; Hobbies/Video Games',
    governmentOrganizations: 'Government &amp; Organizations',
    governmentOrganizationsLocal: 'Government &amp; Organizations/Local',
    governmentOrganizationsNational: 'Government &amp; Organizations/National',
    governmentOrganizationsNonProfit: 'Government &amp; Organizations/Non-Profit',
    governmentOrganizationsRegional: 'Government &amp; Organizations/Regional',
    health: 'Health',
    healthAlternativeHealth: 'Health/Alternative Health',
    healthFitnessNutrition: 'Health/Fitness &amp; Nutrition',
    healthSelfHelp: 'Health/Self-Help',
    healthSexuality: 'Health/Sexuality',
    kidsFamily: 'Kids &amp; Family',
    music: 'Music',
    newsPolitics: 'News &amp; Politics',
    religionSpirituality: 'Religion &amp; Spirituality',
    religionSpiritualityBuddhism: 'Religion &amp; Spirituality/Buddhism',
    religionSpiritualityChristianity: 'Religion &amp; Spirituality/Christianity',
    religionSpiritualityHinduism: 'Religion &amp; Spirituality/Hinduism',
    religionSpiritualityIslam: 'Religion &amp; Spirituality/Islam',
    religionSpiritualityJudaism: 'Religion &amp; Spirituality/Judaism',
    religionSpiritualityOther: 'Religion &amp; Spirituality/Other',
    religionSpiritualitySpirituality: 'Religion &amp; Spirituality/Spirituality',
    scienceMedicine: 'Science &amp; Medicine',
    scienceMedicineMedicine: 'Science &amp; Medicine/Medicine',
    scienceMedicineNaturalSciences: 'Science &amp; Medicine/Natural Sciences',
    scienceMedicineSocialSciences: 'Science &amp; Medicine/Social Sciences',
    societyCulture: 'Society &amp; Culture',
    societyCultureHistory: 'Society &amp; Culture/History',
    societyCulturePersonalJournals: 'Society &amp; Culture/Personal Journals',
    societyCulturePhilosophy: 'Society &amp; Culture/Philosophy',
    societyCulturePlacesTravel: 'Society &amp; Culture/Places &amp; Travel',
    sportsRecreation: 'Sports &amp; Recreation',
    sportsRecreationAmateur: 'Sports &amp; Recreation/Amateur',
    sportsRecreationCollegeHighSchool: 'Sports &amp; Recreation/College &amp; High School',
    sportsRecreationOutdoor: 'Sports &amp; Recreation/Outdoor',
    sportsRecreationProfessional: 'Sports &amp; Recreation/Professional',
    technology: 'Technology',
    technologyGadgets: 'Technology/Gadgets',
    technologyPodcasting: 'Technology/Podcasting',
    technologySoftwareHowTo: 'Technology/Software How-To',
    technologyTechNews: 'Technology/Tech News',
    tvFilm: 'TV &amp; Film',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaITunesSyndicationFeedAdultValues = {
    clean: 'clean',
    no: 'no',
    yes: 'yes',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaITunesSyndicationFeed extends KalturaBaseSyndicationFeed {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaITunesSyndicationFeed' },
            feedDescription: { type: 's' },
            language: { type: 's' },
            feedLandingPage: { type: 's' },
            ownerName: { type: 's' },
            ownerEmail: { type: 's' },
            feedImageUrl: { type: 's' },
            category: { type: 'es', readOnly: true, subTypeConstructor: KalturaITunesSyndicationFeedCategories, subType: 'KalturaITunesSyndicationFeedCategories' },
            adultContent: { type: 'es', subTypeConstructor: KalturaITunesSyndicationFeedAdultValues, subType: 'KalturaITunesSyndicationFeedAdultValues' },
            feedAuthor: { type: 's' },
            enforceFeedAuthor: { type: 'b' },
            enforceOrder: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaITunesSyndicationFeed'] = KalturaITunesSyndicationFeed;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIdeticDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIdeticDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIdeticDistributionProvider'] = KalturaIdeticDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaImportJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaImportJobData' },
            srcFileUrl: { type: 's' },
            destFileLocalPath: { type: 's' },
            flavorAssetId: { type: 's' },
            fileSize: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaImportJobData'] = KalturaImportJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaImportMetadataJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaImportMetadataJobData' },
            srcFileUrl: { type: 's' },
            destFileLocalPath: { type: 's' },
            metadataId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaImportMetadataJobData'] = KalturaImportMetadataJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIndexAdvancedFilter extends KalturaSearchItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIndexAdvancedFilter' },
            indexIdGreaterThan: { type: 'n' },
            depthGreaterThanEqual: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIndexAdvancedFilter'] = KalturaIndexAdvancedFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIndexJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIndexJobData' },
            filter: { type: 'o', subTypeConstructor: KalturaFilter, subType: 'KalturaFilter' },
            lastIndexId: { type: 'n' },
            lastIndexDepth: { type: 'n' },
            shouldUpdate: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIndexJobData'] = KalturaIndexJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIndexTagsByPrivacyContextJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIndexTagsByPrivacyContextJobData' },
            changedCategoryId: { type: 'n' },
            deletedPrivacyContexts: { type: 's' },
            addedPrivacyContexts: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIndexTagsByPrivacyContextJobData'] = KalturaIndexTagsByPrivacyContextJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaIntegrationProviderType = {
    cielo24: 'cielo24.Cielo24',
    voicebase: 'voicebase.Voicebase',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaIntegrationTriggerType = {
    bpmEventNotification: 'bpmEventNotificationIntegration.BpmEventNotification',
    manual: '1',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIntegrationJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIntegrationJobData' },
            callbackNotificationUrl: { type: 's', readOnly: true },
            providerType: { type: 'es', subTypeConstructor: KalturaIntegrationProviderType, subType: 'KalturaIntegrationProviderType' },
            providerData: { type: 'o', subTypeConstructor: KalturaIntegrationJobProviderData, subType: 'KalturaIntegrationJobProviderData' },
            triggerType: { type: 'es', subTypeConstructor: KalturaIntegrationTriggerType, subType: 'KalturaIntegrationTriggerType' },
            triggerData: { type: 'o', subTypeConstructor: KalturaIntegrationJobTriggerData, subType: 'KalturaIntegrationJobTriggerData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIntegrationJobData'] = KalturaIntegrationJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaIpAddressRestrictionType = {
    allowList: 1,
    restrictList: 0,
};
KalturaIpAddressRestrictionType[KalturaIpAddressRestrictionType.allowList] = 'allowList';
KalturaIpAddressRestrictionType[KalturaIpAddressRestrictionType.restrictList] = 'restrictList';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIpAddressRestriction extends KalturaBaseRestriction {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIpAddressRestriction' },
            ipAddressRestrictionType: { type: 'en', subTypeConstructor: KalturaIpAddressRestrictionType, subType: 'KalturaIpAddressRestrictionType' },
            ipAddressList: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIpAddressRestriction'] = KalturaIpAddressRestriction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaKontikiStorageProfile extends KalturaStorageProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaKontikiStorageProfile' },
            serviceToken: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaKontikiStorageProfile'] = KalturaKontikiStorageProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLikeListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLikeListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaLike, subType: 'KalturaLike' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLikeListResponse'] = KalturaLikeListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaLimitFlavorsRestrictionType = {
    allowList: 1,
    restrictList: 0,
};
KalturaLimitFlavorsRestrictionType[KalturaLimitFlavorsRestrictionType.allowList] = 'allowList';
KalturaLimitFlavorsRestrictionType[KalturaLimitFlavorsRestrictionType.restrictList] = 'restrictList';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLimitFlavorsRestriction extends KalturaBaseRestriction {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLimitFlavorsRestriction' },
            limitFlavorsRestrictionType: { type: 'en', subTypeConstructor: KalturaLimitFlavorsRestrictionType, subType: 'KalturaLimitFlavorsRestrictionType' },
            flavorParamsIds: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLimitFlavorsRestriction'] = KalturaLimitFlavorsRestriction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveChannelListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveChannelListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaLiveChannel, subType: 'KalturaLiveChannel' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveChannelListResponse'] = KalturaLiveChannelListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveChannelSegmentListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveChannelSegmentListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaLiveChannelSegment, subType: 'KalturaLiveChannelSegment' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveChannelSegmentListResponse'] = KalturaLiveChannelSegmentListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveEntryScheduleResource extends KalturaScheduleResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveEntryScheduleResource' },
            entryId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveEntryScheduleResource'] = KalturaLiveEntryScheduleResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveEntryServerNode extends KalturaEntryServerNode {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.streams === 'undefined')
            this.streams = [];
        if (typeof this.recordingInfo === 'undefined')
            this.recordingInfo = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveEntryServerNode' },
            streams: { type: 'a', subTypeConstructor: KalturaLiveStreamParams, subType: 'KalturaLiveStreamParams' },
            recordingInfo: { type: 'a', subTypeConstructor: KalturaLiveEntryServerNodeRecordingInfo, subType: 'KalturaLiveEntryServerNodeRecordingInfo' },
            isPlayableUser: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveEntryServerNode'] = KalturaLiveEntryServerNode;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveReportExportJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveReportExportJobData' },
            timeReference: { type: 'd' },
            timeZoneOffset: { type: 'n' },
            entryIds: { type: 's' },
            outputPath: { type: 's' },
            recipientEmail: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveReportExportJobData'] = KalturaLiveReportExportJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStatsListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStatsListResponse' },
            objects: { type: 'o', subTypeConstructor: KalturaLiveStats, subType: 'KalturaLiveStats' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStatsListResponse'] = KalturaLiveStatsListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaLiveStreamEntry, subType: 'KalturaLiveStreamEntry' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamListResponse'] = KalturaLiveStreamListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamPushPublishRTMPConfiguration extends KalturaLiveStreamPushPublishConfiguration {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamPushPublishRTMPConfiguration' },
            userId: { type: 's' },
            password: { type: 's' },
            streamName: { type: 's' },
            applicationName: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamPushPublishRTMPConfiguration'] = KalturaLiveStreamPushPublishRTMPConfiguration;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveToVodJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveToVodJobData' },
            vodEntryId: { type: 's' },
            liveEntryId: { type: 's' },
            totalVodDuration: { type: 'n' },
            lastSegmentDuration: { type: 'n' },
            amfArray: { type: 's' },
            lastCuePointSyncTime: { type: 'd' },
            lastSegmentDrift: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveToVodJobData'] = KalturaLiveToVodJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLocationScheduleResource extends KalturaScheduleResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLocationScheduleResource' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLocationScheduleResource'] = KalturaLocationScheduleResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaMailType = {
    mailTypeAccountReactiveConfirm: '86',
    mailTypeAccountUpgradeConfirm: '80',
    mailTypeAddedKalturaToHisFavorites: '32',
    mailTypeAddedKalturaToHisFavoritesSubscribed: '42',
    mailTypeAddedKalturaToYourFavorites: '23',
    mailTypeAddedToClipFavorites: '12',
    mailTypeAddedToFavorites: '11',
    mailTypeBulkuploadAborted: '66',
    mailTypeBulkuploadFailed: '65',
    mailTypeBulkuploadFinished: '64',
    mailTypeBulkDownloadReady: '63',
    mailTypeClipAdded: '30',
    mailTypeClipAddedYourKaltura: '20',
    mailTypeClipContributed: '40',
    mailTypeKalturaNewsletter: '10',
    mailTypeLiveReportExportAbort: '132',
    mailTypeLiveReportExportFailure: '131',
    mailTypeLiveReportExportSuccess: '130',
    mailTypeLoginMailReset: '52',
    mailTypeNewCommentInKaltura: '24',
    mailTypeNewCommentInKalturaYouContributed: '33',
    mailTypeNewCommentInKalturaYouSubscribed: '43',
    mailTypeNewCommentInProfile: '13',
    mailTypeNotifyErr: '70',
    mailTypePasswordReset: '51',
    mailTypeRegisterConfirm: '50',
    mailTypeRegisterConfirmVideoService: '54',
    mailTypeRoughcutCreated: '22',
    mailTypeRoughcutCreatedSubscribed: '41',
    mailTypeSystemUserCredentialsSaved: '113',
    mailTypeSystemUserNewPassword: '112',
    mailTypeSystemUserResetPassword: '110',
    mailTypeSystemUserResetPasswordSuccess: '111',
    mailTypeUsersCsv: '133',
    mailTypeVideoAdded: '21',
    mailTypeVideoCreated: '31',
    mailTypeVideoIsReady: '62',
    mailTypeVideoReady: '60',
    mailTypeVideoServiceNotice: '81',
    mailTypeVideoServiceNoticeAccountDeleted: '84',
    mailTypeVideoServiceNoticeAccountLocked: '83',
    mailTypeVideoServiceNoticeLimitReached: '82',
    mailTypeVideoServiceNoticeUpgradeOffer: '85',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaMailJobStatus = {
    error: 3,
    pending: 1,
    queued: 4,
    sent: 2,
};
KalturaMailJobStatus[KalturaMailJobStatus.error] = 'error';
KalturaMailJobStatus[KalturaMailJobStatus.pending] = 'pending';
KalturaMailJobStatus[KalturaMailJobStatus.queued] = 'queued';
KalturaMailJobStatus[KalturaMailJobStatus.sent] = 'sent';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMailJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMailJobData' },
            mailType: { type: 'es', subTypeConstructor: KalturaMailType, subType: 'KalturaMailType' },
            mailPriority: { type: 'n' },
            status: { type: 'en', subTypeConstructor: KalturaMailJobStatus, subType: 'KalturaMailJobStatus' },
            recipientName: { type: 's' },
            recipientEmail: { type: 's' },
            recipientId: { type: 'n' },
            fromName: { type: 's' },
            fromEmail: { type: 's' },
            bodyParams: { type: 's' },
            subjectParams: { type: 's' },
            templatePath: { type: 's' },
            language: { type: 'es', subTypeConstructor: KalturaLanguageCode, subType: 'KalturaLanguageCode' },
            campaignId: { type: 'n' },
            minSendDate: { type: 'n' },
            isHtml: { type: 'b' },
            separator: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMailJobData'] = KalturaMailJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMailNotificationObjectTask extends KalturaObjectTask {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMailNotificationObjectTask' },
            mailTo: { type: 's' },
            sender: { type: 's' },
            subject: { type: 's' },
            message: { type: 's' },
            footer: { type: 's' },
            link: { type: 's' },
            sendToUsers: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMailNotificationObjectTask'] = KalturaMailNotificationObjectTask;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaMatchConditionType = {
    matchAll: '2',
    matchAny: '1',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMatchCondition extends KalturaCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.values === 'undefined')
            this.values = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMatchCondition' },
            values: { type: 'a', subTypeConstructor: KalturaStringValue, subType: 'KalturaStringValue' },
            matchType: { type: 'es', subTypeConstructor: KalturaMatchConditionType, subType: 'KalturaMatchConditionType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMatchCondition'] = KalturaMatchCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaInfoBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaInfoBaseFilter' },
            flavorAssetIdEqual: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaInfoBaseFilter'] = KalturaMediaInfoBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaMediaEntry, subType: 'KalturaMediaEntry' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaListResponse'] = KalturaMediaListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetadataListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetadataListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaMetadata, subType: 'KalturaMetadata' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetadataListResponse'] = KalturaMetadataListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetadataProfileBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetadataProfileBaseFilter' },
            idEqual: { type: 'n' },
            partnerIdEqual: { type: 'n' },
            metadataObjectTypeEqual: { type: 'es', subTypeConstructor: KalturaMetadataObjectType, subType: 'KalturaMetadataObjectType' },
            metadataObjectTypeIn: { type: 's' },
            versionEqual: { type: 'n' },
            nameEqual: { type: 's' },
            systemNameEqual: { type: 's' },
            systemNameIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaMetadataProfileStatus, subType: 'KalturaMetadataProfileStatus' },
            statusIn: { type: 's' },
            createModeEqual: { type: 'en', subTypeConstructor: KalturaMetadataProfileCreateMode, subType: 'KalturaMetadataProfileCreateMode' },
            createModeNotEqual: { type: 'en', subTypeConstructor: KalturaMetadataProfileCreateMode, subType: 'KalturaMetadataProfileCreateMode' },
            createModeIn: { type: 's' },
            createModeNotIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetadataProfileBaseFilter'] = KalturaMetadataProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetadataProfileFieldListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetadataProfileFieldListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaMetadataProfileField, subType: 'KalturaMetadataProfileField' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetadataProfileFieldListResponse'] = KalturaMetadataProfileFieldListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetadataProfileListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetadataProfileListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaMetadataProfile, subType: 'KalturaMetadataProfile' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetadataProfileListResponse'] = KalturaMetadataProfileListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetadataReplacementOptionsItem extends KalturaPluginReplacementOptionsItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetadataReplacementOptionsItem' },
            shouldCopyMetadata: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetadataReplacementOptionsItem'] = KalturaMetadataReplacementOptionsItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetadataResponseProfileMapping extends KalturaResponseProfileMapping {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetadataResponseProfileMapping' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetadataResponseProfileMapping'] = KalturaMetadataResponseProfileMapping;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetroPcsDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetroPcsDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetroPcsDistributionProvider'] = KalturaMetroPcsDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMixListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMixListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaMixEntry, subType: 'KalturaMixEntry' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMixListResponse'] = KalturaMixListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaModerationFlagListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaModerationFlagListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaModerationFlag, subType: 'KalturaModerationFlag' }
        });
        return result;
    }
}
typesMappingStorage['KalturaModerationFlagListResponse'] = KalturaModerationFlagListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaScheduledTaskAddOrRemoveType = {
    add: 1,
    move: 3,
    remove: 2,
};
KalturaScheduledTaskAddOrRemoveType[KalturaScheduledTaskAddOrRemoveType.add] = 'add';
KalturaScheduledTaskAddOrRemoveType[KalturaScheduledTaskAddOrRemoveType.move] = 'move';
KalturaScheduledTaskAddOrRemoveType[KalturaScheduledTaskAddOrRemoveType.remove] = 'remove';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaModifyCategoriesObjectTask extends KalturaObjectTask {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.categoryIds === 'undefined')
            this.categoryIds = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaModifyCategoriesObjectTask' },
            addRemoveType: { type: 'en', subTypeConstructor: KalturaScheduledTaskAddOrRemoveType, subType: 'KalturaScheduledTaskAddOrRemoveType' },
            categoryIds: { type: 'a', subTypeConstructor: KalturaIntegerValue, subType: 'KalturaIntegerValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaModifyCategoriesObjectTask'] = KalturaModifyCategoriesObjectTask;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaModifyEntryObjectTask extends KalturaObjectTask {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.inputMetadata === 'undefined')
            this.inputMetadata = [];
        if (typeof this.outputMetadata === 'undefined')
            this.outputMetadata = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaModifyEntryObjectTask' },
            inputMetadataProfileId: { type: 'n' },
            inputMetadata: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            outputMetadataProfileId: { type: 'n' },
            outputMetadata: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            inputUserId: { type: 's' },
            inputEntitledUsersEdit: { type: 's' },
            inputEntitledUsersPublish: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaModifyEntryObjectTask'] = KalturaModifyEntryObjectTask;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMoveCategoryEntriesJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMoveCategoryEntriesJobData' },
            srcCategoryId: { type: 'n' },
            destCategoryId: { type: 'n' },
            lastMovedCategoryId: { type: 'n' },
            lastMovedCategoryPageIndex: { type: 'n' },
            lastMovedCategoryEntryPageIndex: { type: 'n' },
            moveFromChildren: { type: 'b' },
            destCategoryFullIds: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMoveCategoryEntriesJobData'] = KalturaMoveCategoryEntriesJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMsnDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMsnDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMsnDistributionProvider'] = KalturaMsnDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaNotificationType = {
    entryAdd: 1,
    entryBlock: 4,
    entryDelete: 3,
    entryUpdate: 5,
    entryUpdateModeration: 7,
    entryUpdateThumbnail: 6,
    entrUpdatePermissions: 2,
    userAdd: 21,
    userBanned: 26,
};
KalturaNotificationType[KalturaNotificationType.entryAdd] = 'entryAdd';
KalturaNotificationType[KalturaNotificationType.entryBlock] = 'entryBlock';
KalturaNotificationType[KalturaNotificationType.entryDelete] = 'entryDelete';
KalturaNotificationType[KalturaNotificationType.entryUpdate] = 'entryUpdate';
KalturaNotificationType[KalturaNotificationType.entryUpdateModeration] = 'entryUpdateModeration';
KalturaNotificationType[KalturaNotificationType.entryUpdateThumbnail] = 'entryUpdateThumbnail';
KalturaNotificationType[KalturaNotificationType.entrUpdatePermissions] = 'entrUpdatePermissions';
KalturaNotificationType[KalturaNotificationType.userAdd] = 'userAdd';
KalturaNotificationType[KalturaNotificationType.userBanned] = 'userBanned';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaNotificationStatus = {
    error: 3,
    errorResending: 5,
    pending: 1,
    queued: 7,
    sent: 2,
    sentSynch: 6,
    shouldResend: 4,
};
KalturaNotificationStatus[KalturaNotificationStatus.error] = 'error';
KalturaNotificationStatus[KalturaNotificationStatus.errorResending] = 'errorResending';
KalturaNotificationStatus[KalturaNotificationStatus.pending] = 'pending';
KalturaNotificationStatus[KalturaNotificationStatus.queued] = 'queued';
KalturaNotificationStatus[KalturaNotificationStatus.sent] = 'sent';
KalturaNotificationStatus[KalturaNotificationStatus.sentSynch] = 'sentSynch';
KalturaNotificationStatus[KalturaNotificationStatus.shouldResend] = 'shouldResend';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaNotificationObjectType = {
    batchJob: 4,
    entry: 1,
    kshow: 2,
    user: 3,
};
KalturaNotificationObjectType[KalturaNotificationObjectType.batchJob] = 'batchJob';
KalturaNotificationObjectType[KalturaNotificationObjectType.entry] = 'entry';
KalturaNotificationObjectType[KalturaNotificationObjectType.kshow] = 'kshow';
KalturaNotificationObjectType[KalturaNotificationObjectType.user] = 'user';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaNotificationJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaNotificationJobData' },
            userId: { type: 's' },
            type: { type: 'en', subTypeConstructor: KalturaNotificationType, subType: 'KalturaNotificationType' },
            typeAsString: { type: 's' },
            objectId: { type: 's' },
            status: { type: 'en', subTypeConstructor: KalturaNotificationStatus, subType: 'KalturaNotificationStatus' },
            data: { type: 's' },
            numberOfAttempts: { type: 'n' },
            notificationResult: { type: 's' },
            objType: { type: 'en', subTypeConstructor: KalturaNotificationObjectType, subType: 'KalturaNotificationObjectType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaNotificationJobData'] = KalturaNotificationJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaObjectListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaObjectListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaObject, subType: 'KalturaObject' }
        });
        return result;
    }
}
typesMappingStorage['KalturaObjectListResponse'] = KalturaObjectListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaOrCondition extends KalturaCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.conditions === 'undefined')
            this.conditions = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaOrCondition' },
            conditions: { type: 'a', subTypeConstructor: KalturaCondition, subType: 'KalturaCondition' }
        });
        return result;
    }
}
typesMappingStorage['KalturaOrCondition'] = KalturaOrCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaParseCaptionAssetJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaParseCaptionAssetJobData' },
            captionAssetId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaParseCaptionAssetJobData'] = KalturaParseCaptionAssetJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaParseMultiLanguageCaptionAssetJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaParseMultiLanguageCaptionAssetJobData' },
            multiLanaguageCaptionAssetId: { type: 's' },
            entryId: { type: 's' },
            fileLocation: { type: 's' },
            fileEncryptionKey: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaParseMultiLanguageCaptionAssetJobData'] = KalturaParseMultiLanguageCaptionAssetJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPartnerBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPartnerBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            idNotIn: { type: 's' },
            nameLike: { type: 's' },
            nameMultiLikeOr: { type: 's' },
            nameMultiLikeAnd: { type: 's' },
            nameEqual: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaPartnerStatus, subType: 'KalturaPartnerStatus' },
            statusIn: { type: 's' },
            partnerPackageEqual: { type: 'n' },
            partnerPackageGreaterThanOrEqual: { type: 'n' },
            partnerPackageLessThanOrEqual: { type: 'n' },
            partnerPackageIn: { type: 's' },
            partnerGroupTypeEqual: { type: 'en', subTypeConstructor: KalturaPartnerGroupType, subType: 'KalturaPartnerGroupType' },
            partnerNameDescriptionWebsiteAdminNameAdminEmailLike: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPartnerBaseFilter'] = KalturaPartnerBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPartnerListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPartnerListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaPartner, subType: 'KalturaPartner' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPartnerListResponse'] = KalturaPartnerListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPartnerUsageListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPartnerUsageListResponse' },
            total: { type: 'o', subTypeConstructor: KalturaVarPartnerUsageItem, subType: 'KalturaVarPartnerUsageItem' },
            objects: { type: 'a', subTypeConstructor: KalturaVarPartnerUsageItem, subType: 'KalturaVarPartnerUsageItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPartnerUsageListResponse'] = KalturaPartnerUsageListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPermissionItemListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPermissionItemListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaPermissionItem, subType: 'KalturaPermissionItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPermissionItemListResponse'] = KalturaPermissionItemListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPermissionListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPermissionListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaPermission, subType: 'KalturaPermission' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPermissionListResponse'] = KalturaPermissionListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayReadyCopyRight extends KalturaPlayReadyRight {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.copyEnablers === 'undefined')
            this.copyEnablers = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayReadyCopyRight' },
            copyCount: { type: 'n' },
            copyEnablers: { type: 'a', subTypeConstructor: KalturaPlayReadyCopyEnablerHolder, subType: 'KalturaPlayReadyCopyEnablerHolder' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayReadyCopyRight'] = KalturaPlayReadyCopyRight;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaPlayReadyAnalogVideoOPL = {
    min100: 100,
    min150: 150,
    min200: 200,
};
KalturaPlayReadyAnalogVideoOPL[KalturaPlayReadyAnalogVideoOPL.min100] = 'min100';
KalturaPlayReadyAnalogVideoOPL[KalturaPlayReadyAnalogVideoOPL.min150] = 'min150';
KalturaPlayReadyAnalogVideoOPL[KalturaPlayReadyAnalogVideoOPL.min200] = 'min200';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaPlayReadyDigitalAudioOPL = {
    min100: 100,
    min150: 150,
    min200: 200,
    min250: 250,
    min300: 300,
};
KalturaPlayReadyDigitalAudioOPL[KalturaPlayReadyDigitalAudioOPL.min100] = 'min100';
KalturaPlayReadyDigitalAudioOPL[KalturaPlayReadyDigitalAudioOPL.min150] = 'min150';
KalturaPlayReadyDigitalAudioOPL[KalturaPlayReadyDigitalAudioOPL.min200] = 'min200';
KalturaPlayReadyDigitalAudioOPL[KalturaPlayReadyDigitalAudioOPL.min250] = 'min250';
KalturaPlayReadyDigitalAudioOPL[KalturaPlayReadyDigitalAudioOPL.min300] = 'min300';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaPlayReadyCompressedDigitalVideoOPL = {
    min400: 400,
    min500: 500,
};
KalturaPlayReadyCompressedDigitalVideoOPL[KalturaPlayReadyCompressedDigitalVideoOPL.min400] = 'min400';
KalturaPlayReadyCompressedDigitalVideoOPL[KalturaPlayReadyCompressedDigitalVideoOPL.min500] = 'min500';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaPlayReadyUncompressedDigitalVideoOPL = {
    min100: 100,
    min250: 250,
    min270: 270,
    min300: 300,
};
KalturaPlayReadyUncompressedDigitalVideoOPL[KalturaPlayReadyUncompressedDigitalVideoOPL.min100] = 'min100';
KalturaPlayReadyUncompressedDigitalVideoOPL[KalturaPlayReadyUncompressedDigitalVideoOPL.min250] = 'min250';
KalturaPlayReadyUncompressedDigitalVideoOPL[KalturaPlayReadyUncompressedDigitalVideoOPL.min270] = 'min270';
KalturaPlayReadyUncompressedDigitalVideoOPL[KalturaPlayReadyUncompressedDigitalVideoOPL.min300] = 'min300';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayReadyPlayRight extends KalturaPlayReadyRight {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.analogVideoOutputProtectionList === 'undefined')
            this.analogVideoOutputProtectionList = [];
        if (typeof this.digitalAudioOutputProtectionList === 'undefined')
            this.digitalAudioOutputProtectionList = [];
        if (typeof this.playEnablers === 'undefined')
            this.playEnablers = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayReadyPlayRight' },
            analogVideoOPL: { type: 'en', subTypeConstructor: KalturaPlayReadyAnalogVideoOPL, subType: 'KalturaPlayReadyAnalogVideoOPL' },
            analogVideoOutputProtectionList: { type: 'a', subTypeConstructor: KalturaPlayReadyAnalogVideoOPIdHolder, subType: 'KalturaPlayReadyAnalogVideoOPIdHolder' },
            compressedDigitalAudioOPL: { type: 'en', subTypeConstructor: KalturaPlayReadyDigitalAudioOPL, subType: 'KalturaPlayReadyDigitalAudioOPL' },
            compressedDigitalVideoOPL: { type: 'en', subTypeConstructor: KalturaPlayReadyCompressedDigitalVideoOPL, subType: 'KalturaPlayReadyCompressedDigitalVideoOPL' },
            digitalAudioOutputProtectionList: { type: 'a', subTypeConstructor: KalturaPlayReadyDigitalAudioOPIdHolder, subType: 'KalturaPlayReadyDigitalAudioOPIdHolder' },
            uncompressedDigitalAudioOPL: { type: 'en', subTypeConstructor: KalturaPlayReadyDigitalAudioOPL, subType: 'KalturaPlayReadyDigitalAudioOPL' },
            uncompressedDigitalVideoOPL: { type: 'en', subTypeConstructor: KalturaPlayReadyUncompressedDigitalVideoOPL, subType: 'KalturaPlayReadyUncompressedDigitalVideoOPL' },
            firstPlayExpiration: { type: 'n' },
            playEnablers: { type: 'a', subTypeConstructor: KalturaPlayReadyPlayEnablerHolder, subType: 'KalturaPlayReadyPlayEnablerHolder' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayReadyPlayRight'] = KalturaPlayReadyPlayRight;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayReadyProfile extends KalturaDrmProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayReadyProfile' },
            keySeed: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayReadyProfile'] = KalturaPlayReadyProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlaylistListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlaylistListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaPlaylist, subType: 'KalturaPlaylist' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlaylistListResponse'] = KalturaPlaylistListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaProvisionJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaProvisionJobData' },
            streamID: { type: 's' },
            backupStreamID: { type: 's' },
            rtmp: { type: 's' },
            encoderIP: { type: 's' },
            backupEncoderIP: { type: 's' },
            encoderPassword: { type: 's' },
            encoderUsername: { type: 's' },
            endDate: { type: 'n' },
            returnVal: { type: 's' },
            mediaType: { type: 'n' },
            primaryBroadcastingUrl: { type: 's' },
            secondaryBroadcastingUrl: { type: 's' },
            streamName: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaProvisionJobData'] = KalturaProvisionJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPushNotificationTemplate extends KalturaEventNotificationTemplate {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.queueNameParameters === 'undefined')
            this.queueNameParameters = [];
        if (typeof this.queueKeyParameters === 'undefined')
            this.queueKeyParameters = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPushNotificationTemplate' },
            queueNameParameters: { type: 'a', subTypeConstructor: KalturaPushEventNotificationParameter, subType: 'KalturaPushEventNotificationParameter' },
            queueKeyParameters: { type: 'a', subTypeConstructor: KalturaPushEventNotificationParameter, subType: 'KalturaPushEventNotificationParameter' },
            apiObjectType: { type: 's' },
            objectFormat: { type: 'en', subTypeConstructor: KalturaResponseType, subType: 'KalturaResponseType' },
            responseProfileId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPushNotificationTemplate'] = KalturaPushNotificationTemplate;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaQuestionType = {
    fillInBlank: 5,
    goTo: 7,
    hotSpot: 6,
    multipleAnswerQuestion: 4,
    multipleChoiceAnswer: 1,
    reflectionPoint: 3,
    trueFalse: 2,
};
KalturaQuestionType[KalturaQuestionType.fillInBlank] = 'fillInBlank';
KalturaQuestionType[KalturaQuestionType.goTo] = 'goTo';
KalturaQuestionType[KalturaQuestionType.hotSpot] = 'hotSpot';
KalturaQuestionType[KalturaQuestionType.multipleAnswerQuestion] = 'multipleAnswerQuestion';
KalturaQuestionType[KalturaQuestionType.multipleChoiceAnswer] = 'multipleChoiceAnswer';
KalturaQuestionType[KalturaQuestionType.reflectionPoint] = 'reflectionPoint';
KalturaQuestionType[KalturaQuestionType.trueFalse] = 'trueFalse';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaQuestionCuePoint extends KalturaCuePoint {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.optionalAnswers === 'undefined')
            this.optionalAnswers = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaQuestionCuePoint' },
            optionalAnswers: { type: 'a', subTypeConstructor: KalturaOptionalAnswer, subType: 'KalturaOptionalAnswer' },
            hint: { type: 's' },
            question: { type: 's' },
            explanation: { type: 's' },
            questionType: { type: 'en', subTypeConstructor: KalturaQuestionType, subType: 'KalturaQuestionType' },
            presentationOrder: { type: 'n' },
            excludeFromScore: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaQuestionCuePoint'] = KalturaQuestionCuePoint;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaQuickPlayDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaQuickPlayDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaQuickPlayDistributionProvider'] = KalturaQuickPlayDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaQuizAdvancedFilter extends KalturaSearchItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaQuizAdvancedFilter' },
            isQuiz: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaQuizAdvancedFilter'] = KalturaQuizAdvancedFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaQuizListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaQuizListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaQuiz, subType: 'KalturaQuiz' }
        });
        return result;
    }
}
typesMappingStorage['KalturaQuizListResponse'] = KalturaQuizListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaQuizUserEntry extends KalturaUserEntry {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaQuizUserEntry' },
            score: { type: 'n', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaQuizUserEntry'] = KalturaQuizUserEntry;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRecalculateCacheJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRecalculateCacheJobData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaRecalculateCacheJobData'] = KalturaRecalculateCacheJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRemoteDropFolder extends KalturaDropFolder {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRemoteDropFolder' }
        });
        return result;
    }
}
typesMappingStorage['KalturaRemoteDropFolder'] = KalturaRemoteDropFolder;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRemotePathListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRemotePathListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaRemotePath, subType: 'KalturaRemotePath' }
        });
        return result;
    }
}
typesMappingStorage['KalturaRemotePathListResponse'] = KalturaRemotePathListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaReportBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaReportBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            systemNameEqual: { type: 's' },
            systemNameIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaReportBaseFilter'] = KalturaReportBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaReportInterval = {
    days: 'days',
    months: 'months',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaReportInputFilter extends KalturaReportInputBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaReportInputFilter' },
            keywords: { type: 's' },
            searchInTags: { type: 'b' },
            searchInAdminTags: { type: 'b' },
            categories: { type: 's' },
            customVar1In: { type: 's' },
            customVar2In: { type: 's' },
            customVar3In: { type: 's' },
            deviceIn: { type: 's' },
            countryIn: { type: 's' },
            regionIn: { type: 's' },
            operatingSystemFamilyIn: { type: 's' },
            browserFamilyIn: { type: 's' },
            timeZoneOffset: { type: 'n' },
            interval: { type: 'es', subTypeConstructor: KalturaReportInterval, subType: 'KalturaReportInterval' }
        });
        return result;
    }
}
typesMappingStorage['KalturaReportInputFilter'] = KalturaReportInputFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaReportListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaReportListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaReport, subType: 'KalturaReport' }
        });
        return result;
    }
}
typesMappingStorage['KalturaReportListResponse'] = KalturaReportListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaResponseProfileBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaResponseProfileBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            systemNameEqual: { type: 's' },
            systemNameIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaResponseProfileStatus, subType: 'KalturaResponseProfileStatus' },
            statusIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaResponseProfileBaseFilter'] = KalturaResponseProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaResponseProfileHolder extends KalturaBaseResponseProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaResponseProfileHolder' },
            id: { type: 'n' },
            systemName: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaResponseProfileHolder'] = KalturaResponseProfileHolder;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaResponseProfileListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaResponseProfileListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaResponseProfile, subType: 'KalturaResponseProfile' }
        });
        return result;
    }
}
typesMappingStorage['KalturaResponseProfileListResponse'] = KalturaResponseProfileListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduleEventListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduleEventListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaScheduleEvent, subType: 'KalturaScheduleEvent' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduleEventListResponse'] = KalturaScheduleEventListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduleEventResourceListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduleEventResourceListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaScheduleEventResource, subType: 'KalturaScheduleEventResource' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduleEventResourceListResponse'] = KalturaScheduleEventResourceListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduleResourceListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduleResourceListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaScheduleResource, subType: 'KalturaScheduleResource' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduleResourceListResponse'] = KalturaScheduleResourceListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDryRunFileType = {
    csv: 2,
    listResponse: 1,
};
KalturaDryRunFileType[KalturaDryRunFileType.csv] = 'csv';
KalturaDryRunFileType[KalturaDryRunFileType.listResponse] = 'listResponse';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduledTaskJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduledTaskJobData' },
            maxResults: { type: 'n' },
            totalCount: { type: 'n' },
            fileFormat: { type: 'en', subTypeConstructor: KalturaDryRunFileType, subType: 'KalturaDryRunFileType' },
            resultsFilePath: { type: 's' },
            referenceTime: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduledTaskJobData'] = KalturaScheduledTaskJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduledTaskProfileBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduledTaskProfileBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            systemNameEqual: { type: 's' },
            systemNameIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaScheduledTaskProfileStatus, subType: 'KalturaScheduledTaskProfileStatus' },
            statusIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            lastExecutionStartedAtGreaterThanOrEqual: { type: 'd' },
            lastExecutionStartedAtLessThanOrEqual: { type: 'd' },
            lastExecutionStartedAtLessThanOrEqualOrNull: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduledTaskProfileBaseFilter'] = KalturaScheduledTaskProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduledTaskProfileListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduledTaskProfileListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaScheduledTaskProfile, subType: 'KalturaScheduledTaskProfile' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduledTaskProfileListResponse'] = KalturaScheduledTaskProfileListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSchedulerListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSchedulerListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaScheduler, subType: 'KalturaScheduler' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSchedulerListResponse'] = KalturaSchedulerListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSchedulerWorkerListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSchedulerWorkerListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaSchedulerWorker, subType: 'KalturaSchedulerWorker' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSchedulerWorkerListResponse'] = KalturaSchedulerWorkerListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSearchCondition extends KalturaSearchItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSearchCondition' },
            field: { type: 's' },
            value: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSearchCondition'] = KalturaSearchCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaSearchOperatorType = {
    searchAnd: 1,
    searchOr: 2,
};
KalturaSearchOperatorType[KalturaSearchOperatorType.searchAnd] = 'searchAnd';
KalturaSearchOperatorType[KalturaSearchOperatorType.searchOr] = 'searchOr';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSearchOperator extends KalturaSearchItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.items === 'undefined')
            this.items = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSearchOperator' },
            type: { type: 'en', subTypeConstructor: KalturaSearchOperatorType, subType: 'KalturaSearchOperatorType' },
            items: { type: 'a', subTypeConstructor: KalturaSearchItem, subType: 'KalturaSearchItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSearchOperator'] = KalturaSearchOperator;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaServerNodeBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaServerNodeBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            heartbeatTimeGreaterThanOrEqual: { type: 'd' },
            heartbeatTimeLessThanOrEqual: { type: 'd' },
            nameEqual: { type: 's' },
            nameIn: { type: 's' },
            systemNameEqual: { type: 's' },
            systemNameIn: { type: 's' },
            hostNameLike: { type: 's' },
            hostNameMultiLikeOr: { type: 's' },
            hostNameMultiLikeAnd: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaServerNodeStatus, subType: 'KalturaServerNodeStatus' },
            statusIn: { type: 's' },
            typeEqual: { type: 'es', subTypeConstructor: KalturaServerNodeType, subType: 'KalturaServerNodeType' },
            typeIn: { type: 's' },
            tagsLike: { type: 's' },
            tagsMultiLikeOr: { type: 's' },
            tagsMultiLikeAnd: { type: 's' },
            dcEqual: { type: 'n' },
            dcIn: { type: 's' },
            parentIdLike: { type: 's' },
            parentIdMultiLikeOr: { type: 's' },
            parentIdMultiLikeAnd: { type: 's' },
            environmentEqual: { type: 's' },
            environmentIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaServerNodeBaseFilter'] = KalturaServerNodeBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaServerNodeListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaServerNodeListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaServerNode, subType: 'KalturaServerNode' }
        });
        return result;
    }
}
typesMappingStorage['KalturaServerNodeListResponse'] = KalturaServerNodeListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSessionResponse extends KalturaStartWidgetSessionResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSessionResponse' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSessionResponse'] = KalturaSessionResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSessionRestriction extends KalturaBaseRestriction {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSessionRestriction' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSessionRestriction'] = KalturaSessionRestriction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaShortLinkBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaShortLinkBaseFilter' },
            idEqual: { type: 's' },
            idIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            expiresAtGreaterThanOrEqual: { type: 'n' },
            expiresAtLessThanOrEqual: { type: 'n' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            userIdEqual: { type: 's' },
            userIdIn: { type: 's' },
            systemNameEqual: { type: 's' },
            systemNameIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaShortLinkStatus, subType: 'KalturaShortLinkStatus' },
            statusIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaShortLinkBaseFilter'] = KalturaShortLinkBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaShortLinkListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaShortLinkListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaShortLink, subType: 'KalturaShortLink' }
        });
        return result;
    }
}
typesMappingStorage['KalturaShortLinkListResponse'] = KalturaShortLinkListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaSiteRestrictionType = {
    allowSiteList: 1,
    restrictSiteList: 0,
};
KalturaSiteRestrictionType[KalturaSiteRestrictionType.allowSiteList] = 'allowSiteList';
KalturaSiteRestrictionType[KalturaSiteRestrictionType.restrictSiteList] = 'restrictSiteList';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSiteRestriction extends KalturaBaseRestriction {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSiteRestriction' },
            siteRestrictionType: { type: 'en', subTypeConstructor: KalturaSiteRestrictionType, subType: 'KalturaSiteRestrictionType' },
            siteList: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSiteRestriction'] = KalturaSiteRestriction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaStorageAddAction extends KalturaRuleAction {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaStorageAddAction' }
        });
        return result;
    }
}
typesMappingStorage['KalturaStorageAddAction'] = KalturaStorageAddAction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaStorageExportObjectTask extends KalturaObjectTask {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaStorageExportObjectTask' },
            storageId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaStorageExportObjectTask'] = KalturaStorageExportObjectTask;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaStorageJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaStorageJobData' },
            serverUrl: { type: 's' },
            serverUsername: { type: 's' },
            serverPassword: { type: 's' },
            serverPrivateKey: { type: 's' },
            serverPublicKey: { type: 's' },
            serverPassPhrase: { type: 's' },
            ftpPassiveMode: { type: 'b' },
            srcFileSyncLocalPath: { type: 's' },
            srcFileEncryptionKey: { type: 's' },
            srcFileSyncId: { type: 's' },
            destFileSyncStoredPath: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaStorageJobData'] = KalturaStorageJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaStorageProfileBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaStorageProfileBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            systemNameEqual: { type: 's' },
            systemNameIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaStorageProfileStatus, subType: 'KalturaStorageProfileStatus' },
            statusIn: { type: 's' },
            protocolEqual: { type: 'es', subTypeConstructor: KalturaStorageProfileProtocol, subType: 'KalturaStorageProfileProtocol' },
            protocolIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaStorageProfileBaseFilter'] = KalturaStorageProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaStorageProfileListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaStorageProfileListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaStorageProfile, subType: 'KalturaStorageProfile' }
        });
        return result;
    }
}
typesMappingStorage['KalturaStorageProfileListResponse'] = KalturaStorageProfileListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSyncCategoryPrivacyContextJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSyncCategoryPrivacyContextJobData' },
            categoryId: { type: 'n' },
            lastUpdatedCategoryEntryCreatedAt: { type: 'n' },
            lastUpdatedCategoryCreatedAt: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSyncCategoryPrivacyContextJobData'] = KalturaSyncCategoryPrivacyContextJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSyndicationDistributionProfile extends KalturaDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSyndicationDistributionProfile' },
            xsl: { type: 's' },
            feedId: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaSyndicationDistributionProfile'] = KalturaSyndicationDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSyndicationDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSyndicationDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSyndicationDistributionProvider'] = KalturaSyndicationDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSystemPartnerUsageFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSystemPartnerUsageFilter' },
            fromDate: { type: 'n' },
            toDate: { type: 'n' },
            timezoneOffset: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSystemPartnerUsageFilter'] = KalturaSystemPartnerUsageFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSystemPartnerUsageListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSystemPartnerUsageListResponse' },
            objects: { type: 'a', subTypeConstructor: KalturaSystemPartnerUsageItem, subType: 'KalturaSystemPartnerUsageItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSystemPartnerUsageListResponse'] = KalturaSystemPartnerUsageListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTagFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTagFilter' },
            objectTypeEqual: { type: 'es', subTypeConstructor: KalturaTaggedObjectType, subType: 'KalturaTaggedObjectType' },
            tagEqual: { type: 's' },
            tagStartsWith: { type: 's' },
            instanceCountEqual: { type: 'n' },
            instanceCountIn: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaTagFilter'] = KalturaTagFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTagListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTagListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaTag, subType: 'KalturaTag' }
        });
        return result;
    }
}
typesMappingStorage['KalturaTagListResponse'] = KalturaTagListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTaskEntryServerNode extends KalturaEntryServerNode {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTaskEntryServerNode' }
        });
        return result;
    }
}
typesMappingStorage['KalturaTaskEntryServerNode'] = KalturaTaskEntryServerNode;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaThumbAssetListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaThumbAssetListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaThumbAsset, subType: 'KalturaThumbAsset' }
        });
        return result;
    }
}
typesMappingStorage['KalturaThumbAssetListResponse'] = KalturaThumbAssetListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaThumbCuePointSubType = {
    chapter: 2,
    slide: 1,
};
KalturaThumbCuePointSubType[KalturaThumbCuePointSubType.chapter] = 'chapter';
KalturaThumbCuePointSubType[KalturaThumbCuePointSubType.slide] = 'slide';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaThumbCuePoint extends KalturaCuePoint {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaThumbCuePoint' },
            assetId: { type: 's' },
            description: { type: 's' },
            title: { type: 's' },
            subType: { type: 'en', subTypeConstructor: KalturaThumbCuePointSubType, subType: 'KalturaThumbCuePointSubType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaThumbCuePoint'] = KalturaThumbCuePoint;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaThumbParamsListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaThumbParamsListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaThumbParams, subType: 'KalturaThumbParams' }
        });
        return result;
    }
}
typesMappingStorage['KalturaThumbParamsListResponse'] = KalturaThumbParamsListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaThumbnailServeOptions extends KalturaAssetServeOptions {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaThumbnailServeOptions' }
        });
        return result;
    }
}
typesMappingStorage['KalturaThumbnailServeOptions'] = KalturaThumbnailServeOptions;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTrackEntryListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTrackEntryListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaTrackEntry, subType: 'KalturaTrackEntry' }
        });
        return result;
    }
}
typesMappingStorage['KalturaTrackEntryListResponse'] = KalturaTrackEntryListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTranscriptAssetListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTranscriptAssetListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaTranscriptAsset, subType: 'KalturaTranscriptAsset' }
        });
        return result;
    }
}
typesMappingStorage['KalturaTranscriptAssetListResponse'] = KalturaTranscriptAssetListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTransformMetadataJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTransformMetadataJobData' },
            srcXsl: { type: 'o', subTypeConstructor: KalturaFileContainer, subType: 'KalturaFileContainer' },
            srcVersion: { type: 'n' },
            destVersion: { type: 'n' },
            destXsd: { type: 'o', subTypeConstructor: KalturaFileContainer, subType: 'KalturaFileContainer' },
            metadataProfileId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaTransformMetadataJobData'] = KalturaTransformMetadataJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaTubeMogulSyndicationFeedCategories = {
    animalsAndPets: 'Animals &amp; Pets',
    artsAndAnimation: 'Arts &amp; Animation',
    autos: 'Autos',
    comedy: 'Comedy',
    commercialsPromotional: 'Commercials/Promotional',
    entertainment: 'Entertainment',
    familyAndKids: 'Family &amp; Kids',
    howToInstructionalDiy: 'How To/Instructional/DIY',
    music: 'Music',
    newsAndBlogs: 'News &amp; Blogs',
    scienceAndTechnology: 'Science &amp; Technology',
    sports: 'Sports',
    travelAndPlaces: 'Travel &amp; Places',
    videoGames: 'Video Games',
    vlogsPeople: 'Vlogs &amp; People',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTubeMogulSyndicationFeed extends KalturaBaseSyndicationFeed {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTubeMogulSyndicationFeed' },
            category: { type: 'es', readOnly: true, subTypeConstructor: KalturaTubeMogulSyndicationFeedCategories, subType: 'KalturaTubeMogulSyndicationFeedCategories' }
        });
        return result;
    }
}
typesMappingStorage['KalturaTubeMogulSyndicationFeed'] = KalturaTubeMogulSyndicationFeed;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUiConfAdminListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUiConfAdminListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaUiConfAdmin, subType: 'KalturaUiConfAdmin' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUiConfAdminListResponse'] = KalturaUiConfAdminListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUiConfBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUiConfBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            nameLike: { type: 's' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            objTypeEqual: { type: 'en', subTypeConstructor: KalturaUiConfObjType, subType: 'KalturaUiConfObjType' },
            objTypeIn: { type: 's' },
            tagsMultiLikeOr: { type: 's' },
            tagsMultiLikeAnd: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            creationModeEqual: { type: 'en', subTypeConstructor: KalturaUiConfCreationMode, subType: 'KalturaUiConfCreationMode' },
            creationModeIn: { type: 's' },
            versionEqual: { type: 's' },
            versionMultiLikeOr: { type: 's' },
            versionMultiLikeAnd: { type: 's' },
            partnerTagsMultiLikeOr: { type: 's' },
            partnerTagsMultiLikeAnd: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUiConfBaseFilter'] = KalturaUiConfBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUiConfListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUiConfListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaUiConf, subType: 'KalturaUiConf' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUiConfListResponse'] = KalturaUiConfListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUnicornDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUnicornDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUnicornDistributionProvider'] = KalturaUnicornDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUploadTokenBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUploadTokenBaseFilter' },
            idEqual: { type: 's' },
            idIn: { type: 's' },
            userIdEqual: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaUploadTokenStatus, subType: 'KalturaUploadTokenStatus' },
            statusIn: { type: 's' },
            fileNameEqual: { type: 's' },
            fileSizeEqual: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUploadTokenBaseFilter'] = KalturaUploadTokenBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUploadTokenListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUploadTokenListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaUploadToken, subType: 'KalturaUploadToken' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUploadTokenListResponse'] = KalturaUploadTokenListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlRecognizerAkamaiG2O extends KalturaUrlRecognizer {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlRecognizerAkamaiG2O' },
            headerData: { type: 's' },
            headerSign: { type: 's' },
            timeout: { type: 'n' },
            salt: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlRecognizerAkamaiG2O'] = KalturaUrlRecognizerAkamaiG2O;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlTokenizerAkamaiHttp extends KalturaUrlTokenizer {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlTokenizerAkamaiHttp' },
            paramName: { type: 's' },
            rootDir: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlTokenizerAkamaiHttp'] = KalturaUrlTokenizerAkamaiHttp;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlTokenizerAkamaiRtmp extends KalturaUrlTokenizer {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlTokenizerAkamaiRtmp' },
            profile: { type: 's' },
            type: { type: 's' },
            aifp: { type: 's' },
            usePrefix: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlTokenizerAkamaiRtmp'] = KalturaUrlTokenizerAkamaiRtmp;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlTokenizerAkamaiRtsp extends KalturaUrlTokenizer {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlTokenizerAkamaiRtsp' },
            host: { type: 's' },
            cpcode: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlTokenizerAkamaiRtsp'] = KalturaUrlTokenizerAkamaiRtsp;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlTokenizerAkamaiSecureHd extends KalturaUrlTokenizer {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlTokenizerAkamaiSecureHd' },
            paramName: { type: 's' },
            aclPostfix: { type: 's' },
            customPostfixes: { type: 's' },
            useCookieHosts: { type: 's' },
            rootDir: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlTokenizerAkamaiSecureHd'] = KalturaUrlTokenizerAkamaiSecureHd;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlTokenizerBitGravity extends KalturaUrlTokenizer {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlTokenizerBitGravity' },
            hashPatternRegex: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlTokenizerBitGravity'] = KalturaUrlTokenizerBitGravity;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaChinaCacheAlgorithmType = {
    sha1: 1,
    sha256: 2,
};
KalturaChinaCacheAlgorithmType[KalturaChinaCacheAlgorithmType.sha1] = 'sha1';
KalturaChinaCacheAlgorithmType[KalturaChinaCacheAlgorithmType.sha256] = 'sha256';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlTokenizerChinaCache extends KalturaUrlTokenizer {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlTokenizerChinaCache' },
            algorithmId: { type: 'en', subTypeConstructor: KalturaChinaCacheAlgorithmType, subType: 'KalturaChinaCacheAlgorithmType' },
            keyId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlTokenizerChinaCache'] = KalturaUrlTokenizerChinaCache;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlTokenizerCht extends KalturaUrlTokenizer {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlTokenizerCht' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlTokenizerCht'] = KalturaUrlTokenizerCht;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlTokenizerCloudFront extends KalturaUrlTokenizer {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlTokenizerCloudFront' },
            keyPairId: { type: 's' },
            rootDir: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlTokenizerCloudFront'] = KalturaUrlTokenizerCloudFront;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlTokenizerKs extends KalturaUrlTokenizer {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlTokenizerKs' },
            usePath: { type: 'b' },
            additionalUris: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlTokenizerKs'] = KalturaUrlTokenizerKs;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlTokenizerLevel3 extends KalturaUrlTokenizer {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlTokenizerLevel3' },
            paramName: { type: 's' },
            expiryName: { type: 's' },
            gen: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlTokenizerLevel3'] = KalturaUrlTokenizerLevel3;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlTokenizerLimeLight extends KalturaUrlTokenizer {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlTokenizerLimeLight' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlTokenizerLimeLight'] = KalturaUrlTokenizerLimeLight;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlTokenizerVelocix extends KalturaUrlTokenizer {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlTokenizerVelocix' },
            hdsPaths: { type: 's' },
            paramName: { type: 's' },
            authPrefix: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlTokenizerVelocix'] = KalturaUrlTokenizerVelocix;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlTokenizerVnpt extends KalturaUrlTokenizer {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlTokenizerVnpt' },
            tokenizationFormat: { type: 'n' },
            shouldIncludeClientIp: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlTokenizerVnpt'] = KalturaUrlTokenizerVnpt;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUrlTokenizerWowzaSecureToken extends KalturaUrlTokenizer {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUrlTokenizerWowzaSecureToken' },
            paramPrefix: { type: 's' },
            hashAlgorithm: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUrlTokenizerWowzaSecureToken'] = KalturaUrlTokenizerWowzaSecureToken;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaUserAgentRestrictionType = {
    allowList: 1,
    restrictList: 0,
};
KalturaUserAgentRestrictionType[KalturaUserAgentRestrictionType.allowList] = 'allowList';
KalturaUserAgentRestrictionType[KalturaUserAgentRestrictionType.restrictList] = 'restrictList';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserAgentRestriction extends KalturaBaseRestriction {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserAgentRestriction' },
            userAgentRestrictionType: { type: 'en', subTypeConstructor: KalturaUserAgentRestrictionType, subType: 'KalturaUserAgentRestrictionType' },
            userAgentRegexList: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserAgentRestriction'] = KalturaUserAgentRestriction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserEntryListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserEntryListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaUserEntry, subType: 'KalturaUserEntry' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserEntryListResponse'] = KalturaUserEntryListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaUser, subType: 'KalturaUser' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserListResponse'] = KalturaUserListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserLoginDataListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserLoginDataListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaUserLoginData, subType: 'KalturaUserLoginData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserLoginDataListResponse'] = KalturaUserLoginDataListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserRoleCondition extends KalturaCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserRoleCondition' },
            roleIds: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserRoleCondition'] = KalturaUserRoleCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserRoleListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserRoleListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaUserRole, subType: 'KalturaUserRole' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserRoleListResponse'] = KalturaUserRoleListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUsersCsvJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.additionalFields === 'undefined')
            this.additionalFields = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUsersCsvJobData' },
            filter: { type: 'o', subTypeConstructor: KalturaUserFilter, subType: 'KalturaUserFilter' },
            metadataProfileId: { type: 'n' },
            additionalFields: { type: 'a', subTypeConstructor: KalturaCsvAdditionalFieldInfo, subType: 'KalturaCsvAdditionalFieldInfo' },
            userName: { type: 's' },
            userMail: { type: 's' },
            outputPath: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUsersCsvJobData'] = KalturaUsersCsvJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaValidateActiveEdgeCondition extends KalturaCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaValidateActiveEdgeCondition' },
            edgeServerIds: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaValidateActiveEdgeCondition'] = KalturaValidateActiveEdgeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaVarPartnerUsageTotalItem extends KalturaVarPartnerUsageItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaVarPartnerUsageTotalItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaVarPartnerUsageTotalItem'] = KalturaVarPartnerUsageTotalItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaViewHistoryUserEntry extends KalturaUserEntry {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaViewHistoryUserEntry' },
            playbackContext: { type: 's' },
            lastTimeReached: { type: 'n' },
            lastUpdateTime: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaViewHistoryUserEntry'] = KalturaViewHistoryUserEntry;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaViewHistoryUserEntryAdvancedFilter extends KalturaSearchItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaViewHistoryUserEntryAdvancedFilter' },
            idEqual: { type: 's' },
            idIn: { type: 's' },
            userIdEqual: { type: 's' },
            userIdIn: { type: 's' },
            updatedAtGreaterThanOrEqual: { type: 's' },
            updatedAtLessThanOrEqual: { type: 's' },
            extendedStatusEqual: { type: 'es', subTypeConstructor: KalturaUserEntryExtendedStatus, subType: 'KalturaUserEntryExtendedStatus' },
            extendedStatusIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaViewHistoryUserEntryAdvancedFilter'] = KalturaViewHistoryUserEntryAdvancedFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaVirusScanJobResult = {
    fileInfected: 4,
    fileIsClean: 2,
    fileWasCleaned: 3,
    scanError: 1,
};
KalturaVirusScanJobResult[KalturaVirusScanJobResult.fileInfected] = 'fileInfected';
KalturaVirusScanJobResult[KalturaVirusScanJobResult.fileIsClean] = 'fileIsClean';
KalturaVirusScanJobResult[KalturaVirusScanJobResult.fileWasCleaned] = 'fileWasCleaned';
KalturaVirusScanJobResult[KalturaVirusScanJobResult.scanError] = 'scanError';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaVirusScanJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaVirusScanJobData' },
            fileContainer: { type: 'o', subTypeConstructor: KalturaFileContainer, subType: 'KalturaFileContainer' },
            flavorAssetId: { type: 's' },
            scanResult: { type: 'en', subTypeConstructor: KalturaVirusScanJobResult, subType: 'KalturaVirusScanJobResult' },
            virusFoundAction: { type: 'en', subTypeConstructor: KalturaVirusFoundAction, subType: 'KalturaVirusFoundAction' }
        });
        return result;
    }
}
typesMappingStorage['KalturaVirusScanJobData'] = KalturaVirusScanJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaVirusScanProfileBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaVirusScanProfileBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            nameEqual: { type: 's' },
            nameLike: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaVirusScanProfileStatus, subType: 'KalturaVirusScanProfileStatus' },
            statusIn: { type: 's' },
            engineTypeEqual: { type: 'es', subTypeConstructor: KalturaVirusScanEngineType, subType: 'KalturaVirusScanEngineType' },
            engineTypeIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaVirusScanProfileBaseFilter'] = KalturaVirusScanProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaVirusScanProfileListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaVirusScanProfileListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaVirusScanProfile, subType: 'KalturaVirusScanProfile' }
        });
        return result;
    }
}
typesMappingStorage['KalturaVirusScanProfileListResponse'] = KalturaVirusScanProfileListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaVoicebaseJobProviderData extends KalturaIntegrationJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaVoicebaseJobProviderData' },
            entryId: { type: 's' },
            flavorAssetId: { type: 's' },
            transcriptId: { type: 's' },
            captionAssetFormats: { type: 's' },
            apiKey: { type: 's', readOnly: true },
            apiPassword: { type: 's', readOnly: true },
            spokenLanguage: { type: 'es', subTypeConstructor: KalturaLanguage, subType: 'KalturaLanguage' },
            fileLocation: { type: 's', readOnly: true },
            replaceMediaContent: { type: 'b' },
            additionalParameters: { type: 's', readOnly: true }
        });
        return result;
    }
}
typesMappingStorage['KalturaVoicebaseJobProviderData'] = KalturaVoicebaseJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWebexDropFolder extends KalturaDropFolder {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWebexDropFolder' },
            webexUserId: { type: 's' },
            webexPassword: { type: 's' },
            webexSiteId: { type: 'n' },
            webexPartnerId: { type: 's' },
            webexServiceUrl: { type: 's' },
            webexHostIdMetadataFieldName: { type: 's' },
            deleteFromRecycleBin: { type: 'b' },
            webexServiceType: { type: 's' },
            webexSiteName: { type: 's' },
            deleteFromTimestamp: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWebexDropFolder'] = KalturaWebexDropFolder;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWebexDropFolderFile extends KalturaDropFolderFile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWebexDropFolderFile' },
            recordingId: { type: 'n' },
            webexHostId: { type: 's' },
            description: { type: 's' },
            confId: { type: 's' },
            contentUrl: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWebexDropFolderFile'] = KalturaWebexDropFolderFile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWidevineProfile extends KalturaDrmProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWidevineProfile' },
            key: { type: 's' },
            iv: { type: 's' },
            owner: { type: 's' },
            portal: { type: 's' },
            maxGop: { type: 'n' },
            regServerHost: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWidevineProfile'] = KalturaWidevineProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaWidevineRepositorySyncMode = {
    modify: 0,
};
KalturaWidevineRepositorySyncMode[KalturaWidevineRepositorySyncMode.modify] = 'modify';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWidevineRepositorySyncJobData extends KalturaJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWidevineRepositorySyncJobData' },
            syncMode: { type: 'en', subTypeConstructor: KalturaWidevineRepositorySyncMode, subType: 'KalturaWidevineRepositorySyncMode' },
            wvAssetIds: { type: 's' },
            modifiedAttributes: { type: 's' },
            monitorSyncCompletion: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWidevineRepositorySyncJobData'] = KalturaWidevineRepositorySyncJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWidgetBaseFilter extends KalturaFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWidgetBaseFilter' },
            idEqual: { type: 's' },
            idIn: { type: 's' },
            sourceWidgetIdEqual: { type: 's' },
            rootWidgetIdEqual: { type: 's' },
            partnerIdEqual: { type: 'n' },
            entryIdEqual: { type: 's' },
            uiConfIdEqual: { type: 'n' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            partnerDataLike: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWidgetBaseFilter'] = KalturaWidgetBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWidgetListResponse extends KalturaListResponse {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.objects === 'undefined')
            this.objects = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWidgetListResponse' },
            objects: { type: 'a', readOnly: true, subTypeConstructor: KalturaWidget, subType: 'KalturaWidget' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWidgetListResponse'] = KalturaWidgetListResponse;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYahooDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYahooDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYahooDistributionProvider'] = KalturaYahooDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaYahooSyndicationFeedCategories = {
    action: 'Action',
    animals: 'Animals',
    artAndAnimation: 'Art &amp; Animation',
    commercials: 'Commercials',
    entertainmentAndTv: 'Entertainment &amp; TV',
    family: 'Family',
    food: 'Food',
    funnyVideos: 'Funny Videos',
    games: 'Games',
    healthAndBeauty: 'Health &amp; Beauty',
    howTo: 'How-To',
    moviesAndShorts: 'Movies &amp; Shorts',
    music: 'Music',
    newsAndPolitics: 'News &amp; Politics',
    peopleAndVlogs: 'People &amp; Vlogs',
    productsAndTech: 'Products &amp; Tech.',
    scienceAndEnvironment: 'Science &amp; Environment',
    sports: 'Sports',
    transportation: 'Transportation',
    travel: 'Travel',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaYahooSyndicationFeedAdultValues = {
    adult: 'adult',
    nonAdult: 'nonadult',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYahooSyndicationFeed extends KalturaBaseSyndicationFeed {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYahooSyndicationFeed' },
            category: { type: 'es', readOnly: true, subTypeConstructor: KalturaYahooSyndicationFeedCategories, subType: 'KalturaYahooSyndicationFeedCategories' },
            adultContent: { type: 'es', subTypeConstructor: KalturaYahooSyndicationFeedAdultValues, subType: 'KalturaYahooSyndicationFeedAdultValues' },
            feedDescription: { type: 's' },
            feedLandingPage: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYahooSyndicationFeed'] = KalturaYahooSyndicationFeed;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYouTubeDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYouTubeDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYouTubeDistributionProvider'] = KalturaYouTubeDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYoutubeApiDistributionProvider extends KalturaDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYoutubeApiDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYoutubeApiDistributionProvider'] = KalturaYoutubeApiDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            systemNameEqual: { type: 's' },
            systemNameIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlBaseFilter'] = KalturaAccessControlBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlProfileBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlProfileBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            systemNameEqual: { type: 's' },
            systemNameIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlProfileBaseFilter'] = KalturaAccessControlProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAkamaiProvisionJobData extends KalturaProvisionJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAkamaiProvisionJobData' },
            wsdlUsername: { type: 's' },
            wsdlPassword: { type: 's' },
            cpcode: { type: 's' },
            emailId: { type: 's' },
            primaryContact: { type: 's' },
            secondaryContact: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAkamaiProvisionJobData'] = KalturaAkamaiProvisionJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAkamaiUniversalStreamType = {
    hdIphoneIpadLive: 'HD iPhone/iPad Live',
    universalStreamingLive: 'Universal Streaming Live',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAkamaiUniversalProvisionJobData extends KalturaProvisionJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAkamaiUniversalProvisionJobData' },
            streamId: { type: 'n' },
            systemUserName: { type: 's' },
            systemPassword: { type: 's' },
            domainName: { type: 's' },
            dvrEnabled: { type: 'en', subTypeConstructor: KalturaDVRStatus, subType: 'KalturaDVRStatus' },
            dvrWindow: { type: 'n' },
            primaryContact: { type: 's' },
            secondaryContact: { type: 's' },
            streamType: { type: 'es', subTypeConstructor: KalturaAkamaiUniversalStreamType, subType: 'KalturaAkamaiUniversalStreamType' },
            notificationEmail: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAkamaiUniversalProvisionJobData'] = KalturaAkamaiUniversalProvisionJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaGeoCoderType = {
    digitalElement: '3',
    kaltura: '1',
    maxMind: '2',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAnonymousIPCondition extends KalturaMatchCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAnonymousIPCondition' },
            geoCoderType: { type: 'es', subTypeConstructor: KalturaGeoCoderType, subType: 'KalturaGeoCoderType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAnonymousIPCondition'] = KalturaAnonymousIPCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAppTokenFilter extends KalturaAppTokenBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAppTokenFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAppTokenFilter'] = KalturaAppTokenFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAssetParamsBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAssetParamsBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            systemNameEqual: { type: 's' },
            systemNameIn: { type: 's' },
            isSystemDefaultEqual: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            tagsEqual: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAssetParamsBaseFilter'] = KalturaAssetParamsBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAssetResource extends KalturaContentResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAssetResource' },
            assetId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAssetResource'] = KalturaAssetResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAuditTrailBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAuditTrailBaseFilter' },
            idEqual: { type: 'n' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            parsedAtGreaterThanOrEqual: { type: 'n' },
            parsedAtLessThanOrEqual: { type: 'n' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaAuditTrailStatus, subType: 'KalturaAuditTrailStatus' },
            statusIn: { type: 's' },
            auditObjectTypeEqual: { type: 'es', subTypeConstructor: KalturaAuditTrailObjectType, subType: 'KalturaAuditTrailObjectType' },
            auditObjectTypeIn: { type: 's' },
            objectIdEqual: { type: 's' },
            objectIdIn: { type: 's' },
            relatedObjectIdEqual: { type: 's' },
            relatedObjectIdIn: { type: 's' },
            relatedObjectTypeEqual: { type: 'es', subTypeConstructor: KalturaAuditTrailObjectType, subType: 'KalturaAuditTrailObjectType' },
            relatedObjectTypeIn: { type: 's' },
            entryIdEqual: { type: 's' },
            entryIdIn: { type: 's' },
            masterPartnerIdEqual: { type: 'n' },
            masterPartnerIdIn: { type: 's' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            requestIdEqual: { type: 's' },
            requestIdIn: { type: 's' },
            userIdEqual: { type: 's' },
            userIdIn: { type: 's' },
            actionEqual: { type: 'es', subTypeConstructor: KalturaAuditTrailAction, subType: 'KalturaAuditTrailAction' },
            actionIn: { type: 's' },
            ksEqual: { type: 's' },
            contextEqual: { type: 'en', subTypeConstructor: KalturaAuditTrailContext, subType: 'KalturaAuditTrailContext' },
            contextIn: { type: 's' },
            entryPointEqual: { type: 's' },
            entryPointIn: { type: 's' },
            serverNameEqual: { type: 's' },
            serverNameIn: { type: 's' },
            ipAddressEqual: { type: 's' },
            ipAddressIn: { type: 's' },
            clientTagEqual: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAuditTrailBaseFilter'] = KalturaAuditTrailBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAvnDistributionProfile extends KalturaConfigurableDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAvnDistributionProfile' },
            feedUrl: { type: 's', readOnly: true },
            feedTitle: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAvnDistributionProfile'] = KalturaAvnDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBaseSyndicationFeedFilter extends KalturaBaseSyndicationFeedBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBaseSyndicationFeedFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBaseSyndicationFeedFilter'] = KalturaBaseSyndicationFeedFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaBulkUploadCsvVersion = {
    v1: 1,
    v2: 2,
    v3: 3,
};
KalturaBulkUploadCsvVersion[KalturaBulkUploadCsvVersion.v1] = 'v1';
KalturaBulkUploadCsvVersion[KalturaBulkUploadCsvVersion.v2] = 'v2';
KalturaBulkUploadCsvVersion[KalturaBulkUploadCsvVersion.v3] = 'v3';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadCsvJobData extends KalturaBulkUploadJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.columns === 'undefined')
            this.columns = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadCsvJobData' },
            csvVersion: { type: 'en', readOnly: true, subTypeConstructor: KalturaBulkUploadCsvVersion, subType: 'KalturaBulkUploadCsvVersion' },
            columns: { type: 'a', subTypeConstructor: KalturaString, subType: 'KalturaString' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadCsvJobData'] = KalturaBulkUploadCsvJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadFilter extends KalturaBulkUploadBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadFilter'] = KalturaBulkUploadFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadFilterJobData extends KalturaBulkUploadJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadFilterJobData' },
            filter: { type: 'o', subTypeConstructor: KalturaFilter, subType: 'KalturaFilter' },
            templateObject: { type: 'o', subTypeConstructor: KalturaObjectBase, subType: 'KalturaObjectBase' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadFilterJobData'] = KalturaBulkUploadFilterJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadICalJobData extends KalturaBulkUploadJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadICalJobData' },
            eventsType: { type: 'en', subTypeConstructor: KalturaScheduleEventType, subType: 'KalturaScheduleEventType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadICalJobData'] = KalturaBulkUploadICalJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBulkUploadXmlJobData extends KalturaBulkUploadJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBulkUploadXmlJobData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBulkUploadXmlJobData'] = KalturaBulkUploadXmlJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessAbortNotificationTemplate extends KalturaBusinessProcessNotificationTemplate {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessAbortNotificationTemplate' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessAbortNotificationTemplate'] = KalturaBusinessProcessAbortNotificationTemplate;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessNotificationDispatchJobData extends KalturaEventNotificationDispatchJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessNotificationDispatchJobData' },
            server: { type: 'o', subTypeConstructor: KalturaBusinessProcessServer, subType: 'KalturaBusinessProcessServer' },
            caseId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessNotificationDispatchJobData'] = KalturaBusinessProcessNotificationDispatchJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessServerFilter extends KalturaBusinessProcessServerBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessServerFilter' },
            currentDcOrExternal: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            currentDc: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessServerFilter'] = KalturaBusinessProcessServerFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessSignalNotificationTemplate extends KalturaBusinessProcessNotificationTemplate {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessSignalNotificationTemplate' },
            message: { type: 's' },
            eventId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessSignalNotificationTemplate'] = KalturaBusinessProcessSignalNotificationTemplate;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessStartNotificationTemplate extends KalturaBusinessProcessNotificationTemplate {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessStartNotificationTemplate' },
            abortOnDeletion: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessStartNotificationTemplate'] = KalturaBusinessProcessStartNotificationTemplate;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCategoryBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCategoryBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            idNotIn: { type: 's' },
            parentIdEqual: { type: 'n' },
            parentIdIn: { type: 's' },
            depthEqual: { type: 'n' },
            fullNameEqual: { type: 's' },
            fullNameStartsWith: { type: 's' },
            fullNameIn: { type: 's' },
            fullIdsEqual: { type: 's' },
            fullIdsStartsWith: { type: 's' },
            fullIdsMatchOr: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            tagsLike: { type: 's' },
            tagsMultiLikeOr: { type: 's' },
            tagsMultiLikeAnd: { type: 's' },
            appearInListEqual: { type: 'en', subTypeConstructor: KalturaAppearInListType, subType: 'KalturaAppearInListType' },
            privacyEqual: { type: 'en', subTypeConstructor: KalturaPrivacyType, subType: 'KalturaPrivacyType' },
            privacyIn: { type: 's' },
            inheritanceTypeEqual: { type: 'en', subTypeConstructor: KalturaInheritanceType, subType: 'KalturaInheritanceType' },
            inheritanceTypeIn: { type: 's' },
            referenceIdEqual: { type: 's' },
            referenceIdEmpty: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            contributionPolicyEqual: { type: 'en', subTypeConstructor: KalturaContributionPolicyType, subType: 'KalturaContributionPolicyType' },
            membersCountGreaterThanOrEqual: { type: 'n' },
            membersCountLessThanOrEqual: { type: 'n' },
            pendingMembersCountGreaterThanOrEqual: { type: 'n' },
            pendingMembersCountLessThanOrEqual: { type: 'n' },
            privacyContextEqual: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaCategoryStatus, subType: 'KalturaCategoryStatus' },
            statusIn: { type: 's' },
            inheritedParentIdEqual: { type: 'n' },
            inheritedParentIdIn: { type: 's' },
            partnerSortValueGreaterThanOrEqual: { type: 'n' },
            partnerSortValueLessThanOrEqual: { type: 'n' },
            aggregationCategoriesMultiLikeOr: { type: 's' },
            aggregationCategoriesMultiLikeAnd: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCategoryBaseFilter'] = KalturaCategoryBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCategoryEntryBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCategoryEntryBaseFilter' },
            categoryIdEqual: { type: 'n' },
            categoryIdIn: { type: 's' },
            entryIdEqual: { type: 's' },
            entryIdIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            categoryFullIdsStartsWith: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaCategoryEntryStatus, subType: 'KalturaCategoryEntryStatus' },
            statusIn: { type: 's' },
            creatorUserIdEqual: { type: 's' },
            creatorUserIdIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCategoryEntryBaseFilter'] = KalturaCategoryEntryBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaClippingTaskEntryServerNode extends KalturaTaskEntryServerNode {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaClippingTaskEntryServerNode' },
            clipAttributes: { type: 'o', subTypeConstructor: KalturaClipAttributes, subType: 'KalturaClipAttributes' },
            clippedEntryId: { type: 's' },
            liveEntryId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaClippingTaskEntryServerNode'] = KalturaClippingTaskEntryServerNode;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaComcastMrssDistributionProfile extends KalturaConfigurableDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.cPlatformTvSeries === 'undefined')
            this.cPlatformTvSeries = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaComcastMrssDistributionProfile' },
            metadataProfileId: { type: 'n' },
            feedUrl: { type: 's', readOnly: true },
            feedTitle: { type: 's' },
            feedLink: { type: 's' },
            feedDescription: { type: 's' },
            feedLastBuildDate: { type: 's' },
            itemLink: { type: 's' },
            cPlatformTvSeries: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            cPlatformTvSeriesField: { type: 's' },
            shouldIncludeCuePoints: { type: 'b' },
            shouldIncludeCaptions: { type: 'b' },
            shouldAddThumbExtension: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaComcastMrssDistributionProfile'] = KalturaComcastMrssDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCompareMetadataCondition extends KalturaCompareCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCompareMetadataCondition' },
            xPath: { type: 's' },
            profileId: { type: 'n' },
            profileSystemName: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCompareMetadataCondition'] = KalturaCompareMetadataCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaControlPanelCommandFilter extends KalturaControlPanelCommandBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaControlPanelCommandFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaControlPanelCommandFilter'] = KalturaControlPanelCommandFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConversionProfileAssetParamsBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConversionProfileAssetParamsBaseFilter' },
            conversionProfileIdEqual: { type: 'n' },
            conversionProfileIdIn: { type: 's' },
            assetParamsIdEqual: { type: 'n' },
            assetParamsIdIn: { type: 's' },
            readyBehaviorEqual: { type: 'en', subTypeConstructor: KalturaFlavorReadyBehaviorType, subType: 'KalturaFlavorReadyBehaviorType' },
            readyBehaviorIn: { type: 's' },
            originEqual: { type: 'en', subTypeConstructor: KalturaAssetParamsOrigin, subType: 'KalturaAssetParamsOrigin' },
            originIn: { type: 's' },
            systemNameEqual: { type: 's' },
            systemNameIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConversionProfileAssetParamsBaseFilter'] = KalturaConversionProfileAssetParamsBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConversionProfileBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConversionProfileBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            statusEqual: { type: 'es', subTypeConstructor: KalturaConversionProfileStatus, subType: 'KalturaConversionProfileStatus' },
            statusIn: { type: 's' },
            typeEqual: { type: 'es', subTypeConstructor: KalturaConversionProfileType, subType: 'KalturaConversionProfileType' },
            typeIn: { type: 's' },
            nameEqual: { type: 's' },
            systemNameEqual: { type: 's' },
            systemNameIn: { type: 's' },
            tagsMultiLikeOr: { type: 's' },
            tagsMultiLikeAnd: { type: 's' },
            defaultEntryIdEqual: { type: 's' },
            defaultEntryIdIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConversionProfileBaseFilter'] = KalturaConversionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConvertCollectionJobData extends KalturaConvartableJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.flavors === 'undefined')
            this.flavors = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConvertCollectionJobData' },
            destDirLocalPath: { type: 's' },
            destDirRemoteUrl: { type: 's' },
            destFileName: { type: 's' },
            inputXmlLocalPath: { type: 's' },
            inputXmlRemoteUrl: { type: 's' },
            commandLinesStr: { type: 's' },
            flavors: { type: 'a', subTypeConstructor: KalturaConvertCollectionFlavorData, subType: 'KalturaConvertCollectionFlavorData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConvertCollectionJobData'] = KalturaConvertCollectionJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConvertJobData extends KalturaConvartableJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.extraDestFileSyncs === 'undefined')
            this.extraDestFileSyncs = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConvertJobData' },
            destFileSyncLocalPath: { type: 's' },
            destFileSyncRemoteUrl: { type: 's' },
            logFileSyncLocalPath: { type: 's' },
            logFileSyncRemoteUrl: { type: 's' },
            flavorAssetId: { type: 's' },
            remoteMediaId: { type: 's' },
            customData: { type: 's' },
            extraDestFileSyncs: { type: 'a', subTypeConstructor: KalturaDestFileSyncDescriptor, subType: 'KalturaDestFileSyncDescriptor' },
            engineMessage: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConvertJobData'] = KalturaConvertJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCountryCondition extends KalturaMatchCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCountryCondition' },
            geoCoderType: { type: 'es', subTypeConstructor: KalturaGeoCoderType, subType: 'KalturaGeoCoderType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCountryCondition'] = KalturaCountryCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCrossKalturaDistributionJobProviderData extends KalturaConfigurableDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCrossKalturaDistributionJobProviderData' },
            distributedFlavorAssets: { type: 's' },
            distributedThumbAssets: { type: 's' },
            distributedMetadata: { type: 's' },
            distributedCaptionAssets: { type: 's' },
            distributedCuePoints: { type: 's' },
            distributedThumbCuePoints: { type: 's' },
            distributedTimedThumbAssets: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCrossKalturaDistributionJobProviderData'] = KalturaCrossKalturaDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCrossKalturaDistributionProfile extends KalturaConfigurableDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.metadataXpathsTriggerUpdate === 'undefined')
            this.metadataXpathsTriggerUpdate = [];
        if (typeof this.mapAccessControlProfileIds === 'undefined')
            this.mapAccessControlProfileIds = [];
        if (typeof this.mapConversionProfileIds === 'undefined')
            this.mapConversionProfileIds = [];
        if (typeof this.mapMetadataProfileIds === 'undefined')
            this.mapMetadataProfileIds = [];
        if (typeof this.mapStorageProfileIds === 'undefined')
            this.mapStorageProfileIds = [];
        if (typeof this.mapFlavorParamsIds === 'undefined')
            this.mapFlavorParamsIds = [];
        if (typeof this.mapThumbParamsIds === 'undefined')
            this.mapThumbParamsIds = [];
        if (typeof this.mapCaptionParamsIds === 'undefined')
            this.mapCaptionParamsIds = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCrossKalturaDistributionProfile' },
            targetServiceUrl: { type: 's' },
            targetAccountId: { type: 'n' },
            targetLoginId: { type: 's' },
            targetLoginPassword: { type: 's' },
            metadataXslt: { type: 's' },
            metadataXpathsTriggerUpdate: { type: 'a', subTypeConstructor: KalturaStringValue, subType: 'KalturaStringValue' },
            distributeCaptions: { type: 'b' },
            distributeCuePoints: { type: 'b' },
            distributeRemoteFlavorAssetContent: { type: 'b' },
            distributeRemoteThumbAssetContent: { type: 'b' },
            distributeRemoteCaptionAssetContent: { type: 'b' },
            mapAccessControlProfileIds: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            mapConversionProfileIds: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            mapMetadataProfileIds: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            mapStorageProfileIds: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            mapFlavorParamsIds: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            mapThumbParamsIds: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            mapCaptionParamsIds: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCrossKalturaDistributionProfile'] = KalturaCrossKalturaDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCuePointBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCuePointBaseFilter' },
            idEqual: { type: 's' },
            idIn: { type: 's' },
            cuePointTypeEqual: { type: 'es', subTypeConstructor: KalturaCuePointType, subType: 'KalturaCuePointType' },
            cuePointTypeIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaCuePointStatus, subType: 'KalturaCuePointStatus' },
            statusIn: { type: 's' },
            entryIdEqual: { type: 's' },
            entryIdIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            triggeredAtGreaterThanOrEqual: { type: 'd' },
            triggeredAtLessThanOrEqual: { type: 'd' },
            tagsLike: { type: 's' },
            tagsMultiLikeOr: { type: 's' },
            tagsMultiLikeAnd: { type: 's' },
            startTimeGreaterThanOrEqual: { type: 'n' },
            startTimeLessThanOrEqual: { type: 'n' },
            userIdEqual: { type: 's' },
            userIdIn: { type: 's' },
            partnerSortValueEqual: { type: 'n' },
            partnerSortValueIn: { type: 's' },
            partnerSortValueGreaterThanOrEqual: { type: 'n' },
            partnerSortValueLessThanOrEqual: { type: 'n' },
            forceStopEqual: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            systemNameEqual: { type: 's' },
            systemNameIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCuePointBaseFilter'] = KalturaCuePointBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDailymotionDistributionJobProviderData extends KalturaConfigurableDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.captionsInfo === 'undefined')
            this.captionsInfo = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDailymotionDistributionJobProviderData' },
            videoAssetFilePath: { type: 's' },
            accessControlGeoBlockingOperation: { type: 's' },
            accessControlGeoBlockingCountryList: { type: 's' },
            captionsInfo: { type: 'a', subTypeConstructor: KalturaDailymotionDistributionCaptionInfo, subType: 'KalturaDailymotionDistributionCaptionInfo' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDailymotionDistributionJobProviderData'] = KalturaDailymotionDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaDailymotionGeoBlockingMapping = {
    accessControl: 1,
    disabled: 0,
    metadata: 2,
};
KalturaDailymotionGeoBlockingMapping[KalturaDailymotionGeoBlockingMapping.accessControl] = 'accessControl';
KalturaDailymotionGeoBlockingMapping[KalturaDailymotionGeoBlockingMapping.disabled] = 'disabled';
KalturaDailymotionGeoBlockingMapping[KalturaDailymotionGeoBlockingMapping.metadata] = 'metadata';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDailymotionDistributionProfile extends KalturaConfigurableDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDailymotionDistributionProfile' },
            user: { type: 's' },
            password: { type: 's' },
            geoBlockingMapping: { type: 'en', subTypeConstructor: KalturaDailymotionGeoBlockingMapping, subType: 'KalturaDailymotionGeoBlockingMapping' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDailymotionDistributionProfile'] = KalturaDailymotionDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileFilter extends KalturaDeliveryProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileFilter' },
            isLive: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileFilter'] = KalturaDeliveryProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileGenericRtmp extends KalturaDeliveryProfileRtmp {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileGenericRtmp' },
            pattern: { type: 's' },
            rendererClass: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileGenericRtmp'] = KalturaDeliveryProfileGenericRtmp;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileLivePackagerHls extends KalturaDeliveryProfileLivePackager {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileLivePackagerHls' },
            disableExtraAttributes: { type: 'b' },
            forceProxy: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileLivePackagerHls'] = KalturaDeliveryProfileLivePackagerHls;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileVodPackagerHls extends KalturaDeliveryProfileVodPackagerPlayServer {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileVodPackagerHls' },
            allowFairplayOffline: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileVodPackagerHls'] = KalturaDeliveryProfileVodPackagerHls;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionDeleteJobData extends KalturaDistributionJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionDeleteJobData' },
            keepDistributionItem: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionDeleteJobData'] = KalturaDistributionDeleteJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionFetchReportJobData extends KalturaDistributionJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionFetchReportJobData' },
            plays: { type: 'n' },
            views: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionFetchReportJobData'] = KalturaDistributionFetchReportJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionProfileFilter extends KalturaDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionProfileFilter'] = KalturaDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionProviderFilter extends KalturaDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionProviderFilter'] = KalturaDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionSubmitJobData extends KalturaDistributionJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionSubmitJobData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionSubmitJobData'] = KalturaDistributionSubmitJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionUpdateJobData extends KalturaDistributionJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionUpdateJobData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionUpdateJobData'] = KalturaDistributionUpdateJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionValidationErrorInvalidMetadata extends KalturaDistributionValidationErrorInvalidData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionValidationErrorInvalidMetadata' },
            metadataProfileId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionValidationErrorInvalidMetadata'] = KalturaDistributionValidationErrorInvalidMetadata;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDocumentFlavorParams extends KalturaFlavorParams {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDocumentFlavorParams' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDocumentFlavorParams'] = KalturaDocumentFlavorParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDoubleClickDistributionProfile extends KalturaConfigurableDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDoubleClickDistributionProfile' },
            channelTitle: { type: 's' },
            channelLink: { type: 's' },
            channelDescription: { type: 's' },
            feedUrl: { type: 's', readOnly: true },
            cuePointsProvider: { type: 's' },
            itemsPerPage: { type: 's' },
            ignoreSchedulingInFeed: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDoubleClickDistributionProfile'] = KalturaDoubleClickDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDrmPolicyFilter extends KalturaDrmPolicyBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDrmPolicyFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDrmPolicyFilter'] = KalturaDrmPolicyFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDrmProfileFilter extends KalturaDrmProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDrmProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDrmProfileFilter'] = KalturaDrmProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDropFolderFileFilter extends KalturaDropFolderFileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDropFolderFileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDropFolderFileFilter'] = KalturaDropFolderFileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDropFolderFilter extends KalturaDropFolderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDropFolderFilter' },
            currentDc: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDropFolderFilter'] = KalturaDropFolderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDynamicObjectSearchItem extends KalturaSearchOperator {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDynamicObjectSearchItem' },
            field: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDynamicObjectSearchItem'] = KalturaDynamicObjectSearchItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaESearchItemType = {
    exactMatch: 1,
    exists: 4,
    partial: 2,
    range: 5,
    startsWith: 3,
};
KalturaESearchItemType[KalturaESearchItemType.exactMatch] = 'exactMatch';
KalturaESearchItemType[KalturaESearchItemType.exists] = 'exists';
KalturaESearchItemType[KalturaESearchItemType.partial] = 'partial';
KalturaESearchItemType[KalturaESearchItemType.range] = 'range';
KalturaESearchItemType[KalturaESearchItemType.startsWith] = 'startsWith';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchAbstractCategoryItem extends KalturaESearchCategoryBaseItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchAbstractCategoryItem' },
            searchTerm: { type: 's' },
            itemType: { type: 'en', subTypeConstructor: KalturaESearchItemType, subType: 'KalturaESearchItemType' },
            range: { type: 'o', subTypeConstructor: KalturaESearchRange, subType: 'KalturaESearchRange' },
            addHighlight: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchAbstractCategoryItem'] = KalturaESearchAbstractCategoryItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchAbstractEntryItem extends KalturaESearchEntryBaseItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchAbstractEntryItem' },
            searchTerm: { type: 's' },
            itemType: { type: 'en', subTypeConstructor: KalturaESearchItemType, subType: 'KalturaESearchItemType' },
            range: { type: 'o', subTypeConstructor: KalturaESearchRange, subType: 'KalturaESearchRange' },
            addHighlight: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchAbstractEntryItem'] = KalturaESearchAbstractEntryItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchAbstractUserItem extends KalturaESearchUserBaseItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchAbstractUserItem' },
            searchTerm: { type: 's' },
            itemType: { type: 'en', subTypeConstructor: KalturaESearchItemType, subType: 'KalturaESearchItemType' },
            range: { type: 'o', subTypeConstructor: KalturaESearchRange, subType: 'KalturaESearchRange' },
            addHighlight: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchAbstractUserItem'] = KalturaESearchAbstractUserItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEdgeServerNode extends KalturaDeliveryServerNode {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEdgeServerNode' },
            playbackDomain: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEdgeServerNode'] = KalturaEdgeServerNode;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEmailNotificationDispatchJobData extends KalturaEventNotificationDispatchJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.customHeaders === 'undefined')
            this.customHeaders = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEmailNotificationDispatchJobData' },
            fromEmail: { type: 's' },
            fromName: { type: 's' },
            to: { type: 'o', subTypeConstructor: KalturaEmailNotificationRecipientJobData, subType: 'KalturaEmailNotificationRecipientJobData' },
            cc: { type: 'o', subTypeConstructor: KalturaEmailNotificationRecipientJobData, subType: 'KalturaEmailNotificationRecipientJobData' },
            bcc: { type: 'o', subTypeConstructor: KalturaEmailNotificationRecipientJobData, subType: 'KalturaEmailNotificationRecipientJobData' },
            replyTo: { type: 'o', subTypeConstructor: KalturaEmailNotificationRecipientJobData, subType: 'KalturaEmailNotificationRecipientJobData' },
            priority: { type: 'en', subTypeConstructor: KalturaEmailNotificationTemplatePriority, subType: 'KalturaEmailNotificationTemplatePriority' },
            confirmReadingTo: { type: 's' },
            hostname: { type: 's' },
            messageID: { type: 's' },
            customHeaders: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEmailNotificationDispatchJobData'] = KalturaEmailNotificationDispatchJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEndUserReportInputFilter extends KalturaReportInputFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEndUserReportInputFilter' },
            application: { type: 's' },
            userIds: { type: 's' },
            playbackContext: { type: 's' },
            ancestorPlaybackContext: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEndUserReportInputFilter'] = KalturaEndUserReportInputFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryDistributionBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryDistributionBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            submittedAtGreaterThanOrEqual: { type: 'd' },
            submittedAtLessThanOrEqual: { type: 'd' },
            entryIdEqual: { type: 's' },
            entryIdIn: { type: 's' },
            distributionProfileIdEqual: { type: 'n' },
            distributionProfileIdIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaEntryDistributionStatus, subType: 'KalturaEntryDistributionStatus' },
            statusIn: { type: 's' },
            dirtyStatusEqual: { type: 'en', subTypeConstructor: KalturaEntryDistributionFlag, subType: 'KalturaEntryDistributionFlag' },
            dirtyStatusIn: { type: 's' },
            sunriseGreaterThanOrEqual: { type: 'd' },
            sunriseLessThanOrEqual: { type: 'd' },
            sunsetGreaterThanOrEqual: { type: 'd' },
            sunsetLessThanOrEqual: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryDistributionBaseFilter'] = KalturaEntryDistributionBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryIndexAdvancedFilter extends KalturaIndexAdvancedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryIndexAdvancedFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryIndexAdvancedFilter'] = KalturaEntryIndexAdvancedFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryReferrerLiveStats extends KalturaEntryLiveStats {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryReferrerLiveStats' },
            referrer: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryReferrerLiveStats'] = KalturaEntryReferrerLiveStats;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryResource extends KalturaContentResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryResource' },
            entryId: { type: 's' },
            flavorParamsId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryResource'] = KalturaEntryResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryServerNodeFilter extends KalturaEntryServerNodeBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryServerNodeFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryServerNodeFilter'] = KalturaEntryServerNodeFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEventNotificationTemplateFilter extends KalturaEventNotificationTemplateBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEventNotificationTemplateFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEventNotificationTemplateFilter'] = KalturaEventNotificationTemplateFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaExtractMediaJobData extends KalturaConvartableJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaExtractMediaJobData' },
            flavorAssetId: { type: 's' },
            calculateComplexity: { type: 'b' },
            extractId3Tags: { type: 'b' },
            destDataFilePath: { type: 's' },
            detectGOP: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaExtractMediaJobData'] = KalturaExtractMediaJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFacebookDistributionJobProviderData extends KalturaConfigurableDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.captionsInfo === 'undefined')
            this.captionsInfo = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFacebookDistributionJobProviderData' },
            videoAssetFilePath: { type: 's' },
            thumbAssetId: { type: 's' },
            captionsInfo: { type: 'a', subTypeConstructor: KalturaFacebookCaptionDistributionInfo, subType: 'KalturaFacebookCaptionDistributionInfo' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFacebookDistributionJobProviderData'] = KalturaFacebookDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFacebookDistributionProfile extends KalturaConfigurableDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFacebookDistributionProfile' },
            apiAuthorizeUrl: { type: 's' },
            pageId: { type: 's' },
            pageAccessToken: { type: 's' },
            userAccessToken: { type: 's' },
            state: { type: 's' },
            permissions: { type: 's' },
            reRequestPermissions: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFacebookDistributionProfile'] = KalturaFacebookDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFairPlayPlaybackPluginData extends KalturaDrmPlaybackPluginData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFairPlayPlaybackPluginData' },
            certificate: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFairPlayPlaybackPluginData'] = KalturaFairPlayPlaybackPluginData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIntegerField extends KalturaIntegerValue {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIntegerField' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIntegerField'] = KalturaIntegerField;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFieldCompareCondition extends KalturaCompareCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFieldCompareCondition' },
            field: { type: 'o', subTypeConstructor: KalturaIntegerField, subType: 'KalturaIntegerField' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFieldCompareCondition'] = KalturaFieldCompareCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaStringField extends KalturaStringValue {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaStringField' }
        });
        return result;
    }
}
typesMappingStorage['KalturaStringField'] = KalturaStringField;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFieldMatchCondition extends KalturaMatchCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFieldMatchCondition' },
            field: { type: 'o', subTypeConstructor: KalturaStringField, subType: 'KalturaStringField' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFieldMatchCondition'] = KalturaFieldMatchCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFileAssetBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFileAssetBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            partnerIdEqual: { type: 'n' },
            fileAssetObjectTypeEqual: { type: 'es', subTypeConstructor: KalturaFileAssetObjectType, subType: 'KalturaFileAssetObjectType' },
            objectIdEqual: { type: 's' },
            objectIdIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'n' },
            createdAtLessThanOrEqual: { type: 'n' },
            updatedAtGreaterThanOrEqual: { type: 'n' },
            updatedAtLessThanOrEqual: { type: 'n' },
            statusEqual: { type: 'es', subTypeConstructor: KalturaFileAssetStatus, subType: 'KalturaFileAssetStatus' },
            statusIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFileAssetBaseFilter'] = KalturaFileAssetBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFileSyncFilter extends KalturaFileSyncBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFileSyncFilter' },
            currentDc: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFileSyncFilter'] = KalturaFileSyncFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFileSyncResource extends KalturaContentResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFileSyncResource' },
            fileSyncObjectType: { type: 'n' },
            objectSubType: { type: 'n' },
            objectId: { type: 's' },
            version: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFileSyncResource'] = KalturaFileSyncResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFreewheelGenericDistributionJobProviderData extends KalturaConfigurableDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.videoAssetFilePaths === 'undefined')
            this.videoAssetFilePaths = [];
        if (typeof this.cuePoints === 'undefined')
            this.cuePoints = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFreewheelGenericDistributionJobProviderData' },
            videoAssetFilePaths: { type: 'a', subTypeConstructor: KalturaString, subType: 'KalturaString' },
            thumbAssetFilePath: { type: 's' },
            cuePoints: { type: 'a', subTypeConstructor: KalturaCuePoint, subType: 'KalturaCuePoint' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFreewheelGenericDistributionJobProviderData'] = KalturaFreewheelGenericDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFreewheelGenericDistributionProfile extends KalturaConfigurableDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFreewheelGenericDistributionProfile' },
            apikey: { type: 's' },
            email: { type: 's' },
            sftpPass: { type: 's' },
            sftpLogin: { type: 's' },
            contentOwner: { type: 's' },
            upstreamVideoId: { type: 's' },
            upstreamNetworkName: { type: 's' },
            upstreamNetworkId: { type: 's' },
            categoryId: { type: 's' },
            replaceGroup: { type: 'b' },
            replaceAirDates: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFreewheelGenericDistributionProfile'] = KalturaFreewheelGenericDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFtpDistributionJobProviderData extends KalturaConfigurableDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.filesForDistribution === 'undefined')
            this.filesForDistribution = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFtpDistributionJobProviderData' },
            filesForDistribution: { type: 'a', subTypeConstructor: KalturaFtpDistributionFile, subType: 'KalturaFtpDistributionFile' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFtpDistributionJobProviderData'] = KalturaFtpDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFtpDistributionProfile extends KalturaConfigurableDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFtpDistributionProfile' },
            protocol: { type: 'en', subTypeConstructor: KalturaDistributionProtocol, subType: 'KalturaDistributionProtocol' },
            host: { type: 's' },
            port: { type: 'n' },
            basePath: { type: 's' },
            username: { type: 's' },
            password: { type: 's' },
            passphrase: { type: 's' },
            sftpPublicKey: { type: 's' },
            sftpPrivateKey: { type: 's' },
            disableMetadata: { type: 'b' },
            metadataXslt: { type: 's' },
            metadataFilenameXslt: { type: 's' },
            flavorAssetFilenameXslt: { type: 's' },
            thumbnailAssetFilenameXslt: { type: 's' },
            assetFilenameXslt: { type: 's' },
            asperaPublicKey: { type: 's' },
            asperaPrivateKey: { type: 's' },
            sendMetadataAfterAssets: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFtpDistributionProfile'] = KalturaFtpDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFtpDropFolder extends KalturaRemoteDropFolder {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFtpDropFolder' },
            host: { type: 's' },
            port: { type: 'n' },
            username: { type: 's' },
            password: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFtpDropFolder'] = KalturaFtpDropFolder;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFtpScheduledDistributionProvider extends KalturaFtpDistributionProvider {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFtpScheduledDistributionProvider' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFtpScheduledDistributionProvider'] = KalturaFtpScheduledDistributionProvider;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericDistributionProviderActionFilter extends KalturaGenericDistributionProviderActionBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericDistributionProviderActionFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericDistributionProviderActionFilter'] = KalturaGenericDistributionProviderActionFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericXsltSyndicationFeed extends KalturaGenericSyndicationFeed {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.itemXpathsToExtend === 'undefined')
            this.itemXpathsToExtend = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericXsltSyndicationFeed' },
            xslt: { type: 's' },
            itemXpathsToExtend: { type: 'a', subTypeConstructor: KalturaExtendingItemMrssParameter, subType: 'KalturaExtendingItemMrssParameter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericXsltSyndicationFeed'] = KalturaGenericXsltSyndicationFeed;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGeoDistanceCondition extends KalturaMatchCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGeoDistanceCondition' },
            geoCoderType: { type: 'es', subTypeConstructor: KalturaGeoCoderType, subType: 'KalturaGeoCoderType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGeoDistanceCondition'] = KalturaGeoDistanceCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGeoTimeLiveStats extends KalturaEntryLiveStats {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGeoTimeLiveStats' },
            city: { type: 'o', subTypeConstructor: KalturaCoordinate, subType: 'KalturaCoordinate' },
            country: { type: 'o', subTypeConstructor: KalturaCoordinate, subType: 'KalturaCoordinate' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGeoTimeLiveStats'] = KalturaGeoTimeLiveStats;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGroupUserBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGroupUserBaseFilter' },
            userIdEqual: { type: 's' },
            userIdIn: { type: 's' },
            groupIdEqual: { type: 's' },
            groupIdIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaGroupUserStatus, subType: 'KalturaGroupUserStatus' },
            statusIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGroupUserBaseFilter'] = KalturaGroupUserBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaHttpNotificationDispatchJobData extends KalturaEventNotificationDispatchJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.customHeaders === 'undefined')
            this.customHeaders = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaHttpNotificationDispatchJobData' },
            url: { type: 's' },
            method: { type: 'en', subTypeConstructor: KalturaHttpNotificationMethod, subType: 'KalturaHttpNotificationMethod' },
            data: { type: 's' },
            timeout: { type: 'n' },
            connectTimeout: { type: 'n' },
            username: { type: 's' },
            password: { type: 's' },
            authenticationMethod: { type: 'en', subTypeConstructor: KalturaHttpNotificationAuthenticationMethod, subType: 'KalturaHttpNotificationAuthenticationMethod' },
            sslVersion: { type: 'en', subTypeConstructor: KalturaHttpNotificationSslVersion, subType: 'KalturaHttpNotificationSslVersion' },
            sslCertificate: { type: 's' },
            sslCertificateType: { type: 'es', subTypeConstructor: KalturaHttpNotificationCertificateType, subType: 'KalturaHttpNotificationCertificateType' },
            sslCertificatePassword: { type: 's' },
            sslEngine: { type: 's' },
            sslEngineDefault: { type: 's' },
            sslKeyType: { type: 'es', subTypeConstructor: KalturaHttpNotificationSslKeyType, subType: 'KalturaHttpNotificationSslKeyType' },
            sslKey: { type: 's' },
            sslKeyPassword: { type: 's' },
            customHeaders: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            signSecret: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaHttpNotificationDispatchJobData'] = KalturaHttpNotificationDispatchJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaHuluDistributionJobProviderData extends KalturaConfigurableDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.cuePoints === 'undefined')
            this.cuePoints = [];
        if (typeof this.captionLocalPaths === 'undefined')
            this.captionLocalPaths = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaHuluDistributionJobProviderData' },
            videoAssetFilePath: { type: 's' },
            thumbAssetFilePath: { type: 's' },
            cuePoints: { type: 'a', subTypeConstructor: KalturaCuePoint, subType: 'KalturaCuePoint' },
            fileBaseName: { type: 's' },
            captionLocalPaths: { type: 'a', subTypeConstructor: KalturaString, subType: 'KalturaString' }
        });
        return result;
    }
}
typesMappingStorage['KalturaHuluDistributionJobProviderData'] = KalturaHuluDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaHuluDistributionProfile extends KalturaConfigurableDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.seriesAdditionalCategories === 'undefined')
            this.seriesAdditionalCategories = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaHuluDistributionProfile' },
            sftpHost: { type: 's' },
            sftpLogin: { type: 's' },
            sftpPass: { type: 's' },
            seriesChannel: { type: 's' },
            seriesPrimaryCategory: { type: 's' },
            seriesAdditionalCategories: { type: 'a', subTypeConstructor: KalturaString, subType: 'KalturaString' },
            seasonNumber: { type: 's' },
            seasonSynopsis: { type: 's' },
            seasonTuneInInformation: { type: 's' },
            videoMediaType: { type: 's' },
            disableEpisodeNumberCustomValidation: { type: 'b' },
            protocol: { type: 'en', subTypeConstructor: KalturaDistributionProtocol, subType: 'KalturaDistributionProtocol' },
            asperaHost: { type: 's' },
            asperaLogin: { type: 's' },
            asperaPass: { type: 's' },
            port: { type: 'n' },
            passphrase: { type: 's' },
            asperaPublicKey: { type: 's' },
            asperaPrivateKey: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaHuluDistributionProfile'] = KalturaHuluDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIdeticDistributionJobProviderData extends KalturaConfigurableDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIdeticDistributionJobProviderData' },
            thumbnailUrl: { type: 's' },
            flavorAssetUrl: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIdeticDistributionJobProviderData'] = KalturaIdeticDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIdeticDistributionProfile extends KalturaConfigurableDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIdeticDistributionProfile' },
            ftpPath: { type: 's' },
            username: { type: 's' },
            password: { type: 's' },
            domain: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIdeticDistributionProfile'] = KalturaIdeticDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaImageFlavorParams extends KalturaFlavorParams {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaImageFlavorParams' },
            densityWidth: { type: 'n' },
            densityHeight: { type: 'n' },
            sizeWidth: { type: 'n' },
            sizeHeight: { type: 'n' },
            depth: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaImageFlavorParams'] = KalturaImageFlavorParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIpAddressCondition extends KalturaMatchCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIpAddressCondition' },
            acceptInternalIps: { type: 'b' },
            httpHeader: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIpAddressCondition'] = KalturaIpAddressCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLikeBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLikeBaseFilter' },
            entryIdEqual: { type: 's' },
            entryIdIn: { type: 's' },
            userIdEqual: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLikeBaseFilter'] = KalturaLikeBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveAsset extends KalturaFlavorAsset {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveAsset' },
            multicastIP: { type: 's' },
            multicastPort: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveAsset'] = KalturaLiveAsset;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveChannelSegmentBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveChannelSegmentBaseFilter' },
            createdAtGreaterThanOrEqual: { type: 'n' },
            createdAtLessThanOrEqual: { type: 'n' },
            updatedAtGreaterThanOrEqual: { type: 'n' },
            updatedAtLessThanOrEqual: { type: 'n' },
            statusEqual: { type: 'es', subTypeConstructor: KalturaLiveChannelSegmentStatus, subType: 'KalturaLiveChannelSegmentStatus' },
            statusIn: { type: 's' },
            channelIdEqual: { type: 's' },
            channelIdIn: { type: 's' },
            startTimeGreaterThanOrEqual: { type: 'n' },
            startTimeLessThanOrEqual: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveChannelSegmentBaseFilter'] = KalturaLiveChannelSegmentBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveParams extends KalturaFlavorParams {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveParams' },
            streamSuffix: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveParams'] = KalturaLiveParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamScheduleEvent extends KalturaEntryScheduleEvent {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamScheduleEvent' },
            projectedAudience: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamScheduleEvent'] = KalturaLiveStreamScheduleEvent;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMatchMetadataCondition extends KalturaMatchCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMatchMetadataCondition' },
            xPath: { type: 's' },
            profileId: { type: 'n' },
            profileSystemName: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMatchMetadataCondition'] = KalturaMatchMetadataCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaFlavorParams extends KalturaFlavorParams {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaFlavorParams' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaFlavorParams'] = KalturaMediaFlavorParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaInfoFilter extends KalturaMediaInfoBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaInfoFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaInfoFilter'] = KalturaMediaInfoFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaServerNode extends KalturaDeliveryServerNode {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.mediaServerPortConfig === 'undefined')
            this.mediaServerPortConfig = [];
        if (typeof this.mediaServerPlaybackDomainConfig === 'undefined')
            this.mediaServerPlaybackDomainConfig = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaServerNode' },
            applicationName: { type: 's' },
            mediaServerPortConfig: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            mediaServerPlaybackDomainConfig: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaServerNode'] = KalturaMediaServerNode;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetadataBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetadataBaseFilter' },
            partnerIdEqual: { type: 'n' },
            metadataProfileIdEqual: { type: 'n' },
            metadataProfileIdIn: { type: 's' },
            metadataProfileVersionEqual: { type: 'n' },
            metadataProfileVersionGreaterThanOrEqual: { type: 'n' },
            metadataProfileVersionLessThanOrEqual: { type: 'n' },
            metadataObjectTypeEqual: { type: 'es', subTypeConstructor: KalturaMetadataObjectType, subType: 'KalturaMetadataObjectType' },
            objectIdEqual: { type: 's' },
            objectIdIn: { type: 's' },
            versionEqual: { type: 'n' },
            versionGreaterThanOrEqual: { type: 'n' },
            versionLessThanOrEqual: { type: 'n' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaMetadataStatus, subType: 'KalturaMetadataStatus' },
            statusIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetadataBaseFilter'] = KalturaMetadataBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetadataFieldChangedCondition extends KalturaMatchCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetadataFieldChangedCondition' },
            xPath: { type: 's' },
            profileId: { type: 'n' },
            profileSystemName: { type: 's' },
            versionA: { type: 's' },
            versionB: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetadataFieldChangedCondition'] = KalturaMetadataFieldChangedCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetadataProfileFilter extends KalturaMetadataProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetadataProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetadataProfileFilter'] = KalturaMetadataProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetadataSearchItem extends KalturaSearchOperator {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetadataSearchItem' },
            metadataProfileId: { type: 'n' },
            orderBy: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetadataSearchItem'] = KalturaMetadataSearchItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetroPcsDistributionJobProviderData extends KalturaConfigurableDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetroPcsDistributionJobProviderData' },
            assetLocalPaths: { type: 's' },
            thumbUrls: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetroPcsDistributionJobProviderData'] = KalturaMetroPcsDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetroPcsDistributionProfile extends KalturaConfigurableDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetroPcsDistributionProfile' },
            ftpHost: { type: 's' },
            ftpLogin: { type: 's' },
            ftpPass: { type: 's' },
            ftpPath: { type: 's' },
            providerName: { type: 's' },
            providerId: { type: 's' },
            copyright: { type: 's' },
            entitlements: { type: 's' },
            rating: { type: 's' },
            itemType: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetroPcsDistributionProfile'] = KalturaMetroPcsDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMsnDistributionJobProviderData extends KalturaConfigurableDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMsnDistributionJobProviderData' },
            xml: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMsnDistributionJobProviderData'] = KalturaMsnDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMsnDistributionProfile extends KalturaConfigurableDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMsnDistributionProfile' },
            username: { type: 's' },
            password: { type: 's' },
            domain: { type: 's' },
            csId: { type: 's' },
            source: { type: 's' },
            sourceFriendlyName: { type: 's' },
            pageGroup: { type: 's' },
            sourceFlavorParamsId: { type: 'n' },
            wmvFlavorParamsId: { type: 'n' },
            flvFlavorParamsId: { type: 'n' },
            slFlavorParamsId: { type: 'n' },
            slHdFlavorParamsId: { type: 'n' },
            msnvideoCat: { type: 's' },
            msnvideoTop: { type: 's' },
            msnvideoTopCat: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMsnDistributionProfile'] = KalturaMsnDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaOperationResource extends KalturaContentResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.operationAttributes === 'undefined')
            this.operationAttributes = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaOperationResource' },
            resource: { type: 'o', subTypeConstructor: KalturaContentResource, subType: 'KalturaContentResource' },
            operationAttributes: { type: 'a', subTypeConstructor: KalturaOperationAttributes, subType: 'KalturaOperationAttributes' },
            assetParamsId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaOperationResource'] = KalturaOperationResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPartnerFilter extends KalturaPartnerBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPartnerFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPartnerFilter'] = KalturaPartnerFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPdfFlavorParams extends KalturaFlavorParams {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPdfFlavorParams' },
            readonly: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPdfFlavorParams'] = KalturaPdfFlavorParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPermissionBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPermissionBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            typeEqual: { type: 'en', subTypeConstructor: KalturaPermissionType, subType: 'KalturaPermissionType' },
            typeIn: { type: 's' },
            nameEqual: { type: 's' },
            nameIn: { type: 's' },
            friendlyNameLike: { type: 's' },
            descriptionLike: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaPermissionStatus, subType: 'KalturaPermissionStatus' },
            statusIn: { type: 's' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            dependsOnPermissionNamesMultiLikeOr: { type: 's' },
            dependsOnPermissionNamesMultiLikeAnd: { type: 's' },
            tagsMultiLikeOr: { type: 's' },
            tagsMultiLikeAnd: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPermissionBaseFilter'] = KalturaPermissionBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPermissionItemBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPermissionItemBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            typeEqual: { type: 'es', subTypeConstructor: KalturaPermissionItemType, subType: 'KalturaPermissionItemType' },
            typeIn: { type: 's' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            tagsMultiLikeOr: { type: 's' },
            tagsMultiLikeAnd: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPermissionItemBaseFilter'] = KalturaPermissionItemBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlaybackContextOptions extends KalturaEntryContextDataParams {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlaybackContextOptions' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlaybackContextOptions'] = KalturaPlaybackContextOptions;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPostConvertJobData extends KalturaConvartableJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPostConvertJobData' },
            flavorAssetId: { type: 's' },
            flavorAssetEncryptionKey: { type: 's' },
            createThumb: { type: 'b' },
            thumbPath: { type: 's' },
            thumbOffset: { type: 'n' },
            thumbHeight: { type: 'n' },
            thumbBitrate: { type: 'n' },
            customData: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPostConvertJobData'] = KalturaPostConvertJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPreviewRestriction extends KalturaSessionRestriction {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPreviewRestriction' },
            previewLength: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPreviewRestriction'] = KalturaPreviewRestriction;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaQuickPlayDistributionJobProviderData extends KalturaConfigurableDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.videoFilePaths === 'undefined')
            this.videoFilePaths = [];
        if (typeof this.thumbnailFilePaths === 'undefined')
            this.thumbnailFilePaths = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaQuickPlayDistributionJobProviderData' },
            xml: { type: 's' },
            videoFilePaths: { type: 'a', subTypeConstructor: KalturaString, subType: 'KalturaString' },
            thumbnailFilePaths: { type: 'a', subTypeConstructor: KalturaString, subType: 'KalturaString' }
        });
        return result;
    }
}
typesMappingStorage['KalturaQuickPlayDistributionJobProviderData'] = KalturaQuickPlayDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaQuickPlayDistributionProfile extends KalturaConfigurableDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaQuickPlayDistributionProfile' },
            sftpHost: { type: 's' },
            sftpLogin: { type: 's' },
            sftpPass: { type: 's' },
            sftpBasePath: { type: 's' },
            channelTitle: { type: 's' },
            channelLink: { type: 's' },
            channelDescription: { type: 's' },
            channelManagingEditor: { type: 's' },
            channelLanguage: { type: 's' },
            channelImageTitle: { type: 's' },
            channelImageWidth: { type: 's' },
            channelImageHeight: { type: 's' },
            channelImageLink: { type: 's' },
            channelImageUrl: { type: 's' },
            channelCopyright: { type: 's' },
            channelGenerator: { type: 's' },
            channelRating: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaQuickPlayDistributionProfile'] = KalturaQuickPlayDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaQuizFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaQuizFilter' },
            entryIdEqual: { type: 's' },
            entryIdIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaQuizFilter'] = KalturaQuizFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRecalculateResponseProfileCacheJobData extends KalturaRecalculateCacheJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.userRoles === 'undefined')
            this.userRoles = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRecalculateResponseProfileCacheJobData' },
            protocol: { type: 's' },
            ksType: { type: 'en', subTypeConstructor: KalturaSessionType, subType: 'KalturaSessionType' },
            userRoles: { type: 'a', subTypeConstructor: KalturaIntegerValue, subType: 'KalturaIntegerValue' },
            cachedObjectType: { type: 's' },
            objectId: { type: 's' },
            startObjectKey: { type: 's' },
            endObjectKey: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaRecalculateResponseProfileCacheJobData'] = KalturaRecalculateResponseProfileCacheJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRecordScheduleEvent extends KalturaEntryScheduleEvent {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRecordScheduleEvent' }
        });
        return result;
    }
}
typesMappingStorage['KalturaRecordScheduleEvent'] = KalturaRecordScheduleEvent;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRegexCondition extends KalturaMatchCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRegexCondition' }
        });
        return result;
    }
}
typesMappingStorage['KalturaRegexCondition'] = KalturaRegexCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRemoteStorageResources extends KalturaContentResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.resources === 'undefined')
            this.resources = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRemoteStorageResources' },
            resources: { type: 'a', subTypeConstructor: KalturaRemoteStorageResource, subType: 'KalturaRemoteStorageResource' }
        });
        return result;
    }
}
typesMappingStorage['KalturaRemoteStorageResources'] = KalturaRemoteStorageResources;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaResponseProfileFilter extends KalturaResponseProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaResponseProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaResponseProfileFilter'] = KalturaResponseProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduleEventBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduleEventBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            idNotIn: { type: 's' },
            parentIdEqual: { type: 'n' },
            parentIdIn: { type: 's' },
            parentIdNotIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaScheduleEventStatus, subType: 'KalturaScheduleEventStatus' },
            statusIn: { type: 's' },
            startDateGreaterThanOrEqual: { type: 'd' },
            startDateLessThanOrEqual: { type: 'd' },
            endDateGreaterThanOrEqual: { type: 'd' },
            endDateLessThanOrEqual: { type: 'd' },
            referenceIdEqual: { type: 's' },
            referenceIdIn: { type: 's' },
            ownerIdEqual: { type: 's' },
            ownerIdIn: { type: 's' },
            priorityEqual: { type: 'n' },
            priorityIn: { type: 's' },
            priorityGreaterThanOrEqual: { type: 'n' },
            priorityLessThanOrEqual: { type: 'n' },
            recurrenceTypeEqual: { type: 'en', subTypeConstructor: KalturaScheduleEventRecurrenceType, subType: 'KalturaScheduleEventRecurrenceType' },
            recurrenceTypeIn: { type: 's' },
            tagsLike: { type: 's' },
            tagsMultiLikeOr: { type: 's' },
            tagsMultiLikeAnd: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduleEventBaseFilter'] = KalturaScheduleEventBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduleEventResourceBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduleEventResourceBaseFilter' },
            eventIdEqual: { type: 'n' },
            eventIdIn: { type: 's' },
            resourceIdEqual: { type: 'n' },
            resourceIdIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduleEventResourceBaseFilter'] = KalturaScheduleEventResourceBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduleResourceBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduleResourceBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            idNotIn: { type: 's' },
            parentIdEqual: { type: 'n' },
            parentIdIn: { type: 's' },
            nameEqual: { type: 's' },
            systemNameEqual: { type: 's' },
            systemNameIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaScheduleResourceStatus, subType: 'KalturaScheduleResourceStatus' },
            statusIn: { type: 's' },
            tagsLike: { type: 's' },
            tagsMultiLikeOr: { type: 's' },
            tagsMultiLikeAnd: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduleResourceBaseFilter'] = KalturaScheduleResourceBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduledTaskProfileFilter extends KalturaScheduledTaskProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduledTaskProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduledTaskProfileFilter'] = KalturaScheduledTaskProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSearchComparableAttributeCondition extends KalturaAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSearchComparableAttributeCondition' },
            comparison: { type: 'es', subTypeConstructor: KalturaSearchConditionComparison, subType: 'KalturaSearchConditionComparison' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSearchComparableAttributeCondition'] = KalturaSearchComparableAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSearchComparableCondition extends KalturaSearchCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSearchComparableCondition' },
            comparison: { type: 'es', subTypeConstructor: KalturaSearchConditionComparison, subType: 'KalturaSearchConditionComparison' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSearchComparableCondition'] = KalturaSearchComparableCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSearchMatchAttributeCondition extends KalturaAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSearchMatchAttributeCondition' },
            not: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSearchMatchAttributeCondition'] = KalturaSearchMatchAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSearchMatchCondition extends KalturaSearchCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSearchMatchCondition' },
            not: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSearchMatchCondition'] = KalturaSearchMatchCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaServerNodeFilter extends KalturaServerNodeBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaServerNodeFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaServerNodeFilter'] = KalturaServerNodeFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaShortLinkFilter extends KalturaShortLinkBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaShortLinkFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaShortLinkFilter'] = KalturaShortLinkFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSiteCondition extends KalturaMatchCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSiteCondition' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSiteCondition'] = KalturaSiteCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSshDropFolder extends KalturaRemoteDropFolder {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSshDropFolder' },
            host: { type: 's' },
            port: { type: 'n' },
            username: { type: 's' },
            password: { type: 's' },
            privateKey: { type: 's' },
            publicKey: { type: 's' },
            passPhrase: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSshDropFolder'] = KalturaSshDropFolder;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSshImportJobData extends KalturaImportJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSshImportJobData' },
            privateKey: { type: 's' },
            publicKey: { type: 's' },
            passPhrase: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSshImportJobData'] = KalturaSshImportJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaStorageDeleteJobData extends KalturaStorageJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaStorageDeleteJobData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaStorageDeleteJobData'] = KalturaStorageDeleteJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaStorageExportJobData extends KalturaStorageJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaStorageExportJobData' },
            force: { type: 'b' },
            createLink: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaStorageExportJobData'] = KalturaStorageExportJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaStorageProfileFilter extends KalturaStorageProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaStorageProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaStorageProfileFilter'] = KalturaStorageProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaStringResource extends KalturaContentResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaStringResource' },
            content: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaStringResource'] = KalturaStringResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSwfFlavorParams extends KalturaFlavorParams {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSwfFlavorParams' },
            flashVersion: { type: 'n' },
            poly2Bitmap: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSwfFlavorParams'] = KalturaSwfFlavorParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTimedThumbAsset extends KalturaThumbAsset {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTimedThumbAsset' },
            cuePointId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaTimedThumbAsset'] = KalturaTimedThumbAsset;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUiConfFilter extends KalturaUiConfBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUiConfFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUiConfFilter'] = KalturaUiConfFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUnicornDistributionJobProviderData extends KalturaConfigurableDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUnicornDistributionJobProviderData' },
            catalogGuid: { type: 's' },
            title: { type: 's' },
            mediaChanged: { type: 'b' },
            flavorAssetVersion: { type: 's' },
            notificationBaseUrl: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUnicornDistributionJobProviderData'] = KalturaUnicornDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUnicornDistributionProfile extends KalturaConfigurableDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUnicornDistributionProfile' },
            username: { type: 's' },
            password: { type: 's' },
            domainName: { type: 's' },
            channelGuid: { type: 's' },
            apiHostUrl: { type: 's' },
            domainGuid: { type: 's' },
            adFreeApplicationGuid: { type: 's' },
            remoteAssetParamsId: { type: 'n' },
            storageProfileId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUnicornDistributionProfile'] = KalturaUnicornDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUploadTokenFilter extends KalturaUploadTokenBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUploadTokenFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUploadTokenFilter'] = KalturaUploadTokenFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserEntryBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserEntryBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            idNotIn: { type: 's' },
            entryIdEqual: { type: 's' },
            entryIdIn: { type: 's' },
            entryIdNotIn: { type: 's' },
            userIdEqual: { type: 's' },
            userIdIn: { type: 's' },
            userIdNotIn: { type: 's' },
            statusEqual: { type: 'es', subTypeConstructor: KalturaUserEntryStatus, subType: 'KalturaUserEntryStatus' },
            createdAtLessThanOrEqual: { type: 'd' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            typeEqual: { type: 'es', subTypeConstructor: KalturaUserEntryType, subType: 'KalturaUserEntryType' },
            extendedStatusEqual: { type: 'es', subTypeConstructor: KalturaUserEntryExtendedStatus, subType: 'KalturaUserEntryExtendedStatus' },
            extendedStatusIn: { type: 's' },
            extendedStatusNotIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserEntryBaseFilter'] = KalturaUserEntryBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserLoginDataBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserLoginDataBaseFilter' },
            loginEmailEqual: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserLoginDataBaseFilter'] = KalturaUserLoginDataBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserRoleBaseFilter extends KalturaRelatedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserRoleBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            nameEqual: { type: 's' },
            nameIn: { type: 's' },
            systemNameEqual: { type: 's' },
            systemNameIn: { type: 's' },
            descriptionLike: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaUserRoleStatus, subType: 'KalturaUserRoleStatus' },
            statusIn: { type: 's' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            tagsMultiLikeOr: { type: 's' },
            tagsMultiLikeAnd: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserRoleBaseFilter'] = KalturaUserRoleBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaVelocixProvisionJobData extends KalturaProvisionJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.provisioningParams === 'undefined')
            this.provisioningParams = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaVelocixProvisionJobData' },
            provisioningParams: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' },
            userName: { type: 's' },
            password: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaVelocixProvisionJobData'] = KalturaVelocixProvisionJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaVirusScanProfileFilter extends KalturaVirusScanProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaVirusScanProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaVirusScanProfileFilter'] = KalturaVirusScanProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWebexDropFolderContentProcessorJobData extends KalturaDropFolderContentProcessorJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWebexDropFolderContentProcessorJobData' },
            description: { type: 's' },
            webexHostId: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWebexDropFolderContentProcessorJobData'] = KalturaWebexDropFolderContentProcessorJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWidevineFlavorAsset extends KalturaFlavorAsset {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWidevineFlavorAsset' },
            widevineDistributionStartDate: { type: 'n' },
            widevineDistributionEndDate: { type: 'n' },
            widevineAssetId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWidevineFlavorAsset'] = KalturaWidevineFlavorAsset;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWidevineFlavorParams extends KalturaFlavorParams {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWidevineFlavorParams' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWidevineFlavorParams'] = KalturaWidevineFlavorParams;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWidgetFilter extends KalturaWidgetBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWidgetFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWidgetFilter'] = KalturaWidgetFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYahooDistributionJobProviderData extends KalturaConfigurableDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYahooDistributionJobProviderData' },
            smallThumbPath: { type: 's' },
            largeThumbPath: { type: 's' },
            videoAssetFilePath: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYahooDistributionJobProviderData'] = KalturaYahooDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaYahooDistributionProcessFeedActionStatus = {
    automatic: 1,
    manual: 0,
};
KalturaYahooDistributionProcessFeedActionStatus[KalturaYahooDistributionProcessFeedActionStatus.automatic] = 'automatic';
KalturaYahooDistributionProcessFeedActionStatus[KalturaYahooDistributionProcessFeedActionStatus.manual] = 'manual';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYahooDistributionProfile extends KalturaConfigurableDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYahooDistributionProfile' },
            ftpPath: { type: 's' },
            ftpUsername: { type: 's' },
            ftpPassword: { type: 's' },
            ftpHost: { type: 's' },
            contactTelephone: { type: 's' },
            contactEmail: { type: 's' },
            processFeed: { type: 'en', subTypeConstructor: KalturaYahooDistributionProcessFeedActionStatus, subType: 'KalturaYahooDistributionProcessFeedActionStatus' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYahooDistributionProfile'] = KalturaYahooDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYouTubeDistributionJobProviderData extends KalturaConfigurableDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYouTubeDistributionJobProviderData' },
            videoAssetFilePath: { type: 's' },
            thumbAssetFilePath: { type: 's' },
            thumbAssetId: { type: 's' },
            captionAssetIds: { type: 's' },
            sftpDirectory: { type: 's' },
            sftpMetadataFilename: { type: 's' },
            currentPlaylists: { type: 's' },
            newPlaylists: { type: 's' },
            submitXml: { type: 's' },
            updateXml: { type: 's' },
            deleteXml: { type: 's' },
            googleClientId: { type: 's' },
            googleClientSecret: { type: 's' },
            googleTokenData: { type: 's' },
            captionsCsvMap: { type: 's' },
            submitCsvMap: { type: 's' },
            updateCsvMap: { type: 's' },
            deleteVideoIds: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYouTubeDistributionJobProviderData'] = KalturaYouTubeDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaYouTubeDistributionFeedSpecVersion = {
    version1: '1',
    version2: '2',
    version3: '3',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYouTubeDistributionProfile extends KalturaConfigurableDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYouTubeDistributionProfile' },
            feedSpecVersion: { type: 'es', subTypeConstructor: KalturaYouTubeDistributionFeedSpecVersion, subType: 'KalturaYouTubeDistributionFeedSpecVersion' },
            username: { type: 's' },
            notificationEmail: { type: 's' },
            sftpHost: { type: 's' },
            sftpPort: { type: 'n' },
            sftpLogin: { type: 's' },
            sftpPublicKey: { type: 's' },
            sftpPrivateKey: { type: 's' },
            sftpBaseDir: { type: 's' },
            ownerName: { type: 's' },
            defaultCategory: { type: 's' },
            allowComments: { type: 's' },
            allowEmbedding: { type: 's' },
            allowRatings: { type: 's' },
            allowResponses: { type: 's' },
            commercialPolicy: { type: 's' },
            ugcPolicy: { type: 's' },
            target: { type: 's' },
            adServerPartnerId: { type: 's' },
            enableAdServer: { type: 'b' },
            allowPreRollAds: { type: 'b' },
            allowPostRollAds: { type: 'b' },
            strict: { type: 's' },
            overrideManualEdits: { type: 's' },
            urgentReference: { type: 's' },
            allowSyndication: { type: 's' },
            hideViewCount: { type: 's' },
            allowAdsenseForVideo: { type: 's' },
            allowInvideo: { type: 's' },
            allowMidRollAds: { type: 'b' },
            instreamStandard: { type: 's' },
            instreamTrueview: { type: 's' },
            claimType: { type: 's' },
            blockOutsideOwnership: { type: 's' },
            captionAutosync: { type: 's' },
            deleteReference: { type: 'b' },
            releaseClaims: { type: 'b' },
            apiAuthorizeUrl: { type: 's' },
            privacyStatus: { type: 's' },
            enableContentId: { type: 's' },
            thirdPartyAds: { type: 's' },
            productListingAds: { type: 's' },
            domainWhitelist: { type: 's' },
            notifySubscribers: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYouTubeDistributionProfile'] = KalturaYouTubeDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYoutubeApiDistributionJobProviderData extends KalturaConfigurableDistributionJobProviderData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.captionsInfo === 'undefined')
            this.captionsInfo = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYoutubeApiDistributionJobProviderData' },
            videoAssetFilePath: { type: 's' },
            thumbAssetFilePath: { type: 's' },
            captionsInfo: { type: 'a', subTypeConstructor: KalturaYouTubeApiCaptionDistributionInfo, subType: 'KalturaYouTubeApiCaptionDistributionInfo' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYoutubeApiDistributionJobProviderData'] = KalturaYoutubeApiDistributionJobProviderData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYoutubeApiDistributionProfile extends KalturaConfigurableDistributionProfile {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYoutubeApiDistributionProfile' },
            username: { type: 's' },
            defaultCategory: { type: 'n' },
            allowComments: { type: 's' },
            allowEmbedding: { type: 's' },
            allowRatings: { type: 's' },
            allowResponses: { type: 's' },
            apiAuthorizeUrl: { type: 's' },
            googleClientId: { type: 's' },
            googleClientSecret: { type: 's' },
            googleTokenData: { type: 's' },
            assumeSuccess: { type: 'b' },
            privacyStatus: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYoutubeApiDistributionProfile'] = KalturaYoutubeApiDistributionProfile;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlFilter extends KalturaAccessControlBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlFilter'] = KalturaAccessControlFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAccessControlProfileFilter extends KalturaAccessControlProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAccessControlProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAccessControlProfileFilter'] = KalturaAccessControlProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaActivitiBusinessProcessServerBaseFilter extends KalturaBusinessProcessServerFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaActivitiBusinessProcessServerBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaActivitiBusinessProcessServerBaseFilter'] = KalturaActivitiBusinessProcessServerBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAmazonS3StorageExportJobData extends KalturaStorageExportJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAmazonS3StorageExportJobData' },
            filesPermissionInS3: { type: 'es', subTypeConstructor: KalturaAmazonS3StorageProfileFilesPermissionLevel, subType: 'KalturaAmazonS3StorageProfileFilesPermissionLevel' },
            s3Region: { type: 's' },
            sseType: { type: 's' },
            sseKmsKeyId: { type: 's' },
            signatureType: { type: 's' },
            endPoint: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAmazonS3StorageExportJobData'] = KalturaAmazonS3StorageExportJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAmazonS3StorageProfileBaseFilter extends KalturaStorageProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAmazonS3StorageProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAmazonS3StorageProfileBaseFilter'] = KalturaAmazonS3StorageProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAnonymousIPContextField extends KalturaStringField {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAnonymousIPContextField' },
            geoCoderType: { type: 'es', subTypeConstructor: KalturaGeoCoderType, subType: 'KalturaGeoCoderType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAnonymousIPContextField'] = KalturaAnonymousIPContextField;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAssetParamsFilter extends KalturaAssetParamsBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAssetParamsFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAssetParamsFilter'] = KalturaAssetParamsFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAuditTrailFilter extends KalturaAuditTrailBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAuditTrailFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAuditTrailFilter'] = KalturaAuditTrailFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAvnDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAvnDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAvnDistributionProviderBaseFilter'] = KalturaAvnDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBaseEntryCompareAttribute = {
    accessControlId: 'accessControlId',
    createdAt: 'createdAt',
    endDate: 'endDate',
    moderationCount: 'moderationCount',
    moderationStatus: 'moderationStatus',
    partnerId: 'partnerId',
    partnerSortValue: 'partnerSortValue',
    rank: 'rank',
    replacementStatus: 'replacementStatus',
    startDate: 'startDate',
    status: 'status',
    totalRank: 'totalRank',
    type: 'type',
    updatedAt: 'updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBaseEntryCompareAttributeCondition extends KalturaSearchComparableAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBaseEntryCompareAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaBaseEntryCompareAttribute, subType: 'KalturaBaseEntryCompareAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBaseEntryCompareAttributeCondition'] = KalturaBaseEntryCompareAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBaseEntryMatchAttribute = {
    adminTags: 'adminTags',
    categoriesIds: 'categoriesIds',
    creatorId: 'creatorId',
    description: 'description',
    groupId: 'groupId',
    id: 'id',
    _name: 'name',
    referenceId: 'referenceId',
    replacedEntryId: 'replacedEntryId',
    replacingEntryId: 'replacingEntryId',
    searchText: 'searchText',
    tags: 'tags',
    userId: 'userId',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBaseEntryMatchAttributeCondition extends KalturaSearchMatchAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBaseEntryMatchAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaBaseEntryMatchAttribute, subType: 'KalturaBaseEntryMatchAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBaseEntryMatchAttributeCondition'] = KalturaBaseEntryMatchAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBatchJobFilterExt extends KalturaBatchJobFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBatchJobFilterExt' },
            jobTypeAndSubTypeIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBatchJobFilterExt'] = KalturaBatchJobFilterExt;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessNotificationTemplateBaseFilter extends KalturaEventNotificationTemplateFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessNotificationTemplateBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessNotificationTemplateBaseFilter'] = KalturaBusinessProcessNotificationTemplateBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCategoryEntryFilter extends KalturaCategoryEntryBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCategoryEntryFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCategoryEntryFilter'] = KalturaCategoryEntryFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCategoryFilter extends KalturaCategoryBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCategoryFilter' },
            freeText: { type: 's' },
            membersIn: { type: 's' },
            nameOrReferenceIdStartsWith: { type: 's' },
            managerEqual: { type: 's' },
            memberEqual: { type: 's' },
            fullNameStartsWithIn: { type: 's' },
            ancestorIdIn: { type: 's' },
            idOrInheritedParentIdIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCategoryFilter'] = KalturaCategoryFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaComcastMrssDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaComcastMrssDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaComcastMrssDistributionProviderBaseFilter'] = KalturaComcastMrssDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConfigurableDistributionProfileBaseFilter extends KalturaDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConfigurableDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConfigurableDistributionProfileBaseFilter'] = KalturaConfigurableDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConstantXsltSyndicationFeed extends KalturaGenericXsltSyndicationFeed {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConstantXsltSyndicationFeed' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConstantXsltSyndicationFeed'] = KalturaConstantXsltSyndicationFeed;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConversionProfileFilter extends KalturaConversionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConversionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConversionProfileFilter'] = KalturaConversionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConversionProfileAssetParamsFilter extends KalturaConversionProfileAssetParamsBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConversionProfileAssetParamsFilter' },
            conversionProfileIdFilter: { type: 'o', subTypeConstructor: KalturaConversionProfileFilter, subType: 'KalturaConversionProfileFilter' },
            assetParamsIdFilter: { type: 'o', subTypeConstructor: KalturaAssetParamsFilter, subType: 'KalturaAssetParamsFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConversionProfileAssetParamsFilter'] = KalturaConversionProfileAssetParamsFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCoordinatesContextField extends KalturaStringField {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCoordinatesContextField' },
            geoCoderType: { type: 'es', subTypeConstructor: KalturaGeoCoderType, subType: 'KalturaGeoCoderType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCoordinatesContextField'] = KalturaCoordinatesContextField;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCountryContextField extends KalturaStringField {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCountryContextField' },
            geoCoderType: { type: 'es', subTypeConstructor: KalturaGeoCoderType, subType: 'KalturaGeoCoderType' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCountryContextField'] = KalturaCountryContextField;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCrossKalturaDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCrossKalturaDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCrossKalturaDistributionProviderBaseFilter'] = KalturaCrossKalturaDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCuePointFilter extends KalturaCuePointBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCuePointFilter' },
            freeText: { type: 's' },
            userIdEqualCurrent: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            userIdCurrent: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCuePointFilter'] = KalturaCuePointFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDailymotionDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDailymotionDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDailymotionDistributionProviderBaseFilter'] = KalturaDailymotionDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDataEntryCompareAttribute = {
    accessControlId: 'accessControlId',
    createdAt: 'createdAt',
    endDate: 'endDate',
    moderationCount: 'moderationCount',
    moderationStatus: 'moderationStatus',
    partnerId: 'partnerId',
    partnerSortValue: 'partnerSortValue',
    rank: 'rank',
    replacementStatus: 'replacementStatus',
    startDate: 'startDate',
    status: 'status',
    totalRank: 'totalRank',
    type: 'type',
    updatedAt: 'updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDataEntryCompareAttributeCondition extends KalturaSearchComparableAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDataEntryCompareAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaDataEntryCompareAttribute, subType: 'KalturaDataEntryCompareAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDataEntryCompareAttributeCondition'] = KalturaDataEntryCompareAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDataEntryMatchAttribute = {
    adminTags: 'adminTags',
    categoriesIds: 'categoriesIds',
    creatorId: 'creatorId',
    description: 'description',
    groupId: 'groupId',
    id: 'id',
    _name: 'name',
    referenceId: 'referenceId',
    replacedEntryId: 'replacedEntryId',
    replacingEntryId: 'replacingEntryId',
    searchText: 'searchText',
    tags: 'tags',
    userId: 'userId',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDataEntryMatchAttributeCondition extends KalturaSearchMatchAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDataEntryMatchAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaDataEntryMatchAttribute, subType: 'KalturaDataEntryMatchAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDataEntryMatchAttributeCondition'] = KalturaDataEntryMatchAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileAkamaiAppleHttpManifestBaseFilter extends KalturaDeliveryProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileAkamaiAppleHttpManifestBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileAkamaiAppleHttpManifestBaseFilter'] = KalturaDeliveryProfileAkamaiAppleHttpManifestBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileAkamaiHdsBaseFilter extends KalturaDeliveryProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileAkamaiHdsBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileAkamaiHdsBaseFilter'] = KalturaDeliveryProfileAkamaiHdsBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileAkamaiHttpBaseFilter extends KalturaDeliveryProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileAkamaiHttpBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileAkamaiHttpBaseFilter'] = KalturaDeliveryProfileAkamaiHttpBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileGenericAppleHttpBaseFilter extends KalturaDeliveryProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileGenericAppleHttpBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileGenericAppleHttpBaseFilter'] = KalturaDeliveryProfileGenericAppleHttpBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileGenericHdsBaseFilter extends KalturaDeliveryProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileGenericHdsBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileGenericHdsBaseFilter'] = KalturaDeliveryProfileGenericHdsBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileGenericHttpBaseFilter extends KalturaDeliveryProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileGenericHttpBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileGenericHttpBaseFilter'] = KalturaDeliveryProfileGenericHttpBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileGenericSilverLightBaseFilter extends KalturaDeliveryProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileGenericSilverLightBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileGenericSilverLightBaseFilter'] = KalturaDeliveryProfileGenericSilverLightBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileLiveAppleHttpBaseFilter extends KalturaDeliveryProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileLiveAppleHttpBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileLiveAppleHttpBaseFilter'] = KalturaDeliveryProfileLiveAppleHttpBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileRtmpBaseFilter extends KalturaDeliveryProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileRtmpBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileRtmpBaseFilter'] = KalturaDeliveryProfileRtmpBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryServerNodeBaseFilter extends KalturaServerNodeFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryServerNodeBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryServerNodeBaseFilter'] = KalturaDeliveryServerNodeBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionDisableJobData extends KalturaDistributionUpdateJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionDisableJobData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionDisableJobData'] = KalturaDistributionDisableJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDistributionEnableJobData extends KalturaDistributionUpdateJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDistributionEnableJobData' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDistributionEnableJobData'] = KalturaDistributionEnableJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDocumentEntryCompareAttribute = {
    accessControlId: 'accessControlId',
    createdAt: 'createdAt',
    endDate: 'endDate',
    moderationCount: 'moderationCount',
    moderationStatus: 'moderationStatus',
    partnerId: 'partnerId',
    partnerSortValue: 'partnerSortValue',
    rank: 'rank',
    replacementStatus: 'replacementStatus',
    startDate: 'startDate',
    status: 'status',
    totalRank: 'totalRank',
    type: 'type',
    updatedAt: 'updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDocumentEntryCompareAttributeCondition extends KalturaSearchComparableAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDocumentEntryCompareAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaDocumentEntryCompareAttribute, subType: 'KalturaDocumentEntryCompareAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDocumentEntryCompareAttributeCondition'] = KalturaDocumentEntryCompareAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDocumentEntryMatchAttribute = {
    adminTags: 'adminTags',
    categoriesIds: 'categoriesIds',
    creatorId: 'creatorId',
    description: 'description',
    groupId: 'groupId',
    id: 'id',
    _name: 'name',
    referenceId: 'referenceId',
    replacedEntryId: 'replacedEntryId',
    replacingEntryId: 'replacingEntryId',
    searchText: 'searchText',
    tags: 'tags',
    userId: 'userId',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDocumentEntryMatchAttributeCondition extends KalturaSearchMatchAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDocumentEntryMatchAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaDocumentEntryMatchAttribute, subType: 'KalturaDocumentEntryMatchAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDocumentEntryMatchAttributeCondition'] = KalturaDocumentEntryMatchAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDocumentFlavorParamsOutput extends KalturaFlavorParamsOutput {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDocumentFlavorParamsOutput' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDocumentFlavorParamsOutput'] = KalturaDocumentFlavorParamsOutput;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDoubleClickDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDoubleClickDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDoubleClickDistributionProviderBaseFilter'] = KalturaDoubleClickDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDropFolderImportJobData extends KalturaSshImportJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDropFolderImportJobData' },
            dropFolderFileId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDropFolderImportJobData'] = KalturaDropFolderImportJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDropFolderXmlBulkUploadJobData extends KalturaBulkUploadXmlJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDropFolderXmlBulkUploadJobData' },
            dropFolderId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDropFolderXmlBulkUploadJobData'] = KalturaDropFolderXmlBulkUploadJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaESearchCategoryEntryFieldName = {
    ancestorId: 'ancestor_id',
    ancestorName: 'ancestor_name',
    fullIds: 'full_ids',
    id: 'id',
    _name: 'name',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchCategoryEntryItem extends KalturaESearchAbstractEntryItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchCategoryEntryItem' },
            fieldName: { type: 'es', subTypeConstructor: KalturaESearchCategoryEntryFieldName, subType: 'KalturaESearchCategoryEntryFieldName' },
            categoryEntryStatus: { type: 'en', subTypeConstructor: KalturaCategoryEntryStatus, subType: 'KalturaCategoryEntryStatus' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchCategoryEntryItem'] = KalturaESearchCategoryEntryItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaESearchCategoryFieldName = {
    contributionPolicy: 'contribution_policy',
    createdAt: 'created_at',
    depth: 'depth',
    description: 'description',
    directEntriesCount: 'direct_entries_count',
    directSubCategoriesCount: 'direct_sub_categories_count',
    displayInSearch: 'display_in_search',
    entriesCount: 'entries_count',
    fullIds: 'full_ids',
    fullName: 'full_name',
    id: 'id',
    inheritanceType: 'inheritance_type',
    inheritedParentId: 'inherited_parent_id',
    membersCount: 'members_count',
    moderation: 'moderation',
    _name: 'name',
    parentId: 'parent_id',
    pendingEntriesCount: 'pending_entries_count',
    pendingMembersCount: 'pending_members_count',
    privacy: 'privacy',
    privacyContext: 'privacy_context',
    privacyContexts: 'privacy_contexts',
    referenceId: 'reference_id',
    tags: 'tags',
    updatedAt: 'updated_at',
    userId: 'user_id',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchCategoryItem extends KalturaESearchAbstractCategoryItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchCategoryItem' },
            fieldName: { type: 'es', subTypeConstructor: KalturaESearchCategoryFieldName, subType: 'KalturaESearchCategoryFieldName' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchCategoryItem'] = KalturaESearchCategoryItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchCategoryMetadataItem extends KalturaESearchAbstractCategoryItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchCategoryMetadataItem' },
            xpath: { type: 's' },
            metadataProfileId: { type: 'n' },
            metadataFieldId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchCategoryMetadataItem'] = KalturaESearchCategoryMetadataItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaESearchCategoryUserFieldName = {
    userId: 'user_id',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchCategoryUserItem extends KalturaESearchAbstractCategoryItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchCategoryUserItem' },
            fieldName: { type: 'es', subTypeConstructor: KalturaESearchCategoryUserFieldName, subType: 'KalturaESearchCategoryUserFieldName' },
            permissionLevel: { type: 'en', subTypeConstructor: KalturaCategoryUserPermissionLevel, subType: 'KalturaCategoryUserPermissionLevel' },
            permissionName: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchCategoryUserItem'] = KalturaESearchCategoryUserItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaESearchEntryFieldName = {
    accessControlId: 'access_control_id',
    adminTags: 'admin_tags',
    conversionProfileId: 'conversion_profile_id',
    createdAt: 'created_at',
    creatorId: 'creator_kuser_id',
    credit: 'credit',
    description: 'description',
    endDate: 'end_date',
    entitledUserEdit: 'entitled_kusers_edit',
    entitledUserPublish: 'entitled_kusers_publish',
    entryType: 'entry_type',
    externalSourceType: 'external_source_type',
    id: 'id',
    isLive: 'is_live',
    isQuiz: 'is_quiz',
    lengthInMsecs: 'length_in_msecs',
    mediaType: 'media_type',
    moderationStatus: 'moderation_status',
    _name: 'name',
    parentEntryId: 'parent_id',
    pushPublish: 'push_publish',
    recordedEntryId: 'recorded_entry_id',
    redirectEntryId: 'redirect_entry_id',
    referenceId: 'reference_id',
    rootId: 'root_id',
    siteUrl: 'site_url',
    sourceType: 'source_type',
    startDate: 'start_date',
    tags: 'tags',
    templateEntryId: 'template_entry_id',
    updatedAt: 'updated_at',
    userId: 'kuser_id',
    userNames: 'user_names',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchEntryItem extends KalturaESearchAbstractEntryItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchEntryItem' },
            fieldName: { type: 'es', subTypeConstructor: KalturaESearchEntryFieldName, subType: 'KalturaESearchEntryFieldName' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchEntryItem'] = KalturaESearchEntryItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchUnifiedItem extends KalturaESearchAbstractEntryItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchUnifiedItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchUnifiedItem'] = KalturaESearchUnifiedItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaESearchUserFieldName = {
    createdAt: 'created_at',
    email: 'email',
    firstName: 'first_name',
    groupIds: 'group_ids',
    lastName: 'last_name',
    permissionNames: 'permission_names',
    roleIds: 'role_ids',
    screenName: 'screen_name',
    tags: 'tags',
    type: 'user_type',
    updatedAt: 'updated_at',
    userId: 'user_id',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchUserItem extends KalturaESearchAbstractUserItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchUserItem' },
            fieldName: { type: 'es', subTypeConstructor: KalturaESearchUserFieldName, subType: 'KalturaESearchUserFieldName' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchUserItem'] = KalturaESearchUserItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchUserMetadataItem extends KalturaESearchAbstractUserItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchUserMetadataItem' },
            xpath: { type: 's' },
            metadataProfileId: { type: 'n' },
            metadataFieldId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchUserMetadataItem'] = KalturaESearchUserMetadataItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEmailNotificationTemplateBaseFilter extends KalturaEventNotificationTemplateFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEmailNotificationTemplateBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEmailNotificationTemplateBaseFilter'] = KalturaEmailNotificationTemplateBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryDistributionFilter extends KalturaEntryDistributionBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryDistributionFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryDistributionFilter'] = KalturaEntryDistributionFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEvalBooleanField extends KalturaBooleanField {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEvalBooleanField' },
            code: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEvalBooleanField'] = KalturaEvalBooleanField;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEvalStringField extends KalturaStringField {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEvalStringField' },
            code: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEvalStringField'] = KalturaEvalStringField;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaExternalMediaEntryCompareAttribute = {
    accessControlId: 'accessControlId',
    createdAt: 'createdAt',
    endDate: 'endDate',
    lastPlayedAt: 'lastPlayedAt',
    mediaDate: 'mediaDate',
    mediaType: 'mediaType',
    moderationCount: 'moderationCount',
    moderationStatus: 'moderationStatus',
    msDuration: 'msDuration',
    partnerId: 'partnerId',
    partnerSortValue: 'partnerSortValue',
    plays: 'plays',
    rank: 'rank',
    replacementStatus: 'replacementStatus',
    startDate: 'startDate',
    status: 'status',
    totalRank: 'totalRank',
    type: 'type',
    updatedAt: 'updatedAt',
    views: 'views',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaExternalMediaEntryCompareAttributeCondition extends KalturaSearchComparableAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaExternalMediaEntryCompareAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaExternalMediaEntryCompareAttribute, subType: 'KalturaExternalMediaEntryCompareAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaExternalMediaEntryCompareAttributeCondition'] = KalturaExternalMediaEntryCompareAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaExternalMediaEntryMatchAttribute = {
    adminTags: 'adminTags',
    categoriesIds: 'categoriesIds',
    creatorId: 'creatorId',
    description: 'description',
    durationType: 'durationType',
    flavorParamsIds: 'flavorParamsIds',
    groupId: 'groupId',
    id: 'id',
    _name: 'name',
    referenceId: 'referenceId',
    replacedEntryId: 'replacedEntryId',
    replacingEntryId: 'replacingEntryId',
    searchText: 'searchText',
    tags: 'tags',
    userId: 'userId',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaExternalMediaEntryMatchAttributeCondition extends KalturaSearchMatchAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaExternalMediaEntryMatchAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaExternalMediaEntryMatchAttribute, subType: 'KalturaExternalMediaEntryMatchAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaExternalMediaEntryMatchAttributeCondition'] = KalturaExternalMediaEntryMatchAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFacebookDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFacebookDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFacebookDistributionProviderBaseFilter'] = KalturaFacebookDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFileAssetFilter extends KalturaFileAssetBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFileAssetFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFileAssetFilter'] = KalturaFileAssetFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFreewheelDistributionProfileBaseFilter extends KalturaDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFreewheelDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFreewheelDistributionProfileBaseFilter'] = KalturaFreewheelDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFreewheelDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFreewheelDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFreewheelDistributionProviderBaseFilter'] = KalturaFreewheelDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFreewheelGenericDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFreewheelGenericDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFreewheelGenericDistributionProviderBaseFilter'] = KalturaFreewheelGenericDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFtpDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFtpDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFtpDistributionProviderBaseFilter'] = KalturaFtpDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericDataCenterContentResource extends KalturaDataCenterContentResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericDataCenterContentResource' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericDataCenterContentResource'] = KalturaGenericDataCenterContentResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericDistributionProfileBaseFilter extends KalturaDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericDistributionProfileBaseFilter'] = KalturaGenericDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericDistributionProviderBaseFilter' },
            idEqual: { type: 'n' },
            idIn: { type: 's' },
            createdAtGreaterThanOrEqual: { type: 'd' },
            createdAtLessThanOrEqual: { type: 'd' },
            updatedAtGreaterThanOrEqual: { type: 'd' },
            updatedAtLessThanOrEqual: { type: 'd' },
            partnerIdEqual: { type: 'n' },
            partnerIdIn: { type: 's' },
            isDefaultEqual: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            isDefaultIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaGenericDistributionProviderStatus, subType: 'KalturaGenericDistributionProviderStatus' },
            statusIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericDistributionProviderBaseFilter'] = KalturaGenericDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericSyndicationFeedBaseFilter extends KalturaBaseSyndicationFeedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericSyndicationFeedBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericSyndicationFeedBaseFilter'] = KalturaGenericSyndicationFeedBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGoogleVideoSyndicationFeedBaseFilter extends KalturaBaseSyndicationFeedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGoogleVideoSyndicationFeedBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGoogleVideoSyndicationFeedBaseFilter'] = KalturaGoogleVideoSyndicationFeedBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGroupUserFilter extends KalturaGroupUserBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGroupUserFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGroupUserFilter'] = KalturaGroupUserFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaHttpNotificationTemplateBaseFilter extends KalturaEventNotificationTemplateFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaHttpNotificationTemplateBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaHttpNotificationTemplateBaseFilter'] = KalturaHttpNotificationTemplateBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaHuluDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaHuluDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaHuluDistributionProviderBaseFilter'] = KalturaHuluDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaITunesSyndicationFeedBaseFilter extends KalturaBaseSyndicationFeedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaITunesSyndicationFeedBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaITunesSyndicationFeedBaseFilter'] = KalturaITunesSyndicationFeedBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIdeticDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIdeticDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIdeticDistributionProviderBaseFilter'] = KalturaIdeticDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaImageFlavorParamsOutput extends KalturaFlavorParamsOutput {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaImageFlavorParamsOutput' },
            densityWidth: { type: 'n' },
            densityHeight: { type: 'n' },
            sizeWidth: { type: 'n' },
            sizeHeight: { type: 'n' },
            depth: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaImageFlavorParamsOutput'] = KalturaImageFlavorParamsOutput;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIpAddressContextField extends KalturaStringField {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIpAddressContextField' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIpAddressContextField'] = KalturaIpAddressContextField;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaKontikiStorageDeleteJobData extends KalturaStorageDeleteJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaKontikiStorageDeleteJobData' },
            contentMoid: { type: 's' },
            serviceToken: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaKontikiStorageDeleteJobData'] = KalturaKontikiStorageDeleteJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaKontikiStorageExportJobData extends KalturaStorageExportJobData {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaKontikiStorageExportJobData' },
            flavorAssetId: { type: 's' },
            contentMoid: { type: 's' },
            serviceToken: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaKontikiStorageExportJobData'] = KalturaKontikiStorageExportJobData;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaKontikiStorageProfileBaseFilter extends KalturaStorageProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaKontikiStorageProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaKontikiStorageProfileBaseFilter'] = KalturaKontikiStorageProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLikeFilter extends KalturaLikeBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLikeFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLikeFilter'] = KalturaLikeFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveChannelCompareAttribute = {
    accessControlId: 'accessControlId',
    createdAt: 'createdAt',
    endDate: 'endDate',
    lastPlayedAt: 'lastPlayedAt',
    mediaDate: 'mediaDate',
    mediaType: 'mediaType',
    moderationCount: 'moderationCount',
    moderationStatus: 'moderationStatus',
    msDuration: 'msDuration',
    partnerId: 'partnerId',
    partnerSortValue: 'partnerSortValue',
    plays: 'plays',
    rank: 'rank',
    replacementStatus: 'replacementStatus',
    startDate: 'startDate',
    status: 'status',
    totalRank: 'totalRank',
    type: 'type',
    updatedAt: 'updatedAt',
    views: 'views',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveChannelCompareAttributeCondition extends KalturaSearchComparableAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveChannelCompareAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaLiveChannelCompareAttribute, subType: 'KalturaLiveChannelCompareAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveChannelCompareAttributeCondition'] = KalturaLiveChannelCompareAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveChannelMatchAttribute = {
    adminTags: 'adminTags',
    categoriesIds: 'categoriesIds',
    creatorId: 'creatorId',
    description: 'description',
    durationType: 'durationType',
    flavorParamsIds: 'flavorParamsIds',
    groupId: 'groupId',
    id: 'id',
    _name: 'name',
    referenceId: 'referenceId',
    replacedEntryId: 'replacedEntryId',
    replacingEntryId: 'replacingEntryId',
    searchText: 'searchText',
    tags: 'tags',
    userId: 'userId',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveChannelMatchAttributeCondition extends KalturaSearchMatchAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveChannelMatchAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaLiveChannelMatchAttribute, subType: 'KalturaLiveChannelMatchAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveChannelMatchAttributeCondition'] = KalturaLiveChannelMatchAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveChannelSegmentFilter extends KalturaLiveChannelSegmentBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveChannelSegmentFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveChannelSegmentFilter'] = KalturaLiveChannelSegmentFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveEntryCompareAttribute = {
    accessControlId: 'accessControlId',
    createdAt: 'createdAt',
    endDate: 'endDate',
    lastPlayedAt: 'lastPlayedAt',
    mediaDate: 'mediaDate',
    mediaType: 'mediaType',
    moderationCount: 'moderationCount',
    moderationStatus: 'moderationStatus',
    msDuration: 'msDuration',
    partnerId: 'partnerId',
    partnerSortValue: 'partnerSortValue',
    plays: 'plays',
    rank: 'rank',
    replacementStatus: 'replacementStatus',
    startDate: 'startDate',
    status: 'status',
    totalRank: 'totalRank',
    type: 'type',
    updatedAt: 'updatedAt',
    views: 'views',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveEntryCompareAttributeCondition extends KalturaSearchComparableAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveEntryCompareAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaLiveEntryCompareAttribute, subType: 'KalturaLiveEntryCompareAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveEntryCompareAttributeCondition'] = KalturaLiveEntryCompareAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveEntryMatchAttribute = {
    adminTags: 'adminTags',
    categoriesIds: 'categoriesIds',
    creatorId: 'creatorId',
    description: 'description',
    durationType: 'durationType',
    flavorParamsIds: 'flavorParamsIds',
    groupId: 'groupId',
    id: 'id',
    _name: 'name',
    referenceId: 'referenceId',
    replacedEntryId: 'replacedEntryId',
    replacingEntryId: 'replacingEntryId',
    searchText: 'searchText',
    tags: 'tags',
    userId: 'userId',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveEntryMatchAttributeCondition extends KalturaSearchMatchAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveEntryMatchAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaLiveEntryMatchAttribute, subType: 'KalturaLiveEntryMatchAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveEntryMatchAttributeCondition'] = KalturaLiveEntryMatchAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveEntryServerNodeBaseFilter extends KalturaEntryServerNodeFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveEntryServerNodeBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveEntryServerNodeBaseFilter'] = KalturaLiveEntryServerNodeBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveStreamAdminEntryCompareAttribute = {
    accessControlId: 'accessControlId',
    createdAt: 'createdAt',
    endDate: 'endDate',
    lastPlayedAt: 'lastPlayedAt',
    mediaDate: 'mediaDate',
    mediaType: 'mediaType',
    moderationCount: 'moderationCount',
    moderationStatus: 'moderationStatus',
    msDuration: 'msDuration',
    partnerId: 'partnerId',
    partnerSortValue: 'partnerSortValue',
    plays: 'plays',
    rank: 'rank',
    replacementStatus: 'replacementStatus',
    startDate: 'startDate',
    status: 'status',
    totalRank: 'totalRank',
    type: 'type',
    updatedAt: 'updatedAt',
    views: 'views',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamAdminEntryCompareAttributeCondition extends KalturaSearchComparableAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamAdminEntryCompareAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaLiveStreamAdminEntryCompareAttribute, subType: 'KalturaLiveStreamAdminEntryCompareAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamAdminEntryCompareAttributeCondition'] = KalturaLiveStreamAdminEntryCompareAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveStreamAdminEntryMatchAttribute = {
    adminTags: 'adminTags',
    categoriesIds: 'categoriesIds',
    creatorId: 'creatorId',
    description: 'description',
    durationType: 'durationType',
    flavorParamsIds: 'flavorParamsIds',
    groupId: 'groupId',
    id: 'id',
    _name: 'name',
    referenceId: 'referenceId',
    replacedEntryId: 'replacedEntryId',
    replacingEntryId: 'replacingEntryId',
    searchText: 'searchText',
    tags: 'tags',
    userId: 'userId',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamAdminEntryMatchAttributeCondition extends KalturaSearchMatchAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamAdminEntryMatchAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaLiveStreamAdminEntryMatchAttribute, subType: 'KalturaLiveStreamAdminEntryMatchAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamAdminEntryMatchAttributeCondition'] = KalturaLiveStreamAdminEntryMatchAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveStreamEntryCompareAttribute = {
    accessControlId: 'accessControlId',
    createdAt: 'createdAt',
    endDate: 'endDate',
    lastPlayedAt: 'lastPlayedAt',
    mediaDate: 'mediaDate',
    mediaType: 'mediaType',
    moderationCount: 'moderationCount',
    moderationStatus: 'moderationStatus',
    msDuration: 'msDuration',
    partnerId: 'partnerId',
    partnerSortValue: 'partnerSortValue',
    plays: 'plays',
    rank: 'rank',
    replacementStatus: 'replacementStatus',
    startDate: 'startDate',
    status: 'status',
    totalRank: 'totalRank',
    type: 'type',
    updatedAt: 'updatedAt',
    views: 'views',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamEntryCompareAttributeCondition extends KalturaSearchComparableAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamEntryCompareAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaLiveStreamEntryCompareAttribute, subType: 'KalturaLiveStreamEntryCompareAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamEntryCompareAttributeCondition'] = KalturaLiveStreamEntryCompareAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveStreamEntryMatchAttribute = {
    adminTags: 'adminTags',
    categoriesIds: 'categoriesIds',
    creatorId: 'creatorId',
    description: 'description',
    durationType: 'durationType',
    flavorParamsIds: 'flavorParamsIds',
    groupId: 'groupId',
    id: 'id',
    _name: 'name',
    referenceId: 'referenceId',
    replacedEntryId: 'replacedEntryId',
    replacingEntryId: 'replacingEntryId',
    searchText: 'searchText',
    tags: 'tags',
    userId: 'userId',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamEntryMatchAttributeCondition extends KalturaSearchMatchAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamEntryMatchAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaLiveStreamEntryMatchAttribute, subType: 'KalturaLiveStreamEntryMatchAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamEntryMatchAttributeCondition'] = KalturaLiveStreamEntryMatchAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaMediaEntryCompareAttribute = {
    accessControlId: 'accessControlId',
    createdAt: 'createdAt',
    endDate: 'endDate',
    lastPlayedAt: 'lastPlayedAt',
    mediaDate: 'mediaDate',
    mediaType: 'mediaType',
    moderationCount: 'moderationCount',
    moderationStatus: 'moderationStatus',
    msDuration: 'msDuration',
    partnerId: 'partnerId',
    partnerSortValue: 'partnerSortValue',
    plays: 'plays',
    rank: 'rank',
    replacementStatus: 'replacementStatus',
    startDate: 'startDate',
    status: 'status',
    totalRank: 'totalRank',
    type: 'type',
    updatedAt: 'updatedAt',
    views: 'views',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaEntryCompareAttributeCondition extends KalturaSearchComparableAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaEntryCompareAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaMediaEntryCompareAttribute, subType: 'KalturaMediaEntryCompareAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaEntryCompareAttributeCondition'] = KalturaMediaEntryCompareAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaMediaEntryMatchAttribute = {
    adminTags: 'adminTags',
    categoriesIds: 'categoriesIds',
    creatorId: 'creatorId',
    description: 'description',
    durationType: 'durationType',
    flavorParamsIds: 'flavorParamsIds',
    groupId: 'groupId',
    id: 'id',
    _name: 'name',
    referenceId: 'referenceId',
    replacedEntryId: 'replacedEntryId',
    replacingEntryId: 'replacingEntryId',
    searchText: 'searchText',
    tags: 'tags',
    userId: 'userId',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaEntryMatchAttributeCondition extends KalturaSearchMatchAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaEntryMatchAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaMediaEntryMatchAttribute, subType: 'KalturaMediaEntryMatchAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaEntryMatchAttributeCondition'] = KalturaMediaEntryMatchAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaFlavorParamsOutput extends KalturaFlavorParamsOutput {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaFlavorParamsOutput' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaFlavorParamsOutput'] = KalturaMediaFlavorParamsOutput;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetadataField extends KalturaStringField {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetadataField' },
            xPath: { type: 's' },
            profileId: { type: 'n' },
            profileSystemName: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetadataField'] = KalturaMetadataField;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetadataFilter extends KalturaMetadataBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetadataFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetadataFilter'] = KalturaMetadataFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetroPcsDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetroPcsDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetroPcsDistributionProviderBaseFilter'] = KalturaMetroPcsDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaMixEntryCompareAttribute = {
    accessControlId: 'accessControlId',
    createdAt: 'createdAt',
    endDate: 'endDate',
    lastPlayedAt: 'lastPlayedAt',
    moderationCount: 'moderationCount',
    moderationStatus: 'moderationStatus',
    msDuration: 'msDuration',
    partnerId: 'partnerId',
    partnerSortValue: 'partnerSortValue',
    plays: 'plays',
    rank: 'rank',
    replacementStatus: 'replacementStatus',
    startDate: 'startDate',
    status: 'status',
    totalRank: 'totalRank',
    type: 'type',
    updatedAt: 'updatedAt',
    views: 'views',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMixEntryCompareAttributeCondition extends KalturaSearchComparableAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMixEntryCompareAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaMixEntryCompareAttribute, subType: 'KalturaMixEntryCompareAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMixEntryCompareAttributeCondition'] = KalturaMixEntryCompareAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaMixEntryMatchAttribute = {
    adminTags: 'adminTags',
    categoriesIds: 'categoriesIds',
    creatorId: 'creatorId',
    description: 'description',
    durationType: 'durationType',
    groupId: 'groupId',
    id: 'id',
    _name: 'name',
    referenceId: 'referenceId',
    replacedEntryId: 'replacedEntryId',
    replacingEntryId: 'replacingEntryId',
    searchText: 'searchText',
    tags: 'tags',
    userId: 'userId',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMixEntryMatchAttributeCondition extends KalturaSearchMatchAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMixEntryMatchAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaMixEntryMatchAttribute, subType: 'KalturaMixEntryMatchAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMixEntryMatchAttributeCondition'] = KalturaMixEntryMatchAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMsnDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMsnDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMsnDistributionProviderBaseFilter'] = KalturaMsnDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaObjectIdField extends KalturaStringField {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaObjectIdField' }
        });
        return result;
    }
}
typesMappingStorage['KalturaObjectIdField'] = KalturaObjectIdField;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPdfFlavorParamsOutput extends KalturaFlavorParamsOutput {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPdfFlavorParamsOutput' },
            readonly: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPdfFlavorParamsOutput'] = KalturaPdfFlavorParamsOutput;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPermissionFilter extends KalturaPermissionBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPermissionFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPermissionFilter'] = KalturaPermissionFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPermissionItemFilter extends KalturaPermissionItemBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPermissionItemFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPermissionItemFilter'] = KalturaPermissionItemFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayReadyPolicyBaseFilter extends KalturaDrmPolicyFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayReadyPolicyBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayReadyPolicyBaseFilter'] = KalturaPlayReadyPolicyBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayReadyProfileBaseFilter extends KalturaDrmProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayReadyProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayReadyProfileBaseFilter'] = KalturaPlayReadyProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPlayableEntryCompareAttribute = {
    accessControlId: 'accessControlId',
    createdAt: 'createdAt',
    endDate: 'endDate',
    lastPlayedAt: 'lastPlayedAt',
    moderationCount: 'moderationCount',
    moderationStatus: 'moderationStatus',
    msDuration: 'msDuration',
    partnerId: 'partnerId',
    partnerSortValue: 'partnerSortValue',
    plays: 'plays',
    rank: 'rank',
    replacementStatus: 'replacementStatus',
    startDate: 'startDate',
    status: 'status',
    totalRank: 'totalRank',
    type: 'type',
    updatedAt: 'updatedAt',
    views: 'views',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayableEntryCompareAttributeCondition extends KalturaSearchComparableAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayableEntryCompareAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaPlayableEntryCompareAttribute, subType: 'KalturaPlayableEntryCompareAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayableEntryCompareAttributeCondition'] = KalturaPlayableEntryCompareAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPlayableEntryMatchAttribute = {
    adminTags: 'adminTags',
    categoriesIds: 'categoriesIds',
    creatorId: 'creatorId',
    description: 'description',
    durationType: 'durationType',
    groupId: 'groupId',
    id: 'id',
    _name: 'name',
    referenceId: 'referenceId',
    replacedEntryId: 'replacedEntryId',
    replacingEntryId: 'replacingEntryId',
    searchText: 'searchText',
    tags: 'tags',
    userId: 'userId',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayableEntryMatchAttributeCondition extends KalturaSearchMatchAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayableEntryMatchAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaPlayableEntryMatchAttribute, subType: 'KalturaPlayableEntryMatchAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayableEntryMatchAttributeCondition'] = KalturaPlayableEntryMatchAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPlaylistCompareAttribute = {
    accessControlId: 'accessControlId',
    createdAt: 'createdAt',
    endDate: 'endDate',
    moderationCount: 'moderationCount',
    moderationStatus: 'moderationStatus',
    partnerId: 'partnerId',
    partnerSortValue: 'partnerSortValue',
    rank: 'rank',
    replacementStatus: 'replacementStatus',
    startDate: 'startDate',
    status: 'status',
    totalRank: 'totalRank',
    type: 'type',
    updatedAt: 'updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlaylistCompareAttributeCondition extends KalturaSearchComparableAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlaylistCompareAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaPlaylistCompareAttribute, subType: 'KalturaPlaylistCompareAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlaylistCompareAttributeCondition'] = KalturaPlaylistCompareAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPlaylistMatchAttribute = {
    adminTags: 'adminTags',
    categoriesIds: 'categoriesIds',
    creatorId: 'creatorId',
    description: 'description',
    groupId: 'groupId',
    id: 'id',
    _name: 'name',
    referenceId: 'referenceId',
    replacedEntryId: 'replacedEntryId',
    replacingEntryId: 'replacingEntryId',
    searchText: 'searchText',
    tags: 'tags',
    userId: 'userId',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlaylistMatchAttributeCondition extends KalturaSearchMatchAttributeCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlaylistMatchAttributeCondition' },
            attribute: { type: 'es', subTypeConstructor: KalturaPlaylistMatchAttribute, subType: 'KalturaPlaylistMatchAttribute' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlaylistMatchAttributeCondition'] = KalturaPlaylistMatchAttributeCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPushNotificationTemplateBaseFilter extends KalturaEventNotificationTemplateFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPushNotificationTemplateBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPushNotificationTemplateBaseFilter'] = KalturaPushNotificationTemplateBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaQuickPlayDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaQuickPlayDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaQuickPlayDistributionProviderBaseFilter'] = KalturaQuickPlayDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRemoteDropFolderBaseFilter extends KalturaDropFolderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRemoteDropFolderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaRemoteDropFolderBaseFilter'] = KalturaRemoteDropFolderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduleEventFilter extends KalturaScheduleEventBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduleEventFilter' },
            resourceIdsLike: { type: 's' },
            resourceIdsMultiLikeOr: { type: 's' },
            resourceIdsMultiLikeAnd: { type: 's' },
            parentResourceIdsLike: { type: 's' },
            parentResourceIdsMultiLikeOr: { type: 's' },
            parentResourceIdsMultiLikeAnd: { type: 's' },
            templateEntryCategoriesIdsMultiLikeAnd: { type: 's' },
            templateEntryCategoriesIdsMultiLikeOr: { type: 's' },
            resourceSystemNamesMultiLikeOr: { type: 's' },
            templateEntryCategoriesIdsLike: { type: 's' },
            resourceSystemNamesMultiLikeAnd: { type: 's' },
            resourceSystemNamesLike: { type: 's' },
            resourceIdEqual: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduleEventFilter'] = KalturaScheduleEventFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduleEventResourceFilter extends KalturaScheduleEventResourceBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduleEventResourceFilter' },
            eventIdOrItsParentIdEqual: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduleEventResourceFilter'] = KalturaScheduleEventResourceFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScheduleResourceFilter extends KalturaScheduleResourceBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScheduleResourceFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScheduleResourceFilter'] = KalturaScheduleResourceFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScpDropFolder extends KalturaSshDropFolder {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScpDropFolder' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScpDropFolder'] = KalturaScpDropFolder;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSftpDropFolder extends KalturaSshDropFolder {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSftpDropFolder' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSftpDropFolder'] = KalturaSftpDropFolder;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSshUrlResource extends KalturaUrlResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSshUrlResource' },
            privateKey: { type: 's' },
            publicKey: { type: 's' },
            keyPassphrase: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSshUrlResource'] = KalturaSshUrlResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSwfFlavorParamsOutput extends KalturaFlavorParamsOutput {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSwfFlavorParamsOutput' },
            flashVersion: { type: 'n' },
            poly2Bitmap: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSwfFlavorParamsOutput'] = KalturaSwfFlavorParamsOutput;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSyndicationDistributionProfileBaseFilter extends KalturaDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSyndicationDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSyndicationDistributionProfileBaseFilter'] = KalturaSyndicationDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSyndicationDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSyndicationDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSyndicationDistributionProviderBaseFilter'] = KalturaSyndicationDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSystemPartnerFilter extends KalturaPartnerFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSystemPartnerFilter' },
            partnerParentIdEqual: { type: 'n' },
            partnerParentIdIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSystemPartnerFilter'] = KalturaSystemPartnerFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTimeContextField extends KalturaIntegerField {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTimeContextField' },
            offset: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaTimeContextField'] = KalturaTimeContextField;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTubeMogulSyndicationFeedBaseFilter extends KalturaBaseSyndicationFeedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTubeMogulSyndicationFeedBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaTubeMogulSyndicationFeedBaseFilter'] = KalturaTubeMogulSyndicationFeedBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUiConfAdminBaseFilter extends KalturaUiConfFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUiConfAdminBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUiConfAdminBaseFilter'] = KalturaUiConfAdminBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUnicornDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUnicornDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUnicornDistributionProviderBaseFilter'] = KalturaUnicornDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserAgentCondition extends KalturaRegexCondition {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserAgentCondition' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserAgentCondition'] = KalturaUserAgentCondition;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserAgentContextField extends KalturaStringField {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserAgentContextField' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserAgentContextField'] = KalturaUserAgentContextField;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserEmailContextField extends KalturaStringField {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserEmailContextField' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserEmailContextField'] = KalturaUserEmailContextField;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserEntryFilter extends KalturaUserEntryBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserEntryFilter' },
            userIdEqualCurrent: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            isAnonymous: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            privacyContextEqual: { type: 's' },
            privacyContextIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserEntryFilter'] = KalturaUserEntryFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserLoginDataFilter extends KalturaUserLoginDataBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserLoginDataFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserLoginDataFilter'] = KalturaUserLoginDataFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUserRoleFilter extends KalturaUserRoleBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUserRoleFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUserRoleFilter'] = KalturaUserRoleFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWebcamTokenResource extends KalturaDataCenterContentResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWebcamTokenResource' },
            token: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWebcamTokenResource'] = KalturaWebcamTokenResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWebexDropFolderBaseFilter extends KalturaDropFolderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWebexDropFolderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWebexDropFolderBaseFilter'] = KalturaWebexDropFolderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWebexDropFolderFileBaseFilter extends KalturaDropFolderFileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWebexDropFolderFileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWebexDropFolderFileBaseFilter'] = KalturaWebexDropFolderFileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWidevineFlavorParamsOutput extends KalturaFlavorParamsOutput {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWidevineFlavorParamsOutput' },
            widevineDistributionStartDate: { type: 'n' },
            widevineDistributionEndDate: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWidevineFlavorParamsOutput'] = KalturaWidevineFlavorParamsOutput;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWidevineProfileBaseFilter extends KalturaDrmProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWidevineProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWidevineProfileBaseFilter'] = KalturaWidevineProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWowzaMediaServerNode extends KalturaMediaServerNode {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWowzaMediaServerNode' },
            appPrefix: { type: 's' },
            transcoder: { type: 's' },
            GPUID: { type: 'n' },
            liveServicePort: { type: 'n' },
            liveServiceProtocol: { type: 's' },
            liveServiceInternalDomain: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWowzaMediaServerNode'] = KalturaWowzaMediaServerNode;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYahooDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYahooDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYahooDistributionProviderBaseFilter'] = KalturaYahooDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYahooSyndicationFeedBaseFilter extends KalturaBaseSyndicationFeedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYahooSyndicationFeedBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYahooSyndicationFeedBaseFilter'] = KalturaYahooSyndicationFeedBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYouTubeDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYouTubeDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYouTubeDistributionProviderBaseFilter'] = KalturaYouTubeDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYoutubeApiDistributionProviderBaseFilter extends KalturaDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYoutubeApiDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYoutubeApiDistributionProviderBaseFilter'] = KalturaYoutubeApiDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaActivitiBusinessProcessServerFilter extends KalturaActivitiBusinessProcessServerBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaActivitiBusinessProcessServerFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaActivitiBusinessProcessServerFilter'] = KalturaActivitiBusinessProcessServerFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAdCuePointBaseFilter extends KalturaCuePointFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAdCuePointBaseFilter' },
            protocolTypeEqual: { type: 'es', subTypeConstructor: KalturaAdProtocolType, subType: 'KalturaAdProtocolType' },
            protocolTypeIn: { type: 's' },
            titleLike: { type: 's' },
            titleMultiLikeOr: { type: 's' },
            titleMultiLikeAnd: { type: 's' },
            endTimeGreaterThanOrEqual: { type: 'n' },
            endTimeLessThanOrEqual: { type: 'n' },
            durationGreaterThanOrEqual: { type: 'n' },
            durationLessThanOrEqual: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAdCuePointBaseFilter'] = KalturaAdCuePointBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAdminUserBaseFilter extends KalturaUserFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAdminUserBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAdminUserBaseFilter'] = KalturaAdminUserBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAmazonS3StorageProfileFilter extends KalturaAmazonS3StorageProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAmazonS3StorageProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAmazonS3StorageProfileFilter'] = KalturaAmazonS3StorageProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAnnotationBaseFilter extends KalturaCuePointFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAnnotationBaseFilter' },
            parentIdEqual: { type: 's' },
            parentIdIn: { type: 's' },
            textLike: { type: 's' },
            textMultiLikeOr: { type: 's' },
            textMultiLikeAnd: { type: 's' },
            endTimeGreaterThanOrEqual: { type: 'n' },
            endTimeLessThanOrEqual: { type: 'n' },
            durationGreaterThanOrEqual: { type: 'n' },
            durationLessThanOrEqual: { type: 'n' },
            isPublicEqual: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAnnotationBaseFilter'] = KalturaAnnotationBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAnswerCuePointBaseFilter extends KalturaCuePointFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAnswerCuePointBaseFilter' },
            parentIdEqual: { type: 's' },
            parentIdIn: { type: 's' },
            quizUserEntryIdEqual: { type: 's' },
            quizUserEntryIdIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAnswerCuePointBaseFilter'] = KalturaAnswerCuePointBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaApiActionPermissionItemBaseFilter extends KalturaPermissionItemFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaApiActionPermissionItemBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaApiActionPermissionItemBaseFilter'] = KalturaApiActionPermissionItemBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaApiParameterPermissionItemBaseFilter extends KalturaPermissionItemFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaApiParameterPermissionItemBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaApiParameterPermissionItemBaseFilter'] = KalturaApiParameterPermissionItemBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAssetParamsOutputBaseFilter extends KalturaAssetParamsFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAssetParamsOutputBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAssetParamsOutputBaseFilter'] = KalturaAssetParamsOutputBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAttachmentAssetBaseFilter extends KalturaAssetFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAttachmentAssetBaseFilter' },
            formatEqual: { type: 'es', subTypeConstructor: KalturaAttachmentType, subType: 'KalturaAttachmentType' },
            formatIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaAttachmentAssetStatus, subType: 'KalturaAttachmentAssetStatus' },
            statusIn: { type: 's' },
            statusNotIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAttachmentAssetBaseFilter'] = KalturaAttachmentAssetBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAvnDistributionProviderFilter extends KalturaAvnDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAvnDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAvnDistributionProviderFilter'] = KalturaAvnDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessNotificationTemplateFilter extends KalturaBusinessProcessNotificationTemplateBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessNotificationTemplateFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessNotificationTemplateFilter'] = KalturaBusinessProcessNotificationTemplateFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCameraScheduleResourceBaseFilter extends KalturaScheduleResourceFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCameraScheduleResourceBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCameraScheduleResourceBaseFilter'] = KalturaCameraScheduleResourceBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCaptionAssetBaseFilter extends KalturaAssetFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCaptionAssetBaseFilter' },
            captionParamsIdEqual: { type: 'n' },
            captionParamsIdIn: { type: 's' },
            formatEqual: { type: 'es', subTypeConstructor: KalturaCaptionType, subType: 'KalturaCaptionType' },
            formatIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaCaptionAssetStatus, subType: 'KalturaCaptionAssetStatus' },
            statusIn: { type: 's' },
            statusNotIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCaptionAssetBaseFilter'] = KalturaCaptionAssetBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCaptionParamsBaseFilter extends KalturaAssetParamsFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCaptionParamsBaseFilter' },
            formatEqual: { type: 'es', subTypeConstructor: KalturaCaptionType, subType: 'KalturaCaptionType' },
            formatIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCaptionParamsBaseFilter'] = KalturaCaptionParamsBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCodeCuePointBaseFilter extends KalturaCuePointFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCodeCuePointBaseFilter' },
            codeLike: { type: 's' },
            codeMultiLikeOr: { type: 's' },
            codeMultiLikeAnd: { type: 's' },
            codeEqual: { type: 's' },
            codeIn: { type: 's' },
            descriptionLike: { type: 's' },
            descriptionMultiLikeOr: { type: 's' },
            descriptionMultiLikeAnd: { type: 's' },
            endTimeGreaterThanOrEqual: { type: 'n' },
            endTimeLessThanOrEqual: { type: 'n' },
            durationGreaterThanOrEqual: { type: 'n' },
            durationLessThanOrEqual: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCodeCuePointBaseFilter'] = KalturaCodeCuePointBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaComcastMrssDistributionProviderFilter extends KalturaComcastMrssDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaComcastMrssDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaComcastMrssDistributionProviderFilter'] = KalturaComcastMrssDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaConfigurableDistributionProfileFilter extends KalturaConfigurableDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaConfigurableDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaConfigurableDistributionProfileFilter'] = KalturaConfigurableDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCrossKalturaDistributionProviderFilter extends KalturaCrossKalturaDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCrossKalturaDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCrossKalturaDistributionProviderFilter'] = KalturaCrossKalturaDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDailymotionDistributionProviderFilter extends KalturaDailymotionDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDailymotionDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDailymotionDistributionProviderFilter'] = KalturaDailymotionDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDataEntryBaseFilter extends KalturaBaseEntryFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDataEntryBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDataEntryBaseFilter'] = KalturaDataEntryBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileAkamaiAppleHttpManifestFilter extends KalturaDeliveryProfileAkamaiAppleHttpManifestBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileAkamaiAppleHttpManifestFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileAkamaiAppleHttpManifestFilter'] = KalturaDeliveryProfileAkamaiAppleHttpManifestFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileAkamaiHdsFilter extends KalturaDeliveryProfileAkamaiHdsBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileAkamaiHdsFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileAkamaiHdsFilter'] = KalturaDeliveryProfileAkamaiHdsFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileAkamaiHttpFilter extends KalturaDeliveryProfileAkamaiHttpBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileAkamaiHttpFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileAkamaiHttpFilter'] = KalturaDeliveryProfileAkamaiHttpFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileGenericAppleHttpFilter extends KalturaDeliveryProfileGenericAppleHttpBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileGenericAppleHttpFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileGenericAppleHttpFilter'] = KalturaDeliveryProfileGenericAppleHttpFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileGenericHdsFilter extends KalturaDeliveryProfileGenericHdsBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileGenericHdsFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileGenericHdsFilter'] = KalturaDeliveryProfileGenericHdsFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileGenericHttpFilter extends KalturaDeliveryProfileGenericHttpBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileGenericHttpFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileGenericHttpFilter'] = KalturaDeliveryProfileGenericHttpFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileGenericSilverLightFilter extends KalturaDeliveryProfileGenericSilverLightBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileGenericSilverLightFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileGenericSilverLightFilter'] = KalturaDeliveryProfileGenericSilverLightFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileLiveAppleHttpFilter extends KalturaDeliveryProfileLiveAppleHttpBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileLiveAppleHttpFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileLiveAppleHttpFilter'] = KalturaDeliveryProfileLiveAppleHttpFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileRtmpFilter extends KalturaDeliveryProfileRtmpBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileRtmpFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileRtmpFilter'] = KalturaDeliveryProfileRtmpFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryServerNodeFilter extends KalturaDeliveryServerNodeBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryServerNodeFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryServerNodeFilter'] = KalturaDeliveryServerNodeFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDocumentEntryBaseFilter extends KalturaBaseEntryFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDocumentEntryBaseFilter' },
            documentTypeEqual: { type: 'en', subTypeConstructor: KalturaDocumentType, subType: 'KalturaDocumentType' },
            documentTypeIn: { type: 's' },
            assetParamsIdsMatchOr: { type: 's' },
            assetParamsIdsMatchAnd: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDocumentEntryBaseFilter'] = KalturaDocumentEntryBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDoubleClickDistributionProviderFilter extends KalturaDoubleClickDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDoubleClickDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDoubleClickDistributionProviderFilter'] = KalturaDoubleClickDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDropFolderFileResource extends KalturaGenericDataCenterContentResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDropFolderFileResource' },
            dropFolderFileId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDropFolderFileResource'] = KalturaDropFolderFileResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchEntryAbstractNestedItem extends KalturaESearchEntryNestedBaseItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchEntryAbstractNestedItem' },
            searchTerm: { type: 's' },
            itemType: { type: 'en', subTypeConstructor: KalturaESearchItemType, subType: 'KalturaESearchItemType' },
            range: { type: 'o', subTypeConstructor: KalturaESearchRange, subType: 'KalturaESearchRange' },
            addHighlight: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchEntryAbstractNestedItem'] = KalturaESearchEntryAbstractNestedItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchNestedOperator extends KalturaESearchEntryNestedBaseItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
        if (typeof this.searchItems === 'undefined')
            this.searchItems = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchNestedOperator' },
            operator: { type: 'en', subTypeConstructor: KalturaESearchOperatorType, subType: 'KalturaESearchOperatorType' },
            searchItems: { type: 'a', subTypeConstructor: KalturaESearchEntryNestedBaseItem, subType: 'KalturaESearchEntryNestedBaseItem' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchNestedOperator'] = KalturaESearchNestedOperator;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEmailNotificationTemplateFilter extends KalturaEmailNotificationTemplateBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEmailNotificationTemplateFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEmailNotificationTemplateFilter'] = KalturaEmailNotificationTemplateFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryScheduleEventBaseFilter extends KalturaScheduleEventFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryScheduleEventBaseFilter' },
            templateEntryIdEqual: { type: 's' },
            entryIdsLike: { type: 's' },
            entryIdsMultiLikeOr: { type: 's' },
            entryIdsMultiLikeAnd: { type: 's' },
            categoryIdsLike: { type: 's' },
            categoryIdsMultiLikeOr: { type: 's' },
            categoryIdsMultiLikeAnd: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryScheduleEventBaseFilter'] = KalturaEntryScheduleEventBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEventCuePointBaseFilter extends KalturaCuePointFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEventCuePointBaseFilter' },
            eventTypeEqual: { type: 'es', subTypeConstructor: KalturaEventType, subType: 'KalturaEventType' },
            eventTypeIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEventCuePointBaseFilter'] = KalturaEventCuePointBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFacebookDistributionProviderFilter extends KalturaFacebookDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFacebookDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFacebookDistributionProviderFilter'] = KalturaFacebookDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFlavorAssetBaseFilter extends KalturaAssetFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFlavorAssetBaseFilter' },
            flavorParamsIdEqual: { type: 'n' },
            flavorParamsIdIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaFlavorAssetStatus, subType: 'KalturaFlavorAssetStatus' },
            statusIn: { type: 's' },
            statusNotIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFlavorAssetBaseFilter'] = KalturaFlavorAssetBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFlavorParamsBaseFilter extends KalturaAssetParamsFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFlavorParamsBaseFilter' },
            formatEqual: { type: 'es', subTypeConstructor: KalturaContainerFormat, subType: 'KalturaContainerFormat' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFlavorParamsBaseFilter'] = KalturaFlavorParamsBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFreewheelDistributionProfileFilter extends KalturaFreewheelDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFreewheelDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFreewheelDistributionProfileFilter'] = KalturaFreewheelDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFreewheelDistributionProviderFilter extends KalturaFreewheelDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFreewheelDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFreewheelDistributionProviderFilter'] = KalturaFreewheelDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFreewheelGenericDistributionProviderFilter extends KalturaFreewheelGenericDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFreewheelGenericDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFreewheelGenericDistributionProviderFilter'] = KalturaFreewheelGenericDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFtpDistributionProviderFilter extends KalturaFtpDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFtpDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFtpDistributionProviderFilter'] = KalturaFtpDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericDistributionProfileFilter extends KalturaGenericDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericDistributionProfileFilter'] = KalturaGenericDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericDistributionProviderFilter extends KalturaGenericDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericDistributionProviderFilter'] = KalturaGenericDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericSyndicationFeedFilter extends KalturaGenericSyndicationFeedBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericSyndicationFeedFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericSyndicationFeedFilter'] = KalturaGenericSyndicationFeedFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGoogleVideoSyndicationFeedFilter extends KalturaGoogleVideoSyndicationFeedBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGoogleVideoSyndicationFeedFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGoogleVideoSyndicationFeedFilter'] = KalturaGoogleVideoSyndicationFeedFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaHttpNotificationTemplateFilter extends KalturaHttpNotificationTemplateBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaHttpNotificationTemplateFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaHttpNotificationTemplateFilter'] = KalturaHttpNotificationTemplateFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaHuluDistributionProviderFilter extends KalturaHuluDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaHuluDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaHuluDistributionProviderFilter'] = KalturaHuluDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaITunesSyndicationFeedFilter extends KalturaITunesSyndicationFeedBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaITunesSyndicationFeedFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaITunesSyndicationFeedFilter'] = KalturaITunesSyndicationFeedFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIdeticDistributionProviderFilter extends KalturaIdeticDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIdeticDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIdeticDistributionProviderFilter'] = KalturaIdeticDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaKontikiStorageProfileFilter extends KalturaKontikiStorageProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaKontikiStorageProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaKontikiStorageProfileFilter'] = KalturaKontikiStorageProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveEntryScheduleResourceBaseFilter extends KalturaScheduleResourceFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveEntryScheduleResourceBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveEntryScheduleResourceBaseFilter'] = KalturaLiveEntryScheduleResourceBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveEntryServerNodeFilter extends KalturaLiveEntryServerNodeBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveEntryServerNodeFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveEntryServerNodeFilter'] = KalturaLiveEntryServerNodeFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLocationScheduleResourceBaseFilter extends KalturaScheduleResourceFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLocationScheduleResourceBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLocationScheduleResourceBaseFilter'] = KalturaLocationScheduleResourceBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetroPcsDistributionProviderFilter extends KalturaMetroPcsDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetroPcsDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetroPcsDistributionProviderFilter'] = KalturaMetroPcsDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMsnDistributionProviderFilter extends KalturaMsnDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMsnDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMsnDistributionProviderFilter'] = KalturaMsnDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaOperaSyndicationFeed extends KalturaConstantXsltSyndicationFeed {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaOperaSyndicationFeed' }
        });
        return result;
    }
}
typesMappingStorage['KalturaOperaSyndicationFeed'] = KalturaOperaSyndicationFeed;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayReadyPolicyFilter extends KalturaPlayReadyPolicyBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayReadyPolicyFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayReadyPolicyFilter'] = KalturaPlayReadyPolicyFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlayReadyProfileFilter extends KalturaPlayReadyProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlayReadyProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlayReadyProfileFilter'] = KalturaPlayReadyProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlaylistBaseFilter extends KalturaBaseEntryFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlaylistBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlaylistBaseFilter'] = KalturaPlaylistBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPushNotificationTemplateFilter extends KalturaPushNotificationTemplateBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPushNotificationTemplateFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPushNotificationTemplateFilter'] = KalturaPushNotificationTemplateFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaQuestionCuePointBaseFilter extends KalturaCuePointFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaQuestionCuePointBaseFilter' },
            questionLike: { type: 's' },
            questionMultiLikeOr: { type: 's' },
            questionMultiLikeAnd: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaQuestionCuePointBaseFilter'] = KalturaQuestionCuePointBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaQuickPlayDistributionProviderFilter extends KalturaQuickPlayDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaQuickPlayDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaQuickPlayDistributionProviderFilter'] = KalturaQuickPlayDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaQuizUserEntryBaseFilter extends KalturaUserEntryFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaQuizUserEntryBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaQuizUserEntryBaseFilter'] = KalturaQuizUserEntryBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRemoteDropFolderFilter extends KalturaRemoteDropFolderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRemoteDropFolderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaRemoteDropFolderFilter'] = KalturaRemoteDropFolderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRokuSyndicationFeed extends KalturaConstantXsltSyndicationFeed {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRokuSyndicationFeed' }
        });
        return result;
    }
}
typesMappingStorage['KalturaRokuSyndicationFeed'] = KalturaRokuSyndicationFeed;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaServerFileResource extends KalturaGenericDataCenterContentResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaServerFileResource' },
            localFilePath: { type: 's' },
            keepOriginalFile: { type: 'b' }
        });
        return result;
    }
}
typesMappingStorage['KalturaServerFileResource'] = KalturaServerFileResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSyndicationDistributionProfileFilter extends KalturaSyndicationDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSyndicationDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSyndicationDistributionProfileFilter'] = KalturaSyndicationDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaThumbAssetBaseFilter extends KalturaAssetFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaThumbAssetBaseFilter' },
            thumbParamsIdEqual: { type: 'n' },
            thumbParamsIdIn: { type: 's' },
            statusEqual: { type: 'en', subTypeConstructor: KalturaThumbAssetStatus, subType: 'KalturaThumbAssetStatus' },
            statusIn: { type: 's' },
            statusNotIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaThumbAssetBaseFilter'] = KalturaThumbAssetBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaThumbCuePointBaseFilter extends KalturaCuePointFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaThumbCuePointBaseFilter' },
            descriptionLike: { type: 's' },
            descriptionMultiLikeOr: { type: 's' },
            descriptionMultiLikeAnd: { type: 's' },
            titleLike: { type: 's' },
            titleMultiLikeOr: { type: 's' },
            titleMultiLikeAnd: { type: 's' },
            subTypeEqual: { type: 'en', subTypeConstructor: KalturaThumbCuePointSubType, subType: 'KalturaThumbCuePointSubType' },
            subTypeIn: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaThumbCuePointBaseFilter'] = KalturaThumbCuePointBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaThumbParamsBaseFilter extends KalturaAssetParamsFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaThumbParamsBaseFilter' },
            formatEqual: { type: 'es', subTypeConstructor: KalturaContainerFormat, subType: 'KalturaContainerFormat' }
        });
        return result;
    }
}
typesMappingStorage['KalturaThumbParamsBaseFilter'] = KalturaThumbParamsBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTubeMogulSyndicationFeedFilter extends KalturaTubeMogulSyndicationFeedBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTubeMogulSyndicationFeedFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaTubeMogulSyndicationFeedFilter'] = KalturaTubeMogulSyndicationFeedFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUiConfAdminFilter extends KalturaUiConfAdminBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUiConfAdminFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUiConfAdminFilter'] = KalturaUiConfAdminFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUnicornDistributionProviderFilter extends KalturaUnicornDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUnicornDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUnicornDistributionProviderFilter'] = KalturaUnicornDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUploadedFileTokenResource extends KalturaGenericDataCenterContentResource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUploadedFileTokenResource' },
            token: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUploadedFileTokenResource'] = KalturaUploadedFileTokenResource;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaViewHistoryUserEntryFilter extends KalturaUserEntryFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaViewHistoryUserEntryFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaViewHistoryUserEntryFilter'] = KalturaViewHistoryUserEntryFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWebexDropFolderFileFilter extends KalturaWebexDropFolderFileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWebexDropFolderFileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWebexDropFolderFileFilter'] = KalturaWebexDropFolderFileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWebexDropFolderFilter extends KalturaWebexDropFolderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWebexDropFolderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWebexDropFolderFilter'] = KalturaWebexDropFolderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWidevineProfileFilter extends KalturaWidevineProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWidevineProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWidevineProfileFilter'] = KalturaWidevineProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYahooDistributionProviderFilter extends KalturaYahooDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYahooDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYahooDistributionProviderFilter'] = KalturaYahooDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYahooSyndicationFeedFilter extends KalturaYahooSyndicationFeedBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYahooSyndicationFeedFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYahooSyndicationFeedFilter'] = KalturaYahooSyndicationFeedFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYouTubeDistributionProviderFilter extends KalturaYouTubeDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYouTubeDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYouTubeDistributionProviderFilter'] = KalturaYouTubeDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYoutubeApiDistributionProviderFilter extends KalturaYoutubeApiDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYoutubeApiDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYoutubeApiDistributionProviderFilter'] = KalturaYoutubeApiDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAdCuePointFilter extends KalturaAdCuePointBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAdCuePointFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAdCuePointFilter'] = KalturaAdCuePointFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAdminUserFilter extends KalturaAdminUserBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAdminUserFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAdminUserFilter'] = KalturaAdminUserFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAnnotationFilter extends KalturaAnnotationBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAnnotationFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAnnotationFilter'] = KalturaAnnotationFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAnswerCuePointFilter extends KalturaAnswerCuePointBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAnswerCuePointFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAnswerCuePointFilter'] = KalturaAnswerCuePointFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaApiActionPermissionItemFilter extends KalturaApiActionPermissionItemBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaApiActionPermissionItemFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaApiActionPermissionItemFilter'] = KalturaApiActionPermissionItemFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaApiParameterPermissionItemFilter extends KalturaApiParameterPermissionItemBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaApiParameterPermissionItemFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaApiParameterPermissionItemFilter'] = KalturaApiParameterPermissionItemFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAssetParamsOutputFilter extends KalturaAssetParamsOutputBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAssetParamsOutputFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAssetParamsOutputFilter'] = KalturaAssetParamsOutputFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAttachmentAssetFilter extends KalturaAttachmentAssetBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAttachmentAssetFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAttachmentAssetFilter'] = KalturaAttachmentAssetFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAvnDistributionProfileBaseFilter extends KalturaConfigurableDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAvnDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAvnDistributionProfileBaseFilter'] = KalturaAvnDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessAbortNotificationTemplateBaseFilter extends KalturaBusinessProcessNotificationTemplateFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessAbortNotificationTemplateBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessAbortNotificationTemplateBaseFilter'] = KalturaBusinessProcessAbortNotificationTemplateBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessSignalNotificationTemplateBaseFilter extends KalturaBusinessProcessNotificationTemplateFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessSignalNotificationTemplateBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessSignalNotificationTemplateBaseFilter'] = KalturaBusinessProcessSignalNotificationTemplateBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessStartNotificationTemplateBaseFilter extends KalturaBusinessProcessNotificationTemplateFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessStartNotificationTemplateBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessStartNotificationTemplateBaseFilter'] = KalturaBusinessProcessStartNotificationTemplateBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCameraScheduleResourceFilter extends KalturaCameraScheduleResourceBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCameraScheduleResourceFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCameraScheduleResourceFilter'] = KalturaCameraScheduleResourceFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCaptionAssetFilter extends KalturaCaptionAssetBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCaptionAssetFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCaptionAssetFilter'] = KalturaCaptionAssetFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCaptionParamsFilter extends KalturaCaptionParamsBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCaptionParamsFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCaptionParamsFilter'] = KalturaCaptionParamsFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCodeCuePointFilter extends KalturaCodeCuePointBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCodeCuePointFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCodeCuePointFilter'] = KalturaCodeCuePointFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaComcastMrssDistributionProfileBaseFilter extends KalturaConfigurableDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaComcastMrssDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaComcastMrssDistributionProfileBaseFilter'] = KalturaComcastMrssDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCrossKalturaDistributionProfileBaseFilter extends KalturaConfigurableDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCrossKalturaDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCrossKalturaDistributionProfileBaseFilter'] = KalturaCrossKalturaDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDailymotionDistributionProfileBaseFilter extends KalturaConfigurableDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDailymotionDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDailymotionDistributionProfileBaseFilter'] = KalturaDailymotionDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDataEntryFilter extends KalturaDataEntryBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDataEntryFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDataEntryFilter'] = KalturaDataEntryFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileGenericRtmpBaseFilter extends KalturaDeliveryProfileRtmpFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileGenericRtmpBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileGenericRtmpBaseFilter'] = KalturaDeliveryProfileGenericRtmpBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDocumentEntryFilter extends KalturaDocumentEntryBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDocumentEntryFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDocumentEntryFilter'] = KalturaDocumentEntryFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDoubleClickDistributionProfileBaseFilter extends KalturaConfigurableDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDoubleClickDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDoubleClickDistributionProfileBaseFilter'] = KalturaDoubleClickDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaESearchCaptionFieldName = {
    content: 'content',
    endTime: 'end_time',
    label: 'label',
    language: 'language',
    startTime: 'start_time',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchCaptionItem extends KalturaESearchEntryAbstractNestedItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchCaptionItem' },
            fieldName: { type: 'es', subTypeConstructor: KalturaESearchCaptionFieldName, subType: 'KalturaESearchCaptionFieldName' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchCaptionItem'] = KalturaESearchCaptionItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaESearchCuePointFieldName = {
    answers: 'answers',
    endTime: 'end_time',
    explanation: 'explanation',
    hint: 'hint',
    id: 'id',
    _name: 'name',
    question: 'question',
    startTime: 'start_time',
    subType: 'sub_type',
    tags: 'tags',
    text: 'text',
    type: 'type',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchCuePointItem extends KalturaESearchEntryAbstractNestedItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchCuePointItem' },
            fieldName: { type: 'es', subTypeConstructor: KalturaESearchCuePointFieldName, subType: 'KalturaESearchCuePointFieldName' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchCuePointItem'] = KalturaESearchCuePointItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaESearchEntryMetadataItem extends KalturaESearchEntryAbstractNestedItem {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaESearchEntryMetadataItem' },
            xpath: { type: 's' },
            metadataProfileId: { type: 'n' },
            metadataFieldId: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaESearchEntryMetadataItem'] = KalturaESearchEntryMetadataItem;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEdgeServerNodeBaseFilter extends KalturaDeliveryServerNodeFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEdgeServerNodeBaseFilter' },
            playbackDomainLike: { type: 's' },
            playbackDomainMultiLikeOr: { type: 's' },
            playbackDomainMultiLikeAnd: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEdgeServerNodeBaseFilter'] = KalturaEdgeServerNodeBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEntryScheduleEventFilter extends KalturaEntryScheduleEventBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEntryScheduleEventFilter' },
            parentCategoryIdsLike: { type: 's' },
            parentCategoryIdsMultiLikeOr: { type: 's' },
            parentCategoryIdsMultiLikeAnd: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEntryScheduleEventFilter'] = KalturaEntryScheduleEventFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEventCuePointFilter extends KalturaEventCuePointBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEventCuePointFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEventCuePointFilter'] = KalturaEventCuePointFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFacebookDistributionProfileBaseFilter extends KalturaConfigurableDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFacebookDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFacebookDistributionProfileBaseFilter'] = KalturaFacebookDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFlavorAssetFilter extends KalturaFlavorAssetBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFlavorAssetFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFlavorAssetFilter'] = KalturaFlavorAssetFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFlavorParamsFilter extends KalturaFlavorParamsBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFlavorParamsFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFlavorParamsFilter'] = KalturaFlavorParamsFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFreewheelGenericDistributionProfileBaseFilter extends KalturaConfigurableDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFreewheelGenericDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFreewheelGenericDistributionProfileBaseFilter'] = KalturaFreewheelGenericDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFtpDistributionProfileBaseFilter extends KalturaConfigurableDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFtpDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFtpDistributionProfileBaseFilter'] = KalturaFtpDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFtpDropFolderBaseFilter extends KalturaRemoteDropFolderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFtpDropFolderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFtpDropFolderBaseFilter'] = KalturaFtpDropFolderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFtpScheduledDistributionProviderBaseFilter extends KalturaFtpDistributionProviderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFtpScheduledDistributionProviderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFtpScheduledDistributionProviderBaseFilter'] = KalturaFtpScheduledDistributionProviderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericXsltSyndicationFeedBaseFilter extends KalturaGenericSyndicationFeedFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericXsltSyndicationFeedBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericXsltSyndicationFeedBaseFilter'] = KalturaGenericXsltSyndicationFeedBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaHuluDistributionProfileBaseFilter extends KalturaConfigurableDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaHuluDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaHuluDistributionProfileBaseFilter'] = KalturaHuluDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIdeticDistributionProfileBaseFilter extends KalturaConfigurableDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIdeticDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIdeticDistributionProfileBaseFilter'] = KalturaIdeticDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveEntryScheduleResourceFilter extends KalturaLiveEntryScheduleResourceBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveEntryScheduleResourceFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveEntryScheduleResourceFilter'] = KalturaLiveEntryScheduleResourceFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamAdminEntry extends KalturaLiveStreamEntry {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamAdminEntry' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamAdminEntry'] = KalturaLiveStreamAdminEntry;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLocationScheduleResourceFilter extends KalturaLocationScheduleResourceBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLocationScheduleResourceFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLocationScheduleResourceFilter'] = KalturaLocationScheduleResourceFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaServerNodeBaseFilter extends KalturaDeliveryServerNodeFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaServerNodeBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaServerNodeBaseFilter'] = KalturaMediaServerNodeBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetroPcsDistributionProfileBaseFilter extends KalturaConfigurableDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetroPcsDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetroPcsDistributionProfileBaseFilter'] = KalturaMetroPcsDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMsnDistributionProfileBaseFilter extends KalturaConfigurableDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMsnDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMsnDistributionProfileBaseFilter'] = KalturaMsnDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPlaylistFilter extends KalturaPlaylistBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPlaylistFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPlaylistFilter'] = KalturaPlaylistFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaQuestionCuePointFilter extends KalturaQuestionCuePointBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaQuestionCuePointFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaQuestionCuePointFilter'] = KalturaQuestionCuePointFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaQuickPlayDistributionProfileBaseFilter extends KalturaConfigurableDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaQuickPlayDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaQuickPlayDistributionProfileBaseFilter'] = KalturaQuickPlayDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaQuizUserEntryFilter extends KalturaQuizUserEntryBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaQuizUserEntryFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaQuizUserEntryFilter'] = KalturaQuizUserEntryFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSshDropFolderBaseFilter extends KalturaRemoteDropFolderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSshDropFolderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSshDropFolderBaseFilter'] = KalturaSshDropFolderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaThumbAssetFilter extends KalturaThumbAssetBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaThumbAssetFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaThumbAssetFilter'] = KalturaThumbAssetFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaThumbCuePointFilter extends KalturaThumbCuePointBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaThumbCuePointFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaThumbCuePointFilter'] = KalturaThumbCuePointFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaThumbParamsFilter extends KalturaThumbParamsBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaThumbParamsFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaThumbParamsFilter'] = KalturaThumbParamsFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUnicornDistributionProfileBaseFilter extends KalturaConfigurableDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUnicornDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUnicornDistributionProfileBaseFilter'] = KalturaUnicornDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYahooDistributionProfileBaseFilter extends KalturaConfigurableDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYahooDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYahooDistributionProfileBaseFilter'] = KalturaYahooDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYouTubeDistributionProfileBaseFilter extends KalturaConfigurableDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYouTubeDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYouTubeDistributionProfileBaseFilter'] = KalturaYouTubeDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYoutubeApiDistributionProfileBaseFilter extends KalturaConfigurableDistributionProfileFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYoutubeApiDistributionProfileBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYoutubeApiDistributionProfileBaseFilter'] = KalturaYoutubeApiDistributionProfileBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaAvnDistributionProfileFilter extends KalturaAvnDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaAvnDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaAvnDistributionProfileFilter'] = KalturaAvnDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessAbortNotificationTemplateFilter extends KalturaBusinessProcessAbortNotificationTemplateBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessAbortNotificationTemplateFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessAbortNotificationTemplateFilter'] = KalturaBusinessProcessAbortNotificationTemplateFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessSignalNotificationTemplateFilter extends KalturaBusinessProcessSignalNotificationTemplateBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessSignalNotificationTemplateFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessSignalNotificationTemplateFilter'] = KalturaBusinessProcessSignalNotificationTemplateFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaBusinessProcessStartNotificationTemplateFilter extends KalturaBusinessProcessStartNotificationTemplateBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaBusinessProcessStartNotificationTemplateFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaBusinessProcessStartNotificationTemplateFilter'] = KalturaBusinessProcessStartNotificationTemplateFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCaptionAssetItemFilter extends KalturaCaptionAssetFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCaptionAssetItemFilter' },
            contentLike: { type: 's' },
            contentMultiLikeOr: { type: 's' },
            contentMultiLikeAnd: { type: 's' },
            partnerDescriptionLike: { type: 's' },
            partnerDescriptionMultiLikeOr: { type: 's' },
            partnerDescriptionMultiLikeAnd: { type: 's' },
            languageEqual: { type: 'es', subTypeConstructor: KalturaLanguage, subType: 'KalturaLanguage' },
            languageIn: { type: 's' },
            labelEqual: { type: 's' },
            labelIn: { type: 's' },
            startTimeGreaterThanOrEqual: { type: 'n' },
            startTimeLessThanOrEqual: { type: 'n' },
            endTimeGreaterThanOrEqual: { type: 'n' },
            endTimeLessThanOrEqual: { type: 'n' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCaptionAssetItemFilter'] = KalturaCaptionAssetItemFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaComcastMrssDistributionProfileFilter extends KalturaComcastMrssDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaComcastMrssDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaComcastMrssDistributionProfileFilter'] = KalturaComcastMrssDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaCrossKalturaDistributionProfileFilter extends KalturaCrossKalturaDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaCrossKalturaDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaCrossKalturaDistributionProfileFilter'] = KalturaCrossKalturaDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDailymotionDistributionProfileFilter extends KalturaDailymotionDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDailymotionDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDailymotionDistributionProfileFilter'] = KalturaDailymotionDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDeliveryProfileGenericRtmpFilter extends KalturaDeliveryProfileGenericRtmpBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDeliveryProfileGenericRtmpFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDeliveryProfileGenericRtmpFilter'] = KalturaDeliveryProfileGenericRtmpFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDocumentFlavorParamsBaseFilter extends KalturaFlavorParamsFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDocumentFlavorParamsBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDocumentFlavorParamsBaseFilter'] = KalturaDocumentFlavorParamsBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDoubleClickDistributionProfileFilter extends KalturaDoubleClickDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDoubleClickDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDoubleClickDistributionProfileFilter'] = KalturaDoubleClickDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaEdgeServerNodeFilter extends KalturaEdgeServerNodeBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaEdgeServerNodeFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaEdgeServerNodeFilter'] = KalturaEdgeServerNodeFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFacebookDistributionProfileFilter extends KalturaFacebookDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFacebookDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFacebookDistributionProfileFilter'] = KalturaFacebookDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFlavorParamsOutputBaseFilter extends KalturaFlavorParamsFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFlavorParamsOutputBaseFilter' },
            flavorParamsIdEqual: { type: 'n' },
            flavorParamsVersionEqual: { type: 's' },
            flavorAssetIdEqual: { type: 's' },
            flavorAssetVersionEqual: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFlavorParamsOutputBaseFilter'] = KalturaFlavorParamsOutputBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFreewheelGenericDistributionProfileFilter extends KalturaFreewheelGenericDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFreewheelGenericDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFreewheelGenericDistributionProfileFilter'] = KalturaFreewheelGenericDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFtpDistributionProfileFilter extends KalturaFtpDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFtpDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFtpDistributionProfileFilter'] = KalturaFtpDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFtpDropFolderFilter extends KalturaFtpDropFolderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFtpDropFolderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFtpDropFolderFilter'] = KalturaFtpDropFolderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFtpScheduledDistributionProviderFilter extends KalturaFtpScheduledDistributionProviderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFtpScheduledDistributionProviderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFtpScheduledDistributionProviderFilter'] = KalturaFtpScheduledDistributionProviderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaGenericXsltSyndicationFeedFilter extends KalturaGenericXsltSyndicationFeedBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaGenericXsltSyndicationFeedFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaGenericXsltSyndicationFeedFilter'] = KalturaGenericXsltSyndicationFeedFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaHuluDistributionProfileFilter extends KalturaHuluDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaHuluDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaHuluDistributionProfileFilter'] = KalturaHuluDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaIdeticDistributionProfileFilter extends KalturaIdeticDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaIdeticDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaIdeticDistributionProfileFilter'] = KalturaIdeticDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaImageFlavorParamsBaseFilter extends KalturaFlavorParamsFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaImageFlavorParamsBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaImageFlavorParamsBaseFilter'] = KalturaImageFlavorParamsBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveAssetBaseFilter extends KalturaFlavorAssetFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveAssetBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveAssetBaseFilter'] = KalturaLiveAssetBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveParamsBaseFilter extends KalturaFlavorParamsFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveParamsBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveParamsBaseFilter'] = KalturaLiveParamsBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamScheduleEventBaseFilter extends KalturaEntryScheduleEventFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamScheduleEventBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamScheduleEventBaseFilter'] = KalturaLiveStreamScheduleEventBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaFlavorParamsBaseFilter extends KalturaFlavorParamsFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaFlavorParamsBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaFlavorParamsBaseFilter'] = KalturaMediaFlavorParamsBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaServerNodeFilter extends KalturaMediaServerNodeBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaServerNodeFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaServerNodeFilter'] = KalturaMediaServerNodeFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMetroPcsDistributionProfileFilter extends KalturaMetroPcsDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMetroPcsDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMetroPcsDistributionProfileFilter'] = KalturaMetroPcsDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMixEntryBaseFilter extends KalturaPlayableEntryFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMixEntryBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMixEntryBaseFilter'] = KalturaMixEntryBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMsnDistributionProfileFilter extends KalturaMsnDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMsnDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMsnDistributionProfileFilter'] = KalturaMsnDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPdfFlavorParamsBaseFilter extends KalturaFlavorParamsFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPdfFlavorParamsBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPdfFlavorParamsBaseFilter'] = KalturaPdfFlavorParamsBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaQuickPlayDistributionProfileFilter extends KalturaQuickPlayDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaQuickPlayDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaQuickPlayDistributionProfileFilter'] = KalturaQuickPlayDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRecordScheduleEventBaseFilter extends KalturaEntryScheduleEventFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRecordScheduleEventBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaRecordScheduleEventBaseFilter'] = KalturaRecordScheduleEventBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSshDropFolderFilter extends KalturaSshDropFolderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSshDropFolderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSshDropFolderFilter'] = KalturaSshDropFolderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSwfFlavorParamsBaseFilter extends KalturaFlavorParamsFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSwfFlavorParamsBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSwfFlavorParamsBaseFilter'] = KalturaSwfFlavorParamsBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaThumbParamsOutputBaseFilter extends KalturaThumbParamsFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaThumbParamsOutputBaseFilter' },
            thumbParamsIdEqual: { type: 'n' },
            thumbParamsVersionEqual: { type: 's' },
            thumbAssetIdEqual: { type: 's' },
            thumbAssetVersionEqual: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaThumbParamsOutputBaseFilter'] = KalturaThumbParamsOutputBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTimedThumbAssetBaseFilter extends KalturaThumbAssetFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTimedThumbAssetBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaTimedThumbAssetBaseFilter'] = KalturaTimedThumbAssetBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTranscriptAssetBaseFilter extends KalturaAttachmentAssetFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTranscriptAssetBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaTranscriptAssetBaseFilter'] = KalturaTranscriptAssetBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaUnicornDistributionProfileFilter extends KalturaUnicornDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaUnicornDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaUnicornDistributionProfileFilter'] = KalturaUnicornDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWidevineFlavorAssetBaseFilter extends KalturaFlavorAssetFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWidevineFlavorAssetBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWidevineFlavorAssetBaseFilter'] = KalturaWidevineFlavorAssetBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWidevineFlavorParamsBaseFilter extends KalturaFlavorParamsFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWidevineFlavorParamsBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWidevineFlavorParamsBaseFilter'] = KalturaWidevineFlavorParamsBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYahooDistributionProfileFilter extends KalturaYahooDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYahooDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYahooDistributionProfileFilter'] = KalturaYahooDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYouTubeDistributionProfileFilter extends KalturaYouTubeDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYouTubeDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYouTubeDistributionProfileFilter'] = KalturaYouTubeDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaYoutubeApiDistributionProfileFilter extends KalturaYoutubeApiDistributionProfileBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaYoutubeApiDistributionProfileFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaYoutubeApiDistributionProfileFilter'] = KalturaYoutubeApiDistributionProfileFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDocumentFlavorParamsFilter extends KalturaDocumentFlavorParamsBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDocumentFlavorParamsFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDocumentFlavorParamsFilter'] = KalturaDocumentFlavorParamsFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaFlavorParamsOutputFilter extends KalturaFlavorParamsOutputBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaFlavorParamsOutputFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaFlavorParamsOutputFilter'] = KalturaFlavorParamsOutputFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaImageFlavorParamsFilter extends KalturaImageFlavorParamsBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaImageFlavorParamsFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaImageFlavorParamsFilter'] = KalturaImageFlavorParamsFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveAssetFilter extends KalturaLiveAssetBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveAssetFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveAssetFilter'] = KalturaLiveAssetFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveParamsFilter extends KalturaLiveParamsBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveParamsFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveParamsFilter'] = KalturaLiveParamsFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamScheduleEventFilter extends KalturaLiveStreamScheduleEventBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamScheduleEventFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamScheduleEventFilter'] = KalturaLiveStreamScheduleEventFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaFlavorParamsFilter extends KalturaMediaFlavorParamsBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaFlavorParamsFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaFlavorParamsFilter'] = KalturaMediaFlavorParamsFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMixEntryFilter extends KalturaMixEntryBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMixEntryFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMixEntryFilter'] = KalturaMixEntryFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPdfFlavorParamsFilter extends KalturaPdfFlavorParamsBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPdfFlavorParamsFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPdfFlavorParamsFilter'] = KalturaPdfFlavorParamsFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaRecordScheduleEventFilter extends KalturaRecordScheduleEventBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaRecordScheduleEventFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaRecordScheduleEventFilter'] = KalturaRecordScheduleEventFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScpDropFolderBaseFilter extends KalturaSshDropFolderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScpDropFolderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScpDropFolderBaseFilter'] = KalturaScpDropFolderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSftpDropFolderBaseFilter extends KalturaSshDropFolderFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSftpDropFolderBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSftpDropFolderBaseFilter'] = KalturaSftpDropFolderBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSwfFlavorParamsFilter extends KalturaSwfFlavorParamsBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSwfFlavorParamsFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSwfFlavorParamsFilter'] = KalturaSwfFlavorParamsFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaThumbParamsOutputFilter extends KalturaThumbParamsOutputBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaThumbParamsOutputFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaThumbParamsOutputFilter'] = KalturaThumbParamsOutputFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTimedThumbAssetFilter extends KalturaTimedThumbAssetBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTimedThumbAssetFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaTimedThumbAssetFilter'] = KalturaTimedThumbAssetFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaTranscriptAssetFilter extends KalturaTranscriptAssetBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaTranscriptAssetFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaTranscriptAssetFilter'] = KalturaTranscriptAssetFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWidevineFlavorAssetFilter extends KalturaWidevineFlavorAssetBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWidevineFlavorAssetFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWidevineFlavorAssetFilter'] = KalturaWidevineFlavorAssetFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWidevineFlavorParamsFilter extends KalturaWidevineFlavorParamsBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWidevineFlavorParamsFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWidevineFlavorParamsFilter'] = KalturaWidevineFlavorParamsFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWowzaMediaServerNodeBaseFilter extends KalturaMediaServerNodeFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWowzaMediaServerNodeBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWowzaMediaServerNodeBaseFilter'] = KalturaWowzaMediaServerNodeBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDocumentFlavorParamsOutputBaseFilter extends KalturaFlavorParamsOutputFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDocumentFlavorParamsOutputBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDocumentFlavorParamsOutputBaseFilter'] = KalturaDocumentFlavorParamsOutputBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaExternalMediaEntryBaseFilter extends KalturaMediaEntryFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaExternalMediaEntryBaseFilter' },
            externalSourceTypeEqual: { type: 'es', subTypeConstructor: KalturaExternalMediaSourceType, subType: 'KalturaExternalMediaSourceType' },
            externalSourceTypeIn: { type: 's' },
            assetParamsIdsMatchOr: { type: 's' },
            assetParamsIdsMatchAnd: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaExternalMediaEntryBaseFilter'] = KalturaExternalMediaEntryBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaImageFlavorParamsOutputBaseFilter extends KalturaFlavorParamsOutputFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaImageFlavorParamsOutputBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaImageFlavorParamsOutputBaseFilter'] = KalturaImageFlavorParamsOutputBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveEntryBaseFilter extends KalturaMediaEntryFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveEntryBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveEntryBaseFilter'] = KalturaLiveEntryBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaFlavorParamsOutputBaseFilter extends KalturaFlavorParamsOutputFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaFlavorParamsOutputBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaFlavorParamsOutputBaseFilter'] = KalturaMediaFlavorParamsOutputBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPdfFlavorParamsOutputBaseFilter extends KalturaFlavorParamsOutputFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPdfFlavorParamsOutputBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPdfFlavorParamsOutputBaseFilter'] = KalturaPdfFlavorParamsOutputBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaScpDropFolderFilter extends KalturaScpDropFolderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaScpDropFolderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaScpDropFolderFilter'] = KalturaScpDropFolderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSftpDropFolderFilter extends KalturaSftpDropFolderBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSftpDropFolderFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSftpDropFolderFilter'] = KalturaSftpDropFolderFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSwfFlavorParamsOutputBaseFilter extends KalturaFlavorParamsOutputFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSwfFlavorParamsOutputBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSwfFlavorParamsOutputBaseFilter'] = KalturaSwfFlavorParamsOutputBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWidevineFlavorParamsOutputBaseFilter extends KalturaFlavorParamsOutputFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWidevineFlavorParamsOutputBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWidevineFlavorParamsOutputBaseFilter'] = KalturaWidevineFlavorParamsOutputBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWowzaMediaServerNodeFilter extends KalturaWowzaMediaServerNodeBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWowzaMediaServerNodeFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWowzaMediaServerNodeFilter'] = KalturaWowzaMediaServerNodeFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaDocumentFlavorParamsOutputFilter extends KalturaDocumentFlavorParamsOutputBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaDocumentFlavorParamsOutputFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaDocumentFlavorParamsOutputFilter'] = KalturaDocumentFlavorParamsOutputFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaExternalMediaEntryFilter extends KalturaExternalMediaEntryBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaExternalMediaEntryFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaExternalMediaEntryFilter'] = KalturaExternalMediaEntryFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaImageFlavorParamsOutputFilter extends KalturaImageFlavorParamsOutputBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaImageFlavorParamsOutputFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaImageFlavorParamsOutputFilter'] = KalturaImageFlavorParamsOutputFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveEntryFilter extends KalturaLiveEntryBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveEntryFilter' },
            isLive: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            isRecordedEntryIdEmpty: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' },
            hasMediaServerHostname: { type: 's' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveEntryFilter'] = KalturaLiveEntryFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaMediaFlavorParamsOutputFilter extends KalturaMediaFlavorParamsOutputBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaMediaFlavorParamsOutputFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaMediaFlavorParamsOutputFilter'] = KalturaMediaFlavorParamsOutputFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaPdfFlavorParamsOutputFilter extends KalturaPdfFlavorParamsOutputBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaPdfFlavorParamsOutputFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaPdfFlavorParamsOutputFilter'] = KalturaPdfFlavorParamsOutputFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaSwfFlavorParamsOutputFilter extends KalturaSwfFlavorParamsOutputBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaSwfFlavorParamsOutputFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaSwfFlavorParamsOutputFilter'] = KalturaSwfFlavorParamsOutputFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaWidevineFlavorParamsOutputFilter extends KalturaWidevineFlavorParamsOutputBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaWidevineFlavorParamsOutputFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaWidevineFlavorParamsOutputFilter'] = KalturaWidevineFlavorParamsOutputFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveChannelBaseFilter extends KalturaLiveEntryFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveChannelBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveChannelBaseFilter'] = KalturaLiveChannelBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamEntryBaseFilter extends KalturaLiveEntryFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamEntryBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamEntryBaseFilter'] = KalturaLiveStreamEntryBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveChannelFilter extends KalturaLiveChannelBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveChannelFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveChannelFilter'] = KalturaLiveChannelFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamEntryFilter extends KalturaLiveStreamEntryBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamEntryFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamEntryFilter'] = KalturaLiveStreamEntryFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamAdminEntryBaseFilter extends KalturaLiveStreamEntryFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamAdminEntryBaseFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamAdminEntryBaseFilter'] = KalturaLiveStreamAdminEntryBaseFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class KalturaLiveStreamAdminEntryFilter extends KalturaLiveStreamAdminEntryBaseFilter {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            objectType: { type: 'c', default: 'KalturaLiveStreamAdminEntryFilter' }
        });
        return result;
    }
}
typesMappingStorage['KalturaLiveStreamAdminEntryFilter'] = KalturaLiveStreamAdminEntryFilter;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaLiveReportExportType = {
    entryTimeLineAll: 11,
    entryTimeLineLive: 12,
    locationAll: 21,
    locationLive: 22,
    partnerTotalAll: 1,
    partnerTotalLive: 2,
    syndicationAll: 31,
    syndicationLive: 32,
};
KalturaLiveReportExportType[KalturaLiveReportExportType.entryTimeLineAll] = 'entryTimeLineAll';
KalturaLiveReportExportType[KalturaLiveReportExportType.entryTimeLineLive] = 'entryTimeLineLive';
KalturaLiveReportExportType[KalturaLiveReportExportType.locationAll] = 'locationAll';
KalturaLiveReportExportType[KalturaLiveReportExportType.locationLive] = 'locationLive';
KalturaLiveReportExportType[KalturaLiveReportExportType.partnerTotalAll] = 'partnerTotalAll';
KalturaLiveReportExportType[KalturaLiveReportExportType.partnerTotalLive] = 'partnerTotalLive';
KalturaLiveReportExportType[KalturaLiveReportExportType.syndicationAll] = 'syndicationAll';
KalturaLiveReportExportType[KalturaLiveReportExportType.syndicationLive] = 'syndicationLive';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const KalturaQuizOutputType = {
    pdf: 1,
};
KalturaQuizOutputType[KalturaQuizOutputType.pdf] = 'pdf';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAccessControlOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAccessControlProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaActivitiBusinessProcessServerOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAdCuePointOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    durationAsc: '+duration',
    durationDesc: '-duration',
    endTimeAsc: '+endTime',
    endTimeDesc: '-endTime',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    startTimeAsc: '+startTime',
    startTimeDesc: '-startTime',
    triggeredAtAsc: '+triggeredAt',
    triggeredAtDesc: '-triggeredAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAdminUserOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAmazonS3StorageProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAnnotationOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    durationAsc: '+duration',
    durationDesc: '-duration',
    endTimeAsc: '+endTime',
    endTimeDesc: '-endTime',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    startTimeAsc: '+startTime',
    startTimeDesc: '-startTime',
    triggeredAtAsc: '+triggeredAt',
    triggeredAtDesc: '-triggeredAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAnswerCuePointOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    startTimeAsc: '+startTime',
    startTimeDesc: '-startTime',
    triggeredAtAsc: '+triggeredAt',
    triggeredAtDesc: '-triggeredAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaApiActionPermissionItemOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaApiParameterPermissionItemOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAppTokenOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAssetOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    deletedAtAsc: '+deletedAt',
    deletedAtDesc: '-deletedAt',
    sizeAsc: '+size',
    sizeDesc: '-size',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAttachmentAssetOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    deletedAtAsc: '+deletedAt',
    deletedAtDesc: '-deletedAt',
    sizeAsc: '+size',
    sizeDesc: '-size',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAuditTrailOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    parsedAtAsc: '+parsedAt',
    parsedAtDesc: '-parsedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaAvnDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBaseEntryOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    endDateAsc: '+endDate',
    endDateDesc: '-endDate',
    moderationCountAsc: '+moderationCount',
    moderationCountDesc: '-moderationCount',
    nameAsc: '+name',
    nameDesc: '-name',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    rankAsc: '+rank',
    rankDesc: '-rank',
    recentAsc: '+recent',
    recentDesc: '-recent',
    startDateAsc: '+startDate',
    startDateDesc: '-startDate',
    totalRankAsc: '+totalRank',
    totalRankDesc: '-totalRank',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
    weightAsc: '+weight',
    weightDesc: '-weight',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBaseSyndicationFeedOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    nameAsc: '+name',
    nameDesc: '-name',
    playlistIdAsc: '+playlistId',
    playlistIdDesc: '-playlistId',
    typeAsc: '+type',
    typeDesc: '-type',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBatchJobObjectType = {
    asset: '4',
    category: '2',
    dropFolderFile: 'dropFolderXmlBulkUpload.DropFolderFile',
    entry: '1',
    entryDistribution: 'contentDistribution.EntryDistribution',
    fileSync: '3',
    metadata: 'metadata.Metadata',
    metadataProfile: 'metadata.MetadataProfile',
    scheduledTaskProfile: 'scheduledTask.ScheduledTaskProfile',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBatchJobOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    estimatedEffortAsc: '+estimatedEffort',
    estimatedEffortDesc: '-estimatedEffort',
    executionAttemptsAsc: '+executionAttempts',
    executionAttemptsDesc: '-executionAttempts',
    finishTimeAsc: '+finishTime',
    finishTimeDesc: '-finishTime',
    lockVersionAsc: '+lockVersion',
    lockVersionDesc: '-lockVersion',
    priorityAsc: '+priority',
    priorityDesc: '-priority',
    queueTimeAsc: '+queueTime',
    queueTimeDesc: '-queueTime',
    statusAsc: '+status',
    statusDesc: '-status',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBusinessProcessAbortNotificationTemplateOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBusinessProcessNotificationTemplateOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBusinessProcessServerOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBusinessProcessSignalNotificationTemplateOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaBusinessProcessStartNotificationTemplateOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaCameraScheduleResourceOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaCaptionAssetOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    deletedAtAsc: '+deletedAt',
    deletedAtDesc: '-deletedAt',
    sizeAsc: '+size',
    sizeDesc: '-size',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaCategoryEntryOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaCategoryUserOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaCodeCuePointOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    durationAsc: '+duration',
    durationDesc: '-duration',
    endTimeAsc: '+endTime',
    endTimeDesc: '-endTime',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    startTimeAsc: '+startTime',
    startTimeDesc: '-startTime',
    triggeredAtAsc: '+triggeredAt',
    triggeredAtDesc: '-triggeredAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaComcastMrssDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaConfigurableDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaControlPanelCommandOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaConversionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaCrossKalturaDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaCuePointOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    startTimeAsc: '+startTime',
    startTimeDesc: '-startTime',
    triggeredAtAsc: '+triggeredAt',
    triggeredAtDesc: '-triggeredAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDailymotionDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDataEntryOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    endDateAsc: '+endDate',
    endDateDesc: '-endDate',
    moderationCountAsc: '+moderationCount',
    moderationCountDesc: '-moderationCount',
    nameAsc: '+name',
    nameDesc: '-name',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    rankAsc: '+rank',
    rankDesc: '-rank',
    recentAsc: '+recent',
    recentDesc: '-recent',
    startDateAsc: '+startDate',
    startDateDesc: '-startDate',
    totalRankAsc: '+totalRank',
    totalRankDesc: '-totalRank',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
    weightAsc: '+weight',
    weightDesc: '-weight',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDeliveryProfileAkamaiAppleHttpManifestOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDeliveryProfileAkamaiHdsOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDeliveryProfileAkamaiHttpOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDeliveryProfileGenericAppleHttpOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDeliveryProfileGenericHdsOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDeliveryProfileGenericHttpOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDeliveryProfileGenericRtmpOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDeliveryProfileGenericSilverLightOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDeliveryProfileLiveAppleHttpOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDeliveryProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDeliveryProfileRtmpOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDeliveryServerNodeOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    heartbeatTimeAsc: '+heartbeatTime',
    heartbeatTimeDesc: '-heartbeatTime',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDocumentEntryOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    endDateAsc: '+endDate',
    endDateDesc: '-endDate',
    moderationCountAsc: '+moderationCount',
    moderationCountDesc: '-moderationCount',
    nameAsc: '+name',
    nameDesc: '-name',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    rankAsc: '+rank',
    rankDesc: '-rank',
    recentAsc: '+recent',
    recentDesc: '-recent',
    startDateAsc: '+startDate',
    startDateDesc: '-startDate',
    totalRankAsc: '+totalRank',
    totalRankDesc: '-totalRank',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
    weightAsc: '+weight',
    weightDesc: '-weight',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDoubleClickDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDrmProfileOrderBy = {
    idAsc: '+id',
    idDesc: '-id',
    nameAsc: '+name',
    nameDesc: '-name',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDropFolderFileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    fileNameAsc: '+fileName',
    fileNameDesc: '-fileName',
    fileSizeAsc: '+fileSize',
    fileSizeDesc: '-fileSize',
    fileSizeLastSetAtAsc: '+fileSizeLastSetAt',
    fileSizeLastSetAtDesc: '-fileSizeLastSetAt',
    idAsc: '+id',
    idDesc: '-id',
    parsedFlavorAsc: '+parsedFlavor',
    parsedFlavorDesc: '-parsedFlavor',
    parsedSlugAsc: '+parsedSlug',
    parsedSlugDesc: '-parsedSlug',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaDropFolderOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    nameAsc: '+name',
    nameDesc: '-name',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEdgeServerNodeOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    heartbeatTimeAsc: '+heartbeatTime',
    heartbeatTimeDesc: '-heartbeatTime',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEmailNotificationTemplateOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEntryDistributionOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    submittedAtAsc: '+submittedAt',
    submittedAtDesc: '-submittedAt',
    sunriseAsc: '+sunrise',
    sunriseDesc: '-sunrise',
    sunsetAsc: '+sunset',
    sunsetDesc: '-sunset',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEntryScheduleEventOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    endDateAsc: '+endDate',
    endDateDesc: '-endDate',
    priorityAsc: '+priority',
    priorityDesc: '-priority',
    startDateAsc: '+startDate',
    startDateDesc: '-startDate',
    summaryAsc: '+summary',
    summaryDesc: '-summary',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEntryServerNodeOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEventCuePointOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    startTimeAsc: '+startTime',
    startTimeDesc: '-startTime',
    triggeredAtAsc: '+triggeredAt',
    triggeredAtDesc: '-triggeredAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaEventNotificationTemplateOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaExternalMediaEntryOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    durationAsc: '+duration',
    durationDesc: '-duration',
    endDateAsc: '+endDate',
    endDateDesc: '-endDate',
    lastPlayedAtAsc: '+lastPlayedAt',
    lastPlayedAtDesc: '-lastPlayedAt',
    mediaTypeAsc: '+mediaType',
    mediaTypeDesc: '-mediaType',
    moderationCountAsc: '+moderationCount',
    moderationCountDesc: '-moderationCount',
    nameAsc: '+name',
    nameDesc: '-name',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    playsAsc: '+plays',
    playsDesc: '-plays',
    rankAsc: '+rank',
    rankDesc: '-rank',
    recentAsc: '+recent',
    recentDesc: '-recent',
    startDateAsc: '+startDate',
    startDateDesc: '-startDate',
    totalRankAsc: '+totalRank',
    totalRankDesc: '-totalRank',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
    viewsAsc: '+views',
    viewsDesc: '-views',
    weightAsc: '+weight',
    weightDesc: '-weight',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaFacebookDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaFileAssetOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaFileSyncOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    fileSizeAsc: '+fileSize',
    fileSizeDesc: '-fileSize',
    readyAtAsc: '+readyAt',
    readyAtDesc: '-readyAt',
    syncTimeAsc: '+syncTime',
    syncTimeDesc: '-syncTime',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
    versionAsc: '+version',
    versionDesc: '-version',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaFlavorAssetOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    deletedAtAsc: '+deletedAt',
    deletedAtDesc: '-deletedAt',
    sizeAsc: '+size',
    sizeDesc: '-size',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaFreewheelDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaFreewheelGenericDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaFtpDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaFtpDropFolderOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    nameAsc: '+name',
    nameDesc: '-name',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaGenericDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaGenericDistributionProviderActionOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaGenericDistributionProviderOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaGenericSyndicationFeedOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    nameAsc: '+name',
    nameDesc: '-name',
    playlistIdAsc: '+playlistId',
    playlistIdDesc: '-playlistId',
    typeAsc: '+type',
    typeDesc: '-type',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaGenericXsltSyndicationFeedOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    nameAsc: '+name',
    nameDesc: '-name',
    playlistIdAsc: '+playlistId',
    playlistIdDesc: '-playlistId',
    typeAsc: '+type',
    typeDesc: '-type',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaGoogleVideoSyndicationFeedOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    nameAsc: '+name',
    nameDesc: '-name',
    playlistIdAsc: '+playlistId',
    playlistIdDesc: '-playlistId',
    typeAsc: '+type',
    typeDesc: '-type',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaGroupUserOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaHttpNotificationTemplateOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaHuluDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaITunesSyndicationFeedOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    nameAsc: '+name',
    nameDesc: '-name',
    playlistIdAsc: '+playlistId',
    playlistIdDesc: '-playlistId',
    typeAsc: '+type',
    typeDesc: '-type',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaIdeticDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaKontikiStorageProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveAssetOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    deletedAtAsc: '+deletedAt',
    deletedAtDesc: '-deletedAt',
    sizeAsc: '+size',
    sizeDesc: '-size',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveChannelOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    durationAsc: '+duration',
    durationDesc: '-duration',
    endDateAsc: '+endDate',
    endDateDesc: '-endDate',
    firstBroadcastAsc: '+firstBroadcast',
    firstBroadcastDesc: '-firstBroadcast',
    lastBroadcastAsc: '+lastBroadcast',
    lastBroadcastDesc: '-lastBroadcast',
    lastPlayedAtAsc: '+lastPlayedAt',
    lastPlayedAtDesc: '-lastPlayedAt',
    mediaTypeAsc: '+mediaType',
    mediaTypeDesc: '-mediaType',
    moderationCountAsc: '+moderationCount',
    moderationCountDesc: '-moderationCount',
    nameAsc: '+name',
    nameDesc: '-name',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    playsAsc: '+plays',
    playsDesc: '-plays',
    rankAsc: '+rank',
    rankDesc: '-rank',
    recentAsc: '+recent',
    recentDesc: '-recent',
    startDateAsc: '+startDate',
    startDateDesc: '-startDate',
    totalRankAsc: '+totalRank',
    totalRankDesc: '-totalRank',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
    viewsAsc: '+views',
    viewsDesc: '-views',
    weightAsc: '+weight',
    weightDesc: '-weight',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveChannelSegmentOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    startTimeAsc: '+startTime',
    startTimeDesc: '-startTime',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveEntryOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    durationAsc: '+duration',
    durationDesc: '-duration',
    endDateAsc: '+endDate',
    endDateDesc: '-endDate',
    firstBroadcastAsc: '+firstBroadcast',
    firstBroadcastDesc: '-firstBroadcast',
    lastBroadcastAsc: '+lastBroadcast',
    lastBroadcastDesc: '-lastBroadcast',
    lastPlayedAtAsc: '+lastPlayedAt',
    lastPlayedAtDesc: '-lastPlayedAt',
    mediaTypeAsc: '+mediaType',
    mediaTypeDesc: '-mediaType',
    moderationCountAsc: '+moderationCount',
    moderationCountDesc: '-moderationCount',
    nameAsc: '+name',
    nameDesc: '-name',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    playsAsc: '+plays',
    playsDesc: '-plays',
    rankAsc: '+rank',
    rankDesc: '-rank',
    recentAsc: '+recent',
    recentDesc: '-recent',
    startDateAsc: '+startDate',
    startDateDesc: '-startDate',
    totalRankAsc: '+totalRank',
    totalRankDesc: '-totalRank',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
    viewsAsc: '+views',
    viewsDesc: '-views',
    weightAsc: '+weight',
    weightDesc: '-weight',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveEntryScheduleResourceOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveReportType = {
    entryGeoTimeLine: 'ENTRY_GEO_TIME_LINE',
    entrySyndicationTotal: 'ENTRY_SYNDICATION_TOTAL',
    entryTimeLine: 'ENTRY_TIME_LINE',
    entryTotal: 'ENTRY_TOTAL',
    partnerTotal: 'PARTNER_TOTAL',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveStreamAdminEntryOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    durationAsc: '+duration',
    durationDesc: '-duration',
    endDateAsc: '+endDate',
    endDateDesc: '-endDate',
    firstBroadcastAsc: '+firstBroadcast',
    firstBroadcastDesc: '-firstBroadcast',
    lastBroadcastAsc: '+lastBroadcast',
    lastBroadcastDesc: '-lastBroadcast',
    lastPlayedAtAsc: '+lastPlayedAt',
    lastPlayedAtDesc: '-lastPlayedAt',
    mediaTypeAsc: '+mediaType',
    mediaTypeDesc: '-mediaType',
    moderationCountAsc: '+moderationCount',
    moderationCountDesc: '-moderationCount',
    nameAsc: '+name',
    nameDesc: '-name',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    playsAsc: '+plays',
    playsDesc: '-plays',
    rankAsc: '+rank',
    rankDesc: '-rank',
    recentAsc: '+recent',
    recentDesc: '-recent',
    startDateAsc: '+startDate',
    startDateDesc: '-startDate',
    totalRankAsc: '+totalRank',
    totalRankDesc: '-totalRank',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
    viewsAsc: '+views',
    viewsDesc: '-views',
    weightAsc: '+weight',
    weightDesc: '-weight',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveStreamEntryOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    durationAsc: '+duration',
    durationDesc: '-duration',
    endDateAsc: '+endDate',
    endDateDesc: '-endDate',
    firstBroadcastAsc: '+firstBroadcast',
    firstBroadcastDesc: '-firstBroadcast',
    lastBroadcastAsc: '+lastBroadcast',
    lastBroadcastDesc: '-lastBroadcast',
    lastPlayedAtAsc: '+lastPlayedAt',
    lastPlayedAtDesc: '-lastPlayedAt',
    mediaTypeAsc: '+mediaType',
    mediaTypeDesc: '-mediaType',
    moderationCountAsc: '+moderationCount',
    moderationCountDesc: '-moderationCount',
    nameAsc: '+name',
    nameDesc: '-name',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    playsAsc: '+plays',
    playsDesc: '-plays',
    rankAsc: '+rank',
    rankDesc: '-rank',
    recentAsc: '+recent',
    recentDesc: '-recent',
    startDateAsc: '+startDate',
    startDateDesc: '-startDate',
    totalRankAsc: '+totalRank',
    totalRankDesc: '-totalRank',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
    viewsAsc: '+views',
    viewsDesc: '-views',
    weightAsc: '+weight',
    weightDesc: '-weight',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLiveStreamScheduleEventOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    endDateAsc: '+endDate',
    endDateDesc: '-endDate',
    priorityAsc: '+priority',
    priorityDesc: '-priority',
    startDateAsc: '+startDate',
    startDateDesc: '-startDate',
    summaryAsc: '+summary',
    summaryDesc: '-summary',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaLocationScheduleResourceOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaMediaEntryOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    durationAsc: '+duration',
    durationDesc: '-duration',
    endDateAsc: '+endDate',
    endDateDesc: '-endDate',
    lastPlayedAtAsc: '+lastPlayedAt',
    lastPlayedAtDesc: '-lastPlayedAt',
    mediaTypeAsc: '+mediaType',
    mediaTypeDesc: '-mediaType',
    moderationCountAsc: '+moderationCount',
    moderationCountDesc: '-moderationCount',
    nameAsc: '+name',
    nameDesc: '-name',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    playsAsc: '+plays',
    playsDesc: '-plays',
    rankAsc: '+rank',
    rankDesc: '-rank',
    recentAsc: '+recent',
    recentDesc: '-recent',
    startDateAsc: '+startDate',
    startDateDesc: '-startDate',
    totalRankAsc: '+totalRank',
    totalRankDesc: '-totalRank',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
    viewsAsc: '+views',
    viewsDesc: '-views',
    weightAsc: '+weight',
    weightDesc: '-weight',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaMediaServerNodeOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    heartbeatTimeAsc: '+heartbeatTime',
    heartbeatTimeDesc: '-heartbeatTime',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaMetadataOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    metadataProfileVersionAsc: '+metadataProfileVersion',
    metadataProfileVersionDesc: '-metadataProfileVersion',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
    versionAsc: '+version',
    versionDesc: '-version',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaMetadataProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaMetroPcsDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaMixEntryOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    durationAsc: '+duration',
    durationDesc: '-duration',
    endDateAsc: '+endDate',
    endDateDesc: '-endDate',
    lastPlayedAtAsc: '+lastPlayedAt',
    lastPlayedAtDesc: '-lastPlayedAt',
    moderationCountAsc: '+moderationCount',
    moderationCountDesc: '-moderationCount',
    nameAsc: '+name',
    nameDesc: '-name',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    playsAsc: '+plays',
    playsDesc: '-plays',
    rankAsc: '+rank',
    rankDesc: '-rank',
    recentAsc: '+recent',
    recentDesc: '-recent',
    startDateAsc: '+startDate',
    startDateDesc: '-startDate',
    totalRankAsc: '+totalRank',
    totalRankDesc: '-totalRank',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
    viewsAsc: '+views',
    viewsDesc: '-views',
    weightAsc: '+weight',
    weightDesc: '-weight',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaMsnDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPartnerOrderBy = {
    adminEmailAsc: '+adminEmail',
    adminEmailDesc: '-adminEmail',
    adminNameAsc: '+adminName',
    adminNameDesc: '-adminName',
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    nameAsc: '+name',
    nameDesc: '-name',
    statusAsc: '+status',
    statusDesc: '-status',
    websiteAsc: '+website',
    websiteDesc: '-website',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPermissionItemOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPermissionOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    nameAsc: '+name',
    nameDesc: '-name',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPlayReadyProfileOrderBy = {
    idAsc: '+id',
    idDesc: '-id',
    nameAsc: '+name',
    nameDesc: '-name',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPlayableEntryOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    durationAsc: '+duration',
    durationDesc: '-duration',
    endDateAsc: '+endDate',
    endDateDesc: '-endDate',
    lastPlayedAtAsc: '+lastPlayedAt',
    lastPlayedAtDesc: '-lastPlayedAt',
    moderationCountAsc: '+moderationCount',
    moderationCountDesc: '-moderationCount',
    nameAsc: '+name',
    nameDesc: '-name',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    playsAsc: '+plays',
    playsDesc: '-plays',
    rankAsc: '+rank',
    rankDesc: '-rank',
    recentAsc: '+recent',
    recentDesc: '-recent',
    startDateAsc: '+startDate',
    startDateDesc: '-startDate',
    totalRankAsc: '+totalRank',
    totalRankDesc: '-totalRank',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
    viewsAsc: '+views',
    viewsDesc: '-views',
    weightAsc: '+weight',
    weightDesc: '-weight',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPlaylistOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    endDateAsc: '+endDate',
    endDateDesc: '-endDate',
    moderationCountAsc: '+moderationCount',
    moderationCountDesc: '-moderationCount',
    nameAsc: '+name',
    nameDesc: '-name',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    rankAsc: '+rank',
    rankDesc: '-rank',
    recentAsc: '+recent',
    recentDesc: '-recent',
    startDateAsc: '+startDate',
    startDateDesc: '-startDate',
    totalRankAsc: '+totalRank',
    totalRankDesc: '-totalRank',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
    weightAsc: '+weight',
    weightDesc: '-weight',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPushNotificationCommandType = {
    clearQueue: 'CLEAR_QUEUE',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaPushNotificationTemplateOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaQuestionCuePointOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    startTimeAsc: '+startTime',
    startTimeDesc: '-startTime',
    triggeredAtAsc: '+triggeredAt',
    triggeredAtDesc: '-triggeredAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaQuickPlayDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaQuizUserEntryOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaRecordScheduleEventOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    endDateAsc: '+endDate',
    endDateDesc: '-endDate',
    priorityAsc: '+priority',
    priorityDesc: '-priority',
    startDateAsc: '+startDate',
    startDateDesc: '-startDate',
    summaryAsc: '+summary',
    summaryDesc: '-summary',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaRemoteDropFolderOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    nameAsc: '+name',
    nameDesc: '-name',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaReportOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaReportType = {
    applications: '16',
    browsers: '23',
    browsersFamilies: '33',
    cities: '30',
    contentContributions: '7',
    contentDropoff: '2',
    contentInteractions: '3',
    entryUsage: '27',
    live: '24',
    mapOverlay: '4',
    operatingSystem: '22',
    operatingSystemFamilies: '32',
    partnerUsage: '201',
    platforms: '21',
    quiz: 'quiz.QUIZ',
    quizAggregateByQuestion: 'quiz.QUIZ_AGGREGATE_BY_QUESTION',
    quizUserAggregateByQuestion: 'quiz.QUIZ_USER_AGGREGATE_BY_QUESTION',
    quizUserPercentage: 'quiz.QUIZ_USER_PERCENTAGE',
    reachUsage: '28',
    specificUserEngagement: '12',
    specificUserUsage: '18',
    topContent: '1',
    topContributors: '5',
    topCreators: '20',
    topCustomVar1: '29',
    topPlaybackContext: '25',
    topSyndication: '6',
    uniqueUsersPlay: '35',
    userContentDropoff: '14',
    userContentInteractions: '15',
    userEngagement: '11',
    userEngagementTimeline: '34',
    userTopContent: '13',
    userUsage: '17',
    varUsage: '19',
    vpaasUsage: '26',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaResponseProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaScheduleEventOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    endDateAsc: '+endDate',
    endDateDesc: '-endDate',
    priorityAsc: '+priority',
    priorityDesc: '-priority',
    startDateAsc: '+startDate',
    startDateDesc: '-startDate',
    summaryAsc: '+summary',
    summaryDesc: '-summary',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaScheduleEventResourceOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaScheduleResourceOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaScheduledTaskProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    lastExecutionStartedAtAsc: '+lastExecutionStartedAt',
    lastExecutionStartedAtDesc: '-lastExecutionStartedAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaSchemaType = {
    bulkUploadResultXml: 'bulkUploadXml.bulkUploadResultXML',
    bulkUploadXml: 'bulkUploadXml.bulkUploadXML',
    dropFolderXml: 'dropFolderXmlBulkUpload.dropFolderXml',
    ingestApi: 'cuePoint.ingestAPI',
    serveApi: 'cuePoint.serveAPI',
    syndication: 'syndication',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaScpDropFolderOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    nameAsc: '+name',
    nameDesc: '-name',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaServerNodeOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    heartbeatTimeAsc: '+heartbeatTime',
    heartbeatTimeDesc: '-heartbeatTime',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaSftpDropFolderOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    nameAsc: '+name',
    nameDesc: '-name',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaShortLinkOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    expiresAtAsc: '+expiresAt',
    expiresAtDesc: '-expiresAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaSshDropFolderOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    nameAsc: '+name',
    nameDesc: '-name',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaStorageProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaSyndicationDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaThumbAssetOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    deletedAtAsc: '+deletedAt',
    deletedAtDesc: '-deletedAt',
    sizeAsc: '+size',
    sizeDesc: '-size',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaThumbCuePointOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    partnerSortValueAsc: '+partnerSortValue',
    partnerSortValueDesc: '-partnerSortValue',
    startTimeAsc: '+startTime',
    startTimeDesc: '-startTime',
    triggeredAtAsc: '+triggeredAt',
    triggeredAtDesc: '-triggeredAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaTimedThumbAssetOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    deletedAtAsc: '+deletedAt',
    deletedAtDesc: '-deletedAt',
    sizeAsc: '+size',
    sizeDesc: '-size',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaTranscriptAssetOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    deletedAtAsc: '+deletedAt',
    deletedAtDesc: '-deletedAt',
    sizeAsc: '+size',
    sizeDesc: '-size',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaTubeMogulSyndicationFeedOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    nameAsc: '+name',
    nameDesc: '-name',
    playlistIdAsc: '+playlistId',
    playlistIdDesc: '-playlistId',
    typeAsc: '+type',
    typeDesc: '-type',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaUiConfAdminOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaUiConfOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaUnicornDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaUploadTokenOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaUserEntryOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaUserOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaUserRoleOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    nameAsc: '+name',
    nameDesc: '-name',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaVirusScanProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaWebexDropFolderFileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    fileNameAsc: '+fileName',
    fileNameDesc: '-fileName',
    fileSizeAsc: '+fileSize',
    fileSizeDesc: '-fileSize',
    fileSizeLastSetAtAsc: '+fileSizeLastSetAt',
    fileSizeLastSetAtDesc: '-fileSizeLastSetAt',
    idAsc: '+id',
    idDesc: '-id',
    parsedFlavorAsc: '+parsedFlavor',
    parsedFlavorDesc: '-parsedFlavor',
    parsedSlugAsc: '+parsedSlug',
    parsedSlugDesc: '-parsedSlug',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaWebexDropFolderOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    idAsc: '+id',
    idDesc: '-id',
    nameAsc: '+name',
    nameDesc: '-name',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaWidevineFlavorAssetOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    deletedAtAsc: '+deletedAt',
    deletedAtDesc: '-deletedAt',
    sizeAsc: '+size',
    sizeDesc: '-size',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaWidevineProfileOrderBy = {
    idAsc: '+id',
    idDesc: '-id',
    nameAsc: '+name',
    nameDesc: '-name',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaWidgetOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaWowzaMediaServerNodeOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    heartbeatTimeAsc: '+heartbeatTime',
    heartbeatTimeDesc: '-heartbeatTime',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaYahooDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaYahooSyndicationFeedOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    nameAsc: '+name',
    nameDesc: '-name',
    playlistIdAsc: '+playlistId',
    playlistIdDesc: '-playlistId',
    typeAsc: '+type',
    typeDesc: '-type',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaYouTubeDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const KalturaYoutubeApiDistributionProfileOrderBy = {
    createdAtAsc: '+createdAt',
    createdAtDesc: '-createdAt',
    updatedAtAsc: '+updatedAt',
    updatedAtDesc: '-updatedAt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'accessControlProfile' action 'add'.
 *
 * Usage: Add new access control profile
 *
 * Server response type:         KalturaAccessControlProfile
 * Server failure response type: KalturaAPIException
 */
class AccessControlProfileAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAccessControlProfile', responseConstructor: KalturaAccessControlProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'accesscontrolprofile' },
            action: { type: 'c', default: 'add' },
            accessControlProfile: { type: 'o', subTypeConstructor: KalturaAccessControlProfile, subType: 'KalturaAccessControlProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'accessControlProfile' action 'delete'.
 *
 * Usage: Delete access control profile by id
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class AccessControlProfileDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'accesscontrolprofile' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'accessControlProfile' action 'get'.
 *
 * Usage: Get access control profile by id
 *
 * Server response type:         KalturaAccessControlProfile
 * Server failure response type: KalturaAPIException
 */
class AccessControlProfileGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAccessControlProfile', responseConstructor: KalturaAccessControlProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'accesscontrolprofile' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'accessControlProfile' action 'list'.
 *
 * Usage: List access control profiles by filter and pager
 *
 * Server response type:         KalturaAccessControlProfileListResponse
 * Server failure response type: KalturaAPIException
 */
class AccessControlProfileListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAccessControlProfileListResponse', responseConstructor: KalturaAccessControlProfileListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'accesscontrolprofile' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaAccessControlProfileFilter, subType: 'KalturaAccessControlProfileFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'accessControlProfile' action 'update'.
 *
 * Usage: Update access control profile by id
 *
 * Server response type:         KalturaAccessControlProfile
 * Server failure response type: KalturaAPIException
 */
class AccessControlProfileUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAccessControlProfile', responseConstructor: KalturaAccessControlProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'accesscontrolprofile' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            accessControlProfile: { type: 'o', subTypeConstructor: KalturaAccessControlProfile, subType: 'KalturaAccessControlProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'accessControl' action 'add'.
 *
 * Usage: Add new Access Control Profile
 *
 * Server response type:         KalturaAccessControl
 * Server failure response type: KalturaAPIException
 */
class AccessControlAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAccessControl', responseConstructor: KalturaAccessControl });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'accesscontrol' },
            action: { type: 'c', default: 'add' },
            accessControl: { type: 'o', subTypeConstructor: KalturaAccessControl, subType: 'KalturaAccessControl' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'accessControl' action 'delete'.
 *
 * Usage: Delete Access Control Profile by id
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class AccessControlDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'accesscontrol' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'accessControl' action 'get'.
 *
 * Usage: Get Access Control Profile by id
 *
 * Server response type:         KalturaAccessControl
 * Server failure response type: KalturaAPIException
 */
class AccessControlGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAccessControl', responseConstructor: KalturaAccessControl });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'accesscontrol' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'accessControl' action 'list'.
 *
 * Usage: List Access Control Profiles by filter and pager
 *
 * Server response type:         KalturaAccessControlListResponse
 * Server failure response type: KalturaAPIException
 */
class AccessControlListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAccessControlListResponse', responseConstructor: KalturaAccessControlListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'accesscontrol' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaAccessControlFilter, subType: 'KalturaAccessControlFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'accessControl' action 'update'.
 *
 * Usage: Update Access Control Profile by id
 *
 * Server response type:         KalturaAccessControl
 * Server failure response type: KalturaAPIException
 */
class AccessControlUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAccessControl', responseConstructor: KalturaAccessControl });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'accesscontrol' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            accessControl: { type: 'o', subTypeConstructor: KalturaAccessControl, subType: 'KalturaAccessControl' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'adminUser' action 'login'.
 *
 * Usage: Get an admin session using admin email and password (Used for login to the KMC application)
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class AdminUserLoginAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'adminuser' },
            action: { type: 'c', default: 'login' },
            email: { type: 's' },
            password: { type: 's' },
            partnerId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'adminUser' action 'resetPassword'.
 *
 * Usage: Reset admin user password and send it to the users email address
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class AdminUserResetPasswordAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'adminuser' },
            action: { type: 'c', default: 'resetPassword' },
            email: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'adminUser' action 'setInitialPassword'.
 *
 * Usage: Set initial users password
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class AdminUserSetInitialPasswordAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'adminuser' },
            action: { type: 'c', default: 'setInitialPassword' },
            hashKey: { type: 's' },
            newPassword: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'adminUser' action 'updatePassword'.
 *
 * Usage: Update admin user password and email
 *
 * Server response type:         KalturaAdminUser
 * Server failure response type: KalturaAPIException
 */
class AdminUserUpdatePasswordAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAdminUser', responseConstructor: KalturaAdminUser });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'adminuser' },
            action: { type: 'c', default: 'updatePassword' },
            email: { type: 's' },
            password: { type: 's' },
            newEmail: { type: 's' },
            newPassword: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'analytics' action 'query'.
 *
 * Usage: report query action allows to get a analytics data for specific query dimensions, metrics and filters
 *
 * Server response type:         KalturaReportResponse
 * Server failure response type: KalturaAPIException
 */
class AnalyticsQueryAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaReportResponse', responseConstructor: KalturaReportResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'analytics' },
            action: { type: 'c', default: 'query' },
            filter: { type: 'o', subTypeConstructor: KalturaAnalyticsFilter, subType: 'KalturaAnalyticsFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'appToken' action 'add'.
 *
 * Usage: Add new application authentication token
 *
 * Server response type:         KalturaAppToken
 * Server failure response type: KalturaAPIException
 */
class AppTokenAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAppToken', responseConstructor: KalturaAppToken });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'apptoken' },
            action: { type: 'c', default: 'add' },
            appToken: { type: 'o', subTypeConstructor: KalturaAppToken, subType: 'KalturaAppToken' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'appToken' action 'delete'.
 *
 * Usage: Delete application authentication token by ID
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class AppTokenDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'apptoken' },
            action: { type: 'c', default: 'delete' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'appToken' action 'get'.
 *
 * Usage: Get application authentication token by ID
 *
 * Server response type:         KalturaAppToken
 * Server failure response type: KalturaAPIException
 */
class AppTokenGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAppToken', responseConstructor: KalturaAppToken });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'apptoken' },
            action: { type: 'c', default: 'get' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'appToken' action 'list'.
 *
 * Usage: List application authentication tokens by filter and pager
 *
 * Server response type:         KalturaAppTokenListResponse
 * Server failure response type: KalturaAPIException
 */
class AppTokenListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAppTokenListResponse', responseConstructor: KalturaAppTokenListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'apptoken' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaAppTokenFilter, subType: 'KalturaAppTokenFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'appToken' action 'startSession'.
 *
 * Usage: Starts a new KS (kaltura Session) based on an application authentication token ID
 *
 * Server response type:         KalturaSessionInfo
 * Server failure response type: KalturaAPIException
 */
class AppTokenStartSessionAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaSessionInfo', responseConstructor: KalturaSessionInfo });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'apptoken' },
            action: { type: 'c', default: 'startSession' },
            id: { type: 's' },
            tokenHash: { type: 's' },
            userId: { type: 's' },
            type: { type: 'en', subTypeConstructor: KalturaSessionType, subType: 'KalturaSessionType' },
            expiry: { type: 'n' },
            sessionPrivileges: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'appToken' action 'update'.
 *
 * Usage: Update application authentication token by ID
 *
 * Server response type:         KalturaAppToken
 * Server failure response type: KalturaAPIException
 */
class AppTokenUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAppToken', responseConstructor: KalturaAppToken });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'apptoken' },
            action: { type: 'c', default: 'update' },
            id: { type: 's' },
            appToken: { type: 'o', subTypeConstructor: KalturaAppToken, subType: 'KalturaAppToken' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'add'.
 *
 * Usage: Generic add entry, should be used when the uploaded entry type is not known
 *
 * Server response type:         KalturaBaseEntry
 * Server failure response type: KalturaAPIException
 */
class BaseEntryAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseEntry', responseConstructor: KalturaBaseEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'add' },
            entry: { type: 'o', subTypeConstructor: KalturaBaseEntry, subType: 'KalturaBaseEntry' },
            type: { type: 'es', subTypeConstructor: KalturaEntryType, subType: 'KalturaEntryType' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'addContent'.
 *
 * Usage: Attach content resource to entry in status NO_MEDIA
 *
 * Server response type:         KalturaBaseEntry
 * Server failure response type: KalturaAPIException
 */
class BaseEntryAddContentAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseEntry', responseConstructor: KalturaBaseEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'addContent' },
            entryId: { type: 's' },
            resource: { type: 'o', subTypeConstructor: KalturaResource, subType: 'KalturaResource' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'addFromUploadedFile'.
 *
 * Usage: Generic add entry using an uploaded file, should be used when the uploaded entry type is not known
 *
 * Server response type:         KalturaBaseEntry
 * Server failure response type: KalturaAPIException
 */
class BaseEntryAddFromUploadedFileAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseEntry', responseConstructor: KalturaBaseEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'addFromUploadedFile' },
            entry: { type: 'o', subTypeConstructor: KalturaBaseEntry, subType: 'KalturaBaseEntry' },
            uploadTokenId: { type: 's' },
            type: { type: 'es', subTypeConstructor: KalturaEntryType, subType: 'KalturaEntryType' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'anonymousRank'.
 *
 * Usage: Anonymously rank an entry, no validation is done on duplicate rankings
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class BaseEntryAnonymousRankAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'anonymousRank' },
            entryId: { type: 's' },
            rank: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'approve'.
 *
 * Usage: Approve the entry and mark the pending flags (if any) as moderated (this will make the entry playable)
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class BaseEntryApproveAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'approve' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'clone'.
 *
 * Usage: Clone an entry with optional attributes to apply to the clone
 *
 * Server response type:         KalturaBaseEntry
 * Server failure response type: KalturaAPIException
 */
class BaseEntryCloneAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseEntry', responseConstructor: KalturaBaseEntry });
        if (typeof this.cloneOptions === 'undefined')
            this.cloneOptions = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'clone' },
            entryId: { type: 's' },
            cloneOptions: { type: 'a', subTypeConstructor: KalturaBaseEntryCloneOptionItem, subType: 'KalturaBaseEntryCloneOptionItem' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'count'.
 *
 * Usage: Count base entries by filter
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class BaseEntryCountAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'count' },
            filter: { type: 'o', subTypeConstructor: KalturaBaseEntryFilter, subType: 'KalturaBaseEntryFilter' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'delete'.
 *
 * Usage: Delete an entry
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class BaseEntryDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'delete' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'export'.
 *
 *
 *
 * Server response type:         KalturaBaseEntry
 * Server failure response type: KalturaAPIException
 */
class BaseEntryExportAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseEntry', responseConstructor: KalturaBaseEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'export' },
            entryId: { type: 's' },
            storageProfileId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'flag'.
 *
 * Usage: Flag inappropriate entry for moderation
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class BaseEntryFlagAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'flag' },
            moderationFlag: { type: 'o', subTypeConstructor: KalturaModerationFlag, subType: 'KalturaModerationFlag' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'get'.
 *
 * Usage: Get base entry by ID
 *
 * Server response type:         KalturaBaseEntry
 * Server failure response type: KalturaAPIException
 */
class BaseEntryGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseEntry', responseConstructor: KalturaBaseEntry });
        if (typeof this.version === 'undefined')
            this.version = -1;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'get' },
            entryId: { type: 's' },
            version: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'getByIds'.
 *
 * Usage: Get an array of KalturaBaseEntry objects by a comma-separated list of ids
 *
 * Server response type:         KalturaBaseEntry[]
 * Server failure response type: KalturaAPIException
 */
class BaseEntryGetByIdsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaBaseEntry', responseConstructor: KalturaBaseEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'getByIds' },
            entryIds: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'getContextData'.
 *
 * Usage: This action delivers entry-related data, based on the user's context: access control, restriction, playback format and storage information
 *
 * Server response type:         KalturaEntryContextDataResult
 * Server failure response type: KalturaAPIException
 */
class BaseEntryGetContextDataAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEntryContextDataResult', responseConstructor: KalturaEntryContextDataResult });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'getContextData' },
            entryId: { type: 's' },
            contextDataParams: { type: 'o', subTypeConstructor: KalturaEntryContextDataParams, subType: 'KalturaEntryContextDataParams' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'getPlaybackContext'.
 *
 * Usage: This action delivers all data relevant for player
 *
 * Server response type:         KalturaPlaybackContext
 * Server failure response type: KalturaAPIException
 */
class BaseEntryGetPlaybackContextAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPlaybackContext', responseConstructor: KalturaPlaybackContext });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'getPlaybackContext' },
            entryId: { type: 's' },
            contextDataParams: { type: 'o', subTypeConstructor: KalturaPlaybackContextOptions, subType: 'KalturaPlaybackContextOptions' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'getRemotePaths'.
 *
 * Usage: Get remote storage existing paths for the asset
 *
 * Server response type:         KalturaRemotePathListResponse
 * Server failure response type: KalturaAPIException
 */
class BaseEntryGetRemotePathsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaRemotePathListResponse', responseConstructor: KalturaRemotePathListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'getRemotePaths' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'index'.
 *
 * Usage: Index an entry by id
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class BaseEntryIndexAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
        if (typeof this.shouldUpdate === 'undefined')
            this.shouldUpdate = true;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'index' },
            id: { type: 's' },
            shouldUpdate: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'list'.
 *
 * Usage: List base entries by filter with paging support
 *
 * Server response type:         KalturaBaseEntryListResponse
 * Server failure response type: KalturaAPIException
 */
class BaseEntryListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseEntryListResponse', responseConstructor: KalturaBaseEntryListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaBaseEntryFilter, subType: 'KalturaBaseEntryFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'listByReferenceId'.
 *
 * Usage: List base entries by filter according to reference id
 *
 * Server response type:         KalturaBaseEntryListResponse
 * Server failure response type: KalturaAPIException
 */
class BaseEntryListByReferenceIdAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseEntryListResponse', responseConstructor: KalturaBaseEntryListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'listByReferenceId' },
            refId: { type: 's' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'listFlags'.
 *
 * Usage: List all pending flags for the entry
 *
 * Server response type:         KalturaModerationFlagListResponse
 * Server failure response type: KalturaAPIException
 */
class BaseEntryListFlagsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaModerationFlagListResponse', responseConstructor: KalturaModerationFlagListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'listFlags' },
            entryId: { type: 's' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'reject'.
 *
 * Usage: Reject the entry and mark the pending flags (if any) as moderated (this will make the entry non-playable)
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class BaseEntryRejectAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'reject' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'update'.
 *
 * Usage: Update base entry. Only the properties that were set will be updated
 *
 * Server response type:         KalturaBaseEntry
 * Server failure response type: KalturaAPIException
 */
class BaseEntryUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseEntry', responseConstructor: KalturaBaseEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'update' },
            entryId: { type: 's' },
            baseEntry: { type: 'o', subTypeConstructor: KalturaBaseEntry, subType: 'KalturaBaseEntry' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'updateContent'.
 *
 * Usage: Update the content resource associated with the entry
 *
 * Server response type:         KalturaBaseEntry
 * Server failure response type: KalturaAPIException
 */
class BaseEntryUpdateContentAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseEntry', responseConstructor: KalturaBaseEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'updateContent' },
            entryId: { type: 's' },
            resource: { type: 'o', subTypeConstructor: KalturaResource, subType: 'KalturaResource' },
            conversionProfileId: { type: 'n' },
            advancedOptions: { type: 'o', subTypeConstructor: KalturaEntryReplacementOptions, subType: 'KalturaEntryReplacementOptions' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'updateThumbnailFromSourceEntry'.
 *
 * Usage: Update entry thumbnail from a different entry by a specified time offset (in seconds)
 *
 * Server response type:         KalturaBaseEntry
 * Server failure response type: KalturaAPIException
 */
class BaseEntryUpdateThumbnailFromSourceEntryAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseEntry', responseConstructor: KalturaBaseEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'updateThumbnailFromSourceEntry' },
            entryId: { type: 's' },
            sourceEntryId: { type: 's' },
            timeOffset: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'updateThumbnailFromUrl'.
 *
 * Usage: Update entry thumbnail using url
 *
 * Server response type:         KalturaBaseEntry
 * Server failure response type: KalturaAPIException
 */
class BaseEntryUpdateThumbnailFromUrlAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseEntry', responseConstructor: KalturaBaseEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'updateThumbnailFromUrl' },
            entryId: { type: 's' },
            url: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'updateThumbnailJpeg'.
 *
 * Usage: Update entry thumbnail using a raw jpeg file
 *
 * Server response type:         KalturaBaseEntry
 * Server failure response type: KalturaAPIException
 */
class BaseEntryUpdateThumbnailJpegAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseEntry', responseConstructor: KalturaBaseEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'updateThumbnailJpeg' },
            entryId: { type: 's' },
            fileData: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'baseEntry' action 'upload'.
 *
 * Usage: Upload a file to Kaltura, that can be used to create an entry
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class BaseEntryUploadAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'baseentry' },
            action: { type: 'c', default: 'upload' },
            fileData: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'bulkUpload' action 'abort'.
 *
 * Usage: Aborts the bulk upload and all its child jobs
 *
 * Server response type:         KalturaBulkUpload
 * Server failure response type: KalturaAPIException
 */
class BulkUploadAbortAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBulkUpload', responseConstructor: KalturaBulkUpload });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'bulkupload' },
            action: { type: 'c', default: 'abort' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'bulkUpload' action 'add'.
 *
 * Usage: Add new bulk upload batch job
 * Conversion profile id can be specified in the API or in the CSV file, the one in the CSV file will be stronger.
 * If no conversion profile was specified, partner's default will be used
 *
 * Server response type:         KalturaBulkUpload
 * Server failure response type: KalturaAPIException
 */
class BulkUploadAddAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBulkUpload', responseConstructor: KalturaBulkUpload });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'bulkupload' },
            action: { type: 'c', default: 'add' },
            conversionProfileId: { type: 'n' },
            csvFileData: { type: 'f' },
            bulkUploadType: { type: 'es', subTypeConstructor: KalturaBulkUploadType, subType: 'KalturaBulkUploadType' },
            uploadedBy: { type: 's' },
            fileName: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'bulkUpload' action 'get'.
 *
 * Usage: Get bulk upload batch job by id
 *
 * Server response type:         KalturaBulkUpload
 * Server failure response type: KalturaAPIException
 */
class BulkUploadGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBulkUpload', responseConstructor: KalturaBulkUpload });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'bulkupload' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'bulkUpload' action 'list'.
 *
 * Usage: List bulk upload batch jobs
 *
 * Server response type:         KalturaBulkUploadListResponse
 * Server failure response type: KalturaAPIException
 */
class BulkUploadListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBulkUploadListResponse', responseConstructor: KalturaBulkUploadListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'bulkupload' },
            action: { type: 'c', default: 'list' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'bulkUpload' action 'serve'.
 *
 * Usage: serve action return the original file
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class BulkUploadServeAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'bulkupload' },
            action: { type: 'c', default: 'serve' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'bulkUpload' action 'serveLog'.
 *
 * Usage: serveLog action return the original file
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class BulkUploadServeLogAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'bulkupload' },
            action: { type: 'c', default: 'serveLog' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryEntry' action 'activate'.
 *
 * Usage: activate CategoryEntry when it is pending moderation
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class CategoryEntryActivateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryentry' },
            action: { type: 'c', default: 'activate' },
            entryId: { type: 's' },
            categoryId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryEntry' action 'add'.
 *
 * Usage: Add new CategoryEntry
 *
 * Server response type:         KalturaCategoryEntry
 * Server failure response type: KalturaAPIException
 */
class CategoryEntryAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCategoryEntry', responseConstructor: KalturaCategoryEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryentry' },
            action: { type: 'c', default: 'add' },
            categoryEntry: { type: 'o', subTypeConstructor: KalturaCategoryEntry, subType: 'KalturaCategoryEntry' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryEntry' action 'addFromBulkUpload'.
 *
 *
 *
 * Server response type:         KalturaBulkUpload
 * Server failure response type: KalturaAPIException
 */
class CategoryEntryAddFromBulkUploadAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBulkUpload', responseConstructor: KalturaBulkUpload });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryentry' },
            action: { type: 'c', default: 'addFromBulkUpload' },
            bulkUploadData: { type: 'o', subTypeConstructor: KalturaBulkServiceData, subType: 'KalturaBulkServiceData' },
            bulkUploadCategoryEntryData: { type: 'o', subTypeConstructor: KalturaBulkUploadCategoryEntryData, subType: 'KalturaBulkUploadCategoryEntryData' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryEntry' action 'delete'.
 *
 * Usage: Delete CategoryEntry
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class CategoryEntryDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryentry' },
            action: { type: 'c', default: 'delete' },
            entryId: { type: 's' },
            categoryId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryEntry' action 'index'.
 *
 * Usage: Index CategoryEntry by Id
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class CategoryEntryIndexAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
        if (typeof this.shouldUpdate === 'undefined')
            this.shouldUpdate = true;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryentry' },
            action: { type: 'c', default: 'index' },
            entryId: { type: 's' },
            categoryId: { type: 'n' },
            shouldUpdate: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryEntry' action 'list'.
 *
 * Usage: List all categoryEntry
 *
 * Server response type:         KalturaCategoryEntryListResponse
 * Server failure response type: KalturaAPIException
 */
class CategoryEntryListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCategoryEntryListResponse', responseConstructor: KalturaCategoryEntryListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryentry' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaCategoryEntryFilter, subType: 'KalturaCategoryEntryFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryEntry' action 'reject'.
 *
 * Usage: activate CategoryEntry when it is pending moderation
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class CategoryEntryRejectAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryentry' },
            action: { type: 'c', default: 'reject' },
            entryId: { type: 's' },
            categoryId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryEntry' action 'syncPrivacyContext'.
 *
 * Usage: update privacy context from the category
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class CategoryEntrySyncPrivacyContextAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryentry' },
            action: { type: 'c', default: 'syncPrivacyContext' },
            entryId: { type: 's' },
            categoryId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryEntry' action 'updateStatusFromBulk'.
 *
 *
 *
 * Server response type:         KalturaBulkUpload
 * Server failure response type: KalturaAPIException
 */
class CategoryEntryUpdateStatusFromBulkAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBulkUpload', responseConstructor: KalturaBulkUpload });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryentry' },
            action: { type: 'c', default: 'updateStatusFromBulk' },
            fileData: { type: 'f' },
            bulkUploadData: { type: 'o', subTypeConstructor: KalturaBulkUploadJobData, subType: 'KalturaBulkUploadJobData' },
            bulkUploadCategoryEntryData: { type: 'o', subTypeConstructor: KalturaBulkUploadCategoryEntryData, subType: 'KalturaBulkUploadCategoryEntryData' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'category' action 'add'.
 *
 * Usage: Add new Category
 *
 * Server response type:         KalturaCategory
 * Server failure response type: KalturaAPIException
 */
class CategoryAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCategory', responseConstructor: KalturaCategory });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'category' },
            action: { type: 'c', default: 'add' },
            category: { type: 'o', subTypeConstructor: KalturaCategory, subType: 'KalturaCategory' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'category' action 'addFromBulkUpload'.
 *
 *
 *
 * Server response type:         KalturaBulkUpload
 * Server failure response type: KalturaAPIException
 */
class CategoryAddFromBulkUploadAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBulkUpload', responseConstructor: KalturaBulkUpload });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'category' },
            action: { type: 'c', default: 'addFromBulkUpload' },
            fileData: { type: 'f' },
            bulkUploadData: { type: 'o', subTypeConstructor: KalturaBulkUploadJobData, subType: 'KalturaBulkUploadJobData' },
            bulkUploadCategoryData: { type: 'o', subTypeConstructor: KalturaBulkUploadCategoryData, subType: 'KalturaBulkUploadCategoryData' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'category' action 'delete'.
 *
 * Usage: Delete a Category
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class CategoryDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
        if (typeof this.moveEntriesToParentCategory === 'undefined')
            this.moveEntriesToParentCategory = 1;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'category' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' },
            moveEntriesToParentCategory: { type: 'en', subTypeConstructor: KalturaNullableBoolean, subType: 'KalturaNullableBoolean' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'category' action 'get'.
 *
 * Usage: Get Category by id
 *
 * Server response type:         KalturaCategory
 * Server failure response type: KalturaAPIException
 */
class CategoryGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCategory', responseConstructor: KalturaCategory });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'category' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'category' action 'index'.
 *
 * Usage: Index Category by id
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class CategoryIndexAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
        if (typeof this.shouldUpdate === 'undefined')
            this.shouldUpdate = true;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'category' },
            action: { type: 'c', default: 'index' },
            id: { type: 'n' },
            shouldUpdate: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'category' action 'list'.
 *
 * Usage: List all categories
 *
 * Server response type:         KalturaCategoryListResponse
 * Server failure response type: KalturaAPIException
 */
class CategoryListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCategoryListResponse', responseConstructor: KalturaCategoryListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'category' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaCategoryFilter, subType: 'KalturaCategoryFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'category' action 'move'.
 *
 * Usage: Move categories that belong to the same parent category to a target categroy - enabled only for ks with disable entitlement
 *
 * Server response type:         boolean
 * Server failure response type: KalturaAPIException
 */
class CategoryMoveAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'b', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'category' },
            action: { type: 'c', default: 'move' },
            categoryIds: { type: 's' },
            targetCategoryParentId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'category' action 'unlockCategories'.
 *
 * Usage: Unlock categories
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class CategoryUnlockCategoriesAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'category' },
            action: { type: 'c', default: 'unlockCategories' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'category' action 'update'.
 *
 * Usage: Update Category
 *
 * Server response type:         KalturaCategory
 * Server failure response type: KalturaAPIException
 */
class CategoryUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCategory', responseConstructor: KalturaCategory });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'category' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            category: { type: 'o', subTypeConstructor: KalturaCategory, subType: 'KalturaCategory' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryUser' action 'activate'.
 *
 * Usage: activate CategoryUser
 *
 * Server response type:         KalturaCategoryUser
 * Server failure response type: KalturaAPIException
 */
class CategoryUserActivateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCategoryUser', responseConstructor: KalturaCategoryUser });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryuser' },
            action: { type: 'c', default: 'activate' },
            categoryId: { type: 'n' },
            userId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryUser' action 'add'.
 *
 * Usage: Add new CategoryUser
 *
 * Server response type:         KalturaCategoryUser
 * Server failure response type: KalturaAPIException
 */
class CategoryUserAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCategoryUser', responseConstructor: KalturaCategoryUser });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryuser' },
            action: { type: 'c', default: 'add' },
            categoryUser: { type: 'o', subTypeConstructor: KalturaCategoryUser, subType: 'KalturaCategoryUser' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryUser' action 'addFromBulkUpload'.
 *
 *
 *
 * Server response type:         KalturaBulkUpload
 * Server failure response type: KalturaAPIException
 */
class CategoryUserAddFromBulkUploadAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBulkUpload', responseConstructor: KalturaBulkUpload });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryuser' },
            action: { type: 'c', default: 'addFromBulkUpload' },
            fileData: { type: 'f' },
            bulkUploadData: { type: 'o', subTypeConstructor: KalturaBulkUploadJobData, subType: 'KalturaBulkUploadJobData' },
            bulkUploadCategoryUserData: { type: 'o', subTypeConstructor: KalturaBulkUploadCategoryUserData, subType: 'KalturaBulkUploadCategoryUserData' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryUser' action 'copyFromCategory'.
 *
 * Usage: Copy all memeber from parent category
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class CategoryUserCopyFromCategoryAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryuser' },
            action: { type: 'c', default: 'copyFromCategory' },
            categoryId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryUser' action 'deactivate'.
 *
 * Usage: reject CategoryUser
 *
 * Server response type:         KalturaCategoryUser
 * Server failure response type: KalturaAPIException
 */
class CategoryUserDeactivateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCategoryUser', responseConstructor: KalturaCategoryUser });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryuser' },
            action: { type: 'c', default: 'deactivate' },
            categoryId: { type: 'n' },
            userId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryUser' action 'delete'.
 *
 * Usage: Delete a CategoryUser
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class CategoryUserDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryuser' },
            action: { type: 'c', default: 'delete' },
            categoryId: { type: 'n' },
            userId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryUser' action 'get'.
 *
 * Usage: Get CategoryUser by id
 *
 * Server response type:         KalturaCategoryUser
 * Server failure response type: KalturaAPIException
 */
class CategoryUserGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCategoryUser', responseConstructor: KalturaCategoryUser });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryuser' },
            action: { type: 'c', default: 'get' },
            categoryId: { type: 'n' },
            userId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryUser' action 'index'.
 *
 * Usage: Index CategoryUser by userid and category id
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class CategoryUserIndexAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
        if (typeof this.shouldUpdate === 'undefined')
            this.shouldUpdate = true;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryuser' },
            action: { type: 'c', default: 'index' },
            userId: { type: 's' },
            categoryId: { type: 'n' },
            shouldUpdate: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryUser' action 'list'.
 *
 * Usage: List all categories
 *
 * Server response type:         KalturaCategoryUserListResponse
 * Server failure response type: KalturaAPIException
 */
class CategoryUserListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCategoryUserListResponse', responseConstructor: KalturaCategoryUserListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryuser' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaCategoryUserFilter, subType: 'KalturaCategoryUserFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'categoryUser' action 'update'.
 *
 * Usage: Update CategoryUser by id
 *
 * Server response type:         KalturaCategoryUser
 * Server failure response type: KalturaAPIException
 */
class CategoryUserUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCategoryUser', responseConstructor: KalturaCategoryUser });
        if (typeof this.override === 'undefined')
            this.override = false;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'categoryuser' },
            action: { type: 'c', default: 'update' },
            categoryId: { type: 'n' },
            userId: { type: 's' },
            categoryUser: { type: 'o', subTypeConstructor: KalturaCategoryUser, subType: 'KalturaCategoryUser' },
            override: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'conversionProfileAssetParams' action 'list'.
 *
 * Usage: Lists asset parmas of conversion profile by ID
 *
 * Server response type:         KalturaConversionProfileAssetParamsListResponse
 * Server failure response type: KalturaAPIException
 */
class ConversionProfileAssetParamsListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaConversionProfileAssetParamsListResponse', responseConstructor: KalturaConversionProfileAssetParamsListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'conversionprofileassetparams' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaConversionProfileAssetParamsFilter, subType: 'KalturaConversionProfileAssetParamsFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'conversionProfileAssetParams' action 'update'.
 *
 * Usage: Update asset parmas of conversion profile by ID
 *
 * Server response type:         KalturaConversionProfileAssetParams
 * Server failure response type: KalturaAPIException
 */
class ConversionProfileAssetParamsUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaConversionProfileAssetParams', responseConstructor: KalturaConversionProfileAssetParams });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'conversionprofileassetparams' },
            action: { type: 'c', default: 'update' },
            conversionProfileId: { type: 'n' },
            assetParamsId: { type: 'n' },
            conversionProfileAssetParams: { type: 'o', subTypeConstructor: KalturaConversionProfileAssetParams, subType: 'KalturaConversionProfileAssetParams' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'conversionProfile' action 'add'.
 *
 * Usage: Add new Conversion Profile
 *
 * Server response type:         KalturaConversionProfile
 * Server failure response type: KalturaAPIException
 */
class ConversionProfileAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaConversionProfile', responseConstructor: KalturaConversionProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'conversionprofile' },
            action: { type: 'c', default: 'add' },
            conversionProfile: { type: 'o', subTypeConstructor: KalturaConversionProfile, subType: 'KalturaConversionProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'conversionProfile' action 'delete'.
 *
 * Usage: Delete Conversion Profile by ID
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class ConversionProfileDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'conversionprofile' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'conversionProfile' action 'get'.
 *
 * Usage: Get Conversion Profile by ID
 *
 * Server response type:         KalturaConversionProfile
 * Server failure response type: KalturaAPIException
 */
class ConversionProfileGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaConversionProfile', responseConstructor: KalturaConversionProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'conversionprofile' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'conversionProfile' action 'getDefault'.
 *
 * Usage: Get the partner's default conversion profile
 *
 * Server response type:         KalturaConversionProfile
 * Server failure response type: KalturaAPIException
 */
class ConversionProfileGetDefaultAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaConversionProfile', responseConstructor: KalturaConversionProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'conversionprofile' },
            action: { type: 'c', default: 'getDefault' },
            type: { type: 'es', subTypeConstructor: KalturaConversionProfileType, subType: 'KalturaConversionProfileType' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'conversionProfile' action 'list'.
 *
 * Usage: List Conversion Profiles by filter with paging support
 *
 * Server response type:         KalturaConversionProfileListResponse
 * Server failure response type: KalturaAPIException
 */
class ConversionProfileListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaConversionProfileListResponse', responseConstructor: KalturaConversionProfileListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'conversionprofile' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaConversionProfileFilter, subType: 'KalturaConversionProfileFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'conversionProfile' action 'setAsDefault'.
 *
 * Usage: Set Conversion Profile to be the partner default
 *
 * Server response type:         KalturaConversionProfile
 * Server failure response type: KalturaAPIException
 */
class ConversionProfileSetAsDefaultAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaConversionProfile', responseConstructor: KalturaConversionProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'conversionprofile' },
            action: { type: 'c', default: 'setAsDefault' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'conversionProfile' action 'update'.
 *
 * Usage: Update Conversion Profile by ID
 *
 * Server response type:         KalturaConversionProfile
 * Server failure response type: KalturaAPIException
 */
class ConversionProfileUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaConversionProfile', responseConstructor: KalturaConversionProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'conversionprofile' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            conversionProfile: { type: 'o', subTypeConstructor: KalturaConversionProfile, subType: 'KalturaConversionProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'data' action 'add'.
 *
 * Usage: Adds a new data entry
 *
 * Server response type:         KalturaDataEntry
 * Server failure response type: KalturaAPIException
 */
class DataAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDataEntry', responseConstructor: KalturaDataEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'data' },
            action: { type: 'c', default: 'add' },
            dataEntry: { type: 'o', subTypeConstructor: KalturaDataEntry, subType: 'KalturaDataEntry' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'data' action 'addContent'.
 *
 * Usage: Update the dataContent of data entry using a resource
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class DataAddContentAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'data' },
            action: { type: 'c', default: 'addContent' },
            entryId: { type: 's' },
            resource: { type: 'o', subTypeConstructor: KalturaGenericDataCenterContentResource, subType: 'KalturaGenericDataCenterContentResource' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'data' action 'delete'.
 *
 * Usage: Delete a data entry
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class DataDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'data' },
            action: { type: 'c', default: 'delete' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'data' action 'get'.
 *
 * Usage: Get data entry by ID
 *
 * Server response type:         KalturaDataEntry
 * Server failure response type: KalturaAPIException
 */
class DataGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDataEntry', responseConstructor: KalturaDataEntry });
        if (typeof this.version === 'undefined')
            this.version = -1;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'data' },
            action: { type: 'c', default: 'get' },
            entryId: { type: 's' },
            version: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'data' action 'list'.
 *
 * Usage: List data entries by filter with paging support
 *
 * Server response type:         KalturaDataListResponse
 * Server failure response type: KalturaAPIException
 */
class DataListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDataListResponse', responseConstructor: KalturaDataListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'data' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaDataEntryFilter, subType: 'KalturaDataEntryFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'data' action 'serve'.
 *
 * Usage: serve action returan the file from dataContent field
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class DataServeAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
        if (typeof this.version === 'undefined')
            this.version = -1;
        if (typeof this.forceProxy === 'undefined')
            this.forceProxy = false;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'data' },
            action: { type: 'c', default: 'serve' },
            entryId: { type: 's' },
            version: { type: 'n' },
            forceProxy: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'data' action 'update'.
 *
 * Usage: Update data entry. Only the properties that were set will be updated
 *
 * Server response type:         KalturaDataEntry
 * Server failure response type: KalturaAPIException
 */
class DataUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDataEntry', responseConstructor: KalturaDataEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'data' },
            action: { type: 'c', default: 'update' },
            entryId: { type: 's' },
            documentEntry: { type: 'o', subTypeConstructor: KalturaDataEntry, subType: 'KalturaDataEntry' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'deliveryProfile' action 'add'.
 *
 * Usage: Add new delivery
 *
 * Server response type:         KalturaDeliveryProfile
 * Server failure response type: KalturaAPIException
 */
class DeliveryProfileAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDeliveryProfile', responseConstructor: KalturaDeliveryProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'deliveryprofile' },
            action: { type: 'c', default: 'add' },
            delivery: { type: 'o', subTypeConstructor: KalturaDeliveryProfile, subType: 'KalturaDeliveryProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'deliveryProfile' action 'clone'.
 *
 * Usage: Add delivery based on existing delivery.
 * Must provide valid sourceDeliveryId
 *
 * Server response type:         KalturaDeliveryProfile
 * Server failure response type: KalturaAPIException
 */
class DeliveryProfileCloneAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDeliveryProfile', responseConstructor: KalturaDeliveryProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'deliveryprofile' },
            action: { type: 'c', default: 'clone' },
            deliveryId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'deliveryProfile' action 'get'.
 *
 * Usage: Get delivery by id
 *
 * Server response type:         KalturaDeliveryProfile
 * Server failure response type: KalturaAPIException
 */
class DeliveryProfileGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDeliveryProfile', responseConstructor: KalturaDeliveryProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'deliveryprofile' },
            action: { type: 'c', default: 'get' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'deliveryProfile' action 'list'.
 *
 * Usage: Retrieve a list of available delivery depends on the filter given
 *
 * Server response type:         KalturaDeliveryProfileListResponse
 * Server failure response type: KalturaAPIException
 */
class DeliveryProfileListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDeliveryProfileListResponse', responseConstructor: KalturaDeliveryProfileListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'deliveryprofile' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaDeliveryProfileFilter, subType: 'KalturaDeliveryProfileFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'deliveryProfile' action 'update'.
 *
 * Usage: Update exisiting delivery
 *
 * Server response type:         KalturaDeliveryProfile
 * Server failure response type: KalturaAPIException
 */
class DeliveryProfileUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDeliveryProfile', responseConstructor: KalturaDeliveryProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'deliveryprofile' },
            action: { type: 'c', default: 'update' },
            id: { type: 's' },
            delivery: { type: 'o', subTypeConstructor: KalturaDeliveryProfile, subType: 'KalturaDeliveryProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'EmailIngestionProfile' action 'add'.
 *
 * Usage: EmailIngestionProfile Add action allows you to add a EmailIngestionProfile to Kaltura DB
 *
 * Server response type:         KalturaEmailIngestionProfile
 * Server failure response type: KalturaAPIException
 */
class EmailIngestionProfileAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEmailIngestionProfile', responseConstructor: KalturaEmailIngestionProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'emailingestionprofile' },
            action: { type: 'c', default: 'add' },
            EmailIP: { type: 'o', subTypeConstructor: KalturaEmailIngestionProfile, subType: 'KalturaEmailIngestionProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'EmailIngestionProfile' action 'addMediaEntry'.
 *
 * Usage: add KalturaMediaEntry from email ingestion
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class EmailIngestionProfileAddMediaEntryAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'emailingestionprofile' },
            action: { type: 'c', default: 'addMediaEntry' },
            mediaEntry: { type: 'o', subTypeConstructor: KalturaMediaEntry, subType: 'KalturaMediaEntry' },
            uploadTokenId: { type: 's' },
            emailProfId: { type: 'n' },
            fromAddress: { type: 's' },
            emailMsgId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'EmailIngestionProfile' action 'delete'.
 *
 * Usage: Delete an existing EmailIngestionProfile
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class EmailIngestionProfileDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'emailingestionprofile' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'EmailIngestionProfile' action 'get'.
 *
 * Usage: Retrieve a EmailIngestionProfile by id
 *
 * Server response type:         KalturaEmailIngestionProfile
 * Server failure response type: KalturaAPIException
 */
class EmailIngestionProfileGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEmailIngestionProfile', responseConstructor: KalturaEmailIngestionProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'emailingestionprofile' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'EmailIngestionProfile' action 'getByEmailAddress'.
 *
 * Usage: Retrieve a EmailIngestionProfile by email address
 *
 * Server response type:         KalturaEmailIngestionProfile
 * Server failure response type: KalturaAPIException
 */
class EmailIngestionProfileGetByEmailAddressAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEmailIngestionProfile', responseConstructor: KalturaEmailIngestionProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'emailingestionprofile' },
            action: { type: 'c', default: 'getByEmailAddress' },
            emailAddress: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'EmailIngestionProfile' action 'update'.
 *
 * Usage: Update an existing EmailIngestionProfile
 *
 * Server response type:         KalturaEmailIngestionProfile
 * Server failure response type: KalturaAPIException
 */
class EmailIngestionProfileUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEmailIngestionProfile', responseConstructor: KalturaEmailIngestionProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'emailingestionprofile' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            EmailIP: { type: 'o', subTypeConstructor: KalturaEmailIngestionProfile, subType: 'KalturaEmailIngestionProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryServerNode' action 'get'.
 *
 *
 *
 * Server response type:         KalturaEntryServerNode
 * Server failure response type: KalturaAPIException
 */
class EntryServerNodeGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEntryServerNode', responseConstructor: KalturaEntryServerNode });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'entryservernode' },
            action: { type: 'c', default: 'get' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryServerNode' action 'list'.
 *
 *
 *
 * Server response type:         KalturaEntryServerNodeListResponse
 * Server failure response type: KalturaAPIException
 */
class EntryServerNodeListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEntryServerNodeListResponse', responseConstructor: KalturaEntryServerNodeListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'entryservernode' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaEntryServerNodeFilter, subType: 'KalturaEntryServerNodeFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryServerNode' action 'update'.
 *
 *
 *
 * Server response type:         KalturaEntryServerNode
 * Server failure response type: KalturaAPIException
 */
class EntryServerNodeUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEntryServerNode', responseConstructor: KalturaEntryServerNode });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'entryservernode' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            entryServerNode: { type: 'o', subTypeConstructor: KalturaEntryServerNode, subType: 'KalturaEntryServerNode' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryServerNode' action 'updateStatus'.
 *
 *
 *
 * Server response type:         KalturaEntryServerNode
 * Server failure response type: KalturaAPIException
 */
class EntryServerNodeUpdateStatusAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEntryServerNode', responseConstructor: KalturaEntryServerNode });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'entryservernode' },
            action: { type: 'c', default: 'updateStatus' },
            id: { type: 's' },
            status: { type: 'en', subTypeConstructor: KalturaEntryServerNodeStatus, subType: 'KalturaEntryServerNodeStatus' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryServerNode' action 'validateRegisteredEntryServerNode'.
 *
 * Usage: Validates server node still registered on entry
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class EntryServerNodeValidateRegisteredEntryServerNodeAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'entryservernode' },
            action: { type: 'c', default: 'validateRegisteredEntryServerNode' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'fileAsset' action 'add'.
 *
 * Usage: Add new file asset
 *
 * Server response type:         KalturaFileAsset
 * Server failure response type: KalturaAPIException
 */
class FileAssetAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFileAsset', responseConstructor: KalturaFileAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'fileasset' },
            action: { type: 'c', default: 'add' },
            fileAsset: { type: 'o', subTypeConstructor: KalturaFileAsset, subType: 'KalturaFileAsset' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'fileAsset' action 'delete'.
 *
 * Usage: Delete file asset by id
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class FileAssetDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'fileasset' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'fileAsset' action 'get'.
 *
 * Usage: Get file asset by id
 *
 * Server response type:         KalturaFileAsset
 * Server failure response type: KalturaAPIException
 */
class FileAssetGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFileAsset', responseConstructor: KalturaFileAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'fileasset' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'fileAsset' action 'list'.
 *
 * Usage: List file assets by filter and pager
 *
 * Server response type:         KalturaFileAssetListResponse
 * Server failure response type: KalturaAPIException
 */
class FileAssetListAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFileAssetListResponse', responseConstructor: KalturaFileAssetListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'fileasset' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaFileAssetFilter, subType: 'KalturaFileAssetFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'fileAsset' action 'serve'.
 *
 * Usage: Serve file asset by id
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class FileAssetServeAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'fileasset' },
            action: { type: 'c', default: 'serve' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'fileAsset' action 'setContent'.
 *
 * Usage: Set content of file asset
 *
 * Server response type:         KalturaFileAsset
 * Server failure response type: KalturaAPIException
 */
class FileAssetSetContentAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFileAsset', responseConstructor: KalturaFileAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'fileasset' },
            action: { type: 'c', default: 'setContent' },
            id: { type: 'n' },
            contentResource: { type: 'o', subTypeConstructor: KalturaContentResource, subType: 'KalturaContentResource' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'fileAsset' action 'update'.
 *
 * Usage: Update file asset by id
 *
 * Server response type:         KalturaFileAsset
 * Server failure response type: KalturaAPIException
 */
class FileAssetUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFileAsset', responseConstructor: KalturaFileAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'fileasset' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            fileAsset: { type: 'o', subTypeConstructor: KalturaFileAsset, subType: 'KalturaFileAsset' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'add'.
 *
 * Usage: Add flavor asset
 *
 * Server response type:         KalturaFlavorAsset
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFlavorAsset', responseConstructor: KalturaFlavorAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'add' },
            entryId: { type: 's' },
            flavorAsset: { type: 'o', subTypeConstructor: KalturaFlavorAsset, subType: 'KalturaFlavorAsset' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'convert'.
 *
 * Usage: Add and convert new Flavor Asset for Entry with specific Flavor Params
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetConvertAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'convert' },
            entryId: { type: 's' },
            flavorParamsId: { type: 'n' },
            priority: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'delete'.
 *
 * Usage: Delete Flavor Asset by ID
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'delete' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'deleteLocalContent'.
 *
 * Usage: delete all local file syncs for this asset
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetDeleteLocalContentAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'deleteLocalContent' },
            assetId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'export'.
 *
 * Usage: manually export an asset
 *
 * Server response type:         KalturaFlavorAsset
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetExportAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFlavorAsset', responseConstructor: KalturaFlavorAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'export' },
            assetId: { type: 's' },
            storageProfileId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'get'.
 *
 * Usage: Get Flavor Asset by ID
 *
 * Server response type:         KalturaFlavorAsset
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFlavorAsset', responseConstructor: KalturaFlavorAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'get' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'getByEntryId'.
 *
 * Usage: Get Flavor Assets for Entry
 *
 * Server response type:         KalturaFlavorAsset[]
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetGetByEntryIdAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaFlavorAsset', responseConstructor: KalturaFlavorAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'getByEntryId' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'getDownloadUrl'.
 *
 * Usage: Get download URL for the Flavor Asset
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetGetDownloadUrlAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
        if (typeof this.useCdn === 'undefined')
            this.useCdn = false;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'getDownloadUrl' },
            id: { type: 's' },
            useCdn: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'getFlavorAssetsWithParams'.
 *
 * Usage: Get Flavor Asset with the relevant Flavor Params (Flavor Params can exist without Flavor Asset & vice versa)
 *
 * Server response type:         KalturaFlavorAssetWithParams[]
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetGetFlavorAssetsWithParamsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaFlavorAssetWithParams', responseConstructor: KalturaFlavorAssetWithParams });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'getFlavorAssetsWithParams' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'getRemotePaths'.
 *
 * Usage: Get remote storage existing paths for the asset
 *
 * Server response type:         KalturaRemotePathListResponse
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetGetRemotePathsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaRemotePathListResponse', responseConstructor: KalturaRemotePathListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'getRemotePaths' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'getUrl'.
 *
 * Usage: Get download URL for the asset
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetGetUrlAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
        if (typeof this.forceProxy === 'undefined')
            this.forceProxy = false;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'getUrl' },
            id: { type: 's' },
            storageId: { type: 'n' },
            forceProxy: { type: 'b' },
            options: { type: 'o', subTypeConstructor: KalturaFlavorAssetUrlOptions, subType: 'KalturaFlavorAssetUrlOptions' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'getVolumeMap'.
 *
 * Usage: Get volume map by entry id
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetGetVolumeMapAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'getVolumeMap' },
            flavorId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'getWebPlayableByEntryId'.
 *
 * Usage: Get web playable Flavor Assets for Entry
 *
 * Server response type:         KalturaFlavorAsset[]
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetGetWebPlayableByEntryIdAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaFlavorAsset', responseConstructor: KalturaFlavorAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'getWebPlayableByEntryId' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'list'.
 *
 * Usage: List Flavor Assets by filter and pager
 *
 * Server response type:         KalturaFlavorAssetListResponse
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFlavorAssetListResponse', responseConstructor: KalturaFlavorAssetListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaAssetFilter, subType: 'KalturaAssetFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'reconvert'.
 *
 * Usage: Reconvert Flavor Asset by ID
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetReconvertAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'reconvert' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'serveAdStitchCmd'.
 *
 * Usage: serve cmd line to transcode the ad
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetServeAdStitchCmdAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'serveAdStitchCmd' },
            assetId: { type: 's' },
            ffprobeJson: { type: 's' },
            duration: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'setAsSource'.
 *
 * Usage: Set a given flavor as the original flavor
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetSetAsSourceAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'setAsSource' },
            assetId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'setContent'.
 *
 * Usage: Update content of flavor asset
 *
 * Server response type:         KalturaFlavorAsset
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetSetContentAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFlavorAsset', responseConstructor: KalturaFlavorAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'setContent' },
            id: { type: 's' },
            contentResource: { type: 'o', subTypeConstructor: KalturaContentResource, subType: 'KalturaContentResource' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorAsset' action 'update'.
 *
 * Usage: Update flavor asset
 *
 * Server response type:         KalturaFlavorAsset
 * Server failure response type: KalturaAPIException
 */
class FlavorAssetUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFlavorAsset', responseConstructor: KalturaFlavorAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorasset' },
            action: { type: 'c', default: 'update' },
            id: { type: 's' },
            flavorAsset: { type: 'o', subTypeConstructor: KalturaFlavorAsset, subType: 'KalturaFlavorAsset' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorParamsOutput' action 'get'.
 *
 * Usage: Get flavor params output object by ID
 *
 * Server response type:         KalturaFlavorParamsOutput
 * Server failure response type: KalturaAPIException
 */
class FlavorParamsOutputGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFlavorParamsOutput', responseConstructor: KalturaFlavorParamsOutput });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorparamsoutput' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorParamsOutput' action 'list'.
 *
 * Usage: List flavor params output objects by filter and pager
 *
 * Server response type:         KalturaFlavorParamsOutputListResponse
 * Server failure response type: KalturaAPIException
 */
class FlavorParamsOutputListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFlavorParamsOutputListResponse', responseConstructor: KalturaFlavorParamsOutputListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorparamsoutput' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaFlavorParamsOutputFilter, subType: 'KalturaFlavorParamsOutputFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorParams' action 'add'.
 *
 * Usage: Add new Flavor Params
 *
 * Server response type:         KalturaFlavorParams
 * Server failure response type: KalturaAPIException
 */
class FlavorParamsAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFlavorParams', responseConstructor: KalturaFlavorParams });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorparams' },
            action: { type: 'c', default: 'add' },
            flavorParams: { type: 'o', subTypeConstructor: KalturaFlavorParams, subType: 'KalturaFlavorParams' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorParams' action 'delete'.
 *
 * Usage: Delete Flavor Params by ID
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class FlavorParamsDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorparams' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorParams' action 'get'.
 *
 * Usage: Get Flavor Params by ID
 *
 * Server response type:         KalturaFlavorParams
 * Server failure response type: KalturaAPIException
 */
class FlavorParamsGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFlavorParams', responseConstructor: KalturaFlavorParams });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorparams' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorParams' action 'getByConversionProfileId'.
 *
 * Usage: Get Flavor Params by Conversion Profile ID
 *
 * Server response type:         KalturaFlavorParams[]
 * Server failure response type: KalturaAPIException
 */
class FlavorParamsGetByConversionProfileIdAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaFlavorParams', responseConstructor: KalturaFlavorParams });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorparams' },
            action: { type: 'c', default: 'getByConversionProfileId' },
            conversionProfileId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorParams' action 'list'.
 *
 * Usage: List Flavor Params by filter with paging support (By default - all system default params will be listed too)
 *
 * Server response type:         KalturaFlavorParamsListResponse
 * Server failure response type: KalturaAPIException
 */
class FlavorParamsListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFlavorParamsListResponse', responseConstructor: KalturaFlavorParamsListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorparams' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaFlavorParamsFilter, subType: 'KalturaFlavorParamsFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'flavorParams' action 'update'.
 *
 * Usage: Update Flavor Params by ID
 *
 * Server response type:         KalturaFlavorParams
 * Server failure response type: KalturaAPIException
 */
class FlavorParamsUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFlavorParams', responseConstructor: KalturaFlavorParams });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'flavorparams' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            flavorParams: { type: 'o', subTypeConstructor: KalturaFlavorParams, subType: 'KalturaFlavorParams' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'groupUser' action 'add'.
 *
 * Usage: Add new GroupUser
 *
 * Server response type:         KalturaGroupUser
 * Server failure response type: KalturaAPIException
 */
class GroupUserAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGroupUser', responseConstructor: KalturaGroupUser });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'groupuser' },
            action: { type: 'c', default: 'add' },
            groupUser: { type: 'o', subTypeConstructor: KalturaGroupUser, subType: 'KalturaGroupUser' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'groupUser' action 'delete'.
 *
 * Usage: delete by userId and groupId
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class GroupUserDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'groupuser' },
            action: { type: 'c', default: 'delete' },
            userId: { type: 's' },
            groupId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'groupUser' action 'list'.
 *
 * Usage: List all GroupUsers
 *
 * Server response type:         KalturaGroupUserListResponse
 * Server failure response type: KalturaAPIException
 */
class GroupUserListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGroupUserListResponse', responseConstructor: KalturaGroupUserListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'groupuser' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaGroupUserFilter, subType: 'KalturaGroupUserFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'groupUser' action 'sync'.
 *
 * Usage: sync by userId and groupIds
 *
 * Server response type:         KalturaBulkUpload
 * Server failure response type: KalturaAPIException
 */
class GroupUserSyncAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBulkUpload', responseConstructor: KalturaBulkUpload });
        if (typeof this.removeFromExistingGroups === 'undefined')
            this.removeFromExistingGroups = true;
        if (typeof this.createNewGroups === 'undefined')
            this.createNewGroups = true;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'groupuser' },
            action: { type: 'c', default: 'sync' },
            userId: { type: 's' },
            groupIds: { type: 's' },
            removeFromExistingGroups: { type: 'b' },
            createNewGroups: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveChannelSegment' action 'add'.
 *
 * Usage: Add new live channel segment
 *
 * Server response type:         KalturaLiveChannelSegment
 * Server failure response type: KalturaAPIException
 */
class LiveChannelSegmentAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveChannelSegment', responseConstructor: KalturaLiveChannelSegment });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livechannelsegment' },
            action: { type: 'c', default: 'add' },
            liveChannelSegment: { type: 'o', subTypeConstructor: KalturaLiveChannelSegment, subType: 'KalturaLiveChannelSegment' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveChannelSegment' action 'delete'.
 *
 * Usage: Delete live channel segment by id
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class LiveChannelSegmentDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livechannelsegment' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveChannelSegment' action 'get'.
 *
 * Usage: Get live channel segment by id
 *
 * Server response type:         KalturaLiveChannelSegment
 * Server failure response type: KalturaAPIException
 */
class LiveChannelSegmentGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveChannelSegment', responseConstructor: KalturaLiveChannelSegment });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livechannelsegment' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveChannelSegment' action 'list'.
 *
 * Usage: List live channel segments by filter and pager
 *
 * Server response type:         KalturaLiveChannelSegmentListResponse
 * Server failure response type: KalturaAPIException
 */
class LiveChannelSegmentListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveChannelSegmentListResponse', responseConstructor: KalturaLiveChannelSegmentListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livechannelsegment' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaLiveChannelSegmentFilter, subType: 'KalturaLiveChannelSegmentFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveChannelSegment' action 'update'.
 *
 * Usage: Update live channel segment by id
 *
 * Server response type:         KalturaLiveChannelSegment
 * Server failure response type: KalturaAPIException
 */
class LiveChannelSegmentUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveChannelSegment', responseConstructor: KalturaLiveChannelSegment });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livechannelsegment' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            liveChannelSegment: { type: 'o', subTypeConstructor: KalturaLiveChannelSegment, subType: 'KalturaLiveChannelSegment' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveChannel' action 'add'.
 *
 * Usage: Adds new live channel
 *
 * Server response type:         KalturaLiveChannel
 * Server failure response type: KalturaAPIException
 */
class LiveChannelAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveChannel', responseConstructor: KalturaLiveChannel });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livechannel' },
            action: { type: 'c', default: 'add' },
            liveChannel: { type: 'o', subTypeConstructor: KalturaLiveChannel, subType: 'KalturaLiveChannel' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveChannel' action 'appendRecording'.
 *
 * Usage: Append recorded video to live entry
 *
 * Server response type:         KalturaLiveEntry
 * Server failure response type: KalturaAPIException
 */
class LiveChannelAppendRecordingAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveEntry', responseConstructor: KalturaLiveEntry });
        if (typeof this.isLastChunk === 'undefined')
            this.isLastChunk = false;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livechannel' },
            action: { type: 'c', default: 'appendRecording' },
            entryId: { type: 's' },
            assetId: { type: 's' },
            mediaServerIndex: { type: 'es', subTypeConstructor: KalturaEntryServerNodeType, subType: 'KalturaEntryServerNodeType' },
            resource: { type: 'o', subTypeConstructor: KalturaDataCenterContentResource, subType: 'KalturaDataCenterContentResource' },
            duration: { type: 'n' },
            isLastChunk: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveChannel' action 'createRecordedEntry'.
 *
 * Usage: Create recorded entry id if it doesn't exist and make sure it happens on the DC that the live entry was created on
 *
 * Server response type:         KalturaLiveEntry
 * Server failure response type: KalturaAPIException
 */
class LiveChannelCreateRecordedEntryAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveEntry', responseConstructor: KalturaLiveEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livechannel' },
            action: { type: 'c', default: 'createRecordedEntry' },
            entryId: { type: 's' },
            mediaServerIndex: { type: 'es', subTypeConstructor: KalturaEntryServerNodeType, subType: 'KalturaEntryServerNodeType' },
            liveEntryStatus: { type: 'en', subTypeConstructor: KalturaEntryServerNodeStatus, subType: 'KalturaEntryServerNodeStatus' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveChannel' action 'delete'.
 *
 * Usage: Delete a live channel
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class LiveChannelDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livechannel' },
            action: { type: 'c', default: 'delete' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveChannel' action 'get'.
 *
 * Usage: Get live channel by ID
 *
 * Server response type:         KalturaLiveChannel
 * Server failure response type: KalturaAPIException
 */
class LiveChannelGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveChannel', responseConstructor: KalturaLiveChannel });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livechannel' },
            action: { type: 'c', default: 'get' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveChannel' action 'isLive'.
 *
 * Usage: Delivering the status of a live channel (on-air/offline)
 *
 * Server response type:         boolean
 * Server failure response type: KalturaAPIException
 */
class LiveChannelIsLiveAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'b', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livechannel' },
            action: { type: 'c', default: 'isLive' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveChannel' action 'list'.
 *
 * Usage: List live channels by filter with paging support
 *
 * Server response type:         KalturaLiveChannelListResponse
 * Server failure response type: KalturaAPIException
 */
class LiveChannelListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveChannelListResponse', responseConstructor: KalturaLiveChannelListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livechannel' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaLiveChannelFilter, subType: 'KalturaLiveChannelFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveChannel' action 'registerMediaServer'.
 *
 * Usage: Register media server to live entry
 *
 * Server response type:         KalturaLiveEntry
 * Server failure response type: KalturaAPIException
 */
class LiveChannelRegisterMediaServerAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveEntry', responseConstructor: KalturaLiveEntry });
        if (typeof this.liveEntryStatus === 'undefined')
            this.liveEntryStatus = 1;
        if (typeof this.shouldCreateRecordedEntry === 'undefined')
            this.shouldCreateRecordedEntry = true;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livechannel' },
            action: { type: 'c', default: 'registerMediaServer' },
            entryId: { type: 's' },
            hostname: { type: 's' },
            mediaServerIndex: { type: 'es', subTypeConstructor: KalturaEntryServerNodeType, subType: 'KalturaEntryServerNodeType' },
            applicationName: { type: 's' },
            liveEntryStatus: { type: 'en', subTypeConstructor: KalturaEntryServerNodeStatus, subType: 'KalturaEntryServerNodeStatus' },
            shouldCreateRecordedEntry: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveChannel' action 'setRecordedContent'.
 *
 * Usage: Set recorded video to live entry
 *
 * Server response type:         KalturaLiveEntry
 * Server failure response type: KalturaAPIException
 */
class LiveChannelSetRecordedContentAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveEntry', responseConstructor: KalturaLiveEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livechannel' },
            action: { type: 'c', default: 'setRecordedContent' },
            entryId: { type: 's' },
            mediaServerIndex: { type: 'es', subTypeConstructor: KalturaEntryServerNodeType, subType: 'KalturaEntryServerNodeType' },
            resource: { type: 'o', subTypeConstructor: KalturaDataCenterContentResource, subType: 'KalturaDataCenterContentResource' },
            duration: { type: 'n' },
            recordedEntryId: { type: 's' },
            flavorParamsId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveChannel' action 'unregisterMediaServer'.
 *
 * Usage: Unregister media server from live entry
 *
 * Server response type:         KalturaLiveEntry
 * Server failure response type: KalturaAPIException
 */
class LiveChannelUnregisterMediaServerAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveEntry', responseConstructor: KalturaLiveEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livechannel' },
            action: { type: 'c', default: 'unregisterMediaServer' },
            entryId: { type: 's' },
            hostname: { type: 's' },
            mediaServerIndex: { type: 'es', subTypeConstructor: KalturaEntryServerNodeType, subType: 'KalturaEntryServerNodeType' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveChannel' action 'update'.
 *
 * Usage: Update live channel. Only the properties that were set will be updated
 *
 * Server response type:         KalturaLiveChannel
 * Server failure response type: KalturaAPIException
 */
class LiveChannelUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveChannel', responseConstructor: KalturaLiveChannel });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livechannel' },
            action: { type: 'c', default: 'update' },
            id: { type: 's' },
            liveChannel: { type: 'o', subTypeConstructor: KalturaLiveChannel, subType: 'KalturaLiveChannel' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveChannel' action 'validateRegisteredMediaServers'.
 *
 * Usage: Validates all registered media servers
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class LiveChannelValidateRegisteredMediaServersAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livechannel' },
            action: { type: 'c', default: 'validateRegisteredMediaServers' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveReports' action 'exportToCsv'.
 *
 *
 *
 * Server response type:         KalturaLiveReportExportResponse
 * Server failure response type: KalturaAPIException
 */
class LiveReportsExportToCsvAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveReportExportResponse', responseConstructor: KalturaLiveReportExportResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livereports' },
            action: { type: 'c', default: 'exportToCsv' },
            reportType: { type: 'en', subTypeConstructor: KalturaLiveReportExportType, subType: 'KalturaLiveReportExportType' },
            params: { type: 'o', subTypeConstructor: KalturaLiveReportExportParams, subType: 'KalturaLiveReportExportParams' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveReports' action 'getEvents'.
 *
 *
 *
 * Server response type:         KalturaReportGraph[]
 * Server failure response type: KalturaAPIException
 */
class LiveReportsGetEventsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaReportGraph', responseConstructor: KalturaReportGraph });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livereports' },
            action: { type: 'c', default: 'getEvents' },
            reportType: { type: 'es', subTypeConstructor: KalturaLiveReportType, subType: 'KalturaLiveReportType' },
            filter: { type: 'o', subTypeConstructor: KalturaLiveReportInputFilter, subType: 'KalturaLiveReportInputFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveReports' action 'getReport'.
 *
 *
 *
 * Server response type:         KalturaLiveStatsListResponse
 * Server failure response type: KalturaAPIException
 */
class LiveReportsGetReportAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveStatsListResponse', responseConstructor: KalturaLiveStatsListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livereports' },
            action: { type: 'c', default: 'getReport' },
            reportType: { type: 'es', subTypeConstructor: KalturaLiveReportType, subType: 'KalturaLiveReportType' },
            filter: { type: 'o', subTypeConstructor: KalturaLiveReportInputFilter, subType: 'KalturaLiveReportInputFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveReports' action 'serveReport'.
 *
 * Usage: Will serve a requested report
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class LiveReportsServeReportAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livereports' },
            action: { type: 'c', default: 'serveReport' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStats' action 'collect'.
 *
 * Usage: Will write to the event log a single line representing the event
 * KalturaStatsEvent $event
 *
 * Server response type:         boolean
 * Server failure response type: KalturaAPIException
 */
class LiveStatsCollectAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'b', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestats' },
            action: { type: 'c', default: 'collect' },
            event: { type: 'o', subTypeConstructor: KalturaLiveStatsEvent, subType: 'KalturaLiveStatsEvent' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'add'.
 *
 * Usage: Adds new live stream entry.
 * The entry will be queued for provision
 *
 * Server response type:         KalturaLiveStreamEntry
 * Server failure response type: KalturaAPIException
 */
class LiveStreamAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveStreamEntry', responseConstructor: KalturaLiveStreamEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'add' },
            liveStreamEntry: { type: 'o', subTypeConstructor: KalturaLiveStreamEntry, subType: 'KalturaLiveStreamEntry' },
            sourceType: { type: 'es', subTypeConstructor: KalturaSourceType, subType: 'KalturaSourceType' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'addLiveStreamPushPublishConfiguration'.
 *
 * Usage: Add new pushPublish configuration to entry
 *
 * Server response type:         KalturaLiveStreamEntry
 * Server failure response type: KalturaAPIException
 */
class LiveStreamAddLiveStreamPushPublishConfigurationAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveStreamEntry', responseConstructor: KalturaLiveStreamEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'addLiveStreamPushPublishConfiguration' },
            entryId: { type: 's' },
            protocol: { type: 'es', subTypeConstructor: KalturaPlaybackProtocol, subType: 'KalturaPlaybackProtocol' },
            url: { type: 's' },
            liveStreamConfiguration: { type: 'o', subTypeConstructor: KalturaLiveStreamConfiguration, subType: 'KalturaLiveStreamConfiguration' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'appendRecording'.
 *
 * Usage: Append recorded video to live entry
 *
 * Server response type:         KalturaLiveEntry
 * Server failure response type: KalturaAPIException
 */
class LiveStreamAppendRecordingAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveEntry', responseConstructor: KalturaLiveEntry });
        if (typeof this.isLastChunk === 'undefined')
            this.isLastChunk = false;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'appendRecording' },
            entryId: { type: 's' },
            assetId: { type: 's' },
            mediaServerIndex: { type: 'es', subTypeConstructor: KalturaEntryServerNodeType, subType: 'KalturaEntryServerNodeType' },
            resource: { type: 'o', subTypeConstructor: KalturaDataCenterContentResource, subType: 'KalturaDataCenterContentResource' },
            duration: { type: 'n' },
            isLastChunk: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'authenticate'.
 *
 * Usage: Authenticate live-stream entry against stream token and partner limitations
 *
 * Server response type:         KalturaLiveStreamEntry
 * Server failure response type: KalturaAPIException
 */
class LiveStreamAuthenticateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveStreamEntry', responseConstructor: KalturaLiveStreamEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'authenticate' },
            entryId: { type: 's' },
            token: { type: 's' },
            hostname: { type: 's' },
            mediaServerIndex: { type: 'es', subTypeConstructor: KalturaEntryServerNodeType, subType: 'KalturaEntryServerNodeType' },
            applicationName: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'createPeriodicSyncPoints'.
 *
 * Usage: Creates perioding metadata sync-point events on a live stream
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class LiveStreamCreatePeriodicSyncPointsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'createPeriodicSyncPoints' },
            entryId: { type: 's' },
            interval: { type: 'n' },
            duration: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'createRecordedEntry'.
 *
 * Usage: Create recorded entry id if it doesn't exist and make sure it happens on the DC that the live entry was created on
 *
 * Server response type:         KalturaLiveEntry
 * Server failure response type: KalturaAPIException
 */
class LiveStreamCreateRecordedEntryAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveEntry', responseConstructor: KalturaLiveEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'createRecordedEntry' },
            entryId: { type: 's' },
            mediaServerIndex: { type: 'es', subTypeConstructor: KalturaEntryServerNodeType, subType: 'KalturaEntryServerNodeType' },
            liveEntryStatus: { type: 'en', subTypeConstructor: KalturaEntryServerNodeStatus, subType: 'KalturaEntryServerNodeStatus' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'delete'.
 *
 * Usage: Delete a live stream entry
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class LiveStreamDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'delete' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'get'.
 *
 * Usage: Get live stream entry by ID
 *
 * Server response type:         KalturaLiveStreamEntry
 * Server failure response type: KalturaAPIException
 */
class LiveStreamGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveStreamEntry', responseConstructor: KalturaLiveStreamEntry });
        if (typeof this.version === 'undefined')
            this.version = -1;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'get' },
            entryId: { type: 's' },
            version: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'isLive'.
 *
 * Usage: Delivering the status of a live stream (on-air/offline) if it is possible
 *
 * Server response type:         boolean
 * Server failure response type: KalturaAPIException
 */
class LiveStreamIsLiveAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'b', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'isLive' },
            id: { type: 's' },
            protocol: { type: 'es', subTypeConstructor: KalturaPlaybackProtocol, subType: 'KalturaPlaybackProtocol' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'list'.
 *
 * Usage: List live stream entries by filter with paging support
 *
 * Server response type:         KalturaLiveStreamListResponse
 * Server failure response type: KalturaAPIException
 */
class LiveStreamListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveStreamListResponse', responseConstructor: KalturaLiveStreamListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaLiveStreamEntryFilter, subType: 'KalturaLiveStreamEntryFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'regenerateStreamToken'.
 *
 * Usage: Regenerate new secure token for liveStream
 *
 * Server response type:         KalturaLiveEntry
 * Server failure response type: KalturaAPIException
 */
class LiveStreamRegenerateStreamTokenAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveEntry', responseConstructor: KalturaLiveEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'regenerateStreamToken' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'registerMediaServer'.
 *
 * Usage: Register media server to live entry
 *
 * Server response type:         KalturaLiveEntry
 * Server failure response type: KalturaAPIException
 */
class LiveStreamRegisterMediaServerAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveEntry', responseConstructor: KalturaLiveEntry });
        if (typeof this.liveEntryStatus === 'undefined')
            this.liveEntryStatus = 1;
        if (typeof this.shouldCreateRecordedEntry === 'undefined')
            this.shouldCreateRecordedEntry = true;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'registerMediaServer' },
            entryId: { type: 's' },
            hostname: { type: 's' },
            mediaServerIndex: { type: 'es', subTypeConstructor: KalturaEntryServerNodeType, subType: 'KalturaEntryServerNodeType' },
            applicationName: { type: 's' },
            liveEntryStatus: { type: 'en', subTypeConstructor: KalturaEntryServerNodeStatus, subType: 'KalturaEntryServerNodeStatus' },
            shouldCreateRecordedEntry: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'removeLiveStreamPushPublishConfiguration'.
 *
 * Usage: Remove push publish configuration from entry
 *
 * Server response type:         KalturaLiveStreamEntry
 * Server failure response type: KalturaAPIException
 */
class LiveStreamRemoveLiveStreamPushPublishConfigurationAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveStreamEntry', responseConstructor: KalturaLiveStreamEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'removeLiveStreamPushPublishConfiguration' },
            entryId: { type: 's' },
            protocol: { type: 'es', subTypeConstructor: KalturaPlaybackProtocol, subType: 'KalturaPlaybackProtocol' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'setRecordedContent'.
 *
 * Usage: Set recorded video to live entry
 *
 * Server response type:         KalturaLiveEntry
 * Server failure response type: KalturaAPIException
 */
class LiveStreamSetRecordedContentAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveEntry', responseConstructor: KalturaLiveEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'setRecordedContent' },
            entryId: { type: 's' },
            mediaServerIndex: { type: 'es', subTypeConstructor: KalturaEntryServerNodeType, subType: 'KalturaEntryServerNodeType' },
            resource: { type: 'o', subTypeConstructor: KalturaDataCenterContentResource, subType: 'KalturaDataCenterContentResource' },
            duration: { type: 'n' },
            recordedEntryId: { type: 's' },
            flavorParamsId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'unregisterMediaServer'.
 *
 * Usage: Unregister media server from live entry
 *
 * Server response type:         KalturaLiveEntry
 * Server failure response type: KalturaAPIException
 */
class LiveStreamUnregisterMediaServerAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveEntry', responseConstructor: KalturaLiveEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'unregisterMediaServer' },
            entryId: { type: 's' },
            hostname: { type: 's' },
            mediaServerIndex: { type: 'es', subTypeConstructor: KalturaEntryServerNodeType, subType: 'KalturaEntryServerNodeType' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'update'.
 *
 * Usage: Update live stream entry. Only the properties that were set will be updated
 *
 * Server response type:         KalturaLiveStreamEntry
 * Server failure response type: KalturaAPIException
 */
class LiveStreamUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveStreamEntry', responseConstructor: KalturaLiveStreamEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'update' },
            entryId: { type: 's' },
            liveStreamEntry: { type: 'o', subTypeConstructor: KalturaLiveStreamEntry, subType: 'KalturaLiveStreamEntry' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'updateOfflineThumbnailFromUrl'.
 *
 * Usage: Update entry thumbnail using url
 *
 * Server response type:         KalturaLiveStreamEntry
 * Server failure response type: KalturaAPIException
 */
class LiveStreamUpdateOfflineThumbnailFromUrlAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveStreamEntry', responseConstructor: KalturaLiveStreamEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'updateOfflineThumbnailFromUrl' },
            entryId: { type: 's' },
            url: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'updateOfflineThumbnailJpeg'.
 *
 * Usage: Update live stream entry thumbnail using a raw jpeg file
 *
 * Server response type:         KalturaLiveStreamEntry
 * Server failure response type: KalturaAPIException
 */
class LiveStreamUpdateOfflineThumbnailJpegAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLiveStreamEntry', responseConstructor: KalturaLiveStreamEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'updateOfflineThumbnailJpeg' },
            entryId: { type: 's' },
            fileData: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'liveStream' action 'validateRegisteredMediaServers'.
 *
 * Usage: Validates all registered media servers
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class LiveStreamValidateRegisteredMediaServersAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'livestream' },
            action: { type: 'c', default: 'validateRegisteredMediaServers' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'mediaInfo' action 'list'.
 *
 * Usage: List media info objects by filter and pager
 *
 * Server response type:         KalturaMediaInfoListResponse
 * Server failure response type: KalturaAPIException
 */
class MediaInfoListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaInfoListResponse', responseConstructor: KalturaMediaInfoListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'mediainfo' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaMediaInfoFilter, subType: 'KalturaMediaInfoFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'add'.
 *
 * Usage: Add entry
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class MediaAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'add' },
            entry: { type: 'o', subTypeConstructor: KalturaMediaEntry, subType: 'KalturaMediaEntry' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'addContent'.
 *
 * Usage: Add content to media entry which is not yet associated with content (therefore is in status NO_CONTENT).
 * If the requirement is to replace the entry's associated content, use action updateContent
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class MediaAddContentAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'addContent' },
            entryId: { type: 's' },
            resource: { type: 'o', subTypeConstructor: KalturaResource, subType: 'KalturaResource' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'addFromBulk'.
 *
 * Usage: Adds new media entry by importing an HTTP or FTP URL.
 * The entry will be queued for import and then for conversion.
 * This action should be exposed only to the batches
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class MediaAddFromBulkAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'addFromBulk' },
            mediaEntry: { type: 'o', subTypeConstructor: KalturaMediaEntry, subType: 'KalturaMediaEntry' },
            url: { type: 's' },
            bulkUploadId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'addFromEntry'.
 *
 * Usage: Copy entry into new entry
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class MediaAddFromEntryAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'addFromEntry' },
            sourceEntryId: { type: 's' },
            mediaEntry: { type: 'o', subTypeConstructor: KalturaMediaEntry, subType: 'KalturaMediaEntry' },
            sourceFlavorParamsId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'addFromFlavorAsset'.
 *
 * Usage: Copy flavor asset into new entry
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class MediaAddFromFlavorAssetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'addFromFlavorAsset' },
            sourceFlavorAssetId: { type: 's' },
            mediaEntry: { type: 'o', subTypeConstructor: KalturaMediaEntry, subType: 'KalturaMediaEntry' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'addFromRecordedWebcam'.
 *
 * Usage: Add new entry after the file was recored on the server and the token id exists
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class MediaAddFromRecordedWebcamAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'addFromRecordedWebcam' },
            mediaEntry: { type: 'o', subTypeConstructor: KalturaMediaEntry, subType: 'KalturaMediaEntry' },
            webcamTokenId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'addFromSearchResult'.
 *
 * Usage: Adds new media entry by importing the media file from a search provider.
 * This action should be used with the search service result
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class MediaAddFromSearchResultAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'addFromSearchResult' },
            mediaEntry: { type: 'o', subTypeConstructor: KalturaMediaEntry, subType: 'KalturaMediaEntry' },
            searchResult: { type: 'o', subTypeConstructor: KalturaSearchResult, subType: 'KalturaSearchResult' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'addFromUploadedFile'.
 *
 * Usage: Add new entry after the specific media file was uploaded and the upload token id exists
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class MediaAddFromUploadedFileAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'addFromUploadedFile' },
            mediaEntry: { type: 'o', subTypeConstructor: KalturaMediaEntry, subType: 'KalturaMediaEntry' },
            uploadTokenId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'addFromUrl'.
 *
 * Usage: Adds new media entry by importing an HTTP or FTP URL.
 * The entry will be queued for import and then for conversion
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class MediaAddFromUrlAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'addFromUrl' },
            mediaEntry: { type: 'o', subTypeConstructor: KalturaMediaEntry, subType: 'KalturaMediaEntry' },
            url: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'anonymousRank'.
 *
 * Usage: Anonymously rank a media entry, no validation is done on duplicate rankings
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class MediaAnonymousRankAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'anonymousRank' },
            entryId: { type: 's' },
            rank: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'approve'.
 *
 * Usage: Approve the media entry and mark the pending flags (if any) as moderated (this will make the entry playable)
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class MediaApproveAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'approve' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'approveReplace'.
 *
 * Usage: Approves media replacement
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class MediaApproveReplaceAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'approveReplace' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'bulkUploadAdd'.
 *
 * Usage: Add new bulk upload batch job
 * Conversion profile id can be specified in the API or in the CSV file, the one in the CSV file will be stronger.
 * If no conversion profile was specified, partner's default will be used
 *
 * Server response type:         KalturaBulkUpload
 * Server failure response type: KalturaAPIException
 */
class MediaBulkUploadAddAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBulkUpload', responseConstructor: KalturaBulkUpload });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'bulkUploadAdd' },
            fileData: { type: 'f' },
            bulkUploadData: { type: 'o', subTypeConstructor: KalturaBulkUploadJobData, subType: 'KalturaBulkUploadJobData' },
            bulkUploadEntryData: { type: 'o', subTypeConstructor: KalturaBulkUploadEntryData, subType: 'KalturaBulkUploadEntryData' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'cancelReplace'.
 *
 * Usage: Cancels media replacement
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class MediaCancelReplaceAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'cancelReplace' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'convert'.
 *
 * Usage: Convert entry
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class MediaConvertAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
        if (typeof this.dynamicConversionAttributes === 'undefined')
            this.dynamicConversionAttributes = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'convert' },
            entryId: { type: 's' },
            conversionProfileId: { type: 'n' },
            dynamicConversionAttributes: { type: 'a', subTypeConstructor: KalturaConversionAttribute, subType: 'KalturaConversionAttribute' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'count'.
 *
 * Usage: Count media entries by filter
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class MediaCountAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'count' },
            filter: { type: 'o', subTypeConstructor: KalturaMediaEntryFilter, subType: 'KalturaMediaEntryFilter' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'delete'.
 *
 * Usage: Delete a media entry
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class MediaDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'delete' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'flag'.
 *
 * Usage: Flag inappropriate media entry for moderation
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class MediaFlagAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'flag' },
            moderationFlag: { type: 'o', subTypeConstructor: KalturaModerationFlag, subType: 'KalturaModerationFlag' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'get'.
 *
 * Usage: Get media entry by ID
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class MediaGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
        if (typeof this.version === 'undefined')
            this.version = -1;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'get' },
            entryId: { type: 's' },
            version: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'getMrss'.
 *
 * Usage: Get MRSS by entry id
 * XML will return as an escaped string
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class MediaGetMrssAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
        if (typeof this.extendingItemsArray === 'undefined')
            this.extendingItemsArray = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'getMrss' },
            entryId: { type: 's' },
            extendingItemsArray: { type: 'a', subTypeConstructor: KalturaExtendingItemMrssParameter, subType: 'KalturaExtendingItemMrssParameter' },
            features: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'getVolumeMap'.
 *
 * Usage: Get volume map by entry id
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class MediaGetVolumeMapAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'getVolumeMap' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'list'.
 *
 * Usage: List media entries by filter with paging support
 *
 * Server response type:         KalturaMediaListResponse
 * Server failure response type: KalturaAPIException
 */
class MediaListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaListResponse', responseConstructor: KalturaMediaListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaMediaEntryFilter, subType: 'KalturaMediaEntryFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'listFlags'.
 *
 * Usage: List all pending flags for the media entry
 *
 * Server response type:         KalturaModerationFlagListResponse
 * Server failure response type: KalturaAPIException
 */
class MediaListFlagsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaModerationFlagListResponse', responseConstructor: KalturaModerationFlagListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'listFlags' },
            entryId: { type: 's' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'reject'.
 *
 * Usage: Reject the media entry and mark the pending flags (if any) as moderated (this will make the entry non playable)
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class MediaRejectAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'reject' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'requestConversion'.
 *
 * Usage: Request a new conversion job, this can be used to convert the media entry to a different format
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class MediaRequestConversionAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'requestConversion' },
            entryId: { type: 's' },
            fileFormat: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'update'.
 *
 * Usage: Update media entry. Only the properties that were set will be updated
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class MediaUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'update' },
            entryId: { type: 's' },
            mediaEntry: { type: 'o', subTypeConstructor: KalturaMediaEntry, subType: 'KalturaMediaEntry' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'updateContent'.
 *
 * Usage: Replace content associated with the media entry
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class MediaUpdateContentAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'updateContent' },
            entryId: { type: 's' },
            resource: { type: 'o', subTypeConstructor: KalturaResource, subType: 'KalturaResource' },
            conversionProfileId: { type: 'n' },
            advancedOptions: { type: 'o', subTypeConstructor: KalturaEntryReplacementOptions, subType: 'KalturaEntryReplacementOptions' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'updateThumbnail'.
 *
 * Usage: Update media entry thumbnail by a specified time offset (In seconds)
 * If flavor params id not specified, source flavor will be used by default
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class MediaUpdateThumbnailAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'updateThumbnail' },
            entryId: { type: 's' },
            timeOffset: { type: 'n' },
            flavorParamsId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'updateThumbnailFromSourceEntry'.
 *
 * Usage: Update media entry thumbnail from a different entry by a specified time offset (In seconds)
 * If flavor params id not specified, source flavor will be used by default
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class MediaUpdateThumbnailFromSourceEntryAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'updateThumbnailFromSourceEntry' },
            entryId: { type: 's' },
            sourceEntryId: { type: 's' },
            timeOffset: { type: 'n' },
            flavorParamsId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'updateThumbnailFromUrl'.
 *
 * Usage: Update entry thumbnail using url
 *
 * Server response type:         KalturaBaseEntry
 * Server failure response type: KalturaAPIException
 */
class MediaUpdateThumbnailFromUrlAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseEntry', responseConstructor: KalturaBaseEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'updateThumbnailFromUrl' },
            entryId: { type: 's' },
            url: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'updateThumbnailJpeg'.
 *
 * Usage: Update media entry thumbnail using a raw jpeg file
 *
 * Server response type:         KalturaMediaEntry
 * Server failure response type: KalturaAPIException
 */
class MediaUpdateThumbnailJpegAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'updateThumbnailJpeg' },
            entryId: { type: 's' },
            fileData: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'media' action 'upload'.
 *
 * Usage: Upload a media file to Kaltura, then the file can be used to create a media entry
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class MediaUploadAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'media' },
            action: { type: 'c', default: 'upload' },
            fileData: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'mixing' action 'add'.
 *
 * Usage: Adds a new mix.
 * If the dataContent is null, a default timeline will be created
 *
 * Server response type:         KalturaMixEntry
 * Server failure response type: KalturaAPIException
 */
class MixingAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMixEntry', responseConstructor: KalturaMixEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'mixing' },
            action: { type: 'c', default: 'add' },
            mixEntry: { type: 'o', subTypeConstructor: KalturaMixEntry, subType: 'KalturaMixEntry' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'mixing' action 'anonymousRank'.
 *
 * Usage: Anonymously rank a mix entry, no validation is done on duplicate rankings
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class MixingAnonymousRankAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'mixing' },
            action: { type: 'c', default: 'anonymousRank' },
            entryId: { type: 's' },
            rank: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'mixing' action 'appendMediaEntry'.
 *
 * Usage: Appends a media entry to a the end of the mix timeline, this will save the mix timeline as a new version
 *
 * Server response type:         KalturaMixEntry
 * Server failure response type: KalturaAPIException
 */
class MixingAppendMediaEntryAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMixEntry', responseConstructor: KalturaMixEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'mixing' },
            action: { type: 'c', default: 'appendMediaEntry' },
            mixEntryId: { type: 's' },
            mediaEntryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'mixing' action 'clone'.
 *
 * Usage: Clones an existing mix
 *
 * Server response type:         KalturaMixEntry
 * Server failure response type: KalturaAPIException
 */
class MixingCloneAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMixEntry', responseConstructor: KalturaMixEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'mixing' },
            action: { type: 'c', default: 'clone' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'mixing' action 'count'.
 *
 * Usage: Count mix entries by filter
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class MixingCountAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'mixing' },
            action: { type: 'c', default: 'count' },
            filter: { type: 'o', subTypeConstructor: KalturaMediaEntryFilter, subType: 'KalturaMediaEntryFilter' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'mixing' action 'delete'.
 *
 * Usage: Delete a mix entry
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class MixingDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'mixing' },
            action: { type: 'c', default: 'delete' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'mixing' action 'get'.
 *
 * Usage: Get mix entry by id
 *
 * Server response type:         KalturaMixEntry
 * Server failure response type: KalturaAPIException
 */
class MixingGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMixEntry', responseConstructor: KalturaMixEntry });
        if (typeof this.version === 'undefined')
            this.version = -1;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'mixing' },
            action: { type: 'c', default: 'get' },
            entryId: { type: 's' },
            version: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'mixing' action 'getMixesByMediaId'.
 *
 * Usage: Get the mixes in which the media entry is included
 *
 * Server response type:         KalturaMixEntry[]
 * Server failure response type: KalturaAPIException
 */
class MixingGetMixesByMediaIdAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaMixEntry', responseConstructor: KalturaMixEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'mixing' },
            action: { type: 'c', default: 'getMixesByMediaId' },
            mediaEntryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'mixing' action 'getReadyMediaEntries'.
 *
 * Usage: Get all ready media entries that exist in the given mix id
 *
 * Server response type:         KalturaMediaEntry[]
 * Server failure response type: KalturaAPIException
 */
class MixingGetReadyMediaEntriesAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaMediaEntry', responseConstructor: KalturaMediaEntry });
        if (typeof this.version === 'undefined')
            this.version = -1;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'mixing' },
            action: { type: 'c', default: 'getReadyMediaEntries' },
            mixId: { type: 's' },
            version: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'mixing' action 'list'.
 *
 * Usage: List entries by filter with paging support.
 * Return parameter is an array of mix entries
 *
 * Server response type:         KalturaMixListResponse
 * Server failure response type: KalturaAPIException
 */
class MixingListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMixListResponse', responseConstructor: KalturaMixListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'mixing' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaMixEntryFilter, subType: 'KalturaMixEntryFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'mixing' action 'update'.
 *
 * Usage: Update mix entry. Only the properties that were set will be updated
 *
 * Server response type:         KalturaMixEntry
 * Server failure response type: KalturaAPIException
 */
class MixingUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMixEntry', responseConstructor: KalturaMixEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'mixing' },
            action: { type: 'c', default: 'update' },
            entryId: { type: 's' },
            mixEntry: { type: 'o', subTypeConstructor: KalturaMixEntry, subType: 'KalturaMixEntry' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'notification' action 'getClientNotification'.
 *
 * Usage: Return the notifications for a specific entry id and type
 *
 * Server response type:         KalturaClientNotification
 * Server failure response type: KalturaAPIException
 */
class NotificationGetClientNotificationAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaClientNotification', responseConstructor: KalturaClientNotification });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'notification' },
            action: { type: 'c', default: 'getClientNotification' },
            entryId: { type: 's' },
            type: { type: 'en', subTypeConstructor: KalturaNotificationType, subType: 'KalturaNotificationType' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'partner' action 'count'.
 *
 * Usage: Count partner's existing sub-publishers (count includes the partner itself)
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class PartnerCountAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'partner' },
            action: { type: 'c', default: 'count' },
            filter: { type: 'o', subTypeConstructor: KalturaPartnerFilter, subType: 'KalturaPartnerFilter' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'partner' action 'get'.
 *
 * Usage: Retrieve partner object by Id
 *
 * Server response type:         KalturaPartner
 * Server failure response type: KalturaAPIException
 */
class PartnerGetAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPartner', responseConstructor: KalturaPartner });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'partner' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'partner' action 'getInfo'.
 *
 * Usage: Retrieve all info attributed to the partner
 * This action expects no parameters. It returns information for the current KS partnerId
 *
 * Server response type:         KalturaPartner
 * Server failure response type: KalturaAPIException
 */
class PartnerGetInfoAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPartner', responseConstructor: KalturaPartner });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'partner' },
            action: { type: 'c', default: 'getInfo' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'partner' action 'getSecrets'.
 *
 * Usage: Retrieve partner secret and admin secret
 *
 * Server response type:         KalturaPartner
 * Server failure response type: KalturaAPIException
 */
class PartnerGetSecretsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPartner', responseConstructor: KalturaPartner });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'partner' },
            action: { type: 'c', default: 'getSecrets' },
            partnerId: { type: 'n' },
            adminEmail: { type: 's' },
            cmsPassword: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'partner' action 'getStatistics'.
 *
 * Usage: Get usage statistics for a partner
 * Calculation is done according to partner's package
 *
 * Server response type:         KalturaPartnerStatistics
 * Server failure response type: KalturaAPIException
 */
class PartnerGetStatisticsAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPartnerStatistics', responseConstructor: KalturaPartnerStatistics });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'partner' },
            action: { type: 'c', default: 'getStatistics' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'partner' action 'getUsage'.
 *
 * Usage: Get usage statistics for a partner
 * Calculation is done according to partner's package
 * Additional data returned is a graph points of streaming usage in a timeframe
 * The resolution can be "days" or "months"
 *
 * Server response type:         KalturaPartnerUsage
 * Server failure response type: KalturaAPIException
 */
class PartnerGetUsageAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPartnerUsage', responseConstructor: KalturaPartnerUsage });
        if (typeof this.month === 'undefined')
            this.month = 1;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'partner' },
            action: { type: 'c', default: 'getUsage' },
            year: { type: 'n' },
            month: { type: 'n' },
            resolution: { type: 'es', subTypeConstructor: KalturaReportInterval, subType: 'KalturaReportInterval' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'partner' action 'list'.
 *
 * Usage: List partners by filter with paging support
 * Current implementation will only list the sub partners of the partner initiating the api call (using the current KS).
 * This action is only partially implemented to support listing sub partners of a VAR partner
 *
 * Server response type:         KalturaPartnerListResponse
 * Server failure response type: KalturaAPIException
 */
class PartnerListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPartnerListResponse', responseConstructor: KalturaPartnerListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'partner' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaPartnerFilter, subType: 'KalturaPartnerFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'partner' action 'listFeatureStatus'.
 *
 * Usage: List partner's current processes' statuses
 *
 * Server response type:         KalturaFeatureStatusListResponse
 * Server failure response type: KalturaAPIException
 */
class PartnerListFeatureStatusAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFeatureStatusListResponse', responseConstructor: KalturaFeatureStatusListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'partner' },
            action: { type: 'c', default: 'listFeatureStatus' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'partner' action 'listPartnersForUser'.
 *
 * Usage: Retrieve a list of partner objects which the current user is allowed to access
 *
 * Server response type:         KalturaPartnerListResponse
 * Server failure response type: KalturaAPIException
 */
class PartnerListPartnersForUserAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPartnerListResponse', responseConstructor: KalturaPartnerListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'partner' },
            action: { type: 'c', default: 'listPartnersForUser' },
            partnerFilter: { type: 'o', subTypeConstructor: KalturaPartnerFilter, subType: 'KalturaPartnerFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'partner' action 'register'.
 *
 * Usage: Create a new Partner object
 *
 * Server response type:         KalturaPartner
 * Server failure response type: KalturaAPIException
 */
class PartnerRegisterAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPartner', responseConstructor: KalturaPartner });
        if (typeof this.silent === 'undefined')
            this.silent = false;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'partner' },
            action: { type: 'c', default: 'register' },
            partner: { type: 'o', subTypeConstructor: KalturaPartner, subType: 'KalturaPartner' },
            cmsPassword: { type: 's' },
            templatePartnerId: { type: 'n' },
            silent: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'partner' action 'update'.
 *
 * Usage: Update details and settings of an existing partner
 *
 * Server response type:         KalturaPartner
 * Server failure response type: KalturaAPIException
 */
class PartnerUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPartner', responseConstructor: KalturaPartner });
        if (typeof this.allowEmpty === 'undefined')
            this.allowEmpty = false;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'partner' },
            action: { type: 'c', default: 'update' },
            partner: { type: 'o', subTypeConstructor: KalturaPartner, subType: 'KalturaPartner' },
            allowEmpty: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'permissionItem' action 'add'.
 *
 * Usage: Adds a new permission item object to the account.
 * This action is available only to Kaltura system administrators
 *
 * Server response type:         KalturaPermissionItem
 * Server failure response type: KalturaAPIException
 */
class PermissionItemAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPermissionItem', responseConstructor: KalturaPermissionItem });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'permissionitem' },
            action: { type: 'c', default: 'add' },
            permissionItem: { type: 'o', subTypeConstructor: KalturaPermissionItem, subType: 'KalturaPermissionItem' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'permissionItem' action 'delete'.
 *
 * Usage: Deletes an existing permission item object.
 * This action is available only to Kaltura system administrators
 *
 * Server response type:         KalturaPermissionItem
 * Server failure response type: KalturaAPIException
 */
class PermissionItemDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPermissionItem', responseConstructor: KalturaPermissionItem });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'permissionitem' },
            action: { type: 'c', default: 'delete' },
            permissionItemId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'permissionItem' action 'get'.
 *
 * Usage: Retrieves a permission item object using its ID
 *
 * Server response type:         KalturaPermissionItem
 * Server failure response type: KalturaAPIException
 */
class PermissionItemGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPermissionItem', responseConstructor: KalturaPermissionItem });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'permissionitem' },
            action: { type: 'c', default: 'get' },
            permissionItemId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'permissionItem' action 'list'.
 *
 * Usage: Lists permission item objects that are associated with an account
 *
 * Server response type:         KalturaPermissionItemListResponse
 * Server failure response type: KalturaAPIException
 */
class PermissionItemListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPermissionItemListResponse', responseConstructor: KalturaPermissionItemListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'permissionitem' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaPermissionItemFilter, subType: 'KalturaPermissionItemFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'permissionItem' action 'update'.
 *
 * Usage: Updates an existing permission item object.
 * This action is available only to Kaltura system administrators
 *
 * Server response type:         KalturaPermissionItem
 * Server failure response type: KalturaAPIException
 */
class PermissionItemUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPermissionItem', responseConstructor: KalturaPermissionItem });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'permissionitem' },
            action: { type: 'c', default: 'update' },
            permissionItemId: { type: 'n' },
            permissionItem: { type: 'o', subTypeConstructor: KalturaPermissionItem, subType: 'KalturaPermissionItem' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'permission' action 'add'.
 *
 * Usage: Adds a new permission object to the account
 *
 * Server response type:         KalturaPermission
 * Server failure response type: KalturaAPIException
 */
class PermissionAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPermission', responseConstructor: KalturaPermission });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'permission' },
            action: { type: 'c', default: 'add' },
            permission: { type: 'o', subTypeConstructor: KalturaPermission, subType: 'KalturaPermission' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'permission' action 'delete'.
 *
 * Usage: Deletes an existing permission object
 *
 * Server response type:         KalturaPermission
 * Server failure response type: KalturaAPIException
 */
class PermissionDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPermission', responseConstructor: KalturaPermission });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'permission' },
            action: { type: 'c', default: 'delete' },
            permissionName: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'permission' action 'get'.
 *
 * Usage: Retrieves a permission object using its ID
 *
 * Server response type:         KalturaPermission
 * Server failure response type: KalturaAPIException
 */
class PermissionGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPermission', responseConstructor: KalturaPermission });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'permission' },
            action: { type: 'c', default: 'get' },
            permissionName: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'permission' action 'getCurrentPermissions'.
 *
 * Usage: Retrieves a list of permissions that apply to the current KS
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class PermissionGetCurrentPermissionsAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'permission' },
            action: { type: 'c', default: 'getCurrentPermissions' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'permission' action 'list'.
 *
 * Usage: Lists permission objects that are associated with an account.
 * Blocked permissions are listed unless you use a filter to exclude them.
 * Blocked permissions are listed unless you use a filter to exclude them
 *
 * Server response type:         KalturaPermissionListResponse
 * Server failure response type: KalturaAPIException
 */
class PermissionListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPermissionListResponse', responseConstructor: KalturaPermissionListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'permission' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaPermissionFilter, subType: 'KalturaPermissionFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'permission' action 'update'.
 *
 * Usage: Updates an existing permission object
 *
 * Server response type:         KalturaPermission
 * Server failure response type: KalturaAPIException
 */
class PermissionUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPermission', responseConstructor: KalturaPermission });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'permission' },
            action: { type: 'c', default: 'update' },
            permissionName: { type: 's' },
            permission: { type: 'o', subTypeConstructor: KalturaPermission, subType: 'KalturaPermission' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'playlist' action 'add'.
 *
 * Usage: Add new playlist
 * Note that all entries used in a playlist will become public and may appear in KalturaNetwork
 *
 * Server response type:         KalturaPlaylist
 * Server failure response type: KalturaAPIException
 */
class PlaylistAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPlaylist', responseConstructor: KalturaPlaylist });
        if (typeof this.updateStats === 'undefined')
            this.updateStats = false;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'playlist' },
            action: { type: 'c', default: 'add' },
            playlist: { type: 'o', subTypeConstructor: KalturaPlaylist, subType: 'KalturaPlaylist' },
            updateStats: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'playlist' action 'clone'.
 *
 * Usage: Clone an existing playlist
 *
 * Server response type:         KalturaPlaylist
 * Server failure response type: KalturaAPIException
 */
class PlaylistCloneAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPlaylist', responseConstructor: KalturaPlaylist });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'playlist' },
            action: { type: 'c', default: 'clone' },
            id: { type: 's' },
            newPlaylist: { type: 'o', subTypeConstructor: KalturaPlaylist, subType: 'KalturaPlaylist' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'playlist' action 'delete'.
 *
 * Usage: Delete existing playlist
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class PlaylistDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'playlist' },
            action: { type: 'c', default: 'delete' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'playlist' action 'execute'.
 *
 * Usage: Retrieve playlist for playing purpose
 *
 * Server response type:         KalturaBaseEntry[]
 * Server failure response type: KalturaAPIException
 */
class PlaylistExecuteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaBaseEntry', responseConstructor: KalturaBaseEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'playlist' },
            action: { type: 'c', default: 'execute' },
            id: { type: 's' },
            detailed: { type: 's' },
            playlistContext: { type: 'o', subTypeConstructor: KalturaContext, subType: 'KalturaContext' },
            filter: { type: 'o', subTypeConstructor: KalturaMediaEntryFilterForPlaylist, subType: 'KalturaMediaEntryFilterForPlaylist' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'playlist' action 'executeFromContent'.
 *
 * Usage: Retrieve playlist for playing purpose, based on content
 *
 * Server response type:         KalturaBaseEntry[]
 * Server failure response type: KalturaAPIException
 */
class PlaylistExecuteFromContentAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaBaseEntry', responseConstructor: KalturaBaseEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'playlist' },
            action: { type: 'c', default: 'executeFromContent' },
            playlistType: { type: 'en', subTypeConstructor: KalturaPlaylistType, subType: 'KalturaPlaylistType' },
            playlistContent: { type: 's' },
            detailed: { type: 's' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'playlist' action 'executeFromFilters'.
 *
 * Usage: Revrieve playlist for playing purpose, based on media entry filters
 *
 * Server response type:         KalturaBaseEntry[]
 * Server failure response type: KalturaAPIException
 */
class PlaylistExecuteFromFiltersAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaBaseEntry', responseConstructor: KalturaBaseEntry });
        if (typeof this.filters === 'undefined')
            this.filters = [];
        if (typeof this.detailed === 'undefined')
            this.detailed = "1";
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'playlist' },
            action: { type: 'c', default: 'executeFromFilters' },
            filters: { type: 'a', subTypeConstructor: KalturaMediaEntryFilterForPlaylist, subType: 'KalturaMediaEntryFilterForPlaylist' },
            totalResults: { type: 'n' },
            detailed: { type: 's' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'playlist' action 'get'.
 *
 * Usage: Retrieve a playlist
 *
 * Server response type:         KalturaPlaylist
 * Server failure response type: KalturaAPIException
 */
class PlaylistGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPlaylist', responseConstructor: KalturaPlaylist });
        if (typeof this.version === 'undefined')
            this.version = -1;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'playlist' },
            action: { type: 'c', default: 'get' },
            id: { type: 's' },
            version: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'playlist' action 'getStatsFromContent'.
 *
 * Usage: Retrieve playlist statistics
 *
 * Server response type:         KalturaPlaylist
 * Server failure response type: KalturaAPIException
 */
class PlaylistGetStatsFromContentAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPlaylist', responseConstructor: KalturaPlaylist });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'playlist' },
            action: { type: 'c', default: 'getStatsFromContent' },
            playlistType: { type: 'en', subTypeConstructor: KalturaPlaylistType, subType: 'KalturaPlaylistType' },
            playlistContent: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'playlist' action 'list'.
 *
 * Usage: List available playlists
 *
 * Server response type:         KalturaPlaylistListResponse
 * Server failure response type: KalturaAPIException
 */
class PlaylistListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPlaylistListResponse', responseConstructor: KalturaPlaylistListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'playlist' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaPlaylistFilter, subType: 'KalturaPlaylistFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'playlist' action 'update'.
 *
 * Usage: Update existing playlist
 * Note - you cannot change playlist type. updated playlist must be of the same type
 *
 * Server response type:         KalturaPlaylist
 * Server failure response type: KalturaAPIException
 */
class PlaylistUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPlaylist', responseConstructor: KalturaPlaylist });
        if (typeof this.updateStats === 'undefined')
            this.updateStats = false;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'playlist' },
            action: { type: 'c', default: 'update' },
            id: { type: 's' },
            playlist: { type: 'o', subTypeConstructor: KalturaPlaylist, subType: 'KalturaPlaylist' },
            updateStats: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'report' action 'execute'.
 *
 *
 *
 * Server response type:         KalturaReportResponse
 * Server failure response type: KalturaAPIException
 */
class ReportExecuteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaReportResponse', responseConstructor: KalturaReportResponse });
        if (typeof this.params === 'undefined')
            this.params = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'report' },
            action: { type: 'c', default: 'execute' },
            id: { type: 'n' },
            params: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'report' action 'getBaseTotal'.
 *
 * Usage: report getBaseTotal action allows to get a the total base for storage reports
 *
 * Server response type:         KalturaReportBaseTotal[]
 * Server failure response type: KalturaAPIException
 */
class ReportGetBaseTotalAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaReportBaseTotal', responseConstructor: KalturaReportBaseTotal });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'report' },
            action: { type: 'c', default: 'getBaseTotal' },
            reportType: { type: 'es', subTypeConstructor: KalturaReportType, subType: 'KalturaReportType' },
            reportInputFilter: { type: 'o', subTypeConstructor: KalturaReportInputFilter, subType: 'KalturaReportInputFilter' },
            objectIds: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'report' action 'getCsv'.
 *
 *
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class ReportGetCsvAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
        if (typeof this.params === 'undefined')
            this.params = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'report' },
            action: { type: 'c', default: 'getCsv' },
            id: { type: 'n' },
            params: { type: 'a', subTypeConstructor: KalturaKeyValue, subType: 'KalturaKeyValue' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'report' action 'getCsvFromStringParams'.
 *
 * Usage: Returns report CSV file executed by string params with the following convention: param1=value1;param2=value2
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class ReportGetCsvFromStringParamsAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'report' },
            action: { type: 'c', default: 'getCsvFromStringParams' },
            id: { type: 'n' },
            params: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'report' action 'getGraphs'.
 *
 * Usage: report getGraphs action allows to get a graph data for a specific report
 *
 * Server response type:         KalturaReportGraph[]
 * Server failure response type: KalturaAPIException
 */
class ReportGetGraphsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaReportGraph', responseConstructor: KalturaReportGraph });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'report' },
            action: { type: 'c', default: 'getGraphs' },
            reportType: { type: 'es', subTypeConstructor: KalturaReportType, subType: 'KalturaReportType' },
            reportInputFilter: { type: 'o', subTypeConstructor: KalturaReportInputFilter, subType: 'KalturaReportInputFilter' },
            dimension: { type: 's' },
            objectIds: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'report' action 'getTable'.
 *
 * Usage: report getTable action allows to get a graph data for a specific report
 *
 * Server response type:         KalturaReportTable
 * Server failure response type: KalturaAPIException
 */
class ReportGetTableAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaReportTable', responseConstructor: KalturaReportTable });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'report' },
            action: { type: 'c', default: 'getTable' },
            reportType: { type: 'es', subTypeConstructor: KalturaReportType, subType: 'KalturaReportType' },
            reportInputFilter: { type: 'o', subTypeConstructor: KalturaReportInputFilter, subType: 'KalturaReportInputFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' },
            order: { type: 's' },
            objectIds: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'report' action 'getTotal'.
 *
 * Usage: report getTotal action allows to get a graph data for a specific report
 *
 * Server response type:         KalturaReportTotal
 * Server failure response type: KalturaAPIException
 */
class ReportGetTotalAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaReportTotal', responseConstructor: KalturaReportTotal });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'report' },
            action: { type: 'c', default: 'getTotal' },
            reportType: { type: 'es', subTypeConstructor: KalturaReportType, subType: 'KalturaReportType' },
            reportInputFilter: { type: 'o', subTypeConstructor: KalturaReportInputFilter, subType: 'KalturaReportInputFilter' },
            objectIds: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'report' action 'getUrlForReportAsCsv'.
 *
 * Usage: will create a Csv file for the given report and return the URL to access it
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class ReportGetUrlForReportAsCsvAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'report' },
            action: { type: 'c', default: 'getUrlForReportAsCsv' },
            reportTitle: { type: 's' },
            reportText: { type: 's' },
            headers: { type: 's' },
            reportType: { type: 'es', subTypeConstructor: KalturaReportType, subType: 'KalturaReportType' },
            reportInputFilter: { type: 'o', subTypeConstructor: KalturaReportInputFilter, subType: 'KalturaReportInputFilter' },
            dimension: { type: 's' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' },
            order: { type: 's' },
            objectIds: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'report' action 'serve'.
 *
 * Usage: Will serve a requested report
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class ReportServeAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'report' },
            action: { type: 'c', default: 'serve' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'responseProfile' action 'add'.
 *
 * Usage: Add new response profile
 *
 * Server response type:         KalturaResponseProfile
 * Server failure response type: KalturaAPIException
 */
class ResponseProfileAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaResponseProfile', responseConstructor: KalturaResponseProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'responseprofile' },
            action: { type: 'c', default: 'add' },
            addResponseProfile: { type: 'o', subTypeConstructor: KalturaResponseProfile, subType: 'KalturaResponseProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'responseProfile' action 'clone'.
 *
 * Usage: Clone an existing response profile
 *
 * Server response type:         KalturaResponseProfile
 * Server failure response type: KalturaAPIException
 */
class ResponseProfileCloneAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaResponseProfile', responseConstructor: KalturaResponseProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'responseprofile' },
            action: { type: 'c', default: 'clone' },
            id: { type: 'n' },
            profile: { type: 'o', subTypeConstructor: KalturaResponseProfile, subType: 'KalturaResponseProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'responseProfile' action 'delete'.
 *
 * Usage: Delete response profile by id
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class ResponseProfileDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'responseprofile' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'responseProfile' action 'get'.
 *
 * Usage: Get response profile by id
 *
 * Server response type:         KalturaResponseProfile
 * Server failure response type: KalturaAPIException
 */
class ResponseProfileGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaResponseProfile', responseConstructor: KalturaResponseProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'responseprofile' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'responseProfile' action 'list'.
 *
 * Usage: List response profiles by filter and pager
 *
 * Server response type:         KalturaResponseProfileListResponse
 * Server failure response type: KalturaAPIException
 */
class ResponseProfileListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaResponseProfileListResponse', responseConstructor: KalturaResponseProfileListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'responseprofile' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaResponseProfileFilter, subType: 'KalturaResponseProfileFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'responseProfile' action 'recalculate'.
 *
 * Usage: Recalculate response profile cached objects
 *
 * Server response type:         KalturaResponseProfileCacheRecalculateResults
 * Server failure response type: KalturaAPIException
 */
class ResponseProfileRecalculateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaResponseProfileCacheRecalculateResults', responseConstructor: KalturaResponseProfileCacheRecalculateResults });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'responseprofile' },
            action: { type: 'c', default: 'recalculate' },
            options: { type: 'o', subTypeConstructor: KalturaResponseProfileCacheRecalculateOptions, subType: 'KalturaResponseProfileCacheRecalculateOptions' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'responseProfile' action 'update'.
 *
 * Usage: Update response profile by id
 *
 * Server response type:         KalturaResponseProfile
 * Server failure response type: KalturaAPIException
 */
class ResponseProfileUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaResponseProfile', responseConstructor: KalturaResponseProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'responseprofile' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            updateResponseProfile: { type: 'o', subTypeConstructor: KalturaResponseProfile, subType: 'KalturaResponseProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'responseProfile' action 'updateStatus'.
 *
 * Usage: Update response profile status by id
 *
 * Server response type:         KalturaResponseProfile
 * Server failure response type: KalturaAPIException
 */
class ResponseProfileUpdateStatusAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaResponseProfile', responseConstructor: KalturaResponseProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'responseprofile' },
            action: { type: 'c', default: 'updateStatus' },
            id: { type: 'n' },
            status: { type: 'en', subTypeConstructor: KalturaResponseProfileStatus, subType: 'KalturaResponseProfileStatus' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'schema' action 'serve'.
 *
 * Usage: Serves the requested XSD according to the type and name
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class SchemaServeAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schema' },
            action: { type: 'c', default: 'serve' },
            type: { type: 'es', subTypeConstructor: KalturaSchemaType, subType: 'KalturaSchemaType' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'search' action 'externalLogin'.
 *
 *
 *
 * Server response type:         KalturaSearchAuthData
 * Server failure response type: KalturaAPIException
 */
class SearchExternalLoginAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaSearchAuthData', responseConstructor: KalturaSearchAuthData });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'search' },
            action: { type: 'c', default: 'externalLogin' },
            searchSource: { type: 'en', subTypeConstructor: KalturaSearchProviderType, subType: 'KalturaSearchProviderType' },
            userName: { type: 's' },
            password: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'search' action 'getMediaInfo'.
 *
 * Usage: Retrieve extra information about media found in search action
 * Some providers return only part of the fields needed to create entry from, use this action to get the rest of the fields
 *
 * Server response type:         KalturaSearchResult
 * Server failure response type: KalturaAPIException
 */
class SearchGetMediaInfoAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaSearchResult', responseConstructor: KalturaSearchResult });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'search' },
            action: { type: 'c', default: 'getMediaInfo' },
            searchResult: { type: 'o', subTypeConstructor: KalturaSearchResult, subType: 'KalturaSearchResult' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'search' action 'search'.
 *
 * Usage: Search for media in one of the supported media providers
 *
 * Server response type:         KalturaSearchResultResponse
 * Server failure response type: KalturaAPIException
 */
class SearchSearchAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaSearchResultResponse', responseConstructor: KalturaSearchResultResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'search' },
            action: { type: 'c', default: 'search' },
            search: { type: 'o', subTypeConstructor: KalturaSearch, subType: 'KalturaSearch' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'search' action 'searchUrl'.
 *
 * Usage: Search for media given a specific URL
 * Kaltura supports a searchURL action on some of the media providers.
 * This action will return a KalturaSearchResult object based on a given URL (assuming the media provider is supported)
 *
 * Server response type:         KalturaSearchResult
 * Server failure response type: KalturaAPIException
 */
class SearchSearchUrlAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaSearchResult', responseConstructor: KalturaSearchResult });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'search' },
            action: { type: 'c', default: 'searchUrl' },
            mediaType: { type: 'en', subTypeConstructor: KalturaMediaType, subType: 'KalturaMediaType' },
            url: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'serverNode' action 'add'.
 *
 * Usage: Adds a server node to the Kaltura DB
 *
 * Server response type:         KalturaServerNode
 * Server failure response type: KalturaAPIException
 */
class ServerNodeAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaServerNode', responseConstructor: KalturaServerNode });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'servernode' },
            action: { type: 'c', default: 'add' },
            serverNode: { type: 'o', subTypeConstructor: KalturaServerNode, subType: 'KalturaServerNode' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'serverNode' action 'delete'.
 *
 * Usage: delete server node by id
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class ServerNodeDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'servernode' },
            action: { type: 'c', default: 'delete' },
            serverNodeId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'serverNode' action 'disable'.
 *
 * Usage: Disable server node by id
 *
 * Server response type:         KalturaServerNode
 * Server failure response type: KalturaAPIException
 */
class ServerNodeDisableAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaServerNode', responseConstructor: KalturaServerNode });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'servernode' },
            action: { type: 'c', default: 'disable' },
            serverNodeId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'serverNode' action 'enable'.
 *
 * Usage: Enable server node by id
 *
 * Server response type:         KalturaServerNode
 * Server failure response type: KalturaAPIException
 */
class ServerNodeEnableAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaServerNode', responseConstructor: KalturaServerNode });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'servernode' },
            action: { type: 'c', default: 'enable' },
            serverNodeId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'serverNode' action 'get'.
 *
 * Usage: Get server node by id
 *
 * Server response type:         KalturaServerNode
 * Server failure response type: KalturaAPIException
 */
class ServerNodeGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaServerNode', responseConstructor: KalturaServerNode });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'servernode' },
            action: { type: 'c', default: 'get' },
            serverNodeId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'serverNode' action 'getFullPath'.
 *
 * Usage: Get the edge server node full path
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class ServerNodeGetFullPathAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
        if (typeof this.protocol === 'undefined')
            this.protocol = "http";
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'servernode' },
            action: { type: 'c', default: 'getFullPath' },
            hostName: { type: 's' },
            protocol: { type: 's' },
            deliveryFormat: { type: 's' },
            deliveryType: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'serverNode' action 'list'.
 *
 *
 *
 * Server response type:         KalturaServerNodeListResponse
 * Server failure response type: KalturaAPIException
 */
class ServerNodeListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaServerNodeListResponse', responseConstructor: KalturaServerNodeListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'servernode' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaServerNodeFilter, subType: 'KalturaServerNodeFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'serverNode' action 'markOffline'.
 *
 * Usage: Mark server node offline
 *
 * Server response type:         KalturaServerNode
 * Server failure response type: KalturaAPIException
 */
class ServerNodeMarkOfflineAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaServerNode', responseConstructor: KalturaServerNode });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'servernode' },
            action: { type: 'c', default: 'markOffline' },
            serverNodeId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'serverNode' action 'reportStatus'.
 *
 * Usage: Update server node status
 *
 * Server response type:         KalturaServerNode
 * Server failure response type: KalturaAPIException
 */
class ServerNodeReportStatusAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaServerNode', responseConstructor: KalturaServerNode });
        if (typeof this.serverNodeStatus === 'undefined')
            this.serverNodeStatus = 1;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'servernode' },
            action: { type: 'c', default: 'reportStatus' },
            hostName: { type: 's' },
            serverNode: { type: 'o', subTypeConstructor: KalturaServerNode, subType: 'KalturaServerNode' },
            serverNodeStatus: { type: 'en', subTypeConstructor: KalturaServerNodeStatus, subType: 'KalturaServerNodeStatus' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'serverNode' action 'update'.
 *
 * Usage: Update server node by id
 *
 * Server response type:         KalturaServerNode
 * Server failure response type: KalturaAPIException
 */
class ServerNodeUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaServerNode', responseConstructor: KalturaServerNode });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'servernode' },
            action: { type: 'c', default: 'update' },
            serverNodeId: { type: 'n' },
            serverNode: { type: 'o', subTypeConstructor: KalturaServerNode, subType: 'KalturaServerNode' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'session' action 'end'.
 *
 * Usage: End a session with the Kaltura server, making the current KS invalid
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class SessionEndAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'session' },
            action: { type: 'c', default: 'end' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'session' action 'get'.
 *
 * Usage: Parse session key and return its info
 *
 * Server response type:         KalturaSessionInfo
 * Server failure response type: KalturaAPIException
 */
class SessionGetAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaSessionInfo', responseConstructor: KalturaSessionInfo });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'session' },
            action: { type: 'c', default: 'get' },
            session: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'session' action 'impersonate'.
 *
 * Usage: Start an impersonated session with Kaltura's server.
 * The result KS is the session key that you should pass to all services that requires a ticket
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class SessionImpersonateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
        if (typeof this.expiry === 'undefined')
            this.expiry = 86400;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'session' },
            action: { type: 'c', default: 'impersonate' },
            secret: { type: 's' },
            impersonatedPartnerId: { type: 'n' },
            userId: { type: 's' },
            type: { type: 'en', subTypeConstructor: KalturaSessionType, subType: 'KalturaSessionType' },
            partnerId: { type: 'n' },
            expiry: { type: 'n' },
            privileges: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'session' action 'impersonateByKs'.
 *
 * Usage: Start an impersonated session with Kaltura's server.
 * The result KS info contains the session key that you should pass to all services that requires a ticket.
 * Type, expiry and privileges won't be changed if they're not set
 *
 * Server response type:         KalturaSessionInfo
 * Server failure response type: KalturaAPIException
 */
class SessionImpersonateByKsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaSessionInfo', responseConstructor: KalturaSessionInfo });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'session' },
            action: { type: 'c', default: 'impersonateByKs' },
            session: { type: 's' },
            type: { type: 'en', subTypeConstructor: KalturaSessionType, subType: 'KalturaSessionType' },
            expiry: { type: 'n' },
            privileges: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'session' action 'start'.
 *
 * Usage: Start a session with Kaltura's server.
 * The result KS is the session key that you should pass to all services that requires a ticket
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class SessionStartAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
        if (typeof this.expiry === 'undefined')
            this.expiry = 86400;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'session' },
            action: { type: 'c', default: 'start' },
            secret: { type: 's' },
            userId: { type: 's' },
            type: { type: 'en', subTypeConstructor: KalturaSessionType, subType: 'KalturaSessionType' },
            partnerId: { type: 'n' },
            expiry: { type: 'n' },
            privileges: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'session' action 'startWidgetSession'.
 *
 * Usage: Start a session for Kaltura's flash widgets
 *
 * Server response type:         KalturaStartWidgetSessionResponse
 * Server failure response type: KalturaAPIException
 */
class SessionStartWidgetSessionAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaStartWidgetSessionResponse', responseConstructor: KalturaStartWidgetSessionResponse });
        if (typeof this.expiry === 'undefined')
            this.expiry = 86400;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'session' },
            action: { type: 'c', default: 'startWidgetSession' },
            widgetId: { type: 's' },
            expiry: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'stats' action 'collect'.
 *
 * Usage: Will write to the event log a single line representing the event
 * client version - will help interprete the line structure. different client versions might have slightly different data/data formats in the line
 * event_id - number is the row number in yuval's excel
 * datetime - same format as MySql's datetime - can change and should reflect the time zone
 * session id - can be some big random number or guid
 * partner id
 * entry id
 * unique viewer
 * widget id
 * ui_conf id
 * uid - the puser id as set by the ppartner
 * current point - in milliseconds
 * duration - milliseconds
 * user ip
 * process duration - in milliseconds
 * control id
 * seek
 * new point
 * referrer
 *
 *
 * KalturaStatsEvent $event
 *
 * Server response type:         boolean
 * Server failure response type: KalturaAPIException
 */
class StatsCollectAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'b', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'stats' },
            action: { type: 'c', default: 'collect' },
            event: { type: 'o', subTypeConstructor: KalturaStatsEvent, subType: 'KalturaStatsEvent' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'stats' action 'kmcCollect'.
 *
 * Usage: Will collect the kmcEvent sent form the KMC client
 * // this will actually be an empty function because all events will be sent using GET and will anyway be logged in the apache log
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class StatsKmcCollectAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'stats' },
            action: { type: 'c', default: 'kmcCollect' },
            kmcEvent: { type: 'o', subTypeConstructor: KalturaStatsKmcEvent, subType: 'KalturaStatsKmcEvent' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'stats' action 'reportDeviceCapabilities'.
 *
 * Usage: Use this action to report device capabilities to the kaltura server
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class StatsReportDeviceCapabilitiesAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'stats' },
            action: { type: 'c', default: 'reportDeviceCapabilities' },
            data: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'stats' action 'reportError'.
 *
 * Usage: Use this action to report errors to the kaltura server
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class StatsReportErrorAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'stats' },
            action: { type: 'c', default: 'reportError' },
            errorCode: { type: 's' },
            errorMessage: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'stats' action 'reportKceError'.
 *
 *
 *
 * Server response type:         KalturaCEError
 * Server failure response type: KalturaAPIException
 */
class StatsReportKceErrorAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCEError', responseConstructor: KalturaCEError });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'stats' },
            action: { type: 'c', default: 'reportKceError' },
            kalturaCEError: { type: 'o', subTypeConstructor: KalturaCEError, subType: 'KalturaCEError' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'storageProfile' action 'add'.
 *
 * Usage: Adds a storage profile to the Kaltura DB
 *
 * Server response type:         KalturaStorageProfile
 * Server failure response type: KalturaAPIException
 */
class StorageProfileAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaStorageProfile', responseConstructor: KalturaStorageProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'storageprofile' },
            action: { type: 'c', default: 'add' },
            storageProfile: { type: 'o', subTypeConstructor: KalturaStorageProfile, subType: 'KalturaStorageProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'storageProfile' action 'get'.
 *
 * Usage: Get storage profile by id
 *
 * Server response type:         KalturaStorageProfile
 * Server failure response type: KalturaAPIException
 */
class StorageProfileGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaStorageProfile', responseConstructor: KalturaStorageProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'storageprofile' },
            action: { type: 'c', default: 'get' },
            storageProfileId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'storageProfile' action 'list'.
 *
 *
 *
 * Server response type:         KalturaStorageProfileListResponse
 * Server failure response type: KalturaAPIException
 */
class StorageProfileListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaStorageProfileListResponse', responseConstructor: KalturaStorageProfileListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'storageprofile' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaStorageProfileFilter, subType: 'KalturaStorageProfileFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'storageProfile' action 'update'.
 *
 * Usage: Update storage profile by id
 *
 * Server response type:         KalturaStorageProfile
 * Server failure response type: KalturaAPIException
 */
class StorageProfileUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaStorageProfile', responseConstructor: KalturaStorageProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'storageprofile' },
            action: { type: 'c', default: 'update' },
            storageProfileId: { type: 'n' },
            storageProfile: { type: 'o', subTypeConstructor: KalturaStorageProfile, subType: 'KalturaStorageProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'storageProfile' action 'updateStatus'.
 *
 *
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class StorageProfileUpdateStatusAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'storageprofile' },
            action: { type: 'c', default: 'updateStatus' },
            storageId: { type: 'n' },
            status: { type: 'en', subTypeConstructor: KalturaStorageProfileStatus, subType: 'KalturaStorageProfileStatus' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'syndicationFeed' action 'add'.
 *
 * Usage: Add new Syndication Feed
 *
 * Server response type:         KalturaBaseSyndicationFeed
 * Server failure response type: KalturaAPIException
 */
class SyndicationFeedAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseSyndicationFeed', responseConstructor: KalturaBaseSyndicationFeed });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'syndicationfeed' },
            action: { type: 'c', default: 'add' },
            syndicationFeed: { type: 'o', subTypeConstructor: KalturaBaseSyndicationFeed, subType: 'KalturaBaseSyndicationFeed' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'syndicationFeed' action 'delete'.
 *
 * Usage: Delete Syndication Feed by ID
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class SyndicationFeedDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'syndicationfeed' },
            action: { type: 'c', default: 'delete' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'syndicationFeed' action 'get'.
 *
 * Usage: Get Syndication Feed by ID
 *
 * Server response type:         KalturaBaseSyndicationFeed
 * Server failure response type: KalturaAPIException
 */
class SyndicationFeedGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseSyndicationFeed', responseConstructor: KalturaBaseSyndicationFeed });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'syndicationfeed' },
            action: { type: 'c', default: 'get' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'syndicationFeed' action 'getEntryCount'.
 *
 * Usage: get entry count for a syndication feed
 *
 * Server response type:         KalturaSyndicationFeedEntryCount
 * Server failure response type: KalturaAPIException
 */
class SyndicationFeedGetEntryCountAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaSyndicationFeedEntryCount', responseConstructor: KalturaSyndicationFeedEntryCount });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'syndicationfeed' },
            action: { type: 'c', default: 'getEntryCount' },
            feedId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'syndicationFeed' action 'list'.
 *
 * Usage: List Syndication Feeds by filter with paging support
 *
 * Server response type:         KalturaBaseSyndicationFeedListResponse
 * Server failure response type: KalturaAPIException
 */
class SyndicationFeedListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseSyndicationFeedListResponse', responseConstructor: KalturaBaseSyndicationFeedListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'syndicationfeed' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaBaseSyndicationFeedFilter, subType: 'KalturaBaseSyndicationFeedFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'syndicationFeed' action 'requestConversion'.
 *
 * Usage: request conversion for all entries that doesnt have the required flavor param
 * returns a comma-separated ids of conversion jobs
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class SyndicationFeedRequestConversionAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'syndicationfeed' },
            action: { type: 'c', default: 'requestConversion' },
            feedId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'syndicationFeed' action 'update'.
 *
 * Usage: Update Syndication Feed by ID
 *
 * Server response type:         KalturaBaseSyndicationFeed
 * Server failure response type: KalturaAPIException
 */
class SyndicationFeedUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseSyndicationFeed', responseConstructor: KalturaBaseSyndicationFeed });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'syndicationfeed' },
            action: { type: 'c', default: 'update' },
            id: { type: 's' },
            syndicationFeed: { type: 'o', subTypeConstructor: KalturaBaseSyndicationFeed, subType: 'KalturaBaseSyndicationFeed' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'system' action 'getTime'.
 *
 *
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class SystemGetTimeAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'system' },
            action: { type: 'c', default: 'getTime' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'system' action 'getVersion'.
 *
 *
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class SystemGetVersionAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'system' },
            action: { type: 'c', default: 'getVersion' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'system' action 'ping'.
 *
 *
 *
 * Server response type:         boolean
 * Server failure response type: KalturaAPIException
 */
class SystemPingAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'b', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'system' },
            action: { type: 'c', default: 'ping' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'system' action 'pingDatabase'.
 *
 *
 *
 * Server response type:         boolean
 * Server failure response type: KalturaAPIException
 */
class SystemPingDatabaseAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'b', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'system' },
            action: { type: 'c', default: 'pingDatabase' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'add'.
 *
 * Usage: Add thumbnail asset
 *
 * Server response type:         KalturaThumbAsset
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaThumbAsset', responseConstructor: KalturaThumbAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'add' },
            entryId: { type: 's' },
            thumbAsset: { type: 'o', subTypeConstructor: KalturaThumbAsset, subType: 'KalturaThumbAsset' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'addFromImage'.
 *
 *
 *
 * Server response type:         KalturaThumbAsset
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetAddFromImageAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaThumbAsset', responseConstructor: KalturaThumbAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'addFromImage' },
            entryId: { type: 's' },
            fileData: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'addFromUrl'.
 *
 *
 *
 * Server response type:         KalturaThumbAsset
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetAddFromUrlAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaThumbAsset', responseConstructor: KalturaThumbAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'addFromUrl' },
            entryId: { type: 's' },
            url: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'delete'.
 *
 *
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'delete' },
            thumbAssetId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'export'.
 *
 * Usage: manually export an asset
 *
 * Server response type:         KalturaFlavorAsset
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetExportAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaFlavorAsset', responseConstructor: KalturaFlavorAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'export' },
            assetId: { type: 's' },
            storageProfileId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'generate'.
 *
 *
 *
 * Server response type:         KalturaThumbAsset
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetGenerateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaThumbAsset', responseConstructor: KalturaThumbAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'generate' },
            entryId: { type: 's' },
            thumbParams: { type: 'o', subTypeConstructor: KalturaThumbParams, subType: 'KalturaThumbParams' },
            sourceAssetId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'generateByEntryId'.
 *
 *
 *
 * Server response type:         KalturaThumbAsset
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetGenerateByEntryIdAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaThumbAsset', responseConstructor: KalturaThumbAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'generateByEntryId' },
            entryId: { type: 's' },
            destThumbParamsId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'get'.
 *
 *
 *
 * Server response type:         KalturaThumbAsset
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaThumbAsset', responseConstructor: KalturaThumbAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'get' },
            thumbAssetId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'getByEntryId'.
 *
 *
 *
 * Server response type:         KalturaThumbAsset[]
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetGetByEntryIdAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaThumbAsset', responseConstructor: KalturaThumbAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'getByEntryId' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'getRemotePaths'.
 *
 * Usage: Get remote storage existing paths for the asset
 *
 * Server response type:         KalturaRemotePathListResponse
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetGetRemotePathsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaRemotePathListResponse', responseConstructor: KalturaRemotePathListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'getRemotePaths' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'getUrl'.
 *
 * Usage: Get download URL for the asset
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetGetUrlAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'getUrl' },
            id: { type: 's' },
            storageId: { type: 'n' },
            thumbParams: { type: 'o', subTypeConstructor: KalturaThumbParams, subType: 'KalturaThumbParams' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'list'.
 *
 * Usage: List Thumbnail Assets by filter and pager
 *
 * Server response type:         KalturaThumbAssetListResponse
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaThumbAssetListResponse', responseConstructor: KalturaThumbAssetListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaAssetFilter, subType: 'KalturaAssetFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'regenerate'.
 *
 *
 *
 * Server response type:         KalturaThumbAsset
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetRegenerateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaThumbAsset', responseConstructor: KalturaThumbAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'regenerate' },
            thumbAssetId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'serve'.
 *
 * Usage: Serves thumbnail by its id
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetServeAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'serve' },
            thumbAssetId: { type: 's' },
            version: { type: 'n' },
            thumbParams: { type: 'o', subTypeConstructor: KalturaThumbParams, subType: 'KalturaThumbParams' },
            options: { type: 'o', subTypeConstructor: KalturaThumbnailServeOptions, subType: 'KalturaThumbnailServeOptions' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'serveByEntryId'.
 *
 * Usage: Serves thumbnail by entry id and thumnail params id
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetServeByEntryIdAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'serveByEntryId' },
            entryId: { type: 's' },
            thumbParamId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'setAsDefault'.
 *
 * Usage: Tags the thumbnail as DEFAULT_THUMB and removes that tag from all other thumbnail assets of the entry.
 * Create a new file sync link on the entry thumbnail that points to the thumbnail asset file sync
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetSetAsDefaultAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'setAsDefault' },
            thumbAssetId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'setContent'.
 *
 * Usage: Update content of thumbnail asset
 *
 * Server response type:         KalturaThumbAsset
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetSetContentAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaThumbAsset', responseConstructor: KalturaThumbAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'setContent' },
            id: { type: 's' },
            contentResource: { type: 'o', subTypeConstructor: KalturaContentResource, subType: 'KalturaContentResource' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbAsset' action 'update'.
 *
 * Usage: Update thumbnail asset
 *
 * Server response type:         KalturaThumbAsset
 * Server failure response type: KalturaAPIException
 */
class ThumbAssetUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaThumbAsset', responseConstructor: KalturaThumbAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbasset' },
            action: { type: 'c', default: 'update' },
            id: { type: 's' },
            thumbAsset: { type: 'o', subTypeConstructor: KalturaThumbAsset, subType: 'KalturaThumbAsset' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbParamsOutput' action 'get'.
 *
 * Usage: Get thumb params output object by ID
 *
 * Server response type:         KalturaThumbParamsOutput
 * Server failure response type: KalturaAPIException
 */
class ThumbParamsOutputGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaThumbParamsOutput', responseConstructor: KalturaThumbParamsOutput });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbparamsoutput' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbParamsOutput' action 'list'.
 *
 * Usage: List thumb params output objects by filter and pager
 *
 * Server response type:         KalturaThumbParamsOutputListResponse
 * Server failure response type: KalturaAPIException
 */
class ThumbParamsOutputListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaThumbParamsOutputListResponse', responseConstructor: KalturaThumbParamsOutputListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbparamsoutput' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaThumbParamsOutputFilter, subType: 'KalturaThumbParamsOutputFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbParams' action 'add'.
 *
 * Usage: Add new Thumb Params
 *
 * Server response type:         KalturaThumbParams
 * Server failure response type: KalturaAPIException
 */
class ThumbParamsAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaThumbParams', responseConstructor: KalturaThumbParams });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbparams' },
            action: { type: 'c', default: 'add' },
            thumbParams: { type: 'o', subTypeConstructor: KalturaThumbParams, subType: 'KalturaThumbParams' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbParams' action 'delete'.
 *
 * Usage: Delete Thumb Params by ID
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class ThumbParamsDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbparams' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbParams' action 'get'.
 *
 * Usage: Get Thumb Params by ID
 *
 * Server response type:         KalturaThumbParams
 * Server failure response type: KalturaAPIException
 */
class ThumbParamsGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaThumbParams', responseConstructor: KalturaThumbParams });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbparams' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbParams' action 'getByConversionProfileId'.
 *
 * Usage: Get Thumb Params by Conversion Profile ID
 *
 * Server response type:         KalturaThumbParams[]
 * Server failure response type: KalturaAPIException
 */
class ThumbParamsGetByConversionProfileIdAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaThumbParams', responseConstructor: KalturaThumbParams });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbparams' },
            action: { type: 'c', default: 'getByConversionProfileId' },
            conversionProfileId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbParams' action 'list'.
 *
 * Usage: List Thumb Params by filter with paging support (By default - all system default params will be listed too)
 *
 * Server response type:         KalturaThumbParamsListResponse
 * Server failure response type: KalturaAPIException
 */
class ThumbParamsListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaThumbParamsListResponse', responseConstructor: KalturaThumbParamsListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbparams' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaThumbParamsFilter, subType: 'KalturaThumbParamsFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'thumbParams' action 'update'.
 *
 * Usage: Update Thumb Params by ID
 *
 * Server response type:         KalturaThumbParams
 * Server failure response type: KalturaAPIException
 */
class ThumbParamsUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaThumbParams', responseConstructor: KalturaThumbParams });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'thumbparams' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            thumbParams: { type: 'o', subTypeConstructor: KalturaThumbParams, subType: 'KalturaThumbParams' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'uiConf' action 'add'.
 *
 * Usage: UIConf Add action allows you to add a UIConf to Kaltura DB
 *
 * Server response type:         KalturaUiConf
 * Server failure response type: KalturaAPIException
 */
class UiConfAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUiConf', responseConstructor: KalturaUiConf });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'uiconf' },
            action: { type: 'c', default: 'add' },
            uiConf: { type: 'o', subTypeConstructor: KalturaUiConf, subType: 'KalturaUiConf' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'uiConf' action 'clone'.
 *
 * Usage: Clone an existing UIConf
 *
 * Server response type:         KalturaUiConf
 * Server failure response type: KalturaAPIException
 */
class UiConfCloneAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUiConf', responseConstructor: KalturaUiConf });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'uiconf' },
            action: { type: 'c', default: 'clone' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'uiConf' action 'delete'.
 *
 * Usage: Delete an existing UIConf
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class UiConfDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'uiconf' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'uiConf' action 'get'.
 *
 * Usage: Retrieve a UIConf by id
 *
 * Server response type:         KalturaUiConf
 * Server failure response type: KalturaAPIException
 */
class UiConfGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUiConf', responseConstructor: KalturaUiConf });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'uiconf' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'uiConf' action 'getAvailableTypes'.
 *
 * Usage: Retrieve a list of all available versions by object type
 *
 * Server response type:         KalturaUiConfTypeInfo[]
 * Server failure response type: KalturaAPIException
 */
class UiConfGetAvailableTypesAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaUiConfTypeInfo', responseConstructor: KalturaUiConfTypeInfo });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'uiconf' },
            action: { type: 'c', default: 'getAvailableTypes' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'uiConf' action 'list'.
 *
 * Usage: Retrieve a list of available UIConfs
 *
 * Server response type:         KalturaUiConfListResponse
 * Server failure response type: KalturaAPIException
 */
class UiConfListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUiConfListResponse', responseConstructor: KalturaUiConfListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'uiconf' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaUiConfFilter, subType: 'KalturaUiConfFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'uiConf' action 'listTemplates'.
 *
 * Usage: retrieve a list of available template UIConfs
 *
 * Server response type:         KalturaUiConfListResponse
 * Server failure response type: KalturaAPIException
 */
class UiConfListTemplatesAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUiConfListResponse', responseConstructor: KalturaUiConfListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'uiconf' },
            action: { type: 'c', default: 'listTemplates' },
            filter: { type: 'o', subTypeConstructor: KalturaUiConfFilter, subType: 'KalturaUiConfFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'uiConf' action 'update'.
 *
 * Usage: Update an existing UIConf
 *
 * Server response type:         KalturaUiConf
 * Server failure response type: KalturaAPIException
 */
class UiConfUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUiConf', responseConstructor: KalturaUiConf });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'uiconf' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            uiConf: { type: 'o', subTypeConstructor: KalturaUiConf, subType: 'KalturaUiConf' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'upload' action 'getUploadedFileTokenByFileName'.
 *
 *
 *
 * Server response type:         KalturaUploadResponse
 * Server failure response type: KalturaAPIException
 */
class UploadGetUploadedFileTokenByFileNameAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUploadResponse', responseConstructor: KalturaUploadResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'upload' },
            action: { type: 'c', default: 'getUploadedFileTokenByFileName' },
            fileName: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'upload' action 'upload'.
 *
 *
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class UploadUploadAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'upload' },
            action: { type: 'c', default: 'upload' },
            fileData: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'uploadToken' action 'add'.
 *
 * Usage: Adds new upload token to upload a file
 *
 * Server response type:         KalturaUploadToken
 * Server failure response type: KalturaAPIException
 */
class UploadTokenAddAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUploadToken', responseConstructor: KalturaUploadToken });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'uploadtoken' },
            action: { type: 'c', default: 'add' },
            uploadToken: { type: 'o', subTypeConstructor: KalturaUploadToken, subType: 'KalturaUploadToken' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'uploadToken' action 'delete'.
 *
 * Usage: Deletes the upload token by upload token id
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class UploadTokenDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'uploadtoken' },
            action: { type: 'c', default: 'delete' },
            uploadTokenId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'uploadToken' action 'get'.
 *
 * Usage: Get upload token by id
 *
 * Server response type:         KalturaUploadToken
 * Server failure response type: KalturaAPIException
 */
class UploadTokenGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUploadToken', responseConstructor: KalturaUploadToken });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'uploadtoken' },
            action: { type: 'c', default: 'get' },
            uploadTokenId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'uploadToken' action 'list'.
 *
 * Usage: List upload token by filter with pager support.
 * When using a user session the service will be restricted to users objects only
 *
 * Server response type:         KalturaUploadTokenListResponse
 * Server failure response type: KalturaAPIException
 */
class UploadTokenListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUploadTokenListResponse', responseConstructor: KalturaUploadTokenListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'uploadtoken' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaUploadTokenFilter, subType: 'KalturaUploadTokenFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'uploadToken' action 'upload'.
 *
 * Usage: Upload a file using the upload token id, returns an error on failure (an exception will be thrown when using one of the Kaltura clients)
 * Chunks can be uploaded in parallel and they will be appended according to their resumeAt position.
 * A parallel upload session should have three stages:
 * 1. A single upload with resume=false and finalChunk=false
 * 2. Parallel upload requests each with resume=true,finalChunk=false and the expected resumetAt position.
 * If a chunk fails to upload it can be re-uploaded.
 * 3. After all of the chunks have been uploaded a final chunk (can be of zero size) should be uploaded
 * with resume=true, finalChunk=true and the expected resumeAt position. In case an UPLOAD_TOKEN_CANNOT_MATCH_EXPECTED_SIZE exception
 * has been returned (indicating not all of the chunks were appended yet) the final request can be retried
 *
 * Server response type:         KalturaUploadToken
 * Server failure response type: KalturaAPIException
 */
class UploadTokenUploadAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUploadToken', responseConstructor: KalturaUploadToken });
        if (typeof this.resume === 'undefined')
            this.resume = false;
        if (typeof this.finalChunk === 'undefined')
            this.finalChunk = true;
        if (typeof this.resumeAt === 'undefined')
            this.resumeAt = -1;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'uploadtoken' },
            action: { type: 'c', default: 'upload' },
            uploadTokenId: { type: 's' },
            fileData: { type: 'f' },
            resume: { type: 'b' },
            finalChunk: { type: 'b' },
            resumeAt: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'userEntry' action 'add'.
 *
 * Usage: Adds a user_entry to the Kaltura DB
 *
 * Server response type:         KalturaUserEntry
 * Server failure response type: KalturaAPIException
 */
class UserEntryAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUserEntry', responseConstructor: KalturaUserEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'userentry' },
            action: { type: 'c', default: 'add' },
            userEntry: { type: 'o', subTypeConstructor: KalturaUserEntry, subType: 'KalturaUserEntry' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'userEntry' action 'bulkDelete'.
 *
 *
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class UserEntryBulkDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'userentry' },
            action: { type: 'c', default: 'bulkDelete' },
            filter: { type: 'o', subTypeConstructor: KalturaUserEntryFilter, subType: 'KalturaUserEntryFilter' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'userEntry' action 'delete'.
 *
 *
 *
 * Server response type:         KalturaUserEntry
 * Server failure response type: KalturaAPIException
 */
class UserEntryDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUserEntry', responseConstructor: KalturaUserEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'userentry' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'userEntry' action 'get'.
 *
 *
 *
 * Server response type:         KalturaUserEntry
 * Server failure response type: KalturaAPIException
 */
class UserEntryGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUserEntry', responseConstructor: KalturaUserEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'userentry' },
            action: { type: 'c', default: 'get' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'userEntry' action 'list'.
 *
 *
 *
 * Server response type:         KalturaUserEntryListResponse
 * Server failure response type: KalturaAPIException
 */
class UserEntryListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUserEntryListResponse', responseConstructor: KalturaUserEntryListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'userentry' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaUserEntryFilter, subType: 'KalturaUserEntryFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'userEntry' action 'submitQuiz'.
 *
 * Usage: Submits the quiz so that it's status will be submitted and calculates the score for the quiz
 *
 * Server response type:         KalturaQuizUserEntry
 * Server failure response type: KalturaAPIException
 */
class UserEntrySubmitQuizAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaQuizUserEntry', responseConstructor: KalturaQuizUserEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'userentry' },
            action: { type: 'c', default: 'submitQuiz' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'userEntry' action 'update'.
 *
 *
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class UserEntryUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'userentry' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            userEntry: { type: 'o', subTypeConstructor: KalturaUserEntry, subType: 'KalturaUserEntry' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'userRole' action 'add'.
 *
 * Usage: Adds a new user role object to the account
 *
 * Server response type:         KalturaUserRole
 * Server failure response type: KalturaAPIException
 */
class UserRoleAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUserRole', responseConstructor: KalturaUserRole });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'userrole' },
            action: { type: 'c', default: 'add' },
            userRole: { type: 'o', subTypeConstructor: KalturaUserRole, subType: 'KalturaUserRole' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'userRole' action 'clone'.
 *
 * Usage: Creates a new user role object that is a duplicate of an existing role
 *
 * Server response type:         KalturaUserRole
 * Server failure response type: KalturaAPIException
 */
class UserRoleCloneAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUserRole', responseConstructor: KalturaUserRole });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'userrole' },
            action: { type: 'c', default: 'clone' },
            userRoleId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'userRole' action 'delete'.
 *
 * Usage: Deletes an existing user role object
 *
 * Server response type:         KalturaUserRole
 * Server failure response type: KalturaAPIException
 */
class UserRoleDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUserRole', responseConstructor: KalturaUserRole });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'userrole' },
            action: { type: 'c', default: 'delete' },
            userRoleId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'userRole' action 'get'.
 *
 * Usage: Retrieves a user role object using its ID
 *
 * Server response type:         KalturaUserRole
 * Server failure response type: KalturaAPIException
 */
class UserRoleGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUserRole', responseConstructor: KalturaUserRole });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'userrole' },
            action: { type: 'c', default: 'get' },
            userRoleId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'userRole' action 'list'.
 *
 * Usage: Lists user role objects that are associated with an account.
 * Blocked user roles are listed unless you use a filter to exclude them.
 * Deleted user roles are not listed unless you use a filter to include them
 *
 * Server response type:         KalturaUserRoleListResponse
 * Server failure response type: KalturaAPIException
 */
class UserRoleListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUserRoleListResponse', responseConstructor: KalturaUserRoleListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'userrole' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaUserRoleFilter, subType: 'KalturaUserRoleFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'userRole' action 'update'.
 *
 * Usage: Updates an existing user role object
 *
 * Server response type:         KalturaUserRole
 * Server failure response type: KalturaAPIException
 */
class UserRoleUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUserRole', responseConstructor: KalturaUserRole });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'userrole' },
            action: { type: 'c', default: 'update' },
            userRoleId: { type: 'n' },
            userRole: { type: 'o', subTypeConstructor: KalturaUserRole, subType: 'KalturaUserRole' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'add'.
 *
 * Usage: Adds a new user to an existing account in the Kaltura database.
 * Input param $id is the unique identifier in the partner's system
 *
 * Server response type:         KalturaUser
 * Server failure response type: KalturaAPIException
 */
class UserAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUser', responseConstructor: KalturaUser });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'add' },
            user: { type: 'o', subTypeConstructor: KalturaUser, subType: 'KalturaUser' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'addFromBulkUpload'.
 *
 *
 *
 * Server response type:         KalturaBulkUpload
 * Server failure response type: KalturaAPIException
 */
class UserAddFromBulkUploadAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBulkUpload', responseConstructor: KalturaBulkUpload });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'addFromBulkUpload' },
            fileData: { type: 'f' },
            bulkUploadData: { type: 'o', subTypeConstructor: KalturaBulkUploadJobData, subType: 'KalturaBulkUploadJobData' },
            bulkUploadUserData: { type: 'o', subTypeConstructor: KalturaBulkUploadUserData, subType: 'KalturaBulkUploadUserData' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'checkLoginDataExists'.
 *
 * Usage: Action which checks whther user login
 *
 * Server response type:         boolean
 * Server failure response type: KalturaAPIException
 */
class UserCheckLoginDataExistsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'b', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'checkLoginDataExists' },
            filter: { type: 'o', subTypeConstructor: KalturaUserLoginDataFilter, subType: 'KalturaUserLoginDataFilter' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'delete'.
 *
 * Usage: Deletes a user from a partner account
 *
 * Server response type:         KalturaUser
 * Server failure response type: KalturaAPIException
 */
class UserDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUser', responseConstructor: KalturaUser });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'delete' },
            userId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'disableLogin'.
 *
 * Usage: Disables a user's ability to log into a partner account using an email address and a password.
 * You may use either a userId or a loginId parameter for this action
 *
 * Server response type:         KalturaUser
 * Server failure response type: KalturaAPIException
 */
class UserDisableLoginAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUser', responseConstructor: KalturaUser });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'disableLogin' },
            userId: { type: 's' },
            loginId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'enableLogin'.
 *
 * Usage: Enables a user to log into a partner account using an email address and a password
 *
 * Server response type:         KalturaUser
 * Server failure response type: KalturaAPIException
 */
class UserEnableLoginAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUser', responseConstructor: KalturaUser });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'enableLogin' },
            userId: { type: 's' },
            loginId: { type: 's' },
            password: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'exportToCsv'.
 *
 * Usage: Creates a batch job that sends an email with a link to download a CSV containing a list of users
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class UserExportToCsvAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
        if (typeof this.additionalFields === 'undefined')
            this.additionalFields = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'exportToCsv' },
            filter: { type: 'o', subTypeConstructor: KalturaUserFilter, subType: 'KalturaUserFilter' },
            metadataProfileId: { type: 'n' },
            additionalFields: { type: 'a', subTypeConstructor: KalturaCsvAdditionalFieldInfo, subType: 'KalturaCsvAdditionalFieldInfo' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'get'.
 *
 * Usage: Retrieves a user object for a specified user ID
 *
 * Server response type:         KalturaUser
 * Server failure response type: KalturaAPIException
 */
class UserGetAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUser', responseConstructor: KalturaUser });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'get' },
            userId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'getByLoginId'.
 *
 * Usage: Retrieves a user object for a user's login ID and partner ID.
 * A login ID is the email address used by a user to log into the system
 *
 * Server response type:         KalturaUser
 * Server failure response type: KalturaAPIException
 */
class UserGetByLoginIdAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUser', responseConstructor: KalturaUser });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'getByLoginId' },
            loginId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'index'.
 *
 * Usage: Index an entry by id
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class UserIndexAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
        if (typeof this.shouldUpdate === 'undefined')
            this.shouldUpdate = true;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'index' },
            id: { type: 's' },
            shouldUpdate: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'list'.
 *
 * Usage: Lists user objects that are associated with an account.
 * Blocked users are listed unless you use a filter to exclude them.
 * Deleted users are not listed unless you use a filter to include them
 *
 * Server response type:         KalturaUserListResponse
 * Server failure response type: KalturaAPIException
 */
class UserListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUserListResponse', responseConstructor: KalturaUserListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaUserFilter, subType: 'KalturaUserFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'login'.
 *
 * Usage: Logs a user into a partner account with a partner ID, a partner user ID (puser), and a user password
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class UserLoginAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
        if (typeof this.expiry === 'undefined')
            this.expiry = 86400;
        if (typeof this.privileges === 'undefined')
            this.privileges = "*";
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'login' },
            partnerId: { type: 'n' },
            userId: { type: 's' },
            password: { type: 's' },
            expiry: { type: 'n' },
            privileges: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'loginByKs'.
 *
 * Usage: Logs a user to the destination account provided the KS' user ID is associated with the destination account and the loginData ID matches
 *
 * Server response type:         KalturaSessionResponse
 * Server failure response type: KalturaAPIException
 */
class UserLoginByKsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaSessionResponse', responseConstructor: KalturaSessionResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'loginByKs' },
            requestedPartnerId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'loginByLoginId'.
 *
 * Usage: Logs a user into a partner account with a user login ID and a user password
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class UserLoginByLoginIdAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
        if (typeof this.expiry === 'undefined')
            this.expiry = 86400;
        if (typeof this.privileges === 'undefined')
            this.privileges = "*";
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'loginByLoginId' },
            loginId: { type: 's' },
            password: { type: 's' },
            partnerId: { type: 'n' },
            expiry: { type: 'n' },
            privileges: { type: 's' },
            otp: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'notifyBan'.
 *
 * Usage: Notifies that a user is banned from an account
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class UserNotifyBanAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'notifyBan' },
            userId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'resetPassword'.
 *
 * Usage: Reset user's password and send the user an email to generate a new one
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class UserResetPasswordAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'resetPassword' },
            email: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'serveCsv'.
 *
 * Usage: Will serve a requested CSV
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class UserServeCsvAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'serveCsv' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'setInitialPassword'.
 *
 * Usage: Set initial user password
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class UserSetInitialPasswordAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'setInitialPassword' },
            hashKey: { type: 's' },
            newPassword: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'update'.
 *
 * Usage: Updates an existing user object.
 * You can also use this action to update the userId
 *
 * Server response type:         KalturaUser
 * Server failure response type: KalturaAPIException
 */
class UserUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaUser', responseConstructor: KalturaUser });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'update' },
            userId: { type: 's' },
            user: { type: 'o', subTypeConstructor: KalturaUser, subType: 'KalturaUser' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'user' action 'updateLoginData'.
 *
 * Usage: Updates a user's login data: email, password, name
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class UserUpdateLoginDataAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'user' },
            action: { type: 'c', default: 'updateLoginData' },
            oldLoginId: { type: 's' },
            password: { type: 's' },
            newLoginId: { type: 's' },
            newPassword: { type: 's' },
            newFirstName: { type: 's' },
            newLastName: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'widget' action 'add'.
 *
 * Usage: Add new widget, can be attached to entry or kshow
 * SourceWidget is ignored
 *
 * Server response type:         KalturaWidget
 * Server failure response type: KalturaAPIException
 */
class WidgetAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaWidget', responseConstructor: KalturaWidget });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'widget' },
            action: { type: 'c', default: 'add' },
            widget: { type: 'o', subTypeConstructor: KalturaWidget, subType: 'KalturaWidget' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'widget' action 'clone'.
 *
 * Usage: Add widget based on existing widget.
 * Must provide valid sourceWidgetId
 *
 * Server response type:         KalturaWidget
 * Server failure response type: KalturaAPIException
 */
class WidgetCloneAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaWidget', responseConstructor: KalturaWidget });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'widget' },
            action: { type: 'c', default: 'clone' },
            widget: { type: 'o', subTypeConstructor: KalturaWidget, subType: 'KalturaWidget' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'widget' action 'get'.
 *
 * Usage: Get widget by id
 *
 * Server response type:         KalturaWidget
 * Server failure response type: KalturaAPIException
 */
class WidgetGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaWidget', responseConstructor: KalturaWidget });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'widget' },
            action: { type: 'c', default: 'get' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'widget' action 'list'.
 *
 * Usage: Retrieve a list of available widget depends on the filter given
 *
 * Server response type:         KalturaWidgetListResponse
 * Server failure response type: KalturaAPIException
 */
class WidgetListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaWidgetListResponse', responseConstructor: KalturaWidgetListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'widget' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaWidgetFilter, subType: 'KalturaWidgetFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'widget' action 'update'.
 *
 * Usage: Update exisiting widget
 *
 * Server response type:         KalturaWidget
 * Server failure response type: KalturaAPIException
 */
class WidgetUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaWidget', responseConstructor: KalturaWidget });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'widget' },
            action: { type: 'c', default: 'update' },
            id: { type: 's' },
            widget: { type: 'o', subTypeConstructor: KalturaWidget, subType: 'KalturaWidget' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'xInternal' action 'xAddBulkDownload'.
 *
 * Usage: Creates new download job for multiple entry ids (comma separated), an email will be sent when the job is done
 * This sevice support the following entries:
 * - MediaEntry
 * - Video will be converted using the flavor params id
 * - Audio will be downloaded as MP3
 * - Image will be downloaded as Jpeg
 * - MixEntry will be flattened using the flavor params id
 * - Other entry types are not supported
 * Returns the admin email that the email message will be sent to
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class XInternalXAddBulkDownloadAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'xinternal' },
            action: { type: 'c', default: 'xAddBulkDownload' },
            entryIds: { type: 's' },
            flavorParamsId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'annotation' action 'add'.
 *
 * Usage: Allows you to add an annotation object associated with an entry
 *
 * Server response type:         KalturaAnnotation
 * Server failure response type: KalturaAPIException
 */
class AnnotationAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAnnotation', responseConstructor: KalturaAnnotation });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'annotation_annotation' },
            action: { type: 'c', default: 'add' },
            annotation: { type: 'o', subTypeConstructor: KalturaCuePoint, subType: 'KalturaCuePoint' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'annotation' action 'addFromBulk'.
 *
 * Usage: Allows you to add multiple cue points objects by uploading XML that contains multiple cue point definitions
 *
 * Server response type:         KalturaCuePointListResponse
 * Server failure response type: KalturaAPIException
 */
class AnnotationAddFromBulkAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCuePointListResponse', responseConstructor: KalturaCuePointListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'annotation_annotation' },
            action: { type: 'c', default: 'addFromBulk' },
            fileData: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'annotation' action 'clone'.
 *
 * Usage: Clone cuePoint with id to given entry
 *
 * Server response type:         KalturaCuePoint
 * Server failure response type: KalturaAPIException
 */
class AnnotationCloneAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCuePoint', responseConstructor: KalturaCuePoint });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'annotation_annotation' },
            action: { type: 'c', default: 'clone' },
            id: { type: 's' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'annotation' action 'count'.
 *
 * Usage: count cue point objects by filter
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class AnnotationCountAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'annotation_annotation' },
            action: { type: 'c', default: 'count' },
            filter: { type: 'o', subTypeConstructor: KalturaCuePointFilter, subType: 'KalturaCuePointFilter' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'annotation' action 'delete'.
 *
 * Usage: delete cue point by id, and delete all children cue points
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class AnnotationDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'annotation_annotation' },
            action: { type: 'c', default: 'delete' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'annotation' action 'get'.
 *
 * Usage: Retrieve an CuePoint object by id
 *
 * Server response type:         KalturaCuePoint
 * Server failure response type: KalturaAPIException
 */
class AnnotationGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCuePoint', responseConstructor: KalturaCuePoint });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'annotation_annotation' },
            action: { type: 'c', default: 'get' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'annotation' action 'list'.
 *
 * Usage: List annotation objects by filter and pager
 *
 * Server response type:         KalturaAnnotationListResponse
 * Server failure response type: KalturaAPIException
 */
class AnnotationListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAnnotationListResponse', responseConstructor: KalturaAnnotationListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'annotation_annotation' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaCuePointFilter, subType: 'KalturaCuePointFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'annotation' action 'serveBulk'.
 *
 * Usage: Download multiple cue points objects as XML definitions
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class AnnotationServeBulkAction extends KalturaFileRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'annotation_annotation' },
            action: { type: 'c', default: 'serveBulk' },
            filter: { type: 'o', subTypeConstructor: KalturaCuePointFilter, subType: 'KalturaCuePointFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'annotation' action 'update'.
 *
 * Usage: Update annotation by id
 *
 * Server response type:         KalturaAnnotation
 * Server failure response type: KalturaAPIException
 */
class AnnotationUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAnnotation', responseConstructor: KalturaAnnotation });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'annotation_annotation' },
            action: { type: 'c', default: 'update' },
            id: { type: 's' },
            annotation: { type: 'o', subTypeConstructor: KalturaCuePoint, subType: 'KalturaCuePoint' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'annotation' action 'updateCuePointsTimes'.
 *
 *
 *
 * Server response type:         KalturaCuePoint
 * Server failure response type: KalturaAPIException
 */
class AnnotationUpdateCuePointsTimesAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCuePoint', responseConstructor: KalturaCuePoint });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'annotation_annotation' },
            action: { type: 'c', default: 'updateCuePointsTimes' },
            id: { type: 's' },
            startTime: { type: 'n' },
            endTime: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'annotation' action 'updateStatus'.
 *
 * Usage: Update cuePoint status by id
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class AnnotationUpdateStatusAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'annotation_annotation' },
            action: { type: 'c', default: 'updateStatus' },
            id: { type: 's' },
            status: { type: 'en', subTypeConstructor: KalturaCuePointStatus, subType: 'KalturaCuePointStatus' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'aspera' action 'getFaspUrl'.
 *
 *
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class AsperaGetFaspUrlAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'aspera_aspera' },
            action: { type: 'c', default: 'getFaspUrl' },
            flavorAssetId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'attachmentAsset' action 'add'.
 *
 * Usage: Add attachment asset
 *
 * Server response type:         KalturaAttachmentAsset
 * Server failure response type: KalturaAPIException
 */
class AttachmentAssetAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAttachmentAsset', responseConstructor: KalturaAttachmentAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'attachment_attachmentasset' },
            action: { type: 'c', default: 'add' },
            entryId: { type: 's' },
            attachmentAsset: { type: 'o', subTypeConstructor: KalturaAttachmentAsset, subType: 'KalturaAttachmentAsset' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'attachmentAsset' action 'delete'.
 *
 *
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class AttachmentAssetDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'attachment_attachmentasset' },
            action: { type: 'c', default: 'delete' },
            attachmentAssetId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'attachmentAsset' action 'get'.
 *
 *
 *
 * Server response type:         KalturaAttachmentAsset
 * Server failure response type: KalturaAPIException
 */
class AttachmentAssetGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAttachmentAsset', responseConstructor: KalturaAttachmentAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'attachment_attachmentasset' },
            action: { type: 'c', default: 'get' },
            attachmentAssetId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'attachmentAsset' action 'getRemotePaths'.
 *
 * Usage: Get remote storage existing paths for the asset
 *
 * Server response type:         KalturaRemotePathListResponse
 * Server failure response type: KalturaAPIException
 */
class AttachmentAssetGetRemotePathsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaRemotePathListResponse', responseConstructor: KalturaRemotePathListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'attachment_attachmentasset' },
            action: { type: 'c', default: 'getRemotePaths' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'attachmentAsset' action 'getUrl'.
 *
 * Usage: Get download URL for the asset
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class AttachmentAssetGetUrlAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'attachment_attachmentasset' },
            action: { type: 'c', default: 'getUrl' },
            id: { type: 's' },
            storageId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'attachmentAsset' action 'list'.
 *
 * Usage: List attachment Assets by filter and pager
 *
 * Server response type:         KalturaAttachmentAssetListResponse
 * Server failure response type: KalturaAPIException
 */
class AttachmentAssetListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAttachmentAssetListResponse', responseConstructor: KalturaAttachmentAssetListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'attachment_attachmentasset' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaAssetFilter, subType: 'KalturaAssetFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'attachmentAsset' action 'serve'.
 *
 * Usage: Serves attachment by its id
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class AttachmentAssetServeAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'attachment_attachmentasset' },
            action: { type: 'c', default: 'serve' },
            attachmentAssetId: { type: 's' },
            serveOptions: { type: 'o', subTypeConstructor: KalturaAttachmentServeOptions, subType: 'KalturaAttachmentServeOptions' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'attachmentAsset' action 'setContent'.
 *
 * Usage: Update content of attachment asset
 *
 * Server response type:         KalturaAttachmentAsset
 * Server failure response type: KalturaAPIException
 */
class AttachmentAssetSetContentAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAttachmentAsset', responseConstructor: KalturaAttachmentAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'attachment_attachmentasset' },
            action: { type: 'c', default: 'setContent' },
            id: { type: 's' },
            contentResource: { type: 'o', subTypeConstructor: KalturaContentResource, subType: 'KalturaContentResource' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'attachmentAsset' action 'update'.
 *
 * Usage: Update attachment asset
 *
 * Server response type:         KalturaAttachmentAsset
 * Server failure response type: KalturaAPIException
 */
class AttachmentAssetUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAttachmentAsset', responseConstructor: KalturaAttachmentAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'attachment_attachmentasset' },
            action: { type: 'c', default: 'update' },
            id: { type: 's' },
            attachmentAsset: { type: 'o', subTypeConstructor: KalturaAttachmentAsset, subType: 'KalturaAttachmentAsset' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'auditTrail' action 'add'.
 *
 * Usage: Allows you to add an audit trail object and audit trail content associated with Kaltura object
 *
 * Server response type:         KalturaAuditTrail
 * Server failure response type: KalturaAPIException
 */
class AuditTrailAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAuditTrail', responseConstructor: KalturaAuditTrail });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'audit_audittrail' },
            action: { type: 'c', default: 'add' },
            auditTrail: { type: 'o', subTypeConstructor: KalturaAuditTrail, subType: 'KalturaAuditTrail' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'auditTrail' action 'get'.
 *
 * Usage: Retrieve an audit trail object by id
 *
 * Server response type:         KalturaAuditTrail
 * Server failure response type: KalturaAPIException
 */
class AuditTrailGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAuditTrail', responseConstructor: KalturaAuditTrail });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'audit_audittrail' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'auditTrail' action 'list'.
 *
 * Usage: List audit trail objects by filter and pager
 *
 * Server response type:         KalturaAuditTrailListResponse
 * Server failure response type: KalturaAPIException
 */
class AuditTrailListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaAuditTrailListResponse', responseConstructor: KalturaAuditTrailListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'audit_audittrail' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaAuditTrailFilter, subType: 'KalturaAuditTrailFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'bulk' action 'abort'.
 *
 * Usage: Aborts the bulk upload and all its child jobs
 *
 * Server response type:         KalturaBulkUpload
 * Server failure response type: KalturaAPIException
 */
class BulkAbortAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBulkUpload', responseConstructor: KalturaBulkUpload });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'bulkupload_bulk' },
            action: { type: 'c', default: 'abort' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'bulk' action 'get'.
 *
 * Usage: Get bulk upload batch job by id
 *
 * Server response type:         KalturaBulkUpload
 * Server failure response type: KalturaAPIException
 */
class BulkGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBulkUpload', responseConstructor: KalturaBulkUpload });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'bulkupload_bulk' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'bulk' action 'list'.
 *
 * Usage: List bulk upload batch jobs
 *
 * Server response type:         KalturaBulkUploadListResponse
 * Server failure response type: KalturaAPIException
 */
class BulkListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBulkUploadListResponse', responseConstructor: KalturaBulkUploadListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'bulkupload_bulk' },
            action: { type: 'c', default: 'list' },
            bulkUploadFilter: { type: 'o', subTypeConstructor: KalturaBulkUploadFilter, subType: 'KalturaBulkUploadFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'bulk' action 'serve'.
 *
 * Usage: serve action returns the original file
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class BulkServeAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'bulkupload_bulk' },
            action: { type: 'c', default: 'serve' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'bulk' action 'serveLog'.
 *
 * Usage: serveLog action returns the log file for the bulk-upload job
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class BulkServeLogAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'bulkupload_bulk' },
            action: { type: 'c', default: 'serveLog' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'businessProcessCase' action 'abort'.
 *
 * Usage: Abort business-process case
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class BusinessProcessCaseAbortAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'businessprocessnotification_businessprocesscase' },
            action: { type: 'c', default: 'abort' },
            objectType: { type: 'es', subTypeConstructor: KalturaEventNotificationEventObjectType, subType: 'KalturaEventNotificationEventObjectType' },
            objectId: { type: 's' },
            businessProcessStartNotificationTemplateId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'businessProcessCase' action 'list'.
 *
 * Usage: list business-process cases
 *
 * Server response type:         KalturaBusinessProcessCase[]
 * Server failure response type: KalturaAPIException
 */
class BusinessProcessCaseListAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaBusinessProcessCase', responseConstructor: KalturaBusinessProcessCase });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'businessprocessnotification_businessprocesscase' },
            action: { type: 'c', default: 'list' },
            objectType: { type: 'es', subTypeConstructor: KalturaEventNotificationEventObjectType, subType: 'KalturaEventNotificationEventObjectType' },
            objectId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'businessProcessCase' action 'serveDiagram'.
 *
 * Usage: Server business-process case diagram
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class BusinessProcessCaseServeDiagramAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'businessprocessnotification_businessprocesscase' },
            action: { type: 'c', default: 'serveDiagram' },
            objectType: { type: 'es', subTypeConstructor: KalturaEventNotificationEventObjectType, subType: 'KalturaEventNotificationEventObjectType' },
            objectId: { type: 's' },
            businessProcessStartNotificationTemplateId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionAsset' action 'add'.
 *
 * Usage: Add caption asset
 *
 * Server response type:         KalturaCaptionAsset
 * Server failure response type: KalturaAPIException
 */
class CaptionAssetAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCaptionAsset', responseConstructor: KalturaCaptionAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'caption_captionasset' },
            action: { type: 'c', default: 'add' },
            entryId: { type: 's' },
            captionAsset: { type: 'o', subTypeConstructor: KalturaCaptionAsset, subType: 'KalturaCaptionAsset' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionAsset' action 'delete'.
 *
 *
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class CaptionAssetDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'caption_captionasset' },
            action: { type: 'c', default: 'delete' },
            captionAssetId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionAsset' action 'get'.
 *
 *
 *
 * Server response type:         KalturaCaptionAsset
 * Server failure response type: KalturaAPIException
 */
class CaptionAssetGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCaptionAsset', responseConstructor: KalturaCaptionAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'caption_captionasset' },
            action: { type: 'c', default: 'get' },
            captionAssetId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionAsset' action 'getRemotePaths'.
 *
 * Usage: Get remote storage existing paths for the asset
 *
 * Server response type:         KalturaRemotePathListResponse
 * Server failure response type: KalturaAPIException
 */
class CaptionAssetGetRemotePathsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaRemotePathListResponse', responseConstructor: KalturaRemotePathListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'caption_captionasset' },
            action: { type: 'c', default: 'getRemotePaths' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionAsset' action 'getUrl'.
 *
 * Usage: Get download URL for the asset
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class CaptionAssetGetUrlAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'caption_captionasset' },
            action: { type: 'c', default: 'getUrl' },
            id: { type: 's' },
            storageId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionAsset' action 'list'.
 *
 * Usage: List caption Assets by filter and pager
 *
 * Server response type:         KalturaCaptionAssetListResponse
 * Server failure response type: KalturaAPIException
 */
class CaptionAssetListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCaptionAssetListResponse', responseConstructor: KalturaCaptionAssetListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'caption_captionasset' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaAssetFilter, subType: 'KalturaAssetFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionAsset' action 'serve'.
 *
 * Usage: Serves caption by its id
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class CaptionAssetServeAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'caption_captionasset' },
            action: { type: 'c', default: 'serve' },
            captionAssetId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionAsset' action 'serveByEntryId'.
 *
 * Usage: Serves caption by entry id and thumnail params id
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class CaptionAssetServeByEntryIdAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'caption_captionasset' },
            action: { type: 'c', default: 'serveByEntryId' },
            entryId: { type: 's' },
            captionParamId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionAsset' action 'serveWebVTT'.
 *
 * Usage: Serves caption by its id converting it to segmented WebVTT
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class CaptionAssetServeWebVTTAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
        if (typeof this.segmentDuration === 'undefined')
            this.segmentDuration = 30;
        if (typeof this.localTimestamp === 'undefined')
            this.localTimestamp = 10000;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'caption_captionasset' },
            action: { type: 'c', default: 'serveWebVTT' },
            captionAssetId: { type: 's' },
            segmentDuration: { type: 'n' },
            segmentIndex: { type: 'n' },
            localTimestamp: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionAsset' action 'setAsDefault'.
 *
 * Usage: Markss the caption as default and removes that mark from all other caption assets of the entry
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class CaptionAssetSetAsDefaultAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'caption_captionasset' },
            action: { type: 'c', default: 'setAsDefault' },
            captionAssetId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionAsset' action 'setContent'.
 *
 * Usage: Update content of caption asset
 *
 * Server response type:         KalturaCaptionAsset
 * Server failure response type: KalturaAPIException
 */
class CaptionAssetSetContentAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCaptionAsset', responseConstructor: KalturaCaptionAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'caption_captionasset' },
            action: { type: 'c', default: 'setContent' },
            id: { type: 's' },
            contentResource: { type: 'o', subTypeConstructor: KalturaContentResource, subType: 'KalturaContentResource' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionAsset' action 'update'.
 *
 * Usage: Update caption asset
 *
 * Server response type:         KalturaCaptionAsset
 * Server failure response type: KalturaAPIException
 */
class CaptionAssetUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCaptionAsset', responseConstructor: KalturaCaptionAsset });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'caption_captionasset' },
            action: { type: 'c', default: 'update' },
            id: { type: 's' },
            captionAsset: { type: 'o', subTypeConstructor: KalturaCaptionAsset, subType: 'KalturaCaptionAsset' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionParams' action 'add'.
 *
 * Usage: Add new Caption Params
 *
 * Server response type:         KalturaCaptionParams
 * Server failure response type: KalturaAPIException
 */
class CaptionParamsAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCaptionParams', responseConstructor: KalturaCaptionParams });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'caption_captionparams' },
            action: { type: 'c', default: 'add' },
            captionParams: { type: 'o', subTypeConstructor: KalturaCaptionParams, subType: 'KalturaCaptionParams' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionParams' action 'delete'.
 *
 * Usage: Delete Caption Params by ID
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class CaptionParamsDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'caption_captionparams' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionParams' action 'get'.
 *
 * Usage: Get Caption Params by ID
 *
 * Server response type:         KalturaCaptionParams
 * Server failure response type: KalturaAPIException
 */
class CaptionParamsGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCaptionParams', responseConstructor: KalturaCaptionParams });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'caption_captionparams' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionParams' action 'list'.
 *
 * Usage: List Caption Params by filter with paging support (By default - all system default params will be listed too)
 *
 * Server response type:         KalturaCaptionParamsListResponse
 * Server failure response type: KalturaAPIException
 */
class CaptionParamsListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCaptionParamsListResponse', responseConstructor: KalturaCaptionParamsListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'caption_captionparams' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaCaptionParamsFilter, subType: 'KalturaCaptionParamsFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionParams' action 'update'.
 *
 * Usage: Update Caption Params by ID
 *
 * Server response type:         KalturaCaptionParams
 * Server failure response type: KalturaAPIException
 */
class CaptionParamsUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCaptionParams', responseConstructor: KalturaCaptionParams });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'caption_captionparams' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            captionParams: { type: 'o', subTypeConstructor: KalturaCaptionParams, subType: 'KalturaCaptionParams' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionAssetItem' action 'list'.
 *
 * Usage: List caption asset items by filter and pager
 *
 * Server response type:         KalturaCaptionAssetItemListResponse
 * Server failure response type: KalturaAPIException
 */
class CaptionAssetItemListAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCaptionAssetItemListResponse', responseConstructor: KalturaCaptionAssetItemListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'captionsearch_captionassetitem' },
            action: { type: 'c', default: 'list' },
            captionAssetId: { type: 's' },
            captionAssetItemFilter: { type: 'o', subTypeConstructor: KalturaCaptionAssetItemFilter, subType: 'KalturaCaptionAssetItemFilter' },
            captionAssetItemPager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionAssetItem' action 'parse'.
 *
 * Usage: Parse content of caption asset and index it
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class CaptionAssetItemParseAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'captionsearch_captionassetitem' },
            action: { type: 'c', default: 'parse' },
            captionAssetId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionAssetItem' action 'search'.
 *
 * Usage: Search caption asset items by filter, pager and free text
 *
 * Server response type:         KalturaCaptionAssetItemListResponse
 * Server failure response type: KalturaAPIException
 */
class CaptionAssetItemSearchAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCaptionAssetItemListResponse', responseConstructor: KalturaCaptionAssetItemListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'captionsearch_captionassetitem' },
            action: { type: 'c', default: 'search' },
            entryFilter: { type: 'o', subTypeConstructor: KalturaBaseEntryFilter, subType: 'KalturaBaseEntryFilter' },
            captionAssetItemFilter: { type: 'o', subTypeConstructor: KalturaCaptionAssetItemFilter, subType: 'KalturaCaptionAssetItemFilter' },
            captionAssetItemPager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'captionAssetItem' action 'searchEntries'.
 *
 * Usage: Search caption asset items by filter, pager and free text
 *
 * Server response type:         KalturaBaseEntryListResponse
 * Server failure response type: KalturaAPIException
 */
class CaptionAssetItemSearchEntriesAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBaseEntryListResponse', responseConstructor: KalturaBaseEntryListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'captionsearch_captionassetitem' },
            action: { type: 'c', default: 'searchEntries' },
            entryFilter: { type: 'o', subTypeConstructor: KalturaBaseEntryFilter, subType: 'KalturaBaseEntryFilter' },
            captionAssetItemFilter: { type: 'o', subTypeConstructor: KalturaCaptionAssetItemFilter, subType: 'KalturaCaptionAssetItemFilter' },
            captionAssetItemPager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'distributionProfile' action 'add'.
 *
 * Usage: Add new Distribution Profile
 *
 * Server response type:         KalturaDistributionProfile
 * Server failure response type: KalturaAPIException
 */
class DistributionProfileAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDistributionProfile', responseConstructor: KalturaDistributionProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_distributionprofile' },
            action: { type: 'c', default: 'add' },
            distributionProfile: { type: 'o', subTypeConstructor: KalturaDistributionProfile, subType: 'KalturaDistributionProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'distributionProfile' action 'delete'.
 *
 * Usage: Delete Distribution Profile by id
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class DistributionProfileDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_distributionprofile' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'distributionProfile' action 'get'.
 *
 * Usage: Get Distribution Profile by id
 *
 * Server response type:         KalturaDistributionProfile
 * Server failure response type: KalturaAPIException
 */
class DistributionProfileGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDistributionProfile', responseConstructor: KalturaDistributionProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_distributionprofile' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'distributionProfile' action 'list'.
 *
 * Usage: List all distribution providers
 *
 * Server response type:         KalturaDistributionProfileListResponse
 * Server failure response type: KalturaAPIException
 */
class DistributionProfileListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDistributionProfileListResponse', responseConstructor: KalturaDistributionProfileListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_distributionprofile' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaDistributionProfileFilter, subType: 'KalturaDistributionProfileFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'distributionProfile' action 'listByPartner'.
 *
 *
 *
 * Server response type:         KalturaDistributionProfileListResponse
 * Server failure response type: KalturaAPIException
 */
class DistributionProfileListByPartnerAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDistributionProfileListResponse', responseConstructor: KalturaDistributionProfileListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_distributionprofile' },
            action: { type: 'c', default: 'listByPartner' },
            filter: { type: 'o', subTypeConstructor: KalturaPartnerFilter, subType: 'KalturaPartnerFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'distributionProfile' action 'update'.
 *
 * Usage: Update Distribution Profile by id
 *
 * Server response type:         KalturaDistributionProfile
 * Server failure response type: KalturaAPIException
 */
class DistributionProfileUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDistributionProfile', responseConstructor: KalturaDistributionProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_distributionprofile' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            distributionProfile: { type: 'o', subTypeConstructor: KalturaDistributionProfile, subType: 'KalturaDistributionProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'distributionProfile' action 'updateStatus'.
 *
 * Usage: Update Distribution Profile status by id
 *
 * Server response type:         KalturaDistributionProfile
 * Server failure response type: KalturaAPIException
 */
class DistributionProfileUpdateStatusAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDistributionProfile', responseConstructor: KalturaDistributionProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_distributionprofile' },
            action: { type: 'c', default: 'updateStatus' },
            id: { type: 'n' },
            status: { type: 'en', subTypeConstructor: KalturaDistributionProfileStatus, subType: 'KalturaDistributionProfileStatus' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryDistribution' action 'add'.
 *
 * Usage: Add new Entry Distribution
 *
 * Server response type:         KalturaEntryDistribution
 * Server failure response type: KalturaAPIException
 */
class EntryDistributionAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEntryDistribution', responseConstructor: KalturaEntryDistribution });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_entrydistribution' },
            action: { type: 'c', default: 'add' },
            entryDistribution: { type: 'o', subTypeConstructor: KalturaEntryDistribution, subType: 'KalturaEntryDistribution' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryDistribution' action 'delete'.
 *
 * Usage: Delete Entry Distribution by id
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class EntryDistributionDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_entrydistribution' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryDistribution' action 'get'.
 *
 * Usage: Get Entry Distribution by id
 *
 * Server response type:         KalturaEntryDistribution
 * Server failure response type: KalturaAPIException
 */
class EntryDistributionGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEntryDistribution', responseConstructor: KalturaEntryDistribution });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_entrydistribution' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryDistribution' action 'list'.
 *
 * Usage: List all distribution providers
 *
 * Server response type:         KalturaEntryDistributionListResponse
 * Server failure response type: KalturaAPIException
 */
class EntryDistributionListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEntryDistributionListResponse', responseConstructor: KalturaEntryDistributionListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_entrydistribution' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaEntryDistributionFilter, subType: 'KalturaEntryDistributionFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryDistribution' action 'retrySubmit'.
 *
 * Usage: Retries last submit action
 *
 * Server response type:         KalturaEntryDistribution
 * Server failure response type: KalturaAPIException
 */
class EntryDistributionRetrySubmitAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEntryDistribution', responseConstructor: KalturaEntryDistribution });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_entrydistribution' },
            action: { type: 'c', default: 'retrySubmit' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryDistribution' action 'serveReturnedData'.
 *
 * Usage: Serves entry distribution returned data
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class EntryDistributionServeReturnedDataAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_entrydistribution' },
            action: { type: 'c', default: 'serveReturnedData' },
            id: { type: 'n' },
            actionType: { type: 'en', subTypeConstructor: KalturaDistributionAction, subType: 'KalturaDistributionAction' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryDistribution' action 'serveSentData'.
 *
 * Usage: Serves entry distribution sent data
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class EntryDistributionServeSentDataAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_entrydistribution' },
            action: { type: 'c', default: 'serveSentData' },
            id: { type: 'n' },
            actionType: { type: 'en', subTypeConstructor: KalturaDistributionAction, subType: 'KalturaDistributionAction' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryDistribution' action 'submitAdd'.
 *
 * Usage: Submits Entry Distribution to the remote destination
 *
 * Server response type:         KalturaEntryDistribution
 * Server failure response type: KalturaAPIException
 */
class EntryDistributionSubmitAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEntryDistribution', responseConstructor: KalturaEntryDistribution });
        if (typeof this.submitWhenReady === 'undefined')
            this.submitWhenReady = false;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_entrydistribution' },
            action: { type: 'c', default: 'submitAdd' },
            id: { type: 'n' },
            submitWhenReady: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryDistribution' action 'submitDelete'.
 *
 * Usage: Deletes Entry Distribution from the remote destination
 *
 * Server response type:         KalturaEntryDistribution
 * Server failure response type: KalturaAPIException
 */
class EntryDistributionSubmitDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEntryDistribution', responseConstructor: KalturaEntryDistribution });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_entrydistribution' },
            action: { type: 'c', default: 'submitDelete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryDistribution' action 'submitFetchReport'.
 *
 * Usage: Submits Entry Distribution report request
 *
 * Server response type:         KalturaEntryDistribution
 * Server failure response type: KalturaAPIException
 */
class EntryDistributionSubmitFetchReportAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEntryDistribution', responseConstructor: KalturaEntryDistribution });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_entrydistribution' },
            action: { type: 'c', default: 'submitFetchReport' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryDistribution' action 'submitUpdate'.
 *
 * Usage: Submits Entry Distribution changes to the remote destination
 *
 * Server response type:         KalturaEntryDistribution
 * Server failure response type: KalturaAPIException
 */
class EntryDistributionSubmitUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEntryDistribution', responseConstructor: KalturaEntryDistribution });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_entrydistribution' },
            action: { type: 'c', default: 'submitUpdate' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryDistribution' action 'update'.
 *
 * Usage: Update Entry Distribution by id
 *
 * Server response type:         KalturaEntryDistribution
 * Server failure response type: KalturaAPIException
 */
class EntryDistributionUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEntryDistribution', responseConstructor: KalturaEntryDistribution });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_entrydistribution' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            entryDistribution: { type: 'o', subTypeConstructor: KalturaEntryDistribution, subType: 'KalturaEntryDistribution' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'entryDistribution' action 'validate'.
 *
 * Usage: Validates Entry Distribution by id for submission
 *
 * Server response type:         KalturaEntryDistribution
 * Server failure response type: KalturaAPIException
 */
class EntryDistributionValidateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEntryDistribution', responseConstructor: KalturaEntryDistribution });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_entrydistribution' },
            action: { type: 'c', default: 'validate' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'distributionProvider' action 'list'.
 *
 * Usage: List all distribution providers
 *
 * Server response type:         KalturaDistributionProviderListResponse
 * Server failure response type: KalturaAPIException
 */
class DistributionProviderListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDistributionProviderListResponse', responseConstructor: KalturaDistributionProviderListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_distributionprovider' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaDistributionProviderFilter, subType: 'KalturaDistributionProviderFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProvider' action 'add'.
 *
 * Usage: Add new Generic Distribution Provider
 *
 * Server response type:         KalturaGenericDistributionProvider
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGenericDistributionProvider', responseConstructor: KalturaGenericDistributionProvider });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovider' },
            action: { type: 'c', default: 'add' },
            genericDistributionProvider: { type: 'o', subTypeConstructor: KalturaGenericDistributionProvider, subType: 'KalturaGenericDistributionProvider' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProvider' action 'delete'.
 *
 * Usage: Delete Generic Distribution Provider by id
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovider' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProvider' action 'get'.
 *
 * Usage: Get Generic Distribution Provider by id
 *
 * Server response type:         KalturaGenericDistributionProvider
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGenericDistributionProvider', responseConstructor: KalturaGenericDistributionProvider });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovider' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProvider' action 'list'.
 *
 * Usage: List all distribution providers
 *
 * Server response type:         KalturaGenericDistributionProviderListResponse
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGenericDistributionProviderListResponse', responseConstructor: KalturaGenericDistributionProviderListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovider' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaGenericDistributionProviderFilter, subType: 'KalturaGenericDistributionProviderFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProvider' action 'update'.
 *
 * Usage: Update Generic Distribution Provider by id
 *
 * Server response type:         KalturaGenericDistributionProvider
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGenericDistributionProvider', responseConstructor: KalturaGenericDistributionProvider });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovider' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            genericDistributionProvider: { type: 'o', subTypeConstructor: KalturaGenericDistributionProvider, subType: 'KalturaGenericDistributionProvider' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProviderAction' action 'add'.
 *
 * Usage: Add new Generic Distribution Provider Action
 *
 * Server response type:         KalturaGenericDistributionProviderAction
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderActionAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGenericDistributionProviderAction', responseConstructor: KalturaGenericDistributionProviderAction });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovideraction' },
            action: { type: 'c', default: 'add' },
            genericDistributionProviderAction: { type: 'o', subTypeConstructor: KalturaGenericDistributionProviderAction, subType: 'KalturaGenericDistributionProviderAction' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProviderAction' action 'addMrssTransform'.
 *
 * Usage: Add MRSS transform file to generic distribution provider action
 *
 * Server response type:         KalturaGenericDistributionProviderAction
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderActionAddMrssTransformAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGenericDistributionProviderAction', responseConstructor: KalturaGenericDistributionProviderAction });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovideraction' },
            action: { type: 'c', default: 'addMrssTransform' },
            id: { type: 'n' },
            xslData: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProviderAction' action 'addMrssTransformFromFile'.
 *
 * Usage: Add MRSS transform file to generic distribution provider action
 *
 * Server response type:         KalturaGenericDistributionProviderAction
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderActionAddMrssTransformFromFileAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGenericDistributionProviderAction', responseConstructor: KalturaGenericDistributionProviderAction });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovideraction' },
            action: { type: 'c', default: 'addMrssTransformFromFile' },
            id: { type: 'n' },
            xslFile: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProviderAction' action 'addMrssValidate'.
 *
 * Usage: Add MRSS validate file to generic distribution provider action
 *
 * Server response type:         KalturaGenericDistributionProviderAction
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderActionAddMrssValidateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGenericDistributionProviderAction', responseConstructor: KalturaGenericDistributionProviderAction });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovideraction' },
            action: { type: 'c', default: 'addMrssValidate' },
            id: { type: 'n' },
            xsdData: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProviderAction' action 'addMrssValidateFromFile'.
 *
 * Usage: Add MRSS validate file to generic distribution provider action
 *
 * Server response type:         KalturaGenericDistributionProviderAction
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderActionAddMrssValidateFromFileAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGenericDistributionProviderAction', responseConstructor: KalturaGenericDistributionProviderAction });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovideraction' },
            action: { type: 'c', default: 'addMrssValidateFromFile' },
            id: { type: 'n' },
            xsdFile: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProviderAction' action 'addResultsTransform'.
 *
 * Usage: Add results transform file to generic distribution provider action
 *
 * Server response type:         KalturaGenericDistributionProviderAction
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderActionAddResultsTransformAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGenericDistributionProviderAction', responseConstructor: KalturaGenericDistributionProviderAction });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovideraction' },
            action: { type: 'c', default: 'addResultsTransform' },
            id: { type: 'n' },
            transformData: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProviderAction' action 'addResultsTransformFromFile'.
 *
 * Usage: Add MRSS transform file to generic distribution provider action
 *
 * Server response type:         KalturaGenericDistributionProviderAction
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderActionAddResultsTransformFromFileAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGenericDistributionProviderAction', responseConstructor: KalturaGenericDistributionProviderAction });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovideraction' },
            action: { type: 'c', default: 'addResultsTransformFromFile' },
            id: { type: 'n' },
            transformFile: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProviderAction' action 'delete'.
 *
 * Usage: Delete Generic Distribution Provider Action by id
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderActionDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovideraction' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProviderAction' action 'deleteByProviderId'.
 *
 * Usage: Delete Generic Distribution Provider Action by provider id
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderActionDeleteByProviderIdAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovideraction' },
            action: { type: 'c', default: 'deleteByProviderId' },
            genericDistributionProviderId: { type: 'n' },
            actionType: { type: 'en', subTypeConstructor: KalturaDistributionAction, subType: 'KalturaDistributionAction' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProviderAction' action 'get'.
 *
 * Usage: Get Generic Distribution Provider Action by id
 *
 * Server response type:         KalturaGenericDistributionProviderAction
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderActionGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGenericDistributionProviderAction', responseConstructor: KalturaGenericDistributionProviderAction });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovideraction' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProviderAction' action 'getByProviderId'.
 *
 * Usage: Get Generic Distribution Provider Action by provider id
 *
 * Server response type:         KalturaGenericDistributionProviderAction
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderActionGetByProviderIdAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGenericDistributionProviderAction', responseConstructor: KalturaGenericDistributionProviderAction });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovideraction' },
            action: { type: 'c', default: 'getByProviderId' },
            genericDistributionProviderId: { type: 'n' },
            actionType: { type: 'en', subTypeConstructor: KalturaDistributionAction, subType: 'KalturaDistributionAction' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProviderAction' action 'list'.
 *
 * Usage: List all distribution providers
 *
 * Server response type:         KalturaGenericDistributionProviderActionListResponse
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderActionListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGenericDistributionProviderActionListResponse', responseConstructor: KalturaGenericDistributionProviderActionListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovideraction' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaGenericDistributionProviderActionFilter, subType: 'KalturaGenericDistributionProviderActionFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProviderAction' action 'update'.
 *
 * Usage: Update Generic Distribution Provider Action by id
 *
 * Server response type:         KalturaGenericDistributionProviderAction
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderActionUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGenericDistributionProviderAction', responseConstructor: KalturaGenericDistributionProviderAction });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovideraction' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            genericDistributionProviderAction: { type: 'o', subTypeConstructor: KalturaGenericDistributionProviderAction, subType: 'KalturaGenericDistributionProviderAction' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'genericDistributionProviderAction' action 'updateByProviderId'.
 *
 * Usage: Update Generic Distribution Provider Action by provider id
 *
 * Server response type:         KalturaGenericDistributionProviderAction
 * Server failure response type: KalturaAPIException
 */
class GenericDistributionProviderActionUpdateByProviderIdAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaGenericDistributionProviderAction', responseConstructor: KalturaGenericDistributionProviderAction });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'contentdistribution_genericdistributionprovideraction' },
            action: { type: 'c', default: 'updateByProviderId' },
            genericDistributionProviderId: { type: 'n' },
            actionType: { type: 'en', subTypeConstructor: KalturaDistributionAction, subType: 'KalturaDistributionAction' },
            genericDistributionProviderAction: { type: 'o', subTypeConstructor: KalturaGenericDistributionProviderAction, subType: 'KalturaGenericDistributionProviderAction' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'cuePoint' action 'add'.
 *
 * Usage: Allows you to add an cue point object associated with an entry
 *
 * Server response type:         KalturaCuePoint
 * Server failure response type: KalturaAPIException
 */
class CuePointAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCuePoint', responseConstructor: KalturaCuePoint });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'cuepoint_cuepoint' },
            action: { type: 'c', default: 'add' },
            cuePoint: { type: 'o', subTypeConstructor: KalturaCuePoint, subType: 'KalturaCuePoint' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'cuePoint' action 'addFromBulk'.
 *
 * Usage: Allows you to add multiple cue points objects by uploading XML that contains multiple cue point definitions
 *
 * Server response type:         KalturaCuePointListResponse
 * Server failure response type: KalturaAPIException
 */
class CuePointAddFromBulkAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCuePointListResponse', responseConstructor: KalturaCuePointListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'cuepoint_cuepoint' },
            action: { type: 'c', default: 'addFromBulk' },
            fileData: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'cuePoint' action 'clone'.
 *
 * Usage: Clone cuePoint with id to given entry
 *
 * Server response type:         KalturaCuePoint
 * Server failure response type: KalturaAPIException
 */
class CuePointCloneAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCuePoint', responseConstructor: KalturaCuePoint });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'cuepoint_cuepoint' },
            action: { type: 'c', default: 'clone' },
            id: { type: 's' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'cuePoint' action 'count'.
 *
 * Usage: count cue point objects by filter
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class CuePointCountAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'cuepoint_cuepoint' },
            action: { type: 'c', default: 'count' },
            filter: { type: 'o', subTypeConstructor: KalturaCuePointFilter, subType: 'KalturaCuePointFilter' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'cuePoint' action 'delete'.
 *
 * Usage: delete cue point by id, and delete all children cue points
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class CuePointDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'cuepoint_cuepoint' },
            action: { type: 'c', default: 'delete' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'cuePoint' action 'get'.
 *
 * Usage: Retrieve an CuePoint object by id
 *
 * Server response type:         KalturaCuePoint
 * Server failure response type: KalturaAPIException
 */
class CuePointGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCuePoint', responseConstructor: KalturaCuePoint });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'cuepoint_cuepoint' },
            action: { type: 'c', default: 'get' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'cuePoint' action 'list'.
 *
 * Usage: List cue point objects by filter and pager
 *
 * Server response type:         KalturaCuePointListResponse
 * Server failure response type: KalturaAPIException
 */
class CuePointListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCuePointListResponse', responseConstructor: KalturaCuePointListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'cuepoint_cuepoint' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaCuePointFilter, subType: 'KalturaCuePointFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'cuePoint' action 'serveBulk'.
 *
 * Usage: Download multiple cue points objects as XML definitions
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class CuePointServeBulkAction extends KalturaFileRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'cuepoint_cuepoint' },
            action: { type: 'c', default: 'serveBulk' },
            filter: { type: 'o', subTypeConstructor: KalturaCuePointFilter, subType: 'KalturaCuePointFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'cuePoint' action 'update'.
 *
 * Usage: Update cue point by id
 *
 * Server response type:         KalturaCuePoint
 * Server failure response type: KalturaAPIException
 */
class CuePointUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCuePoint', responseConstructor: KalturaCuePoint });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'cuepoint_cuepoint' },
            action: { type: 'c', default: 'update' },
            id: { type: 's' },
            cuePoint: { type: 'o', subTypeConstructor: KalturaCuePoint, subType: 'KalturaCuePoint' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'cuePoint' action 'updateCuePointsTimes'.
 *
 *
 *
 * Server response type:         KalturaCuePoint
 * Server failure response type: KalturaAPIException
 */
class CuePointUpdateCuePointsTimesAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaCuePoint', responseConstructor: KalturaCuePoint });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'cuepoint_cuepoint' },
            action: { type: 'c', default: 'updateCuePointsTimes' },
            id: { type: 's' },
            startTime: { type: 'n' },
            endTime: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'cuePoint' action 'updateStatus'.
 *
 * Usage: Update cuePoint status by id
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class CuePointUpdateStatusAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'cuepoint_cuepoint' },
            action: { type: 'c', default: 'updateStatus' },
            id: { type: 's' },
            status: { type: 'en', subTypeConstructor: KalturaCuePointStatus, subType: 'KalturaCuePointStatus' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'documents' action 'addFromEntry'.
 *
 * Usage: Copy entry into new entry
 *
 * Server response type:         KalturaDocumentEntry
 * Server failure response type: KalturaAPIException
 */
class DocumentsAddFromEntryAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDocumentEntry', responseConstructor: KalturaDocumentEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'document_documents' },
            action: { type: 'c', default: 'addFromEntry' },
            sourceEntryId: { type: 's' },
            documentEntry: { type: 'o', subTypeConstructor: KalturaDocumentEntry, subType: 'KalturaDocumentEntry' },
            sourceFlavorParamsId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'documents' action 'addFromFlavorAsset'.
 *
 * Usage: Copy flavor asset into new entry
 *
 * Server response type:         KalturaDocumentEntry
 * Server failure response type: KalturaAPIException
 */
class DocumentsAddFromFlavorAssetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDocumentEntry', responseConstructor: KalturaDocumentEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'document_documents' },
            action: { type: 'c', default: 'addFromFlavorAsset' },
            sourceFlavorAssetId: { type: 's' },
            documentEntry: { type: 'o', subTypeConstructor: KalturaDocumentEntry, subType: 'KalturaDocumentEntry' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'documents' action 'addFromUploadedFile'.
 *
 * Usage: Add new document entry after the specific document file was uploaded and the upload token id exists
 *
 * Server response type:         KalturaDocumentEntry
 * Server failure response type: KalturaAPIException
 */
class DocumentsAddFromUploadedFileAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDocumentEntry', responseConstructor: KalturaDocumentEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'document_documents' },
            action: { type: 'c', default: 'addFromUploadedFile' },
            documentEntry: { type: 'o', subTypeConstructor: KalturaDocumentEntry, subType: 'KalturaDocumentEntry' },
            uploadTokenId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'documents' action 'approveReplace'.
 *
 * Usage: Approves document replacement
 *
 * Server response type:         KalturaDocumentEntry
 * Server failure response type: KalturaAPIException
 */
class DocumentsApproveReplaceAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDocumentEntry', responseConstructor: KalturaDocumentEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'document_documents' },
            action: { type: 'c', default: 'approveReplace' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'documents' action 'cancelReplace'.
 *
 * Usage: Cancels document replacement
 *
 * Server response type:         KalturaDocumentEntry
 * Server failure response type: KalturaAPIException
 */
class DocumentsCancelReplaceAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDocumentEntry', responseConstructor: KalturaDocumentEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'document_documents' },
            action: { type: 'c', default: 'cancelReplace' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'documents' action 'convert'.
 *
 * Usage: Convert entry
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class DocumentsConvertAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
        if (typeof this.dynamicConversionAttributes === 'undefined')
            this.dynamicConversionAttributes = [];
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'document_documents' },
            action: { type: 'c', default: 'convert' },
            entryId: { type: 's' },
            conversionProfileId: { type: 'n' },
            dynamicConversionAttributes: { type: 'a', subTypeConstructor: KalturaConversionAttribute, subType: 'KalturaConversionAttribute' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'documents' action 'convertPptToSwf'.
 *
 * Usage: This will queue a batch job for converting the document file to swf
 * Returns the URL where the new swf will be available
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class DocumentsConvertPptToSwfAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'document_documents' },
            action: { type: 'c', default: 'convertPptToSwf' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'documents' action 'delete'.
 *
 * Usage: Delete a document entry
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class DocumentsDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'document_documents' },
            action: { type: 'c', default: 'delete' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'documents' action 'get'.
 *
 * Usage: Get document entry by ID
 *
 * Server response type:         KalturaDocumentEntry
 * Server failure response type: KalturaAPIException
 */
class DocumentsGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDocumentEntry', responseConstructor: KalturaDocumentEntry });
        if (typeof this.version === 'undefined')
            this.version = -1;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'document_documents' },
            action: { type: 'c', default: 'get' },
            entryId: { type: 's' },
            version: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'documents' action 'list'.
 *
 * Usage: List document entries by filter with paging support
 *
 * Server response type:         KalturaDocumentListResponse
 * Server failure response type: KalturaAPIException
 */
class DocumentsListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDocumentListResponse', responseConstructor: KalturaDocumentListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'document_documents' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaDocumentEntryFilter, subType: 'KalturaDocumentEntryFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'documents' action 'serve'.
 *
 * Usage: Serves the file content
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class DocumentsServeAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
        if (typeof this.forceProxy === 'undefined')
            this.forceProxy = false;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'document_documents' },
            action: { type: 'c', default: 'serve' },
            entryId: { type: 's' },
            flavorAssetId: { type: 's' },
            forceProxy: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'documents' action 'serveByFlavorParamsId'.
 *
 * Usage: Serves the file content
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class DocumentsServeByFlavorParamsIdAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
        if (typeof this.forceProxy === 'undefined')
            this.forceProxy = false;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'document_documents' },
            action: { type: 'c', default: 'serveByFlavorParamsId' },
            entryId: { type: 's' },
            flavorParamsId: { type: 's' },
            forceProxy: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'documents' action 'update'.
 *
 * Usage: Update document entry. Only the properties that were set will be updated
 *
 * Server response type:         KalturaDocumentEntry
 * Server failure response type: KalturaAPIException
 */
class DocumentsUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDocumentEntry', responseConstructor: KalturaDocumentEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'document_documents' },
            action: { type: 'c', default: 'update' },
            entryId: { type: 's' },
            documentEntry: { type: 'o', subTypeConstructor: KalturaDocumentEntry, subType: 'KalturaDocumentEntry' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'documents' action 'updateContent'.
 *
 * Usage: Replace content associated with the given document entry
 *
 * Server response type:         KalturaDocumentEntry
 * Server failure response type: KalturaAPIException
 */
class DocumentsUpdateContentAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDocumentEntry', responseConstructor: KalturaDocumentEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'document_documents' },
            action: { type: 'c', default: 'updateContent' },
            entryId: { type: 's' },
            resource: { type: 'o', subTypeConstructor: KalturaResource, subType: 'KalturaResource' },
            conversionProfileId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'documents' action 'upload'.
 *
 * Usage: Upload a document file to Kaltura, then the file can be used to create a document entry
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class DocumentsUploadAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'document_documents' },
            action: { type: 'c', default: 'upload' },
            fileData: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'drmPolicy' action 'add'.
 *
 * Usage: Allows you to add a new DrmPolicy object
 *
 * Server response type:         KalturaDrmPolicy
 * Server failure response type: KalturaAPIException
 */
class DrmPolicyAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDrmPolicy', responseConstructor: KalturaDrmPolicy });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'drm_drmpolicy' },
            action: { type: 'c', default: 'add' },
            drmPolicy: { type: 'o', subTypeConstructor: KalturaDrmPolicy, subType: 'KalturaDrmPolicy' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'drmPolicy' action 'delete'.
 *
 * Usage: Mark the KalturaDrmPolicy object as deleted
 *
 * Server response type:         KalturaDrmPolicy
 * Server failure response type: KalturaAPIException
 */
class DrmPolicyDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDrmPolicy', responseConstructor: KalturaDrmPolicy });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'drm_drmpolicy' },
            action: { type: 'c', default: 'delete' },
            drmPolicyId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'drmPolicy' action 'get'.
 *
 * Usage: Retrieve a KalturaDrmPolicy object by ID
 *
 * Server response type:         KalturaDrmPolicy
 * Server failure response type: KalturaAPIException
 */
class DrmPolicyGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDrmPolicy', responseConstructor: KalturaDrmPolicy });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'drm_drmpolicy' },
            action: { type: 'c', default: 'get' },
            drmPolicyId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'drmPolicy' action 'list'.
 *
 * Usage: List KalturaDrmPolicy objects
 *
 * Server response type:         KalturaDrmPolicyListResponse
 * Server failure response type: KalturaAPIException
 */
class DrmPolicyListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDrmPolicyListResponse', responseConstructor: KalturaDrmPolicyListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'drm_drmpolicy' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaDrmPolicyFilter, subType: 'KalturaDrmPolicyFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'drmPolicy' action 'update'.
 *
 * Usage: Update an existing KalturaDrmPolicy object
 *
 * Server response type:         KalturaDrmPolicy
 * Server failure response type: KalturaAPIException
 */
class DrmPolicyUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDrmPolicy', responseConstructor: KalturaDrmPolicy });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'drm_drmpolicy' },
            action: { type: 'c', default: 'update' },
            drmPolicyId: { type: 'n' },
            drmPolicy: { type: 'o', subTypeConstructor: KalturaDrmPolicy, subType: 'KalturaDrmPolicy' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'drmProfile' action 'add'.
 *
 * Usage: Allows you to add a new DrmProfile object
 *
 * Server response type:         KalturaDrmProfile
 * Server failure response type: KalturaAPIException
 */
class DrmProfileAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDrmProfile', responseConstructor: KalturaDrmProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'drm_drmprofile' },
            action: { type: 'c', default: 'add' },
            drmProfile: { type: 'o', subTypeConstructor: KalturaDrmProfile, subType: 'KalturaDrmProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'drmProfile' action 'delete'.
 *
 * Usage: Mark the KalturaDrmProfile object as deleted
 *
 * Server response type:         KalturaDrmProfile
 * Server failure response type: KalturaAPIException
 */
class DrmProfileDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDrmProfile', responseConstructor: KalturaDrmProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'drm_drmprofile' },
            action: { type: 'c', default: 'delete' },
            drmProfileId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'drmProfile' action 'get'.
 *
 * Usage: Retrieve a KalturaDrmProfile object by ID
 *
 * Server response type:         KalturaDrmProfile
 * Server failure response type: KalturaAPIException
 */
class DrmProfileGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDrmProfile', responseConstructor: KalturaDrmProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'drm_drmprofile' },
            action: { type: 'c', default: 'get' },
            drmProfileId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'drmProfile' action 'getByProvider'.
 *
 * Usage: Retrieve a KalturaDrmProfile object by provider, if no specific profile defined return default profile
 *
 * Server response type:         KalturaDrmProfile
 * Server failure response type: KalturaAPIException
 */
class DrmProfileGetByProviderAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDrmProfile', responseConstructor: KalturaDrmProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'drm_drmprofile' },
            action: { type: 'c', default: 'getByProvider' },
            provider: { type: 'es', subTypeConstructor: KalturaDrmProviderType, subType: 'KalturaDrmProviderType' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'drmProfile' action 'list'.
 *
 * Usage: List KalturaDrmProfile objects
 *
 * Server response type:         KalturaDrmProfileListResponse
 * Server failure response type: KalturaAPIException
 */
class DrmProfileListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDrmProfileListResponse', responseConstructor: KalturaDrmProfileListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'drm_drmprofile' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaDrmProfileFilter, subType: 'KalturaDrmProfileFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'drmProfile' action 'update'.
 *
 * Usage: Update an existing KalturaDrmProfile object
 *
 * Server response type:         KalturaDrmProfile
 * Server failure response type: KalturaAPIException
 */
class DrmProfileUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDrmProfile', responseConstructor: KalturaDrmProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'drm_drmprofile' },
            action: { type: 'c', default: 'update' },
            drmProfileId: { type: 'n' },
            drmProfile: { type: 'o', subTypeConstructor: KalturaDrmProfile, subType: 'KalturaDrmProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'drmLicenseAccess' action 'getAccess'.
 *
 * Usage: getAccessAction
 * input: flavor ids, drmProvider
 * Get Access Action
 *
 * Server response type:         KalturaDrmLicenseAccessDetails
 * Server failure response type: KalturaAPIException
 */
class DrmLicenseAccessGetAccessAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDrmLicenseAccessDetails', responseConstructor: KalturaDrmLicenseAccessDetails });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'drm_drmlicenseaccess' },
            action: { type: 'c', default: 'getAccess' },
            entryId: { type: 's' },
            flavorIds: { type: 's' },
            referrer: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'dropFolder' action 'add'.
 *
 * Usage: Allows you to add a new KalturaDropFolder object
 *
 * Server response type:         KalturaDropFolder
 * Server failure response type: KalturaAPIException
 */
class DropFolderAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDropFolder', responseConstructor: KalturaDropFolder });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'dropfolder_dropfolder' },
            action: { type: 'c', default: 'add' },
            dropFolder: { type: 'o', subTypeConstructor: KalturaDropFolder, subType: 'KalturaDropFolder' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'dropFolder' action 'delete'.
 *
 * Usage: Mark the KalturaDropFolder object as deleted
 *
 * Server response type:         KalturaDropFolder
 * Server failure response type: KalturaAPIException
 */
class DropFolderDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDropFolder', responseConstructor: KalturaDropFolder });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'dropfolder_dropfolder' },
            action: { type: 'c', default: 'delete' },
            dropFolderId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'dropFolder' action 'freeExclusiveDropFolder'.
 *
 * Usage: freeExclusive KalturaDropFolder object
 *
 * Server response type:         KalturaDropFolder
 * Server failure response type: KalturaAPIException
 */
class DropFolderFreeExclusiveDropFolderAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDropFolder', responseConstructor: KalturaDropFolder });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'dropfolder_dropfolder' },
            action: { type: 'c', default: 'freeExclusiveDropFolder' },
            dropFolderId: { type: 'n' },
            errorCode: { type: 's' },
            errorDescription: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'dropFolder' action 'get'.
 *
 * Usage: Retrieve a KalturaDropFolder object by ID
 *
 * Server response type:         KalturaDropFolder
 * Server failure response type: KalturaAPIException
 */
class DropFolderGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDropFolder', responseConstructor: KalturaDropFolder });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'dropfolder_dropfolder' },
            action: { type: 'c', default: 'get' },
            dropFolderId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'dropFolder' action 'getExclusiveDropFolder'.
 *
 * Usage: getExclusive KalturaDropFolder object
 *
 * Server response type:         KalturaDropFolder
 * Server failure response type: KalturaAPIException
 */
class DropFolderGetExclusiveDropFolderAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDropFolder', responseConstructor: KalturaDropFolder });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'dropfolder_dropfolder' },
            action: { type: 'c', default: 'getExclusiveDropFolder' },
            tag: { type: 's' },
            maxTime: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'dropFolder' action 'list'.
 *
 * Usage: List KalturaDropFolder objects
 *
 * Server response type:         KalturaDropFolderListResponse
 * Server failure response type: KalturaAPIException
 */
class DropFolderListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDropFolderListResponse', responseConstructor: KalturaDropFolderListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'dropfolder_dropfolder' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaDropFolderFilter, subType: 'KalturaDropFolderFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'dropFolder' action 'update'.
 *
 * Usage: Update an existing KalturaDropFolder object
 *
 * Server response type:         KalturaDropFolder
 * Server failure response type: KalturaAPIException
 */
class DropFolderUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDropFolder', responseConstructor: KalturaDropFolder });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'dropfolder_dropfolder' },
            action: { type: 'c', default: 'update' },
            dropFolderId: { type: 'n' },
            dropFolder: { type: 'o', subTypeConstructor: KalturaDropFolder, subType: 'KalturaDropFolder' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'dropFolderFile' action 'add'.
 *
 * Usage: Allows you to add a new KalturaDropFolderFile object
 *
 * Server response type:         KalturaDropFolderFile
 * Server failure response type: KalturaAPIException
 */
class DropFolderFileAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDropFolderFile', responseConstructor: KalturaDropFolderFile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'dropfolder_dropfolderfile' },
            action: { type: 'c', default: 'add' },
            dropFolderFile: { type: 'o', subTypeConstructor: KalturaDropFolderFile, subType: 'KalturaDropFolderFile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'dropFolderFile' action 'delete'.
 *
 * Usage: Mark the KalturaDropFolderFile object as deleted
 *
 * Server response type:         KalturaDropFolderFile
 * Server failure response type: KalturaAPIException
 */
class DropFolderFileDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDropFolderFile', responseConstructor: KalturaDropFolderFile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'dropfolder_dropfolderfile' },
            action: { type: 'c', default: 'delete' },
            dropFolderFileId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'dropFolderFile' action 'get'.
 *
 * Usage: Retrieve a KalturaDropFolderFile object by ID
 *
 * Server response type:         KalturaDropFolderFile
 * Server failure response type: KalturaAPIException
 */
class DropFolderFileGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDropFolderFile', responseConstructor: KalturaDropFolderFile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'dropfolder_dropfolderfile' },
            action: { type: 'c', default: 'get' },
            dropFolderFileId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'dropFolderFile' action 'ignore'.
 *
 * Usage: Set the KalturaDropFolderFile status to ignore (KalturaDropFolderFileStatus::IGNORE)
 *
 * Server response type:         KalturaDropFolderFile
 * Server failure response type: KalturaAPIException
 */
class DropFolderFileIgnoreAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDropFolderFile', responseConstructor: KalturaDropFolderFile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'dropfolder_dropfolderfile' },
            action: { type: 'c', default: 'ignore' },
            dropFolderFileId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'dropFolderFile' action 'list'.
 *
 * Usage: List KalturaDropFolderFile objects
 *
 * Server response type:         KalturaDropFolderFileListResponse
 * Server failure response type: KalturaAPIException
 */
class DropFolderFileListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDropFolderFileListResponse', responseConstructor: KalturaDropFolderFileListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'dropfolder_dropfolderfile' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaDropFolderFileFilter, subType: 'KalturaDropFolderFileFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'dropFolderFile' action 'update'.
 *
 * Usage: Update an existing KalturaDropFolderFile object
 *
 * Server response type:         KalturaDropFolderFile
 * Server failure response type: KalturaAPIException
 */
class DropFolderFileUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDropFolderFile', responseConstructor: KalturaDropFolderFile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'dropfolder_dropfolderfile' },
            action: { type: 'c', default: 'update' },
            dropFolderFileId: { type: 'n' },
            dropFolderFile: { type: 'o', subTypeConstructor: KalturaDropFolderFile, subType: 'KalturaDropFolderFile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'dropFolderFile' action 'updateStatus'.
 *
 * Usage: Update status of KalturaDropFolderFile
 *
 * Server response type:         KalturaDropFolderFile
 * Server failure response type: KalturaAPIException
 */
class DropFolderFileUpdateStatusAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaDropFolderFile', responseConstructor: KalturaDropFolderFile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'dropfolder_dropfolderfile' },
            action: { type: 'c', default: 'updateStatus' },
            dropFolderFileId: { type: 'n' },
            status: { type: 'en', subTypeConstructor: KalturaDropFolderFileStatus, subType: 'KalturaDropFolderFileStatus' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'eSearch' action 'searchCategory'.
 *
 *
 *
 * Server response type:         KalturaESearchCategoryResponse
 * Server failure response type: KalturaAPIException
 */
class ESearchSearchCategoryAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaESearchCategoryResponse', responseConstructor: KalturaESearchCategoryResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'elasticsearch_esearch' },
            action: { type: 'c', default: 'searchCategory' },
            searchParams: { type: 'o', subTypeConstructor: KalturaESearchCategoryParams, subType: 'KalturaESearchCategoryParams' },
            pager: { type: 'o', subTypeConstructor: KalturaPager, subType: 'KalturaPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'eSearch' action 'searchEntry'.
 *
 *
 *
 * Server response type:         KalturaESearchEntryResponse
 * Server failure response type: KalturaAPIException
 */
class ESearchSearchEntryAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaESearchEntryResponse', responseConstructor: KalturaESearchEntryResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'elasticsearch_esearch' },
            action: { type: 'c', default: 'searchEntry' },
            searchParams: { type: 'o', subTypeConstructor: KalturaESearchEntryParams, subType: 'KalturaESearchEntryParams' },
            pager: { type: 'o', subTypeConstructor: KalturaPager, subType: 'KalturaPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'eSearch' action 'searchUser'.
 *
 *
 *
 * Server response type:         KalturaESearchUserResponse
 * Server failure response type: KalturaAPIException
 */
class ESearchSearchUserAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaESearchUserResponse', responseConstructor: KalturaESearchUserResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'elasticsearch_esearch' },
            action: { type: 'c', default: 'searchUser' },
            searchParams: { type: 'o', subTypeConstructor: KalturaESearchUserParams, subType: 'KalturaESearchUserParams' },
            pager: { type: 'o', subTypeConstructor: KalturaPager, subType: 'KalturaPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'eventNotificationTemplate' action 'add'.
 *
 * Usage: This action allows for the creation of new backend event types in the system. This action requires access to the Kaltura server Admin Console. If you're looking to register to existing event types, please use the clone action instead
 *
 * Server response type:         KalturaEventNotificationTemplate
 * Server failure response type: KalturaAPIException
 */
class EventNotificationTemplateAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEventNotificationTemplate', responseConstructor: KalturaEventNotificationTemplate });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'eventnotification_eventnotificationtemplate' },
            action: { type: 'c', default: 'add' },
            eventNotificationTemplate: { type: 'o', subTypeConstructor: KalturaEventNotificationTemplate, subType: 'KalturaEventNotificationTemplate' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'eventNotificationTemplate' action 'clone'.
 *
 * Usage: This action allows registering to various backend event. Use this action to create notifications that will react to events such as new video was uploaded or metadata field was updated. To see the list of available event types, call the listTemplates action
 *
 * Server response type:         KalturaEventNotificationTemplate
 * Server failure response type: KalturaAPIException
 */
class EventNotificationTemplateCloneAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEventNotificationTemplate', responseConstructor: KalturaEventNotificationTemplate });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'eventnotification_eventnotificationtemplate' },
            action: { type: 'c', default: 'clone' },
            id: { type: 'n' },
            eventNotificationTemplate: { type: 'o', subTypeConstructor: KalturaEventNotificationTemplate, subType: 'KalturaEventNotificationTemplate' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'eventNotificationTemplate' action 'delete'.
 *
 * Usage: Delete an event notification template object
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class EventNotificationTemplateDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'eventnotification_eventnotificationtemplate' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'eventNotificationTemplate' action 'dispatch'.
 *
 * Usage: Dispatch event notification object by id
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class EventNotificationTemplateDispatchAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'eventnotification_eventnotificationtemplate' },
            action: { type: 'c', default: 'dispatch' },
            id: { type: 'n' },
            scope: { type: 'o', subTypeConstructor: KalturaEventNotificationScope, subType: 'KalturaEventNotificationScope' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'eventNotificationTemplate' action 'get'.
 *
 * Usage: Retrieve an event notification template object by id
 *
 * Server response type:         KalturaEventNotificationTemplate
 * Server failure response type: KalturaAPIException
 */
class EventNotificationTemplateGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEventNotificationTemplate', responseConstructor: KalturaEventNotificationTemplate });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'eventnotification_eventnotificationtemplate' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'eventNotificationTemplate' action 'list'.
 *
 * Usage: list event notification template objects
 *
 * Server response type:         KalturaEventNotificationTemplateListResponse
 * Server failure response type: KalturaAPIException
 */
class EventNotificationTemplateListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEventNotificationTemplateListResponse', responseConstructor: KalturaEventNotificationTemplateListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'eventnotification_eventnotificationtemplate' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaEventNotificationTemplateFilter, subType: 'KalturaEventNotificationTemplateFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'eventNotificationTemplate' action 'listByPartner'.
 *
 *
 *
 * Server response type:         KalturaEventNotificationTemplateListResponse
 * Server failure response type: KalturaAPIException
 */
class EventNotificationTemplateListByPartnerAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEventNotificationTemplateListResponse', responseConstructor: KalturaEventNotificationTemplateListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'eventnotification_eventnotificationtemplate' },
            action: { type: 'c', default: 'listByPartner' },
            filter: { type: 'o', subTypeConstructor: KalturaPartnerFilter, subType: 'KalturaPartnerFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'eventNotificationTemplate' action 'listTemplates'.
 *
 * Usage: Action lists the template partner event notification templates
 *
 * Server response type:         KalturaEventNotificationTemplateListResponse
 * Server failure response type: KalturaAPIException
 */
class EventNotificationTemplateListTemplatesAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEventNotificationTemplateListResponse', responseConstructor: KalturaEventNotificationTemplateListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'eventnotification_eventnotificationtemplate' },
            action: { type: 'c', default: 'listTemplates' },
            filter: { type: 'o', subTypeConstructor: KalturaEventNotificationTemplateFilter, subType: 'KalturaEventNotificationTemplateFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'eventNotificationTemplate' action 'register'.
 *
 * Usage: Register to a queue from which event messages will be provided according to given template. Queue will be created if not already exists
 *
 * Server response type:         KalturaPushNotificationData
 * Server failure response type: KalturaAPIException
 */
class EventNotificationTemplateRegisterAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPushNotificationData', responseConstructor: KalturaPushNotificationData });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'eventnotification_eventnotificationtemplate' },
            action: { type: 'c', default: 'register' },
            notificationTemplateSystemName: { type: 's' },
            pushNotificationParams: { type: 'o', subTypeConstructor: KalturaPushNotificationParams, subType: 'KalturaPushNotificationParams' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'eventNotificationTemplate' action 'sendCommand'.
 *
 * Usage: Clear queue messages
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class EventNotificationTemplateSendCommandAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'eventnotification_eventnotificationtemplate' },
            action: { type: 'c', default: 'sendCommand' },
            notificationTemplateSystemName: { type: 's' },
            pushNotificationParams: { type: 'o', subTypeConstructor: KalturaPushNotificationParams, subType: 'KalturaPushNotificationParams' },
            command: { type: 'es', subTypeConstructor: KalturaPushNotificationCommandType, subType: 'KalturaPushNotificationCommandType' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'eventNotificationTemplate' action 'update'.
 *
 * Usage: Update an existing event notification template object
 *
 * Server response type:         KalturaEventNotificationTemplate
 * Server failure response type: KalturaAPIException
 */
class EventNotificationTemplateUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEventNotificationTemplate', responseConstructor: KalturaEventNotificationTemplate });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'eventnotification_eventnotificationtemplate' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            eventNotificationTemplate: { type: 'o', subTypeConstructor: KalturaEventNotificationTemplate, subType: 'KalturaEventNotificationTemplate' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'eventNotificationTemplate' action 'updateStatus'.
 *
 * Usage: Update event notification template status by id
 *
 * Server response type:         KalturaEventNotificationTemplate
 * Server failure response type: KalturaAPIException
 */
class EventNotificationTemplateUpdateStatusAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaEventNotificationTemplate', responseConstructor: KalturaEventNotificationTemplate });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'eventnotification_eventnotificationtemplate' },
            action: { type: 'c', default: 'updateStatus' },
            id: { type: 'n' },
            status: { type: 'en', subTypeConstructor: KalturaEventNotificationTemplateStatus, subType: 'KalturaEventNotificationTemplateStatus' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'externalMedia' action 'add'.
 *
 * Usage: Add external media entry
 *
 * Server response type:         KalturaExternalMediaEntry
 * Server failure response type: KalturaAPIException
 */
class ExternalMediaAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaExternalMediaEntry', responseConstructor: KalturaExternalMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'externalmedia_externalmedia' },
            action: { type: 'c', default: 'add' },
            entry: { type: 'o', subTypeConstructor: KalturaExternalMediaEntry, subType: 'KalturaExternalMediaEntry' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'externalMedia' action 'count'.
 *
 * Usage: Count media entries by filter
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class ExternalMediaCountAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'externalmedia_externalmedia' },
            action: { type: 'c', default: 'count' },
            filter: { type: 'o', subTypeConstructor: KalturaExternalMediaEntryFilter, subType: 'KalturaExternalMediaEntryFilter' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'externalMedia' action 'delete'.
 *
 * Usage: Delete a external media entry
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class ExternalMediaDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'externalmedia_externalmedia' },
            action: { type: 'c', default: 'delete' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'externalMedia' action 'get'.
 *
 * Usage: Get external media entry by ID
 *
 * Server response type:         KalturaExternalMediaEntry
 * Server failure response type: KalturaAPIException
 */
class ExternalMediaGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaExternalMediaEntry', responseConstructor: KalturaExternalMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'externalmedia_externalmedia' },
            action: { type: 'c', default: 'get' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'externalMedia' action 'list'.
 *
 * Usage: List media entries by filter with paging support
 *
 * Server response type:         KalturaExternalMediaEntryListResponse
 * Server failure response type: KalturaAPIException
 */
class ExternalMediaListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaExternalMediaEntryListResponse', responseConstructor: KalturaExternalMediaEntryListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'externalmedia_externalmedia' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaExternalMediaEntryFilter, subType: 'KalturaExternalMediaEntryFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'externalMedia' action 'update'.
 *
 * Usage: Update external media entry. Only the properties that were set will be updated
 *
 * Server response type:         KalturaExternalMediaEntry
 * Server failure response type: KalturaAPIException
 */
class ExternalMediaUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaExternalMediaEntry', responseConstructor: KalturaExternalMediaEntry });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'externalmedia_externalmedia' },
            action: { type: 'c', default: 'update' },
            id: { type: 's' },
            entry: { type: 'o', subTypeConstructor: KalturaExternalMediaEntry, subType: 'KalturaExternalMediaEntry' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'integration' action 'dispatch'.
 *
 * Usage: Dispatch integration task
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class IntegrationDispatchAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'integration_integration' },
            action: { type: 'c', default: 'dispatch' },
            data: { type: 'o', subTypeConstructor: KalturaIntegrationJobData, subType: 'KalturaIntegrationJobData' },
            objectType: { type: 'es', subTypeConstructor: KalturaBatchJobObjectType, subType: 'KalturaBatchJobObjectType' },
            objectId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'integration' action 'notify'.
 *
 *
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class IntegrationNotifyAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'integration_integration' },
            action: { type: 'c', default: 'notify' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'like' action 'checkLikeExists'.
 *
 *
 *
 * Server response type:         boolean
 * Server failure response type: KalturaAPIException
 */
class LikeCheckLikeExistsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'b', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'like_like' },
            action: { type: 'c', default: 'checkLikeExists' },
            entryId: { type: 's' },
            userId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'like' action 'like'.
 *
 *
 *
 * Server response type:         boolean
 * Server failure response type: KalturaAPIException
 */
class LikeLikeAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'b', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'like_like' },
            action: { type: 'c', default: 'like' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'like' action 'list'.
 *
 *
 *
 * Server response type:         KalturaLikeListResponse
 * Server failure response type: KalturaAPIException
 */
class LikeListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaLikeListResponse', responseConstructor: KalturaLikeListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'like_like' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaLikeFilter, subType: 'KalturaLikeFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'like' action 'unlike'.
 *
 *
 *
 * Server response type:         boolean
 * Server failure response type: KalturaAPIException
 */
class LikeUnlikeAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'b', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'like_like' },
            action: { type: 'c', default: 'unlike' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadata' action 'add'.
 *
 * Usage: Allows you to add a metadata object and metadata content associated with Kaltura object
 *
 * Server response type:         KalturaMetadata
 * Server failure response type: KalturaAPIException
 */
class MetadataAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadata', responseConstructor: KalturaMetadata });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadata' },
            action: { type: 'c', default: 'add' },
            metadataProfileId: { type: 'n' },
            objectType: { type: 'es', subTypeConstructor: KalturaMetadataObjectType, subType: 'KalturaMetadataObjectType' },
            objectId: { type: 's' },
            xmlData: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadata' action 'addFromBulk'.
 *
 * Usage: Allows you to add a metadata xml data from remote URL.
 * Enables different permissions than addFromUrl action
 *
 * Server response type:         KalturaMetadata
 * Server failure response type: KalturaAPIException
 */
class MetadataAddFromBulkAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadata', responseConstructor: KalturaMetadata });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadata' },
            action: { type: 'c', default: 'addFromBulk' },
            metadataProfileId: { type: 'n' },
            objectType: { type: 'es', subTypeConstructor: KalturaMetadataObjectType, subType: 'KalturaMetadataObjectType' },
            objectId: { type: 's' },
            url: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadata' action 'addFromFile'.
 *
 * Usage: Allows you to add a metadata object and metadata file associated with Kaltura object
 *
 * Server response type:         KalturaMetadata
 * Server failure response type: KalturaAPIException
 */
class MetadataAddFromFileAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadata', responseConstructor: KalturaMetadata });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadata' },
            action: { type: 'c', default: 'addFromFile' },
            metadataProfileId: { type: 'n' },
            objectType: { type: 'es', subTypeConstructor: KalturaMetadataObjectType, subType: 'KalturaMetadataObjectType' },
            objectId: { type: 's' },
            xmlFile: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadata' action 'addFromUrl'.
 *
 * Usage: Allows you to add a metadata xml data from remote URL
 *
 * Server response type:         KalturaMetadata
 * Server failure response type: KalturaAPIException
 */
class MetadataAddFromUrlAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadata', responseConstructor: KalturaMetadata });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadata' },
            action: { type: 'c', default: 'addFromUrl' },
            metadataProfileId: { type: 'n' },
            objectType: { type: 'es', subTypeConstructor: KalturaMetadataObjectType, subType: 'KalturaMetadataObjectType' },
            objectId: { type: 's' },
            url: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadata' action 'delete'.
 *
 * Usage: Delete an existing metadata
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class MetadataDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadata' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadata' action 'get'.
 *
 * Usage: Retrieve a metadata object by id
 *
 * Server response type:         KalturaMetadata
 * Server failure response type: KalturaAPIException
 */
class MetadataGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadata', responseConstructor: KalturaMetadata });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadata' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadata' action 'index'.
 *
 * Usage: Index metadata by id, will also index the related object
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class MetadataIndexAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadata' },
            action: { type: 'c', default: 'index' },
            id: { type: 's' },
            shouldUpdate: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadata' action 'invalidate'.
 *
 * Usage: Mark existing metadata as invalid
 * Used by batch metadata transform
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class MetadataInvalidateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadata' },
            action: { type: 'c', default: 'invalidate' },
            id: { type: 'n' },
            version: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadata' action 'list'.
 *
 * Usage: List metadata objects by filter and pager
 *
 * Server response type:         KalturaMetadataListResponse
 * Server failure response type: KalturaAPIException
 */
class MetadataListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadataListResponse', responseConstructor: KalturaMetadataListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadata' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaMetadataFilter, subType: 'KalturaMetadataFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadata' action 'serve'.
 *
 * Usage: Serves metadata XML file
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class MetadataServeAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadata' },
            action: { type: 'c', default: 'serve' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadata' action 'update'.
 *
 * Usage: Update an existing metadata object with new XML content
 *
 * Server response type:         KalturaMetadata
 * Server failure response type: KalturaAPIException
 */
class MetadataUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadata', responseConstructor: KalturaMetadata });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadata' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            xmlData: { type: 's' },
            version: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadata' action 'updateFromFile'.
 *
 * Usage: Update an existing metadata object with new XML file
 *
 * Server response type:         KalturaMetadata
 * Server failure response type: KalturaAPIException
 */
class MetadataUpdateFromFileAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadata', responseConstructor: KalturaMetadata });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadata' },
            action: { type: 'c', default: 'updateFromFile' },
            id: { type: 'n' },
            xmlFile: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadata' action 'updateFromXSL'.
 *
 * Usage: Action transforms current metadata object XML using a provided XSL
 *
 * Server response type:         KalturaMetadata
 * Server failure response type: KalturaAPIException
 */
class MetadataUpdateFromXSLAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadata', responseConstructor: KalturaMetadata });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadata' },
            action: { type: 'c', default: 'updateFromXSL' },
            id: { type: 'n' },
            xslFile: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadataProfile' action 'add'.
 *
 * Usage: Allows you to add a metadata profile object and metadata profile content associated with Kaltura object type
 *
 * Server response type:         KalturaMetadataProfile
 * Server failure response type: KalturaAPIException
 */
class MetadataProfileAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadataProfile', responseConstructor: KalturaMetadataProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadataprofile' },
            action: { type: 'c', default: 'add' },
            metadataProfile: { type: 'o', subTypeConstructor: KalturaMetadataProfile, subType: 'KalturaMetadataProfile' },
            xsdData: { type: 's' },
            viewsData: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadataProfile' action 'addFromFile'.
 *
 * Usage: Allows you to add a metadata profile object and metadata profile file associated with Kaltura object type
 *
 * Server response type:         KalturaMetadataProfile
 * Server failure response type: KalturaAPIException
 */
class MetadataProfileAddFromFileAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadataProfile', responseConstructor: KalturaMetadataProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadataprofile' },
            action: { type: 'c', default: 'addFromFile' },
            metadataProfile: { type: 'o', subTypeConstructor: KalturaMetadataProfile, subType: 'KalturaMetadataProfile' },
            xsdFile: { type: 'f' },
            viewsFile: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadataProfile' action 'delete'.
 *
 * Usage: Delete an existing metadata profile
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class MetadataProfileDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadataprofile' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadataProfile' action 'get'.
 *
 * Usage: Retrieve a metadata profile object by id
 *
 * Server response type:         KalturaMetadataProfile
 * Server failure response type: KalturaAPIException
 */
class MetadataProfileGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadataProfile', responseConstructor: KalturaMetadataProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadataprofile' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadataProfile' action 'list'.
 *
 * Usage: List metadata profile objects by filter and pager
 *
 * Server response type:         KalturaMetadataProfileListResponse
 * Server failure response type: KalturaAPIException
 */
class MetadataProfileListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadataProfileListResponse', responseConstructor: KalturaMetadataProfileListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadataprofile' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaMetadataProfileFilter, subType: 'KalturaMetadataProfileFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadataProfile' action 'listFields'.
 *
 * Usage: List metadata profile fields by metadata profile id
 *
 * Server response type:         KalturaMetadataProfileFieldListResponse
 * Server failure response type: KalturaAPIException
 */
class MetadataProfileListFieldsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadataProfileFieldListResponse', responseConstructor: KalturaMetadataProfileFieldListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadataprofile' },
            action: { type: 'c', default: 'listFields' },
            metadataProfileId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadataProfile' action 'revert'.
 *
 * Usage: Update an existing metadata object definition file
 *
 * Server response type:         KalturaMetadataProfile
 * Server failure response type: KalturaAPIException
 */
class MetadataProfileRevertAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadataProfile', responseConstructor: KalturaMetadataProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadataprofile' },
            action: { type: 'c', default: 'revert' },
            id: { type: 'n' },
            toVersion: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadataProfile' action 'serve'.
 *
 * Usage: Serves metadata profile XSD file
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class MetadataProfileServeAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadataprofile' },
            action: { type: 'c', default: 'serve' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadataProfile' action 'serveView'.
 *
 * Usage: Serves metadata profile view file
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class MetadataProfileServeViewAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadataprofile' },
            action: { type: 'c', default: 'serveView' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadataProfile' action 'update'.
 *
 * Usage: Update an existing metadata object
 *
 * Server response type:         KalturaMetadataProfile
 * Server failure response type: KalturaAPIException
 */
class MetadataProfileUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadataProfile', responseConstructor: KalturaMetadataProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadataprofile' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            metadataProfile: { type: 'o', subTypeConstructor: KalturaMetadataProfile, subType: 'KalturaMetadataProfile' },
            xsdData: { type: 's' },
            viewsData: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadataProfile' action 'updateDefinitionFromFile'.
 *
 * Usage: Update an existing metadata object definition file
 *
 * Server response type:         KalturaMetadataProfile
 * Server failure response type: KalturaAPIException
 */
class MetadataProfileUpdateDefinitionFromFileAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadataProfile', responseConstructor: KalturaMetadataProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadataprofile' },
            action: { type: 'c', default: 'updateDefinitionFromFile' },
            id: { type: 'n' },
            xsdFile: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadataProfile' action 'updateTransformationFromFile'.
 *
 * Usage: Update an existing metadata object xslt file
 *
 * Server response type:         KalturaMetadataProfile
 * Server failure response type: KalturaAPIException
 */
class MetadataProfileUpdateTransformationFromFileAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadataProfile', responseConstructor: KalturaMetadataProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadataprofile' },
            action: { type: 'c', default: 'updateTransformationFromFile' },
            id: { type: 'n' },
            xsltFile: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'metadataProfile' action 'updateViewsFromFile'.
 *
 * Usage: Update an existing metadata object views file
 *
 * Server response type:         KalturaMetadataProfile
 * Server failure response type: KalturaAPIException
 */
class MetadataProfileUpdateViewsFromFileAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaMetadataProfile', responseConstructor: KalturaMetadataProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'metadata_metadataprofile' },
            action: { type: 'c', default: 'updateViewsFromFile' },
            id: { type: 'n' },
            viewsFile: { type: 'f' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'playReadyDrm' action 'generateKey'.
 *
 * Usage: Generate key id and content key for PlayReady encryption
 *
 * Server response type:         KalturaPlayReadyContentKey
 * Server failure response type: KalturaAPIException
 */
class PlayReadyDrmGenerateKeyAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPlayReadyContentKey', responseConstructor: KalturaPlayReadyContentKey });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'playready_playreadydrm' },
            action: { type: 'c', default: 'generateKey' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'playReadyDrm' action 'getContentKeys'.
 *
 * Usage: Get content keys for input key ids
 *
 * Server response type:         KalturaPlayReadyContentKey[]
 * Server failure response type: KalturaAPIException
 */
class PlayReadyDrmGetContentKeysAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'a', responseSubType: 'KalturaPlayReadyContentKey', responseConstructor: KalturaPlayReadyContentKey });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'playready_playreadydrm' },
            action: { type: 'c', default: 'getContentKeys' },
            keyIds: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'playReadyDrm' action 'getEntryContentKey'.
 *
 * Usage: Get content key and key id for the given entry
 *
 * Server response type:         KalturaPlayReadyContentKey
 * Server failure response type: KalturaAPIException
 */
class PlayReadyDrmGetEntryContentKeyAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPlayReadyContentKey', responseConstructor: KalturaPlayReadyContentKey });
        if (typeof this.createIfMissing === 'undefined')
            this.createIfMissing = false;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'playready_playreadydrm' },
            action: { type: 'c', default: 'getEntryContentKey' },
            entryId: { type: 's' },
            createIfMissing: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'playReadyDrm' action 'getLicenseDetails'.
 *
 * Usage: Get Play Ready policy and dates for license creation
 *
 * Server response type:         KalturaPlayReadyLicenseDetails
 * Server failure response type: KalturaAPIException
 */
class PlayReadyDrmGetLicenseDetailsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPlayReadyLicenseDetails', responseConstructor: KalturaPlayReadyLicenseDetails });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'playready_playreadydrm' },
            action: { type: 'c', default: 'getLicenseDetails' },
            keyId: { type: 's' },
            deviceId: { type: 's' },
            deviceType: { type: 'n' },
            entryId: { type: 's' },
            referrer: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'poll' action 'add'.
 *
 * Usage: Add Action
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class PollAddAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
        if (typeof this.pollType === 'undefined')
            this.pollType = "SINGLE_ANONYMOUS";
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'poll_poll' },
            action: { type: 'c', default: 'add' },
            pollType: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'poll' action 'getVote'.
 *
 * Usage: Vote Action
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class PollGetVoteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'poll_poll' },
            action: { type: 'c', default: 'getVote' },
            pollId: { type: 's' },
            userId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'poll' action 'getVotes'.
 *
 * Usage: Get Votes Action
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class PollGetVotesAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'poll_poll' },
            action: { type: 'c', default: 'getVotes' },
            pollId: { type: 's' },
            answerIds: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'poll' action 'resetVotes'.
 *
 * Usage: Get resetVotes Action
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class PollResetVotesAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'poll_poll' },
            action: { type: 'c', default: 'resetVotes' },
            pollId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'poll' action 'vote'.
 *
 * Usage: Vote Action
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class PollVoteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'poll_poll' },
            action: { type: 'c', default: 'vote' },
            pollId: { type: 's' },
            userId: { type: 's' },
            answerIds: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'quiz' action 'add'.
 *
 * Usage: Allows to add a quiz to an entry
 *
 * Server response type:         KalturaQuiz
 * Server failure response type: KalturaAPIException
 */
class QuizAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaQuiz', responseConstructor: KalturaQuiz });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'quiz_quiz' },
            action: { type: 'c', default: 'add' },
            entryId: { type: 's' },
            quiz: { type: 'o', subTypeConstructor: KalturaQuiz, subType: 'KalturaQuiz' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'quiz' action 'get'.
 *
 * Usage: Allows to get a quiz
 *
 * Server response type:         KalturaQuiz
 * Server failure response type: KalturaAPIException
 */
class QuizGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaQuiz', responseConstructor: KalturaQuiz });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'quiz_quiz' },
            action: { type: 'c', default: 'get' },
            entryId: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'quiz' action 'getUrl'.
 *
 * Usage: sends a with an api request for pdf from quiz object
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class QuizGetUrlAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'quiz_quiz' },
            action: { type: 'c', default: 'getUrl' },
            entryId: { type: 's' },
            quizOutputType: { type: 'en', subTypeConstructor: KalturaQuizOutputType, subType: 'KalturaQuizOutputType' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'quiz' action 'list'.
 *
 * Usage: List quiz objects by filter and pager
 *
 * Server response type:         KalturaQuizListResponse
 * Server failure response type: KalturaAPIException
 */
class QuizListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaQuizListResponse', responseConstructor: KalturaQuizListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'quiz_quiz' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaQuizFilter, subType: 'KalturaQuizFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'quiz' action 'serve'.
 *
 * Usage: creates a pdf from quiz object
 * The Output type defines the file format in which the quiz will be generated
 * Currently only PDF files are supported
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class QuizServeAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'quiz_quiz' },
            action: { type: 'c', default: 'serve' },
            entryId: { type: 's' },
            quizOutputType: { type: 'en', subTypeConstructor: KalturaQuizOutputType, subType: 'KalturaQuizOutputType' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'quiz' action 'update'.
 *
 * Usage: Allows to update a quiz
 *
 * Server response type:         KalturaQuiz
 * Server failure response type: KalturaAPIException
 */
class QuizUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaQuiz', responseConstructor: KalturaQuiz });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'quiz_quiz' },
            action: { type: 'c', default: 'update' },
            entryId: { type: 's' },
            quiz: { type: 'o', subTypeConstructor: KalturaQuiz, subType: 'KalturaQuiz' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleEvent' action 'add'.
 *
 * Usage: Allows you to add a new KalturaScheduleEvent object
 *
 * Server response type:         KalturaScheduleEvent
 * Server failure response type: KalturaAPIException
 */
class ScheduleEventAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduleEvent', responseConstructor: KalturaScheduleEvent });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleevent' },
            action: { type: 'c', default: 'add' },
            scheduleEvent: { type: 'o', subTypeConstructor: KalturaScheduleEvent, subType: 'KalturaScheduleEvent' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleEvent' action 'addFromBulkUpload'.
 *
 * Usage: Add new bulk upload batch job
 *
 * Server response type:         KalturaBulkUpload
 * Server failure response type: KalturaAPIException
 */
class ScheduleEventAddFromBulkUploadAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBulkUpload', responseConstructor: KalturaBulkUpload });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleevent' },
            action: { type: 'c', default: 'addFromBulkUpload' },
            fileData: { type: 'f' },
            bulkUploadData: { type: 'o', subTypeConstructor: KalturaBulkUploadICalJobData, subType: 'KalturaBulkUploadICalJobData' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleEvent' action 'cancel'.
 *
 * Usage: Mark the KalturaScheduleEvent object as cancelled
 *
 * Server response type:         KalturaScheduleEvent
 * Server failure response type: KalturaAPIException
 */
class ScheduleEventCancelAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduleEvent', responseConstructor: KalturaScheduleEvent });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleevent' },
            action: { type: 'c', default: 'cancel' },
            scheduleEventId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleEvent' action 'delete'.
 *
 * Usage: Mark the KalturaScheduleEvent object as deleted
 *
 * Server response type:         KalturaScheduleEvent
 * Server failure response type: KalturaAPIException
 */
class ScheduleEventDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduleEvent', responseConstructor: KalturaScheduleEvent });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleevent' },
            action: { type: 'c', default: 'delete' },
            scheduleEventId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleEvent' action 'get'.
 *
 * Usage: Retrieve a KalturaScheduleEvent object by ID
 *
 * Server response type:         KalturaScheduleEvent
 * Server failure response type: KalturaAPIException
 */
class ScheduleEventGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduleEvent', responseConstructor: KalturaScheduleEvent });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleevent' },
            action: { type: 'c', default: 'get' },
            scheduleEventId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleEvent' action 'getConflicts'.
 *
 * Usage: List conflicting events for resourcesIds by event's dates
 *
 * Server response type:         KalturaScheduleEventListResponse
 * Server failure response type: KalturaAPIException
 */
class ScheduleEventGetConflictsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduleEventListResponse', responseConstructor: KalturaScheduleEventListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleevent' },
            action: { type: 'c', default: 'getConflicts' },
            resourceIds: { type: 's' },
            scheduleEvent: { type: 'o', subTypeConstructor: KalturaScheduleEvent, subType: 'KalturaScheduleEvent' },
            scheduleEventIdToIgnore: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleEvent' action 'list'.
 *
 * Usage: List KalturaScheduleEvent objects
 *
 * Server response type:         KalturaScheduleEventListResponse
 * Server failure response type: KalturaAPIException
 */
class ScheduleEventListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduleEventListResponse', responseConstructor: KalturaScheduleEventListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleevent' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaScheduleEventFilter, subType: 'KalturaScheduleEventFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleEvent' action 'update'.
 *
 * Usage: Update an existing KalturaScheduleEvent object
 *
 * Server response type:         KalturaScheduleEvent
 * Server failure response type: KalturaAPIException
 */
class ScheduleEventUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduleEvent', responseConstructor: KalturaScheduleEvent });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleevent' },
            action: { type: 'c', default: 'update' },
            scheduleEventId: { type: 'n' },
            scheduleEvent: { type: 'o', subTypeConstructor: KalturaScheduleEvent, subType: 'KalturaScheduleEvent' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleResource' action 'add'.
 *
 * Usage: Allows you to add a new KalturaScheduleResource object
 *
 * Server response type:         KalturaScheduleResource
 * Server failure response type: KalturaAPIException
 */
class ScheduleResourceAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduleResource', responseConstructor: KalturaScheduleResource });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleresource' },
            action: { type: 'c', default: 'add' },
            scheduleResource: { type: 'o', subTypeConstructor: KalturaScheduleResource, subType: 'KalturaScheduleResource' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleResource' action 'addFromBulkUpload'.
 *
 * Usage: Add new bulk upload batch job
 *
 * Server response type:         KalturaBulkUpload
 * Server failure response type: KalturaAPIException
 */
class ScheduleResourceAddFromBulkUploadAction extends KalturaUploadRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaBulkUpload', responseConstructor: KalturaBulkUpload });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleresource' },
            action: { type: 'c', default: 'addFromBulkUpload' },
            fileData: { type: 'f' },
            bulkUploadData: { type: 'o', subTypeConstructor: KalturaBulkUploadCsvJobData, subType: 'KalturaBulkUploadCsvJobData' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleResource' action 'delete'.
 *
 * Usage: Mark the KalturaScheduleResource object as deleted
 *
 * Server response type:         KalturaScheduleResource
 * Server failure response type: KalturaAPIException
 */
class ScheduleResourceDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduleResource', responseConstructor: KalturaScheduleResource });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleresource' },
            action: { type: 'c', default: 'delete' },
            scheduleResourceId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleResource' action 'get'.
 *
 * Usage: Retrieve a KalturaScheduleResource object by ID
 *
 * Server response type:         KalturaScheduleResource
 * Server failure response type: KalturaAPIException
 */
class ScheduleResourceGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduleResource', responseConstructor: KalturaScheduleResource });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleresource' },
            action: { type: 'c', default: 'get' },
            scheduleResourceId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleResource' action 'list'.
 *
 * Usage: List KalturaScheduleResource objects
 *
 * Server response type:         KalturaScheduleResourceListResponse
 * Server failure response type: KalturaAPIException
 */
class ScheduleResourceListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduleResourceListResponse', responseConstructor: KalturaScheduleResourceListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleresource' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaScheduleResourceFilter, subType: 'KalturaScheduleResourceFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleResource' action 'update'.
 *
 * Usage: Update an existing KalturaScheduleResource object
 *
 * Server response type:         KalturaScheduleResource
 * Server failure response type: KalturaAPIException
 */
class ScheduleResourceUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduleResource', responseConstructor: KalturaScheduleResource });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleresource' },
            action: { type: 'c', default: 'update' },
            scheduleResourceId: { type: 'n' },
            scheduleResource: { type: 'o', subTypeConstructor: KalturaScheduleResource, subType: 'KalturaScheduleResource' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleEventResource' action 'add'.
 *
 * Usage: Allows you to add a new KalturaScheduleEventResource object
 *
 * Server response type:         KalturaScheduleEventResource
 * Server failure response type: KalturaAPIException
 */
class ScheduleEventResourceAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduleEventResource', responseConstructor: KalturaScheduleEventResource });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleeventresource' },
            action: { type: 'c', default: 'add' },
            scheduleEventResource: { type: 'o', subTypeConstructor: KalturaScheduleEventResource, subType: 'KalturaScheduleEventResource' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleEventResource' action 'delete'.
 *
 * Usage: Mark the KalturaScheduleEventResource object as deleted
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class ScheduleEventResourceDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleeventresource' },
            action: { type: 'c', default: 'delete' },
            scheduleEventId: { type: 'n' },
            scheduleResourceId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleEventResource' action 'get'.
 *
 * Usage: Retrieve a KalturaScheduleEventResource object by ID
 *
 * Server response type:         KalturaScheduleEventResource
 * Server failure response type: KalturaAPIException
 */
class ScheduleEventResourceGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduleEventResource', responseConstructor: KalturaScheduleEventResource });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleeventresource' },
            action: { type: 'c', default: 'get' },
            scheduleEventId: { type: 'n' },
            scheduleResourceId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleEventResource' action 'list'.
 *
 * Usage: List KalturaScheduleEventResource objects
 *
 * Server response type:         KalturaScheduleEventResourceListResponse
 * Server failure response type: KalturaAPIException
 */
class ScheduleEventResourceListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduleEventResourceListResponse', responseConstructor: KalturaScheduleEventResourceListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleeventresource' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaScheduleEventResourceFilter, subType: 'KalturaScheduleEventResourceFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduleEventResource' action 'update'.
 *
 * Usage: Update an existing KalturaScheduleEventResource object
 *
 * Server response type:         KalturaScheduleEventResource
 * Server failure response type: KalturaAPIException
 */
class ScheduleEventResourceUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduleEventResource', responseConstructor: KalturaScheduleEventResource });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'schedule_scheduleeventresource' },
            action: { type: 'c', default: 'update' },
            scheduleEventId: { type: 'n' },
            scheduleResourceId: { type: 'n' },
            scheduleEventResource: { type: 'o', subTypeConstructor: KalturaScheduleEventResource, subType: 'KalturaScheduleEventResource' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduledTaskProfile' action 'add'.
 *
 * Usage: Add a new scheduled task profile
 *
 * Server response type:         KalturaScheduledTaskProfile
 * Server failure response type: KalturaAPIException
 */
class ScheduledTaskProfileAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduledTaskProfile', responseConstructor: KalturaScheduledTaskProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'scheduledtask_scheduledtaskprofile' },
            action: { type: 'c', default: 'add' },
            scheduledTaskProfile: { type: 'o', subTypeConstructor: KalturaScheduledTaskProfile, subType: 'KalturaScheduledTaskProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduledTaskProfile' action 'delete'.
 *
 * Usage: Delete a scheduled task profile
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class ScheduledTaskProfileDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'scheduledtask_scheduledtaskprofile' },
            action: { type: 'c', default: 'delete' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduledTaskProfile' action 'get'.
 *
 * Usage: Retrieve a scheduled task profile by id
 *
 * Server response type:         KalturaScheduledTaskProfile
 * Server failure response type: KalturaAPIException
 */
class ScheduledTaskProfileGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduledTaskProfile', responseConstructor: KalturaScheduledTaskProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'scheduledtask_scheduledtaskprofile' },
            action: { type: 'c', default: 'get' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduledTaskProfile' action 'getDryRunResults'.
 *
 *
 *
 * Server response type:         KalturaObjectListResponse
 * Server failure response type: KalturaAPIException
 */
class ScheduledTaskProfileGetDryRunResultsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaObjectListResponse', responseConstructor: KalturaObjectListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'scheduledtask_scheduledtaskprofile' },
            action: { type: 'c', default: 'getDryRunResults' },
            requestId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduledTaskProfile' action 'list'.
 *
 * Usage: List scheduled task profiles
 *
 * Server response type:         KalturaScheduledTaskProfileListResponse
 * Server failure response type: KalturaAPIException
 */
class ScheduledTaskProfileListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduledTaskProfileListResponse', responseConstructor: KalturaScheduledTaskProfileListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'scheduledtask_scheduledtaskprofile' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaScheduledTaskProfileFilter, subType: 'KalturaScheduledTaskProfileFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduledTaskProfile' action 'requestDryRun'.
 *
 *
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class ScheduledTaskProfileRequestDryRunAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
        if (typeof this.maxResults === 'undefined')
            this.maxResults = 500;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'scheduledtask_scheduledtaskprofile' },
            action: { type: 'c', default: 'requestDryRun' },
            scheduledTaskProfileId: { type: 'n' },
            maxResults: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduledTaskProfile' action 'serveDryRunResults'.
 *
 * Usage: Serves dry run results by its request id
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class ScheduledTaskProfileServeDryRunResultsAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'scheduledtask_scheduledtaskprofile' },
            action: { type: 'c', default: 'serveDryRunResults' },
            requestId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'scheduledTaskProfile' action 'update'.
 *
 * Usage: Update an existing scheduled task profile
 *
 * Server response type:         KalturaScheduledTaskProfile
 * Server failure response type: KalturaAPIException
 */
class ScheduledTaskProfileUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaScheduledTaskProfile', responseConstructor: KalturaScheduledTaskProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'scheduledtask_scheduledtaskprofile' },
            action: { type: 'c', default: 'update' },
            id: { type: 'n' },
            scheduledTaskProfile: { type: 'o', subTypeConstructor: KalturaScheduledTaskProfile, subType: 'KalturaScheduledTaskProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'shortLink' action 'add'.
 *
 * Usage: Allows you to add a short link object
 *
 * Server response type:         KalturaShortLink
 * Server failure response type: KalturaAPIException
 */
class ShortLinkAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaShortLink', responseConstructor: KalturaShortLink });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'shortlink_shortlink' },
            action: { type: 'c', default: 'add' },
            shortLink: { type: 'o', subTypeConstructor: KalturaShortLink, subType: 'KalturaShortLink' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'shortLink' action 'delete'.
 *
 * Usage: Mark the short link as deleted
 *
 * Server response type:         KalturaShortLink
 * Server failure response type: KalturaAPIException
 */
class ShortLinkDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaShortLink', responseConstructor: KalturaShortLink });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'shortlink_shortlink' },
            action: { type: 'c', default: 'delete' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'shortLink' action 'get'.
 *
 * Usage: Retrieve an short link object by id
 *
 * Server response type:         KalturaShortLink
 * Server failure response type: KalturaAPIException
 */
class ShortLinkGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaShortLink', responseConstructor: KalturaShortLink });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'shortlink_shortlink' },
            action: { type: 'c', default: 'get' },
            id: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'shortLink' action 'goto'.
 *
 * Usage: Serves short link
 *
 * Server response type:         { url: string }
 * Server failure response type: KalturaAPIException
 */
class ShortLinkGotoAction extends KalturaFileRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data);
        if (typeof this.proxy === 'undefined')
            this.proxy = false;
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'shortlink_shortlink' },
            action: { type: 'c', default: 'goto' },
            id: { type: 's' },
            proxy: { type: 'b' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'shortLink' action 'list'.
 *
 * Usage: List short link objects by filter and pager
 *
 * Server response type:         KalturaShortLinkListResponse
 * Server failure response type: KalturaAPIException
 */
class ShortLinkListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaShortLinkListResponse', responseConstructor: KalturaShortLinkListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'shortlink_shortlink' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaShortLinkFilter, subType: 'KalturaShortLinkFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'shortLink' action 'update'.
 *
 * Usage: Update exisitng short link
 *
 * Server response type:         KalturaShortLink
 * Server failure response type: KalturaAPIException
 */
class ShortLinkUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaShortLink', responseConstructor: KalturaShortLink });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'shortlink_shortlink' },
            action: { type: 'c', default: 'update' },
            id: { type: 's' },
            shortLink: { type: 'o', subTypeConstructor: KalturaShortLink, subType: 'KalturaShortLink' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'tag' action 'deletePending'.
 *
 * Usage: Action goes over all tags with instanceCount==0 and checks whether they need to be removed from the DB. Returns number of removed tags
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class TagDeletePendingAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'tagsearch_tag' },
            action: { type: 'c', default: 'deletePending' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'tag' action 'indexCategoryEntryTags'.
 *
 *
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class TagIndexCategoryEntryTagsAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'tagsearch_tag' },
            action: { type: 'c', default: 'indexCategoryEntryTags' },
            categoryId: { type: 'n' },
            pcToDecrement: { type: 's' },
            pcToIncrement: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'tag' action 'search'.
 *
 *
 *
 * Server response type:         KalturaTagListResponse
 * Server failure response type: KalturaAPIException
 */
class TagSearchAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaTagListResponse', responseConstructor: KalturaTagListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'tagsearch_tag' },
            action: { type: 'c', default: 'search' },
            tagFilter: { type: 'o', subTypeConstructor: KalturaTagFilter, subType: 'KalturaTagFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'unicorn' action 'notify'.
 *
 *
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class UnicornNotifyAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'unicorndistribution_unicorn' },
            action: { type: 'c', default: 'notify' },
            id: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'varConsole' action 'getPartnerUsage'.
 *
 * Usage: Function which calulates partner usage of a group of a VAR's sub-publishers
 *
 * Server response type:         KalturaPartnerUsageListResponse
 * Server failure response type: KalturaAPIException
 */
class VarConsoleGetPartnerUsageAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaPartnerUsageListResponse', responseConstructor: KalturaPartnerUsageListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'varconsole_varconsole' },
            action: { type: 'c', default: 'getPartnerUsage' },
            partnerFilter: { type: 'o', subTypeConstructor: KalturaPartnerFilter, subType: 'KalturaPartnerFilter' },
            usageFilter: { type: 'o', subTypeConstructor: KalturaReportInputFilter, subType: 'KalturaReportInputFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'varConsole' action 'updateStatus'.
 *
 * Usage: Function to change a sub-publisher's status
 *
 * Server response type:         void
 * Server failure response type: KalturaAPIException
 */
class VarConsoleUpdateStatusAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'v', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'varconsole_varconsole' },
            action: { type: 'c', default: 'updateStatus' },
            id: { type: 'n' },
            status: { type: 'en', subTypeConstructor: KalturaPartnerStatus, subType: 'KalturaPartnerStatus' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'virusScanProfile' action 'add'.
 *
 * Usage: Allows you to add an virus scan profile object and virus scan profile content associated with Kaltura object
 *
 * Server response type:         KalturaVirusScanProfile
 * Server failure response type: KalturaAPIException
 */
class VirusScanProfileAddAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaVirusScanProfile', responseConstructor: KalturaVirusScanProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'virusscan_virusscanprofile' },
            action: { type: 'c', default: 'add' },
            virusScanProfile: { type: 'o', subTypeConstructor: KalturaVirusScanProfile, subType: 'KalturaVirusScanProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'virusScanProfile' action 'delete'.
 *
 * Usage: Mark the virus scan profile as deleted
 *
 * Server response type:         KalturaVirusScanProfile
 * Server failure response type: KalturaAPIException
 */
class VirusScanProfileDeleteAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaVirusScanProfile', responseConstructor: KalturaVirusScanProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'virusscan_virusscanprofile' },
            action: { type: 'c', default: 'delete' },
            virusScanProfileId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'virusScanProfile' action 'get'.
 *
 * Usage: Retrieve an virus scan profile object by id
 *
 * Server response type:         KalturaVirusScanProfile
 * Server failure response type: KalturaAPIException
 */
class VirusScanProfileGetAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaVirusScanProfile', responseConstructor: KalturaVirusScanProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'virusscan_virusscanprofile' },
            action: { type: 'c', default: 'get' },
            virusScanProfileId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'virusScanProfile' action 'list'.
 *
 * Usage: List virus scan profile objects by filter and pager
 *
 * Server response type:         KalturaVirusScanProfileListResponse
 * Server failure response type: KalturaAPIException
 */
class VirusScanProfileListAction extends KalturaRequest {
    /**
     * @param {?=} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaVirusScanProfileListResponse', responseConstructor: KalturaVirusScanProfileListResponse });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'virusscan_virusscanprofile' },
            action: { type: 'c', default: 'list' },
            filter: { type: 'o', subTypeConstructor: KalturaVirusScanProfileFilter, subType: 'KalturaVirusScanProfileFilter' },
            pager: { type: 'o', subTypeConstructor: KalturaFilterPager, subType: 'KalturaFilterPager' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'virusScanProfile' action 'scan'.
 *
 * Usage: Scan flavor asset according to virus scan profile
 *
 * Server response type:         number
 * Server failure response type: KalturaAPIException
 */
class VirusScanProfileScanAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'n', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'virusscan_virusscanprofile' },
            action: { type: 'c', default: 'scan' },
            flavorAssetId: { type: 's' },
            virusScanProfileId: { type: 'n' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'virusScanProfile' action 'update'.
 *
 * Usage: Update exisitng virus scan profile, it is possible to update the virus scan profile id too
 *
 * Server response type:         KalturaVirusScanProfile
 * Server failure response type: KalturaAPIException
 */
class VirusScanProfileUpdateAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 'o', responseSubType: 'KalturaVirusScanProfile', responseConstructor: KalturaVirusScanProfile });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'virusscan_virusscanprofile' },
            action: { type: 'c', default: 'update' },
            virusScanProfileId: { type: 'n' },
            virusScanProfile: { type: 'o', subTypeConstructor: KalturaVirusScanProfile, subType: 'KalturaVirusScanProfile' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Build request payload for service 'widevineDrm' action 'getLicense'.
 *
 * Usage: Get license for encrypted content playback
 *
 * Server response type:         string
 * Server failure response type: KalturaAPIException
 */
class WidevineDrmGetLicenseAction extends KalturaRequest {
    /**
     * @param {?} data
     */
    constructor(data) {
        super(data, { responseType: 's', responseSubType: '', responseConstructor: null });
    }
    /**
     * @return {?}
     */
    _getMetadata() {
        /** @type {?} */
        const result = super._getMetadata();
        Object.assign(result.properties, {
            service: { type: 'c', default: 'widevine_widevinedrm' },
            action: { type: 'c', default: 'getLicense' },
            flavorAssetId: { type: 's' },
            referrer: { type: 's' }
        });
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { KalturaClient, KalturaClientModule, KalturaClientException, KalturaAPIException, KalturaMultiRequest, KalturaMultiResponse, KalturaRequest, KalturaRequestBase, KalturaUploadRequest, KalturaResponse, KALTURA_CLIENT_DEFAULT_REQUEST_OPTIONS, KalturaRequestOptions, typesMappingStorage, KalturaObjectBaseFactory, KalturaObjectBase, KALTURA_CLIENT_OPTIONS, KalturaListResponse, KalturaBaseRestriction, KalturaAccessControl, KalturaContextTypeHolder, KalturaAccessControlContextTypeHolder, KalturaAccessControlMessage, KalturaRuleAction, KalturaCondition, KalturaRule, KalturaAccessControlProfile, KalturaKeyValue, KalturaAccessControlScope, KalturaReportFilter, KalturaAnalyticsFilter, KalturaCuePoint, KalturaAnnotation, KalturaApiExceptionArg, KalturaAppToken, KalturaAsset, KalturaAssetDistributionCondition, KalturaAssetDistributionRule, KalturaString, KalturaAssetParams, KalturaResource, KalturaContentResource, KalturaAssetParamsResourceContainer, KalturaAssetServeOptions, KalturaAttachmentAsset, KalturaAuditTrailInfo, KalturaAuditTrail, KalturaAuditTrailChangeItem, KalturaOperationAttributes, KalturaBaseEntry, KalturaBaseEntryCloneOptionItem, KalturaBaseResponseProfile, KalturaBaseSyndicationFeed, KalturaJobData, KalturaBatchHistoryData, KalturaBatchJob, KalturaPlayerDeliveryType, KalturaPlayerEmbedCodeType, KalturaESearchLanguageItem, KalturaPartner, KalturaValue, KalturaBooleanValue, KalturaBulkServiceData, KalturaBulkUploadPluginData, KalturaBulkUploadResult, KalturaBulkUpload, KalturaBulkUploadObjectData, KalturaBusinessProcessCase, KalturaBusinessProcessServer, KalturaCEError, KalturaCaptionAsset, KalturaCaptionAssetItem, KalturaCaptionParams, KalturaCategory, KalturaCategoryEntry, KalturaCategoryUser, KalturaClientNotification, KalturaClipDescription, KalturaContext, KalturaContextDataResult, KalturaControlPanelCommand, KalturaConversionAttribute, KalturaCropDimensions, KalturaPluginReplacementOptionsItem, KalturaEntryReplacementOptions, KalturaConversionProfile, KalturaConversionProfileAssetParams, KalturaConvertCollectionFlavorData, KalturaCoordinate, KalturaCsvAdditionalFieldInfo, KalturaDailymotionDistributionCaptionInfo, KalturaDataEntry, KalturaUrlRecognizer, KalturaUrlTokenizer, KalturaSearchItem, KalturaFilter, KalturaRelatedFilter, KalturaAssetBaseFilter, KalturaAssetFilter, KalturaDeliveryProfile, KalturaFileSyncDescriptor, KalturaDestFileSyncDescriptor, KalturaPager, KalturaFilterPager, KalturaResponseProfileMapping, KalturaDetachedResponseProfile, KalturaDistributionFieldConfig, KalturaDistributionJobProviderData, KalturaDistributionThumbDimensions, KalturaDistributionProfile, KalturaDistributionProvider, KalturaDistributionRemoteMediaFile, KalturaDistributionValidationError, KalturaDocumentEntry, KalturaDrmLicenseAccessDetails, KalturaPluginData, KalturaDrmPlaybackPluginData, KalturaDrmPolicy, KalturaDrmProfile, KalturaDropFolderFileHandlerConfig, KalturaDropFolder, KalturaDropFolderFile, KalturaESearchBaseItem, KalturaESearchCategoryBaseItem, KalturaESearchHighlight, KalturaESearchItemData, KalturaESearchItemDataResult, KalturaESearchResult, KalturaESearchCategoryResult, KalturaESearchEntryBaseItem, KalturaESearchEntryBaseNestedObject, KalturaESearchEntryNestedBaseItem, KalturaESearchEntryResult, KalturaESearchOrderByItem, KalturaESearchOrderBy, KalturaESearchParams, KalturaESearchRange, KalturaESearchResponse, KalturaESearchUserBaseItem, KalturaUser, KalturaESearchUserResult, KalturaEffect, KalturaEmailIngestionProfile, KalturaStringValue, KalturaEmailNotificationRecipient, KalturaEmailNotificationRecipientJobData, KalturaEmailNotificationRecipientProvider, KalturaEntryDistribution, KalturaEntryServerNode, KalturaEventNotificationParameter, KalturaEventNotificationTemplate, KalturaObjectIdentifier, KalturaExtendingItemMrssParameter, KalturaPlayableEntry, KalturaStreamContainer, KalturaMediaEntry, KalturaExternalMediaEntry, KalturaFacebookCaptionDistributionInfo, KalturaFeatureStatus, KalturaFeedItemInfo, KalturaFileAsset, KalturaFileContainer, KalturaFileSync, KalturaFlavorAsset, KalturaFlavorAssetUrlOptions, KalturaFlavorParams, KalturaFlavorAssetWithParams, KalturaFlavorParamsOutput, KalturaFreewheelDistributionAssetPath, KalturaFtpDistributionFile, KalturaSchedulerStatus, KalturaSchedulerConfig, KalturaSchedulerWorker, KalturaScheduler, KalturaGenericDistributionProfileAction, KalturaGenericDistributionProviderAction, KalturaGenericDistributionProvider, KalturaGroupUser, KalturaObject, KalturaHttpNotification, KalturaHttpNotificationData, KalturaIntegerValue, KalturaIntegrationJobProviderData, KalturaIntegrationJobTriggerData, KalturaFileSyncListResponse, KalturaBatchJobListResponse, KalturaMediaInfo, KalturaMediaInfoListResponse, KalturaFlavorParamsOutputListResponse, KalturaThumbAsset, KalturaThumbParams, KalturaThumbParamsOutput, KalturaThumbParamsOutputListResponse, KalturaTrackEntry, KalturaLike, KalturaLiveStreamConfiguration, KalturaLiveStreamPushPublishConfiguration, KalturaLiveEntryRecordingOptions, KalturaLiveEntry, KalturaLiveChannel, KalturaLiveChannelSegment, KalturaLiveEntryServerNodeRecordingInfo, KalturaLiveReportExportParams, KalturaLiveReportExportResponse, KalturaLiveReportInputFilter, KalturaLiveStats, KalturaLiveStatsEvent, KalturaLiveStreamBitrate, KalturaLiveStreamEntry, KalturaLiveStreamParams, KalturaBaseEntryBaseFilter, KalturaBaseEntryFilter, KalturaPlayableEntryBaseFilter, KalturaPlayableEntryFilter, KalturaMediaEntryBaseFilter, KalturaMediaEntryFilter, KalturaMediaEntryFilterForPlaylist, KalturaMetadata, KalturaMetadataProfile, KalturaMetadataProfileField, KalturaMixEntry, KalturaModerationFlag, KalturaObjectTask, KalturaOptionalAnswer, KalturaPartnerStatistics, KalturaPartnerUsage, KalturaPermission, KalturaPermissionItem, KalturaPlayReadyAnalogVideoOPIdHolder, KalturaPlayReadyContentKey, KalturaPlayReadyCopyEnablerHolder, KalturaPlayReadyDigitalAudioOPIdHolder, KalturaPlayReadyRight, KalturaPlayReadyPolicy, KalturaPlayReadyLicenseDetails, KalturaPlayReadyPlayEnablerHolder, KalturaPlaybackSource, KalturaPlaybackContext, KalturaPlaylist, KalturaPushEventNotificationParameter, KalturaPushNotificationData, KalturaPushNotificationParams, KalturaQuiz, KalturaRemotePath, KalturaUrlResource, KalturaRemoteStorageResource, KalturaReport, KalturaReportBaseTotal, KalturaReportGraph, KalturaReportInputBaseFilter, KalturaReportResponse, KalturaReportTable, KalturaReportTotal, KalturaRequestConfiguration, KalturaResponseProfile, KalturaResponseProfileCacheRecalculateOptions, KalturaResponseProfileCacheRecalculateResults, KalturaScheduleEventRecurrence, KalturaScheduleEvent, KalturaScheduleEventResource, KalturaScheduleResource, KalturaScheduledTaskProfile, KalturaScope, KalturaSearch, KalturaSearchAuthData, KalturaSearchResult, KalturaSearchResultResponse, KalturaServerNode, KalturaSessionInfo, KalturaShortLink, KalturaSourceFileSyncDescriptor, KalturaStartWidgetSessionResponse, KalturaStatsEvent, KalturaStatsKmcEvent, KalturaStorageProfile, KalturaSyndicationFeedEntryCount, KalturaSystemPartnerUsageItem, KalturaTag, KalturaTranscriptAsset, KalturaUiConf, KalturaUiConfAdmin, KalturaUiConfTypeInfo, KalturaUploadResponse, KalturaUploadToken, KalturaUserEntry, KalturaUserLoginData, KalturaUserRole, KalturaVarPartnerUsageItem, KalturaVirusScanProfile, KalturaWidget, KalturaBatchJobBaseFilter, KalturaBatchJobFilter, KalturaYouTubeApiCaptionDistributionInfo, KalturaAccessControlBlockAction, KalturaAccessControlDrmPolicyAction, KalturaAccessControlLimitDeliveryProfilesAction, KalturaAccessControlLimitFlavorsAction, KalturaAccessControlLimitThumbnailCaptureAction, KalturaAccessControlListResponse, KalturaAccessControlModifyRequestHostRegexAction, KalturaAccessControlPreviewAction, KalturaAccessControlProfileListResponse, KalturaAccessControlServeRemoteEdgeServerAction, KalturaActivitiBusinessProcessServer, KalturaAdCuePoint, KalturaAdminUser, KalturaAmazonS3StorageProfile, KalturaAnnotationListResponse, KalturaAnswerCuePoint, KalturaApiActionPermissionItem, KalturaApiParameterPermissionItem, KalturaAppTokenBaseFilter, KalturaAppTokenListResponse, KalturaAssetDistributionPropertyCondition, KalturaAssetParamsOutput, KalturaAssetPropertiesCompareCondition, KalturaAssetTypeCondition, KalturaAssetsParamsResourceContainers, KalturaAttachmentAssetListResponse, KalturaAttachmentServeOptions, KalturaAttributeCondition, KalturaAuditTrailChangeInfo, KalturaAuditTrailChangeXmlNode, KalturaAuditTrailFileSyncCreateInfo, KalturaAuditTrailListResponse, KalturaAuditTrailTextInfo, KalturaAuthenticatedCondition, KalturaAvnDistributionProvider, KalturaBaseEntryCloneOptionComponent, KalturaBaseEntryListResponse, KalturaBaseSyndicationFeedBaseFilter, KalturaBaseSyndicationFeedListResponse, KalturaBpmEventNotificationIntegrationJobTriggerData, KalturaBulkDownloadJobData, KalturaBulkServiceFilterData, KalturaBulkUploadBaseFilter, KalturaBulkUploadCategoryData, KalturaBulkUploadCategoryEntryData, KalturaBulkUploadCategoryUserData, KalturaBulkUploadEntryData, KalturaBulkUploadJobData, KalturaBulkUploadListResponse, KalturaBulkUploadResultCategory, KalturaBulkUploadResultCategoryEntry, KalturaBulkUploadResultCategoryUser, KalturaBulkUploadResultEntry, KalturaBulkUploadResultScheduleEvent, KalturaBulkUploadResultScheduleResource, KalturaBulkUploadResultUser, KalturaBulkUploadUserData, KalturaBusinessProcessNotificationTemplate, KalturaBusinessProcessServerBaseFilter, KalturaBusinessProcessServerListResponse, KalturaCameraScheduleResource, KalturaCaptionAssetItemListResponse, KalturaCaptionAssetListResponse, KalturaCaptionParamsListResponse, KalturaCaptureThumbJobData, KalturaCategoryEntryAdvancedFilter, KalturaCategoryEntryListResponse, KalturaCategoryIdentifier, KalturaCategoryListResponse, KalturaCategoryUserAdvancedFilter, KalturaCategoryUserListResponse, KalturaCategoryUserProviderFilter, KalturaCielo24JobProviderData, KalturaClipAttributes, KalturaClipConcatJobData, KalturaCodeCuePoint, KalturaComcastMrssDistributionProvider, KalturaCompareCondition, KalturaDataCenterContentResource, KalturaConcatAttributes, KalturaConcatJobData, KalturaConfigurableDistributionJobProviderData, KalturaConfigurableDistributionProfile, KalturaContentDistributionSearchItem, KalturaControlPanelCommandBaseFilter, KalturaControlPanelCommandListResponse, KalturaConvartableJobData, KalturaConversionProfileAssetParamsListResponse, KalturaConversionProfileListResponse, KalturaConvertEntryFlavorsObjectTask, KalturaConvertLiveSegmentJobData, KalturaConvertProfileJobData, KalturaCopyCaptionsJobData, KalturaCopyPartnerJobData, KalturaCountryRestriction, KalturaCrossKalturaDistributionProvider, KalturaCuePointListResponse, KalturaDailymotionDistributionProvider, KalturaDataListResponse, KalturaDeleteEntryFlavorsObjectTask, KalturaDeleteEntryObjectTask, KalturaDeleteFileJobData, KalturaDeleteJobData, KalturaDeleteLocalContentObjectTask, KalturaDeliveryProfileAkamaiAppleHttpManifest, KalturaDeliveryProfileAkamaiHds, KalturaDeliveryProfileAkamaiHttp, KalturaDeliveryProfileBaseFilter, KalturaDeliveryProfileCondition, KalturaDeliveryProfileGenericAppleHttp, KalturaDeliveryProfileGenericHds, KalturaDeliveryProfileGenericHttp, KalturaDeliveryProfileGenericSilverLight, KalturaDeliveryProfileListResponse, KalturaDeliveryProfileLiveAppleHttp, KalturaDeliveryProfileLivePackager, KalturaDeliveryProfileRtmp, KalturaDeliveryProfileVodPackagerPlayServer, KalturaDeliveryServerNode, KalturaDirectoryRestriction, KalturaDispatchEventNotificationObjectTask, KalturaDistributeObjectTask, KalturaDistributionJobData, KalturaDistributionProfileBaseFilter, KalturaDistributionProfileListResponse, KalturaDistributionProviderBaseFilter, KalturaDistributionProviderListResponse, KalturaDistributionValidationErrorConditionNotMet, KalturaDistributionValidationErrorInvalidData, KalturaDistributionValidationErrorMissingAsset, KalturaDistributionValidationErrorMissingFlavor, KalturaDistributionValidationErrorMissingMetadata, KalturaDistributionValidationErrorMissingThumbnail, KalturaDocumentListResponse, KalturaDoubleClickDistributionJobProviderData, KalturaDoubleClickDistributionProvider, KalturaDrmEntryContextPluginData, KalturaDrmPolicyBaseFilter, KalturaDrmPolicyListResponse, KalturaDrmProfileBaseFilter, KalturaDrmProfileListResponse, KalturaDropFolderBaseFilter, KalturaDropFolderContentFileHandlerConfig, KalturaDropFolderContentProcessorJobData, KalturaDropFolderFileBaseFilter, KalturaDropFolderFileListResponse, KalturaDropFolderICalBulkUploadFileHandlerConfig, KalturaDropFolderListResponse, KalturaDropFolderXmlBulkUploadFileHandlerConfig, KalturaESearchCaptionItemData, KalturaESearchCategoryOrderByItem, KalturaESearchCategoryOperator, KalturaESearchCategoryParams, KalturaESearchCategoryResponse, KalturaESearchCuePointItemData, KalturaESearchEntryOrderByItem, KalturaESearchEntryOperator, KalturaESearchEntryParams, KalturaESearchEntryResponse, KalturaESearchMetadataItemData, KalturaESearchMetadataOrderByItem, KalturaESearchUserOrderByItem, KalturaESearchUserOperator, KalturaESearchUserParams, KalturaESearchUserResponse, KalturaCategoryUserBaseFilter, KalturaCategoryUserFilter, KalturaEmailNotificationCategoryRecipientJobData, KalturaEmailNotificationCategoryRecipientProvider, KalturaEmailNotificationGroupRecipientJobData, KalturaEmailNotificationGroupRecipientProvider, KalturaEmailNotificationParameter, KalturaEmailNotificationStaticRecipientJobData, KalturaEmailNotificationStaticRecipientProvider, KalturaEmailNotificationTemplate, KalturaUserBaseFilter, KalturaUserFilter, KalturaEmailNotificationUserRecipientJobData, KalturaEmailNotificationUserRecipientProvider, KalturaEntryCaptionAssetSearchItem, KalturaEntryContext, KalturaEntryContextDataParams, KalturaEntryContextDataResult, KalturaEntryCuePointSearchFilter, KalturaEntryDistributionListResponse, KalturaEntryIdentifier, KalturaEntryLiveStats, KalturaEntryScheduleEvent, KalturaEntryServerNodeBaseFilter, KalturaEntryServerNodeListResponse, KalturaEntryTranscriptAssetSearchItem, KalturaEventCuePoint, KalturaBooleanField, KalturaEventFieldCondition, KalturaEventNotificationArrayParameter, KalturaEventNotificationDispatchJobData, KalturaEventNotificationScope, KalturaEventNotificationTemplateBaseFilter, KalturaEventNotificationTemplateListResponse, KalturaEventObjectChangedCondition, KalturaExecuteMetadataXsltObjectTask, KalturaExternalMediaEntryListResponse, KalturaFacebookDistributionProvider, KalturaFairplayDrmProfile, KalturaFairplayEntryContextPluginData, KalturaFeatureStatusListResponse, KalturaFeedDropFolder, KalturaFeedDropFolderFile, KalturaFileAssetListResponse, KalturaFileSyncBaseFilter, KalturaFlattenJobData, KalturaFlavorAssetListResponse, KalturaFlavorParamsListResponse, KalturaFreewheelDistributionJobProviderData, KalturaFreewheelDistributionProfile, KalturaFreewheelDistributionProvider, KalturaFreewheelGenericDistributionProvider, KalturaFtpDistributionProvider, KalturaGenericDistributionJobProviderData, KalturaGenericDistributionProfile, KalturaGenericDistributionProviderActionBaseFilter, KalturaGenericDistributionProviderActionListResponse, KalturaGenericDistributionProviderListResponse, KalturaGenericSyndicationFeed, KalturaGoogleVideoSyndicationFeed, KalturaGroupUserListResponse, KalturaHashCondition, KalturaHttpNotificationDataFields, KalturaHttpNotificationDataText, KalturaHttpNotificationObjectData, KalturaHttpNotificationTemplate, KalturaHuluDistributionProvider, KalturaITunesSyndicationFeed, KalturaIdeticDistributionProvider, KalturaImportJobData, KalturaImportMetadataJobData, KalturaIndexAdvancedFilter, KalturaIndexJobData, KalturaIndexTagsByPrivacyContextJobData, KalturaIntegrationJobData, KalturaIpAddressRestriction, KalturaKontikiStorageProfile, KalturaLikeListResponse, KalturaLimitFlavorsRestriction, KalturaLiveChannelListResponse, KalturaLiveChannelSegmentListResponse, KalturaLiveEntryScheduleResource, KalturaLiveEntryServerNode, KalturaLiveReportExportJobData, KalturaLiveStatsListResponse, KalturaLiveStreamListResponse, KalturaLiveStreamPushPublishRTMPConfiguration, KalturaLiveToVodJobData, KalturaLocationScheduleResource, KalturaMailJobData, KalturaMailNotificationObjectTask, KalturaMatchCondition, KalturaMediaInfoBaseFilter, KalturaMediaListResponse, KalturaMetadataListResponse, KalturaMetadataProfileBaseFilter, KalturaMetadataProfileFieldListResponse, KalturaMetadataProfileListResponse, KalturaMetadataReplacementOptionsItem, KalturaMetadataResponseProfileMapping, KalturaMetroPcsDistributionProvider, KalturaMixListResponse, KalturaModerationFlagListResponse, KalturaModifyCategoriesObjectTask, KalturaModifyEntryObjectTask, KalturaMoveCategoryEntriesJobData, KalturaMsnDistributionProvider, KalturaNotificationJobData, KalturaObjectListResponse, KalturaOrCondition, KalturaParseCaptionAssetJobData, KalturaParseMultiLanguageCaptionAssetJobData, KalturaPartnerBaseFilter, KalturaPartnerListResponse, KalturaPartnerUsageListResponse, KalturaPermissionItemListResponse, KalturaPermissionListResponse, KalturaPlayReadyCopyRight, KalturaPlayReadyPlayRight, KalturaPlayReadyProfile, KalturaPlaylistListResponse, KalturaProvisionJobData, KalturaPushNotificationTemplate, KalturaQuestionCuePoint, KalturaQuickPlayDistributionProvider, KalturaQuizAdvancedFilter, KalturaQuizListResponse, KalturaQuizUserEntry, KalturaRecalculateCacheJobData, KalturaRemoteDropFolder, KalturaRemotePathListResponse, KalturaReportBaseFilter, KalturaReportInputFilter, KalturaReportListResponse, KalturaResponseProfileBaseFilter, KalturaResponseProfileHolder, KalturaResponseProfileListResponse, KalturaScheduleEventListResponse, KalturaScheduleEventResourceListResponse, KalturaScheduleResourceListResponse, KalturaScheduledTaskJobData, KalturaScheduledTaskProfileBaseFilter, KalturaScheduledTaskProfileListResponse, KalturaSchedulerListResponse, KalturaSchedulerWorkerListResponse, KalturaSearchCondition, KalturaSearchOperator, KalturaServerNodeBaseFilter, KalturaServerNodeListResponse, KalturaSessionResponse, KalturaSessionRestriction, KalturaShortLinkBaseFilter, KalturaShortLinkListResponse, KalturaSiteRestriction, KalturaStorageAddAction, KalturaStorageExportObjectTask, KalturaStorageJobData, KalturaStorageProfileBaseFilter, KalturaStorageProfileListResponse, KalturaSyncCategoryPrivacyContextJobData, KalturaSyndicationDistributionProfile, KalturaSyndicationDistributionProvider, KalturaSystemPartnerUsageFilter, KalturaSystemPartnerUsageListResponse, KalturaTagFilter, KalturaTagListResponse, KalturaTaskEntryServerNode, KalturaThumbAssetListResponse, KalturaThumbCuePoint, KalturaThumbParamsListResponse, KalturaThumbnailServeOptions, KalturaTrackEntryListResponse, KalturaTranscriptAssetListResponse, KalturaTransformMetadataJobData, KalturaTubeMogulSyndicationFeed, KalturaUiConfAdminListResponse, KalturaUiConfBaseFilter, KalturaUiConfListResponse, KalturaUnicornDistributionProvider, KalturaUploadTokenBaseFilter, KalturaUploadTokenListResponse, KalturaUrlRecognizerAkamaiG2O, KalturaUrlTokenizerAkamaiHttp, KalturaUrlTokenizerAkamaiRtmp, KalturaUrlTokenizerAkamaiRtsp, KalturaUrlTokenizerAkamaiSecureHd, KalturaUrlTokenizerBitGravity, KalturaUrlTokenizerChinaCache, KalturaUrlTokenizerCht, KalturaUrlTokenizerCloudFront, KalturaUrlTokenizerKs, KalturaUrlTokenizerLevel3, KalturaUrlTokenizerLimeLight, KalturaUrlTokenizerVelocix, KalturaUrlTokenizerVnpt, KalturaUrlTokenizerWowzaSecureToken, KalturaUserAgentRestriction, KalturaUserEntryListResponse, KalturaUserListResponse, KalturaUserLoginDataListResponse, KalturaUserRoleCondition, KalturaUserRoleListResponse, KalturaUsersCsvJobData, KalturaValidateActiveEdgeCondition, KalturaVarPartnerUsageTotalItem, KalturaViewHistoryUserEntry, KalturaViewHistoryUserEntryAdvancedFilter, KalturaVirusScanJobData, KalturaVirusScanProfileBaseFilter, KalturaVirusScanProfileListResponse, KalturaVoicebaseJobProviderData, KalturaWebexDropFolder, KalturaWebexDropFolderFile, KalturaWidevineProfile, KalturaWidevineRepositorySyncJobData, KalturaWidgetBaseFilter, KalturaWidgetListResponse, KalturaYahooDistributionProvider, KalturaYahooSyndicationFeed, KalturaYouTubeDistributionProvider, KalturaYoutubeApiDistributionProvider, KalturaAccessControlBaseFilter, KalturaAccessControlProfileBaseFilter, KalturaAkamaiProvisionJobData, KalturaAkamaiUniversalProvisionJobData, KalturaAnonymousIPCondition, KalturaAppTokenFilter, KalturaAssetParamsBaseFilter, KalturaAssetResource, KalturaAuditTrailBaseFilter, KalturaAvnDistributionProfile, KalturaBaseSyndicationFeedFilter, KalturaBulkUploadCsvJobData, KalturaBulkUploadFilter, KalturaBulkUploadFilterJobData, KalturaBulkUploadICalJobData, KalturaBulkUploadXmlJobData, KalturaBusinessProcessAbortNotificationTemplate, KalturaBusinessProcessNotificationDispatchJobData, KalturaBusinessProcessServerFilter, KalturaBusinessProcessSignalNotificationTemplate, KalturaBusinessProcessStartNotificationTemplate, KalturaCategoryBaseFilter, KalturaCategoryEntryBaseFilter, KalturaClippingTaskEntryServerNode, KalturaComcastMrssDistributionProfile, KalturaCompareMetadataCondition, KalturaControlPanelCommandFilter, KalturaConversionProfileAssetParamsBaseFilter, KalturaConversionProfileBaseFilter, KalturaConvertCollectionJobData, KalturaConvertJobData, KalturaCountryCondition, KalturaCrossKalturaDistributionJobProviderData, KalturaCrossKalturaDistributionProfile, KalturaCuePointBaseFilter, KalturaDailymotionDistributionJobProviderData, KalturaDailymotionDistributionProfile, KalturaDeliveryProfileFilter, KalturaDeliveryProfileGenericRtmp, KalturaDeliveryProfileLivePackagerHls, KalturaDeliveryProfileVodPackagerHls, KalturaDistributionDeleteJobData, KalturaDistributionFetchReportJobData, KalturaDistributionProfileFilter, KalturaDistributionProviderFilter, KalturaDistributionSubmitJobData, KalturaDistributionUpdateJobData, KalturaDistributionValidationErrorInvalidMetadata, KalturaDocumentFlavorParams, KalturaDoubleClickDistributionProfile, KalturaDrmPolicyFilter, KalturaDrmProfileFilter, KalturaDropFolderFileFilter, KalturaDropFolderFilter, KalturaDynamicObjectSearchItem, KalturaESearchAbstractCategoryItem, KalturaESearchAbstractEntryItem, KalturaESearchAbstractUserItem, KalturaEdgeServerNode, KalturaEmailNotificationDispatchJobData, KalturaEndUserReportInputFilter, KalturaEntryDistributionBaseFilter, KalturaEntryIndexAdvancedFilter, KalturaEntryReferrerLiveStats, KalturaEntryResource, KalturaEntryServerNodeFilter, KalturaEventNotificationTemplateFilter, KalturaExtractMediaJobData, KalturaFacebookDistributionJobProviderData, KalturaFacebookDistributionProfile, KalturaFairPlayPlaybackPluginData, KalturaIntegerField, KalturaFieldCompareCondition, KalturaStringField, KalturaFieldMatchCondition, KalturaFileAssetBaseFilter, KalturaFileSyncFilter, KalturaFileSyncResource, KalturaFreewheelGenericDistributionJobProviderData, KalturaFreewheelGenericDistributionProfile, KalturaFtpDistributionJobProviderData, KalturaFtpDistributionProfile, KalturaFtpDropFolder, KalturaFtpScheduledDistributionProvider, KalturaGenericDistributionProviderActionFilter, KalturaGenericXsltSyndicationFeed, KalturaGeoDistanceCondition, KalturaGeoTimeLiveStats, KalturaGroupUserBaseFilter, KalturaHttpNotificationDispatchJobData, KalturaHuluDistributionJobProviderData, KalturaHuluDistributionProfile, KalturaIdeticDistributionJobProviderData, KalturaIdeticDistributionProfile, KalturaImageFlavorParams, KalturaIpAddressCondition, KalturaLikeBaseFilter, KalturaLiveAsset, KalturaLiveChannelSegmentBaseFilter, KalturaLiveParams, KalturaLiveStreamScheduleEvent, KalturaMatchMetadataCondition, KalturaMediaFlavorParams, KalturaMediaInfoFilter, KalturaMediaServerNode, KalturaMetadataBaseFilter, KalturaMetadataFieldChangedCondition, KalturaMetadataProfileFilter, KalturaMetadataSearchItem, KalturaMetroPcsDistributionJobProviderData, KalturaMetroPcsDistributionProfile, KalturaMsnDistributionJobProviderData, KalturaMsnDistributionProfile, KalturaOperationResource, KalturaPartnerFilter, KalturaPdfFlavorParams, KalturaPermissionBaseFilter, KalturaPermissionItemBaseFilter, KalturaPlaybackContextOptions, KalturaPostConvertJobData, KalturaPreviewRestriction, KalturaQuickPlayDistributionJobProviderData, KalturaQuickPlayDistributionProfile, KalturaQuizFilter, KalturaRecalculateResponseProfileCacheJobData, KalturaRecordScheduleEvent, KalturaRegexCondition, KalturaRemoteStorageResources, KalturaResponseProfileFilter, KalturaScheduleEventBaseFilter, KalturaScheduleEventResourceBaseFilter, KalturaScheduleResourceBaseFilter, KalturaScheduledTaskProfileFilter, KalturaSearchComparableAttributeCondition, KalturaSearchComparableCondition, KalturaSearchMatchAttributeCondition, KalturaSearchMatchCondition, KalturaServerNodeFilter, KalturaShortLinkFilter, KalturaSiteCondition, KalturaSshDropFolder, KalturaSshImportJobData, KalturaStorageDeleteJobData, KalturaStorageExportJobData, KalturaStorageProfileFilter, KalturaStringResource, KalturaSwfFlavorParams, KalturaTimedThumbAsset, KalturaUiConfFilter, KalturaUnicornDistributionJobProviderData, KalturaUnicornDistributionProfile, KalturaUploadTokenFilter, KalturaUserEntryBaseFilter, KalturaUserLoginDataBaseFilter, KalturaUserRoleBaseFilter, KalturaVelocixProvisionJobData, KalturaVirusScanProfileFilter, KalturaWebexDropFolderContentProcessorJobData, KalturaWidevineFlavorAsset, KalturaWidevineFlavorParams, KalturaWidgetFilter, KalturaYahooDistributionJobProviderData, KalturaYahooDistributionProfile, KalturaYouTubeDistributionJobProviderData, KalturaYouTubeDistributionProfile, KalturaYoutubeApiDistributionJobProviderData, KalturaYoutubeApiDistributionProfile, KalturaAccessControlFilter, KalturaAccessControlProfileFilter, KalturaActivitiBusinessProcessServerBaseFilter, KalturaAmazonS3StorageExportJobData, KalturaAmazonS3StorageProfileBaseFilter, KalturaAnonymousIPContextField, KalturaAssetParamsFilter, KalturaAuditTrailFilter, KalturaAvnDistributionProviderBaseFilter, KalturaBaseEntryCompareAttributeCondition, KalturaBaseEntryMatchAttributeCondition, KalturaBatchJobFilterExt, KalturaBusinessProcessNotificationTemplateBaseFilter, KalturaCategoryEntryFilter, KalturaCategoryFilter, KalturaComcastMrssDistributionProviderBaseFilter, KalturaConfigurableDistributionProfileBaseFilter, KalturaConstantXsltSyndicationFeed, KalturaConversionProfileFilter, KalturaConversionProfileAssetParamsFilter, KalturaCoordinatesContextField, KalturaCountryContextField, KalturaCrossKalturaDistributionProviderBaseFilter, KalturaCuePointFilter, KalturaDailymotionDistributionProviderBaseFilter, KalturaDataEntryCompareAttributeCondition, KalturaDataEntryMatchAttributeCondition, KalturaDeliveryProfileAkamaiAppleHttpManifestBaseFilter, KalturaDeliveryProfileAkamaiHdsBaseFilter, KalturaDeliveryProfileAkamaiHttpBaseFilter, KalturaDeliveryProfileGenericAppleHttpBaseFilter, KalturaDeliveryProfileGenericHdsBaseFilter, KalturaDeliveryProfileGenericHttpBaseFilter, KalturaDeliveryProfileGenericSilverLightBaseFilter, KalturaDeliveryProfileLiveAppleHttpBaseFilter, KalturaDeliveryProfileRtmpBaseFilter, KalturaDeliveryServerNodeBaseFilter, KalturaDistributionDisableJobData, KalturaDistributionEnableJobData, KalturaDocumentEntryCompareAttributeCondition, KalturaDocumentEntryMatchAttributeCondition, KalturaDocumentFlavorParamsOutput, KalturaDoubleClickDistributionProviderBaseFilter, KalturaDropFolderImportJobData, KalturaDropFolderXmlBulkUploadJobData, KalturaESearchCategoryEntryItem, KalturaESearchCategoryItem, KalturaESearchCategoryMetadataItem, KalturaESearchCategoryUserItem, KalturaESearchEntryItem, KalturaESearchUnifiedItem, KalturaESearchUserItem, KalturaESearchUserMetadataItem, KalturaEmailNotificationTemplateBaseFilter, KalturaEntryDistributionFilter, KalturaEvalBooleanField, KalturaEvalStringField, KalturaExternalMediaEntryCompareAttributeCondition, KalturaExternalMediaEntryMatchAttributeCondition, KalturaFacebookDistributionProviderBaseFilter, KalturaFileAssetFilter, KalturaFreewheelDistributionProfileBaseFilter, KalturaFreewheelDistributionProviderBaseFilter, KalturaFreewheelGenericDistributionProviderBaseFilter, KalturaFtpDistributionProviderBaseFilter, KalturaGenericDataCenterContentResource, KalturaGenericDistributionProfileBaseFilter, KalturaGenericDistributionProviderBaseFilter, KalturaGenericSyndicationFeedBaseFilter, KalturaGoogleVideoSyndicationFeedBaseFilter, KalturaGroupUserFilter, KalturaHttpNotificationTemplateBaseFilter, KalturaHuluDistributionProviderBaseFilter, KalturaITunesSyndicationFeedBaseFilter, KalturaIdeticDistributionProviderBaseFilter, KalturaImageFlavorParamsOutput, KalturaIpAddressContextField, KalturaKontikiStorageDeleteJobData, KalturaKontikiStorageExportJobData, KalturaKontikiStorageProfileBaseFilter, KalturaLikeFilter, KalturaLiveChannelCompareAttributeCondition, KalturaLiveChannelMatchAttributeCondition, KalturaLiveChannelSegmentFilter, KalturaLiveEntryCompareAttributeCondition, KalturaLiveEntryMatchAttributeCondition, KalturaLiveEntryServerNodeBaseFilter, KalturaLiveStreamAdminEntryCompareAttributeCondition, KalturaLiveStreamAdminEntryMatchAttributeCondition, KalturaLiveStreamEntryCompareAttributeCondition, KalturaLiveStreamEntryMatchAttributeCondition, KalturaMediaEntryCompareAttributeCondition, KalturaMediaEntryMatchAttributeCondition, KalturaMediaFlavorParamsOutput, KalturaMetadataField, KalturaMetadataFilter, KalturaMetroPcsDistributionProviderBaseFilter, KalturaMixEntryCompareAttributeCondition, KalturaMixEntryMatchAttributeCondition, KalturaMsnDistributionProviderBaseFilter, KalturaObjectIdField, KalturaPdfFlavorParamsOutput, KalturaPermissionFilter, KalturaPermissionItemFilter, KalturaPlayReadyPolicyBaseFilter, KalturaPlayReadyProfileBaseFilter, KalturaPlayableEntryCompareAttributeCondition, KalturaPlayableEntryMatchAttributeCondition, KalturaPlaylistCompareAttributeCondition, KalturaPlaylistMatchAttributeCondition, KalturaPushNotificationTemplateBaseFilter, KalturaQuickPlayDistributionProviderBaseFilter, KalturaRemoteDropFolderBaseFilter, KalturaScheduleEventFilter, KalturaScheduleEventResourceFilter, KalturaScheduleResourceFilter, KalturaScpDropFolder, KalturaSftpDropFolder, KalturaSshUrlResource, KalturaSwfFlavorParamsOutput, KalturaSyndicationDistributionProfileBaseFilter, KalturaSyndicationDistributionProviderBaseFilter, KalturaSystemPartnerFilter, KalturaTimeContextField, KalturaTubeMogulSyndicationFeedBaseFilter, KalturaUiConfAdminBaseFilter, KalturaUnicornDistributionProviderBaseFilter, KalturaUserAgentCondition, KalturaUserAgentContextField, KalturaUserEmailContextField, KalturaUserEntryFilter, KalturaUserLoginDataFilter, KalturaUserRoleFilter, KalturaWebcamTokenResource, KalturaWebexDropFolderBaseFilter, KalturaWebexDropFolderFileBaseFilter, KalturaWidevineFlavorParamsOutput, KalturaWidevineProfileBaseFilter, KalturaWowzaMediaServerNode, KalturaYahooDistributionProviderBaseFilter, KalturaYahooSyndicationFeedBaseFilter, KalturaYouTubeDistributionProviderBaseFilter, KalturaYoutubeApiDistributionProviderBaseFilter, KalturaActivitiBusinessProcessServerFilter, KalturaAdCuePointBaseFilter, KalturaAdminUserBaseFilter, KalturaAmazonS3StorageProfileFilter, KalturaAnnotationBaseFilter, KalturaAnswerCuePointBaseFilter, KalturaApiActionPermissionItemBaseFilter, KalturaApiParameterPermissionItemBaseFilter, KalturaAssetParamsOutputBaseFilter, KalturaAttachmentAssetBaseFilter, KalturaAvnDistributionProviderFilter, KalturaBusinessProcessNotificationTemplateFilter, KalturaCameraScheduleResourceBaseFilter, KalturaCaptionAssetBaseFilter, KalturaCaptionParamsBaseFilter, KalturaCodeCuePointBaseFilter, KalturaComcastMrssDistributionProviderFilter, KalturaConfigurableDistributionProfileFilter, KalturaCrossKalturaDistributionProviderFilter, KalturaDailymotionDistributionProviderFilter, KalturaDataEntryBaseFilter, KalturaDeliveryProfileAkamaiAppleHttpManifestFilter, KalturaDeliveryProfileAkamaiHdsFilter, KalturaDeliveryProfileAkamaiHttpFilter, KalturaDeliveryProfileGenericAppleHttpFilter, KalturaDeliveryProfileGenericHdsFilter, KalturaDeliveryProfileGenericHttpFilter, KalturaDeliveryProfileGenericSilverLightFilter, KalturaDeliveryProfileLiveAppleHttpFilter, KalturaDeliveryProfileRtmpFilter, KalturaDeliveryServerNodeFilter, KalturaDocumentEntryBaseFilter, KalturaDoubleClickDistributionProviderFilter, KalturaDropFolderFileResource, KalturaESearchEntryAbstractNestedItem, KalturaESearchNestedOperator, KalturaEmailNotificationTemplateFilter, KalturaEntryScheduleEventBaseFilter, KalturaEventCuePointBaseFilter, KalturaFacebookDistributionProviderFilter, KalturaFlavorAssetBaseFilter, KalturaFlavorParamsBaseFilter, KalturaFreewheelDistributionProfileFilter, KalturaFreewheelDistributionProviderFilter, KalturaFreewheelGenericDistributionProviderFilter, KalturaFtpDistributionProviderFilter, KalturaGenericDistributionProfileFilter, KalturaGenericDistributionProviderFilter, KalturaGenericSyndicationFeedFilter, KalturaGoogleVideoSyndicationFeedFilter, KalturaHttpNotificationTemplateFilter, KalturaHuluDistributionProviderFilter, KalturaITunesSyndicationFeedFilter, KalturaIdeticDistributionProviderFilter, KalturaKontikiStorageProfileFilter, KalturaLiveEntryScheduleResourceBaseFilter, KalturaLiveEntryServerNodeFilter, KalturaLocationScheduleResourceBaseFilter, KalturaMetroPcsDistributionProviderFilter, KalturaMsnDistributionProviderFilter, KalturaOperaSyndicationFeed, KalturaPlayReadyPolicyFilter, KalturaPlayReadyProfileFilter, KalturaPlaylistBaseFilter, KalturaPushNotificationTemplateFilter, KalturaQuestionCuePointBaseFilter, KalturaQuickPlayDistributionProviderFilter, KalturaQuizUserEntryBaseFilter, KalturaRemoteDropFolderFilter, KalturaRokuSyndicationFeed, KalturaServerFileResource, KalturaSyndicationDistributionProfileFilter, KalturaThumbAssetBaseFilter, KalturaThumbCuePointBaseFilter, KalturaThumbParamsBaseFilter, KalturaTubeMogulSyndicationFeedFilter, KalturaUiConfAdminFilter, KalturaUnicornDistributionProviderFilter, KalturaUploadedFileTokenResource, KalturaViewHistoryUserEntryFilter, KalturaWebexDropFolderFileFilter, KalturaWebexDropFolderFilter, KalturaWidevineProfileFilter, KalturaYahooDistributionProviderFilter, KalturaYahooSyndicationFeedFilter, KalturaYouTubeDistributionProviderFilter, KalturaYoutubeApiDistributionProviderFilter, KalturaAdCuePointFilter, KalturaAdminUserFilter, KalturaAnnotationFilter, KalturaAnswerCuePointFilter, KalturaApiActionPermissionItemFilter, KalturaApiParameterPermissionItemFilter, KalturaAssetParamsOutputFilter, KalturaAttachmentAssetFilter, KalturaAvnDistributionProfileBaseFilter, KalturaBusinessProcessAbortNotificationTemplateBaseFilter, KalturaBusinessProcessSignalNotificationTemplateBaseFilter, KalturaBusinessProcessStartNotificationTemplateBaseFilter, KalturaCameraScheduleResourceFilter, KalturaCaptionAssetFilter, KalturaCaptionParamsFilter, KalturaCodeCuePointFilter, KalturaComcastMrssDistributionProfileBaseFilter, KalturaCrossKalturaDistributionProfileBaseFilter, KalturaDailymotionDistributionProfileBaseFilter, KalturaDataEntryFilter, KalturaDeliveryProfileGenericRtmpBaseFilter, KalturaDocumentEntryFilter, KalturaDoubleClickDistributionProfileBaseFilter, KalturaESearchCaptionItem, KalturaESearchCuePointItem, KalturaESearchEntryMetadataItem, KalturaEdgeServerNodeBaseFilter, KalturaEntryScheduleEventFilter, KalturaEventCuePointFilter, KalturaFacebookDistributionProfileBaseFilter, KalturaFlavorAssetFilter, KalturaFlavorParamsFilter, KalturaFreewheelGenericDistributionProfileBaseFilter, KalturaFtpDistributionProfileBaseFilter, KalturaFtpDropFolderBaseFilter, KalturaFtpScheduledDistributionProviderBaseFilter, KalturaGenericXsltSyndicationFeedBaseFilter, KalturaHuluDistributionProfileBaseFilter, KalturaIdeticDistributionProfileBaseFilter, KalturaLiveEntryScheduleResourceFilter, KalturaLiveStreamAdminEntry, KalturaLocationScheduleResourceFilter, KalturaMediaServerNodeBaseFilter, KalturaMetroPcsDistributionProfileBaseFilter, KalturaMsnDistributionProfileBaseFilter, KalturaPlaylistFilter, KalturaQuestionCuePointFilter, KalturaQuickPlayDistributionProfileBaseFilter, KalturaQuizUserEntryFilter, KalturaSshDropFolderBaseFilter, KalturaThumbAssetFilter, KalturaThumbCuePointFilter, KalturaThumbParamsFilter, KalturaUnicornDistributionProfileBaseFilter, KalturaYahooDistributionProfileBaseFilter, KalturaYouTubeDistributionProfileBaseFilter, KalturaYoutubeApiDistributionProfileBaseFilter, KalturaAvnDistributionProfileFilter, KalturaBusinessProcessAbortNotificationTemplateFilter, KalturaBusinessProcessSignalNotificationTemplateFilter, KalturaBusinessProcessStartNotificationTemplateFilter, KalturaCaptionAssetItemFilter, KalturaComcastMrssDistributionProfileFilter, KalturaCrossKalturaDistributionProfileFilter, KalturaDailymotionDistributionProfileFilter, KalturaDeliveryProfileGenericRtmpFilter, KalturaDocumentFlavorParamsBaseFilter, KalturaDoubleClickDistributionProfileFilter, KalturaEdgeServerNodeFilter, KalturaFacebookDistributionProfileFilter, KalturaFlavorParamsOutputBaseFilter, KalturaFreewheelGenericDistributionProfileFilter, KalturaFtpDistributionProfileFilter, KalturaFtpDropFolderFilter, KalturaFtpScheduledDistributionProviderFilter, KalturaGenericXsltSyndicationFeedFilter, KalturaHuluDistributionProfileFilter, KalturaIdeticDistributionProfileFilter, KalturaImageFlavorParamsBaseFilter, KalturaLiveAssetBaseFilter, KalturaLiveParamsBaseFilter, KalturaLiveStreamScheduleEventBaseFilter, KalturaMediaFlavorParamsBaseFilter, KalturaMediaServerNodeFilter, KalturaMetroPcsDistributionProfileFilter, KalturaMixEntryBaseFilter, KalturaMsnDistributionProfileFilter, KalturaPdfFlavorParamsBaseFilter, KalturaQuickPlayDistributionProfileFilter, KalturaRecordScheduleEventBaseFilter, KalturaSshDropFolderFilter, KalturaSwfFlavorParamsBaseFilter, KalturaThumbParamsOutputBaseFilter, KalturaTimedThumbAssetBaseFilter, KalturaTranscriptAssetBaseFilter, KalturaUnicornDistributionProfileFilter, KalturaWidevineFlavorAssetBaseFilter, KalturaWidevineFlavorParamsBaseFilter, KalturaYahooDistributionProfileFilter, KalturaYouTubeDistributionProfileFilter, KalturaYoutubeApiDistributionProfileFilter, KalturaDocumentFlavorParamsFilter, KalturaFlavorParamsOutputFilter, KalturaImageFlavorParamsFilter, KalturaLiveAssetFilter, KalturaLiveParamsFilter, KalturaLiveStreamScheduleEventFilter, KalturaMediaFlavorParamsFilter, KalturaMixEntryFilter, KalturaPdfFlavorParamsFilter, KalturaRecordScheduleEventFilter, KalturaScpDropFolderBaseFilter, KalturaSftpDropFolderBaseFilter, KalturaSwfFlavorParamsFilter, KalturaThumbParamsOutputFilter, KalturaTimedThumbAssetFilter, KalturaTranscriptAssetFilter, KalturaWidevineFlavorAssetFilter, KalturaWidevineFlavorParamsFilter, KalturaWowzaMediaServerNodeBaseFilter, KalturaDocumentFlavorParamsOutputBaseFilter, KalturaExternalMediaEntryBaseFilter, KalturaImageFlavorParamsOutputBaseFilter, KalturaLiveEntryBaseFilter, KalturaMediaFlavorParamsOutputBaseFilter, KalturaPdfFlavorParamsOutputBaseFilter, KalturaScpDropFolderFilter, KalturaSftpDropFolderFilter, KalturaSwfFlavorParamsOutputBaseFilter, KalturaWidevineFlavorParamsOutputBaseFilter, KalturaWowzaMediaServerNodeFilter, KalturaDocumentFlavorParamsOutputFilter, KalturaExternalMediaEntryFilter, KalturaImageFlavorParamsOutputFilter, KalturaLiveEntryFilter, KalturaMediaFlavorParamsOutputFilter, KalturaPdfFlavorParamsOutputFilter, KalturaSwfFlavorParamsOutputFilter, KalturaWidevineFlavorParamsOutputFilter, KalturaLiveChannelBaseFilter, KalturaLiveStreamEntryBaseFilter, KalturaLiveChannelFilter, KalturaLiveStreamEntryFilter, KalturaLiveStreamAdminEntryBaseFilter, KalturaLiveStreamAdminEntryFilter, KalturaAppTokenStatus, KalturaAppearInListType, KalturaAssetParamsDeletePolicy, KalturaAssetParamsOrigin, KalturaAttachmentAssetStatus, KalturaAuditTrailChangeXmlNodeType, KalturaAuditTrailContext, KalturaAuditTrailFileSyncType, KalturaAuditTrailStatus, KalturaBatchJobErrorTypes, KalturaBatchJobStatus, KalturaBitRateMode, KalturaBulkUploadCsvVersion, KalturaCaptionAssetStatus, KalturaCategoryEntryStatus, KalturaCategoryStatus, KalturaCategoryUserPermissionLevel, KalturaCategoryUserStatus, KalturaChinaCacheAlgorithmType, KalturaCommercialUseType, KalturaContributionPolicyType, KalturaControlPanelCommandStatus, KalturaControlPanelCommandTargetType, KalturaControlPanelCommandType, KalturaCountryRestrictionType, KalturaCuePointStatus, KalturaDVRStatus, KalturaDailymotionDistributionCaptionAction, KalturaDailymotionDistributionCaptionFormat, KalturaDailymotionGeoBlockingMapping, KalturaDeleteFlavorsLogicType, KalturaDeliveryStatus, KalturaDirectoryRestrictionType, KalturaDistributionAction, KalturaDistributionErrorType, KalturaDistributionFieldRequiredStatus, KalturaDistributionProfileActionStatus, KalturaDistributionProfileStatus, KalturaDistributionProtocol, KalturaDistributionValidationErrorType, KalturaDocumentType, KalturaDrmLicenseExpirationPolicy, KalturaDrmPolicyStatus, KalturaDrmProfileStatus, KalturaDropFolderContentFileHandlerMatchPolicy, KalturaDropFolderFileDeletePolicy, KalturaDropFolderFileStatus, KalturaDropFolderStatus, KalturaDryRunFileType, KalturaESearchItemType, KalturaESearchOperatorType, KalturaEditorType, KalturaEffectType, KalturaEmailIngestionProfileStatus, KalturaEmailNotificationTemplatePriority, KalturaEntryDisplayInSearchType, KalturaEntryDistributionFlag, KalturaEntryDistributionStatus, KalturaEntryDistributionSunStatus, KalturaEntryModerationStatus, KalturaEntryServerNodeRecordingStatus, KalturaEntryServerNodeStatus, KalturaEventNotificationTemplateStatus, KalturaFeatureStatusType, KalturaFileSyncStatus, KalturaFileSyncType, KalturaFlavorAssetStatus, KalturaFlavorReadyBehaviorType, KalturaGender, KalturaGenericDistributionProviderParser, KalturaGenericDistributionProviderStatus, KalturaGroupUserCreationMode, KalturaGroupUserStatus, KalturaHttpNotificationAuthenticationMethod, KalturaHttpNotificationMethod, KalturaHttpNotificationSslVersion, KalturaInheritanceType, KalturaIpAddressRestrictionType, KalturaLicenseType, KalturaLimitFlavorsRestrictionType, KalturaLivePublishStatus, KalturaLiveReportExportType, KalturaLiveStatsEventType, KalturaMailJobStatus, KalturaMediaType, KalturaMetadataProfileCreateMode, KalturaMetadataProfileStatus, KalturaMetadataStatus, KalturaModerationFlagType, KalturaMrssExtensionMode, KalturaNotificationObjectType, KalturaNotificationStatus, KalturaNotificationType, KalturaNullableBoolean, KalturaPartnerGroupType, KalturaPartnerStatus, KalturaPartnerType, KalturaPermissionStatus, KalturaPermissionType, KalturaPlayReadyAnalogVideoOPL, KalturaPlayReadyCompressedDigitalVideoOPL, KalturaPlayReadyDigitalAudioOPL, KalturaPlayReadyLicenseRemovalPolicy, KalturaPlayReadyMinimumLicenseSecurityLevel, KalturaPlayReadyUncompressedDigitalVideoOPL, KalturaPlaylistType, KalturaPrivacyType, KalturaQuestionType, KalturaQuizOutputType, KalturaRecordStatus, KalturaRecordingStatus, KalturaResponseProfileStatus, KalturaResponseProfileType, KalturaResponseType, KalturaScheduleEventClassificationType, KalturaScheduleEventRecurrenceType, KalturaScheduleEventStatus, KalturaScheduleEventType, KalturaScheduleResourceStatus, KalturaScheduledTaskAddOrRemoveType, KalturaScheduledTaskProfileStatus, KalturaSchedulerStatusType, KalturaSearchOperatorType, KalturaSearchProviderType, KalturaServerNodeStatus, KalturaSessionType, KalturaShortLinkStatus, KalturaSiteRestrictionType, KalturaStatsEventType, KalturaStatsFeatureType, KalturaStatsKmcEventType, KalturaStorageProfileDeliveryStatus, KalturaStorageProfileReadyBehavior, KalturaStorageProfileStatus, KalturaSyndicationFeedStatus, KalturaSyndicationFeedType, KalturaThumbAssetStatus, KalturaThumbCropType, KalturaThumbCuePointSubType, KalturaTrackEntryEventType, KalturaUiConfCreationMode, KalturaUiConfObjType, KalturaUpdateMethodType, KalturaUploadErrorCode, KalturaUploadTokenStatus, KalturaUserAgentRestrictionType, KalturaUserJoinPolicyType, KalturaUserMode, KalturaUserRoleStatus, KalturaUserStatus, KalturaUserType, KalturaViewMode, KalturaVirusFoundAction, KalturaVirusScanJobResult, KalturaVirusScanProfileStatus, KalturaWidevineRepositorySyncMode, KalturaWidgetSecurityType, KalturaYahooDistributionProcessFeedActionStatus, KalturaYouTubeApiDistributionCaptionAction, KalturaAccessControlOrderBy, KalturaAccessControlProfileOrderBy, KalturaActivitiBusinessProcessServerOrderBy, KalturaActivitiBusinessProcessServerProtocol, KalturaAdCuePointOrderBy, KalturaAdProtocolType, KalturaAdType, KalturaAdminUserOrderBy, KalturaAkamaiUniversalStreamType, KalturaAmazonS3StorageProfileFilesPermissionLevel, KalturaAmazonS3StorageProfileOrderBy, KalturaAnnotationOrderBy, KalturaAnswerCuePointOrderBy, KalturaApiActionPermissionItemOrderBy, KalturaApiParameterPermissionItemAction, KalturaApiParameterPermissionItemOrderBy, KalturaAppTokenHashType, KalturaAppTokenOrderBy, KalturaAssetOrderBy, KalturaAssetType, KalturaAttachmentAssetOrderBy, KalturaAttachmentType, KalturaAudioCodec, KalturaAuditTrailAction, KalturaAuditTrailObjectType, KalturaAuditTrailOrderBy, KalturaAvnDistributionProfileOrderBy, KalturaBaseEntryCloneOptions, KalturaBaseEntryCompareAttribute, KalturaBaseEntryMatchAttribute, KalturaBaseEntryOrderBy, KalturaBaseSyndicationFeedOrderBy, KalturaBatchJobObjectType, KalturaBatchJobOrderBy, KalturaBatchJobType, KalturaBulkUploadAction, KalturaBulkUploadObjectType, KalturaBulkUploadResultStatus, KalturaBulkUploadType, KalturaBusinessProcessAbortNotificationTemplateOrderBy, KalturaBusinessProcessNotificationTemplateOrderBy, KalturaBusinessProcessProvider, KalturaBusinessProcessServerOrderBy, KalturaBusinessProcessServerStatus, KalturaBusinessProcessSignalNotificationTemplateOrderBy, KalturaBusinessProcessStartNotificationTemplateOrderBy, KalturaCameraScheduleResourceOrderBy, KalturaCaptionAssetOrderBy, KalturaCaptionType, KalturaCategoryEntryAdvancedOrderBy, KalturaCategoryEntryOrderBy, KalturaCategoryIdentifierField, KalturaCategoryOrderBy, KalturaCategoryUserOrderBy, KalturaCielo24Fidelity, KalturaCielo24Priority, KalturaCloneComponentSelectorType, KalturaCodeCuePointOrderBy, KalturaComcastMrssDistributionProfileOrderBy, KalturaConditionType, KalturaConfigurableDistributionProfileOrderBy, KalturaContainerFormat, KalturaContextType, KalturaControlPanelCommandOrderBy, KalturaConversionProfileOrderBy, KalturaConversionProfileStatus, KalturaConversionProfileType, KalturaCrossKalturaDistributionProfileOrderBy, KalturaCuePointOrderBy, KalturaCuePointType, KalturaDailymotionDistributionProfileOrderBy, KalturaDataEntryCompareAttribute, KalturaDataEntryMatchAttribute, KalturaDataEntryOrderBy, KalturaDeliveryProfileAkamaiAppleHttpManifestOrderBy, KalturaDeliveryProfileAkamaiHdsOrderBy, KalturaDeliveryProfileAkamaiHttpOrderBy, KalturaDeliveryProfileGenericAppleHttpOrderBy, KalturaDeliveryProfileGenericHdsOrderBy, KalturaDeliveryProfileGenericHttpOrderBy, KalturaDeliveryProfileGenericRtmpOrderBy, KalturaDeliveryProfileGenericSilverLightOrderBy, KalturaDeliveryProfileLiveAppleHttpOrderBy, KalturaDeliveryProfileOrderBy, KalturaDeliveryProfileRtmpOrderBy, KalturaDeliveryProfileType, KalturaDeliveryServerNodeOrderBy, KalturaDistributionProfileOrderBy, KalturaDistributionProviderType, KalturaDocumentEntryCompareAttribute, KalturaDocumentEntryMatchAttribute, KalturaDocumentEntryOrderBy, KalturaDoubleClickDistributionProfileOrderBy, KalturaDrmLicenseScenario, KalturaDrmLicenseType, KalturaDrmProfileOrderBy, KalturaDrmProviderType, KalturaDrmSchemeName, KalturaDropFolderErrorCode, KalturaDropFolderFileErrorCode, KalturaDropFolderFileHandlerType, KalturaDropFolderFileOrderBy, KalturaDropFolderOrderBy, KalturaDropFolderType, KalturaDurationType, KalturaESearchCaptionFieldName, KalturaESearchCategoryEntryFieldName, KalturaESearchCategoryFieldName, KalturaESearchCategoryOrderByFieldName, KalturaESearchCategoryUserFieldName, KalturaESearchCuePointFieldName, KalturaESearchEntryFieldName, KalturaESearchEntryOrderByFieldName, KalturaESearchLanguage, KalturaESearchSortOrder, KalturaESearchUserFieldName, KalturaESearchUserOrderByFieldName, KalturaEdgeServerNodeOrderBy, KalturaEmailNotificationFormat, KalturaEmailNotificationRecipientProviderType, KalturaEmailNotificationTemplateOrderBy, KalturaEntryDistributionOrderBy, KalturaEntryIdentifierField, KalturaEntryReplacementStatus, KalturaEntryScheduleEventOrderBy, KalturaEntryServerNodeOrderBy, KalturaEntryServerNodeType, KalturaEntryStatus, KalturaEntryType, KalturaEventCuePointOrderBy, KalturaEventNotificationEventObjectType, KalturaEventNotificationEventType, KalturaEventNotificationTemplateOrderBy, KalturaEventNotificationTemplateType, KalturaEventType, KalturaExternalMediaEntryCompareAttribute, KalturaExternalMediaEntryMatchAttribute, KalturaExternalMediaEntryOrderBy, KalturaExternalMediaSourceType, KalturaFacebookDistributionProfileOrderBy, KalturaFileAssetObjectType, KalturaFileAssetOrderBy, KalturaFileAssetStatus, KalturaFileSyncObjectType, KalturaFileSyncOrderBy, KalturaFlavorAssetOrderBy, KalturaFreewheelDistributionProfileOrderBy, KalturaFreewheelGenericDistributionProfileOrderBy, KalturaFtpDistributionProfileOrderBy, KalturaFtpDropFolderOrderBy, KalturaGenericDistributionProfileOrderBy, KalturaGenericDistributionProviderActionOrderBy, KalturaGenericDistributionProviderOrderBy, KalturaGenericSyndicationFeedOrderBy, KalturaGenericXsltSyndicationFeedOrderBy, KalturaGeoCoderType, KalturaGoogleSyndicationFeedAdultValues, KalturaGoogleVideoSyndicationFeedOrderBy, KalturaGroupUserOrderBy, KalturaHttpNotificationCertificateType, KalturaHttpNotificationSslKeyType, KalturaHttpNotificationTemplateOrderBy, KalturaHuluDistributionProfileOrderBy, KalturaITunesSyndicationFeedAdultValues, KalturaITunesSyndicationFeedCategories, KalturaITunesSyndicationFeedOrderBy, KalturaIdeticDistributionProfileOrderBy, KalturaIntegrationProviderType, KalturaIntegrationTriggerType, KalturaKontikiStorageProfileOrderBy, KalturaLanguage, KalturaLanguageCode, KalturaLiveAssetOrderBy, KalturaLiveChannelCompareAttribute, KalturaLiveChannelMatchAttribute, KalturaLiveChannelOrderBy, KalturaLiveChannelSegmentOrderBy, KalturaLiveChannelSegmentStatus, KalturaLiveChannelSegmentTriggerType, KalturaLiveChannelSegmentType, KalturaLiveEntryCompareAttribute, KalturaLiveEntryMatchAttribute, KalturaLiveEntryOrderBy, KalturaLiveEntryScheduleResourceOrderBy, KalturaLiveReportOrderBy, KalturaLiveReportType, KalturaLiveStreamAdminEntryCompareAttribute, KalturaLiveStreamAdminEntryMatchAttribute, KalturaLiveStreamAdminEntryOrderBy, KalturaLiveStreamEntryCompareAttribute, KalturaLiveStreamEntryMatchAttribute, KalturaLiveStreamEntryOrderBy, KalturaLiveStreamScheduleEventOrderBy, KalturaLocationScheduleResourceOrderBy, KalturaMailType, KalturaMatchConditionType, KalturaMediaEntryCompareAttribute, KalturaMediaEntryMatchAttribute, KalturaMediaEntryOrderBy, KalturaMediaParserType, KalturaMediaServerNodeOrderBy, KalturaMetadataObjectType, KalturaMetadataOrderBy, KalturaMetadataProfileOrderBy, KalturaMetroPcsDistributionProfileOrderBy, KalturaMixEntryCompareAttribute, KalturaMixEntryMatchAttribute, KalturaMixEntryOrderBy, KalturaModerationFlagStatus, KalturaModerationObjectType, KalturaMsnDistributionProfileOrderBy, KalturaObjectFilterEngineType, KalturaObjectTaskType, KalturaPartnerOrderBy, KalturaPermissionItemOrderBy, KalturaPermissionItemType, KalturaPermissionOrderBy, KalturaPlayReadyAnalogVideoOPId, KalturaPlayReadyCopyEnablerType, KalturaPlayReadyDigitalAudioOPId, KalturaPlayReadyPlayEnablerType, KalturaPlayReadyProfileOrderBy, KalturaPlayableEntryCompareAttribute, KalturaPlayableEntryMatchAttribute, KalturaPlayableEntryOrderBy, KalturaPlaybackProtocol, KalturaPlaylistCompareAttribute, KalturaPlaylistMatchAttribute, KalturaPlaylistOrderBy, KalturaPushNotificationCommandType, KalturaPushNotificationTemplateOrderBy, KalturaQuestionCuePointOrderBy, KalturaQuickPlayDistributionProfileOrderBy, KalturaQuizUserEntryOrderBy, KalturaRecordScheduleEventOrderBy, KalturaRemoteDropFolderOrderBy, KalturaReportInterval, KalturaReportOrderBy, KalturaReportType, KalturaResponseProfileOrderBy, KalturaRuleActionType, KalturaScheduleEventOrderBy, KalturaScheduleEventRecurrenceDay, KalturaScheduleEventRecurrenceFrequency, KalturaScheduleEventResourceOrderBy, KalturaScheduleResourceOrderBy, KalturaScheduledTaskProfileOrderBy, KalturaSchemaType, KalturaScpDropFolderOrderBy, KalturaSearchConditionComparison, KalturaServerNodeOrderBy, KalturaServerNodeType, KalturaSftpDropFolderOrderBy, KalturaShortLinkOrderBy, KalturaSourceType, KalturaSshDropFolderOrderBy, KalturaStorageProfileOrderBy, KalturaStorageProfileProtocol, KalturaSyndicationDistributionProfileOrderBy, KalturaSyndicationFeedEntriesOrderBy, KalturaTaggedObjectType, KalturaThumbAssetOrderBy, KalturaThumbCuePointOrderBy, KalturaTimedThumbAssetOrderBy, KalturaTranscriptAssetOrderBy, KalturaTranscriptProviderType, KalturaTubeMogulSyndicationFeedCategories, KalturaTubeMogulSyndicationFeedOrderBy, KalturaUiConfAdminOrderBy, KalturaUiConfOrderBy, KalturaUnicornDistributionProfileOrderBy, KalturaUploadTokenOrderBy, KalturaUserEntryExtendedStatus, KalturaUserEntryOrderBy, KalturaUserEntryStatus, KalturaUserEntryType, KalturaUserOrderBy, KalturaUserRoleOrderBy, KalturaVideoCodec, KalturaVirusScanEngineType, KalturaVirusScanProfileOrderBy, KalturaWebexDropFolderFileOrderBy, KalturaWebexDropFolderOrderBy, KalturaWidevineFlavorAssetOrderBy, KalturaWidevineProfileOrderBy, KalturaWidgetOrderBy, KalturaWowzaMediaServerNodeOrderBy, KalturaYahooDistributionProfileOrderBy, KalturaYahooSyndicationFeedAdultValues, KalturaYahooSyndicationFeedCategories, KalturaYahooSyndicationFeedOrderBy, KalturaYouTubeDistributionFeedSpecVersion, KalturaYouTubeDistributionProfileOrderBy, KalturaYoutubeApiDistributionProfileOrderBy, AccessControlProfileAddAction, AccessControlProfileDeleteAction, AccessControlProfileGetAction, AccessControlProfileListAction, AccessControlProfileUpdateAction, AccessControlAddAction, AccessControlDeleteAction, AccessControlGetAction, AccessControlListAction, AccessControlUpdateAction, AdminUserLoginAction, AdminUserResetPasswordAction, AdminUserSetInitialPasswordAction, AdminUserUpdatePasswordAction, AnalyticsQueryAction, AppTokenAddAction, AppTokenDeleteAction, AppTokenGetAction, AppTokenListAction, AppTokenStartSessionAction, AppTokenUpdateAction, BaseEntryAddAction, BaseEntryAddContentAction, BaseEntryAddFromUploadedFileAction, BaseEntryAnonymousRankAction, BaseEntryApproveAction, BaseEntryCloneAction, BaseEntryCountAction, BaseEntryDeleteAction, BaseEntryExportAction, BaseEntryFlagAction, BaseEntryGetAction, BaseEntryGetByIdsAction, BaseEntryGetContextDataAction, BaseEntryGetPlaybackContextAction, BaseEntryGetRemotePathsAction, BaseEntryIndexAction, BaseEntryListAction, BaseEntryListByReferenceIdAction, BaseEntryListFlagsAction, BaseEntryRejectAction, BaseEntryUpdateAction, BaseEntryUpdateContentAction, BaseEntryUpdateThumbnailFromSourceEntryAction, BaseEntryUpdateThumbnailFromUrlAction, BaseEntryUpdateThumbnailJpegAction, BaseEntryUploadAction, BulkUploadAbortAction, BulkUploadAddAction, BulkUploadGetAction, BulkUploadListAction, BulkUploadServeAction, BulkUploadServeLogAction, CategoryEntryActivateAction, CategoryEntryAddAction, CategoryEntryAddFromBulkUploadAction, CategoryEntryDeleteAction, CategoryEntryIndexAction, CategoryEntryListAction, CategoryEntryRejectAction, CategoryEntrySyncPrivacyContextAction, CategoryEntryUpdateStatusFromBulkAction, CategoryAddAction, CategoryAddFromBulkUploadAction, CategoryDeleteAction, CategoryGetAction, CategoryIndexAction, CategoryListAction, CategoryMoveAction, CategoryUnlockCategoriesAction, CategoryUpdateAction, CategoryUserActivateAction, CategoryUserAddAction, CategoryUserAddFromBulkUploadAction, CategoryUserCopyFromCategoryAction, CategoryUserDeactivateAction, CategoryUserDeleteAction, CategoryUserGetAction, CategoryUserIndexAction, CategoryUserListAction, CategoryUserUpdateAction, ConversionProfileAssetParamsListAction, ConversionProfileAssetParamsUpdateAction, ConversionProfileAddAction, ConversionProfileDeleteAction, ConversionProfileGetAction, ConversionProfileGetDefaultAction, ConversionProfileListAction, ConversionProfileSetAsDefaultAction, ConversionProfileUpdateAction, DataAddAction, DataAddContentAction, DataDeleteAction, DataGetAction, DataListAction, DataServeAction, DataUpdateAction, DeliveryProfileAddAction, DeliveryProfileCloneAction, DeliveryProfileGetAction, DeliveryProfileListAction, DeliveryProfileUpdateAction, EmailIngestionProfileAddAction, EmailIngestionProfileAddMediaEntryAction, EmailIngestionProfileDeleteAction, EmailIngestionProfileGetAction, EmailIngestionProfileGetByEmailAddressAction, EmailIngestionProfileUpdateAction, EntryServerNodeGetAction, EntryServerNodeListAction, EntryServerNodeUpdateAction, EntryServerNodeUpdateStatusAction, EntryServerNodeValidateRegisteredEntryServerNodeAction, FileAssetAddAction, FileAssetDeleteAction, FileAssetGetAction, FileAssetListAction, FileAssetServeAction, FileAssetSetContentAction, FileAssetUpdateAction, FlavorAssetAddAction, FlavorAssetConvertAction, FlavorAssetDeleteAction, FlavorAssetDeleteLocalContentAction, FlavorAssetExportAction, FlavorAssetGetAction, FlavorAssetGetByEntryIdAction, FlavorAssetGetDownloadUrlAction, FlavorAssetGetFlavorAssetsWithParamsAction, FlavorAssetGetRemotePathsAction, FlavorAssetGetUrlAction, FlavorAssetGetVolumeMapAction, FlavorAssetGetWebPlayableByEntryIdAction, FlavorAssetListAction, FlavorAssetReconvertAction, FlavorAssetServeAdStitchCmdAction, FlavorAssetSetAsSourceAction, FlavorAssetSetContentAction, FlavorAssetUpdateAction, FlavorParamsOutputGetAction, FlavorParamsOutputListAction, FlavorParamsAddAction, FlavorParamsDeleteAction, FlavorParamsGetAction, FlavorParamsGetByConversionProfileIdAction, FlavorParamsListAction, FlavorParamsUpdateAction, GroupUserAddAction, GroupUserDeleteAction, GroupUserListAction, GroupUserSyncAction, LiveChannelSegmentAddAction, LiveChannelSegmentDeleteAction, LiveChannelSegmentGetAction, LiveChannelSegmentListAction, LiveChannelSegmentUpdateAction, LiveChannelAddAction, LiveChannelAppendRecordingAction, LiveChannelCreateRecordedEntryAction, LiveChannelDeleteAction, LiveChannelGetAction, LiveChannelIsLiveAction, LiveChannelListAction, LiveChannelRegisterMediaServerAction, LiveChannelSetRecordedContentAction, LiveChannelUnregisterMediaServerAction, LiveChannelUpdateAction, LiveChannelValidateRegisteredMediaServersAction, LiveReportsExportToCsvAction, LiveReportsGetEventsAction, LiveReportsGetReportAction, LiveReportsServeReportAction, LiveStatsCollectAction, LiveStreamAddAction, LiveStreamAddLiveStreamPushPublishConfigurationAction, LiveStreamAppendRecordingAction, LiveStreamAuthenticateAction, LiveStreamCreatePeriodicSyncPointsAction, LiveStreamCreateRecordedEntryAction, LiveStreamDeleteAction, LiveStreamGetAction, LiveStreamIsLiveAction, LiveStreamListAction, LiveStreamRegenerateStreamTokenAction, LiveStreamRegisterMediaServerAction, LiveStreamRemoveLiveStreamPushPublishConfigurationAction, LiveStreamSetRecordedContentAction, LiveStreamUnregisterMediaServerAction, LiveStreamUpdateAction, LiveStreamUpdateOfflineThumbnailFromUrlAction, LiveStreamUpdateOfflineThumbnailJpegAction, LiveStreamValidateRegisteredMediaServersAction, MediaInfoListAction, MediaAddAction, MediaAddContentAction, MediaAddFromBulkAction, MediaAddFromEntryAction, MediaAddFromFlavorAssetAction, MediaAddFromRecordedWebcamAction, MediaAddFromSearchResultAction, MediaAddFromUploadedFileAction, MediaAddFromUrlAction, MediaAnonymousRankAction, MediaApproveAction, MediaApproveReplaceAction, MediaBulkUploadAddAction, MediaCancelReplaceAction, MediaConvertAction, MediaCountAction, MediaDeleteAction, MediaFlagAction, MediaGetAction, MediaGetMrssAction, MediaGetVolumeMapAction, MediaListAction, MediaListFlagsAction, MediaRejectAction, MediaRequestConversionAction, MediaUpdateAction, MediaUpdateContentAction, MediaUpdateThumbnailAction, MediaUpdateThumbnailFromSourceEntryAction, MediaUpdateThumbnailFromUrlAction, MediaUpdateThumbnailJpegAction, MediaUploadAction, MixingAddAction, MixingAnonymousRankAction, MixingAppendMediaEntryAction, MixingCloneAction, MixingCountAction, MixingDeleteAction, MixingGetAction, MixingGetMixesByMediaIdAction, MixingGetReadyMediaEntriesAction, MixingListAction, MixingUpdateAction, NotificationGetClientNotificationAction, PartnerCountAction, PartnerGetAction, PartnerGetInfoAction, PartnerGetSecretsAction, PartnerGetStatisticsAction, PartnerGetUsageAction, PartnerListAction, PartnerListFeatureStatusAction, PartnerListPartnersForUserAction, PartnerRegisterAction, PartnerUpdateAction, PermissionItemAddAction, PermissionItemDeleteAction, PermissionItemGetAction, PermissionItemListAction, PermissionItemUpdateAction, PermissionAddAction, PermissionDeleteAction, PermissionGetAction, PermissionGetCurrentPermissionsAction, PermissionListAction, PermissionUpdateAction, PlaylistAddAction, PlaylistCloneAction, PlaylistDeleteAction, PlaylistExecuteAction, PlaylistExecuteFromContentAction, PlaylistExecuteFromFiltersAction, PlaylistGetAction, PlaylistGetStatsFromContentAction, PlaylistListAction, PlaylistUpdateAction, ReportExecuteAction, ReportGetBaseTotalAction, ReportGetCsvAction, ReportGetCsvFromStringParamsAction, ReportGetGraphsAction, ReportGetTableAction, ReportGetTotalAction, ReportGetUrlForReportAsCsvAction, ReportServeAction, ResponseProfileAddAction, ResponseProfileCloneAction, ResponseProfileDeleteAction, ResponseProfileGetAction, ResponseProfileListAction, ResponseProfileRecalculateAction, ResponseProfileUpdateAction, ResponseProfileUpdateStatusAction, SchemaServeAction, SearchExternalLoginAction, SearchGetMediaInfoAction, SearchSearchAction, SearchSearchUrlAction, ServerNodeAddAction, ServerNodeDeleteAction, ServerNodeDisableAction, ServerNodeEnableAction, ServerNodeGetAction, ServerNodeGetFullPathAction, ServerNodeListAction, ServerNodeMarkOfflineAction, ServerNodeReportStatusAction, ServerNodeUpdateAction, SessionEndAction, SessionGetAction, SessionImpersonateAction, SessionImpersonateByKsAction, SessionStartAction, SessionStartWidgetSessionAction, StatsCollectAction, StatsKmcCollectAction, StatsReportDeviceCapabilitiesAction, StatsReportErrorAction, StatsReportKceErrorAction, StorageProfileAddAction, StorageProfileGetAction, StorageProfileListAction, StorageProfileUpdateAction, StorageProfileUpdateStatusAction, SyndicationFeedAddAction, SyndicationFeedDeleteAction, SyndicationFeedGetAction, SyndicationFeedGetEntryCountAction, SyndicationFeedListAction, SyndicationFeedRequestConversionAction, SyndicationFeedUpdateAction, SystemGetTimeAction, SystemGetVersionAction, SystemPingAction, SystemPingDatabaseAction, ThumbAssetAddAction, ThumbAssetAddFromImageAction, ThumbAssetAddFromUrlAction, ThumbAssetDeleteAction, ThumbAssetExportAction, ThumbAssetGenerateAction, ThumbAssetGenerateByEntryIdAction, ThumbAssetGetAction, ThumbAssetGetByEntryIdAction, ThumbAssetGetRemotePathsAction, ThumbAssetGetUrlAction, ThumbAssetListAction, ThumbAssetRegenerateAction, ThumbAssetServeAction, ThumbAssetServeByEntryIdAction, ThumbAssetSetAsDefaultAction, ThumbAssetSetContentAction, ThumbAssetUpdateAction, ThumbParamsOutputGetAction, ThumbParamsOutputListAction, ThumbParamsAddAction, ThumbParamsDeleteAction, ThumbParamsGetAction, ThumbParamsGetByConversionProfileIdAction, ThumbParamsListAction, ThumbParamsUpdateAction, UiConfAddAction, UiConfCloneAction, UiConfDeleteAction, UiConfGetAction, UiConfGetAvailableTypesAction, UiConfListAction, UiConfListTemplatesAction, UiConfUpdateAction, UploadGetUploadedFileTokenByFileNameAction, UploadUploadAction, UploadTokenAddAction, UploadTokenDeleteAction, UploadTokenGetAction, UploadTokenListAction, UploadTokenUploadAction, UserEntryAddAction, UserEntryBulkDeleteAction, UserEntryDeleteAction, UserEntryGetAction, UserEntryListAction, UserEntrySubmitQuizAction, UserEntryUpdateAction, UserRoleAddAction, UserRoleCloneAction, UserRoleDeleteAction, UserRoleGetAction, UserRoleListAction, UserRoleUpdateAction, UserAddAction, UserAddFromBulkUploadAction, UserCheckLoginDataExistsAction, UserDeleteAction, UserDisableLoginAction, UserEnableLoginAction, UserExportToCsvAction, UserGetAction, UserGetByLoginIdAction, UserIndexAction, UserListAction, UserLoginAction, UserLoginByKsAction, UserLoginByLoginIdAction, UserNotifyBanAction, UserResetPasswordAction, UserServeCsvAction, UserSetInitialPasswordAction, UserUpdateAction, UserUpdateLoginDataAction, WidgetAddAction, WidgetCloneAction, WidgetGetAction, WidgetListAction, WidgetUpdateAction, XInternalXAddBulkDownloadAction, AnnotationAddAction, AnnotationAddFromBulkAction, AnnotationCloneAction, AnnotationCountAction, AnnotationDeleteAction, AnnotationGetAction, AnnotationListAction, AnnotationServeBulkAction, AnnotationUpdateAction, AnnotationUpdateCuePointsTimesAction, AnnotationUpdateStatusAction, AsperaGetFaspUrlAction, AttachmentAssetAddAction, AttachmentAssetDeleteAction, AttachmentAssetGetAction, AttachmentAssetGetRemotePathsAction, AttachmentAssetGetUrlAction, AttachmentAssetListAction, AttachmentAssetServeAction, AttachmentAssetSetContentAction, AttachmentAssetUpdateAction, AuditTrailAddAction, AuditTrailGetAction, AuditTrailListAction, BulkAbortAction, BulkGetAction, BulkListAction, BulkServeAction, BulkServeLogAction, BusinessProcessCaseAbortAction, BusinessProcessCaseListAction, BusinessProcessCaseServeDiagramAction, CaptionAssetAddAction, CaptionAssetDeleteAction, CaptionAssetGetAction, CaptionAssetGetRemotePathsAction, CaptionAssetGetUrlAction, CaptionAssetListAction, CaptionAssetServeAction, CaptionAssetServeByEntryIdAction, CaptionAssetServeWebVTTAction, CaptionAssetSetAsDefaultAction, CaptionAssetSetContentAction, CaptionAssetUpdateAction, CaptionParamsAddAction, CaptionParamsDeleteAction, CaptionParamsGetAction, CaptionParamsListAction, CaptionParamsUpdateAction, CaptionAssetItemListAction, CaptionAssetItemParseAction, CaptionAssetItemSearchAction, CaptionAssetItemSearchEntriesAction, DistributionProfileAddAction, DistributionProfileDeleteAction, DistributionProfileGetAction, DistributionProfileListAction, DistributionProfileListByPartnerAction, DistributionProfileUpdateAction, DistributionProfileUpdateStatusAction, EntryDistributionAddAction, EntryDistributionDeleteAction, EntryDistributionGetAction, EntryDistributionListAction, EntryDistributionRetrySubmitAction, EntryDistributionServeReturnedDataAction, EntryDistributionServeSentDataAction, EntryDistributionSubmitAddAction, EntryDistributionSubmitDeleteAction, EntryDistributionSubmitFetchReportAction, EntryDistributionSubmitUpdateAction, EntryDistributionUpdateAction, EntryDistributionValidateAction, DistributionProviderListAction, GenericDistributionProviderAddAction, GenericDistributionProviderDeleteAction, GenericDistributionProviderGetAction, GenericDistributionProviderListAction, GenericDistributionProviderUpdateAction, GenericDistributionProviderActionAddAction, GenericDistributionProviderActionAddMrssTransformAction, GenericDistributionProviderActionAddMrssTransformFromFileAction, GenericDistributionProviderActionAddMrssValidateAction, GenericDistributionProviderActionAddMrssValidateFromFileAction, GenericDistributionProviderActionAddResultsTransformAction, GenericDistributionProviderActionAddResultsTransformFromFileAction, GenericDistributionProviderActionDeleteAction, GenericDistributionProviderActionDeleteByProviderIdAction, GenericDistributionProviderActionGetAction, GenericDistributionProviderActionGetByProviderIdAction, GenericDistributionProviderActionListAction, GenericDistributionProviderActionUpdateAction, GenericDistributionProviderActionUpdateByProviderIdAction, CuePointAddAction, CuePointAddFromBulkAction, CuePointCloneAction, CuePointCountAction, CuePointDeleteAction, CuePointGetAction, CuePointListAction, CuePointServeBulkAction, CuePointUpdateAction, CuePointUpdateCuePointsTimesAction, CuePointUpdateStatusAction, DocumentsAddFromEntryAction, DocumentsAddFromFlavorAssetAction, DocumentsAddFromUploadedFileAction, DocumentsApproveReplaceAction, DocumentsCancelReplaceAction, DocumentsConvertAction, DocumentsConvertPptToSwfAction, DocumentsDeleteAction, DocumentsGetAction, DocumentsListAction, DocumentsServeAction, DocumentsServeByFlavorParamsIdAction, DocumentsUpdateAction, DocumentsUpdateContentAction, DocumentsUploadAction, DrmPolicyAddAction, DrmPolicyDeleteAction, DrmPolicyGetAction, DrmPolicyListAction, DrmPolicyUpdateAction, DrmProfileAddAction, DrmProfileDeleteAction, DrmProfileGetAction, DrmProfileGetByProviderAction, DrmProfileListAction, DrmProfileUpdateAction, DrmLicenseAccessGetAccessAction, DropFolderAddAction, DropFolderDeleteAction, DropFolderFreeExclusiveDropFolderAction, DropFolderGetAction, DropFolderGetExclusiveDropFolderAction, DropFolderListAction, DropFolderUpdateAction, DropFolderFileAddAction, DropFolderFileDeleteAction, DropFolderFileGetAction, DropFolderFileIgnoreAction, DropFolderFileListAction, DropFolderFileUpdateAction, DropFolderFileUpdateStatusAction, ESearchSearchCategoryAction, ESearchSearchEntryAction, ESearchSearchUserAction, EventNotificationTemplateAddAction, EventNotificationTemplateCloneAction, EventNotificationTemplateDeleteAction, EventNotificationTemplateDispatchAction, EventNotificationTemplateGetAction, EventNotificationTemplateListAction, EventNotificationTemplateListByPartnerAction, EventNotificationTemplateListTemplatesAction, EventNotificationTemplateRegisterAction, EventNotificationTemplateSendCommandAction, EventNotificationTemplateUpdateAction, EventNotificationTemplateUpdateStatusAction, ExternalMediaAddAction, ExternalMediaCountAction, ExternalMediaDeleteAction, ExternalMediaGetAction, ExternalMediaListAction, ExternalMediaUpdateAction, IntegrationDispatchAction, IntegrationNotifyAction, LikeCheckLikeExistsAction, LikeLikeAction, LikeListAction, LikeUnlikeAction, MetadataAddAction, MetadataAddFromBulkAction, MetadataAddFromFileAction, MetadataAddFromUrlAction, MetadataDeleteAction, MetadataGetAction, MetadataIndexAction, MetadataInvalidateAction, MetadataListAction, MetadataServeAction, MetadataUpdateAction, MetadataUpdateFromFileAction, MetadataUpdateFromXSLAction, MetadataProfileAddAction, MetadataProfileAddFromFileAction, MetadataProfileDeleteAction, MetadataProfileGetAction, MetadataProfileListAction, MetadataProfileListFieldsAction, MetadataProfileRevertAction, MetadataProfileServeAction, MetadataProfileServeViewAction, MetadataProfileUpdateAction, MetadataProfileUpdateDefinitionFromFileAction, MetadataProfileUpdateTransformationFromFileAction, MetadataProfileUpdateViewsFromFileAction, PlayReadyDrmGenerateKeyAction, PlayReadyDrmGetContentKeysAction, PlayReadyDrmGetEntryContentKeyAction, PlayReadyDrmGetLicenseDetailsAction, PollAddAction, PollGetVoteAction, PollGetVotesAction, PollResetVotesAction, PollVoteAction, QuizAddAction, QuizGetAction, QuizGetUrlAction, QuizListAction, QuizServeAction, QuizUpdateAction, ScheduleEventAddAction, ScheduleEventAddFromBulkUploadAction, ScheduleEventCancelAction, ScheduleEventDeleteAction, ScheduleEventGetAction, ScheduleEventGetConflictsAction, ScheduleEventListAction, ScheduleEventUpdateAction, ScheduleResourceAddAction, ScheduleResourceAddFromBulkUploadAction, ScheduleResourceDeleteAction, ScheduleResourceGetAction, ScheduleResourceListAction, ScheduleResourceUpdateAction, ScheduleEventResourceAddAction, ScheduleEventResourceDeleteAction, ScheduleEventResourceGetAction, ScheduleEventResourceListAction, ScheduleEventResourceUpdateAction, ScheduledTaskProfileAddAction, ScheduledTaskProfileDeleteAction, ScheduledTaskProfileGetAction, ScheduledTaskProfileGetDryRunResultsAction, ScheduledTaskProfileListAction, ScheduledTaskProfileRequestDryRunAction, ScheduledTaskProfileServeDryRunResultsAction, ScheduledTaskProfileUpdateAction, ShortLinkAddAction, ShortLinkDeleteAction, ShortLinkGetAction, ShortLinkGotoAction, ShortLinkListAction, ShortLinkUpdateAction, TagDeletePendingAction, TagIndexCategoryEntryTagsAction, TagSearchAction, UnicornNotifyAction, VarConsoleGetPartnerUsageAction, VarConsoleUpdateStatusAction, VirusScanProfileAddAction, VirusScanProfileDeleteAction, VirusScanProfileGetAction, VirusScanProfileListAction, VirusScanProfileScanAction, VirusScanProfileUpdateAction, WidevineDrmGetLicenseAction, KalturaFileRequest as ɵa };

